import { Injectable, ComponentFactoryResolver, ApplicationRef, Injector, Optional, Component, Input, EventEmitter, ChangeDetectorRef, ElementRef, Inject, Output, NgModule } from '@angular/core';
import { isObservable, iif, EMPTY, Observable, Subject } from 'rxjs';
import { takeUntil, first } from 'rxjs/operators';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { flatten } from 'un-flatten-tree';
import * as moment_ from 'moment-mini';
import * as DOMPurify_ from 'dompurify';
import { __awaiter } from 'tslib';
import * as ExcelBuilder from 'excel-builder-webpacker';
import { TextEncoder } from 'text-encoding-utf-8';
import 'slickgrid/plugins/slick.cellrangedecorator';
import 'slickgrid/plugins/slick.cellrangeselector';
import 'slickgrid/plugins/slick.cellselectionmodel';
import 'slickgrid/plugins/slick.autotooltips';
import 'slickgrid/plugins/slick.cellexternalcopymanager';
import 'slickgrid/plugins/slick.cellmenu';
import 'slickgrid/plugins/slick.checkboxselectcolumn';
import 'slickgrid/plugins/slick.rowselectionmodel';
import 'slickgrid/controls/slick.columnpicker';
import 'slickgrid/plugins/slick.contextmenu';
import 'slickgrid/plugins/slick.draggablegrouping';
import 'slickgrid/controls/slick.gridmenu';
import { dequal } from 'dequal/lite';
import * as flatpickr_ from 'flatpickr';
import 'slickgrid/plugins/slick.headerbuttons';
import 'slickgrid/plugins/slick.headermenu';
import 'slickgrid/plugins/slick.rowdetailview';
import 'slickgrid/plugins/slick.rowmovemanager';
import 'jquery-ui-dist/jquery-ui';
import 'slickgrid/lib/jquery.event.drag-2.3.0';
import 'slickgrid/lib/jquery.mousewheel';
import 'slickgrid/slick.core';
import 'slickgrid/slick.grid';
import 'slickgrid/slick.dataview';
import 'slickgrid/slick.groupitemmetadataprovider';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@ngx-translate/core';
import * as ɵngcc2 from '@angular/common';

function SlickPaginationComponent_option_24_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 19);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const pageSize_r2 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("value", pageSize_r2);
    ɵngcc0.ɵɵproperty("selected", pageSize_r2 === ctx_r0.itemsPerPage);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(pageSize_r2);
} }
function SlickPaginationComponent_span_29_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵelementStart(1, "span", 20);
    ɵngcc0.ɵɵelementStart(2, "span", 21);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(4, "-");
    ɵngcc0.ɵɵelementStart(5, "span", 22);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.dataFrom);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.dataTo);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.textOf, " ");
} }
function AngularSlickgridComponent_slick_pagination_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "slick-pagination", 4);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate1("id", "slickPagingContainer-", ctx_r0.gridId, "");
    ɵngcc0.ɵɵproperty("gridOptions", ctx_r0.gridOptions);
} }
function AngularSlickgridComponent_div_3_div_3_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "date");
    ɵngcc0.ɵɵelementStart(5, "span", 10);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.customFooterOptions.metricTexts == null ? null : ctx_r3.customFooterOptions.metricTexts.lastUpdate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(4, 3, ctx_r3.metrics.endTime, ctx_r3.customFooterOptions.dateFormat), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.customFooterOptions.metricSeparator);
} }
function AngularSlickgridComponent_div_3_div_3_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2("", ctx_r4.customFooterOptions.metricTexts == null ? null : ctx_r4.customFooterOptions.metricTexts.of, " ", ctx_r4.metrics.totalItemCount, " ");
} }
function AngularSlickgridComponent_div_3_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵtemplate(1, AngularSlickgridComponent_div_3_div_3_span_1_Template, 7, 6, "span", 9);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵtemplate(3, AngularSlickgridComponent_div_3_div_3_span_3_Template, 2, 2, "span", 9);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r2.customFooterOptions.rightContainerClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r2.customFooterOptions.hideLastUpdateTimestamp);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.metrics.itemCount, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r2.customFooterOptions.hideTotalItemCount);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.customFooterOptions.metricTexts == null ? null : ctx_r2.customFooterOptions.metricTexts.items, " ");
} }
function AngularSlickgridComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, AngularSlickgridComponent_div_3_div_3_Template, 5, 5, "div", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("height", (ctx_r1.customFooterOptions == null ? null : ctx_r1.customFooterOptions.footerHeight) || 20);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r1.customFooterOptions.leftContainerClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.customFooterOptions.leftFooterText);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.metrics && !ctx_r1.customFooterOptions.hideMetrics);
} }
var CaseType;
(function (CaseType) {
    /** For example: camelCase */
    CaseType[CaseType["camelCase"] = 0] = "camelCase";
    /** For example: PascalCase */
    CaseType[CaseType["pascalCase"] = 1] = "pascalCase";
    /** For example: snake_case */
    CaseType[CaseType["snakeCase"] = 2] = "snakeCase";
    /** For example: kebab-case */
    CaseType[CaseType["kebabCase"] = 3] = "kebabCase";
})(CaseType || (CaseType = {}));

var DelimiterType;
(function (DelimiterType) {
    DelimiterType["colon"] = ":";
    DelimiterType["comma"] = ",";
    DelimiterType["equalSign"] = "=";
    DelimiterType["pipe"] = "|";
    DelimiterType["semicolon"] = ";";
    DelimiterType["space"] = " ";
    DelimiterType["tab"] = "\t";
    DelimiterType["doubleColon"] = "::";
    DelimiterType["doublePipe"] = "||";
    DelimiterType["doubleSemicolon"] = ";;";
})(DelimiterType || (DelimiterType = {}));

var EmitterType;
(function (EmitterType) {
    EmitterType["local"] = "local";
    EmitterType["remote"] = "remote";
})(EmitterType || (EmitterType = {}));

/** List of available SlickGrid Extensions (Controls & Plugins) */
var ExtensionName;
(function (ExtensionName) {
    ExtensionName["autoTooltip"] = "autoTooltip";
    ExtensionName["cellExternalCopyManager"] = "cellExternalCopyManager";
    ExtensionName["cellMenu"] = "cellMenu";
    ExtensionName["checkboxSelector"] = "checkboxSelector";
    ExtensionName["columnPicker"] = "columnPicker";
    ExtensionName["contextMenu"] = "contextMenu";
    ExtensionName["draggableGrouping"] = "draggableGrouping";
    ExtensionName["groupItemMetaProvider"] = "groupItemMetaProvider";
    ExtensionName["gridMenu"] = "gridMenu";
    ExtensionName["headerButton"] = "headerButton";
    ExtensionName["headerMenu"] = "headerMenu";
    ExtensionName["noname"] = "noname";
    ExtensionName["rowDetailView"] = "rowDetailView";
    ExtensionName["rowMoveManager"] = "rowMoveManager";
    ExtensionName["rowSelection"] = "rowSelection";
})(ExtensionName || (ExtensionName = {}));

var FieldType;
(function (FieldType) {
    /** unknown type */
    FieldType["unknown"] = "unknown";
    /** string type */
    FieldType["string"] = "string";
    /** boolean type (true/false) */
    FieldType["boolean"] = "boolean";
    /** integer number type (1,2,99) */
    FieldType["integer"] = "integer";
    /** float number (with decimal) type */
    FieldType["float"] = "float";
    /** number includes Integer and Float */
    FieldType["number"] = "number";
    /** new Date(), javascript Date object */
    FieldType["date"] = "date";
    /** Format: 'YYYY-MM-DD' => 2001-02-28 */
    FieldType["dateIso"] = "dateIso";
    /** Format: 'YYYY-MM-DDTHH:mm:ss.SSSZ' => 2001-02-28T14:00:00.123Z */
    FieldType["dateUtc"] = "dateUtc";
    /** new Date(), javacript Date Object with Time */
    FieldType["dateTime"] = "dateTime";
    /** Format: 'YYYY-MM-DD HH:mm:ss' => 2001-02-28 14:01:01 */
    FieldType["dateTimeIso"] = "dateTimeIso";
    /** Format: 'YYYY-MM-DD h:mm:ss a' => 2001-02-28 11:01:01 pm */
    FieldType["dateTimeIsoAmPm"] = "dateTimeIsoAmPm";
    /** Format: 'YYYY-MM-DD h:mm:ss A' => 2001-02-28 11:01:01 PM */
    FieldType["dateTimeIsoAM_PM"] = "dateTimeIsoAM_PM";
    /** Format: 'YYYY-MM-DD HH:mm' => 2001-02-28 14:01 */
    FieldType["dateTimeShortIso"] = "dateTimeShortIso";
    /** Format (Euro): 'DD/MM/YYYY' => 28/02/2001 */
    FieldType["dateEuro"] = "dateEuro";
    /** Format (Euro): 'D/M/YY' => 28/2/12 */
    FieldType["dateEuroShort"] = "dateEuroShort";
    /** Format (Euro): 'DD/MM/YYYY HH:mm' => 28/02/2001 13:01 */
    FieldType["dateTimeShortEuro"] = "dateTimeShortEuro";
    /** Format (Euro): 'DD/MM/YYYY HH:mm:ss' => 02/28/2001 13:01:01 */
    FieldType["dateTimeEuro"] = "dateTimeEuro";
    /** Format (Euro): 'DD/MM/YYYY hh:mm:ss a' => 28/02/2001 11:01:01 pm */
    FieldType["dateTimeEuroAmPm"] = "dateTimeEuroAmPm";
    /** Format (Euro): 'DD/MM/YYYY hh:mm:ss A' => 28/02/2001 11:01:01 PM */
    FieldType["dateTimeEuroAM_PM"] = "dateTimeEuroAM_PM";
    /** Format (Euro): 'D/M/YY H:m:s' => 28/2/14 14:1:2 */
    FieldType["dateTimeEuroShort"] = "dateTimeEuroShort";
    /** Format (Euro): 'D/M/YY h:m:s a' => 28/2/14 1:2:10 pm */
    FieldType["dateTimeEuroShortAmPm"] = "dateTimeEuroShortAmPm";
    /** Format (Euro): 'D/M/YY h:m:s A' => 28/2/14 14:1:1 PM */
    FieldType["dateTimeEuroShortAM_PM"] = "dateTimeEuroShortAM_PM";
    /** Format: 'MM/DD/YYYY' => 02/28/2001 */
    FieldType["dateUs"] = "dateUs";
    /** Format: 'M/D/YY' => 2/28/12 */
    FieldType["dateUsShort"] = "dateUsShort";
    /** Format: 'MM/DD/YYYY HH:mm' => 02/28/2001 13:01 */
    FieldType["dateTimeShortUs"] = "dateTimeShortUs";
    /** Format: 'MM/DD/YYYY HH:mm:ss' => 02/28/2001 13:01:01 */
    FieldType["dateTimeUs"] = "dateTimeUs";
    /** Format: 'MM/DD/YYYY hh:mm:ss a' => 02/28/2001 11:01:01 pm */
    FieldType["dateTimeUsAmPm"] = "dateTimeUsAmPm";
    /** Format: 'MM/DD/YYYY hh:mm:ss A' => 02/28/2001 11:01:01 PM */
    FieldType["dateTimeUsAM_PM"] = "dateTimeUsAM_PM";
    /** Format: 'M/D/YY H:m:s' => 2/28/14 14:1:2 */
    FieldType["dateTimeUsShort"] = "dateTimeUsShort";
    /** Format: 'M/D/YY h:m:s a' => 2/28/14 1:2:10 pm */
    FieldType["dateTimeUsShortAmPm"] = "dateTimeUsShortAmPm";
    /** Format: 'M/D/YY h:m:s A' => 2/28/14 14:1:1 PM */
    FieldType["dateTimeUsShortAM_PM"] = "dateTimeUsShortAM_PM";
    /** complex object with various properties */
    FieldType["object"] = "object";
    /** password text string */
    FieldType["password"] = "password";
    /** alias to string */
    FieldType["text"] = "text";
    /** readonly text string */
    FieldType["readonly"] = "readonly";
})(FieldType || (FieldType = {}));

var FileType;
(function (FileType) {
    FileType["csv"] = "csv";
    FileType["txt"] = "txt";
    FileType["xls"] = "xls";
    FileType["xlsx"] = "xlsx";
})(FileType || (FileType = {}));

var FilterMultiplePassType;
(function (FilterMultiplePassType) {
    FilterMultiplePassType["merge"] = "merge";
    FilterMultiplePassType["chain"] = "chain";
})(FilterMultiplePassType || (FilterMultiplePassType = {}));

var GridStateType;
(function (GridStateType) {
    GridStateType["columns"] = "columns";
    GridStateType["filter"] = "filter";
    GridStateType["pagination"] = "pagination";
    GridStateType["pinning"] = "pinning";
    GridStateType["sorter"] = "sorter";
    GridStateType["rowSelection"] = "rowSelection";
    GridStateType["treeData"] = "treeData";
})(GridStateType || (GridStateType = {}));

var KeyCode;
(function (KeyCode) {
    KeyCode[KeyCode["BACKSPACE"] = 8] = "BACKSPACE";
    KeyCode[KeyCode["DELETE"] = 46] = "DELETE";
    KeyCode[KeyCode["DOWN"] = 40] = "DOWN";
    KeyCode[KeyCode["END"] = 35] = "END";
    KeyCode[KeyCode["ENTER"] = 13] = "ENTER";
    KeyCode[KeyCode["ESCAPE"] = 27] = "ESCAPE";
    KeyCode[KeyCode["HOME"] = 36] = "HOME";
    KeyCode[KeyCode["INSERT"] = 45] = "INSERT";
    KeyCode[KeyCode["LEFT"] = 37] = "LEFT";
    KeyCode[KeyCode["PAGE_DOWN"] = 34] = "PAGE_DOWN";
    KeyCode[KeyCode["PAGE_UP"] = 33] = "PAGE_UP";
    KeyCode[KeyCode["RIGHT"] = 39] = "RIGHT";
    KeyCode[KeyCode["TAB"] = 9] = "TAB";
    KeyCode[KeyCode["UP"] = 38] = "UP";
    KeyCode[KeyCode["SPACE"] = 32] = "SPACE";
})(KeyCode || (KeyCode = {}));

var OperatorType;
(function (OperatorType) {
    /** value is empty */
    OperatorType["empty"] = "";
    /** value contains in x (search for substring in the string) */
    OperatorType["contains"] = "Contains";
    /** value not contains x (inversed of contains) */
    OperatorType["notContains"] = "Not_Contains";
    /** value less than x */
    OperatorType["lessThan"] = "LT";
    /** value less than or equal to x */
    OperatorType["lessThanOrEqual"] = "LE";
    /** value greater than x */
    OperatorType["greaterThan"] = "GT";
    /** value great than or equal to x */
    OperatorType["greaterThanOrEqual"] = "GE";
    /** value not equal to x */
    OperatorType["notEqual"] = "NE";
    /** value equal to x */
    OperatorType["equal"] = "EQ";
    /** String ends with value */
    OperatorType["endsWith"] = "EndsWith";
    /**
     * Search in an inclusive range of values that is greater or equal to search value 1 and is smaller or equal to value 2
     * For example the search term of "5..10" will return any values that are greater or equal to 5 and smaller or equal to 10
     */
    OperatorType["rangeInclusive"] = "RangeInclusive";
    /**
     * Search in an inclusive range of values that is greater then search value 1 and is smaller then value 2
     * For example the search term of "5..10" will return any values that is greater then 5 and smaller then 10
     */
    OperatorType["rangeExclusive"] = "RangeExclusive";
    /** String starts with value */
    OperatorType["startsWith"] = "StartsWith";
    /** Find an equal match inside a collection */
    OperatorType["in"] = "IN";
    /** Inverse (Not In) of an equal match inside a collection */
    OperatorType["notIn"] = "NOT_IN";
    /**
     * Find a substring contained inside a collection, note that it has to be a CSV string.
     * For example, this condition would return True with "IN_CONTAINS":: value='Task2,Task3', collection=['Task2','Task3']
     * This would have returned False with "IN" because 'Task2' does not equal 'Task2,Task3'. However 'Task2' is contained in 'Task2,Task3'
     */
    OperatorType["inContains"] = "IN_CONTAINS";
    /** Inversed (Not In) of substring contained inside a collection */
    OperatorType["notInContains"] = "NOT_IN_CONTAINS";
    /** Find a value from within a collection inside another collection */
    OperatorType["inCollection"] = "IN_COLLECTION";
    /** Inversed (Not In) of looking for a value from a collection inside another collection */
    OperatorType["notInCollection"] = "NOT_IN_COLLECTION";
})(OperatorType || (OperatorType = {}));

var SortDirection;
(function (SortDirection) {
    SortDirection["asc"] = "asc";
    SortDirection["ASC"] = "ASC";
    SortDirection["desc"] = "desc";
    SortDirection["DESC"] = "DESC";
})(SortDirection || (SortDirection = {}));

var SortDirectionNumber;
(function (SortDirectionNumber) {
    SortDirectionNumber[SortDirectionNumber["asc"] = 1] = "asc";
    SortDirectionNumber[SortDirectionNumber["desc"] = -1] = "desc";
    SortDirectionNumber[SortDirectionNumber["neutral"] = 0] = "neutral";
})(SortDirectionNumber || (SortDirectionNumber = {}));

var ToggleStateChangeType;
(function (ToggleStateChangeType) {
    /** full tree collapse */
    ToggleStateChangeType["toggleCollapse"] = "toggle-collapse";
    /** full tree expand */
    ToggleStateChangeType["fullExpand"] = "full-expand";
    /** item toggle collapse */
    ToggleStateChangeType["fullCollapse"] = "full-collapse";
    /** item toggle expand */
    ToggleStateChangeType["toggleExpand"] = "toggle-expand";
})(ToggleStateChangeType || (ToggleStateChangeType = {}));

class AngularUtilService {
    constructor(compFactoryResolver, appRef, injector) {
        this.compFactoryResolver = compFactoryResolver;
        this.appRef = appRef;
        this.injector = injector;
    }
    // ref https://hackernoon.com/angular-pro-tip-how-to-dynamically-create-components-in-body-ba200cc289e6
    createAngularComponent(component) {
        // Create a component reference from the component
        const componentRef = this.compFactoryResolver
            .resolveComponentFactory(component)
            .create(this.injector);
        // Attach component to the appRef so that it's inside the ng component tree
        this.appRef.attachView(componentRef.hostView);
        // Get DOM element from component
        let domElem;
        const viewRef = componentRef.hostView;
        if (viewRef && Array.isArray(viewRef.rootNodes) && viewRef.rootNodes[0]) {
            domElem = viewRef.rootNodes[0];
        }
        return { componentRef, domElement: domElem };
    }
    // ref https://hackernoon.com/angular-pro-tip-how-to-dynamically-create-components-in-body-ba200cc289e6
    createAngularComponentAppendToDom(component, targetElement, clearTargetContent = false) {
        const componentOutput = this.createAngularComponent(component);
        // Append DOM element to the HTML element specified
        if (targetElement && targetElement.appendChild) {
            if (clearTargetContent && targetElement.innerHTML) {
                targetElement.innerHTML = '';
            }
            targetElement.appendChild(componentOutput.domElement);
        }
        else {
            document.body.appendChild(componentOutput.domElement); // when no target provided, we'll simply add it to the HTML Body
        }
        return componentOutput;
    }
}
AngularUtilService.ɵfac = function AngularUtilService_Factory(t) { return new (t || AngularUtilService)(ɵngcc0.ɵɵinject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵinject(ɵngcc0.ApplicationRef), ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
AngularUtilService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AngularUtilService, factory: AngularUtilService.ɵfac });
AngularUtilService.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: ApplicationRef },
    { type: Injector }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AngularUtilService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.ApplicationRef }, { type: ɵngcc0.Injector }]; }, null); })();

const main = {};
/** Execute the Backend Processes Callback, that could come from an Observable or a Promise callback */
main.executeBackendProcessesCallback = function exeBackendProcessesCallback(startTime, processResult, backendApi, totalItems) {
    const endTime = new Date();
    // define what our internal Post Process callback, only available for GraphQL Service for now
    // it will basically refresh the Dataset & Pagination removing the need for the user to always create his own PostProcess every time
    if (processResult && backendApi && backendApi.internalPostProcess) {
        backendApi.internalPostProcess(processResult);
    }
    // send the response process to the postProcess callback
    if (backendApi.postProcess) {
        if (processResult instanceof Object) {
            processResult.metrics = {
                startTime,
                endTime,
                executionTime: endTime.valueOf() - startTime.valueOf(),
                itemCount: totalItems,
                totalItemCount: totalItems
            };
            // @deprecated
            processResult.statistics = processResult.metrics;
        }
        backendApi.postProcess(processResult);
    }
};
/** On a backend service api error, we will run the "onError" if there is 1 provided or just throw back the error when nothing is provided */
main.onBackendError = function backendError(e, backendApi) {
    if (backendApi && backendApi.onError) {
        backendApi.onError(e);
    }
    else {
        throw e;
    }
};
/**
 * Execute the backend callback, which are mainly the "process" & "postProcess" methods.
 * Also note that "preProcess" was executed prior to this callback
 */
main.executeBackendCallback = function exeBackendCallback(backendServiceApi, query, args, startTime, totalItems, emitActionChangedCallback, httpCancelRequests$) {
    if (backendServiceApi) {
        // emit an onFilterChanged event when it's not called by a clear filter
        if (args && !args.clearFilterTriggered && !args.clearSortTriggered && emitActionChangedCallback) {
            emitActionChangedCallback(EmitterType.remote);
        }
        // the processes can be Observables (like HttpClient) or Promises
        const process = backendServiceApi.process(query);
        if (process instanceof Promise && process.then) {
            process.then((processResult) => main.executeBackendProcessesCallback(startTime, processResult, backendServiceApi, totalItems))
                .catch((error) => main.onBackendError(error, backendServiceApi));
        }
        else if (isObservable(process)) {
            // this will abort any previous HTTP requests, that were previously hooked in the takeUntil, before sending a new request
            if (isObservable(httpCancelRequests$)) {
                httpCancelRequests$.next();
            }
            process
                // the following takeUntil, will potentially be used later to cancel any pending http request (takeUntil another rx, that would be httpCancelRequests$, completes)
                // but make sure the observable is actually defined with the iif condition check before piping it to the takeUntil
                .pipe(takeUntil(iif(() => isObservable(httpCancelRequests$), httpCancelRequests$, EMPTY)))
                .subscribe((processResult) => main.executeBackendProcessesCallback(startTime, processResult, backendServiceApi, totalItems), (error) => main.onBackendError(error, backendServiceApi));
        }
    }
};
/** Refresh the dataset through the Backend Service */
main.refreshBackendDataset = function refreshBackend(gridOptions) {
    let query = '';
    const backendApi = gridOptions && gridOptions.backendServiceApi;
    if (!backendApi || !backendApi.service || !backendApi.process) {
        throw new Error(`BackendServiceApi requires at least a "process" function and a "service" defined`);
    }
    if (backendApi.service) {
        query = backendApi.service.buildQuery();
    }
    if (query && query !== '') {
        // keep start time & end timestamps & return it after process execution
        const startTime = new Date();
        if (backendApi.preProcess) {
            backendApi.preProcess();
        }
        const totalItems = gridOptions && gridOptions.pagination && gridOptions.pagination.totalItems;
        main.executeBackendCallback(backendApi, query, null, startTime, totalItems);
    }
};
// export all methods & the main so that it works in all modules but also in Jest unit test
// export every method as independent constant so that it still works whenever this is used in other modules
const executeBackendProcessesCallback = main.executeBackendProcessesCallback;
const onBackendError = main.onBackendError;
const executeBackendCallback = main.executeBackendCallback;
const refreshBackendDataset = main.refreshBackendDataset;

class BindingEventService {
    constructor() {
        this._boundedEvents = [];
    }
    /** Bind an event listener to any element */
    bind(element, eventNameOrNames, listener, options) {
        const eventNames = (Array.isArray(eventNameOrNames)) ? eventNameOrNames : [eventNameOrNames];
        for (const eventName of eventNames) {
            element.addEventListener(eventName, listener, options);
            this._boundedEvents.push({ element, eventName, listener });
        }
    }
    /** Unbind all will remove every every event handlers that were bounded earlier */
    unbindAll() {
        while (this._boundedEvents.length > 0) {
            const boundedEvent = this._boundedEvents.pop();
            const { element, eventName, listener } = boundedEvent;
            if (element && element.removeEventListener) {
                element.removeEventListener(eventName, listener);
            }
        }
    }
}

// Boostrap dropdown service
class BsDropDownService {
    constructor(angularUtilService) {
        this.angularUtilService = angularUtilService;
    }
    get domElement() {
        return this._domElement;
    }
    get domContainerElement() {
        return this._domContainerElement;
    }
    get gridViewport() {
        return $('.slick-viewport');
    }
    dispose() {
        if (this._domElement && this._domElement.remove) {
            this._domElement.remove();
        }
    }
    dropContainerShow() {
        if (this._domContainerElement && this._domContainerElement.show) {
            this._domContainerElement.show();
        }
    }
    render(dropdownParams) {
        return new Promise((resolve) => {
            const { component, args, parent, offsetTop, offsetLeft, offsetDropupBottom } = dropdownParams;
            const cell = args.cell;
            const row = args.row;
            this._domContainerElement = $(`#myDrop-r${row}-c${cell}`);
            if (this._domContainerElement) {
                // hide the dropdown we created as a formatter Component, we'll redisplay it later
                const cellPos = this._domContainerElement.offset();
                const componentOutput = this.angularUtilService.createAngularComponent(component);
                const componentInstance = componentOutput && componentOutput.componentRef && componentOutput.componentRef.instance;
                if (componentInstance) {
                    const myDropId = componentInstance.dropdownId || 'myDrop';
                    const dropDownToggleId = componentInstance.dropDownToggleId || 'dropdownMenu1';
                    this._domElement = $(`#${myDropId}`);
                    if (this._domElement) {
                        // make sure to remove any previous Action dropdown elements, to avoid having multiple element of the same on top of each other
                        this.dispose();
                        // assign the row data to the dropdown component instance
                        Object.assign(componentInstance, { parent, row: args.row, dataContext: args.grid.getDataItem(args.row) });
                        // use a delay to make sure Angular ran at least a full cycle and make sure it finished rendering the Component before using it
                        setTimeout(() => {
                            // create a new dropdown element
                            this._domElement = $(componentOutput.domElement);
                            const topPos = (cellPos && cellPos.top || 0) + 30 + (offsetTop || 0);
                            const leftPos = (cellPos && cellPos.left || 0) + (offsetLeft || 0);
                            this._domElement.appendTo('body');
                            this._domElement.css('position', 'absolute');
                            this._domElement.css('top', topPos);
                            this._domElement.css('left', leftPos);
                            $(`#${myDropId}`).addClass('open');
                            $(`#${dropDownToggleId}`).hide();
                            // check if it should drop Up or Down
                            const offset = 35;
                            const iElement = $('.dropdown-menu');
                            const iElementWrapper = iElement.parent();
                            const iElementWrapperOffset = iElementWrapper.offset() || {};
                            const iElementWrapperOffsetTop = iElementWrapperOffset.top || iElementWrapper && iElementWrapper.length > 0 && iElementWrapper[0].offsetTop;
                            const iElementHeight = iElement.height();
                            const windowHeight = window.innerHeight;
                            const shouldDropUp = (windowHeight - iElementHeight - offset) < iElementWrapperOffsetTop;
                            let menuMarginTop = '0px';
                            if (shouldDropUp) {
                                const offsetBottom = offsetDropupBottom || 0;
                                menuMarginTop = '-'.concat(`${iElementHeight + offset + offsetBottom + 5}`, 'px');
                            }
                            this._domElement.css({ 'margin-top': menuMarginTop });
                            // set dropdown margin left according to the document width
                            const parentOffset = iElementWrapperOffset.left;
                            const leftMargin = parentOffset - $(document).width();
                            this._domElement.css({ 'margin-left': (this._domElement.width() + leftMargin + 60) + 'px' });
                            try {
                                this._domElement.dropdown('show'); // required for Bootstrap 4 only
                            }
                            catch (e) {
                                // Bootstrap 3 wil throw an error since that method doesn't exist, we can safely disregard it
                            }
                            this._domElement.on('hidden.bs.dropdown', () => this.dropContainerShow());
                            // hide dropdown menu on grid scroll
                            this.gridViewport.on('scroll', () => this.dispose());
                            // hide on dropdown click
                            this._domElement.on('click', () => this.dispose());
                            resolve(true);
                        });
                    }
                }
            }
        });
    }
}
BsDropDownService.ɵfac = function BsDropDownService_Factory(t) { return new (t || BsDropDownService)(ɵngcc0.ɵɵinject(AngularUtilService)); };
BsDropDownService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: BsDropDownService, factory: BsDropDownService.ɵfac });
BsDropDownService.ctorParameters = () => [
    { type: AngularUtilService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsDropDownService, [{
        type: Injectable
    }], function () { return [{ type: AngularUtilService }]; }, null); })();

const numericSorter = (value1, value2, sortDirection, sortColumn, gridOptions) => {
    const checkForUndefinedValues = sortColumn && sortColumn.valueCouldBeUndefined || gridOptions && gridOptions.cellValueCouldBeUndefined || false;
    const x = (isNaN(value1) || value1 === '' || value1 === null || (checkForUndefinedValues && value1 === undefined)) ? -99e+10 : parseFloat(value1);
    const y = (isNaN(value2) || value2 === '' || value2 === null || (checkForUndefinedValues && value2 === undefined)) ? -99e+10 : parseFloat(value2);
    return sortDirection * (x === y ? 0 : (x > y ? 1 : -1));
};

const objectStringSorter = (value1, value2, sortDirection, sortColumn, gridOptions) => {
    if (!sortColumn || !sortColumn.dataKey) {
        throw new Error('Sorting a "FieldType.object" requires you to provide the "dataKey" (object property name) of the object so that we can use it to sort correctly');
    }
    const stringValue1 = (value1 && value1.hasOwnProperty(sortColumn.dataKey)) ? value1[sortColumn.dataKey] : value1;
    const stringValue2 = (value2 && value2.hasOwnProperty(sortColumn.dataKey)) ? value2[sortColumn.dataKey] : value2;
    const checkForUndefinedValues = sortColumn && sortColumn.valueCouldBeUndefined || gridOptions && gridOptions.cellValueCouldBeUndefined || false;
    if (sortDirection === undefined || sortDirection === null) {
        sortDirection = SortDirectionNumber.neutral;
    }
    let position = 0;
    if (typeof value1 !== 'object') {
        position = -99e+10;
    }
    else if (typeof value2 !== 'object') {
        position = 99e+10;
    }
    else if (stringValue1 === null || (checkForUndefinedValues && stringValue1 === undefined)) {
        position = -1;
    }
    else if (stringValue2 === null || (checkForUndefinedValues && stringValue2 === undefined)) {
        position = 1;
    }
    else if (stringValue1 === stringValue2) {
        position = 0;
    }
    else if (sortDirection) {
        position = stringValue1 < stringValue2 ? -1 : 1;
    }
    else {
        position = stringValue1 < stringValue2 ? 1 : -1;
    }
    return sortDirection * position;
};

const stringSorter = (value1, value2, sortDirection, sortColumn, gridOptions) => {
    if (sortDirection === undefined || sortDirection === null) {
        sortDirection = SortDirectionNumber.neutral;
    }
    let position = 0;
    const checkForUndefinedValues = sortColumn && sortColumn.valueCouldBeUndefined || gridOptions && gridOptions.cellValueCouldBeUndefined || false;
    if (value1 === value2) {
        position = 0;
    }
    else if (value1 === null || (checkForUndefinedValues && value1 === undefined)) {
        position = -1;
    }
    else if (value2 === null || (checkForUndefinedValues && value2 === undefined)) {
        position = 1;
    }
    else if (sortDirection) {
        position = value1 < value2 ? -1 : 1;
    }
    else {
        position = value1 < value2 ? 1 : -1;
    }
    return sortDirection * position;
};

class Constants {
}
// English Locale texts when using only 1 Locale instead of I18N
Constants.locales = {
    TEXT_ALL_SELECTED: 'All Selected',
    TEXT_CANCEL: 'Cancel',
    TEXT_CLEAR_ALL_FILTERS: 'Clear all Filters',
    TEXT_CLEAR_ALL_GROUPING: 'Clear all Grouping',
    TEXT_CLEAR_ALL_SORTING: 'Clear all Sorting',
    TEXT_CLEAR_PINNING: 'Unfreeze Columns/Rows',
    TEXT_COLLAPSE_ALL_GROUPS: 'Collapse all Groups',
    TEXT_CONTAINS: 'Contains',
    TEXT_COLUMNS: 'Columns',
    TEXT_COLUMN_RESIZE_BY_CONTENT: 'Resize by Content',
    TEXT_COMMANDS: 'Commands',
    TEXT_COPY: 'Copy',
    TEXT_EQUALS: 'Equals',
    TEXT_EQUAL_TO: 'Equal to',
    TEXT_ENDS_WITH: 'Ends With',
    TEXT_EXPAND_ALL_GROUPS: 'Expand all Groups',
    TEXT_EXPORT_TO_CSV: 'Export in CSV format',
    TEXT_EXPORT_TO_TEXT_FORMAT: 'Export in Text format (Tab delimited)',
    TEXT_EXPORT_TO_EXCEL: 'Export to Excel',
    TEXT_FORCE_FIT_COLUMNS: 'Force fit columns',
    TEXT_FREEZE_COLUMNS: 'Freeze Columns',
    TEXT_GREATER_THAN: 'Greater than',
    TEXT_GREATER_THAN_OR_EQUAL_TO: 'Greater than or equal to',
    TEXT_GROUP_BY: 'Group By',
    TEXT_HIDE_COLUMN: 'Hide Column',
    TEXT_ITEMS: 'items',
    TEXT_ITEMS_PER_PAGE: 'items per page',
    TEXT_ITEMS_SELECTED: 'items selected',
    TEXT_OF: 'of',
    TEXT_OK: 'OK',
    TEXT_LAST_UPDATE: 'Last Update',
    TEXT_LESS_THAN: 'Less than',
    TEXT_LESS_THAN_OR_EQUAL_TO: 'Less than or equal to',
    TEXT_NOT_CONTAINS: 'Not contains',
    TEXT_NOT_EQUAL_TO: 'Not equal to',
    TEXT_PAGE: 'Page',
    TEXT_REFRESH_DATASET: 'Refresh Dataset',
    TEXT_REMOVE_FILTER: 'Remove Filter',
    TEXT_REMOVE_SORT: 'Remove Sort',
    TEXT_SAVE: 'Save',
    TEXT_SELECT_ALL: 'Select All',
    TEXT_SYNCHRONOUS_RESIZE: 'Synchronous resize',
    TEXT_SORT_ASCENDING: 'Sort Ascending',
    TEXT_SORT_DESCENDING: 'Sort Descending',
    TEXT_STARTS_WITH: 'Starts With',
    TEXT_TOGGLE_FILTER_ROW: 'Toggle Filter Row',
    TEXT_TOGGLE_PRE_HEADER_ROW: 'Toggle Pre-Header Row',
    TEXT_X_OF_Y_SELECTED: '# of % selected',
};
Constants.treeDataProperties = {
    CHILDREN_PROP: 'children',
    COLLAPSED_PROP: '__collapsed',
    HAS_CHILDREN_PROP: '__hasChildren',
    TREE_LEVEL_PROP: '__treeLevel',
    PARENT_PROP: '__parentId',
};
// some Validation default texts
Constants.VALIDATION_REQUIRED_FIELD = 'Field is required';
Constants.VALIDATION_EDITOR_VALID_NUMBER = 'Please enter a valid number';
Constants.VALIDATION_EDITOR_VALID_INTEGER = 'Please enter a valid integer number';
Constants.VALIDATION_EDITOR_INTEGER_BETWEEN = 'Please enter a valid integer number between {{minValue}} and {{maxValue}}';
Constants.VALIDATION_EDITOR_INTEGER_MAX = 'Please enter a valid integer number that is lower than {{maxValue}}';
Constants.VALIDATION_EDITOR_INTEGER_MAX_INCLUSIVE = 'Please enter a valid integer number that is lower than or equal to {{maxValue}}';
Constants.VALIDATION_EDITOR_INTEGER_MIN = 'Please enter a valid integer number that is greater than {{minValue}}';
Constants.VALIDATION_EDITOR_INTEGER_MIN_INCLUSIVE = 'Please enter a valid integer number that is greater than or equal to {{minValue}}';
Constants.VALIDATION_EDITOR_NUMBER_BETWEEN = 'Please enter a valid number between {{minValue}} and {{maxValue}}';
Constants.VALIDATION_EDITOR_NUMBER_MAX = 'Please enter a valid number that is lower than {{maxValue}}';
Constants.VALIDATION_EDITOR_NUMBER_MAX_INCLUSIVE = 'Please enter a valid number that is lower than or equal to {{maxValue}}';
Constants.VALIDATION_EDITOR_NUMBER_MIN = 'Please enter a valid number that is greater than {{minValue}}';
Constants.VALIDATION_EDITOR_NUMBER_MIN_INCLUSIVE = 'Please enter a valid number that is greater than or equal to {{minValue}}';
Constants.VALIDATION_EDITOR_DECIMAL_BETWEEN = 'Please enter a valid number with a maximum of {{maxDecimal}} decimals';
Constants.VALIDATION_EDITOR_TEXT_LENGTH_BETWEEN = 'Please make sure your text length is between {{minLength}} and {{maxLength}} characters';
Constants.VALIDATION_EDITOR_TEXT_MAX_LENGTH = 'Please make sure your text is less than {{maxLength}} characters';
Constants.VALIDATION_EDITOR_TEXT_MAX_LENGTH_INCLUSIVE = 'Please make sure your text is less than or equal to {{maxLength}} characters';
Constants.VALIDATION_EDITOR_TEXT_MIN_LENGTH = 'Please make sure your text is more than {{minLength}} character(s)';
Constants.VALIDATION_EDITOR_TEXT_MIN_LENGTH_INCLUSIVE = 'Please make sure your text is at least {{minLength}} character(s)';

const moment$6 = moment_['default'] || moment_; // patch to fix rollup "moment has no default export" issue, document here https://github.com/rollup/rollup/issues/670
/**
 * Add an item to an array only when the item does not exists, when the item is an object we will be using their "id" to compare
 * @param inputArray
 * @param inputItem
 * @param itemIdPropName
 */
function addToArrayWhenNotExists(inputArray, inputItem, itemIdPropName = 'id') {
    let arrayRowIndex = -1;
    if (typeof inputItem === 'object' && itemIdPropName in inputItem) {
        arrayRowIndex = inputArray.findIndex((item) => item[itemIdPropName] === inputItem[itemIdPropName]);
    }
    else {
        arrayRowIndex = inputArray.findIndex((item) => item === inputItem);
    }
    if (arrayRowIndex < 0) {
        inputArray.push(inputItem);
    }
}
/**
 * Simple function to which will loop and create as demanded the number of white spaces,
 * this is used in the CSV export
 * @param {Number} nbSpaces - number of white spaces to create
 * @param {String} spaceChar - optionally provide character to use as a space (could be override to use &nbsp; in html)
 */
function addWhiteSpaces(nbSpaces, spaceChar = ' ') {
    let result = '';
    for (let i = 0; i < nbSpaces; i++) {
        result += spaceChar;
    }
    return result;
}
/**
 * Remove a column from the grid by it's index in the grid
 * @param array input
 * @param index
 */
function arrayRemoveItemByIndex(array, index) {
    return array.filter((_el, i) => index !== i);
}
/**
 * Convert a flat array (with "parentId" references) into a hierarchical (tree) dataset structure (where children are array(s) inside their parent objects)
 * @param flatArray input array (flat dataset)
 * @param options you can provide the following tree data options (which are all prop names, except 1 boolean flag, to use or else use their defaults):: collapsedPropName, childrenPropName, parentPropName, identifierPropName and levelPropName and initiallyCollapsed (boolean)
 * @return roots - hierarchical (tree) data view array
 */
function unflattenParentChildArrayToTree(flatArray, options) {
    var _a, _b, _c, _d, _e;
    const identifierPropName = (_a = options === null || options === void 0 ? void 0 : options.identifierPropName) !== null && _a !== void 0 ? _a : 'id';
    const childrenPropName = (_b = options === null || options === void 0 ? void 0 : options.childrenPropName) !== null && _b !== void 0 ? _b : Constants.treeDataProperties.CHILDREN_PROP;
    const parentPropName = (_c = options === null || options === void 0 ? void 0 : options.parentPropName) !== null && _c !== void 0 ? _c : Constants.treeDataProperties.PARENT_PROP;
    const levelPropName = (_d = options === null || options === void 0 ? void 0 : options.levelPropName) !== null && _d !== void 0 ? _d : Constants.treeDataProperties.TREE_LEVEL_PROP;
    const collapsedPropName = (_e = options === null || options === void 0 ? void 0 : options.collapsedPropName) !== null && _e !== void 0 ? _e : Constants.treeDataProperties.COLLAPSED_PROP;
    const inputArray = flatArray || [];
    const roots = []; // items without parent which at the root
    // make them accessible by guid on this map
    const all = {};
    inputArray.forEach((item) => all[item[identifierPropName]] = item);
    // connect childrens to its parent, and split roots apart
    Object.keys(all).forEach((id) => {
        var _a;
        const item = all[id];
        if (!(parentPropName in item) || item[parentPropName] === null || item[parentPropName] === undefined || item[parentPropName] === '') {
            roots.push(item);
        }
        else if (item[parentPropName] in all) {
            const p = all[item[parentPropName]];
            if (!(childrenPropName in p)) {
                p[childrenPropName] = [];
            }
            p[childrenPropName].push(item);
            if (p[collapsedPropName] === undefined) {
                p[collapsedPropName] = (_a = options === null || options === void 0 ? void 0 : options.initiallyCollapsed) !== null && _a !== void 0 ? _a : false;
            }
        }
    });
    // we need and want to the Tree Level,
    // we can do that after the tree is created and mutate the array by adding a __treeLevel property on each item
    // perhaps there might be a way to add this while creating the tree for now that is the easiest way I found
    addTreeLevelByMutation(roots, { childrenPropName, levelPropName }, 0);
    return roots;
}
/**
 * Mutate the original array and add a treeLevel (defaults to `__treeLevel`) property on each item.
 * @param {Array<Object>} treeArray - hierarchical tree array
 * @param {Object} options - options containing info like children & treeLevel property names
 * @param {Number} [treeLevel] - current tree level
 */
function addTreeLevelByMutation(treeArray, options, treeLevel = 0) {
    var _a;
    const childrenPropName = ((_a = options === null || options === void 0 ? void 0 : options.childrenPropName) !== null && _a !== void 0 ? _a : Constants.treeDataProperties.CHILDREN_PROP);
    if (Array.isArray(treeArray)) {
        for (const item of treeArray) {
            if (item) {
                if (Array.isArray(item[childrenPropName]) && item[childrenPropName].length > 0) {
                    treeLevel++;
                    addTreeLevelByMutation(item[childrenPropName], options, treeLevel);
                    treeLevel--;
                }
                item[options.levelPropName] = treeLevel;
            }
        }
    }
}
/**
 * Convert a hierarchical (tree) array (with children) into a flat array structure array (where the children are pushed as next indexed item in the array)
 * @param {Array<Object>} treeArray - input hierarchical (tree) array
 * @param {Object} options - you can provide "childrenPropName" (defaults to "children")
 * @return {Array<Object>} output - Parent/Child array
 */
function flattenToParentChildArray(treeArray, options) {
    var _a, _b, _c, _d, _e;
    const identifierPropName = ((_a = options === null || options === void 0 ? void 0 : options.identifierPropName) !== null && _a !== void 0 ? _a : 'id');
    const childrenPropName = ((_b = options === null || options === void 0 ? void 0 : options.childrenPropName) !== null && _b !== void 0 ? _b : Constants.treeDataProperties.CHILDREN_PROP);
    const hasChildrenPropName = ((_c = options === null || options === void 0 ? void 0 : options.hasChildrenPropName) !== null && _c !== void 0 ? _c : Constants.treeDataProperties.HAS_CHILDREN_PROP);
    const parentPropName = ((_d = options === null || options === void 0 ? void 0 : options.parentPropName) !== null && _d !== void 0 ? _d : Constants.treeDataProperties.PARENT_PROP);
    const levelPropName = (_e = options === null || options === void 0 ? void 0 : options.levelPropName) !== null && _e !== void 0 ? _e : Constants.treeDataProperties.TREE_LEVEL_PROP;
    if (options === null || options === void 0 ? void 0 : options.shouldAddTreeLevelNumber) {
        addTreeLevelByMutation(treeArray, { childrenPropName, levelPropName });
    }
    const flat = flatten(treeArray, (node) => node[childrenPropName], (node, parentNode) => {
        return Object.assign({ [identifierPropName]: node[identifierPropName], [parentPropName]: parentNode !== undefined ? parentNode[identifierPropName] : null, [hasChildrenPropName]: !!node[childrenPropName] }, objectWithoutKey(node, childrenPropName) // reuse the entire object except the children array property
        );
    });
    return flat;
}
/**
 * Create an immutable clone of an array or object
 * (c) 2019 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Array|Object} objectOrArray - the array or object to copy
 * @return {Array|Object} - the clone of the array or object
 */
function deepCopy(objectOrArray) {
    /**
     * Create an immutable copy of an object
     * @return {Object}
     */
    const cloneObj = () => {
        // Create new object
        const clone = {};
        // Loop through each item in the original
        // Recursively copy it's value and add to the clone
        for (const key in objectOrArray) {
            if (Object.prototype.hasOwnProperty.call(objectOrArray, key)) {
                clone[key] = deepCopy(objectOrArray[key]);
            }
        }
        return clone;
    };
    /**
     * Create an immutable copy of an array
     * @return {Array}
     */
    const cloneArr = () => objectOrArray.map((item) => deepCopy(item));
    // -- init --//
    // Get object type
    const type = Object.prototype.toString.call(objectOrArray).slice(8, -1).toLowerCase();
    // If an object
    if (type === 'object') {
        return cloneObj();
    }
    // If an array
    if (type === 'array') {
        return cloneArr();
    }
    // Otherwise, return it as-is
    return objectOrArray;
}
/**
 * Empty a DOM element by removing all of its DOM element children leaving with an empty element (basically an empty shell)
 * @return {object} element - updated element
 */
function emptyElement(element) {
    if (element === null || element === void 0 ? void 0 : element.firstChild) {
        while (element.firstChild) {
            if (element.lastChild) {
                element.removeChild(element.lastChild);
            }
        }
    }
    return element;
}
/**
 * @deprecated use `findItemInTreeStructure()` instead. Find an item from a hierarchical (tree) view structure (a parent that can have children array which themseleves can children and so on)
 * @param treeArray
 * @param predicate
 * @param childrenPropertyName
 */
function findItemInHierarchicalStructure(treeArray, predicate, childrenPropertyName) {
    return findItemInTreeStructure(treeArray, predicate, childrenPropertyName);
}
/**
 * Find an item from a tree (hierarchical) view structure (a parent that can have children array which themseleves can children and so on)
 * @param {Array<Object>} treeArray - hierarchical tree dataset
 * @param {Function} predicate - search predicate to find the item in the hierarchical tree structure
 * @param {String} childrenPropertyName - children property name to use in the tree (defaults to "children")
 */
function findItemInTreeStructure(treeArray, predicate, childrenPropertyName) {
    if (!childrenPropertyName) {
        throw new Error('findRecursive requires parameter "childrenPropertyName"');
    }
    const initialFind = treeArray.find(predicate);
    const elementsWithChildren = treeArray.filter((x) => childrenPropertyName in x && x[childrenPropertyName]);
    if (initialFind) {
        return initialFind;
    }
    else if (elementsWithChildren.length) {
        const childElements = [];
        elementsWithChildren.forEach((item) => {
            if (childrenPropertyName in item) {
                childElements.push(...item[childrenPropertyName]);
            }
        });
        return findItemInTreeStructure(childElements, predicate, childrenPropertyName);
    }
    return undefined;
}
/**
 * HTML decode using jQuery with a <div>
 * Create a in-memory div, set it's inner text(which jQuery automatically encodes)
 * then grab the encoded contents back out.  The div never exists on the page.
*/
function htmlDecode(encodedStr) {
    const parser = DOMParser && new DOMParser;
    if (parser && parser.parseFromString) {
        const dom = parser.parseFromString('<!doctype html><body>' + encodedStr, 'text/html');
        return dom && dom.body && dom.body.textContent || '';
    }
    else {
        // for some browsers that might not support DOMParser, use jQuery instead
        return $('<div/>').html(encodedStr).text();
    }
}
/**
 * HTML encode using jQuery with a <div>
 * Create a in-memory div, set it's inner text(which jQuery automatically encodes)
 * then grab the encoded contents back out.  The div never exists on the page.
*/
function htmlEncode(inputValue) {
    const entityMap = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        '\'': '&#39;'
    };
    // all symbols::  /[&<>"'`=\/]/g
    return (inputValue || '').toString().replace(/[&<>"']/g, (s) => entityMap[s]);
}
/**
 * Decode text into html entity
 * @param string text: input text
 * @param string text: output text
 */
function htmlEntityDecode(input) {
    return input.replace(/&#(\d+);/g, function (_match, dec) {
        return String.fromCharCode(dec);
    });
}
/**
 * Decode text into html entity
 * @param string text: input text
 * @param string text: output text
 */
function htmlEntityEncode(input) {
    const buf = [];
    for (let i = input.length - 1; i >= 0; i--) {
        buf.unshift(['&#', input[i].charCodeAt(), ';'].join(''));
    }
    return buf.join('');
}
/**
 * Try casting an input of type Promise | Observable into a Promise type.
 * @param object which could be of type Promise or Observable
 * @param fromServiceName string representing the caller service name and will be used if we throw a casting problem error
 */
function castToPromise(input, fromServiceName = '') {
    let promise = input;
    if (input instanceof Promise) {
        // if it's already a Promise then return it
        return input;
    }
    else if (input instanceof Observable) {
        promise = input.pipe(first()).toPromise();
    }
    if (!(promise instanceof Promise)) {
        throw new Error(`Something went wrong, Angular-Slickgrid ${fromServiceName} is not able to convert the Observable into a Promise.
      If you are using Angular HttpClient, you could try converting your http call to a Promise with ".toPromise()"
      for example::  this.http.post('graphql', { query: graphqlQuery }).toPromise()
      `);
    }
    return promise;
}
/**
 * Uses the logic function to find an item in an array or returns the default
 * value provided (empty object by default)
 * @param any[] array the array to filter
 * @param function logic the logic to find the item
 * @param any [defaultVal={}] the default value to return
 * @return object the found object or default value
 */
function findOrDefault(array, logic, defaultVal = {}) {
    return array.find(logic) || defaultVal;
}
/**
 * Encode string to html special char and add html space padding defined
 * @param {string} inputStr - input string
 * @param {number} paddingLength - padding to add
 */
function htmlEncodedStringWithPadding(inputStr, paddingLength) {
    const inputStrLn = inputStr.length;
    let outputStr = htmlEncode(inputStr);
    if (inputStrLn < paddingLength) {
        for (let i = inputStrLn; i < paddingLength; i++) {
            outputStr += `&nbsp;`;
        }
    }
    return outputStr;
}
/**
 * Check if input value is a number, by default it won't be a strict checking
 * but optionally we could check for strict equality, for example in strict "3" will return False but without strict it will return True
 * @param value - input value of any type
 * @param strict - when using strict it also check for strict equality, for example in strict "3" will return but without strict it will return true
 */
function isNumber(value, strict = false) {
    if (strict) {
        return (value === null || value === undefined || typeof value === 'string') ? false : !isNaN(value);
    }
    return (value === null || value === undefined || value === '') ? false : !isNaN(+value);
}
/**
  * Take a number (or a string) and display it as a formatted decimal string with defined minimum and maximum decimals
  * @param input
  * @param minDecimal
  * @param maxDecimal
  */
function decimalFormatted(input, minDecimal, maxDecimal, decimalSeparator = '.', thousandSeparator = '') {
    if (isNaN(+input)) {
        return input;
    }
    const minDec = (minDecimal === undefined) ? 2 : minDecimal;
    const maxDec = (maxDecimal === undefined) ? 2 : maxDecimal;
    let amount = String(Math.round(+input * Math.pow(10, maxDec)) / Math.pow(10, maxDec));
    if ((amount.indexOf('.') < 0) && (minDec > 0)) {
        amount += '.';
    }
    while ((amount.length - amount.indexOf('.')) <= minDec) {
        amount += '0';
    }
    const decimalSplit = amount.split('.');
    let integerNumber;
    let decimalNumber;
    // do we want to display our number with a custom separator in each thousand position
    if (thousandSeparator) {
        integerNumber = decimalSplit.length >= 1 ? thousandSeparatorFormatted(decimalSplit[0], thousandSeparator) : undefined;
    }
    else {
        integerNumber = decimalSplit.length >= 1 ? decimalSplit[0] : amount;
    }
    // when using a separator that is not a dot, replace it with the new separator
    if (decimalSplit.length > 1) {
        decimalNumber = decimalSplit[1];
    }
    let output = '';
    if (integerNumber !== undefined && decimalNumber !== undefined) {
        output = `${integerNumber}${decimalSeparator}${decimalNumber}`;
    }
    else if (integerNumber !== undefined && integerNumber !== null) {
        output = integerNumber;
    }
    return output;
}
/**
 * Loop through all properties of an object and nullify any properties that are instanceof HTMLElement,
 * if we detect an array then use recursion to go inside it and apply same logic
 * @param obj - object containing 1 or more properties with DOM Elements
 */
function destroyObjectDomElementProps(obj) {
    if (obj) {
        for (const key of Object.keys(obj)) {
            if (Array.isArray(obj[key])) {
                destroyObjectDomElementProps(obj[key]);
            }
            if (obj[key] instanceof HTMLElement) {
                obj[key] = null;
            }
        }
    }
}
/**
 * Format a number following options passed as arguments (decimals, separator, ...)
 * @param input
 * @param minDecimal
 * @param maxDecimal
 * @param displayNegativeNumberWithParentheses
 * @param symbolPrefix
 * @param symbolSuffix
 * @param decimalSeparator
 * @param thousandSeparator
 */
function formatNumber(input, minDecimal, maxDecimal, displayNegativeNumberWithParentheses, symbolPrefix = '', symbolSuffix = '', decimalSeparator = '.', thousandSeparator = '') {
    if (isNaN(+input)) {
        return input;
    }
    const calculatedValue = ((Math.round(parseFloat(input) * 1000000) / 1000000));
    if (calculatedValue < 0) {
        const absValue = Math.abs(calculatedValue);
        if (displayNegativeNumberWithParentheses) {
            if (!isNaN(minDecimal) || !isNaN(maxDecimal)) {
                return `(${symbolPrefix}${decimalFormatted(absValue, minDecimal, maxDecimal, decimalSeparator, thousandSeparator)}${symbolSuffix})`;
            }
            const formattedValue = thousandSeparatorFormatted(`${absValue}`, thousandSeparator);
            return `(${symbolPrefix}${formattedValue}${symbolSuffix})`;
        }
        else {
            if (!isNaN(minDecimal) || !isNaN(maxDecimal)) {
                return `-${symbolPrefix}${decimalFormatted(absValue, minDecimal, maxDecimal, decimalSeparator, thousandSeparator)}${symbolSuffix}`;
            }
            const formattedValue = thousandSeparatorFormatted(`${absValue}`, thousandSeparator);
            return `-${symbolPrefix}${formattedValue}${symbolSuffix}`;
        }
    }
    else {
        if (!isNaN(minDecimal) || !isNaN(maxDecimal)) {
            return `${symbolPrefix}${decimalFormatted(input, minDecimal, maxDecimal, decimalSeparator, thousandSeparator)}${symbolSuffix}`;
        }
        const formattedValue = thousandSeparatorFormatted(`${input}`, thousandSeparator);
        return `${symbolPrefix}${formattedValue}${symbolSuffix}`;
    }
}
/** From a dot (.) notation path, find and return a property within an object given a path */
function getDescendantProperty(obj, path) {
    return path.split('.').reduce((acc, part) => acc && acc[part], obj);
}
/** Get HTML Element position offset (without jQuery) */
function getHtmlElementOffset(element) {
    var _a;
    const rect = (_a = element === null || element === void 0 ? void 0 : element.getBoundingClientRect) === null || _a === void 0 ? void 0 : _a.call(element);
    let top = 0;
    let left = 0;
    if (rect && rect.top !== undefined && rect.left !== undefined) {
        top = rect.top + window.pageYOffset;
        left = rect.left + window.pageXOffset;
    }
    return { top, left };
}
/** Get Translation Prefix, defaults to an empty string */
function getTranslationPrefix(gridOptions) {
    if (gridOptions && gridOptions.translationNamespace) {
        return gridOptions.translationNamespace + (gridOptions.translationNamespaceSeparator || '');
    }
    return '';
}
/**
 * From a Date FieldType, return it's equivalent moment.js format
 * refer to moment.js for the format standard used: https://momentjs.com/docs/#/parsing/string-format/
 * @param fieldType
 */
function mapMomentDateFormatWithFieldType(fieldType) {
    let map;
    switch (fieldType) {
        case FieldType.dateTime:
        case FieldType.dateTimeIso:
            map = 'YYYY-MM-DD HH:mm:ss';
            break;
        case FieldType.dateTimeShortIso:
            map = 'YYYY-MM-DD HH:mm';
            break;
        case FieldType.dateTimeIsoAmPm:
            map = 'YYYY-MM-DD hh:mm:ss a';
            break;
        case FieldType.dateTimeIsoAM_PM:
            map = 'YYYY-MM-DD hh:mm:ss A';
            break;
        // all Euro Formats (date/month/year)
        case FieldType.dateEuro:
            map = 'DD/MM/YYYY';
            break;
        case FieldType.dateEuroShort:
            map = 'D/M/YY';
            break;
        case FieldType.dateTimeEuro:
            map = 'DD/MM/YYYY HH:mm:ss';
            break;
        case FieldType.dateTimeShortEuro:
            map = 'DD/MM/YYYY HH:mm';
            break;
        case FieldType.dateTimeEuroAmPm:
            map = 'DD/MM/YYYY hh:mm:ss a';
            break;
        case FieldType.dateTimeEuroAM_PM:
            map = 'DD/MM/YYYY hh:mm:ss A';
            break;
        case FieldType.dateTimeEuroShort:
            map = 'D/M/YY H:m:s';
            break;
        case FieldType.dateTimeEuroShortAmPm:
            map = 'D/M/YY h:m:s a';
            break;
        // all US Formats (month/date/year)
        case FieldType.dateUs:
            map = 'MM/DD/YYYY';
            break;
        case FieldType.dateUsShort:
            map = 'M/D/YY';
            break;
        case FieldType.dateTimeUs:
            map = 'MM/DD/YYYY HH:mm:ss';
            break;
        case FieldType.dateTimeShortUs:
            map = 'MM/DD/YYYY HH:mm';
            break;
        case FieldType.dateTimeUsAmPm:
            map = 'MM/DD/YYYY hh:mm:ss a';
            break;
        case FieldType.dateTimeUsAM_PM:
            map = 'MM/DD/YYYY hh:mm:ss A';
            break;
        case FieldType.dateTimeUsShort:
            map = 'M/D/YY H:m:s';
            break;
        case FieldType.dateTimeUsShortAmPm:
            map = 'M/D/YY h:m:s a';
            break;
        case FieldType.dateUtc:
            map = 'YYYY-MM-DDTHH:mm:ss.SSSZ';
            break;
        case FieldType.date:
        case FieldType.dateIso:
        default:
            map = 'YYYY-MM-DD';
            break;
    }
    return map;
}
/**
 * From a Date FieldType, return it's equivalent Flatpickr format
 * refer to Flatpickr for the format standard used: https://chmln.github.io/flatpickr/formatting/#date-formatting-tokens
 * also note that they seem very similar to PHP format (except for am/pm): http://php.net/manual/en/function.date.php
 * @param fieldType
 */
function mapFlatpickrDateFormatWithFieldType(fieldType) {
    /*
      d: Day of the month, 2 digits with leading zeros	01 to 31
      D: A textual representation of a day	Mon through Sun
      l: (lowercase 'L')	A full textual representation of the day of the week	Sunday through Saturday
      j: Day of the month without leading zeros	1 to 31
      J: Day of the month without leading zeros and ordinal suffix	1st, 2nd, to 31st
      w: Numeric representation of the day of the week	0 (for Sunday) through 6 (for Saturday)
      F: A full textual representation of a month	January through December
      m: Numeric representation of a month, with leading zero	01 through 12
      n: Numeric representation of a month, without leading zeros	1 through 12
      M: A short textual representation of a month	Jan through Dec
      U: The number of seconds since the Unix Epoch	1413704993
      y: A two digit representation of a year	99 or 03
      Y: A full numeric representation of a year, 4 digits	1999 or 2003
      H: Hours (24 hours)	00 to 23
      h: Hours	1 to 12
      i: Minutes	00 to 59
      S: Seconds, 2 digits	00 to 59
      s: Seconds	0, 1 to 59
      K: AM/PM	AM or PM
    */
    let map;
    switch (fieldType) {
        case FieldType.dateTime:
        case FieldType.dateTimeIso:
            map = 'Y-m-d H:i:S';
            break;
        case FieldType.dateTimeShortIso:
            map = 'Y-m-d H:i';
            break;
        case FieldType.dateTimeIsoAmPm:
        case FieldType.dateTimeIsoAM_PM:
            map = 'Y-m-d h:i:S K'; // there is no lowercase in Flatpickr :(
            break;
        // all Euro Formats (date/month/year)
        case FieldType.dateEuro:
            map = 'd/m/Y';
            break;
        case FieldType.dateEuroShort:
            map = 'd/m/y';
            break;
        case FieldType.dateTimeEuro:
            map = 'd/m/Y H:i:S';
            break;
        case FieldType.dateTimeShortEuro:
            map = 'd/m/y H:i';
            break;
        case FieldType.dateTimeEuroAmPm:
            map = 'd/m/Y h:i:S K'; // there is no lowercase in Flatpickr :(
            break;
        case FieldType.dateTimeEuroAM_PM:
            map = 'd/m/Y h:i:s K';
            break;
        case FieldType.dateTimeEuroShort:
            map = 'd/m/y H:i:s';
            break;
        case FieldType.dateTimeEuroShortAmPm:
            map = 'd/m/y h:i:s K'; // there is no lowercase in Flatpickr :(
            break;
        // all US Formats (month/date/year)
        case FieldType.dateUs:
            map = 'm/d/Y';
            break;
        case FieldType.dateUsShort:
            map = 'm/d/y';
            break;
        case FieldType.dateTimeUs:
            map = 'm/d/Y H:i:S';
            break;
        case FieldType.dateTimeShortUs:
            map = 'm/d/y H:i';
            break;
        case FieldType.dateTimeUsAmPm:
            map = 'm/d/Y h:i:S K'; // there is no lowercase in Flatpickr :(
            break;
        case FieldType.dateTimeUsAM_PM:
            map = 'm/d/Y h:i:s K';
            break;
        case FieldType.dateTimeUsShort:
            map = 'm/d/y H:i:s';
            break;
        case FieldType.dateTimeUsShortAmPm:
            map = 'm/d/y h:i:s K'; // there is no lowercase in Flatpickr :(
            break;
        case FieldType.dateUtc:
            map = 'Z';
            break;
        case FieldType.date:
        case FieldType.dateIso:
        default:
            map = 'Y-m-d';
            break;
    }
    return map;
}
/**
 * Mapper for query operators (ex.: <= is "le", > is "gt")
 * @param string operator
 * @returns string map
 */
function mapOperatorType(operator) {
    let map;
    switch (operator) {
        case '<':
        case 'LT':
            map = OperatorType.lessThan;
            break;
        case '<=':
        case 'LE':
            map = OperatorType.lessThanOrEqual;
            break;
        case '>':
        case 'GT':
            map = OperatorType.greaterThan;
            break;
        case '>=':
        case 'GE':
            map = OperatorType.greaterThanOrEqual;
            break;
        case '<>':
        case '!=':
        case 'NE':
            map = OperatorType.notEqual;
            break;
        case '*':
        case 'a*':
        case 'StartsWith':
            map = OperatorType.startsWith;
            break;
        case '*z':
        case 'EndsWith':
            map = OperatorType.endsWith;
            break;
        case '=':
        case '==':
        case 'EQ':
            map = OperatorType.equal;
            break;
        case 'IN':
            map = OperatorType.in;
            break;
        case 'NIN':
        case 'NOT_IN':
            map = OperatorType.notIn;
            break;
        case 'Not_Contains':
        case 'NOT_CONTAINS':
            map = OperatorType.notContains;
            break;
        case 'Contains':
        case 'CONTAINS':
        default:
            map = OperatorType.contains;
            break;
    }
    return map;
}
/**
 * Find equivalent short designation of an Operator Type or Operator String.
 * When using a Compound Filter, we use the short designation and so we need the mapped value.
 * For example OperatorType.startsWith short designation is "a*", while OperatorType.greaterThanOrEqual is ">="
 */
function mapOperatorToShorthandDesignation(operator) {
    let shortOperator = '';
    switch (operator) {
        case OperatorType.greaterThan:
        case '>':
            shortOperator = '>';
            break;
        case OperatorType.greaterThanOrEqual:
        case '>=':
            shortOperator = '>=';
            break;
        case OperatorType.lessThan:
        case '<':
            shortOperator = '<';
            break;
        case OperatorType.lessThanOrEqual:
        case '<=':
            shortOperator = '<=';
            break;
        case OperatorType.notEqual:
        case '<>':
            shortOperator = '<>';
            break;
        case OperatorType.equal:
        case '=':
        case '==':
        case 'EQ':
            shortOperator = '=';
            break;
        case OperatorType.startsWith:
        case 'a*':
        case '*':
            shortOperator = 'a*';
            break;
        case OperatorType.endsWith:
        case '*z':
            shortOperator = '*z';
            break;
        default:
            // any other operator will be considered as already a short expression, so we can return same input operator
            shortOperator = operator;
            break;
    }
    return shortOperator;
}
/**
 * Mapper for query operator by a Filter Type
 * For example a multiple-select typically uses 'IN' operator
 * @param operator
 * @returns string map
 */
function mapOperatorByFieldType(fieldType) {
    let map;
    switch (fieldType) {
        case FieldType.unknown:
        case FieldType.string:
        case FieldType.text:
        case FieldType.password:
        case FieldType.readonly:
            map = OperatorType.contains;
            break;
        case FieldType.float:
        case FieldType.number:
        case FieldType.date:
        case FieldType.dateIso:
        case FieldType.dateUtc:
        case FieldType.dateTime:
        case FieldType.dateTimeIso:
        case FieldType.dateTimeIsoAmPm:
        case FieldType.dateTimeIsoAM_PM:
        case FieldType.dateEuro:
        case FieldType.dateEuroShort:
        case FieldType.dateTimeEuro:
        case FieldType.dateTimeEuroAmPm:
        case FieldType.dateTimeEuroAM_PM:
        case FieldType.dateTimeEuroShort:
        case FieldType.dateTimeEuroShortAmPm:
        case FieldType.dateTimeEuroShortAM_PM:
        case FieldType.dateUs:
        case FieldType.dateUsShort:
        case FieldType.dateTimeUs:
        case FieldType.dateTimeUsAmPm:
        case FieldType.dateTimeUsAM_PM:
        case FieldType.dateTimeUsShort:
        case FieldType.dateTimeUsShortAmPm:
        case FieldType.dateTimeUsShortAM_PM:
        default:
            map = OperatorType.equal;
            break;
    }
    return map;
}
/**
 * Takes an object and allow to provide a property key to omit from the original object
 * @param {Object} obj - input object
 * @param {String} omitKey - object property key to omit
 * @returns {String} original object without the property that user wants to omit
 */
function objectWithoutKey(obj, omitKey) {
    return Object.keys(obj).reduce((result, objKey) => {
        if (objKey !== omitKey) {
            result[objKey] = obj[objKey];
        }
        return result;
    }, {});
}
/** Parse any input (bool, number, string) and return a boolean or False when not possible */
function parseBoolean(input) {
    return /(true|1)/i.test(input + '');
}
/**
 * Parse a date passed as a string (Date only, without time) and return a Date object (if valid)
 * @param inputDateString
 * @returns string date formatted
 */
function parseUtcDate(inputDateString, useUtc) {
    let date = null;
    if (/^[0-9\-\/]*$/.test(inputDateString)) {
        // get the UTC datetime with moment.js but we need to decode the value so that it's valid text
        const dateString = decodeURIComponent(inputDateString);
        const dateMoment = moment$6(new Date(dateString));
        if (dateMoment.isValid() && dateMoment.year().toString().length === 4) {
            date = (useUtc) ? dateMoment.utc().format() : dateMoment.format();
        }
    }
    return date;
}
/**
 * Sanitize, return only the text without HTML tags
 * @input htmlString
 * @return text
 */
function sanitizeHtmlToText(htmlString) {
    const temp = document.createElement('div');
    temp.innerHTML = htmlString;
    return temp.textContent || temp.innerText || '';
}
/** Set the object value of deeper node from a given dot (.) notation path (e.g.: "user.firstName") */
function setDeepValue(obj, path, value) {
    if (typeof path === 'string') {
        path = path.split('.');
    }
    if (path.length > 1) {
        const e = path.shift();
        if (obj && e !== undefined) {
            setDeepValue(obj[e] = Object.prototype.toString.call(obj[e]) === '[object Object]' ? obj[e] : {}, path, value);
        }
    }
    else if (obj && path[0]) {
        obj[path[0]] = value;
    }
}
/**
 * Format a number or a string into a string that is separated every thousand,
 * the default separator is a comma but user can optionally pass a different one
 * @param inputValue
 * @param separator default to comma ","
 * @returns string
 */
function thousandSeparatorFormatted(inputValue, separator = ',') {
    if (inputValue !== null && inputValue !== undefined) {
        const stringValue = `${inputValue}`;
        const decimalSplit = stringValue.split('.');
        if (decimalSplit.length === 2) {
            return `${decimalSplit[0].replace(/\B(?=(\d{3})+(?!\d))/g, separator)}.${decimalSplit[1]}`;
        }
        return stringValue.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
    }
    return inputValue;
}
/**
 * Title case (or capitalize) first char of a string, for example "hello world" will become "Hello world"
 * Change the string to be title case on the complete sentence (upper case first char of each word while changing everything else to lower case)
 * @param inputStr
 * @returns string
 */
function titleCase(inputStr, caseEveryWords = false) {
    if (typeof inputStr === 'string') {
        if (caseEveryWords) {
            return inputStr.replace(/\w\S*/g, (outputStr) => {
                return outputStr.charAt(0).toUpperCase() + outputStr.substr(1).toLowerCase();
            });
        }
        return inputStr.charAt(0).toUpperCase() + inputStr.slice(1);
    }
    return inputStr;
}
/**
 * Converts a string to camel case (camelCase), for example "hello-world" (or "hellow world") will become "helloWorld"
 * @param inputStr the string to convert
 * @return the string in camel case
 */
function toCamelCase(inputStr) {
    if (typeof inputStr === 'string') {
        return inputStr.replace(/(?:^\w|[A-Z]|\b\w|[\s+\-_\/])/g, (match, offset) => {
            // remove white space or hypens or underscores
            if (/[\s+\-_\/]/.test(match)) {
                return '';
            }
            return offset === 0 ? match.toLowerCase() : match.toUpperCase();
        });
    }
    return inputStr;
}
/**
 * Converts a string to kebab (hypen) case, for example "helloWorld" will become "hello-world"
 * @param str the string to convert
 * @return the string in kebab case
 */
function toKebabCase(inputStr) {
    if (typeof inputStr === 'string') {
        return toCamelCase(inputStr).replace(/([A-Z])/g, '-$1').toLowerCase();
    }
    return inputStr;
}
/**
 * Converts a string from camelCase to snake_case (underscore) case, for example "helloWorld" will become "hello_world"
 * @param str the string to convert
 * @return the string in kebab case
 */
function toSnakeCase(inputStr) {
    if (typeof inputStr === 'string') {
        return toCamelCase(inputStr).replace(/([A-Z])/g, '_$1').toLowerCase();
    }
    return inputStr;
}
/**
 * Takes an input array and makes sure the array has unique values by removing duplicates
 * @param array input with possible duplicates
 * @param objectProperty optionally provide an object property to compare (example: 'id')
 * @return array output without duplicates
 */
function uniqueArray(arr) {
    if (Array.isArray(arr) && arr.length > 0) {
        return arr.filter((item, index) => {
            return arr.indexOf(item) >= index;
        });
    }
    return arr;
}
/**
 * Takes an input array of objects and makes sure the array has unique object values by removing duplicates
 * it will loop through the array using a property name (or "id" when is not provided) to compare uniqueness
 * @param array input with possible duplicates
 * @param propertyName defaults to "id"
 * @return array output without duplicates
 */
function uniqueObjectArray(arr, propertyName = 'id') {
    if (Array.isArray(arr) && arr.length > 0) {
        const result = [];
        const map = new Map();
        for (const item of arr) {
            if (!map.has(item[propertyName])) {
                map.set(item[propertyName], true); // set any value to Map
                result.push({
                    id: item[propertyName],
                    name: item.name
                });
            }
        }
        return result;
    }
    return arr;
}
/**
 * Unsubscribe all Observables Subscriptions
 * It will return an empty array if it all went well
 * @param subscriptions
 */
function unsubscribeAllObservables(subscriptions) {
    if (Array.isArray(subscriptions)) {
        subscriptions.forEach((subscription) => {
            if (subscription && subscription.unsubscribe) {
                subscription.unsubscribe();
            }
        });
        subscriptions = [];
    }
    return subscriptions;
}

const moment$5 = moment_['default'] || moment_; // patch to fix rollup "moment has no default export" issue, document here https://github.com/rollup/rollup/issues/670
function compareDates(value1, value2, sortDirection, sortColumn, gridOptions, format, strict) {
    let diff = 0;
    const checkForUndefinedValues = sortColumn && sortColumn.valueCouldBeUndefined || gridOptions && gridOptions.cellValueCouldBeUndefined || false;
    const date1 = moment$5(value1, format, strict);
    const date2 = moment$5(value2, format, strict);
    if (value1 === null || value1 === '' || (checkForUndefinedValues && value1 === undefined) || !date1.isValid()) {
        diff = -1;
    }
    else if (value2 === null || value2 === '' || (checkForUndefinedValues && value2 === undefined) || !date2.isValid()) {
        diff = 1;
    }
    else {
        diff = date1.valueOf() < date2.valueOf() ? -1 : 1;
    }
    return sortDirection * diff;
}
/** From a FieldType, return the associated date Sorter */
function getAssociatedDateSorter(fieldType) {
    const FORMAT = (fieldType === FieldType.date) ? moment$5.ISO_8601 : mapMomentDateFormatWithFieldType(fieldType);
    return (value1, value2, sortDirection, sortColumn, gridOptions) => {
        if (FORMAT === moment$5.ISO_8601) {
            return compareDates(value1, value2, sortDirection, sortColumn, gridOptions, FORMAT, false);
        }
        return compareDates(value1, value2, sortDirection, sortColumn, gridOptions, FORMAT, true);
    };
}

const Sorters = {
    /** Sorter method to sort values by Date object type (uses Moment.js ISO_8601 standard format, optionally include time) */
    date: getAssociatedDateSorter(FieldType.date),
    /**
     * Sorter method to sort values by Date formatted as ISO date (excluding time),
     * If you wish to optionally include time simply use the "Sorters.date" which work with/without time
     */
    dateIso: getAssociatedDateSorter(FieldType.dateIso),
    /** Sorter method to sort values by Date formatted as (YYYY-MM-DDTHH:mm:ss.SSSZ) */
    dateUtc: getAssociatedDateSorter(FieldType.dateUtc),
    /** Sorter method to sort values by Date and Time (native Date object) */
    dateTime: getAssociatedDateSorter(FieldType.dateTime),
    /** Sorter method to sort values by Date formatted as (YYYY-MM-DD HH:mm:ss) */
    dateTimeIso: getAssociatedDateSorter(FieldType.dateTimeIso),
    /** Sorter method to sort values by Date formatted as (YYYY-MM-DD h:mm:ss a) */
    dateTimeIsoAmPm: getAssociatedDateSorter(FieldType.dateTimeIsoAmPm),
    /** Sorter method to sort values by Date formatted as (YYYY-MM-DD h:mm:ss A) */
    dateTimeIsoAM_PM: getAssociatedDateSorter(FieldType.dateTimeIsoAM_PM),
    /** Sorter method to sort values by Date formatted as (YYYY-MM-DD HH:mm) */
    dateTimeShortIso: getAssociatedDateSorter(FieldType.dateTimeShortIso),
    /** Sorter method to sort values by Date formatted as Euro date (DD/MM/YYYY) */
    dateEuro: getAssociatedDateSorter(FieldType.dateEuro),
    /** Sorter method to sort values by Date formatted as Euro short date (D/M/YY) */
    dateEuroShort: getAssociatedDateSorter(FieldType.dateEuroShort),
    /** Sorter method to sort values by Date formatted as (DD/MM/YYYY HH:mm) */
    dateTimeShortEuro: getAssociatedDateSorter(FieldType.dateTimeShortEuro),
    /** Sorter method to sort values by Date formatted as (DD/MM/YYYY HH:mm:ss) */
    dateTimeEuro: getAssociatedDateSorter(FieldType.dateTimeEuro),
    /** Sorter method to sort values by Date formatted as (DD/MM/YYYY hh:mm:ss a) */
    dateTimeEuroAmPm: getAssociatedDateSorter(FieldType.dateTimeEuroAmPm),
    /** Sorter method to sort values by Date formatted as (DD/MM/YYYY hh:mm:ss A) */
    dateTimeEuroAM_PM: getAssociatedDateSorter(FieldType.dateTimeEuroAM_PM),
    /** Sorter method to sort values by Date formatted as (D/M/YY H:m:s) */
    dateTimeEuroShort: getAssociatedDateSorter(FieldType.dateTimeEuroShort),
    /** Sorter method to sort values by Date formatted as (D/M/YY h:m:s a) */
    dateTimeEuroShortAmPm: getAssociatedDateSorter(FieldType.dateTimeEuroShortAmPm),
    /** Sorter method to sort values by Date formatted as (D/M/YY h:m:s A) */
    dateTimeEuroShortAM_PM: getAssociatedDateSorter(FieldType.dateTimeEuroShortAM_PM),
    /** Sorter method to sort values by Date formatted as US date (MM/DD/YYYY) */
    dateUs: getAssociatedDateSorter(FieldType.dateUs),
    /** Sorter method to sort values by Date formatted as US short date (M/D/YY) */
    dateUsShort: getAssociatedDateSorter(FieldType.dateUsShort),
    /** Sorter method to sort values by Date formatted as (MM/DD/YYYY HH:mm) */
    dateTimeShortUs: getAssociatedDateSorter(FieldType.dateTimeShortUs),
    /** Sorter method to sort values by Date formatted as (MM/DD/YYYY HH:mm:s) */
    dateTimeUs: getAssociatedDateSorter(FieldType.dateTimeUs),
    /** Sorter method to sort values by Date formatted as (MM/DD/YYYY hh:mm:ss a) */
    dateTimeUsAmPm: getAssociatedDateSorter(FieldType.dateTimeUsAmPm),
    /** Sorter method to sort values by Date formatted as (MM/DD/YYYY hh:mm:ss A) */
    dateTimeUsAM_PM: getAssociatedDateSorter(FieldType.dateTimeUsAM_PM),
    /** Sorter method to sort values by Date formatted as (M/D/YY H:m:s) */
    dateTimeUsShort: getAssociatedDateSorter(FieldType.dateTimeUsShort),
    /** Sorter method to sort values by Date formatted as (M/D/YY h:m:s a) */
    dateTimeUsShortAmPm: getAssociatedDateSorter(FieldType.dateTimeUsShortAmPm),
    /** Sorter method to sort values by Date formatted as (M/D/YY h:m:s A) */
    dateTimeUsShortAM_PM: getAssociatedDateSorter(FieldType.dateTimeUsShortAM_PM),
    /** Sorter method to sort values as numeric fields */
    numeric: numericSorter,
    /**
     * Sorter method to sort object values with a "dataKey" provided in your column definition, it's data content must be of type string
     * Example:
     * columnDef = { id='user', field: 'user', ..., dataKey: 'firstName', sorter: Sorters.objectString }
     * collection = [{ firstName: 'John', lastName: 'Doe' }, { firstName: 'Bob', lastName: 'Cash' }]
     */
    objectString: objectStringSorter,
    /** Sorter method to sort values as regular strings */
    string: stringSorter
};

function sortByFieldType(fieldType, value1, value2, sortDirection, sortColumn, gridOptions) {
    let sortResult = 0;
    switch (fieldType) {
        case FieldType.float:
        case FieldType.integer:
        case FieldType.number:
            sortResult = Sorters.numeric(value1, value2, sortDirection, sortColumn, gridOptions);
            break;
        case FieldType.date:
        case FieldType.dateIso:
        case FieldType.dateUtc:
        case FieldType.dateTime:
        case FieldType.dateTimeIso:
        case FieldType.dateTimeIsoAmPm:
        case FieldType.dateTimeIsoAM_PM:
        case FieldType.dateTimeShortIso:
        case FieldType.dateEuro:
        case FieldType.dateEuroShort:
        case FieldType.dateTimeShortEuro:
        case FieldType.dateTimeEuro:
        case FieldType.dateTimeEuroAmPm:
        case FieldType.dateTimeEuroAM_PM:
        case FieldType.dateTimeEuroShort:
        case FieldType.dateTimeEuroShortAmPm:
        case FieldType.dateTimeEuroShortAM_PM:
        case FieldType.dateUs:
        case FieldType.dateUsShort:
        case FieldType.dateTimeShortUs:
        case FieldType.dateTimeUs:
        case FieldType.dateTimeUsAmPm:
        case FieldType.dateTimeUsAM_PM:
        case FieldType.dateTimeUsShort:
        case FieldType.dateTimeUsShortAmPm:
        case FieldType.dateTimeUsShortAM_PM:
            // @ts-ignore
            sortResult = getAssociatedDateSorter(fieldType).call(this, value1, value2, sortDirection, sortColumn, gridOptions);
            break;
        case FieldType.object:
            sortResult = Sorters.objectString(value1, value2, sortDirection, sortColumn, gridOptions);
            break;
        case FieldType.string:
        case FieldType.text:
        case FieldType.password:
        case FieldType.readonly:
        default:
            sortResult = Sorters.string(value1, value2, sortDirection, sortColumn, gridOptions);
            break;
    }
    return sortResult;
}

class CollectionService {
    constructor(translate) {
        this.translate = translate;
    }
    /**
     * Filter 1 or more items from a collection
     * @param collection
     * @param filterByOptions
     */
    filterCollection(collection, filterByOptions, filterResultBy = FilterMultiplePassType.chain) {
        let filteredCollection = [];
        // when it's array, we will use the new filtered collection after every pass
        // basically if input collection has 10 items on 1st pass and 1 item is filtered out, then on 2nd pass the input collection will be 9 items
        if (Array.isArray(filterByOptions)) {
            filteredCollection = (filterResultBy === FilterMultiplePassType.merge) ? [] : collection;
            for (const filter of filterByOptions) {
                if (filterResultBy === FilterMultiplePassType.merge) {
                    const filteredPass = this.singleFilterCollection(collection, filter);
                    filteredCollection = uniqueArray([...filteredCollection, ...filteredPass]);
                }
                else {
                    filteredCollection = this.singleFilterCollection(filteredCollection, filter);
                }
            }
        }
        else {
            filteredCollection = this.singleFilterCollection(collection, filterByOptions);
        }
        return filteredCollection;
    }
    /**
     * Filter an item from a collection
     * @param collection
     * @param filterBy
     */
    singleFilterCollection(collection, filterBy) {
        let filteredCollection = [];
        if (filterBy) {
            const objectProperty = filterBy.property;
            const operator = filterBy.operator || OperatorType.equal;
            // just check for undefined since the filter value could be null, 0, '', false etc
            const value = typeof filterBy.value === 'undefined' ? '' : filterBy.value;
            switch (operator) {
                case OperatorType.equal:
                    if (objectProperty) {
                        filteredCollection = collection.filter((item) => item[objectProperty] === value);
                    }
                    else {
                        filteredCollection = collection.filter((item) => item === value);
                    }
                    break;
                case OperatorType.contains:
                    if (objectProperty) {
                        filteredCollection = collection.filter((item) => item[objectProperty].toString().indexOf(value.toString()) !== -1);
                    }
                    else {
                        filteredCollection = collection.filter((item) => (item !== null && item !== undefined) && item.toString().indexOf(value.toString()) !== -1);
                    }
                    break;
                case OperatorType.notContains:
                    if (objectProperty) {
                        filteredCollection = collection.filter((item) => item[objectProperty].toString().indexOf(value.toString()) === -1);
                    }
                    else {
                        filteredCollection = collection.filter((item) => (item !== null && item !== undefined) && item.toString().indexOf(value.toString()) === -1);
                    }
                    break;
                case OperatorType.notEqual:
                default:
                    if (objectProperty) {
                        filteredCollection = collection.filter((item) => item[objectProperty] !== value);
                    }
                    else {
                        filteredCollection = collection.filter((item) => item !== value);
                    }
            }
        }
        return filteredCollection;
    }
    /**
     * Sort 1 or more items in a collection
     * @param column definition
     * @param collection
     * @param sortByOptions
     * @param enableTranslateLabel
     */
    sortCollection(columnDef, collection, sortByOptions, enableTranslateLabel) {
        if (enableTranslateLabel && (!this.translate || !this.translate.instant)) {
            throw new Error('[Angular-Slickgrid] requires "ngx-translate" to be installed and configured when the grid option "enableTranslate" is enabled.');
        }
        let sortedCollection = [];
        if (sortByOptions) {
            if (Array.isArray(sortByOptions)) {
                // multi-sort
                sortedCollection = collection.sort((dataRow1, dataRow2) => {
                    for (let i = 0, l = sortByOptions.length; i < l; i++) {
                        const sortBy = sortByOptions[i];
                        if (sortBy && sortBy.property) {
                            // collection of objects with a property name provided
                            const sortDirection = sortBy.sortDesc ? SortDirectionNumber.desc : SortDirectionNumber.asc;
                            const objectProperty = sortBy.property;
                            const fieldType = sortBy.fieldType || columnDef && columnDef.type || FieldType.string;
                            const value1 = (enableTranslateLabel) ? this.translate && this.translate.currentLang && this.translate.instant(dataRow1[objectProperty] || ' ') : dataRow1[objectProperty];
                            const value2 = (enableTranslateLabel) ? this.translate && this.translate.currentLang && this.translate.instant(dataRow2[objectProperty] || ' ') : dataRow2[objectProperty];
                            const sortResult = sortByFieldType(fieldType, value1, value2, sortDirection, columnDef);
                            if (sortResult !== SortDirectionNumber.neutral) {
                                return sortResult;
                            }
                        }
                    }
                    return SortDirectionNumber.neutral;
                });
            }
            else if (sortByOptions && sortByOptions.property) {
                // single sort
                // collection of objects with a property name provided
                const objectProperty = sortByOptions.property;
                const sortDirection = sortByOptions.sortDesc ? SortDirectionNumber.desc : SortDirectionNumber.asc;
                const fieldType = sortByOptions.fieldType || columnDef && columnDef.type || FieldType.string;
                if (objectProperty) {
                    sortedCollection = collection.sort((dataRow1, dataRow2) => {
                        const value1 = (enableTranslateLabel) ? this.translate && this.translate.currentLang && this.translate.instant(dataRow1[objectProperty] || ' ') : dataRow1[objectProperty];
                        const value2 = (enableTranslateLabel) ? this.translate && this.translate.currentLang && this.translate.instant(dataRow2[objectProperty] || ' ') : dataRow2[objectProperty];
                        const sortResult = sortByFieldType(fieldType, value1, value2, sortDirection, columnDef);
                        if (sortResult !== SortDirectionNumber.neutral) {
                            return sortResult;
                        }
                        return SortDirectionNumber.neutral;
                    });
                }
            }
            else if (sortByOptions && !sortByOptions.property) {
                const sortDirection = sortByOptions.sortDesc ? SortDirectionNumber.desc : SortDirectionNumber.asc;
                const fieldType = sortByOptions.fieldType || columnDef && columnDef.type || FieldType.string;
                sortedCollection = collection.sort((dataRow1, dataRow2) => {
                    const value1 = (enableTranslateLabel) ? this.translate && this.translate.currentLang && this.translate.instant(dataRow1 || ' ') : dataRow1;
                    const value2 = (enableTranslateLabel) ? this.translate && this.translate.currentLang && this.translate.instant(dataRow2 || ' ') : dataRow2;
                    const sortResult = sortByFieldType(fieldType, value1, value2, sortDirection, columnDef);
                    if (sortResult !== SortDirectionNumber.neutral) {
                        return sortResult;
                    }
                    return SortDirectionNumber.neutral;
                });
            }
        }
        return sortedCollection;
    }
}
CollectionService.ɵfac = function CollectionService_Factory(t) { return new (t || CollectionService)(ɵngcc0.ɵɵinject(ɵngcc1.TranslateService, 8)); };
CollectionService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: CollectionService, factory: CollectionService.ɵfac });
CollectionService.ctorParameters = () => [
    { type: TranslateService, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CollectionService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.TranslateService, decorators: [{
                type: Optional
            }] }]; }, null); })();

const DOMPurify$6 = DOMPurify_; // patch to fix rollup to work
/**
 * Create the HTML DOM Element for a Select Editor or Filter, this is specific to these 2 types only and the unit tests are directly under them
 * @param {String} type - type of select DOM element to build, can be either 'editor' or 'filter'
 * @param {Array<Object>} collection - array of items to build the select html options
 * @param {Array<Object>} columnDef - column definition object
 * @param {Object} grid - Slick Grid object
 * @param {Boolean} isMultiSelect - are we building a multiple select element (false means it's a single select)
 * @param {Object} translaterService - optional Translater Service
 * @param {Array<*>} searchTerms - optional array of search term (used by the "filter" type only)
 * @returns object with 2 properties for the select element & a boolean value telling us if any of the search terms were found and selected in the dropdown
 */
function buildSelectEditorOrFilterDomElement(type, collection, columnDef, grid, isMultiSelect = false, translateService, searchTerms) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    const columnId = (_a = columnDef === null || columnDef === void 0 ? void 0 : columnDef.id) !== null && _a !== void 0 ? _a : '';
    const gridOptions = grid.getOptions();
    const columnFilterOrEditor = (_b = (type === 'editor' ? columnDef === null || columnDef === void 0 ? void 0 : columnDef.internalColumnEditor : columnDef === null || columnDef === void 0 ? void 0 : columnDef.filter)) !== null && _b !== void 0 ? _b : {};
    const collectionOptions = (_c = columnFilterOrEditor === null || columnFilterOrEditor === void 0 ? void 0 : columnFilterOrEditor.collectionOptions) !== null && _c !== void 0 ? _c : {};
    const separatorBetweenLabels = (_d = collectionOptions === null || collectionOptions === void 0 ? void 0 : collectionOptions.separatorBetweenTextLabels) !== null && _d !== void 0 ? _d : '';
    const enableTranslateLabel = (_e = columnFilterOrEditor === null || columnFilterOrEditor === void 0 ? void 0 : columnFilterOrEditor.enableTranslateLabel) !== null && _e !== void 0 ? _e : false;
    const isTranslateEnabled = (_f = gridOptions === null || gridOptions === void 0 ? void 0 : gridOptions.enableTranslate) !== null && _f !== void 0 ? _f : false;
    const isRenderHtmlEnabled = (_g = columnFilterOrEditor === null || columnFilterOrEditor === void 0 ? void 0 : columnFilterOrEditor.enableRenderHtml) !== null && _g !== void 0 ? _g : false;
    const sanitizedOptions = (_h = gridOptions === null || gridOptions === void 0 ? void 0 : gridOptions.sanitizeHtmlOptions) !== null && _h !== void 0 ? _h : {};
    const labelName = (_k = (_j = columnFilterOrEditor === null || columnFilterOrEditor === void 0 ? void 0 : columnFilterOrEditor.customStructure) === null || _j === void 0 ? void 0 : _j.label) !== null && _k !== void 0 ? _k : 'label';
    const labelPrefixName = (_m = (_l = columnFilterOrEditor === null || columnFilterOrEditor === void 0 ? void 0 : columnFilterOrEditor.customStructure) === null || _l === void 0 ? void 0 : _l.labelPrefix) !== null && _m !== void 0 ? _m : 'labelPrefix';
    const labelSuffixName = (_p = (_o = columnFilterOrEditor === null || columnFilterOrEditor === void 0 ? void 0 : columnFilterOrEditor.customStructure) === null || _o === void 0 ? void 0 : _o.labelSuffix) !== null && _p !== void 0 ? _p : 'labelSuffix';
    const optionLabel = (_r = (_q = columnFilterOrEditor === null || columnFilterOrEditor === void 0 ? void 0 : columnFilterOrEditor.customStructure) === null || _q === void 0 ? void 0 : _q.optionLabel) !== null && _r !== void 0 ? _r : 'value';
    const valueName = (_t = (_s = columnFilterOrEditor === null || columnFilterOrEditor === void 0 ? void 0 : columnFilterOrEditor.customStructure) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : 'value';
    const selectElement = document.createElement('select');
    selectElement.className = 'ms-filter search-filter';
    const extraCssClasses = type === 'filter' ? ['search-filter', `filter-${columnId}`] : ['select-editor', `editor-${columnId}`];
    selectElement.classList.add(...extraCssClasses);
    selectElement.multiple = isMultiSelect;
    // use an HTML Fragment for performance reason, MDN explains it well as shown below::
    // The key difference is that because the document fragment isn't part of the actual DOM's structure, changes made to the fragment don't affect the document, cause reflow, or incur any performance impact that can occur when changes are made.
    const selectOptionsFragment = document.createDocumentFragment();
    let hasFoundSearchTerm = false;
    // collection could be an Array of Strings OR Objects
    if (Array.isArray(collection)) {
        if (collection.every((x) => typeof x === 'string')) {
            for (const option of collection) {
                const selectOptionElm = document.createElement('option');
                if (type === 'filter' && Array.isArray(searchTerms)) {
                    selectOptionElm.selected = (searchTerms.findIndex(term => term === option) >= 0); // when filter search term is found then select it in dropdown
                }
                selectOptionElm.value = option;
                selectOptionElm.label = option;
                selectOptionElm.textContent = option;
                selectOptionsFragment.appendChild(selectOptionElm);
                // if there's at least 1 Filter search term found, we will add the "filled" class for styling purposes
                // on a single select, we'll also make sure the single value is not an empty string to consider this being filled
                if ((selectOptionElm.selected && isMultiSelect) || (selectOptionElm.selected && !isMultiSelect && option !== '')) {
                    hasFoundSearchTerm = true;
                }
            }
        }
        else {
            // array of objects will require a label/value pair unless a customStructure is passed
            collection.forEach((option) => {
                if (!option || (option[labelName] === undefined && option.labelKey === undefined)) {
                    throw new Error(`[Angular-Slickgrid] Select Filter/Editor collection with value/label (or value/labelKey when using Locale) is required to populate the Select list, for example:: { filter: model: Filters.multipleSelect, collection: [ { value: '1', label: 'One' } ]')`);
                }
                const selectOptionElm = document.createElement('option');
                const labelKey = (option.labelKey || option[labelName]);
                const labelText = ((option.labelKey || (enableTranslateLabel && translateService)) && labelKey && isTranslateEnabled) ? translateService === null || translateService === void 0 ? void 0 : translateService.instant(labelKey || ' ') : labelKey;
                let prefixText = option[labelPrefixName] || '';
                let suffixText = option[labelSuffixName] || '';
                let selectOptionLabel = option.hasOwnProperty(optionLabel) ? option[optionLabel] : '';
                if (selectOptionLabel === null || selectOptionLabel === void 0 ? void 0 : selectOptionLabel.toString) {
                    selectOptionLabel = selectOptionLabel.toString().replace(/\"/g, '\''); // replace double quotes by single quotes to avoid interfering with regular html
                }
                // also translate prefix/suffix if enableTranslateLabel is true and text is a string
                prefixText = (enableTranslateLabel && translateService && prefixText && typeof prefixText === 'string') ? translateService.instant(prefixText || ' ') : prefixText;
                suffixText = (enableTranslateLabel && translateService && suffixText && typeof suffixText === 'string') ? translateService.instant(suffixText || ' ') : suffixText;
                selectOptionLabel = (enableTranslateLabel && translateService && selectOptionLabel && typeof selectOptionLabel === 'string') ? translateService.instant(selectOptionLabel || ' ') : selectOptionLabel;
                // add to a temp array for joining purpose and filter out empty text
                const tmpOptionArray = [prefixText, (typeof labelText === 'string' || typeof labelText === 'number') ? labelText.toString() : labelText, suffixText].filter((text) => text);
                let optionText = tmpOptionArray.join(separatorBetweenLabels);
                // if user specifically wants to render html text, he needs to opt-in else it will stripped out by default
                // also, the 3rd party lib will saninitze any html code unless it's encoded, so we'll do that
                if (isRenderHtmlEnabled) {
                    // sanitize any unauthorized html tags like script and others
                    // for the remaining allowed tags we'll permit all attributes
                    const sanitizedText = (DOMPurify$6.sanitize(optionText, sanitizedOptions) || '').toString();
                    optionText = htmlEncode(sanitizedText);
                    selectOptionElm.innerHTML = optionText;
                }
                else {
                    selectOptionElm.textContent = optionText;
                }
                // html text of each select option
                let selectOptionValue = option[valueName];
                if (selectOptionValue === undefined || selectOptionValue === null) {
                    selectOptionValue = '';
                }
                if (type === 'filter' && Array.isArray(searchTerms)) {
                    selectOptionElm.selected = (searchTerms.findIndex(term => `${term}` === `${option[valueName]}`) >= 0); // when filter search term is found then select it in dropdown
                }
                selectOptionElm.value = `${selectOptionValue}`;
                selectOptionElm.label = `${selectOptionLabel !== null && selectOptionLabel !== void 0 ? selectOptionLabel : ''}`;
                selectOptionsFragment.appendChild(selectOptionElm);
                // if there's a search term, we will add the "filled" class for styling purposes
                // on a single select, we'll also make sure the single value is not an empty string to consider this being filled
                if ((selectOptionElm.selected && isMultiSelect) || (selectOptionElm.selected && !isMultiSelect && option[valueName] !== '')) {
                    hasFoundSearchTerm = true;
                }
            });
        }
    }
    // last step append the HTML fragment to the final select DOM element
    selectElement.appendChild(selectOptionsFragment);
    return { selectElement, hasFoundSearchTerm };
}

const moment$4 = moment_['default'] || moment_; // patch to fix rollup "moment has no default export" issue, document here https://github.com/rollup/rollup/issues/670
/**
 * Find the option value from the following (in order of execution)
 * 1- Column Definition "params"
 * 2- Grid Options "formatterOptions"
 * 3- nothing found, return default value provided
 */
function getValueFromParamsOrFormatterOptions(optionName, columnDef, grid, defaultValue) {
    var _a;
    const gridOptions = ((grid && typeof grid.getOptions === 'function') ? grid.getOptions() : {});
    const params = columnDef && columnDef.params;
    if (params && params.hasOwnProperty(optionName)) {
        return params[optionName];
    }
    else if ((_a = gridOptions.formatterOptions) === null || _a === void 0 ? void 0 : _a.hasOwnProperty(optionName)) {
        return gridOptions.formatterOptions[optionName];
    }
    return defaultValue;
}
/** From a FieldType, return the associated date Formatter */
function getAssociatedDateFormatter(fieldType, defaultSeparator) {
    const defaultDateFormat = mapMomentDateFormatWithFieldType(fieldType);
    return (_row, _cell, value, columnDef, _dataContext, grid) => {
        var _a, _b, _c, _d, _e;
        const gridOptions = ((grid && typeof grid.getOptions === 'function') ? grid.getOptions() : {});
        const customSeparator = (_b = (_a = gridOptions === null || gridOptions === void 0 ? void 0 : gridOptions.formatterOptions) === null || _a === void 0 ? void 0 : _a.dateSeparator) !== null && _b !== void 0 ? _b : defaultSeparator;
        const inputType = (_c = columnDef === null || columnDef === void 0 ? void 0 : columnDef.type) !== null && _c !== void 0 ? _c : FieldType.date;
        const inputDateFormat = mapMomentDateFormatWithFieldType(inputType);
        const isParsingAsUtc = (_e = (_d = columnDef === null || columnDef === void 0 ? void 0 : columnDef.params) === null || _d === void 0 ? void 0 : _d.parseDateAsUtc) !== null && _e !== void 0 ? _e : false;
        const isDateValid = moment$4(value, inputDateFormat, false).isValid();
        let outputDate = value;
        if (value && isDateValid) {
            outputDate = isParsingAsUtc ? moment$4.utc(value).format(defaultDateFormat) : moment$4(value).format(defaultDateFormat);
        }
        // user can customize the separator through the "formatterOptions"
        // if that is the case we need to replace the default "/" to the new separator
        if (outputDate && customSeparator !== defaultSeparator) {
            const regex = new RegExp(defaultSeparator, 'ig'); // find separator globally
            outputDate = outputDate.replace(regex, customSeparator);
        }
        return outputDate;
    };
}
/**
 * Goes through every possible ways to find and apply a Formatter when found,
 * it will first check if a `exportCustomFormatter` is defined else it will check if there's a regular `formatter` and `exportWithFormatter` is enabled.
 * This function is similar to `applyFormatterWhenDefined()` except that it execute any `exportCustomFormatter` while `applyFormatterWhenDefined` does not.
 * @param {Number} row - grid row index
 * @param {Number} col - grid column index
 * @param {Object} dataContext - item data context object
 * @param {Object} columnDef - column definition
 * @param {Object} grid - Slick Grid object
 * @param {Object} exportOptions - Excel or Text Export Options
 * @returns formatted string output or empty string
 */
function exportWithFormatterWhenDefined(row, col, columnDef, dataContext, grid, exportOptions) {
    let isEvaluatingFormatter = false;
    // first check if there are any export options provided (as Grid Options)
    if (exportOptions && exportOptions.hasOwnProperty('exportWithFormatter')) {
        isEvaluatingFormatter = !!exportOptions.exportWithFormatter;
    }
    // second check if "exportWithFormatter" is provided in the column definition, if so it will have precendence over the Grid Options exportOptions
    if (columnDef && columnDef.hasOwnProperty('exportWithFormatter')) {
        isEvaluatingFormatter = !!columnDef.exportWithFormatter;
    }
    let formatter;
    if (dataContext && columnDef.exportCustomFormatter) {
        // did the user provide a Custom Formatter for the export
        formatter = columnDef.exportCustomFormatter;
    }
    else if (isEvaluatingFormatter && columnDef.formatter) {
        // or else do we have a column Formatter AND are we evaluating it?
        formatter = columnDef.formatter;
    }
    return parseFormatterWhenExist(formatter, row, col, columnDef, dataContext, grid);
}
/**
 * Takes a Formatter function, execute and return the formatted output
 * @param {Function} formatter - formatter function
 * @param {Number} row - grid row index
 * @param {Number} col - grid column index
 * @param {Object} dataContext - item data context object
 * @param {Object} columnDef - column definition
 * @param {Object} grid - Slick Grid object
 * @returns formatted string output or empty string
 */
function parseFormatterWhenExist(formatter, row, col, columnDef, dataContext, grid) {
    let output = '';
    // does the field have the dot (.) notation and is a complex object? if so pull the first property name
    const fieldId = columnDef.field || columnDef.id || '';
    let fieldProperty = fieldId;
    if (typeof columnDef.field === 'string' && columnDef.field.indexOf('.') > 0) {
        const props = columnDef.field.split('.');
        fieldProperty = (props.length > 0) ? props[0] : columnDef.field;
    }
    const cellValue = dataContext.hasOwnProperty(fieldProperty) ? dataContext[fieldProperty] : null;
    if (typeof formatter === 'function') {
        const formattedData = formatter(row, col, cellValue, columnDef, dataContext, grid);
        output = formattedData;
        if (formattedData && typeof formattedData === 'object' && formattedData.hasOwnProperty('text')) {
            output = formattedData.text;
        }
        if (output === null || output === undefined) {
            output = '';
        }
    }
    else {
        output = (!dataContext.hasOwnProperty(fieldProperty)) ? '' : cellValue;
        if (output === null || output === undefined) {
            output = '';
        }
    }
    // if at the end we have an empty object, then replace it with an empty string
    if (typeof output === 'object' && Object.entries(output).length === 0) {
        output = '';
    }
    return output;
}

const moment$3 = moment_['default'] || moment_; // patch to fix rollup "moment has no default export" issue, document here https://github.com/rollup/rollup/issues/670
const DEFAULT_EXPORT_OPTIONS$1 = {
    filename: 'export',
    format: FileType.xlsx
};
class ExcelExportService {
    constructor(translate) {
        this.translate = translate;
        this._fileFormat = FileType.xlsx;
        this._hasColumnTitlePreHeader = false;
        this._hasGroupedItems = false;
        this.onGridBeforeExportToExcel = new Subject();
        this.onGridAfterExportToExcel = new Subject();
    }
    get datasetIdName() {
        return this._gridOptions && this._gridOptions.datasetIdPropertyName || 'id';
    }
    /** Getter for the Grid Options pulled through the Grid Object */
    get _gridOptions() {
        return (this._grid && this._grid.getOptions) ? this._grid.getOptions() : {};
    }
    /**
     * Initialize the Export Service
     * @param grid
     * @param dataView
     */
    init(grid, dataView) {
        this._grid = grid;
        this._dataView = dataView;
        // get locales provided by user in forRoot or else use default English locales via the Constants
        this._locales = this._gridOptions && this._gridOptions.locales || Constants.locales;
        if (this._gridOptions.enableTranslate && (!this.translate || !this.translate.instant)) {
            throw new Error('[Angular-Slickgrid] requires "ngx-translate" to be installed and configured when the grid option "enableTranslate" is enabled.');
        }
    }
    /**
     * Function to export the Grid result to an Excel CSV format using javascript for it to produce the CSV file.
     * This is a WYSIWYG export to file output (What You See is What You Get)
     *
     * NOTES: The column position needs to match perfectly the JSON Object position because of the way we are pulling the data,
     * which means that if any column(s) got moved in the UI, it has to be reflected in the JSON array output as well
     *
     * Example: exportToExcel({ format: FileType.csv, delimiter: DelimiterType.comma })
     */
    exportToExcel(options) {
        if (!this._grid || !this._dataView) {
            throw new Error('[Angular-Slickgrid] it seems that the SlickGrid & DataView objects are not initialized did you forget to enable the grid option flag "enableExcelExport"?');
        }
        return new Promise((resolve, reject) => {
            this.onGridBeforeExportToExcel.next(true);
            this._excelExportOptions = deepCopy(Object.assign(Object.assign(Object.assign({}, DEFAULT_EXPORT_OPTIONS$1), this._gridOptions.excelExportOptions), options));
            this._fileFormat = this._excelExportOptions.format || FileType.xlsx;
            // prepare the Excel Workbook & Sheet
            this._workbook = new ExcelBuilder.Workbook();
            this._sheet = new ExcelBuilder.Worksheet({ name: this._excelExportOptions.sheetName || 'Sheet1' });
            // add any Excel Format/Stylesheet to current Workbook
            this._stylesheet = this._workbook.getStyleSheet();
            const boldFormatter = this._stylesheet.createFormat({ font: { bold: true } });
            const stringFormatter = this._stylesheet.createFormat({ format: '@' });
            const numberFormatter = this._stylesheet.createFormat({ format: '0' });
            const usdFormatter = this._stylesheet.createFormat({ format: '$#,##0.00' });
            this._stylesheetFormats = {
                boldFormatter,
                dollarFormatter: usdFormatter,
                numberFormatter,
                stringFormatter,
            };
            // get the CSV output from the grid data
            const dataOutput = this.getDataOutput();
            // trigger a download file
            // wrap it into a setTimeout so that the EventAggregator has enough time to start a pre-process like showing a spinner
            setTimeout(() => __awaiter(this, void 0, void 0, function* () {
                try {
                    if (this._gridOptions && this._gridOptions.excelExportOptions && this._gridOptions.excelExportOptions.customExcelHeader) {
                        this._gridOptions.excelExportOptions.customExcelHeader(this._workbook, this._sheet);
                    }
                    const columns = this._grid && this._grid.getColumns && this._grid.getColumns() || [];
                    this._sheet.setColumns(this.getColumnStyles(columns));
                    const currentSheetData = this._sheet.data;
                    let finalOutput = currentSheetData;
                    if (Array.isArray(currentSheetData) && Array.isArray(dataOutput)) {
                        finalOutput = this._sheet.data.concat(dataOutput);
                    }
                    this._sheet.setData(finalOutput);
                    this._workbook.addWorksheet(this._sheet);
                    const mimeType = this._fileFormat === FileType.xls ? 'application/vnd.ms-excel' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet ';
                    const excelBlob = yield ExcelBuilder.Builder.createFile(this._workbook, { type: 'blob', mimeType });
                    const downloadOptions = {
                        filename: `${this._excelExportOptions.filename}.${this._fileFormat}`,
                        format: this._fileFormat
                    };
                    // start downloading but add the Blob property only on the start download not on the event itself
                    this.startDownloadFile(Object.assign(Object.assign({}, downloadOptions), { blob: excelBlob, data: this._sheet.data }));
                    this.onGridAfterExportToExcel.next(downloadOptions);
                    resolve(true);
                }
                catch (error) {
                    reject(error);
                }
            }));
        });
    }
    /**
     * Takes a positive integer and returns the corresponding column name.
     * dealing with the Excel column position is a bit tricky since the first 26 columns are single char (A,B,...) but after that it becomes double char (AA,AB,...)
     * so we must first see if we are in the first section of 26 chars, if that is the case we just concatenate 1 (1st row) so it becomes (A1, B1, ...)
     * and again if we go 26, we need to add yet again an extra prefix (AA1, AB1, ...) and so goes the cycle
     * @param {number} colIndex - The positive integer to convert to a column name.
     * @return {string}  The column name.
     */
    getExcelColumnNameByIndex(colIndex) {
        const letters = 'ZABCDEFGHIJKLMNOPQRSTUVWXY';
        let nextPos = Math.floor(colIndex / 26);
        const lastPos = Math.floor(colIndex % 26);
        if (lastPos === 0) {
            nextPos--;
        }
        if (colIndex > 26) {
            return this.getExcelColumnNameByIndex(nextPos) + letters[lastPos];
        }
        return letters[lastPos] + '';
    }
    /**
     * Triggers download file with file format.
     * IE(6-10) are not supported
     * All other browsers will use plain javascript on client side to produce a file download.
     * @param options
     */
    startDownloadFile(options) {
        // IE(6-10) don't support javascript download and our service doesn't support either so throw an error, we have to make a round trip to the Web Server for exporting
        if (navigator.appName === 'Microsoft Internet Explorer') {
            throw new Error('Microsoft Internet Explorer 6 to 10 do not support javascript export to Excel. Please upgrade your browser.');
        }
        // when using IE/Edge, then use different download call
        if (typeof navigator.msSaveOrOpenBlob === 'function') {
            navigator.msSaveOrOpenBlob(options.blob, options.filename);
        }
        else {
            // this trick will generate a temp <a /> tag
            // the code will then trigger a hidden click for it to start downloading
            const link = document && document.createElement('a');
            const url = URL.createObjectURL(options.blob);
            if (link && document) {
                link.textContent = 'download';
                link.href = url;
                link.setAttribute('download', options.filename);
                // set the visibility to hidden so there is no effect on your web-layout
                link.style.visibility = 'hidden';
                // this part will append the anchor tag, trigger a click (for download to start) and finally remove the tag once completed
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    }
    /** use different Excel Stylesheet Format as per the Field Type */
    useCellFormatByFieldType(data, fieldType) {
        let outputData = data;
        switch (fieldType) {
            case FieldType.dateTime:
            case FieldType.dateTimeIso:
            case FieldType.dateTimeShortIso:
            case FieldType.dateTimeIsoAmPm:
            case FieldType.dateTimeIsoAM_PM:
            case FieldType.dateEuro:
            case FieldType.dateEuroShort:
            case FieldType.dateTimeEuro:
            case FieldType.dateTimeShortEuro:
            case FieldType.dateTimeEuroAmPm:
            case FieldType.dateTimeEuroAM_PM:
            case FieldType.dateTimeEuroShort:
            case FieldType.dateTimeEuroShortAmPm:
            case FieldType.dateUs:
            case FieldType.dateUsShort:
            case FieldType.dateTimeUs:
            case FieldType.dateTimeShortUs:
            case FieldType.dateTimeUsAmPm:
            case FieldType.dateTimeUsAM_PM:
            case FieldType.dateTimeUsShort:
            case FieldType.dateTimeUsShortAmPm:
            case FieldType.dateUtc:
            case FieldType.date:
            case FieldType.dateIso:
                outputData = data;
                if (data) {
                    const defaultDateFormat = mapMomentDateFormatWithFieldType(fieldType);
                    const isDateValid = moment$3(data, defaultDateFormat, false).isValid();
                    const outputDate = (data && isDateValid) ? moment$3(data).format(defaultDateFormat) : data;
                    const dateFormatter = this._stylesheet.createFormat({ format: defaultDateFormat });
                    outputData = { value: outputDate, metadata: { style: dateFormatter.id } };
                }
                break;
            case FieldType.number:
                const val = isNaN(+data) ? null : +data;
                outputData = { value: val, metadata: { style: this._stylesheetFormats.numberFormatter.id } };
                break;
            default:
                outputData = data;
        }
        return outputData;
    }
    // -----------------------
    // Private functions
    // -----------------------
    getDataOutput() {
        const columns = this._grid && this._grid.getColumns && this._grid.getColumns() || [];
        // data variable which will hold all the fields data of a row
        const outputData = [];
        const columnHeaderStyle = this._gridOptions && this._gridOptions.excelExportOptions && this._gridOptions.excelExportOptions.columnHeaderStyle;
        let columnHeaderStyleId = this._stylesheetFormats.boldFormatter.id;
        if (columnHeaderStyle) {
            columnHeaderStyleId = this._stylesheet.createFormat(columnHeaderStyle).id;
        }
        // get all Grouped Column Header Titles when defined (from pre-header row)
        if (this._gridOptions.createPreHeaderPanel && this._gridOptions.showPreHeaderPanel && !this._gridOptions.enableDraggableGrouping) {
            // when having Grouped Header Titles (in the pre-header), then make the cell Bold & Aligned Center
            const boldCenterAlign = this._stylesheet.createFormat({ alignment: { horizontal: 'center' }, font: { bold: true } });
            outputData.push(this.getColumnGroupedHeaderTitlesData(columns, { style: boldCenterAlign && boldCenterAlign.id }));
            this._hasColumnTitlePreHeader = true;
        }
        // get all Column Header Titles (it might include a "Group by" title at A1 cell)
        // also style the headers, defaults to Bold but user could pass his own style
        outputData.push(this.getColumnHeaderData(columns, { style: columnHeaderStyleId }));
        // Populate the rest of the Grid Data
        this.pushAllGridRowDataToArray(outputData, columns);
        return outputData;
    }
    /** Get each column style including a style for the width of each column */
    getColumnStyles(columns) {
        const grouping = this._dataView && this._dataView.getGrouping && this._dataView.getGrouping();
        const columnStyles = [];
        if (Array.isArray(grouping) && grouping.length > 0) {
            columnStyles.push({
                bestFit: true,
                columnStyles: (this._gridOptions && this._gridOptions.excelExportOptions && this._gridOptions.excelExportOptions.customColumnWidth) || 10
            });
        }
        columns.forEach((columnDef) => {
            const skippedField = columnDef.excludeFromExport || false;
            // if column width is 0, then we consider that field as a hidden field and should not be part of the export
            if ((columnDef.width === undefined || columnDef.width > 0) && !skippedField) {
                columnStyles.push({
                    bestFit: true,
                    width: columnDef.exportColumnWidth || (this._gridOptions && this._gridOptions.excelExportOptions && this._gridOptions.excelExportOptions.customColumnWidth) || 10
                });
            }
        });
        return columnStyles;
    }
    /**
     * Get all Grouped Header Titles and their keys, translate the title when required, and format them in Bold
     * @param {Array<Object>} columns - grid column definitions
     * @param {Object} metadata - Excel metadata
     * @returns {Object} array of Excel cell format
     */
    getColumnGroupedHeaderTitlesData(columns, metadata) {
        let outputGroupedHeaderTitles = [];
        // get all Column Header Titles
        this._groupedColumnHeaders = this.getColumnGroupedHeaderTitles(columns) || [];
        if (this._groupedColumnHeaders && Array.isArray(this._groupedColumnHeaders) && this._groupedColumnHeaders.length > 0) {
            // add the header row + add a new line at the end of the row
            outputGroupedHeaderTitles = this._groupedColumnHeaders.map((header) => ({ value: header.title, metadata }));
        }
        // merge necessary cells (any grouped header titles)
        let colspanStartIndex = 0;
        const headersLn = this._groupedColumnHeaders.length;
        for (let cellIndex = 0; cellIndex < headersLn; cellIndex++) {
            if ((cellIndex + 1) === headersLn || ((cellIndex + 1) < headersLn && this._groupedColumnHeaders[cellIndex].title !== this._groupedColumnHeaders[cellIndex + 1].title)) {
                const leftExcelColumnChar = this.getExcelColumnNameByIndex(colspanStartIndex + 1);
                const rightExcelColumnChar = this.getExcelColumnNameByIndex(cellIndex + 1);
                this._sheet.mergeCells(`${leftExcelColumnChar}1`, `${rightExcelColumnChar}1`);
                // next group starts 1 column index away
                colspanStartIndex = cellIndex + 1;
            }
        }
        return outputGroupedHeaderTitles;
    }
    /** Get all column headers and format them in Bold */
    getColumnHeaderData(columns, metadata) {
        let outputHeaderTitles = [];
        // get all Column Header Titles
        this._columnHeaders = this.getColumnHeaders(columns) || [];
        if (this._columnHeaders && Array.isArray(this._columnHeaders) && this._columnHeaders.length > 0) {
            // add the header row + add a new line at the end of the row
            outputHeaderTitles = this._columnHeaders.map((header) => ({ value: header.title, metadata }));
        }
        // do we have a Group by title?
        const groupTitle = this.getGroupColumnTitle();
        if (groupTitle) {
            outputHeaderTitles.unshift({ value: groupTitle, metadata });
        }
        return outputHeaderTitles;
    }
    getGroupColumnTitle() {
        // Group By text, it could be set in the export options or from translation or if nothing is found then use the English constant text
        let groupByColumnHeader = this._excelExportOptions.groupingColumnHeaderTitle;
        if (!groupByColumnHeader && this._gridOptions.enableTranslate && this.translate && this.translate.currentLang && this.translate.instant) {
            groupByColumnHeader = this.translate.instant(`${getTranslationPrefix(this._gridOptions)}GROUP_BY`);
        }
        else if (!groupByColumnHeader) {
            groupByColumnHeader = this._locales && this._locales.TEXT_GROUP_BY;
        }
        // get grouped column titles and if found, we will add a "Group by" column at the first column index
        // if it's a CSV format, we'll escape the text in double quotes
        const grouping = this._dataView && this._dataView.getGrouping && this._dataView.getGrouping();
        if (Array.isArray(grouping) && grouping.length > 0) {
            this._hasGroupedItems = true;
            return groupByColumnHeader;
        }
        else {
            this._hasGroupedItems = false;
        }
        return null;
    }
    /**
     * Get all Grouped Header Titles and their keys, translate the title when required.
     * @param {Array<object>} columns of the grid
     */
    getColumnGroupedHeaderTitles(columns) {
        const groupedColumnHeaders = [];
        if (columns && Array.isArray(columns)) {
            // Populate the Grouped Column Header, pull the columnGroup(Key) defined
            columns.forEach((columnDef) => {
                let groupedHeaderTitle = '';
                if (columnDef.columnGroupKey && this._gridOptions.enableTranslate && this.translate && this.translate.currentLang && this.translate.instant) {
                    groupedHeaderTitle = this.translate.instant(columnDef.columnGroupKey);
                }
                else {
                    groupedHeaderTitle = columnDef.columnGroup;
                }
                const skippedField = columnDef.excludeFromExport || false;
                // if column width is 0px, then we consider that field as a hidden field and should not be part of the export
                if ((columnDef.width === undefined || columnDef.width > 0) && !skippedField) {
                    groupedColumnHeaders.push({
                        key: (columnDef.field || columnDef.id),
                        title: groupedHeaderTitle || '',
                    });
                }
            });
        }
        return groupedColumnHeaders;
    }
    /**
     * Get all header titles and their keys, translate the title when required.
     * @param columns of the grid
     */
    getColumnHeaders(columns) {
        const columnHeaders = [];
        if (columns && Array.isArray(columns)) {
            // Populate the Column Header, pull the name defined
            columns.forEach((columnDef) => {
                let headerTitle = '';
                if ((columnDef.headerKey || columnDef.nameKey) && this._gridOptions.enableTranslate && this.translate && this.translate.currentLang && this.translate.instant) {
                    headerTitle = this.translate.instant((columnDef.headerKey || columnDef.nameKey) || ' ');
                }
                else {
                    headerTitle = columnDef.name || titleCase(columnDef.field);
                }
                const skippedField = columnDef.excludeFromExport || false;
                // if column width is 0, then we consider that field as a hidden field and should not be part of the export
                if ((columnDef.width === undefined || columnDef.width > 0) && !skippedField) {
                    columnHeaders.push({
                        key: columnDef.field || columnDef.id,
                        title: headerTitle
                    });
                }
            });
        }
        return columnHeaders;
    }
    /**
     * Get all the grid row data and return that as an output string
     */
    pushAllGridRowDataToArray(originalDataArray, columns) {
        var _a, _b;
        const lineCount = (_b = (_a = this._dataView) === null || _a === void 0 ? void 0 : _a.getLength()) !== null && _b !== void 0 ? _b : 0;
        // loop through all the grid rows of data
        for (let rowNumber = 0; rowNumber < lineCount; rowNumber++) {
            const itemObj = this._dataView.getItem(rowNumber);
            // make sure we have a filled object AND that the item doesn't include the "getItem" method
            // this happen could happen with an opened Row Detail as it seems to include an empty Slick DataView (we'll just skip those lines)
            if (itemObj && !itemObj.hasOwnProperty('getItem')) {
                // Normal row (not grouped by anything) would have an ID which was predefined in the Grid Columns definition
                if (itemObj[this.datasetIdName] !== null && itemObj[this.datasetIdName] !== undefined) {
                    // get regular row item data
                    originalDataArray.push(this.readRegularRowData(columns, rowNumber, itemObj));
                }
                else if (this._hasGroupedItems && itemObj.__groupTotals === undefined) {
                    // get the group row
                    originalDataArray.push([this.readGroupedTitleRow(itemObj)]);
                }
                else if (itemObj.__groupTotals) {
                    // else if the row is a Group By and we have agreggators, then a property of '__groupTotals' would exist under that object
                    originalDataArray.push(this.readGroupedTotalRow(columns, itemObj));
                }
            }
        }
        return originalDataArray;
    }
    /**
     * Get the data of a regular row (a row without grouping).
     * If the row has colspan, we will also merge the cells data
     * @param row
     * @param itemObj
     */
    readRegularRowData(columns, row, itemObj) {
        var _a;
        let idx = 0;
        const rowOutputStrings = [];
        const columnsLn = columns.length;
        let prevColspan = 1;
        let colspanStartIndex = 0;
        const itemMetadata = this._dataView.getItemMetadata(row);
        for (let col = 0; col < columnsLn; col++) {
            const columnDef = columns[col];
            const fieldType = columnDef.outputType || columnDef.type || FieldType.string;
            // skip excluded column
            if (columnDef.excludeFromExport) {
                continue;
            }
            // if we are grouping and are on 1st column index, we need to skip this column since it will be used later by the grouping text:: Group by [columnX]
            if (this._hasGroupedItems && idx === 0) {
                rowOutputStrings.push('');
            }
            let colspan = 1;
            let colspanColumnId;
            if (itemMetadata === null || itemMetadata === void 0 ? void 0 : itemMetadata.columns) {
                const metadata = itemMetadata === null || itemMetadata === void 0 ? void 0 : itemMetadata.columns;
                const columnData = metadata[columnDef.id] || metadata[col];
                if (!(prevColspan > 1 || (prevColspan === '*' && col > 0))) {
                    prevColspan = (_a = columnData === null || columnData === void 0 ? void 0 : columnData.colspan) !== null && _a !== void 0 ? _a : 1;
                }
                if (prevColspan === '*') {
                    colspan = columns.length - col;
                }
                else {
                    colspan = prevColspan;
                    if (columnDef.id in metadata) {
                        colspanColumnId = columnDef.id;
                        colspanStartIndex = col;
                    }
                }
            }
            // when using grid with colspan, we will merge some cells together
            if ((prevColspan === '*' && col > 0) || (prevColspan > 1 && columnDef.id !== colspanColumnId)) {
                // -- Merge Data
                // Excel row starts at 2 or at 3 when dealing with pre-header grouping
                const excelRowNumber = row + (this._hasColumnTitlePreHeader ? 3 : 2);
                if (typeof prevColspan === 'number' && (colspan - 1) === 1) {
                    // partial column span
                    const leftExcelColumnChar = this.getExcelColumnNameByIndex(colspanStartIndex + 1);
                    const rightExcelColumnChar = this.getExcelColumnNameByIndex(col + 1);
                    this._sheet.mergeCells(`${leftExcelColumnChar}${excelRowNumber}`, `${rightExcelColumnChar}${excelRowNumber}`);
                    rowOutputStrings.push(''); // clear cell that won't be shown by a cell merge
                }
                else if (prevColspan === '*' && colspan === 1) {
                    // full column span (from A1 until the last column)
                    const rightExcelColumnChar = this.getExcelColumnNameByIndex(col + 1);
                    this._sheet.mergeCells(`A${excelRowNumber}`, `${rightExcelColumnChar}${excelRowNumber}`);
                }
                else {
                    rowOutputStrings.push(''); // clear cell that won't be shown by a cell merge
                }
                // decrement colspan until we reach colspan of 1 then proceed with cell merge OR full row merge when colspan is (*)
                if (typeof prevColspan === 'number' && prevColspan > 1) {
                    colspan = prevColspan--;
                }
            }
            else {
                // -- Read Data & Push to Data Array
                // get the output by analyzing if we'll pull the value from the cell or from a formatter
                let itemData = exportWithFormatterWhenDefined(row, col, columnDef, itemObj, this._grid, this._excelExportOptions);
                // does the user want to sanitize the output data (remove HTML tags)?
                if (columnDef.sanitizeDataExport || this._excelExportOptions.sanitizeDataExport) {
                    itemData = sanitizeHtmlToText(itemData);
                }
                // use different Excel Stylesheet Format as per the Field Type
                if (!columnDef.exportWithFormatter) {
                    itemData = this.useCellFormatByFieldType(itemData, fieldType);
                }
                rowOutputStrings.push(itemData);
                idx++;
            }
        }
        return rowOutputStrings;
    }
    /**
     * Get the grouped title(s) and its group title formatter, for example if we grouped by salesRep, the returned result would be:: 'Sales Rep: John Dow (2 items)'
     * @param itemObj
     */
    readGroupedTitleRow(itemObj) {
        var _a, _b, _c, _d, _e;
        const groupName = sanitizeHtmlToText(itemObj.title);
        if ((_a = this._excelExportOptions) === null || _a === void 0 ? void 0 : _a.addGroupIndentation) {
            const collapsedSymbol = (_c = (_b = this._excelExportOptions) === null || _b === void 0 ? void 0 : _b.groupCollapsedSymbol) !== null && _c !== void 0 ? _c : '⮞';
            const expandedSymbol = (_e = (_d = this._excelExportOptions) === null || _d === void 0 ? void 0 : _d.groupExpandedSymbol) !== null && _e !== void 0 ? _e : '⮟';
            const chevron = itemObj.collapsed ? collapsedSymbol : expandedSymbol;
            return chevron + ' ' + addWhiteSpaces(5 * itemObj.level) + groupName;
        }
        return groupName;
    }
    /**
     * Get the grouped totals (below the regular rows), these are set by Slick Aggregators.
     * For example if we grouped by "salesRep" and we have a Sum Aggregator on "sales", then the returned output would be:: ["Sum 123$"]
     * @param itemObj
     */
    readGroupedTotalRow(columns, itemObj) {
        const groupingAggregatorRowText = this._excelExportOptions.groupingAggregatorRowText || '';
        const outputStrings = [groupingAggregatorRowText];
        columns.forEach((columnDef) => {
            let itemData = '';
            const skippedField = columnDef.excludeFromExport || false;
            // if there's a exportCustomGroupTotalsFormatter or groupTotalsFormatter, we will re-run it to get the exact same output as what is shown in UI
            if (columnDef.exportCustomGroupTotalsFormatter) {
                itemData = columnDef.exportCustomGroupTotalsFormatter(itemObj, columnDef);
            }
            else {
                if (columnDef.groupTotalsFormatter) {
                    itemData = columnDef.groupTotalsFormatter(itemObj, columnDef);
                }
            }
            // does the user want to sanitize the output data (remove HTML tags)?
            if (columnDef.sanitizeDataExport || this._excelExportOptions.sanitizeDataExport) {
                itemData = sanitizeHtmlToText(itemData);
            }
            // add the column (unless user wants to skip it)
            if ((columnDef.width === undefined || columnDef.width > 0) && !skippedField) {
                outputStrings.push(itemData);
            }
        });
        return outputStrings;
    }
}
ExcelExportService.ɵfac = function ExcelExportService_Factory(t) { return new (t || ExcelExportService)(ɵngcc0.ɵɵinject(ɵngcc1.TranslateService, 8)); };
ExcelExportService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ExcelExportService, factory: ExcelExportService.ɵfac });
ExcelExportService.ctorParameters = () => [
    { type: TranslateService, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ExcelExportService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.TranslateService, decorators: [{
                type: Optional
            }] }]; }, null); })();

const DEFAULT_EXPORT_OPTIONS = {
    delimiter: DelimiterType.comma,
    filename: 'export',
    format: FileType.csv,
    useUtf8WithBom: true,
};
class ExportService {
    constructor(translate) {
        this.translate = translate;
        this._delimiter = ',';
        this._fileFormat = FileType.csv;
        this._lineCarriageReturn = '\n';
        this._exportQuoteWrapper = '';
        this._hasGroupedItems = false;
        this.onGridBeforeExportToFile = new Subject();
        this.onGridAfterExportToFile = new Subject();
    }
    get datasetIdName() {
        return this._gridOptions && this._gridOptions.datasetIdPropertyName || 'id';
    }
    /** Getter for the Grid Options pulled through the Grid Object */
    get _gridOptions() {
        return (this._grid && this._grid.getOptions) ? this._grid.getOptions() : {};
    }
    /**
     * Initialize the Export Service
     * @param grid
     * @param gridOptions
     * @param dataView
     */
    init(grid, dataView) {
        this._grid = grid;
        this._dataView = dataView;
        // get locales provided by user in forRoot or else use default English locales via the Constants
        this._locales = this._gridOptions && this._gridOptions.locales || Constants.locales;
        if (this._gridOptions.enableTranslate && (!this.translate || !this.translate.instant)) {
            throw new Error('[Angular-Slickgrid] requires "ngx-translate" to be installed and configured when the grid option "enableTranslate" is enabled.');
        }
    }
    /**
     * Function to export the Grid result to an Excel CSV format using javascript for it to produce the CSV file.
     * This is a WYSIWYG export to file output (What You See is What You Get)
     *
     * NOTES: The column position needs to match perfectly the JSON Object position because of the way we are pulling the data,
     * which means that if any column(s) got moved in the UI, it has to be reflected in the JSON array output as well
     *
     * Example: exportToFile({ format: FileType.csv, delimiter: DelimiterType.comma })
     */
    exportToFile(options) {
        if (!this._grid || !this._dataView) {
            throw new Error('[Angular-Slickgrid] it seems that the SlickGrid & DataView objects are not initialized did you forget to enable the grid option flag "enableExport"?');
        }
        return new Promise((resolve, reject) => {
            this.onGridBeforeExportToFile.next(true);
            this._exportOptions = deepCopy(Object.assign(Object.assign(Object.assign({}, DEFAULT_EXPORT_OPTIONS), this._gridOptions.exportOptions), options));
            this._delimiter = this._exportOptions.delimiterOverride || this._exportOptions.delimiter || '';
            this._fileFormat = this._exportOptions.format || FileType.csv;
            // get the CSV output from the grid data
            const dataOutput = this.getDataOutput();
            // trigger a download file
            // wrap it into a setTimeout so that the EventAggregator has enough time to start a pre-process like showing a spinner
            setTimeout(() => {
                try {
                    const downloadOptions = {
                        filename: `${this._exportOptions.filename}.${this._fileFormat}`,
                        format: this._fileFormat,
                        useUtf8WithBom: this._exportOptions.hasOwnProperty('useUtf8WithBom') ? this._exportOptions.useUtf8WithBom : true
                    };
                    // start downloading but add the content property only on the start download not on the event itself
                    this.startDownloadFile(Object.assign(Object.assign({}, downloadOptions), { content: dataOutput })); // add content property
                    this.onGridAfterExportToFile.next(downloadOptions);
                    resolve(true);
                }
                catch (error) {
                    reject(error);
                }
            }, 0);
        });
    }
    /**
     * Triggers download file with file format.
     * IE(6-10) are not supported
     * All other browsers will use plain javascript on client side to produce a file download.
     * @param options
     */
    startDownloadFile(options) {
        // IE(6-10) don't support javascript download and our service doesn't support either so throw an error, we have to make a round trip to the Web Server for exporting
        if (navigator.appName === 'Microsoft Internet Explorer') {
            throw new Error('Microsoft Internet Explorer 6 to 10 do not support javascript export to CSV. Please upgrade your browser.');
        }
        // set the correct MIME type
        const mimeType = (options.format === FileType.csv) ? 'text/csv' : 'text/plain';
        // make sure no html entities exist in the data
        const dataContent = htmlEntityDecode(options.content);
        // dealing with Excel CSV export and UTF-8 is a little tricky.. We will use Option #2 to cover older Excel versions
        // Option #1: we need to make Excel knowing that it's dealing with an UTF-8, A correctly formatted UTF8 file can have a Byte Order Mark as its first three octets
        // reference: http://stackoverflow.com/questions/155097/microsoft-excel-mangles-diacritics-in-csv-files
        // Option#2: use a 3rd party extension to javascript encode into UTF-16
        let outputData;
        if (options.format === FileType.csv) {
            outputData = new TextEncoder('utf-8').encode(dataContent);
        }
        else {
            outputData = dataContent;
        }
        // create a Blob object for the download
        const blob = new Blob([options.useUtf8WithBom ? '\uFEFF' : '', outputData], {
            type: `${mimeType};charset=utf-8;`
        });
        // when using IE/Edge, then use different download call
        if (typeof navigator.msSaveOrOpenBlob === 'function') {
            navigator.msSaveOrOpenBlob(blob, options.filename);
        }
        else {
            // this trick will generate a temp <a /> tag
            // the code will then trigger a hidden click for it to start downloading
            const link = document.createElement('a');
            const csvUrl = URL.createObjectURL(blob);
            link.textContent = 'download';
            link.href = csvUrl;
            link.setAttribute('download', options.filename);
            // set the visibility to hidden so there is no effect on your web-layout
            link.style.visibility = 'hidden';
            // this part will append the anchor tag, trigger a click (for download to start) and finally remove the tag once completed
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
    // -----------------------
    // Private functions
    // -----------------------
    getDataOutput() {
        const columns = this._grid.getColumns() || [];
        // Group By text, it could be set in the export options or from translation or if nothing is found then use the English constant text
        let groupByColumnHeader = this._exportOptions.groupingColumnHeaderTitle;
        if (!groupByColumnHeader && this._gridOptions.enableTranslate && this.translate && this.translate.currentLang && this.translate.instant) {
            groupByColumnHeader = this.translate.instant(`${getTranslationPrefix(this._gridOptions)}GROUP_BY`);
        }
        else if (!groupByColumnHeader) {
            groupByColumnHeader = this._locales && this._locales.TEXT_GROUP_BY;
        }
        // a CSV needs double quotes wrapper, the other types do not need any wrapper
        this._exportQuoteWrapper = (this._fileFormat === FileType.csv) ? '"' : '';
        // data variable which will hold all the fields data of a row
        let outputDataString = '';
        // get grouped column titles and if found, we will add a "Group by" column at the first column index
        // if it's a CSV format, we'll escape the text in double quotes
        const grouping = this._dataView.getGrouping();
        if (grouping && Array.isArray(grouping) && grouping.length > 0) {
            this._hasGroupedItems = true;
            outputDataString += (this._fileFormat === FileType.csv) ? `"${groupByColumnHeader}"${this._delimiter}` : `${groupByColumnHeader}${this._delimiter}`;
        }
        else {
            this._hasGroupedItems = false;
        }
        // get all Grouped Column Header Titles when defined (from pre-header row)
        if (this._gridOptions.createPreHeaderPanel && this._gridOptions.showPreHeaderPanel && !this._gridOptions.enableDraggableGrouping) {
            this._groupedColumnHeaders = this.getColumnGroupedHeaderTitles(columns) || [];
            if (this._groupedColumnHeaders && Array.isArray(this._groupedColumnHeaders) && this._groupedColumnHeaders.length > 0) {
                // add the header row + add a new line at the end of the row
                const outputGroupedHeaderTitles = this._groupedColumnHeaders.map((header) => `${this._exportQuoteWrapper}${header.title}${this._exportQuoteWrapper}`);
                outputDataString += (outputGroupedHeaderTitles.join(this._delimiter) + this._lineCarriageReturn);
            }
        }
        // get all Column Header Titles
        this._columnHeaders = this.getColumnHeaders(columns) || [];
        if (this._columnHeaders && Array.isArray(this._columnHeaders) && this._columnHeaders.length > 0) {
            // add the header row + add a new line at the end of the row
            const outputHeaderTitles = this._columnHeaders.map((header) => `${this._exportQuoteWrapper}${header.title}${this._exportQuoteWrapper}`);
            outputDataString += (outputHeaderTitles.join(this._delimiter) + this._lineCarriageReturn);
        }
        // Populate the rest of the Grid Data
        outputDataString += this.getAllGridRowData(columns, this._lineCarriageReturn);
        return outputDataString;
    }
    /**
     * Get all the grid row data and return that as an output string
     */
    getAllGridRowData(columns, lineCarriageReturn) {
        const outputDataStrings = [];
        const lineCount = this._dataView.getLength();
        // loop through all the grid rows of data
        for (let rowNumber = 0; rowNumber < lineCount; rowNumber++) {
            const itemObj = this._dataView.getItem(rowNumber);
            // make sure we have a filled object AND that the item doesn't include the "getItem" method
            // this happen could happen with an opened Row Detail as it seems to include an empty Slick DataView (we'll just skip those lines)
            if (itemObj && !itemObj.hasOwnProperty('getItem')) {
                // Normal row (not grouped by anything) would have an ID which was predefined in the Grid Columns definition
                if (itemObj[this.datasetIdName] !== null && itemObj[this.datasetIdName] !== undefined) {
                    // get regular row item data
                    outputDataStrings.push(this.readRegularRowData(columns, rowNumber, itemObj));
                }
                else if (this._hasGroupedItems && itemObj.__groupTotals === undefined) {
                    // get the group row
                    outputDataStrings.push(this.readGroupedTitleRow(itemObj));
                }
                else if (itemObj.__groupTotals) {
                    // else if the row is a Group By and we have agreggators, then a property of '__groupTotals' would exist under that object
                    outputDataStrings.push(this.readGroupedTotalRow(columns, itemObj));
                }
            }
        }
        return outputDataStrings.join(lineCarriageReturn);
    }
    /**
   * Get all Grouped Header Titles and their keys, translate the title when required.
   * @param {Array<object>} columns of the grid
   */
    getColumnGroupedHeaderTitles(columns) {
        const groupedColumnHeaders = [];
        if (columns && Array.isArray(columns)) {
            // Populate the Grouped Column Header, pull the columnGroup(Key) defined
            columns.forEach((columnDef) => {
                let groupedHeaderTitle = '';
                if ((columnDef.columnGroupKey || columnDef.columnGroupKey) && this._gridOptions.enableTranslate && this.translate && this.translate.currentLang && this.translate.instant) {
                    groupedHeaderTitle = this.translate.instant((columnDef.columnGroupKey || columnDef.columnGroupKey));
                }
                else {
                    groupedHeaderTitle = columnDef.columnGroup || '';
                }
                const skippedField = columnDef.excludeFromExport || false;
                // if column width is 0px, then we consider that field as a hidden field and should not be part of the export
                if ((columnDef.width === undefined || columnDef.width > 0) && !skippedField) {
                    groupedColumnHeaders.push({
                        key: (columnDef.field || columnDef.id),
                        title: groupedHeaderTitle || ''
                    });
                }
            });
        }
        return groupedColumnHeaders;
    }
    /**
     * Get all header titles and their keys, translate the title when required.
     * @param {Array<object>} columns of the grid
     */
    getColumnHeaders(columns) {
        const columnHeaders = [];
        if (columns && Array.isArray(columns)) {
            // Populate the Column Header, pull the name defined
            columns.forEach((columnDef) => {
                let headerTitle = '';
                if ((columnDef.headerKey || columnDef.nameKey) && this._gridOptions.enableTranslate && this.translate && this.translate.currentLang && this.translate.instant) {
                    headerTitle = this.translate.instant((columnDef.headerKey || columnDef.nameKey) || ' ');
                }
                else {
                    headerTitle = columnDef.name || titleCase(columnDef.field);
                }
                const skippedField = columnDef.excludeFromExport || false;
                // if column width is 0, then we consider that field as a hidden field and should not be part of the export
                if ((columnDef.width === undefined || columnDef.width > 0) && !skippedField) {
                    columnHeaders.push({
                        key: columnDef.field || columnDef.id,
                        title: headerTitle
                    });
                }
            });
        }
        return columnHeaders;
    }
    /**
     * Get the data of a regular row (a row without grouping)
     * @param row
     * @param itemObj
     */
    readRegularRowData(columns, row, itemObj) {
        var _a;
        let idx = 0;
        const rowOutputStrings = [];
        const exportQuoteWrapper = this._exportQuoteWrapper;
        let prevColspan = 1;
        const itemMetadata = this._dataView.getItemMetadata(row);
        for (let col = 0, ln = columns.length; col < ln; col++) {
            const columnDef = columns[col];
            // skip excluded column
            if (columnDef.excludeFromExport) {
                continue;
            }
            // if we are grouping and are on 1st column index, we need to skip this column since it will be used later by the grouping text:: Group by [columnX]
            if (this._hasGroupedItems && idx === 0) {
                const emptyValue = this._fileFormat === FileType.csv ? `""` : '';
                rowOutputStrings.push(emptyValue);
            }
            let colspanColumnId;
            if (itemMetadata === null || itemMetadata === void 0 ? void 0 : itemMetadata.columns) {
                const metadata = itemMetadata === null || itemMetadata === void 0 ? void 0 : itemMetadata.columns;
                const columnData = metadata[columnDef.id] || metadata[col];
                if (!(prevColspan > 1 || (prevColspan === '*' && col > 0))) {
                    prevColspan = (_a = columnData === null || columnData === void 0 ? void 0 : columnData.colspan) !== null && _a !== void 0 ? _a : 1;
                }
                if (prevColspan !== '*') {
                    if (columnDef.id in metadata) {
                        colspanColumnId = columnDef.id;
                    }
                }
            }
            if ((prevColspan === '*' && col > 0) || (prevColspan > 1 && columnDef.id !== colspanColumnId)) {
                rowOutputStrings.push('');
                if (prevColspan > 1) {
                    prevColspan--;
                }
            }
            else {
                // get the output by analyzing if we'll pull the value from the cell or from a formatter
                let itemData = exportWithFormatterWhenDefined(row, col, columnDef, itemObj, this._grid, this._exportOptions);
                // does the user want to sanitize the output data (remove HTML tags)?
                if (columnDef.sanitizeDataExport || this._exportOptions.sanitizeDataExport) {
                    itemData = sanitizeHtmlToText(itemData);
                }
                // when CSV we also need to escape double quotes twice, so " becomes ""
                if (this._fileFormat === FileType.csv && itemData) {
                    itemData = itemData.toString().replace(/"/gi, `""`);
                }
                // do we have a wrapper to keep as a string? in certain cases like "1E06", we don't want excel to transform it into exponential (1.0E06)
                // to cancel that effect we can had = in front, ex: ="1E06"
                const keepAsStringWrapper = (columnDef === null || columnDef === void 0 ? void 0 : columnDef.exportCsvForceToKeepAsString) ? '=' : '';
                rowOutputStrings.push(keepAsStringWrapper + exportQuoteWrapper + itemData + exportQuoteWrapper);
            }
            idx++;
        }
        return rowOutputStrings.join(this._delimiter);
    }
    /**
     * Get the grouped title(s) and its group title formatter, for example if we grouped by salesRep, the returned result would be:: 'Sales Rep: John Dow (2 items)'
     * @param itemObj
     */
    readGroupedTitleRow(itemObj) {
        let groupName = sanitizeHtmlToText(itemObj.title);
        const exportQuoteWrapper = this._exportQuoteWrapper;
        groupName = addWhiteSpaces(5 * itemObj.level) + groupName;
        if (this._fileFormat === FileType.csv) {
            // when CSV we also need to escape double quotes twice, so " becomes ""
            groupName = groupName.toString().replace(/"/gi, `""`);
        }
        return exportQuoteWrapper + groupName + exportQuoteWrapper;
    }
    /**
     * Get the grouped totals (below the regular rows), these are set by Slick Aggregators.
     * For example if we grouped by "salesRep" and we have a Sum Aggregator on "sales", then the returned output would be:: ["Sum 123$"]
     * @param itemObj
     */
    readGroupedTotalRow(columns, itemObj) {
        const delimiter = this._exportOptions.delimiter;
        const format = this._exportOptions.format;
        const groupingAggregatorRowText = this._exportOptions.groupingAggregatorRowText || '';
        const exportQuoteWrapper = this._exportQuoteWrapper;
        const outputStrings = [`${exportQuoteWrapper}${groupingAggregatorRowText}${exportQuoteWrapper}`];
        columns.forEach((columnDef) => {
            let itemData = '';
            const skippedField = columnDef.excludeFromExport || false;
            // if there's a groupTotalsFormatter, we will re-run it to get the exact same output as what is shown in UI
            if (columnDef.groupTotalsFormatter) {
                itemData = columnDef.groupTotalsFormatter(itemObj, columnDef);
            }
            // does the user want to sanitize the output data (remove HTML tags)?
            if (columnDef.sanitizeDataExport || this._exportOptions.sanitizeDataExport) {
                itemData = sanitizeHtmlToText(itemData);
            }
            if (format === FileType.csv) {
                // when CSV we also need to escape double quotes twice, so a double quote " becomes 2x double quotes ""
                itemData = itemData.toString().replace(/"/gi, `""`);
            }
            // add the column (unless user wants to skip it)
            if ((columnDef.width === undefined || columnDef.width > 0) && !skippedField) {
                outputStrings.push(exportQuoteWrapper + itemData + exportQuoteWrapper);
            }
        });
        return outputStrings.join(delimiter);
    }
}
ExportService.ɵfac = function ExportService_Factory(t) { return new (t || ExportService)(ɵngcc0.ɵɵinject(ɵngcc1.TranslateService, 8)); };
ExportService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ExportService, factory: ExportService.ɵfac });
ExportService.ctorParameters = () => [
    { type: TranslateService, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ExportService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.TranslateService, decorators: [{
                type: Optional
            }] }]; }, null); })();

class SharedService {
    constructor() {
        this._allColumns = [];
        this._hasColumnsReordered = false;
        this._hideHeaderRowAfterPageLoad = false;
        this._visibleColumns = [];
        this.onHeaderMenuHideColumns = new Subject();
        this.onTreeItemToggled = new Subject();
        this.onTreeFullToggleStart = new Subject();
        this.onTreeFullToggleEnd = new Subject();
    }
    // --
    // public
    /** Getter for All Columns  in the grid (hidden/visible) */
    get allColumns() {
        return this._allColumns;
    }
    /** Setter for All Columns  in the grid (hidden/visible) */
    set allColumns(allColumns) {
        this._allColumns = allColumns;
    }
    /** Getter for the Column Definitions pulled through the Grid Object */
    get columnDefinitions() {
        return (this._grid && this._grid.getColumns) ? this._grid.getColumns() : [];
    }
    /** Getter for the Current Pagination (when Pagination is enabled) */
    get currentPagination() {
        return this._currentPagination;
    }
    /** Setter for the Current Pagination (when Pagination is enabled) */
    set currentPagination(currentPagination) {
        this._currentPagination = currentPagination;
    }
    /** Getter for SlickGrid DataView object */
    get dataView() {
        return this._dataView;
    }
    /** Setter for SlickGrid DataView object */
    set dataView(dataView) {
        this._dataView = dataView;
    }
    /** Setter to keep the frozen column id for reference if we ever show/hide column from ColumnPicker/GridMenu afterward */
    get frozenVisibleColumnId() {
        return this._frozenVisibleColumnId;
    }
    /** Getter to keep the frozen column id for reference if we ever show/hide column from ColumnPicker/GridMenu afterward */
    set frozenVisibleColumnId(columnId) {
        this._frozenVisibleColumnId = columnId;
    }
    /** Setter to keep the frozen column id for reference if we ever show/hide column from ColumnPicker/GridMenu afterward */
    get hasColumnsReordered() {
        return this._hasColumnsReordered;
    }
    /** Getter to keep the frozen column id for reference if we ever show/hide column from ColumnPicker/GridMenu afterward */
    set hasColumnsReordered(isColumnReordered) {
        this._hasColumnsReordered = isColumnReordered;
    }
    /** Getter for SlickGrid Grid object */
    get grid() {
        return this._grid;
    }
    /** Setter for SlickGrid Grid object */
    set grid(grid) {
        this._grid = grid;
    }
    /** Getter for the Grid Options pulled through the Grid Object */
    get gridOptions() {
        return this._gridOptions || this._grid && this._grid.getOptions && this._grid.getOptions() || {};
    }
    /** Setter for the Grid Options pulled through the Grid Object */
    set gridOptions(gridOptions) {
        this._gridOptions = gridOptions;
    }
    /** Getter for the Grid Options */
    get groupItemMetadataProvider() {
        return this._groupItemMetadataProvider;
    }
    /** Setter for the Grid Options */
    set groupItemMetadataProvider(groupItemMetadataProvider) {
        this._groupItemMetadataProvider = groupItemMetadataProvider;
    }
    /** Getter to know if user want to hide header row after 1st page load */
    get hideHeaderRowAfterPageLoad() {
        return this._hideHeaderRowAfterPageLoad;
    }
    /** Setter for knowing if user want to hide header row after 1st page load */
    set hideHeaderRowAfterPageLoad(hideHeaderRowAfterPageLoad) {
        this._hideHeaderRowAfterPageLoad = hideHeaderRowAfterPageLoad;
    }
    /** Getter for the Visible Columns in the grid */
    get visibleColumns() {
        return this._visibleColumns;
    }
    /** Setter for the Visible Columns in the grid */
    set visibleColumns(visibleColumns) {
        this._visibleColumns = visibleColumns;
    }
    /** Getter for the Hierarchical Tree Data dataset when the feature is enabled */
    get hierarchicalDataset() {
        return this._hierarchicalDataset;
    }
    /** Getter for the Hierarchical Tree Data dataset when the feature is enabled */
    set hierarchicalDataset(hierarchicalDataset) {
        this._hierarchicalDataset = hierarchicalDataset;
    }
}
SharedService.ɵfac = function SharedService_Factory(t) { return new (t || SharedService)(); };
SharedService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: SharedService, factory: SharedService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SharedService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class AutoTooltipExtension {
    constructor(sharedService) {
        this.sharedService = sharedService;
    }
    dispose() {
        if (this._addon && this._addon.destroy) {
            this._addon.destroy();
            this._addon = null;
        }
    }
    /** Get the instance of the SlickGrid addon (control or plugin). */
    getAddonInstance() {
        return this._addon;
    }
    register() {
        if (this.sharedService && this.sharedService.grid && this.sharedService.gridOptions) {
            this._addon = new Slick.AutoTooltips(this.sharedService.gridOptions.autoTooltipOptions || {});
            this.sharedService.grid.registerPlugin(this._addon);
            return this._addon;
        }
        return null;
    }
}
AutoTooltipExtension.ɵfac = function AutoTooltipExtension_Factory(t) { return new (t || AutoTooltipExtension)(ɵngcc0.ɵɵinject(SharedService)); };
AutoTooltipExtension.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AutoTooltipExtension, factory: AutoTooltipExtension.ɵfac });
AutoTooltipExtension.ctorParameters = () => [
    { type: SharedService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AutoTooltipExtension, [{
        type: Injectable
    }], function () { return [{ type: SharedService }]; }, null); })();

class ExtensionUtility {
    constructor(sharedService, translate) {
        this.sharedService = sharedService;
        this.translate = translate;
    }
    /**
     * From a Grid Menu object property name, we will return the correct title output string following this order
     * 1- if user provided a title, use it as the output title
     * 2- else if user provided a title key, use it to translate the output title
     * 3- else if nothing is provided use text defined as constants
     */
    getPickerTitleOutputString(propName, pickerName) {
        if (this.sharedService.gridOptions && this.sharedService.gridOptions.enableTranslate && (!this.translate || !this.translate.instant)) {
            throw new Error('[Angular-Slickgrid] requires "ngx-translate" to be installed and configured when the grid option "enableTranslate" is enabled.');
        }
        let output = '';
        const picker = this.sharedService.gridOptions && this.sharedService.gridOptions[pickerName] || {};
        const enableTranslate = this.sharedService.gridOptions && this.sharedService.gridOptions.enableTranslate || false;
        // get locales provided by user in forRoot or else use default English locales via the Constants
        const locales = this.sharedService && this.sharedService.gridOptions && this.sharedService.gridOptions.locales || Constants.locales;
        const title = picker && picker[propName];
        const titleKey = picker && picker[`${propName}Key`];
        const gridOptions = this.sharedService.gridOptions;
        const translationPrefix = getTranslationPrefix(gridOptions);
        if (titleKey && this.translate && this.translate.currentLang && this.translate.instant) {
            output = this.translate.instant(titleKey || ' ');
        }
        else {
            switch (propName) {
                case 'customTitle':
                    output = title || enableTranslate && this.translate && this.translate.currentLang && this.translate.instant && this.translate.instant(`${translationPrefix}COMMANDS` || ' ') || locales && locales.TEXT_COMMANDS;
                    break;
                case 'columnTitle':
                    output = title || enableTranslate && this.translate && this.translate.currentLang && this.translate.instant && this.translate.instant(`${translationPrefix}COLUMNS` || ' ') || locales && locales.TEXT_COLUMNS;
                    break;
                case 'forceFitTitle':
                    output = title || enableTranslate && this.translate && this.translate.currentLang && this.translate.instant && this.translate.instant(`${translationPrefix}FORCE_FIT_COLUMNS` || ' ') || locales && locales.TEXT_FORCE_FIT_COLUMNS;
                    break;
                case 'syncResizeTitle':
                    output = title || enableTranslate && this.translate && this.translate.currentLang && this.translate.instant && this.translate.instant(`${translationPrefix}SYNCHRONOUS_RESIZE` || ' ') || locales && locales.TEXT_SYNCHRONOUS_RESIZE;
                    break;
                default:
                    output = title;
                    break;
            }
        }
        return output;
    }
    /**
     * Loop through object provided and set to null any property found starting with "onX"
     * @param {Object}: obj
     */
    nullifyFunctionNameStartingWithOn(obj) {
        if (obj) {
            for (const prop of Object.keys(obj)) {
                if (prop.startsWith('on')) {
                    obj[prop] = null;
                }
            }
        }
    }
    /**
     * When using ColumnPicker/GridMenu to show/hide a column, we potentially need to readjust the grid option "frozenColumn" index.
     * That is because SlickGrid freezes by column index and it has no knowledge of the columns themselves and won't change the index, we need to do that ourselves whenever necessary.
     * Note: we call this method right after the visibleColumns array got updated, it won't work properly if we call it before the setting the visibleColumns.
     * @param {Number} frozenColumnIndex - current frozenColumn index
     * @param {Array<Object>} allColumns - all columns (including hidden ones)
     * @param {Array<Object>} visibleColumns - only visible columns (excluding hidden ones)
     */
    readjustFrozenColumnIndexWhenNeeded(frozenColumnIndex, allColumns, visibleColumns) {
        if (frozenColumnIndex >= 0) {
            const recalculatedFrozenColumnIndex = visibleColumns.findIndex(col => col.id === this.sharedService.frozenVisibleColumnId);
            if (recalculatedFrozenColumnIndex >= 0 && recalculatedFrozenColumnIndex !== frozenColumnIndex) {
                this.sharedService.gridOptions.frozenColumn = recalculatedFrozenColumnIndex;
                this.sharedService.grid.setOptions({ frozenColumn: recalculatedFrozenColumnIndex });
            }
            // to freeze columns, we need to take only the visible columns and we also need to use setColumns() when some of them are hidden
            // to make sure that we only use the visible columns, not doing this would show back some of the hidden columns
            if (Array.isArray(visibleColumns) && Array.isArray(allColumns) && visibleColumns.length !== allColumns.length) {
                this.sharedService.grid.setColumns(visibleColumns);
            }
        }
    }
    /**
     * Sort items (by pointers) in an array by a property name
     * @params items array
     * @param property name to sort with
     */
    sortItems(items, propertyName) {
        // sort the custom items by their position in the list
        if (Array.isArray(items)) {
            items.sort((itemA, itemB) => {
                if (itemA && itemB && itemA.hasOwnProperty(propertyName) && itemB.hasOwnProperty(propertyName)) {
                    return itemA[propertyName] - itemB[propertyName];
                }
                return 0;
            });
        }
    }
    /** Translate the an array of items from an input key and assign to the output key */
    translateItems(items, inputKey, outputKey) {
        if (Array.isArray(items)) {
            for (const item of items) {
                if (item[inputKey]) {
                    item[outputKey] = this.translate && this.translate && this.translate.currentLang && this.translate.instant && this.translate.instant(item[inputKey]);
                }
            }
        }
    }
    /**
     * When "enabledTranslate" is set to True, we will try to translate if the Translate Service exist or use the Locales when not
     * @param {String} translationKey
     * @param {String} localeKey
     * @param {String} textToUse - optionally provide a static text to use (that will completely override the other arguments of the method)
     */
    translateWhenEnabledAndServiceExist(translationKey, localeKey, textToUse) {
        var _a, _b, _c;
        let text = '';
        const gridOptions = (_a = this.sharedService) === null || _a === void 0 ? void 0 : _a.gridOptions;
        // get locales provided by user in main file or else use default English locales via the Constants
        const locales = (_b = gridOptions === null || gridOptions === void 0 ? void 0 : gridOptions.locales) !== null && _b !== void 0 ? _b : Constants.locales;
        if (textToUse) {
            text = textToUse;
        }
        else if (gridOptions.enableTranslate && ((_c = this.translate) === null || _c === void 0 ? void 0 : _c.instant)) {
            text = this.translate.instant(translationKey || ' ');
        }
        else if (localeKey in locales) {
            text = locales[localeKey];
        }
        else {
            text = localeKey;
        }
        return text;
    }
}
ExtensionUtility.ɵfac = function ExtensionUtility_Factory(t) { return new (t || ExtensionUtility)(ɵngcc0.ɵɵinject(SharedService), ɵngcc0.ɵɵinject(ɵngcc1.TranslateService, 8)); };
ExtensionUtility.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ExtensionUtility, factory: ExtensionUtility.ɵfac });
ExtensionUtility.ctorParameters = () => [
    { type: SharedService },
    { type: TranslateService, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ExtensionUtility, [{
        type: Injectable
    }], function () { return [{ type: SharedService }, { type: ɵngcc1.TranslateService, decorators: [{
                type: Optional
            }] }]; }, null); })();

class CellExternalCopyManagerExtension {
    constructor(extensionUtility, sharedService) {
        this.extensionUtility = extensionUtility;
        this.sharedService = sharedService;
        this._eventHandler = new Slick.EventHandler();
        this._bindingEventService = new BindingEventService();
    }
    get addonOptions() {
        return this._addonOptions;
    }
    get eventHandler() {
        return this._eventHandler;
    }
    get commandQueue() {
        return this._commandQueue;
    }
    get undoRedoBuffer() {
        return this._undoRedoBuffer;
    }
    dispose() {
        // unsubscribe all SlickGrid events
        this._eventHandler.unsubscribeAll();
        this._bindingEventService.unbindAll();
        if (this._addon && this._addon.destroy) {
            this._addon.destroy();
        }
        if (this._cellSelectionModel && this._cellSelectionModel.destroy) {
            this._cellSelectionModel.destroy();
        }
        this.extensionUtility.nullifyFunctionNameStartingWithOn(this._addonOptions);
        this._addon = null;
        this._addonOptions = null;
    }
    /** Get the instance of the SlickGrid addon (control or plugin). */
    getAddonInstance() {
        return this._addon;
    }
    register() {
        if (this.sharedService && this.sharedService.grid && this.sharedService.gridOptions) {
            this.createUndoRedoBuffer();
            this._bindingEventService.bind(document.body, 'keydown', this.handleKeyDown.bind(this));
            this._addonOptions = Object.assign(Object.assign({}, this.getDefaultOptions()), this.sharedService.gridOptions.excelCopyBufferOptions);
            this._cellSelectionModel = new Slick.CellSelectionModel();
            this.sharedService.grid.setSelectionModel(this._cellSelectionModel);
            this._addon = new Slick.CellExternalCopyManager(this._addonOptions);
            if (this._addon) {
                this.sharedService.grid.registerPlugin(this._addon);
            }
            // hook to all possible events
            if (this.sharedService.grid && this._addonOptions) {
                if (this._addonOptions.onExtensionRegistered) {
                    this._addonOptions.onExtensionRegistered(this._addon);
                }
                this._eventHandler.subscribe(this._addon.onCopyCells, (e, args) => {
                    if (this._addonOptions && typeof this._addonOptions.onCopyCells === 'function') {
                        this._addonOptions.onCopyCells(e, args);
                    }
                });
                this._eventHandler.subscribe(this._addon.onCopyCancelled, (e, args) => {
                    if (this._addonOptions && typeof this._addonOptions.onCopyCancelled === 'function') {
                        this._addonOptions.onCopyCancelled(e, args);
                    }
                });
                this._eventHandler.subscribe(this._addon.onPasteCells, (e, args) => {
                    if (this._addonOptions && typeof this._addonOptions.onPasteCells === 'function') {
                        this._addonOptions.onPasteCells(e, args);
                    }
                });
            }
            return this._addon;
        }
        return null;
    }
    /** Create an undo redo buffer used by the Excel like copy */
    createUndoRedoBuffer() {
        let commandCtr = 0;
        this._commandQueue = [];
        this._undoRedoBuffer = {
            queueAndExecuteCommand: (editCommand) => {
                this._commandQueue[commandCtr] = editCommand;
                commandCtr++;
                editCommand.execute();
            },
            undo: () => {
                if (commandCtr === 0) {
                    return;
                }
                commandCtr--;
                const command = this._commandQueue[commandCtr];
                if (command && Slick.GlobalEditorLock.cancelCurrentEdit()) {
                    command.undo();
                }
            },
            redo: () => {
                if (commandCtr >= this._commandQueue.length) {
                    return;
                }
                const command = this._commandQueue[commandCtr];
                commandCtr++;
                if (command && Slick.GlobalEditorLock.cancelCurrentEdit()) {
                    command.execute();
                }
            }
        };
    }
    /** @return default plugin (addon) options */
    getDefaultOptions() {
        let newRowIds = 0;
        return {
            clipboardCommandHandler: (editCommand) => {
                this._undoRedoBuffer.queueAndExecuteCommand.call(this._undoRedoBuffer, editCommand);
            },
            dataItemColumnValueExtractor: (item, columnDef) => {
                // when grid or cell is not editable, we will possibly evaluate the Formatter if it was passed
                // to decide if we evaluate the Formatter, we will use the same flag from Export which is "exportWithFormatter"
                if (!this.sharedService.gridOptions.editable || !columnDef.editor) {
                    const isEvaluatingFormatter = (columnDef.exportWithFormatter !== undefined) ? columnDef.exportWithFormatter : (this.sharedService.gridOptions.exportOptions && this.sharedService.gridOptions.exportOptions.exportWithFormatter);
                    if (columnDef.formatter && isEvaluatingFormatter) {
                        const formattedOutput = columnDef.formatter(0, 0, item[columnDef.field], columnDef, item, this.sharedService.grid);
                        if (columnDef.sanitizeDataExport || (this.sharedService.gridOptions.exportOptions && this.sharedService.gridOptions.exportOptions.sanitizeDataExport)) {
                            let outputString = formattedOutput;
                            if (formattedOutput && typeof formattedOutput === 'object' && formattedOutput.hasOwnProperty('text')) {
                                outputString = formattedOutput.text;
                            }
                            if (outputString === null) {
                                outputString = '';
                            }
                            return sanitizeHtmlToText(outputString);
                        }
                        return formattedOutput;
                    }
                }
                // else use the default "dataItemColumnValueExtractor" from the plugin itself
                // we can do that by setting back the getter with null
                return null;
            },
            readOnlyMode: false,
            includeHeaderWhenCopying: false,
            newRowCreator: (count) => {
                for (let i = 0; i < count; i++) {
                    const item = {
                        id: 'newRow_' + newRowIds++
                    };
                    this.sharedService.grid.getData().addItem(item);
                }
            }
        };
    }
    /** Hook an undo shortcut key hook that will redo/undo the copy buffer using Ctrl+(Shift)+Z keyboard events */
    handleKeyDown(e) {
        const keyCode = e.keyCode || e.code;
        if (keyCode === 90 && (e.ctrlKey || e.metaKey)) {
            if (e.shiftKey) {
                this._undoRedoBuffer.redo(); // Ctrl + Shift + Z
            }
            else {
                this._undoRedoBuffer.undo(); // Ctrl + Z
            }
        }
    }
}
CellExternalCopyManagerExtension.ɵfac = function CellExternalCopyManagerExtension_Factory(t) { return new (t || CellExternalCopyManagerExtension)(ɵngcc0.ɵɵinject(ExtensionUtility), ɵngcc0.ɵɵinject(SharedService)); };
CellExternalCopyManagerExtension.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: CellExternalCopyManagerExtension, factory: CellExternalCopyManagerExtension.ɵfac });
CellExternalCopyManagerExtension.ctorParameters = () => [
    { type: ExtensionUtility },
    { type: SharedService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CellExternalCopyManagerExtension, [{
        type: Injectable
    }], function () { return [{ type: ExtensionUtility }, { type: SharedService }]; }, null); })();

class CellMenuExtension {
    constructor(extensionUtility, sharedService, translate) {
        this.extensionUtility = extensionUtility;
        this.sharedService = sharedService;
        this.translate = translate;
        this._eventHandler = new Slick.EventHandler();
    }
    get eventHandler() {
        return this._eventHandler;
    }
    dispose() {
        // unsubscribe all SlickGrid events
        this._eventHandler.unsubscribeAll();
        if (this._addon && this._addon.destroy) {
            this._addon.destroy();
        }
        this.extensionUtility.nullifyFunctionNameStartingWithOn(this._cellMenuOptions);
        this._addon = null;
        this._cellMenuOptions = null;
    }
    /** Get the instance of the SlickGrid addon (control or plugin). */
    getAddonInstance() {
        return this._addon;
    }
    /**
     * Create the Action Cell Menu and expose all the available hooks that user can subscribe (onCommand, onBeforeMenuShow, ...)
     * @param grid
     * @param dataView
     * @param columnDefinitions
     */
    register() {
        if (this.sharedService.gridOptions && this.sharedService.gridOptions.enableTranslate && (!this.translate || !this.translate.instant)) {
            throw new Error('[Angular-Slickgrid] requires "ngx-translate" to be installed and configured when the grid option "enableTranslate" is enabled.');
        }
        if (this.sharedService && this.sharedService.grid && this.sharedService.gridOptions) {
            // get locales provided by user in main file or else use default English locales via the Constants
            this._locales = this.sharedService.gridOptions && this.sharedService.gridOptions.locales || Constants.locales;
            this._cellMenuOptions = Object.assign(Object.assign({}, this.getDefaultCellMenuOptions()), this.sharedService.gridOptions.cellMenu);
            this.sharedService.gridOptions.cellMenu = this._cellMenuOptions;
            // translate the item keys when necessary
            if (this.sharedService.gridOptions.enableTranslate) {
                this.translateCellMenu();
            }
            // sort all menu items by their position order when defined
            this.sortMenuItems(this.sharedService.allColumns);
            this._addon = new Slick.Plugins.CellMenu(this._cellMenuOptions);
            this.sharedService.grid.registerPlugin(this._addon);
            // hook all events
            if (this._cellMenuOptions) {
                if (this._cellMenuOptions.onExtensionRegistered) {
                    this._cellMenuOptions.onExtensionRegistered(this._addon);
                }
                if (this._cellMenuOptions && typeof this._cellMenuOptions.onCommand === 'function') {
                    this._eventHandler.subscribe(this._addon.onCommand, (event, args) => {
                        if (this._cellMenuOptions && this._cellMenuOptions.onCommand) {
                            this._cellMenuOptions.onCommand(event, args);
                        }
                    });
                }
                if (this._cellMenuOptions && typeof this._cellMenuOptions.onOptionSelected === 'function') {
                    this._eventHandler.subscribe(this._addon.onOptionSelected, (event, args) => {
                        if (this._cellMenuOptions && this._cellMenuOptions.onOptionSelected) {
                            this._cellMenuOptions.onOptionSelected(event, args);
                        }
                    });
                }
                if (this._cellMenuOptions && typeof this._cellMenuOptions.onAfterMenuShow === 'function') {
                    this._eventHandler.subscribe(this._addon.onAfterMenuShow, (event, args) => {
                        if (this._cellMenuOptions && this._cellMenuOptions.onAfterMenuShow) {
                            this._cellMenuOptions.onAfterMenuShow(event, args);
                        }
                    });
                }
                if (this._cellMenuOptions && typeof this._cellMenuOptions.onBeforeMenuShow === 'function') {
                    this._eventHandler.subscribe(this._addon.onBeforeMenuShow, (event, args) => {
                        if (this._cellMenuOptions && this._cellMenuOptions.onBeforeMenuShow) {
                            this._cellMenuOptions.onBeforeMenuShow(event, args);
                        }
                    });
                }
                if (this._cellMenuOptions && typeof this._cellMenuOptions.onBeforeMenuClose === 'function') {
                    this._eventHandler.subscribe(this._addon.onBeforeMenuClose, (event, args) => {
                        if (this._cellMenuOptions && this._cellMenuOptions.onBeforeMenuClose) {
                            this._cellMenuOptions.onBeforeMenuClose(event, args);
                        }
                    });
                }
            }
            return this._addon;
        }
        return null;
    }
    /** Translate the Cell Menu titles, we need to loop through all column definition to re-translate them */
    translateCellMenu() {
        if (this.sharedService.gridOptions && this.sharedService.gridOptions.cellMenu) {
            this.resetMenuTranslations(this.sharedService.allColumns);
        }
    }
    /**
     * @return default Action Cell Menu options
     */
    getDefaultCellMenuOptions() {
        return {
            width: 180,
        };
    }
    /**
     * Reset all the internal Menu options which have text to translate
     * @param grid menu object
     */
    resetMenuTranslations(columnDefinitions) {
        const gridOptions = this.sharedService && this.sharedService.gridOptions;
        if (gridOptions && gridOptions.enableTranslate) {
            columnDefinitions.forEach((columnDef) => {
                if (columnDef && columnDef.cellMenu && (Array.isArray(columnDef.cellMenu.commandItems) || Array.isArray(columnDef.cellMenu.optionItems))) {
                    // get both items list
                    const columnCellMenuCommandItems = columnDef.cellMenu.commandItems || [];
                    const columnCellMenuOptionItems = columnDef.cellMenu.optionItems || [];
                    // translate their titles only if they have a titleKey defined
                    if (columnDef.cellMenu.commandTitleKey) {
                        columnDef.cellMenu.commandTitle = this.translate && this.translate.currentLang && this.translate.instant && this.translate.instant(columnDef.cellMenu.commandTitleKey) || this._locales && this._locales.TEXT_COMMANDS || columnDef.cellMenu.commandTitle;
                    }
                    if (columnDef.cellMenu.optionTitleKey) {
                        columnDef.cellMenu.optionTitle = this.translate && this.translate.currentLang && this.translate.instant && this.translate.instant(columnDef.cellMenu.optionTitleKey) || columnDef.cellMenu.optionTitle;
                    }
                    // translate both command/option items (whichever is provided)
                    this.extensionUtility.translateItems(columnCellMenuCommandItems, 'titleKey', 'title');
                    this.extensionUtility.translateItems(columnCellMenuOptionItems, 'titleKey', 'title');
                }
            });
        }
    }
    sortMenuItems(columnDefinitions) {
        columnDefinitions.forEach((columnDef) => {
            if (columnDef && columnDef.cellMenu && columnDef.cellMenu.commandItems) {
                // get both items list
                const columnCellMenuCommandItems = columnDef.cellMenu.commandItems || [];
                const columnCellMenuOptionItems = columnDef.cellMenu.optionItems || [];
                this.extensionUtility.sortItems(columnCellMenuCommandItems, 'positionOrder');
                this.extensionUtility.sortItems(columnCellMenuOptionItems, 'positionOrder');
            }
        });
    }
}
CellMenuExtension.ɵfac = function CellMenuExtension_Factory(t) { return new (t || CellMenuExtension)(ɵngcc0.ɵɵinject(ExtensionUtility), ɵngcc0.ɵɵinject(SharedService), ɵngcc0.ɵɵinject(ɵngcc1.TranslateService, 8)); };
CellMenuExtension.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: CellMenuExtension, factory: CellMenuExtension.ɵfac });
CellMenuExtension.ctorParameters = () => [
    { type: ExtensionUtility },
    { type: SharedService },
    { type: TranslateService, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CellMenuExtension, [{
        type: Injectable
    }], function () { return [{ type: ExtensionUtility }, { type: SharedService }, { type: ɵngcc1.TranslateService, decorators: [{
                type: Optional
            }] }]; }, null); })();

class CheckboxSelectorExtension {
    constructor(sharedService) {
        this.sharedService = sharedService;
    }
    dispose() {
        if (this._addon && this._addon.destroy) {
            this._addon.destroy();
        }
        this._addon = null;
        if (this._rowSelectionPlugin && this._rowSelectionPlugin.destroy) {
            this._rowSelectionPlugin.destroy();
        }
    }
    /**
     * Create the plugin before the Grid creation, else it will behave oddly.
     * Mostly because the column definitions might change after the grid creation
     */
    create(columnDefinitions, gridOptions) {
        if (Array.isArray(columnDefinitions) && gridOptions) {
            if (!this._addon) {
                this._addon = new Slick.CheckboxSelectColumn(gridOptions.checkboxSelector || {});
            }
            const selectionColumn = this._addon.getColumnDefinition();
            if (typeof selectionColumn === 'object') {
                selectionColumn.excludeFromExport = true;
                selectionColumn.excludeFromColumnPicker = true;
                selectionColumn.excludeFromGridMenu = true;
                selectionColumn.excludeFromQuery = true;
                selectionColumn.excludeFromHeaderMenu = true;
                selectionColumn.maxWidth = selectionColumn.width || 30;
                // column index position in the grid
                const columnPosition = gridOptions && gridOptions.checkboxSelector && gridOptions.checkboxSelector.columnIndexPosition || 0;
                if (columnPosition > 0) {
                    columnDefinitions.splice(columnPosition, 0, selectionColumn);
                }
                else {
                    columnDefinitions.unshift(selectionColumn);
                }
            }
            return this._addon;
        }
        return null;
    }
    /** Get the instance of the SlickGrid addon (control or plugin). */
    getAddonInstance() {
        return this._addon;
    }
    register(rowSelectionPlugin) {
        if (this.sharedService && this.sharedService.grid && this.sharedService.gridOptions) {
            // the plugin has to be created BEFORE the grid (else it behaves oddly), but we can only watch grid events AFTER the grid is created
            this.sharedService.grid.registerPlugin(this._addon);
            // this also requires the Row Selection Model to be registered as well
            if (!rowSelectionPlugin || !this.sharedService.grid.getSelectionModel()) {
                rowSelectionPlugin = new Slick.RowSelectionModel(this.sharedService.gridOptions.rowSelectionOptions || {});
                this.sharedService.grid.setSelectionModel(rowSelectionPlugin);
            }
            // user might want to pre-select some rows
            // the setTimeout is because of timing issue with styling (row selection happen but rows aren't highlighted properly)
            if (this.sharedService.gridOptions.preselectedRows && rowSelectionPlugin && this.sharedService.grid.getSelectionModel()) {
                setTimeout(() => this._addon.selectRows(this.sharedService.gridOptions.preselectedRows));
            }
            this._rowSelectionPlugin = rowSelectionPlugin;
            return rowSelectionPlugin;
        }
        return null;
    }
}
CheckboxSelectorExtension.ɵfac = function CheckboxSelectorExtension_Factory(t) { return new (t || CheckboxSelectorExtension)(ɵngcc0.ɵɵinject(SharedService)); };
CheckboxSelectorExtension.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: CheckboxSelectorExtension, factory: CheckboxSelectorExtension.ɵfac });
CheckboxSelectorExtension.ctorParameters = () => [
    { type: SharedService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CheckboxSelectorExtension, [{
        type: Injectable
    }], function () { return [{ type: SharedService }]; }, null); })();

class ColumnPickerExtension {
    constructor(extensionUtility, sharedService) {
        this.extensionUtility = extensionUtility;
        this.sharedService = sharedService;
        this._eventHandler = new Slick.EventHandler();
    }
    get eventHandler() {
        return this._eventHandler;
    }
    dispose() {
        // unsubscribe all SlickGrid events
        this._eventHandler.unsubscribeAll();
        if (this._addon && this._addon.destroy) {
            this._addon.destroy();
        }
        this.extensionUtility.nullifyFunctionNameStartingWithOn(this._columnPicker);
        this._addon = null;
    }
    /** Get the instance of the SlickGrid addon (control or plugin). */
    getAddonInstance() {
        return this._addon;
    }
    register() {
        if (this.sharedService && this.sharedService.grid && this.sharedService.gridOptions) {
            // localization support for the picker
            const columnTitle = this.extensionUtility.getPickerTitleOutputString('columnTitle', 'columnPicker');
            const forceFitTitle = this.extensionUtility.getPickerTitleOutputString('forceFitTitle', 'columnPicker');
            const syncResizeTitle = this.extensionUtility.getPickerTitleOutputString('syncResizeTitle', 'columnPicker');
            this._columnPicker = this.sharedService.gridOptions.columnPicker || {};
            this.sharedService.gridOptions.columnPicker = this._columnPicker;
            this._columnPicker.columnTitle = this._columnPicker.columnTitle || columnTitle;
            this._columnPicker.forceFitTitle = this._columnPicker.forceFitTitle || forceFitTitle;
            this._columnPicker.syncResizeTitle = this._columnPicker.syncResizeTitle || syncResizeTitle;
            this._addon = new Slick.Controls.ColumnPicker(this.sharedService.allColumns, this.sharedService.grid, this.sharedService.gridOptions);
            if (this.sharedService.grid && this.sharedService.gridOptions.enableColumnPicker) {
                if (this._columnPicker.onExtensionRegistered) {
                    this._columnPicker.onExtensionRegistered(this._addon);
                }
                this._eventHandler.subscribe(this._addon.onColumnsChanged, (e, args) => {
                    if (this._columnPicker && typeof this._columnPicker.onColumnsChanged === 'function') {
                        this._columnPicker.onColumnsChanged(e, args);
                    }
                    // keep reference to the updated visible columns list
                    if (args && Array.isArray(args.columns) && args.columns.length !== this.sharedService.visibleColumns.length) {
                        this.sharedService.visibleColumns = args.columns;
                    }
                    // when using row selection, SlickGrid will only apply the "selected" CSS class on the visible columns only
                    // and if the row selection was done prior to the column being shown then that column that was previously hidden (at the time of the row selection)
                    // will not have the "selected" CSS class because it wasn't visible at the time.
                    // To bypass this problem we can simply recall the row selection with the same selection and that will trigger a re-apply of the CSS class
                    // on all columns including the column we just made visible
                    if (this.sharedService.gridOptions.enableRowSelection && args.showing) {
                        const rowSelection = args.grid.getSelectedRows();
                        args.grid.setSelectedRows(rowSelection);
                    }
                    // if we're using frozen columns, we need to readjust pinning when the new hidden column becomes visible again on the left pinning container
                    // we need to readjust frozenColumn index because SlickGrid freezes by index and has no knowledge of the columns themselves
                    const frozenColumnIndex = this.sharedService.gridOptions.frozenColumn !== undefined ? this.sharedService.gridOptions.frozenColumn : -1;
                    if (frozenColumnIndex >= 0) {
                        const { allColumns, columns: visibleColumns } = args;
                        this.extensionUtility.readjustFrozenColumnIndexWhenNeeded(frozenColumnIndex, allColumns, visibleColumns);
                    }
                });
            }
            return this._addon;
        }
        return null;
    }
    /** Translate the Column Picker headers and also the last 2 checkboxes */
    translateColumnPicker() {
        // update the properties by pointers, that is the only way to get Column Picker Control to see the new values
        if (this._columnPicker) {
            this.emptyColumnPickerTitles();
            this._columnPicker.columnTitle = this.extensionUtility.getPickerTitleOutputString('columnTitle', 'columnPicker');
            this._columnPicker.forceFitTitle = this.extensionUtility.getPickerTitleOutputString('forceFitTitle', 'columnPicker');
            this._columnPicker.syncResizeTitle = this.extensionUtility.getPickerTitleOutputString('syncResizeTitle', 'columnPicker');
        }
        // translate all columns (including hidden columns)
        // eventually deprecate the "headerKey" and use only the "nameKey"
        this.extensionUtility.translateItems(this.sharedService.allColumns, 'headerKey', 'name');
        this.extensionUtility.translateItems(this.sharedService.allColumns, 'nameKey', 'name');
        // update the Titles of each sections (command, customTitle, ...)
        if (this._addon && this._addon.updateAllTitles && this._columnPicker) {
            this._addon.updateAllTitles(this._columnPicker);
        }
    }
    emptyColumnPickerTitles() {
        if (this._columnPicker) {
            this._columnPicker.columnTitle = '';
            this._columnPicker.forceFitTitle = '';
            this._columnPicker.syncResizeTitle = '';
        }
    }
}
ColumnPickerExtension.ɵfac = function ColumnPickerExtension_Factory(t) { return new (t || ColumnPickerExtension)(ɵngcc0.ɵɵinject(ExtensionUtility), ɵngcc0.ɵɵinject(SharedService)); };
ColumnPickerExtension.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ColumnPickerExtension, factory: ColumnPickerExtension.ɵfac });
ColumnPickerExtension.ctorParameters = () => [
    { type: ExtensionUtility },
    { type: SharedService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ColumnPickerExtension, [{
        type: Injectable
    }], function () { return [{ type: ExtensionUtility }, { type: SharedService }]; }, null); })();

class SortService {
    constructor(sharedService) {
        this.sharedService = sharedService;
        this._currentLocalSorters = [];
        this._isBackendGrid = false;
        this.httpCancelRequests$ = new Subject(); // this will be used to cancel any pending http request
        this.onSortChanged = new Subject();
        this.onSortCleared = new Subject();
        this._eventHandler = new Slick.EventHandler();
    }
    /** Getter of the SlickGrid Event Handler */
    get eventHandler() {
        return this._eventHandler;
    }
    /** Getter for the Grid Options pulled through the Grid Object */
    get _gridOptions() {
        return (this._grid && this._grid.getOptions) ? this._grid.getOptions() : {};
    }
    /** Getter for the Column Definitions pulled through the Grid Object */
    get _columnDefinitions() {
        return (this._grid && this._grid.getColumns) ? this._grid.getColumns() : [];
    }
    /** Getter of SlickGrid DataView object */
    get _dataView() {
        return (this._grid && this._grid.getData) ? this._grid.getData() : {};
    }
    /**
     * Bind a backend sort (single/multi) hook to the grid
     * @param grid SlickGrid Grid object
     * @param dataView SlickGrid DataView object
     */
    bindBackendOnSort(grid) {
        this._isBackendGrid = true;
        this._grid = grid;
        // subscribe to the SlickGrid event and call the backend execution
        this._eventHandler.subscribe(grid.onSort, this.onBackendSortChanged.bind(this));
    }
    /**
     * Bind a local sort (single/multi) hook to the grid
     * @param grid SlickGrid Grid object
     * @param gridOptions Grid Options object
     * @param dataView
     */
    bindLocalOnSort(grid) {
        this._isBackendGrid = false;
        this._grid = grid;
        this.processTreeDataInitialSort();
        this._eventHandler.subscribe(grid.onSort, this.handleLocalOnSort.bind(this));
    }
    handleLocalOnSort(_e, args) {
        if (args && (args.sortCols || args.sortCol)) {
            // multiSort and singleSort are not exactly the same, but we want to structure it the same for the (for loop) after
            // also to avoid having to rewrite the for loop in the sort, we will make the singleSort an array of 1 object
            const sortColumns = (args.multiColumnSort) ? args.sortCols : new Array({ sortAsc: args.sortAsc, sortCol: args.sortCol });
            // keep current sorters
            this._currentLocalSorters = []; // reset current local sorters
            if (Array.isArray(sortColumns)) {
                sortColumns.forEach((sortColumn) => {
                    if (sortColumn.sortCol) {
                        this._currentLocalSorters.push({
                            columnId: sortColumn.sortCol.id,
                            direction: sortColumn.sortAsc ? SortDirection.ASC : SortDirection.DESC
                        });
                    }
                });
            }
            this.onLocalSortChanged(this._grid, sortColumns);
            this.emitSortChanged(EmitterType.local);
        }
    }
    clearSortByColumnId(event, columnId) {
        // get previously sorted columns
        const allSortedCols = this.getCurrentColumnSorts();
        const sortedColsWithoutCurrent = this.getCurrentColumnSorts(`${columnId}`);
        if (Array.isArray(allSortedCols) && Array.isArray(sortedColsWithoutCurrent) && allSortedCols.length !== sortedColsWithoutCurrent.length) {
            if (this._gridOptions.backendServiceApi) {
                this.onBackendSortChanged(event, { multiColumnSort: true, sortCols: sortedColsWithoutCurrent, grid: this._grid });
            }
            else if (this._dataView) {
                this.onLocalSortChanged(this._grid, sortedColsWithoutCurrent, true, true);
            }
            else {
                // when using customDataView, we will simply send it as a onSort event with notify
                const isMultiSort = this._gridOptions && this._gridOptions.multiColumnSort || false;
                const sortOutput = isMultiSort ? sortedColsWithoutCurrent : sortedColsWithoutCurrent[0];
                this._grid.onSort.notify(sortOutput);
            }
            // update the grid sortColumns array which will at the same add the visual sort icon(s) on the UI
            const updatedSortColumns = sortedColsWithoutCurrent.map((col) => {
                return {
                    columnId: col && col.sortCol && col.sortCol.id,
                    sortAsc: col && col.sortAsc,
                    sortCol: col && col.sortCol,
                };
            });
            this._grid.setSortColumns(updatedSortColumns); // add sort icon in UI
        }
        // when there's no more sorting, we re-sort by the default sort field, user can customize it "defaultColumnSortFieldId", defaults to "id"
        if (Array.isArray(sortedColsWithoutCurrent) && sortedColsWithoutCurrent.length === 0) {
            this.sortLocalGridByDefaultSortFieldId();
        }
    }
    /**
     * Clear Sorting
     * - 1st, remove the SlickGrid sort icons (this setSortColumns function call really does only that)
     * - 2nd, we also need to trigger a sort change
     *   - for a backend grid, we will trigger a backend sort changed with an empty sort columns array
     *   - however for a local grid, we need to pass a sort column and so we will sort by the 1st column
     * @param trigger query event after executing clear filter?
     */
    clearSorting(triggerQueryEvent = true) {
        var _a, _b;
        if (this._grid && this._gridOptions && this._dataView) {
            // remove any sort icons (this setSortColumns function call really does only that)
            this._grid.setSortColumns([]);
            // we also need to trigger a sort change
            // for a backend grid, we will trigger a backend sort changed with an empty sort columns array
            // however for a local grid, we need to pass a sort column and so we will sort by the 1st column
            if (triggerQueryEvent) {
                if (this._isBackendGrid) {
                    this.onBackendSortChanged(undefined, { grid: this._grid, sortCols: [], clearSortTriggered: true });
                }
                else {
                    if (this._columnDefinitions && Array.isArray(this._columnDefinitions)) {
                        this.sortLocalGridByDefaultSortFieldId();
                    }
                }
            }
            else if (this._isBackendGrid) {
                const backendService = (_b = (_a = this._gridOptions) === null || _a === void 0 ? void 0 : _a.backendServiceApi) === null || _b === void 0 ? void 0 : _b.service;
                if (backendService === null || backendService === void 0 ? void 0 : backendService.clearSorters) {
                    backendService.clearSorters();
                }
            }
        }
        // set current sorter to empty & emit a sort changed event
        this._currentLocalSorters = [];
        // emit an event when sorts are all cleared
        this.onSortCleared.next(true);
    }
    dispose() {
        // unsubscribe all SlickGrid events
        if (this._eventHandler && this._eventHandler.unsubscribeAll) {
            this._eventHandler.unsubscribeAll();
        }
        if (isObservable(this.httpCancelRequests$)) {
            this.httpCancelRequests$.next(); // this cancels any pending http requests
            this.httpCancelRequests$.complete();
        }
    }
    /**
     * Toggle the Sorting Functionality
     * @param {boolean} isSortingDisabled - optionally force a disable/enable of the Sort Functionality? Defaults to True
     * @param {boolean} clearSortingWhenDisabled - when disabling the sorting, do we also want to clear the sorting as well? Defaults to True
     */
    disableSortFunctionality(isSortingDisabled = true, clearSortingWhenDisabled = true) {
        const prevSorting = this._gridOptions.enableSorting;
        const newSorting = !prevSorting;
        this._gridOptions.enableSorting = newSorting;
        let updatedColumnDefinitions;
        if (isSortingDisabled) {
            if (clearSortingWhenDisabled) {
                this.clearSorting();
            }
            this._eventHandler.unsubscribeAll();
            updatedColumnDefinitions = this.disableAllSortingCommands(true);
        }
        else {
            updatedColumnDefinitions = this.disableAllSortingCommands(false);
            const onSortHandler = this._grid.onSort;
            this._eventHandler.subscribe(onSortHandler, (e, args) => this.handleLocalOnSort(e, args));
        }
        this._grid.setOptions({ enableSorting: this._gridOptions.enableSorting }, false, true);
        this.sharedService.gridOptions = this._gridOptions;
        // reset columns so that it recreate the column headers and remove/add the sort icon hints
        // basically without this, the sort icon hints were still showing up even after disabling the Sorting
        this._grid.setColumns(updatedColumnDefinitions);
    }
    /**
     * Toggle the Sorting functionality
     * @param {boolean} clearSortingWhenDisabled - when disabling the sorting, do we also want to clear the sorting as well? Defaults to True
     */
    toggleSortFunctionality(clearSortingOnDisable = true) {
        const previousSorting = this._gridOptions.enableSorting;
        this.disableSortFunctionality(previousSorting, clearSortingOnDisable);
    }
    /**
     * A simple function that is binded to the subscriber and emit a change when the sort is called.
     * Other services, like Pagination, can then subscribe to it.
     * @param sender
     */
    emitSortChanged(sender, currentLocalSorters) {
        if (sender === EmitterType.remote && this._gridOptions && this._gridOptions.backendServiceApi) {
            let currentSorters = [];
            const backendService = this._gridOptions.backendServiceApi.service;
            if (backendService && backendService.getCurrentSorters) {
                currentSorters = backendService.getCurrentSorters();
            }
            this.onSortChanged.next(currentSorters);
        }
        else if (sender === EmitterType.local) {
            if (currentLocalSorters) {
                this._currentLocalSorters = currentLocalSorters;
            }
            this.onSortChanged.next(this.getCurrentLocalSorters());
        }
    }
    getCurrentLocalSorters() {
        return this._currentLocalSorters;
    }
    /**
     * Get current column sorts,
     * If a column is passed as an argument, that will be exclusion so we won't add this column to our output array since it is already in the array.
     * The usage of this method is that we want to know the sort prior to calling the next sorting command
     */
    getCurrentColumnSorts(excludedColumnId) {
        // getSortColumns() only returns sortAsc & columnId, we want the entire column definition
        const oldSortColumns = this._grid && this._grid.getSortColumns();
        // get the column definition but only keep column which are not equal to our current column
        if (Array.isArray(oldSortColumns)) {
            const sortedCols = oldSortColumns.reduce((cols, col) => {
                if (!excludedColumnId || col.columnId !== excludedColumnId) {
                    cols.push({ columnId: col.columnId || '', sortCol: this._columnDefinitions[this._grid.getColumnIndex(col.columnId)], sortAsc: col.sortAsc });
                }
                return cols;
            }, []);
            return sortedCols;
        }
        return [];
    }
    /** Load defined Sorting (sorters) into the grid */
    loadGridSorters(sorters) {
        this._currentLocalSorters = []; // reset current local sorters
        const sortCols = [];
        if (Array.isArray(sorters)) {
            const tmpSorters = this._gridOptions.multiColumnSort ? sorters : sorters.slice(0, 1);
            tmpSorters.forEach((sorter) => {
                const gridColumn = this._columnDefinitions.find((col) => col.id === sorter.columnId);
                if (gridColumn) {
                    sortCols.push({
                        columnId: gridColumn.id,
                        sortAsc: ((sorter.direction.toUpperCase() === SortDirection.ASC) ? true : false),
                        sortCol: gridColumn
                    });
                    // keep current sorters
                    this._currentLocalSorters.push({
                        columnId: gridColumn.id + '',
                        direction: sorter.direction.toUpperCase()
                    });
                }
            });
            this.onLocalSortChanged(this._grid, sortCols);
            this._grid.setSortColumns(sortCols.map(col => ({ columnId: col.columnId, sortAsc: col.sortAsc }))); // use this to add sort icon(s) in UI
        }
        return sortCols;
    }
    /** Process the initial sort, typically it will sort ascending by the column that has the Tree Data unless user specifies a different initialSort */
    processTreeDataInitialSort() {
        var _a, _b, _c;
        // when a Tree Data view is defined, we must sort the data so that the UI works correctly
        if (((_a = this._gridOptions) === null || _a === void 0 ? void 0 : _a.enableTreeData) && this._gridOptions.treeDataOptions) {
            // first presort it once by tree level
            const treeDataOptions = this._gridOptions.treeDataOptions;
            const columnWithTreeData = this._columnDefinitions.find((col) => col.id === treeDataOptions.columnId);
            if (columnWithTreeData) {
                let sortDirection = SortDirection.ASC;
                let sortTreeLevelColumn = { columnId: treeDataOptions.columnId, sortCol: columnWithTreeData, sortAsc: true };
                // user could provide a custom sort field id, if so get that column and sort by it
                if ((_b = treeDataOptions === null || treeDataOptions === void 0 ? void 0 : treeDataOptions.initialSort) === null || _b === void 0 ? void 0 : _b.columnId) {
                    const initialSortColumnId = treeDataOptions.initialSort.columnId;
                    const initialSortColumn = this._columnDefinitions.find((col) => col.id === initialSortColumnId);
                    sortDirection = (treeDataOptions.initialSort.direction || SortDirection.ASC).toUpperCase();
                    sortTreeLevelColumn = { columnId: initialSortColumnId, sortCol: initialSortColumn, sortAsc: (sortDirection === SortDirection.ASC) };
                }
                // when we have a valid column with Tree Data, we can sort by that column
                if ((sortTreeLevelColumn === null || sortTreeLevelColumn === void 0 ? void 0 : sortTreeLevelColumn.columnId) && ((_c = this.sharedService) === null || _c === void 0 ? void 0 : _c.hierarchicalDataset)) {
                    this.updateSorting([{ columnId: sortTreeLevelColumn.columnId || '', direction: sortDirection }]);
                }
            }
        }
    }
    onBackendSortChanged(event, args) {
        if (!args || !args.grid) {
            throw new Error('Something went wrong when trying to bind the "onBackendSortChanged(event, args)" function, it seems that "args" is not populated correctly');
        }
        const gridOptions = (args.grid && args.grid.getOptions) ? args.grid.getOptions() : {};
        const backendApi = gridOptions.backendServiceApi;
        if (!backendApi || !backendApi.process || !backendApi.service) {
            throw new Error(`BackendServiceApi requires at least a "process" function and a "service" defined`);
        }
        // keep start time & end timestamps & return it after process execution
        const startTime = new Date();
        if (backendApi.preProcess) {
            backendApi.preProcess();
        }
        // query backend
        const query = backendApi.service.processOnSortChanged(event, args);
        const totalItems = gridOptions && gridOptions.pagination && gridOptions.pagination.totalItems;
        executeBackendCallback(backendApi, query, args, startTime, totalItems, this.emitSortChanged.bind(this), this.httpCancelRequests$);
    }
    /** When a Sort Changes on a Local grid (JSON dataset) */
    onLocalSortChanged(grid, sortColumns, forceReSort = false, emitSortChanged = false) {
        var _a, _b, _c, _d;
        const datasetIdPropertyName = (_b = (_a = this._gridOptions) === null || _a === void 0 ? void 0 : _a.datasetIdPropertyName) !== null && _b !== void 0 ? _b : 'id';
        const isTreeDataEnabled = (_d = (_c = this._gridOptions) === null || _c === void 0 ? void 0 : _c.enableTreeData) !== null && _d !== void 0 ? _d : false;
        const dataView = grid && grid.getData && grid.getData();
        if (grid && dataView) {
            if (forceReSort && !isTreeDataEnabled) {
                dataView.reSort();
            }
            if (isTreeDataEnabled && this.sharedService && Array.isArray(this.sharedService.hierarchicalDataset)) {
                const datasetSortResult = this.sortHierarchicalDataset(this.sharedService.hierarchicalDataset, sortColumns);
                // we could use the DataView sort but that would require re-sorting again (since the 2nd array that is currently in the DataView would have to be resorted against the 1st array that was sorting from tree sort)
                // it is simply much faster to just replace the entire dataset
                this._dataView.setItems(datasetSortResult.flat, datasetIdPropertyName);
            }
            else {
                dataView.sort(this.sortComparers.bind(this, sortColumns));
            }
            grid.invalidate();
            grid.render();
            if (emitSortChanged) {
                this.emitSortChanged(EmitterType.local, sortColumns.map(col => {
                    return {
                        columnId: col.sortCol && col.sortCol.id || 'id',
                        direction: col.sortAsc ? SortDirection.ASC : SortDirection.DESC
                    };
                }));
            }
        }
    }
    /** Takes a hierarchical dataset and sort it recursively,  */
    sortHierarchicalDataset(hierarchicalDataset, sortColumns) {
        var _a, _b, _c, _d, _f;
        this.sortTreeData(hierarchicalDataset, sortColumns);
        const dataViewIdIdentifier = (_b = (_a = this._gridOptions) === null || _a === void 0 ? void 0 : _a.datasetIdPropertyName) !== null && _b !== void 0 ? _b : 'id';
        const treeDataOpt = (_d = (_c = this._gridOptions) === null || _c === void 0 ? void 0 : _c.treeDataOptions) !== null && _d !== void 0 ? _d : { columnId: '' };
        const treeDataOptions = Object.assign(Object.assign({}, treeDataOpt), { identifierPropName: (_f = treeDataOpt.identifierPropName) !== null && _f !== void 0 ? _f : dataViewIdIdentifier, shouldAddTreeLevelNumber: true });
        const sortedFlatArray = flattenToParentChildArray(hierarchicalDataset, treeDataOptions);
        return { hierarchical: hierarchicalDataset, flat: sortedFlatArray };
    }
    /** Call a local grid sort by its default sort field id (user can customize default field by configuring "defaultColumnSortFieldId" in the grid options, defaults to "id") */
    sortLocalGridByDefaultSortFieldId() {
        const sortColFieldId = this._gridOptions && this._gridOptions.defaultColumnSortFieldId || this._gridOptions.datasetIdPropertyName || 'id';
        const sortCol = { id: sortColFieldId, field: sortColFieldId };
        this.onLocalSortChanged(this._grid, new Array({ sortAsc: true, sortCol, clearSortTriggered: true }));
    }
    sortComparers(sortColumns, dataRow1, dataRow2) {
        if (Array.isArray(sortColumns)) {
            for (const sortColumn of sortColumns) {
                const result = this.sortComparer(sortColumn, dataRow1, dataRow2);
                if (result !== undefined) {
                    return result;
                }
            }
        }
        return SortDirectionNumber.neutral;
    }
    sortComparer(sortColumn, dataRow1, dataRow2, querySortField) {
        if (sortColumn && sortColumn.sortCol) {
            const columnDef = sortColumn.sortCol;
            const sortDirection = sortColumn.sortAsc ? SortDirectionNumber.asc : SortDirectionNumber.desc;
            let queryFieldName1 = querySortField || columnDef.queryFieldSorter || columnDef.queryField || columnDef.field;
            let queryFieldName2 = queryFieldName1;
            const fieldType = columnDef.type || FieldType.string;
            // if user provided a query field name getter callback, we need to get the name on each item independently
            if (typeof columnDef.queryFieldNameGetterFn === 'function') {
                queryFieldName1 = columnDef.queryFieldNameGetterFn(dataRow1);
                queryFieldName2 = columnDef.queryFieldNameGetterFn(dataRow2);
            }
            let value1 = dataRow1[queryFieldName1];
            let value2 = dataRow2[queryFieldName2];
            // when item is a complex object (dot "." notation), we need to filter the value contained in the object tree
            if (queryFieldName1 && queryFieldName1.indexOf('.') >= 0) {
                value1 = getDescendantProperty(dataRow1, queryFieldName1);
            }
            if (queryFieldName2 && queryFieldName2.indexOf('.') >= 0) {
                value2 = getDescendantProperty(dataRow2, queryFieldName2);
            }
            // user could provide his own custom Sorter
            if (columnDef.sorter) {
                const customSortResult = columnDef.sorter(value1, value2, sortDirection, columnDef, this._gridOptions);
                if (customSortResult !== SortDirectionNumber.neutral) {
                    return customSortResult;
                }
            }
            else {
                const sortResult = sortByFieldType(fieldType, value1, value2, sortDirection, columnDef, this._gridOptions);
                if (sortResult !== SortDirectionNumber.neutral) {
                    return sortResult;
                }
            }
        }
        return undefined;
    }
    sortTreeData(treeArray, sortColumns) {
        if (Array.isArray(sortColumns)) {
            for (const sortColumn of sortColumns) {
                this.sortTreeChild(treeArray, sortColumn, 0);
            }
        }
    }
    /** Sort the Tree Children of a hierarchical dataset by recursion */
    sortTreeChild(treeArray, sortColumn, treeLevel) {
        var _a, _b;
        const treeDataOptions = (_a = this._gridOptions) === null || _a === void 0 ? void 0 : _a.treeDataOptions;
        const childrenPropName = (_b = treeDataOptions === null || treeDataOptions === void 0 ? void 0 : treeDataOptions.childrenPropName) !== null && _b !== void 0 ? _b : 'children';
        treeArray.sort((a, b) => { var _a; return (_a = this.sortComparer(sortColumn, a, b)) !== null && _a !== void 0 ? _a : SortDirectionNumber.neutral; });
        // when item has a child, we'll sort recursively
        for (const item of treeArray) {
            if (item) {
                const hasChildren = item.hasOwnProperty(childrenPropName) && Array.isArray(item[childrenPropName]);
                // when item has a child, we'll sort recursively
                if (hasChildren) {
                    treeLevel++;
                    this.sortTreeChild(item[childrenPropName], sortColumn, treeLevel);
                    treeLevel--;
                }
            }
        }
    }
    /**
     * Update Sorting (sorters) dynamically just by providing an array of sorter(s).
     * You can also choose emit (default) a Sort Changed event that will be picked by the Grid State Service.
     *
     * Also for backend service only, you can choose to trigger a backend query (default) or not if you wish to do it later,
     * this could be useful when using updateFilters & updateSorting and you wish to only send the backend query once.
     * @param sorters array
     * @param triggerEvent defaults to True, do we want to emit a sort changed event?
     * @param triggerBackendQuery defaults to True, which will query the backend.
     */
    updateSorting(sorters, emitChangedEvent = true, triggerBackendQuery = true) {
        var _a;
        if (!this._gridOptions || !this._gridOptions.enableSorting) {
            throw new Error('[Angular-Slickgrid] in order to use "updateSorting" method, you need to have Sortable Columns defined in your grid and "enableSorting" set in your Grid Options');
        }
        if (Array.isArray(sorters)) {
            const backendApi = (_a = this._gridOptions) === null || _a === void 0 ? void 0 : _a.backendServiceApi;
            if (backendApi) {
                const backendApiService = backendApi === null || backendApi === void 0 ? void 0 : backendApi.service;
                if (backendApiService === null || backendApiService === void 0 ? void 0 : backendApiService.updateSorters) {
                    backendApiService.updateSorters(undefined, sorters);
                    if (triggerBackendQuery) {
                        refreshBackendDataset(this._gridOptions);
                    }
                }
            }
            else {
                this.loadGridSorters(sorters);
            }
            if (emitChangedEvent) {
                const emitterType = backendApi ? EmitterType.remote : EmitterType.local;
                this.emitSortChanged(emitterType);
            }
        }
    }
    // --
    // private functions
    // -------------------
    /**
     * Loop through all column definitions and do the following 2 things
     * 1. disable/enable the "sortable" property of each column
     * 2. loop through each Header Menu commands and change the "hidden" commands to show/hide depending if it's enabled/disabled
     * Also note that we aren't deleting any properties, we just toggle their flags so that we can reloop through at later point in time.
     * (if we previously deleted these properties we wouldn't be able to change them back since these properties wouldn't exist anymore, hence why we just hide the commands)
     * @param {boolean} isDisabling - are we disabling the sort functionality? Defaults to true
     */
    disableAllSortingCommands(isDisabling = true) {
        const columnDefinitions = this._grid.getColumns();
        // loop through column definition to hide/show header menu commands
        columnDefinitions.forEach((col) => {
            if (typeof col.sortable !== undefined) {
                col.sortable = !isDisabling;
            }
            if (col && col.header && col.header.menu) {
                col.header.menu.items.forEach(menuItem => {
                    if (menuItem && typeof menuItem !== 'string') {
                        const menuCommand = menuItem.command;
                        if (menuCommand === 'sort-asc' || menuCommand === 'sort-desc' || menuCommand === 'clear-sort') {
                            menuItem.hidden = isDisabling;
                        }
                    }
                });
            }
        });
        // loop through column definition to hide/show grid menu commands
        if (this._gridOptions && this._gridOptions.gridMenu && this._gridOptions.gridMenu.customItems) {
            this._gridOptions.gridMenu.customItems.forEach((menuItem) => {
                if (menuItem && typeof menuItem !== 'string') {
                    const menuCommand = menuItem.command;
                    if (menuCommand === 'clear-sorting') {
                        menuItem.hidden = isDisabling;
                    }
                }
            });
        }
        return columnDefinitions;
    }
}
SortService.ɵfac = function SortService_Factory(t) { return new (t || SortService)(ɵngcc0.ɵɵinject(SharedService)); };
SortService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: SortService, factory: SortService.ɵfac });
SortService.ctorParameters = () => [
    { type: SharedService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SortService, [{
        type: Injectable
    }], function () { return [{ type: SharedService }]; }, null); })();

class TreeDataService {
    constructor(sharedService, sortService) {
        var _a, _b, _c, _d;
        this.sharedService = sharedService;
        this.sortService = sortService;
        this._isLastFullToggleCollapsed = false;
        this._lastToggleStateChange = {
            type: ((_b = (_a = this.gridOptions) === null || _a === void 0 ? void 0 : _a.treeDataOptions) === null || _b === void 0 ? void 0 : _b.initiallyCollapsed) ? 'full-collapse' : 'full-expand',
            previousFullToggleType: ((_d = (_c = this.gridOptions) === null || _c === void 0 ? void 0 : _c.treeDataOptions) === null || _d === void 0 ? void 0 : _d.initiallyCollapsed) ? 'full-collapse' : 'full-expand',
            toggledItems: null
        };
        this._currentToggledItems = [];
        this._eventHandler = new Slick.EventHandler();
    }
    set currentToggledItems(newToggledItems) {
        this._currentToggledItems = newToggledItems;
    }
    get dataset() {
        var _a;
        return (_a = this.dataView) === null || _a === void 0 ? void 0 : _a.getItems();
    }
    get datasetHierarchical() {
        return this.sharedService.hierarchicalDataset;
    }
    /** Getter of SlickGrid DataView object */
    get dataView() {
        var _a, _b, _c;
        return (_c = (_b = (_a = this._grid) === null || _a === void 0 ? void 0 : _a.getData) === null || _b === void 0 ? void 0 : _b.call(_a)) !== null && _c !== void 0 ? _c : {};
    }
    /** Getter of the SlickGrid Event Handler */
    get eventHandler() {
        return this._eventHandler;
    }
    get gridOptions() {
        var _a, _b, _c;
        return (_c = (_b = (_a = this._grid) === null || _a === void 0 ? void 0 : _a.getOptions) === null || _b === void 0 ? void 0 : _b.call(_a)) !== null && _c !== void 0 ? _c : {};
    }
    get treeDataOptions() {
        return this.gridOptions.treeDataOptions;
    }
    dispose() {
        var _a;
        // unsubscribe all SlickGrid events
        if ((_a = this._eventHandler) === null || _a === void 0 ? void 0 : _a.unsubscribeAll) {
            this._eventHandler.unsubscribeAll();
        }
    }
    init(grid) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        this._grid = grid;
        this._isLastFullToggleCollapsed = (_c = (_b = (_a = this.gridOptions) === null || _a === void 0 ? void 0 : _a.treeDataOptions) === null || _b === void 0 ? void 0 : _b.initiallyCollapsed) !== null && _c !== void 0 ? _c : false;
        this._currentToggledItems = (_f = (_e = (_d = this.gridOptions.presets) === null || _d === void 0 ? void 0 : _d.treeData) === null || _e === void 0 ? void 0 : _e.toggledItems) !== null && _f !== void 0 ? _f : [];
        // there's a few limitations with Tree Data, we'll just throw error when that happens
        if ((_g = this.gridOptions) === null || _g === void 0 ? void 0 : _g.enableTreeData) {
            if ((_h = this.gridOptions) === null || _h === void 0 ? void 0 : _h.multiColumnSort) {
                throw new Error('[Angular-Slickgrid] Tree Data does not currently support multi-column sorting, you can disable it via "multiColumnSort: false" grid option and/or help in providing support for this feature.');
            }
            if (!((_j = this.gridOptions) === null || _j === void 0 ? void 0 : _j.enableFiltering)) {
                throw new Error('[Angular-Slickgrid] It looks like you are trying to use Tree Data without using the filtering option, unfortunately that is not possible with Tree Data since it relies heavily on the filters to expand/collapse the tree. You need to enable it via "enableFiltering: true"');
            }
            if (((_k = this.gridOptions) === null || _k === void 0 ? void 0 : _k.backendServiceApi) || ((_l = this.gridOptions) === null || _l === void 0 ? void 0 : _l.enablePagination)) {
                throw new Error('[Angular-Slickgrid] It looks like you are trying to use Tree Data with Pagination and/or a Backend Service (OData, GraphQL) but unfortunately that is simply not supported because of its complexity.');
            }
            if (!this.gridOptions.treeDataOptions || !this.gridOptions.treeDataOptions.columnId) {
                throw new Error('[Angular-Slickgrid] When enabling tree data, you must also provide the "treeDataOption" property in your Grid Options with "childrenPropName" or "parentPropName" (depending if your array is hierarchical or flat) for the Tree Data to work properly.');
            }
        }
        // subscribe to the SlickGrid event and call the backend execution
        this._eventHandler.subscribe(grid.onClick, this.handleOnCellClick.bind(this));
    }
    /**
     * Apply different tree toggle state changes by providing an array of parentIds that are designated as collapsed (or not).
     * User will have to provide an array of `parentId` and `isCollapsed` boolean and the code will only apply the ones that are tagged as collapsed, everything else will be expanded
     * @param {Array<TreeToggledItem>} treeToggledItems - array of parentId which are tagged as changed
     * @param {ToggleStateChangeType} previousFullToggleType - optionally provide the previous full toggle type ('full-expand' or 'full-collapse')
     * @param {Boolean} shouldPreProcessFullToggle - should we pre-process a full toggle on all items? defaults to True
     * @param {Boolean} shouldTriggerEvent - should we trigger a toggled item event? defaults to False
     */
    applyToggledItemStateChanges(treeToggledItems, previousFullToggleType, shouldPreProcessFullToggle = true, shouldTriggerEvent = false) {
        if (Array.isArray(treeToggledItems)) {
            const collapsedPropName = this.getTreeDataOptionPropName('collapsedPropName');
            const hasChildrenPropName = this.getTreeDataOptionPropName('hasChildrenPropName');
            // for the rows we identified as collapsed, we'll send them to the DataView with the new updated collapsed flag
            // and we'll refresh the DataView to see the collapsing applied in the grid
            this.dataView.beginUpdate(true);
            // we first need to put back the previous full toggle state (whether it was a full collapse or expand) by collapsing/expanding everything depending on the last toggled that was called `isLastFullToggleCollapsed`
            const previousFullToggle = previousFullToggleType !== null && previousFullToggleType !== void 0 ? previousFullToggleType : this._lastToggleStateChange.previousFullToggleType;
            const shouldCollapseAll = previousFullToggle === 'full-collapse';
            // when full toggle type is provided, we also need to update our internal reference of our current toggle state
            if (previousFullToggleType) {
                this._lastToggleStateChange.previousFullToggleType = previousFullToggleType;
            }
            // typically (optionally and defaults to true) if we want to reapply some toggled items we probably want to be in the full toggled state as it was at the start
            // collapse/expand from the last full toggle state, all the items which are parent items with children
            if (shouldPreProcessFullToggle) {
                (this.dataView.getItems() || []).forEach((item) => {
                    if (item[hasChildrenPropName]) {
                        item[collapsedPropName] = shouldCollapseAll;
                    }
                });
            }
            // then we reapply only the ones that changed (provided as argument to the function)
            for (const collapsedItem of treeToggledItems) {
                const item = this.dataView.getItemById(collapsedItem.itemId);
                this.updateToggledItem(item, collapsedItem.isCollapsed);
                if (shouldTriggerEvent) {
                    const parentFoundIdx = this._currentToggledItems.findIndex(treeChange => treeChange.itemId === collapsedItem.itemId);
                    if (parentFoundIdx >= 0) {
                        this._currentToggledItems[parentFoundIdx].isCollapsed = collapsedItem.isCollapsed;
                    }
                    else {
                        this._currentToggledItems.push({ itemId: collapsedItem.itemId, isCollapsed: collapsedItem.isCollapsed });
                    }
                    this.sharedService.onTreeItemToggled.next(Object.assign(Object.assign({}, this._lastToggleStateChange), { fromItemId: collapsedItem.itemId, toggledItems: this._currentToggledItems, type: collapsedItem.isCollapsed ? ToggleStateChangeType.toggleCollapse : ToggleStateChangeType.toggleExpand }));
                }
            }
            // close the update transaction & call a refresh which will trigger a re-render with filters applied (including expand/collapse)
            this.dataView.endUpdate();
            this.dataView.refresh();
        }
    }
    /**
     * Get the current toggle state that includes the type (toggle, full-expand, full-collapse) and toggled items (only applies when it's a parent toggle)
     * @returns {TreeToggleStateChange} treeDataToggledItems - items that were toggled (array of `parentId` and `isCollapsed` flag)
     */
    getCurrentToggleState() {
        return this._lastToggleStateChange;
    }
    getInitialSort(columnDefinitions, gridOptions) {
        var _a, _b, _c;
        const treeDataOptions = gridOptions === null || gridOptions === void 0 ? void 0 : gridOptions.treeDataOptions;
        const initialColumnSorting = (_a = treeDataOptions === null || treeDataOptions === void 0 ? void 0 : treeDataOptions.initialSort) !== null && _a !== void 0 ? _a : { columnId: (_b = treeDataOptions === null || treeDataOptions === void 0 ? void 0 : treeDataOptions.columnId) !== null && _b !== void 0 ? _b : '', direction: 'ASC' };
        const initialSortColumn = columnDefinitions.find(col => col.id === initialColumnSorting.columnId);
        return {
            columnId: initialColumnSorting.columnId,
            sortAsc: ((_c = initialColumnSorting === null || initialColumnSorting === void 0 ? void 0 : initialColumnSorting.direction) === null || _c === void 0 ? void 0 : _c.toUpperCase()) !== 'DESC',
            sortCol: initialSortColumn,
        };
    }
    /**
     * Get the current list of Tree Data item(s) that got toggled in the grid (basically the parents that the user clicked on the toggle icon to expand/collapse the child)
     * @returns {Array<TreeToggledItem>} treeDataToggledItems - items that were toggled (array of `parentId` and `isCollapsed` flag)
     */
    getToggledItems() {
        return this._currentToggledItems;
    }
    /** Find the associated property name from the Tree Data option when found or return a default property name that we defined internally */
    getTreeDataOptionPropName(optionName) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        let propName = '';
        switch (optionName) {
            case 'childrenPropName':
                propName = (_b = (_a = this.treeDataOptions) === null || _a === void 0 ? void 0 : _a.childrenPropName) !== null && _b !== void 0 ? _b : Constants.treeDataProperties.CHILDREN_PROP;
                break;
            case 'collapsedPropName':
                propName = (_d = (_c = this.treeDataOptions) === null || _c === void 0 ? void 0 : _c.collapsedPropName) !== null && _d !== void 0 ? _d : Constants.treeDataProperties.COLLAPSED_PROP;
                break;
            case 'hasChildrenPropName':
                propName = (_f = (_e = this.treeDataOptions) === null || _e === void 0 ? void 0 : _e.hasChildrenPropName) !== null && _f !== void 0 ? _f : Constants.treeDataProperties.HAS_CHILDREN_PROP;
                break;
            case 'identifierPropName':
                propName = (_k = (_h = (_g = this.treeDataOptions) === null || _g === void 0 ? void 0 : _g.identifierPropName) !== null && _h !== void 0 ? _h : (_j = this.gridOptions) === null || _j === void 0 ? void 0 : _j.datasetIdPropertyName) !== null && _k !== void 0 ? _k : 'id';
                break;
            case 'levelPropName':
                propName = (_m = (_l = this.treeDataOptions) === null || _l === void 0 ? void 0 : _l.levelPropName) !== null && _m !== void 0 ? _m : Constants.treeDataProperties.TREE_LEVEL_PROP;
                break;
            case 'parentPropName':
                propName = (_p = (_o = this.treeDataOptions) === null || _o === void 0 ? void 0 : _o.parentPropName) !== null && _p !== void 0 ? _p : Constants.treeDataProperties.PARENT_PROP;
                break;
        }
        return propName;
    }
    /**
     * Takes a flat dataset, converts it into a hierarchical dataset, sort it by recursion and finally return back the final and sorted flat array
     * @param {Array<Object>} flatDataset - parent/child flat dataset
     * @param {Object} gridOptions - grid options
     * @returns {Array<Object>} - tree dataset
     */
    convertFlatParentChildToTreeDatasetAndSort(flatDataset, columnDefinitions, gridOptions) {
        var _a;
        // 1- convert the flat array into a hierarchical array
        const datasetHierarchical = this.convertFlatParentChildToTreeDataset(flatDataset, gridOptions);
        // 2- sort the hierarchical array recursively by an optional "initialSort" OR if nothing is provided we'll sort by the column defined as the Tree column
        // also note that multi-column is not currently supported with Tree Data
        const columnSort = this.getInitialSort(columnDefinitions, gridOptions);
        const datasetSortResult = this.sortService.sortHierarchicalDataset(datasetHierarchical, [columnSort]);
        // and finally add the sorting icon (this has to be done manually in SlickGrid) to the column we used for the sorting
        (_a = this._grid) === null || _a === void 0 ? void 0 : _a.setSortColumns([columnSort]);
        return datasetSortResult;
    }
    /**
     * Takes a flat dataset, converts it into a hierarchical dataset
     * @param {Array<Object>} flatDataset - parent/child flat dataset
     * @param {Object} gridOptions - grid options
     * @returns {Array<Object>} - tree dataset
     */
    convertFlatParentChildToTreeDataset(flatDataset, gridOptions) {
        var _a, _b, _c;
        const dataViewIdIdentifier = (_a = gridOptions === null || gridOptions === void 0 ? void 0 : gridOptions.datasetIdPropertyName) !== null && _a !== void 0 ? _a : 'id';
        const treeDataOpt = (_b = gridOptions === null || gridOptions === void 0 ? void 0 : gridOptions.treeDataOptions) !== null && _b !== void 0 ? _b : { columnId: 'id' };
        const treeDataOptions = Object.assign(Object.assign({}, treeDataOpt), { identifierPropName: (_c = treeDataOpt.identifierPropName) !== null && _c !== void 0 ? _c : dataViewIdIdentifier });
        return unflattenParentChildArrayToTree(flatDataset, treeDataOptions);
    }
    /**
     * Takes a hierarchical (tree) input array and sort it (if an `initialSort` exist, it will use that to sort)
     * @param {Array<Object>} hierarchicalDataset - inpu
     * @returns {Object} sort result object that includes both the flat & tree data arrays
     */
    sortHierarchicalDataset(hierarchicalDataset, inputColumnSorts) {
        const columnSorts = inputColumnSorts !== null && inputColumnSorts !== void 0 ? inputColumnSorts : this.getInitialSort(this.sharedService.allColumns, this.gridOptions);
        const finalColumnSorts = Array.isArray(columnSorts) ? columnSorts : [columnSorts];
        return this.sortService.sortHierarchicalDataset(hierarchicalDataset, finalColumnSorts);
    }
    /**
     * Toggle the collapsed values of all parent items (the ones with children), we can optionally provide a flag to force a collapse or expand
     * @param {Boolean} collapsing - optionally force a collapse/expand (True => collapse all, False => expand all)
     * @param {Boolean} shouldTriggerEvent - defaults to true, should we trigger an event? For example, we could disable this to avoid a Grid State change event.
     * @returns {Promise<void>} - returns a void Promise, the reason we use a Promise is simply to make sure that when we add a spinner, it doesn't start/stop only at the end of the process
     */
    toggleTreeDataCollapse(collapsing, shouldTriggerEvent = true) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if ((_a = this.gridOptions) === null || _a === void 0 ? void 0 : _a.enableTreeData) {
                const hasChildrenPropName = this.getTreeDataOptionPropName('hasChildrenPropName');
                // emit an event when full toggle starts (useful to show a spinner)
                if (shouldTriggerEvent) {
                    this.sharedService.onTreeFullToggleStart.next({ collapsing });
                }
                // do a bulk change data update to toggle all necessary parents (the ones with children) to the new collapsed flag value
                this.dataView.beginUpdate(true);
                // toggle the collapsed flag but only when it's a parent item with children
                (this.dataView.getItems() || []).forEach((item) => {
                    if (item[hasChildrenPropName]) {
                        this.updateToggledItem(item, collapsing);
                    }
                });
                this.dataView.endUpdate();
                this.dataView.refresh();
                this._isLastFullToggleCollapsed = collapsing;
            }
            const toggleType = collapsing ? ToggleStateChangeType.fullCollapse : ToggleStateChangeType.fullExpand;
            this._lastToggleStateChange = {
                type: toggleType,
                previousFullToggleType: toggleType,
                toggledItems: null
            };
            // emit an event when full toggle ends
            if (shouldTriggerEvent) {
                this.sharedService.onTreeFullToggleEnd.next(this._lastToggleStateChange);
            }
        });
    }
    // --
    // private functions
    // ------------------
    handleOnCellClick(event, args) {
        var _a;
        if (event && args) {
            const targetElm = event.target || {};
            const idPropName = (_a = this.gridOptions.datasetIdPropertyName) !== null && _a !== void 0 ? _a : 'id';
            const collapsedPropName = this.getTreeDataOptionPropName('collapsedPropName');
            const childrenPropName = this.getTreeDataOptionPropName('childrenPropName');
            if (targetElm === null || targetElm === void 0 ? void 0 : targetElm.className) {
                const hasToggleClass = targetElm.className.indexOf('toggle') >= 0 || false;
                if (hasToggleClass) {
                    const item = this.dataView.getItem(args.row);
                    if (item) {
                        item[collapsedPropName] = !item[collapsedPropName]; // toggle the collapsed flag
                        const isCollapsed = item[collapsedPropName];
                        const itemId = item[idPropName];
                        const parentFoundIdx = this._currentToggledItems.findIndex(treeChange => treeChange.itemId === itemId);
                        if (parentFoundIdx >= 0) {
                            this._currentToggledItems[parentFoundIdx].isCollapsed = isCollapsed;
                        }
                        else {
                            this._currentToggledItems.push({ itemId, isCollapsed });
                        }
                        this.dataView.updateItem(itemId, item);
                        // since we always keep 2 arrays as reference (flat + hierarchical)
                        // we also need to update the hierarchical array with the new toggle flag
                        const searchTreePredicate = (treeItemToSearch) => treeItemToSearch[idPropName] === itemId;
                        const treeItemFound = findItemInTreeStructure(this.sharedService.hierarchicalDataset || [], searchTreePredicate, childrenPropName);
                        if (treeItemFound) {
                            treeItemFound[collapsedPropName] = isCollapsed;
                        }
                        // and finally we can invalidate the grid to re-render the UI
                        this._grid.invalidate();
                        this._lastToggleStateChange = {
                            type: isCollapsed ? ToggleStateChangeType.toggleCollapse : ToggleStateChangeType.toggleExpand,
                            previousFullToggleType: this._isLastFullToggleCollapsed ? 'full-collapse' : 'full-expand',
                            toggledItems: this._currentToggledItems
                        };
                        this.sharedService.onTreeItemToggled.next(Object.assign(Object.assign({}, this._lastToggleStateChange), { fromItemId: itemId }));
                    }
                    event.stopImmediatePropagation();
                }
            }
        }
    }
    updateToggledItem(item, isCollapsed) {
        var _a, _b;
        const dataViewIdIdentifier = (_b = (_a = this.gridOptions) === null || _a === void 0 ? void 0 : _a.datasetIdPropertyName) !== null && _b !== void 0 ? _b : 'id';
        const childrenPropName = this.getTreeDataOptionPropName('childrenPropName');
        const collapsedPropName = this.getTreeDataOptionPropName('collapsedPropName');
        if (item) {
            // update the flat dataset item
            item[collapsedPropName] = isCollapsed;
            this.dataView.updateItem(item[dataViewIdIdentifier], item);
            // also update the hierarchical tree item
            const searchTreePredicate = (treeItemToSearch) => treeItemToSearch[dataViewIdIdentifier] === item[dataViewIdIdentifier];
            const treeItemFound = findItemInTreeStructure(this.sharedService.hierarchicalDataset || [], searchTreePredicate, childrenPropName);
            if (treeItemFound) {
                treeItemFound[collapsedPropName] = isCollapsed;
            }
        }
    }
}
TreeDataService.ɵfac = function TreeDataService_Factory(t) { return new (t || TreeDataService)(ɵngcc0.ɵɵinject(SharedService), ɵngcc0.ɵɵinject(SortService)); };
TreeDataService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: TreeDataService, factory: TreeDataService.ɵfac });
TreeDataService.ctorParameters = () => [
    { type: SharedService },
    { type: SortService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TreeDataService, [{
        type: Injectable
    }], function () { return [{ type: SharedService }, { type: SortService }]; }, null); })();

class ContextMenuExtension {
    constructor(excelExportService, exportService, extensionUtility, sharedService, treeDataService, translate) {
        this.excelExportService = excelExportService;
        this.exportService = exportService;
        this.extensionUtility = extensionUtility;
        this.sharedService = sharedService;
        this.treeDataService = treeDataService;
        this.translate = translate;
        this._eventHandler = new Slick.EventHandler();
    }
    get eventHandler() {
        return this._eventHandler;
    }
    dispose() {
        // unsubscribe all SlickGrid events
        this._eventHandler.unsubscribeAll();
        if (this._addon && this._addon.destroy) {
            this._addon.destroy();
        }
        if (this.sharedService.gridOptions && this.sharedService.gridOptions.contextMenu && this.sharedService.gridOptions.contextMenu.commandItems) {
            this.sharedService.gridOptions.contextMenu = this._userOriginalContextMenu;
        }
        this.extensionUtility.nullifyFunctionNameStartingWithOn(this._contextMenuOptions);
        this._addon = null;
        this._contextMenuOptions = null;
    }
    /** Get the instance of the SlickGrid addon (control or plugin). */
    getAddonInstance() {
        return this._addon;
    }
    /**
     * Create the Action Cell Menu and expose all the available hooks that user can subscribe (onCommand, onBeforeMenuShow, ...)
     * @param grid
     * @param dataView
     * @param columnDefinitions
     */
    register() {
        if (this.sharedService.gridOptions && this.sharedService.gridOptions.enableTranslate && (!this.translate || !this.translate.instant)) {
            throw new Error('[Angular-Slickgrid] requires "ngx-translate" to be installed and configured when the grid option "enableTranslate" is enabled.');
        }
        if (this.sharedService && this.sharedService.grid && this.sharedService.gridOptions && this.sharedService.gridOptions.contextMenu) {
            this._contextMenuOptions = this.sharedService.gridOptions.contextMenu;
            // keep original user context menu, useful when switching locale to translate
            this._userOriginalContextMenu = Object.assign({}, this._contextMenuOptions);
            // merge the original commands with the built-in internal commands
            const originalCommandItems = this._userOriginalContextMenu && Array.isArray(this._userOriginalContextMenu.commandItems) ? this._userOriginalContextMenu.commandItems : [];
            this._contextMenuOptions.commandItems = [...originalCommandItems, ...this.addMenuCustomCommands(originalCommandItems)];
            this._contextMenuOptions = Object.assign({}, this._contextMenuOptions);
            this.sharedService.gridOptions.contextMenu = this._contextMenuOptions;
            // sort all menu items by their position order when defined
            this.extensionUtility.sortItems(this._contextMenuOptions.commandItems || [], 'positionOrder');
            this.extensionUtility.sortItems(this._contextMenuOptions.optionItems || [], 'positionOrder');
            this._addon = new Slick.Plugins.ContextMenu(this._contextMenuOptions);
            this.sharedService.grid.registerPlugin(this._addon);
            // translate the item keys when necessary
            if (this.sharedService.gridOptions.enableTranslate) {
                this.translateContextMenu();
            }
            // hook all events
            if (this.sharedService.grid && this._contextMenuOptions) {
                if (this._contextMenuOptions.onExtensionRegistered) {
                    this._contextMenuOptions.onExtensionRegistered(this._addon);
                }
                if (this._contextMenuOptions && typeof this._contextMenuOptions.onCommand === 'function') {
                    this._eventHandler.subscribe(this._addon.onCommand, (event, args) => {
                        if (this._contextMenuOptions && this._contextMenuOptions.onCommand) {
                            this._contextMenuOptions.onCommand(event, args);
                        }
                    });
                }
                if (this._contextMenuOptions && typeof this._contextMenuOptions.onOptionSelected === 'function') {
                    this._eventHandler.subscribe(this._addon.onOptionSelected, (event, args) => {
                        if (this._contextMenuOptions && this._contextMenuOptions.onOptionSelected) {
                            this._contextMenuOptions.onOptionSelected(event, args);
                        }
                    });
                }
                if (this._contextMenuOptions && typeof this._contextMenuOptions.onBeforeMenuShow === 'function') {
                    this._eventHandler.subscribe(this._addon.onBeforeMenuShow, (event, args) => {
                        if (this._contextMenuOptions && this._contextMenuOptions.onBeforeMenuShow) {
                            this._contextMenuOptions.onBeforeMenuShow(event, args);
                        }
                    });
                }
                if (this._contextMenuOptions && typeof this._contextMenuOptions.onBeforeMenuClose === 'function') {
                    this._eventHandler.subscribe(this._addon.onBeforeMenuClose, (event, args) => {
                        if (this._contextMenuOptions && this._contextMenuOptions.onBeforeMenuClose) {
                            this._contextMenuOptions.onBeforeMenuClose(event, args);
                        }
                    });
                }
                if (this._contextMenuOptions && typeof this._contextMenuOptions.onAfterMenuShow === 'function') {
                    this._eventHandler.subscribe(this._addon.onAfterMenuShow, (event, args) => {
                        if (this._contextMenuOptions && this._contextMenuOptions.onAfterMenuShow) {
                            this._contextMenuOptions.onAfterMenuShow(event, args);
                        }
                    });
                }
            }
            return this._addon;
        }
        return null;
    }
    /** Translate the Cell Menu titles, we need to loop through all column definition to re-translate them */
    translateContextMenu() {
        if (this.sharedService && this.sharedService.gridOptions && this.sharedService.gridOptions.contextMenu) {
            const contextMenu = this.sharedService.gridOptions.contextMenu;
            const menuOptions = {};
            if (contextMenu.commandTitleKey) {
                contextMenu.commandTitle = this.translate && this.translate.currentLang && this.translate.instant && this.translate.instant(contextMenu.commandTitleKey) || contextMenu.commandTitle;
                menuOptions.commandTitle = contextMenu.commandTitle;
            }
            if (contextMenu.optionTitleKey) {
                contextMenu.optionTitle = this.translate && this.translate.currentLang && this.translate.instant && this.translate.instant(contextMenu.optionTitleKey) || contextMenu.optionTitle;
                menuOptions.optionTitle = contextMenu.optionTitle;
            }
            const originalCommandItems = this._userOriginalContextMenu && Array.isArray(this._userOriginalContextMenu.commandItems) ? this._userOriginalContextMenu.commandItems : [];
            contextMenu.commandItems = [...originalCommandItems, ...this.addMenuCustomCommands(originalCommandItems)];
            menuOptions.commandItems = contextMenu.commandItems; // copy it also to the menuOptions else they won't be translated when locale changes
            // translate all command/options and resort them afterward
            this.extensionUtility.translateItems(contextMenu.commandItems || [], 'titleKey', 'title');
            this.extensionUtility.translateItems(contextMenu.optionItems || [], 'titleKey', 'title');
            this.extensionUtility.sortItems(contextMenu.commandItems || [], 'positionOrder');
            this.extensionUtility.sortItems(contextMenu.optionItems || [], 'positionOrder');
            // update the title options so that it has latest translated values
            if (this._addon && this._addon.setOptions) {
                this._addon.setOptions(menuOptions);
            }
        }
    }
    // --
    // private functions
    // ------------------
    /** Create Context Menu with Custom Commands (copy cell value, export) */
    addMenuCustomCommands(originalCustomItems) {
        const menuCustomItems = [];
        const gridOptions = this.sharedService && this.sharedService.gridOptions || {};
        const contextMenu = gridOptions && gridOptions.contextMenu;
        const dataView = this.sharedService && this.sharedService.dataView;
        const translationPrefix = getTranslationPrefix(gridOptions);
        // show context menu: Copy (cell value)
        if (contextMenu && !contextMenu.hideCopyCellValueCommand) {
            const commandName = 'copy';
            if (!originalCustomItems.find(item => item !== 'divider' && item.hasOwnProperty('command') && item.command === commandName)) {
                menuCustomItems.push({
                    iconCssClass: contextMenu.iconCopyCellValueCommand || 'fa fa-clone',
                    title: this.extensionUtility.translateWhenEnabledAndServiceExist(`${translationPrefix}COPY`, 'TEXT_COPY'),
                    disabled: false,
                    command: commandName,
                    positionOrder: 50,
                    action: (e, args) => {
                        this.copyToClipboard(args);
                    },
                    itemUsabilityOverride: (args) => {
                        // make sure there's an item to copy before enabling this command
                        const columnDef = args && args.column;
                        const dataContext = args && args.dataContext;
                        if (typeof columnDef.queryFieldNameGetterFn === 'function') {
                            const cellValue = this.getCellValueFromQueryFieldGetter(columnDef, dataContext);
                            if (cellValue !== '' && cellValue !== undefined) {
                                return true;
                            }
                        }
                        else if (columnDef && dataContext.hasOwnProperty(columnDef.field)) {
                            return dataContext[columnDef.field] !== '' && dataContext[columnDef.field] !== null && dataContext[columnDef.field] !== undefined;
                        }
                        return false;
                    }
                });
            }
        }
        // show context menu: Export to file
        if (gridOptions && gridOptions.enableExport && contextMenu && !contextMenu.hideExportCsvCommand) {
            const commandName = 'export-csv';
            if (!originalCustomItems.find(item => item !== 'divider' && item.hasOwnProperty('command') && item.command === commandName)) {
                menuCustomItems.push({
                    iconCssClass: contextMenu.iconExportCsvCommand || 'fa fa-download',
                    title: this.extensionUtility.translateWhenEnabledAndServiceExist(`${translationPrefix}EXPORT_TO_CSV`, 'TEXT_EXPORT_TO_CSV'),
                    disabled: false,
                    command: commandName,
                    positionOrder: 51,
                    action: () => this.exportService.exportToFile({
                        delimiter: DelimiterType.comma,
                        format: FileType.csv,
                    }),
                });
            }
        }
        // show context menu: Export to Excel
        if (gridOptions && gridOptions.enableExcelExport && contextMenu && !contextMenu.hideExportExcelCommand) {
            const commandName = 'export-excel';
            if (!originalCustomItems.find(item => item !== 'divider' && item.hasOwnProperty('command') && item.command === commandName)) {
                menuCustomItems.push({
                    iconCssClass: contextMenu.iconExportExcelCommand || 'fa fa-file-excel-o text-success',
                    title: this.extensionUtility.translateWhenEnabledAndServiceExist(`${translationPrefix}EXPORT_TO_EXCEL`, 'TEXT_EXPORT_TO_EXCEL'),
                    disabled: false,
                    command: commandName,
                    positionOrder: 52,
                    action: () => this.excelExportService.exportToExcel(),
                });
            }
        }
        // show context menu: export to text file as tab delimited
        if (gridOptions && gridOptions.enableExport && contextMenu && !contextMenu.hideExportTextDelimitedCommand) {
            const commandName = 'export-text-delimited';
            if (!originalCustomItems.find(item => item !== 'divider' && item.hasOwnProperty('command') && item.command === commandName)) {
                menuCustomItems.push({
                    iconCssClass: contextMenu.iconExportTextDelimitedCommand || 'fa fa-download',
                    title: this.extensionUtility.translateWhenEnabledAndServiceExist(`${translationPrefix}EXPORT_TO_TAB_DELIMITED`, 'TEXT_EXPORT_TO_TAB_DELIMITED'),
                    disabled: false,
                    command: commandName,
                    positionOrder: 53,
                    action: () => this.exportService.exportToFile({
                        delimiter: DelimiterType.tab,
                        format: FileType.txt,
                    }),
                });
            }
        }
        // -- Grouping Commands
        if (gridOptions && (gridOptions.enableGrouping || gridOptions.enableDraggableGrouping || gridOptions.enableTreeData)) {
            // add a divider (separator) between the top sort commands and the other clear commands
            if (contextMenu && !contextMenu.hideCopyCellValueCommand) {
                menuCustomItems.push({ divider: true, command: '', positionOrder: 54 });
            }
            // show context menu: Clear Grouping
            if (gridOptions && !gridOptions.enableTreeData && contextMenu && !contextMenu.hideClearAllGrouping) {
                const commandName = 'clear-grouping';
                if (!originalCustomItems.find(item => item !== 'divider' && item.hasOwnProperty('command') && item.command === commandName)) {
                    menuCustomItems.push({
                        iconCssClass: contextMenu.iconClearGroupingCommand || 'fa fa-times',
                        title: this.extensionUtility.translateWhenEnabledAndServiceExist(`${translationPrefix}CLEAR_ALL_GROUPING`, 'TEXT_CLEAR_ALL_GROUPING'),
                        disabled: false,
                        command: commandName,
                        positionOrder: 55,
                        action: () => dataView.setGrouping([]),
                        itemUsabilityOverride: () => {
                            // only enable the command when there's an actually grouping in play
                            const groupingArray = dataView && dataView.getGrouping && dataView.getGrouping();
                            return Array.isArray(groupingArray) && groupingArray.length > 0;
                        }
                    });
                }
            }
            // show context menu: Collapse all Groups
            if (gridOptions && contextMenu && !contextMenu.hideCollapseAllGroups) {
                const commandName = 'collapse-all-groups';
                if (!originalCustomItems.find(item => item !== 'divider' && item.hasOwnProperty('command') && item.command === commandName)) {
                    menuCustomItems.push({
                        iconCssClass: contextMenu.iconCollapseAllGroupsCommand || 'fa fa-compress',
                        title: this.extensionUtility.translateWhenEnabledAndServiceExist(`${translationPrefix}COLLAPSE_ALL_GROUPS`, 'TEXT_COLLAPSE_ALL_GROUPS'),
                        disabled: false,
                        command: commandName,
                        positionOrder: 56,
                        action: () => {
                            if (gridOptions.enableTreeData) {
                                this.treeDataService.toggleTreeDataCollapse(true);
                            }
                            else {
                                dataView.collapseAllGroups();
                            }
                        },
                        itemUsabilityOverride: () => {
                            if (gridOptions.enableTreeData) {
                                return true;
                            }
                            // only enable the command when there's an actually grouping in play
                            const groupingArray = dataView && dataView.getGrouping && dataView.getGrouping();
                            return Array.isArray(groupingArray) && groupingArray.length > 0;
                        }
                    });
                }
            }
            // show context menu: Expand all Groups
            if (gridOptions && contextMenu && !contextMenu.hideExpandAllGroups) {
                const commandName = 'expand-all-groups';
                if (!originalCustomItems.find(item => item !== 'divider' && item.hasOwnProperty('command') && item.command === commandName)) {
                    menuCustomItems.push({
                        iconCssClass: contextMenu.iconExpandAllGroupsCommand || 'fa fa-expand',
                        title: this.extensionUtility.translateWhenEnabledAndServiceExist(`${translationPrefix}EXPAND_ALL_GROUPS`, 'TEXT_EXPAND_ALL_GROUPS'),
                        disabled: false,
                        command: commandName,
                        positionOrder: 57,
                        action: () => {
                            if (gridOptions.enableTreeData) {
                                this.treeDataService.toggleTreeDataCollapse(false);
                            }
                            else {
                                dataView.expandAllGroups();
                            }
                        },
                        itemUsabilityOverride: () => {
                            if (gridOptions.enableTreeData) {
                                return true;
                            }
                            // only enable the command when there's an actually grouping in play
                            const groupingArray = dataView && dataView.getGrouping && dataView.getGrouping();
                            return Array.isArray(groupingArray) && groupingArray.length > 0;
                        }
                    });
                }
            }
        }
        return menuCustomItems;
    }
    /**
     * First get the value, if "exportWithFormatter" is set then we'll use the formatter output
     * Then we create the DOM trick to copy a text value by creating a fake <div> that is not shown to the user
     * and from there we can call the execCommand 'copy' command and expect the value to be in clipboard
     * @param args
     */
    copyToClipboard(args) {
        try {
            if (args && args.grid && args.command) {
                // get the value, if "exportWithFormatter" is set then we'll use the formatter output
                const gridOptions = this.sharedService && this.sharedService.gridOptions || {};
                const cell = args && args.cell || 0;
                const row = args && args.row || 0;
                const columnDef = args && args.column;
                const dataContext = args && args.dataContext;
                const grid = this.sharedService && this.sharedService.grid;
                const exportOptions = gridOptions && (gridOptions.excelExportOptions || gridOptions.exportOptions);
                let textToCopy = exportWithFormatterWhenDefined(row, cell, columnDef, dataContext, grid, exportOptions);
                if (typeof columnDef.queryFieldNameGetterFn === 'function') {
                    textToCopy = this.getCellValueFromQueryFieldGetter(columnDef, dataContext);
                }
                // create fake <div> to copy into clipboard & delete it from the DOM once we're done
                const range = document.createRange();
                const tmpElem = $('<div>').css({ position: 'absolute', left: '-1000px', top: '-1000px' }).text(textToCopy);
                $('body').append(tmpElem);
                range.selectNodeContents(tmpElem.get(0));
                const selection = window.getSelection();
                if (selection && selection.addRange && selection.removeAllRanges) {
                    selection.removeAllRanges();
                    selection.addRange(range);
                    const success = document.execCommand('copy', false, textToCopy);
                    if (success) {
                        tmpElem.remove();
                    }
                }
            }
        }
        catch (e) { }
    }
    /**
     * When a queryFieldNameGetterFn is defined, then get the value from that getter callback function
     * @param columnDef
     * @param dataContext
     * @return cellValue
     */
    getCellValueFromQueryFieldGetter(columnDef, dataContext) {
        let cellValue = '';
        if (typeof columnDef.queryFieldNameGetterFn === 'function') {
            const queryFieldName = columnDef.queryFieldNameGetterFn(dataContext);
            // get the cell value from the item or when it's a dot notation then exploded the item and get the final value
            if (queryFieldName && queryFieldName.indexOf('.') >= 0) {
                cellValue = getDescendantProperty(dataContext, queryFieldName);
            }
            else {
                cellValue = dataContext[queryFieldName];
            }
        }
        return cellValue;
    }
}
ContextMenuExtension.ɵfac = function ContextMenuExtension_Factory(t) { return new (t || ContextMenuExtension)(ɵngcc0.ɵɵinject(ExcelExportService), ɵngcc0.ɵɵinject(ExportService), ɵngcc0.ɵɵinject(ExtensionUtility), ɵngcc0.ɵɵinject(SharedService), ɵngcc0.ɵɵinject(TreeDataService), ɵngcc0.ɵɵinject(ɵngcc1.TranslateService, 8)); };
ContextMenuExtension.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ContextMenuExtension, factory: ContextMenuExtension.ɵfac });
ContextMenuExtension.ctorParameters = () => [
    { type: ExcelExportService },
    { type: ExportService },
    { type: ExtensionUtility },
    { type: SharedService },
    { type: TreeDataService },
    { type: TranslateService, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ContextMenuExtension, [{
        type: Injectable
    }], function () { return [{ type: ExcelExportService }, { type: ExportService }, { type: ExtensionUtility }, { type: SharedService }, { type: TreeDataService }, { type: ɵngcc1.TranslateService, decorators: [{
                type: Optional
            }] }]; }, null); })();

class DraggableGroupingExtension {
    constructor(extensionUtility, sharedService) {
        this.extensionUtility = extensionUtility;
        this.sharedService = sharedService;
        this._eventHandler = new Slick.EventHandler();
    }
    get eventHandler() {
        return this._eventHandler;
    }
    dispose() {
        // unsubscribe all SlickGrid events
        this._eventHandler.unsubscribeAll();
        if (this._addon && this._addon.destroy) {
            this._addon.destroy();
        }
        this.extensionUtility.nullifyFunctionNameStartingWithOn(this._draggableGroupingOptions);
        this._addon = null;
        this._draggableGroupingOptions = null;
    }
    /**
     * Bind/Create different plugins before the Grid creation.
     * For example the multi-select have to be added to the column definition before the grid is created to work properly
     */
    create(gridOptions) {
        if (gridOptions) {
            if (!this._addon) {
                this._addon = new Slick.DraggableGrouping(gridOptions.draggableGrouping || {});
            }
            return this._addon;
        }
        return null;
    }
    /** Get the instance of the SlickGrid addon (control or plugin). */
    getAddonInstance() {
        return this._addon;
    }
    register() {
        if (this.sharedService && this.sharedService.grid && this.sharedService.gridOptions) {
            this.sharedService.grid.registerPlugin(this._addon);
            // Events
            if (this.sharedService.grid && this.sharedService.gridOptions.draggableGrouping) {
                this._draggableGroupingOptions = this.sharedService.gridOptions.draggableGrouping;
                if (this._draggableGroupingOptions.onExtensionRegistered) {
                    this._draggableGroupingOptions.onExtensionRegistered(this._addon);
                }
                this._eventHandler.subscribe(this._addon.onGroupChanged, (e, args) => {
                    if (this._draggableGroupingOptions && typeof this._draggableGroupingOptions.onGroupChanged === 'function') {
                        this._draggableGroupingOptions.onGroupChanged(e, args);
                    }
                });
            }
            return this._addon;
        }
        return null;
    }
}
DraggableGroupingExtension.ɵfac = function DraggableGroupingExtension_Factory(t) { return new (t || DraggableGroupingExtension)(ɵngcc0.ɵɵinject(ExtensionUtility), ɵngcc0.ɵɵinject(SharedService)); };
DraggableGroupingExtension.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: DraggableGroupingExtension, factory: DraggableGroupingExtension.ɵfac });
DraggableGroupingExtension.ctorParameters = () => [
    { type: ExtensionUtility },
    { type: SharedService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DraggableGroupingExtension, [{
        type: Injectable
    }], function () { return [{ type: ExtensionUtility }, { type: SharedService }]; }, null); })();

/**
 * Compare 2 objects,
 * we will loop through all properties of the object to compare the entire content of both objects
 * Optionally we can compare by a property key, when that is provided we will compare the object content
 * @param o1
 * @param o2
 * @param compareKey optional
 * @return boolean are objects equals?
 */
function compareObjects(o1, o2, compareKey) {
    // if user provided an object compare key then compare directly both objects by that key
    if (compareKey && ((o1 && o1.hasOwnProperty(compareKey)) || (o2 && o2.hasOwnProperty(compareKey)))) {
        return o1[compareKey] === o2 || o1 === o2[compareKey] || o1[compareKey] === o2[compareKey];
    }
    // loop through all object properties to compare the full content of the object
    // we'll return false as soon as a difference is detected
    for (const p in o1) {
        if (o1.hasOwnProperty(p)) {
            if (o1[p] !== o2[p]) {
                return false;
            }
        }
    }
    return true;
}
/** Simple check to see if the given Operator is meant to be used with a collection check */
function isCollectionOperator(operator) {
    const inputOperator = operator && operator.toUpperCase() || '';
    switch (inputOperator) {
        case 'IN':
        case 'NIN':
        case 'NOT_IN':
        case 'IN_CONTAINS':
        case 'NIN_CONTAINS':
        case 'NOT_IN_CONTAINS':
        case 'IN_COLLECTION':
        case 'NOT_IN_COLLECTION':
            return true;
        default:
            return false;
    }
}
/** Execute the test on the filter condition given an operator and both values, returns a boolean */
const testFilterCondition = (operator, value1, value2) => {
    switch (operator.toUpperCase()) {
        case '<':
        case 'LT':
            return (value1 < value2);
        case '<=':
        case 'LE':
            return (value1 <= value2);
        case '>':
        case 'GT':
            return (value1 > value2);
        case '>=':
        case 'GE':
            return (value1 >= value2);
        case '!=':
        case '<>':
        case 'NE':
            return (value1 !== value2);
        case '=':
        case '==':
        case 'EQ':
            return (value1 === value2);
        case 'IN':
            return ((value2 && Array.isArray(value2)) ? (value2.includes(value1)) : false);
        case 'NIN':
        case 'NOT_IN':
            return ((value2 && Array.isArray(value2)) ? (!value2.includes(value1)) : false);
        case 'IN_CONTAINS':
            if (value2 && Array.isArray(value2) && typeof value1 === 'string') {
                return value2.some(item => value1.split(/[,]+/).map(val => (val.trim())).includes(item));
            }
            return false;
        case 'NIN_CONTAINS':
        case 'NOT_IN_CONTAINS':
            if (value2 && Array.isArray(value2) && typeof value1 === 'string') {
                return !value2.some(item => value1.split(/[\s,]+/).map(val => (val.trim())).includes(item));
            }
            return false;
        case 'IN_COLLECTION':
            if (value1 && value2 && Array.isArray(value1) && Array.isArray(value2)) {
                return value2.some(item => value1.includes(item));
            }
            return false;
        case 'NOT_IN_COLLECTION':
            if (value1 && value2 && Array.isArray(value1) && Array.isArray(value2)) {
                return !value2.some(item => value1.includes(item));
            }
            return false;
    }
    return true;
};

/** Execute filter condition check on each cell */
const executeStringFilterCondition = ((options, parsedSearchValues) => {
    let [searchValue1, searchValue2] = parsedSearchValues;
    if (searchValue1 === undefined && !options.operator) {
        return true;
    }
    // make sure the cell value is a string by casting it when possible
    options.cellValue = (options.cellValue === undefined || options.cellValue === null) ? '' : options.cellValue.toString();
    // make both the cell value and search value lower for case insensitive comparison
    const cellValue = options.cellValue.toLowerCase();
    if (typeof searchValue1 === 'string') {
        searchValue1 = searchValue1.toLowerCase();
    }
    if (typeof searchValue2 === 'string') {
        searchValue2 = searchValue2.toLowerCase();
    }
    if (searchValue1 !== undefined && searchValue2 !== undefined) {
        let operator = options && options.operator || options.defaultFilterRangeOperator;
        if (operator !== OperatorType.rangeInclusive && operator !== OperatorType.rangeExclusive) {
            operator = options.defaultFilterRangeOperator;
        }
        const isInclusive = operator === OperatorType.rangeInclusive;
        const searchResult1 = testStringCondition((isInclusive ? '>=' : '>'), cellValue, searchValue1, options.searchInputLastChar);
        const searchResult2 = testStringCondition((isInclusive ? '<=' : '<'), cellValue, searchValue2, options.searchInputLastChar);
        return searchResult1 && searchResult2;
    }
    const searchResult1 = testStringCondition(options.operator, cellValue, searchValue1, options.searchInputLastChar);
    return searchResult1;
});
/**
 * From our search filter value(s), get the parsed value(s).
 * This is called only once per filter before running the actual filter condition check on each cell
 */
function getFilterParsedText(inputSearchTerms) {
    const defaultSearchTerm = ''; // when nothing is provided, we'll default to 0
    const searchTerms = Array.isArray(inputSearchTerms) && inputSearchTerms || [defaultSearchTerm];
    const parsedSearchValues = [];
    let searchValue1;
    let searchValue2;
    if (searchTerms.length === 2 || (typeof searchTerms[0] === 'string' && searchTerms[0].indexOf('..') > 0)) {
        const searchValues = (searchTerms.length === 2) ? searchTerms : searchTerms[0].split('..');
        searchValue1 = `${Array.isArray(searchValues) ? searchValues[0] : ''}`;
        searchValue2 = `${Array.isArray(searchValues) ? searchValues[1] : ''}`;
    }
    else {
        const parsedSearchValue = (Array.isArray(inputSearchTerms) && inputSearchTerms.length > 0) ? inputSearchTerms[0] : '';
        searchValue1 = parsedSearchValue === undefined || parsedSearchValue === null ? '' : `${parsedSearchValue}`; // make sure it's a string
    }
    if (searchValue1 !== undefined && searchValue2 !== undefined) {
        parsedSearchValues.push(searchValue1, searchValue2);
    }
    else if (searchValue1 !== undefined) {
        parsedSearchValues.push(searchValue1);
    }
    return parsedSearchValues;
}
/** Execute the filter string test condition, returns a boolean */
function testStringCondition(operator, cellValue, searchValue, searchInputLastChar) {
    if (operator === '*' || operator === OperatorType.endsWith || operator === '*z') {
        return cellValue.endsWith(searchValue);
    }
    else if ((operator === '' && searchInputLastChar === '*') || operator === OperatorType.startsWith || operator === 'a*') {
        return cellValue.startsWith(searchValue);
    }
    else if (operator === '' || operator === OperatorType.contains) {
        return (cellValue.indexOf(searchValue) > -1);
    }
    else if (operator === '<>' || operator === OperatorType.notContains) {
        return (cellValue.indexOf(searchValue) === -1);
    }
    return testFilterCondition(operator || '==', cellValue, searchValue);
}

/** Execute filter condition check on each cell */
const executeObjectFilterCondition = ((options, parsedSearchValue) => {
    if (parsedSearchValue === undefined && !options.operator) {
        return true;
    }
    const operator = (options.operator || '').toUpperCase();
    switch (operator) {
        case '!=':
        case '<>':
        case 'NE':
            return !compareObjects(options.cellValue, parsedSearchValue, options.dataKey);
        case '=':
        case '==':
        case 'EQ':
        default:
            return compareObjects(options.cellValue, parsedSearchValue, options.dataKey);
    }
});
/**
 * From our search filter value(s), get the parsed value(s).
 * This is called only once per filter before running the actual filter condition check on each cell
 */
function getFilterParsedObjectResult(inputSearchTerms) {
    const parsedSearchValue = (Array.isArray(inputSearchTerms) && inputSearchTerms.length > 0) ? inputSearchTerms[0] : '';
    return parsedSearchValue || '';
}

/** Execute filter condition check on each cell */
const executeNumberFilterCondition = ((options, parsedSearchValues) => {
    const cellValue = parseFloat(options.cellValue);
    const [searchValue1, searchValue2] = parsedSearchValues;
    if (searchValue1 === undefined && !options.operator) {
        return true;
    }
    if (searchValue1 !== undefined && searchValue2 !== undefined) {
        let operator = options && options.operator || options.defaultFilterRangeOperator;
        if (operator !== OperatorType.rangeInclusive && operator !== OperatorType.rangeExclusive) {
            operator = options.defaultFilterRangeOperator;
        }
        const isInclusive = operator === OperatorType.rangeInclusive;
        const resultCondition1 = testFilterCondition((isInclusive ? '>=' : '>'), cellValue, +searchValue1);
        const resultCondition2 = testFilterCondition((isInclusive ? '<=' : '<'), cellValue, +searchValue2);
        return (resultCondition1 && resultCondition2);
    }
    return testFilterCondition(options.operator || '==', cellValue, +searchValue1);
});
/**
 * From our search filter value(s), get the parsed value(s).
 * This is called only once per filter before running the actual filter condition check on each cell
 */
function getFilterParsedNumbers(inputSearchTerms) {
    const defaultSearchTerm = 0; // when nothing is provided, we'll default to 0
    const searchTerms = Array.isArray(inputSearchTerms) && inputSearchTerms || [defaultSearchTerm];
    const parsedSearchValues = [];
    let searchValue1;
    let searchValue2;
    if (searchTerms.length === 2 || (typeof searchTerms[0] === 'string' && searchTerms[0].indexOf('..') > 0)) {
        const searchValues = (searchTerms.length === 2) ? searchTerms : searchTerms[0].split('..');
        searchValue1 = parseFloat(Array.isArray(searchValues) ? searchValues[0] : '');
        searchValue2 = parseFloat(Array.isArray(searchValues) ? searchValues[1] : '');
    }
    else {
        searchValue1 = parseFloat(searchTerms[0]);
    }
    if (isNumber(searchValue1, true) && isNumber(searchValue2, true)) {
        parsedSearchValues.push(searchValue1, searchValue2);
    }
    else if (isNumber(searchValue1, true)) {
        parsedSearchValues.push(searchValue1);
    }
    return parsedSearchValues;
}

/** Execute filter condition check on each cell */
const executeBooleanFilterCondition = ((options, parsedSearchValue) => {
    return parseBoolean(options.cellValue) === parseBoolean(parsedSearchValue);
});
/**
 * From our search filter value(s), get the parsed value(s).
 * This is called only once per filter before running the actual filter condition check on each cell
 */
function getFilterParsedBoolean(inputSearchTerms) {
    const searchTerm = Array.isArray(inputSearchTerms) && inputSearchTerms[0] || false;
    return parseBoolean(searchTerm);
}

/**
 * Execute filter condition check on each cell.
 * This is used only by the Select Single/Multiple Filter which uses the "multiple-select.js" 3rd party lib which always provide values as strings
 */
const executeCollectionSearchFilterCondition = (options) => {
    // multiple-select will always return text, so we should make our cell values text as well
    const filterOperator = options.operator;
    let cellValue;
    if (Array.isArray(options.cellValue) && (filterOperator === 'IN_COLLECTION' || filterOperator === 'NOT_IN_COLLECTION')) {
        cellValue = (!!options.cellValue.length ? options.cellValue.map(value => `${value}`) : []);
    }
    else {
        cellValue = (options.cellValue === undefined || options.cellValue === null) ? '' : `${options.cellValue}`;
    }
    return testFilterCondition(filterOperator || 'IN', cellValue, options.searchTerms || []);
};

const moment$2 = moment_['default'] || moment_; // patch to fix rollup "moment has no default export" issue, document here https://github.com/rollup/rollup/issues/670
/**
 * Execute Date filter condition check on each cell and use correct date format depending on it's field type (or filterSearchType when that is provided)
 */
function executeDateFilterCondition(options, parsedSearchDates) {
    const filterSearchType = options && (options.filterSearchType || options.fieldType) || FieldType.dateIso;
    const FORMAT = mapMomentDateFormatWithFieldType(filterSearchType);
    const [searchDate1, searchDate2] = parsedSearchDates;
    // cell value in moment format
    const dateCell = moment$2(options.cellValue, FORMAT, true);
    // return when cell value is not a valid date
    if ((!searchDate1 && !searchDate2) || !dateCell.isValid()) {
        return false;
    }
    // when comparing with Dates only (without time), we need to disregard the time portion, we can do so by setting our time to start at midnight
    // ref, see https://stackoverflow.com/a/19699447/1212166
    const dateCellTimestamp = FORMAT.toLowerCase().includes('h') ? dateCell.valueOf() : dateCell.clone().startOf('day').valueOf();
    // having 2 search dates, we assume that it's a date range filtering and we'll compare against both dates
    if (searchDate1 && searchDate2) {
        let operator = options && options.operator || options.defaultFilterRangeOperator;
        if (operator !== OperatorType.rangeInclusive && operator !== OperatorType.rangeExclusive) {
            operator = options.defaultFilterRangeOperator;
        }
        const isInclusive = operator === OperatorType.rangeInclusive;
        const resultCondition1 = testFilterCondition((isInclusive ? '>=' : '>'), dateCellTimestamp, searchDate1.valueOf());
        const resultCondition2 = testFilterCondition((isInclusive ? '<=' : '<'), dateCellTimestamp, searchDate2.valueOf());
        return (resultCondition1 && resultCondition2);
    }
    // comparing against a single search date
    const dateSearchTimestamp1 = FORMAT.toLowerCase().includes('h') ? searchDate1.valueOf() : searchDate1.clone().startOf('day').valueOf();
    return testFilterCondition(options.operator || '==', dateCellTimestamp, dateSearchTimestamp1);
}
/**
 * From our search filter value(s), get the parsed value(s), they are parsed as Moment object(s).
 * This is called only once per filter before running the actual filter condition check on each cell
 */
function getFilterParsedDates(inputSearchTerms, inputFilterSearchType) {
    const searchTerms = Array.isArray(inputSearchTerms) && inputSearchTerms || [];
    const filterSearchType = inputFilterSearchType || FieldType.dateIso;
    const FORMAT = mapMomentDateFormatWithFieldType(filterSearchType);
    const parsedSearchValues = [];
    if (searchTerms.length === 2 || (typeof searchTerms[0] === 'string' && searchTerms[0].indexOf('..') > 0)) {
        const searchValues = (searchTerms.length === 2) ? searchTerms : searchTerms[0].split('..');
        const searchValue1 = (Array.isArray(searchValues) && searchValues[0] || '');
        const searchValue2 = (Array.isArray(searchValues) && searchValues[1] || '');
        const searchDate1 = moment$2(searchValue1, FORMAT, true);
        const searchDate2 = moment$2(searchValue2, FORMAT, true);
        // return if any of the 2 values are invalid dates
        if (!searchDate1.isValid() || !searchDate2.isValid()) {
            return [];
        }
        parsedSearchValues.push(searchDate1, searchDate2);
    }
    else {
        // return if the search term is an invalid date
        const searchDate1 = moment$2(searchTerms[0], FORMAT, true);
        if (!searchDate1.isValid()) {
            return [];
        }
        parsedSearchValues.push(searchDate1);
    }
    return parsedSearchValues;
}

/** Execute mapped condition (per field type) for each cell in the grid */
const executeFilterConditionTest = (options, parsedSearchTerms) => {
    // when using a multi-select ('IN' operator) we will not use the field type but instead go directly with a collection search
    if (isCollectionOperator(options.operator)) {
        return executeCollectionSearchFilterCondition(options);
    }
    // From a more specific field type (dateIso, dateEuro, text, readonly, ...), get the more generalized type (boolean, date, number, object, text)
    const generalizedType = getVarTypeOfByColumnFieldType(options.filterSearchType || options.fieldType);
    // execute the mapped type, or default to String condition check
    switch (generalizedType) {
        case 'boolean':
            // the parsedSearchTerms should be single value (result came from getFilterParsedBoolean() method)
            return executeBooleanFilterCondition(options, parsedSearchTerms);
        case 'date':
            return executeDateFilterCondition(options, (parsedSearchTerms || []));
        case 'number':
            return executeNumberFilterCondition(options, (parsedSearchTerms || []));
        case 'object':
            // the parsedSearchTerms should be single value (result came from getFilterParsedObjectResult() method)
            return executeObjectFilterCondition(options, parsedSearchTerms);
        case 'string':
        default:
            // the parsedSearchTerms should be single value (result came from getFilterParsedText() method)
            return executeStringFilterCondition(options, (parsedSearchTerms || []));
    }
};
/**
 * From our search filter value(s), get their parsed value(s), for example a "dateIso" filter will be parsed as Moment object.
 * Then later when we execute the filtering checks, we won't need to re-parse all search value(s) again and again.
 * So this is called only once, for each search filter that is, prior to running the actual filter condition checks on each cell afterward.
 */
function getParsedSearchTermsByFieldType(inputSearchTerms, inputFilterSearchType) {
    const generalizedType = getVarTypeOfByColumnFieldType(inputFilterSearchType);
    let parsedSearchValues;
    // parse the search value(s), the Date & Numbers could be in a range and so we will return an array for them
    // any other type will return a single search value
    switch (generalizedType) {
        case 'boolean':
            parsedSearchValues = getFilterParsedBoolean(inputSearchTerms);
            break;
        case 'date':
            parsedSearchValues = getFilterParsedDates(inputSearchTerms, inputFilterSearchType);
            break;
        case 'number':
            parsedSearchValues = getFilterParsedNumbers(inputSearchTerms);
            break;
        case 'object':
            parsedSearchValues = getFilterParsedObjectResult(inputSearchTerms);
            break;
        case 'string':
            parsedSearchValues = getFilterParsedText(inputSearchTerms);
            break;
    }
    return parsedSearchValues;
}
/**
 * From a more specific field type, let's return a simple and more general type (boolean, date, number, object, text)
 * @param fieldType - specific field type
 * @returns generalType - general field type
 */
function getVarTypeOfByColumnFieldType(fieldType) {
    // return general field type
    switch (fieldType) {
        case FieldType.boolean:
            return 'boolean';
        case FieldType.date:
        case FieldType.dateIso:
        case FieldType.dateUtc:
        case FieldType.dateTime:
        case FieldType.dateTimeIso:
        case FieldType.dateTimeIsoAmPm:
        case FieldType.dateTimeIsoAM_PM:
        case FieldType.dateTimeShortIso:
        case FieldType.dateEuro:
        case FieldType.dateEuroShort:
        case FieldType.dateTimeShortEuro:
        case FieldType.dateTimeEuro:
        case FieldType.dateTimeEuroAmPm:
        case FieldType.dateTimeEuroAM_PM:
        case FieldType.dateTimeEuroShort:
        case FieldType.dateTimeEuroShortAmPm:
        case FieldType.dateTimeEuroShortAM_PM:
        case FieldType.dateUs:
        case FieldType.dateUsShort:
        case FieldType.dateTimeShortUs:
        case FieldType.dateTimeUs:
        case FieldType.dateTimeUsAmPm:
        case FieldType.dateTimeUsAM_PM:
        case FieldType.dateTimeUsShort:
        case FieldType.dateTimeUsShortAmPm:
        case FieldType.dateTimeUsShortAM_PM:
            return 'date';
        case FieldType.integer:
        case FieldType.float:
        case FieldType.number:
            return 'number';
        case FieldType.object:
            return 'object';
        case FieldType.string:
        case FieldType.text:
        case FieldType.password:
        case FieldType.readonly:
        default:
            return 'string';
    }
}

const FilterConditions = {
    executeFilterConditionTest,
    booleanFilter: executeBooleanFilterCondition,
    collectionSearchFilter: executeCollectionSearchFilterCondition,
    numberFilter: executeNumberFilterCondition,
    stringFilter: executeStringFilterCondition,
    testFilter: testFilterCondition
};

const DOMPurify$5 = DOMPurify_; // patch to fix rollup to work
class AutoCompleteFilter {
    /**
     * Initialize the Filter
     */
    constructor(translate, collectionService) {
        this.translate = translate;
        this.collectionService = collectionService;
        this._clearFilterTriggered = false;
        this._collection = [];
        this._shouldTriggerQuery = true;
        this.searchTerms = [];
        this.isFilled = false;
        /** The property name for values in the collection */
        this.valueName = 'label';
        this.enableTranslateLabel = false;
        this.subscriptions = [];
    }
    /** Getter for the Autocomplete Option */
    get autoCompleteOptions() {
        return this._autoCompleteOptions || {};
    }
    /** Getter for the Collection Options */
    get collectionOptions() {
        return this.columnDef && this.columnDef.filter && this.columnDef.filter.collectionOptions || {};
    }
    /** Getter for the Collection Used by the Filter */
    get collection() {
        return this._collection;
    }
    /** Getter for the Column Filter */
    get columnFilter() {
        return this.columnDef && this.columnDef.filter || {};
    }
    /** Get the Editor DOM Element */
    get filterDomElement() {
        return this.$filterElm;
    }
    get filterOptions() {
        return this.columnFilter && this.columnFilter.filterOptions || {};
    }
    /** Getter for the Custom Structure if exist */
    get customStructure() {
        let customStructure = this.columnFilter && this.columnFilter.customStructure;
        const columnType = this.columnFilter && this.columnFilter.type || this.columnDef && this.columnDef.type;
        if (!customStructure && (columnType === FieldType.object && this.columnDef && this.columnDef.dataKey && this.columnDef.labelKey)) {
            customStructure = {
                label: this.columnDef.labelKey,
                value: this.columnDef.dataKey,
            };
        }
        return customStructure;
    }
    /** Getter to know what would be the default operator when none is specified */
    get defaultOperator() {
        return OperatorType.equal;
    }
    /** Getter for the Grid Options pulled through the Grid Object */
    get gridOptions() {
        return (this.grid && this.grid.getOptions) ? this.grid.getOptions() : {};
    }
    /** jQuery UI AutoComplete instance */
    get instance() {
        return this.$filterElm.autocomplete('instance');
    }
    /** Getter of the Operator to use when doing the filter comparing */
    get operator() {
        return this.columnFilter && this.columnFilter.operator || this.defaultOperator;
    }
    /** Setter for the filter operator */
    set operator(operator) {
        if (this.columnFilter) {
            this.columnFilter.operator = operator;
        }
    }
    /**
     * Initialize the filter template
     */
    init(args) {
        if (!args) {
            throw new Error('[Angular-SlickGrid] A filter must always have an "init()" with valid arguments.');
        }
        this.grid = args.grid;
        this.callback = args.callback;
        this.columnDef = args.columnDef;
        this.searchTerms = (args.hasOwnProperty('searchTerms') ? args.searchTerms : []) || [];
        if (!this.grid || !this.columnDef || !this.columnFilter || (!this.columnFilter.collection && !this.columnFilter.collectionAsync && !this.columnFilter.filterOptions)) {
            throw new Error(`[Angular-SlickGrid] You need to pass a "collection" (or "collectionAsync") for the AutoComplete Filter to work correctly. Also each option should include a value/label pair (or value/labelKey when using Locale). For example:: { filter: model: Filters.autoComplete, collection: [{ value: true, label: 'True' }, { value: false, label: 'False'}] }`);
        }
        this.enableTranslateLabel = this.columnFilter && this.columnFilter.enableTranslateLabel || false;
        this.labelName = this.customStructure && this.customStructure.label || 'label';
        this.valueName = this.customStructure && this.customStructure.value || 'value';
        this.labelPrefixName = this.customStructure && this.customStructure.labelPrefix || 'labelPrefix';
        this.labelSuffixName = this.customStructure && this.customStructure.labelSuffix || 'labelSuffix';
        // always render the DOM element, even if user passed a "collectionAsync",
        const newCollection = this.columnFilter.collection || [];
        this._collection = newCollection;
        this.renderDomElement(newCollection);
        // on every Filter which have a "collection" or a "collectionAsync"
        // we will add (or replace) a Subject to the "collectionAsync" property so that user has possibility to change the collection
        // if "collectionAsync" is already set by the user, it will resolve it first then after it will replace it with a Subject
        const collectionAsync = this.columnFilter && this.columnFilter.collectionAsync;
        if (collectionAsync) {
            return this.renderOptionsAsync(collectionAsync); // create Subject after resolve (createCollectionAsyncSubject)
        }
        else {
            return new Promise((resolve) => resolve(true));
        }
    }
    /**
     * Clear the filter value
     */
    clear(shouldTriggerQuery = true) {
        if (this.$filterElm) {
            this._clearFilterTriggered = true;
            this._shouldTriggerQuery = shouldTriggerQuery;
            this.searchTerms = [];
            this.$filterElm.val('');
            this.$filterElm.trigger('input');
        }
    }
    /**
     * destroy the filter
     */
    destroy() {
        // also unsubscribe all RxJS subscriptions
        this.subscriptions = unsubscribeAllObservables(this.subscriptions);
        if (this.$filterElm) {
            this.$filterElm.off('input').remove();
        }
        this.$filterElm = null;
        this._collection = null;
    }
    /** Set value(s) on the DOM element */
    setValues(values, operator) {
        if (values) {
            this.$filterElm.val(values);
        }
        // set the operator when defined
        this.operator = operator || this.defaultOperator;
    }
    //
    // protected functions
    // ------------------
    /**
     * user might want to filter certain items of the collection
     * @param inputCollection
     * @return outputCollection filtered and/or sorted collection
     */
    filterCollection(inputCollection) {
        let outputCollection = inputCollection;
        // user might want to filter certain items of the collection
        if (this.columnFilter && this.columnFilter.collectionFilterBy) {
            const filterBy = this.columnFilter.collectionFilterBy;
            const filterCollectionBy = this.columnFilter.collectionOptions && this.columnFilter.collectionOptions.filterResultAfterEachPass || null;
            outputCollection = this.collectionService.filterCollection(outputCollection, filterBy, filterCollectionBy);
        }
        return outputCollection;
    }
    /**
     * user might want to sort the collection in a certain way
     * @param inputCollection
     * @return outputCollection filtered and/or sorted collection
     */
    sortCollection(inputCollection) {
        let outputCollection = inputCollection;
        // user might want to sort the collection
        if (this.columnFilter && this.columnFilter.collectionSortBy) {
            const sortBy = this.columnFilter.collectionSortBy;
            outputCollection = this.collectionService.sortCollection(this.columnDef, outputCollection, sortBy, this.enableTranslateLabel);
        }
        return outputCollection;
    }
    renderOptionsAsync(collectionAsync) {
        return __awaiter(this, void 0, void 0, function* () {
            if (collectionAsync) {
                const awaitedCollection = yield castToPromise(collectionAsync);
                this.renderDomElementFromCollectionAsync(awaitedCollection);
                // because we accept Promises & HttpClient Observable only execute once
                // we will re-create an RxJs Subject which will replace the "collectionAsync" which got executed once anyway
                // doing this provide the user a way to call a "collectionAsync.next()"
                this.createCollectionAsyncSubject();
            }
            return true;
        });
    }
    /** Create or recreate an Observable Subject and reassign it to the "collectionAsync" object so user can call a "collectionAsync.next()" on it */
    createCollectionAsyncSubject() {
        const newCollectionAsync = new Subject();
        this.columnFilter.collectionAsync = newCollectionAsync;
        this.subscriptions.push(newCollectionAsync.subscribe(collection => this.renderDomElementFromCollectionAsync(collection)));
    }
    /**
     * When user use a CollectionAsync we will use the returned collection to render the filter DOM element
     * and reinitialize filter collection with this new collection
     */
    renderDomElementFromCollectionAsync(collection) {
        this._collection = collection;
        if (this.collectionOptions && (this.collectionOptions.collectionInsideObjectProperty || this.collectionOptions.collectionInObjectProperty)) {
            const collectionInsideObjectProperty = this.collectionOptions.collectionInsideObjectProperty || this.collectionOptions.collectionInObjectProperty;
            collection = getDescendantProperty(collection, collectionInsideObjectProperty);
        }
        if (!Array.isArray(collection)) {
            throw new Error('Something went wrong while trying to pull the collection from the "collectionAsync" call in the AutoComplete Filter, the collection is not a valid array.');
        }
        // copy over the array received from the async call to the "collection" as the new collection to use
        // this has to be BEFORE the `collectionObserver().subscribe` to avoid going into an infinite loop
        this.columnFilter.collection = collection;
        // recreate Filter DOM element after getting async collection
        this.renderDomElement(collection);
    }
    renderDomElement(collection) {
        if (!Array.isArray(collection) && this.collectionOptions && (this.collectionOptions.collectionInsideObjectProperty || this.collectionOptions.collectionInObjectProperty)) {
            const collectionInsideObjectProperty = this.collectionOptions.collectionInsideObjectProperty || this.collectionOptions.collectionInObjectProperty;
            collection = getDescendantProperty(collection, collectionInsideObjectProperty);
        }
        if (!Array.isArray(collection)) {
            throw new Error('The "collection" passed to the Autocomplete Filter is not a valid array.');
        }
        // assign the collection to a temp variable before filtering/sorting the collection
        let newCollection = collection;
        // user might want to filter and/or sort certain items of the collection
        newCollection = this.filterCollection(newCollection);
        newCollection = this.sortCollection(newCollection);
        // filter input can only have 1 search term, so we will use the 1st array index if it exist
        const searchTerm = (Array.isArray(this.searchTerms) && this.searchTerms.length >= 0) ? this.searchTerms[0] : '';
        // step 1, create HTML string template
        const filterTemplate = this.buildTemplateHtmlString();
        // step 2, create the DOM Element of the filter & pre-load search term
        // also subscribe to the onSelect event
        this._collection = newCollection;
        this.$filterElm = this.createDomElement(filterTemplate, newCollection, searchTerm);
        // step 3, subscribe to the input change event and run the callback when that happens
        // also add/remove "filled" class for styling purposes
        this.$filterElm.on('input', (e) => {
            let value = e && e.target && e.target.value || '';
            const enableWhiteSpaceTrim = this.gridOptions.enableFilterTrimWhiteSpace || this.columnFilter.enableTrimWhiteSpace;
            if (typeof value === 'string' && enableWhiteSpaceTrim) {
                value = value.trim();
            }
            if (this._clearFilterTriggered) {
                this.callback(e, { columnDef: this.columnDef, clearFilterTriggered: this._clearFilterTriggered, shouldTriggerQuery: this._shouldTriggerQuery });
                this.$filterElm.removeClass('filled');
            }
            else {
                value === '' ? this.$filterElm.removeClass('filled') : this.$filterElm.addClass('filled');
                this.callback(e, { columnDef: this.columnDef, operator: this.operator, searchTerms: [value], shouldTriggerQuery: this._shouldTriggerQuery });
            }
            // reset both flags for next use
            this._clearFilterTriggered = false;
            this._shouldTriggerQuery = true;
        });
    }
    /**
     * Create the HTML template as a string
     */
    buildTemplateHtmlString() {
        const columnId = this.columnDef && this.columnDef.id;
        let placeholder = (this.gridOptions) ? (this.gridOptions.defaultFilterPlaceholder || '') : '';
        if (this.columnFilter && this.columnFilter.placeholder) {
            placeholder = this.columnFilter.placeholder;
        }
        return `<input type="text" role="presentation" autocomplete="off" class="form-control autocomplete search-filter filter-${columnId}" placeholder="${placeholder}">`;
    }
    /**
     * From the html template string, create a DOM element
     * @param filterTemplate
     */
    createDomElement(filterTemplate, collection, searchTerm) {
        const columnId = this.columnDef && this.columnDef.id;
        const $headerElm = this.grid.getHeaderRowColumn(columnId);
        $($headerElm).empty();
        // create the DOM element & add an ID and filter class
        this.$filterElm = $(filterTemplate);
        const searchTermInput = searchTerm;
        // user might provide his own custom structure
        // jQuery UI autocomplete requires a label/value pair, so we must remap them when user provide different ones
        if (Array.isArray(collection)) {
            collection = collection.map((item) => {
                return { label: item[this.labelName], value: item[this.valueName], labelPrefix: item[this.labelPrefixName] || '', labelSuffix: item[this.labelSuffixName] || '' };
            });
        }
        // user might pass his own autocomplete options
        const autoCompleteOptions = this.filterOptions;
        // when user passes it's own autocomplete options
        // we still need to provide our own "select" callback implementation
        if (autoCompleteOptions && autoCompleteOptions.source) {
            autoCompleteOptions.select = (event, ui) => this.onSelect(event, ui);
            this._autoCompleteOptions = Object.assign({}, autoCompleteOptions);
            // when renderItem is defined, we need to add our custom style CSS class
            if (this._autoCompleteOptions.renderItem) {
                this._autoCompleteOptions.classes = {
                    'ui-autocomplete': `autocomplete-custom-${toKebabCase(this._autoCompleteOptions.renderItem.layout)}`
                };
            }
            // create the jQueryUI AutoComplete
            this.$filterElm.autocomplete(this._autoCompleteOptions);
            // when "renderItem" is defined, we need to call the user's custom renderItem template callback
            if (this._autoCompleteOptions.renderItem) {
                this.$filterElm.autocomplete('instance')._renderItem = this.renderCustomItem.bind(this);
            }
        }
        else {
            const definedOptions = {
                minLength: 0,
                source: collection,
                select: (event, ui) => this.onSelect(event, ui),
            };
            this._autoCompleteOptions = Object.assign(Object.assign({}, definedOptions), this.filterOptions);
            this.$filterElm.autocomplete(this._autoCompleteOptions);
            // we'll use our own renderer so that it works with label prefix/suffix and also with html rendering when enabled
            this.$filterElm.autocomplete('instance')._renderItem = this.renderCollectionItem.bind(this);
        }
        this.$filterElm.val(searchTermInput);
        this.$filterElm.data('columnId', columnId);
        // if there's a search term, we will add the "filled" class for styling purposes
        if (searchTerm) {
            this.$filterElm.addClass('filled');
        }
        // append the new DOM element to the header row
        if (this.$filterElm && typeof this.$filterElm.appendTo === 'function') {
            const $container = $(`<div class="autocomplete-container"></div>`);
            $container.appendTo($headerElm);
            this.$filterElm.appendTo($container);
            // add a <span> in order to add spinner styling
            $(`<span></span>`).appendTo($container);
        }
        // we could optionally trigger a search when clicking on the AutoComplete
        if (this.filterOptions.openSearchListOnFocus) {
            this.$filterElm.click(() => this.$filterElm.autocomplete('search', this.$filterElm.val()));
        }
        // user might override any of the jQueryUI callback methods
        if (this.columnFilter.callbacks) {
            for (const callback of Object.keys(this.columnFilter.callbacks)) {
                if (typeof this.columnFilter.callbacks[callback] === 'function') {
                    this.$filterElm.autocomplete('instance')[callback] = this.columnFilter.callbacks[callback];
                }
            }
        }
        return this.$filterElm;
    }
    //
    // protected functions
    // ------------------
    // this function should be protected but for unit tests purposes we'll make it public until a better solution is found
    // a better solution would be to get the autocomplete DOM element to work with selection but I couldn't find how to do that in Jest
    onSelect(event, ui) {
        if (ui && ui.item) {
            const item = ui.item;
            // when the user defines a "renderItem" (or "_renderItem") template, then we assume the user defines his own custom structure of label/value pair
            // otherwise we know that jQueryUI always require a label/value pair, we can pull them directly
            const hasCustomRenderItemCallback = this.columnFilter && this.columnFilter.callbacks && this.columnFilter.callbacks.hasOwnProperty('_renderItem') || (this.columnFilter && this.columnFilter.filterOptions && this.columnFilter.filterOptions.renderItem) || false;
            const itemLabel = typeof item === 'string' ? item : (hasCustomRenderItemCallback ? item[this.labelName] : item.label);
            const itemValue = typeof item === 'string' ? item : (hasCustomRenderItemCallback ? item[this.valueName] : item.value);
            this.setValues(itemLabel);
            itemValue === '' ? this.$filterElm.removeClass('filled') : this.$filterElm.addClass('filled');
            this.callback(event, { columnDef: this.columnDef, operator: this.operator, searchTerms: [itemValue], shouldTriggerQuery: this._shouldTriggerQuery });
            // reset both flags for next use
            this._clearFilterTriggered = false;
            this._shouldTriggerQuery = true;
        }
        return false;
    }
    renderCustomItem(ul, item) {
        const templateString = this._autoCompleteOptions && this._autoCompleteOptions.renderItem && this._autoCompleteOptions.renderItem.templateCallback(item) || '';
        // sanitize any unauthorized html tags like script and others
        // for the remaining allowed tags we'll permit all attributes
        const sanitizedTemplateText = (DOMPurify$5.sanitize(templateString, {}) || '').toString();
        return $('<li></li>')
            .data('item.autocomplete', item)
            .append(sanitizedTemplateText)
            .appendTo(ul);
    }
    renderCollectionItem(ul, item) {
        const isRenderHtmlEnabled = this.columnFilter && this.columnFilter.enableRenderHtml || false;
        const prefixText = item.labelPrefix || '';
        const labelText = item.label || '';
        const suffixText = item.labelSuffix || '';
        const finalText = prefixText + labelText + suffixText;
        // sanitize any unauthorized html tags like script and others
        // for the remaining allowed tags we'll permit all attributes
        const sanitizedText = (DOMPurify$5.sanitize(finalText, {}) || '').toString();
        const $liDiv = $('<div></div>')[isRenderHtmlEnabled ? 'html' : 'text'](sanitizedText);
        return $('<li></li>')
            .data('item.autocomplete', item)
            .append($liDiv)
            .appendTo(ul);
    }
}
AutoCompleteFilter.ɵfac = function AutoCompleteFilter_Factory(t) { return new (t || AutoCompleteFilter)(ɵngcc0.ɵɵinject(ɵngcc1.TranslateService), ɵngcc0.ɵɵinject(CollectionService)); };
AutoCompleteFilter.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AutoCompleteFilter, factory: AutoCompleteFilter.ɵfac });
AutoCompleteFilter.ctorParameters = () => [
    { type: TranslateService },
    { type: CollectionService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AutoCompleteFilter, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.TranslateService }, { type: CollectionService }]; }, null); })();

/**
 * Create and return a select dropdown HTML element with a list of Operators with descriptions
 * @param {Array<Object>} optionValues - list of operators and their descriptions
 * @returns {Object} selectElm - Select Dropdown HTML Element
 */
function buildSelectOperator(optionValues) {
    const selectElm = document.createElement('select');
    selectElm.className = 'form-control';
    for (const option of optionValues) {
        const selectOption = document.createElement('option');
        selectOption.value = option.operator;
        selectOption.innerHTML = `${htmlEncodedStringWithPadding(option.operator, 3)}${option.description}`;
        selectElm.appendChild(selectOption);
    }
    return selectElm;
}

const flatpickr$2 = (flatpickr_ && flatpickr_['default'] || flatpickr_); // patch for rollup
class CompoundDateFilter {
    constructor(translate) {
        this.translate = translate;
        this._clearFilterTriggered = false;
        this._shouldTriggerQuery = true;
        this.searchTerms = [];
        this._bindEventService = new BindingEventService();
    }
    /** Getter for the Grid Options pulled through the Grid Object */
    get gridOptions() {
        return (this.grid && this.grid.getOptions) ? this.grid.getOptions() : {};
    }
    /** Getter for the Filter Operator */
    get columnFilter() {
        return this.columnDef && this.columnDef.filter || {};
    }
    /** Getter for the Current Dates selected */
    get currentDate() {
        return this._currentDate;
    }
    /** Getter to know what would be the default operator when none is specified */
    get defaultOperator() {
        return OperatorType.empty;
    }
    /** Getter for the Flatpickr Options */
    get flatpickrOptions() {
        return this._flatpickrOptions || {};
    }
    /** Getter for the single Locale texts provided by the user in main file or else use default English locales via the Constants */
    get locales() {
        return this.gridOptions.locales || Constants.locales;
    }
    /** Getter for the Filter Operator */
    get operator() {
        return this._operator || this.columnFilter.operator || this.defaultOperator;
    }
    /** Setter for the Filter Operator */
    set operator(op) {
        this._operator = op;
    }
    /**
     * Initialize the Filter
     */
    init(args) {
        if (!args) {
            throw new Error('[Angular-SlickGrid] A filter must always have an "init()" with valid arguments.');
        }
        this.grid = args.grid;
        this.callback = args.callback;
        this.columnDef = args.columnDef;
        this.operator = args.operator || '';
        this.searchTerms = (args.hasOwnProperty('searchTerms') ? args.searchTerms : []) || [];
        // date input can only have 1 search term, so we will use the 1st array index if it exist
        const searchTerm = (Array.isArray(this.searchTerms) && this.searchTerms.length >= 0) ? this.searchTerms[0] : '';
        // step 1, create the DOM Element of the filter which contain the compound Operator+Input
        // and initialize it if searchTerm is filled
        this._filterElm = this.createDomElement(searchTerm);
        // step 3, subscribe to the keyup event and run the callback when that happens
        // also add/remove "filled" class for styling purposes
        this._bindEventService.bind(this._filterDivInputElm, 'keyup', this.onTriggerEvent.bind(this));
        this._bindEventService.bind(this._selectOperatorElm, 'change', this.onTriggerEvent.bind(this));
    }
    /**
     * Clear the filter value
     */
    clear(shouldTriggerQuery = true) {
        if (this.flatInstance && this._selectOperatorElm) {
            this._clearFilterTriggered = true;
            this._shouldTriggerQuery = shouldTriggerQuery;
            this.searchTerms = [];
            this._selectOperatorElm.selectedIndex = 0;
            this.flatInstance.clear();
        }
    }
    /**
     * destroy the filter
     */
    destroy() {
        var _a, _b, _c, _d;
        this._bindEventService.unbindAll();
        if (this.flatInstance && typeof this.flatInstance.destroy === 'function') {
            this.flatInstance.destroy();
            if (this.flatInstance.element) {
                destroyObjectDomElementProps(this.flatInstance);
            }
        }
        (_b = (_a = this._filterElm) === null || _a === void 0 ? void 0 : _a.remove) === null || _b === void 0 ? void 0 : _b.call(_a);
        (_d = (_c = this._selectOperatorElm) === null || _c === void 0 ? void 0 : _c.remove) === null || _d === void 0 ? void 0 : _d.call(_c);
    }
    hide() {
        if (this.flatInstance && typeof this.flatInstance.close === 'function') {
            this.flatInstance.close();
        }
    }
    show() {
        if (this.flatInstance && typeof this.flatInstance.open === 'function') {
            this.flatInstance.open();
        }
    }
    /** Set value(s) in the DOM element, we can optionally pass an operator and/or trigger a change event */
    setValues(values, operator) {
        if (this.flatInstance && values) {
            const newValue = Array.isArray(values) ? values[0] : values;
            this._currentDate = newValue;
            this.flatInstance.setDate(newValue);
        }
        // set the operator, in the DOM as well, when defined
        this.operator = operator || this.defaultOperator;
        if (operator && this._selectOperatorElm) {
            const operatorShorthand = mapOperatorToShorthandDesignation(this.operator);
            this._selectOperatorElm.value = operatorShorthand;
        }
    }
    //
    // protected functions
    // ------------------
    buildDatePickerInput(searchTerm) {
        const inputFormat = mapFlatpickrDateFormatWithFieldType(this.columnFilter.type || this.columnDef.type || FieldType.dateIso);
        const outputFormat = mapFlatpickrDateFormatWithFieldType(this.columnDef.outputType || this.columnFilter.type || this.columnDef.type || FieldType.dateUtc);
        const userFilterOptions = (this.columnFilter && this.columnFilter.filterOptions || {});
        // get current locale, if user defined a custom locale just use or get it the Translate Service if it exist else just use English
        let currentLocale = (userFilterOptions && userFilterOptions.locale) || (this.translate && this.translate.currentLang) || this.gridOptions.locale || 'en';
        if (currentLocale && currentLocale.length > 2) {
            currentLocale = currentLocale.substring(0, 2);
        }
        // if we are preloading searchTerms, we'll keep them for reference
        if (searchTerm) {
            this._currentDate = searchTerm;
        }
        const pickerOptions = {
            defaultDate: searchTerm || '',
            altInput: true,
            altFormat: outputFormat,
            dateFormat: inputFormat,
            wrap: true,
            closeOnSelect: true,
            locale: currentLocale,
            onChange: (selectedDates, dateStr) => {
                this._currentValue = dateStr;
                this._currentDate = Array.isArray(selectedDates) && selectedDates[0] || undefined;
                // when using the time picker, we can simulate a keyup event to avoid multiple backend request
                // since backend request are only executed after user start typing, changing the time should be treated the same way
                let customEvent;
                if (pickerOptions.enableTime) {
                    customEvent = new CustomEvent('keyup');
                }
                this.onTriggerEvent(customEvent);
            },
            errorHandler: (error) => {
                if (error.toString().includes('invalid locale')) {
                    console.warn(`[Angular-Slickgrid] Flatpickr missing locale imports (${currentLocale}), will revert to English as the default locale.
          See Flatpickr Localization for more info, for example if we want to use French, then we can import it with:  import 'flatpickr/dist/l10n/fr';`);
                }
            }
        };
        // add the time picker when format is UTC (Z) or has the 'h' (meaning hours)
        if (outputFormat && (outputFormat === 'Z' || outputFormat.toLowerCase().includes('h'))) {
            pickerOptions.enableTime = true;
        }
        // merge options with optional user's custom options
        this._flatpickrOptions = Object.assign(Object.assign({}, pickerOptions), userFilterOptions);
        let placeholder = (this.gridOptions) ? (this.gridOptions.defaultFilterPlaceholder || '') : '';
        if (this.columnFilter && this.columnFilter.placeholder) {
            placeholder = this.columnFilter.placeholder;
        }
        const filterDivInputElm = document.createElement('div');
        filterDivInputElm.className = 'flatpickr';
        const inputElm = document.createElement('input');
        inputElm.type = 'text';
        inputElm.className = 'form-control';
        inputElm.dataset.input = '';
        inputElm.placeholder = placeholder;
        filterDivInputElm.appendChild(inputElm);
        this.flatInstance = flatpickr$2(filterDivInputElm, this._flatpickrOptions);
        return filterDivInputElm;
    }
    /** Get the available operator option values to populate the operator select dropdown list */
    getOperatorOptionValues() {
        var _a;
        if ((_a = this.columnFilter) === null || _a === void 0 ? void 0 : _a.compoundOperatorList) {
            return this.columnFilter.compoundOperatorList;
        }
        else {
            return [
                { operator: '', description: '' },
                { operator: '=', description: this.getOutputText('EQUAL_TO', 'TEXT_EQUAL_TO', 'Equal to') },
                { operator: '<', description: this.getOutputText('LESS_THAN', 'TEXT_LESS_THAN', 'Less than') },
                { operator: '<=', description: this.getOutputText('LESS_THAN_OR_EQUAL_TO', 'TEXT_LESS_THAN_OR_EQUAL_TO', 'Less than or equal to') },
                { operator: '>', description: this.getOutputText('GREATER_THAN', 'TEXT_GREATER_THAN', 'Greater than') },
                { operator: '>=', description: this.getOutputText('GREATER_THAN_OR_EQUAL_TO', 'TEXT_GREATER_THAN_OR_EQUAL_TO', 'Greater than or equal to') },
                { operator: '<>', description: this.getOutputText('NOT_EQUAL_TO', 'TEXT_NOT_EQUAL_TO', 'Not equal to') }
            ];
        }
    }
    /** Get Locale, Translated or a Default Text if first two aren't detected */
    getOutputText(translationKey, localeText, defaultText) {
        var _a, _b, _c, _d;
        if (((_a = this.gridOptions) === null || _a === void 0 ? void 0 : _a.enableTranslate) && ((_b = this.translate) === null || _b === void 0 ? void 0 : _b.instant)) {
            const translationPrefix = getTranslationPrefix(this.gridOptions);
            return this.translate.instant(`${translationPrefix}${translationKey}`);
        }
        return (_d = (_c = this.locales) === null || _c === void 0 ? void 0 : _c[localeText]) !== null && _d !== void 0 ? _d : defaultText;
    }
    /**
     * Create the DOM element
     */
    createDomElement(searchTerm) {
        var _a, _b;
        const columnId = (_b = (_a = this.columnDef) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '';
        const headerElm = this.grid.getHeaderRowColumn(columnId);
        emptyElement(headerElm);
        // create the DOM Select dropdown for the Operator
        this._selectOperatorElm = buildSelectOperator(this.getOperatorOptionValues());
        this._filterDivInputElm = this.buildDatePickerInput(searchTerm);
        const filterContainerElm = document.createElement('div');
        filterContainerElm.className = `form-group search-filter filter-${columnId}`;
        const containerInputGroupElm = document.createElement('div');
        containerInputGroupElm.className = 'input-group flatpickr';
        const operatorInputGroupAddonElm = document.createElement('div');
        operatorInputGroupAddonElm.className = 'input-group-addon input-group-prepend operator';
        /* the DOM element final structure will be
          <div class="input-group">
            <div class="input-group-addon input-group-prepend operator">
              <select class="form-control"></select>
            </div>
            <div class="flatpickr">
              <input type="text" class="form-control" data-input>
            </div>
          </div>
        */
        operatorInputGroupAddonElm.appendChild(this._selectOperatorElm);
        containerInputGroupElm.appendChild(operatorInputGroupAddonElm);
        containerInputGroupElm.appendChild(this._filterDivInputElm);
        // create the DOM element & add an ID and filter class
        filterContainerElm.appendChild(containerInputGroupElm);
        this._filterDivInputElm.dataset.columnid = `${columnId}`;
        if (this.operator) {
            const operatorShorthand = mapOperatorToShorthandDesignation(this.operator);
            this._selectOperatorElm.value = operatorShorthand;
        }
        // if there's a search term, we will add the "filled" class for styling purposes
        if (searchTerm && searchTerm !== '') {
            this._filterDivInputElm.classList.add('filled');
            this._currentDate = searchTerm;
            this._currentValue = searchTerm;
        }
        // append the new DOM element to the header row
        if (filterContainerElm) {
            headerElm.appendChild(filterContainerElm);
        }
        return filterContainerElm;
    }
    onTriggerEvent(e) {
        if (this._clearFilterTriggered) {
            this.callback(e, { columnDef: this.columnDef, clearFilterTriggered: this._clearFilterTriggered, shouldTriggerQuery: this._shouldTriggerQuery });
            this._filterElm.classList.remove('filled');
        }
        else {
            const selectedOperator = this._selectOperatorElm.value;
            (this._currentValue) ? this._filterElm.classList.add('filled') : this._filterElm.classList.remove('filled');
            this.callback(e, { columnDef: this.columnDef, searchTerms: (this._currentValue ? [this._currentValue] : null), operator: selectedOperator || '', shouldTriggerQuery: this._shouldTriggerQuery });
        }
        // reset both flags for next use
        this._clearFilterTriggered = false;
        this._shouldTriggerQuery = true;
    }
}
CompoundDateFilter.ctorParameters = () => [
    { type: TranslateService, decorators: [{ type: Optional }] }
];

class CompoundInputFilter {
    constructor(translate) {
        this.translate = translate;
        this._clearFilterTriggered = false;
        this._debounceTypingDelay = 0;
        this._shouldTriggerQuery = true;
        this._inputType = 'text';
        this.searchTerms = [];
        this._bindEventService = new BindingEventService();
    }
    /** Getter for the Grid Options pulled through the Grid Object */
    get gridOptions() {
        var _a, _b, _c;
        return (_c = (_b = (_a = this.grid) === null || _a === void 0 ? void 0 : _a.getOptions) === null || _b === void 0 ? void 0 : _b.call(_a)) !== null && _c !== void 0 ? _c : {};
    }
    /** Getter for the Column Filter */
    get columnFilter() {
        var _a, _b;
        return (_b = (_a = this.columnDef) === null || _a === void 0 ? void 0 : _a.filter) !== null && _b !== void 0 ? _b : {};
    }
    /** Getter to know what would be the default operator when none is specified */
    get defaultOperator() {
        return OperatorType.empty;
    }
    /** Getter of input type (text, number, password) */
    get inputType() {
        return this._inputType;
    }
    /** Setter of input type (text, number, password) */
    set inputType(type) {
        this._inputType = type;
    }
    /** Getter for the single Locale texts provided by the user in main file or else use default English locales via the Constants */
    get locales() {
        return this.gridOptions.locales || Constants.locales;
    }
    /** Getter of the Operator to use when doing the filter comparing */
    get operator() {
        return this._operator || this.defaultOperator;
    }
    /** Setter of the Operator to use when doing the filter comparing */
    set operator(op) {
        this._operator = op;
    }
    /**
     * Initialize the Filter
     */
    init(args) {
        var _a, _b, _c, _d, _e;
        if (!args) {
            throw new Error('[Angular-SlickGrid] A filter must always have an "init()" with valid arguments.');
        }
        this.grid = args.grid;
        this.callback = args.callback;
        this.columnDef = args.columnDef;
        this.operator = args.operator;
        this.searchTerms = (args.hasOwnProperty('searchTerms') ? args.searchTerms : []) || [];
        // analyze if we have any keyboard debounce delay (do we wait for user to finish typing before querying)
        // it is used by default for a backend service but is optional when using local dataset
        const backendApi = (_a = this.gridOptions) === null || _a === void 0 ? void 0 : _a.backendServiceApi;
        this._debounceTypingDelay = (_e = (backendApi ? ((_b = backendApi === null || backendApi === void 0 ? void 0 : backendApi.filterTypingDebounce) !== null && _b !== void 0 ? _b : (_c = this.gridOptions) === null || _c === void 0 ? void 0 : _c.defaultBackendServiceFilterTypingDebounce) : (_d = this.gridOptions) === null || _d === void 0 ? void 0 : _d.filterTypingDebounce)) !== null && _e !== void 0 ? _e : 0;
        // filter input can only have 1 search term, so we will use the 1st array index if it exist
        const searchTerm = (Array.isArray(this.searchTerms) && this.searchTerms.length >= 0) ? this.searchTerms[0] : '';
        // step 1, create the DOM Element of the filter which contain the compound Operator+Input
        // and initialize it if searchTerm is filled
        this._filterElm = this.createDomElement(searchTerm);
        // step 3, subscribe to the keyup event and run the callback when that happens
        // also add/remove "filled" class for styling purposes
        // we'll use all necessary events to cover the following (keyup, change, mousewheel & spinner)
        this._bindEventService.bind(this._filterInputElm, ['keyup', 'blur', 'change', 'wheel'], this.onTriggerEvent.bind(this));
        this._bindEventService.bind(this._selectOperatorElm, 'change', this.onTriggerEvent.bind(this));
    }
    /**
     * Clear the filter value
     */
    clear(shouldTriggerQuery = true) {
        if (this._filterElm && this._selectOperatorElm) {
            this._clearFilterTriggered = true;
            this._shouldTriggerQuery = shouldTriggerQuery;
            this.searchTerms = [];
            this._selectOperatorElm.selectedIndex = 0;
            this._filterInputElm.value = '';
            this.onTriggerEvent(undefined);
        }
    }
    /**
     * destroy the filter
     */
    destroy() {
        var _a, _b, _c, _d;
        this._bindEventService.unbindAll();
        (_b = (_a = this._selectOperatorElm) === null || _a === void 0 ? void 0 : _a.remove) === null || _b === void 0 ? void 0 : _b.call(_a);
        (_d = (_c = this._filterElm) === null || _c === void 0 ? void 0 : _c.remove) === null || _d === void 0 ? void 0 : _d.call(_c);
    }
    /** Set value(s) on the DOM element */
    setValues(values, operator) {
        if (values) {
            const newValue = Array.isArray(values) ? values[0] : values;
            this._filterInputElm.value = `${newValue !== null && newValue !== void 0 ? newValue : ''}`;
        }
        // set the operator, in the DOM as well, when defined
        this.operator = operator || this.defaultOperator;
        if (operator && this._selectOperatorElm) {
            const operatorShorthand = mapOperatorToShorthandDesignation(this.operator);
            this._selectOperatorElm.value = operatorShorthand;
        }
    }
    //
    // protected functions
    // ------------------
    buildInputElement() {
        var _a, _b, _c, _d, _e;
        const columnId = (_b = (_a = this.columnDef) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '';
        // create the DOM element & add an ID and filter class
        let placeholder = (_d = (_c = this.gridOptions) === null || _c === void 0 ? void 0 : _c.defaultFilterPlaceholder) !== null && _d !== void 0 ? _d : '';
        if ((_e = this.columnFilter) === null || _e === void 0 ? void 0 : _e.placeholder) {
            placeholder = this.columnFilter.placeholder;
        }
        const inputElm = document.createElement('input');
        inputElm.type = this._inputType || 'text';
        inputElm.className = `form-control compound-input filter-${columnId}`;
        inputElm.autocomplete = 'off';
        inputElm.placeholder = placeholder;
        inputElm.setAttribute('role', 'presentation');
        return inputElm;
    }
    /** Get the available operator option values to populate the operator select dropdown list */
    getOperatorOptionValues() {
        var _a;
        const type = (this.columnDef.type && this.columnDef.type) ? this.columnDef.type : FieldType.string;
        let optionValues = [];
        if ((_a = this.columnFilter) === null || _a === void 0 ? void 0 : _a.compoundOperatorList) {
            return this.columnFilter.compoundOperatorList;
        }
        else {
            switch (type) {
                case FieldType.string:
                case FieldType.text:
                case FieldType.readonly:
                case FieldType.password:
                    optionValues = [
                        { operator: '', description: this.getOutputText('CONTAINS', 'TEXT_CONTAINS', 'Contains') },
                        { operator: '<>', description: this.getOutputText('NOT_CONTAINS', 'TEXT_NOT_CONTAINS', 'Not Contains') },
                        { operator: '=', description: this.getOutputText('EQUALS', 'TEXT_EQUALS', 'Equals') },
                        { operator: '!=', description: this.getOutputText('NOT_EQUAL_TO', 'TEXT_NOT_EQUAL_TO', 'Not equal to') },
                        { operator: 'a*', description: this.getOutputText('STARTS_WITH', 'TEXT_STARTS_WITH', 'Starts with') },
                        { operator: '*z', description: this.getOutputText('ENDS_WITH', 'TEXT_ENDS_WITH', 'Ends with') },
                    ];
                    break;
                default:
                    optionValues = [
                        { operator: '', description: '' },
                        { operator: '=', description: this.getOutputText('EQUAL_TO', 'TEXT_EQUAL_TO', 'Equal to') },
                        { operator: '<', description: this.getOutputText('LESS_THAN', 'TEXT_LESS_THAN', 'Less than') },
                        { operator: '<=', description: this.getOutputText('LESS_THAN_OR_EQUAL_TO', 'TEXT_LESS_THAN_OR_EQUAL_TO', 'Less than or equal to') },
                        { operator: '>', description: this.getOutputText('GREATER_THAN', 'TEXT_GREATER_THAN', 'Greater than') },
                        { operator: '>=', description: this.getOutputText('GREATER_THAN_OR_EQUAL_TO', 'TEXT_GREATER_THAN_OR_EQUAL_TO', 'Greater than or equal to') },
                        { operator: '<>', description: this.getOutputText('NOT_EQUAL_TO', 'TEXT_NOT_EQUAL_TO', 'Not equal to') }
                    ];
                    break;
            }
        }
        return optionValues;
    }
    /** Get Locale, Translated or a Default Text if first two aren't detected */
    getOutputText(translationKey, localeText, defaultText) {
        var _a, _b, _c, _d;
        if (((_a = this.gridOptions) === null || _a === void 0 ? void 0 : _a.enableTranslate) && ((_b = this.translate) === null || _b === void 0 ? void 0 : _b.instant)) {
            const translationPrefix = getTranslationPrefix(this.gridOptions);
            return this.translate.instant(`${translationPrefix}${translationKey}`);
        }
        return (_d = (_c = this.locales) === null || _c === void 0 ? void 0 : _c[localeText]) !== null && _d !== void 0 ? _d : defaultText;
    }
    /**
     * Create the DOM element
     */
    createDomElement(searchTerm) {
        var _a, _b;
        const columnId = (_b = (_a = this.columnDef) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '';
        const headerElm = this.grid.getHeaderRowColumn(columnId);
        emptyElement(headerElm);
        // create the DOM Select dropdown for the Operator
        this._selectOperatorElm = buildSelectOperator(this.getOperatorOptionValues());
        this._filterInputElm = this.buildInputElement();
        const emptySpanElm = document.createElement('span');
        const filterContainerElm = document.createElement('div');
        filterContainerElm.className = `form-group search-filter filter-${columnId}`;
        const containerInputGroupElm = document.createElement('div');
        containerInputGroupElm.className = 'input-group';
        const operatorInputGroupAddonElm = document.createElement('div');
        operatorInputGroupAddonElm.className = 'input-group-addon input-group-prepend operator';
        /* the DOM element final structure will be
          <div class="input-group">
            <div class="input-group-addon input-group-prepend operator">
              <select class="form-control"></select>
            </div>
            <input class="form-control compound-input" type="text" />
          </div>
        */
        operatorInputGroupAddonElm.appendChild(this._selectOperatorElm);
        containerInputGroupElm.appendChild(operatorInputGroupAddonElm);
        containerInputGroupElm.appendChild(this._filterInputElm);
        containerInputGroupElm.appendChild(emptySpanElm);
        // create the DOM element & add an ID and filter class
        filterContainerElm.appendChild(containerInputGroupElm);
        this._filterInputElm.value = `${searchTerm !== null && searchTerm !== void 0 ? searchTerm : ''}`;
        this._filterInputElm.dataset.columnid = `${columnId}`;
        if (this.operator) {
            const operatorShorthand = mapOperatorToShorthandDesignation(this.operator);
            this._selectOperatorElm.value = operatorShorthand;
        }
        // if there's a search term, we will add the "filled" class for styling purposes
        if (searchTerm) {
            this._filterInputElm.classList.add('filled');
        }
        // append the new DOM element to the header row
        if (filterContainerElm) {
            headerElm.appendChild(filterContainerElm);
        }
        return filterContainerElm;
    }
    /**
     * Event trigger, could be called by the Operator dropdown or the input itself and we will cover the following (keyup, change, mousewheel & spinner)
     * We will trigger the Filter Service callback from this handler
     */
    onTriggerEvent(event) {
        var _a, _b;
        if (this._clearFilterTriggered) {
            this.callback(event, { columnDef: this.columnDef, clearFilterTriggered: this._clearFilterTriggered, shouldTriggerQuery: this._shouldTriggerQuery });
            this._filterElm.classList.remove('filled');
        }
        else {
            const eventType = (_a = event === null || event === void 0 ? void 0 : event.type) !== null && _a !== void 0 ? _a : '';
            const selectedOperator = this._selectOperatorElm.value;
            let value = this._filterInputElm.value;
            const enableWhiteSpaceTrim = this.gridOptions.enableFilterTrimWhiteSpace || this.columnFilter.enableTrimWhiteSpace;
            if (typeof value === 'string' && enableWhiteSpaceTrim) {
                value = value.trim();
            }
            (value !== null && value !== undefined && value !== '') ? this._filterElm.classList.add('filled') : this._filterElm.classList.remove('filled');
            const callbackArgs = { columnDef: this.columnDef, searchTerms: (value ? [value] : null), operator: selectedOperator, shouldTriggerQuery: this._shouldTriggerQuery };
            const typingDelay = (eventType === 'keyup' && ((_b = event) === null || _b === void 0 ? void 0 : _b.key) !== 'Enter') ? this._debounceTypingDelay : 0;
            if (typingDelay > 0) {
                clearTimeout(this.timer);
                this.timer = setTimeout(() => this.callback(event, callbackArgs), typingDelay);
            }
            else {
                this.callback(event, callbackArgs);
            }
        }
        // reset both flags for next use
        this._clearFilterTriggered = false;
        this._shouldTriggerQuery = true;
    }
}

class CompoundInputNumberFilter extends CompoundInputFilter {
    /** Initialize the Filter */
    constructor(translate) {
        super(translate);
        this.translate = translate;
        this.inputType = 'number';
    }
}

class CompoundInputPasswordFilter extends CompoundInputFilter {
    /** Initialize the Filter */
    constructor(translate) {
        super(translate);
        this.translate = translate;
        this.inputType = 'password';
    }
}

const DEFAULT_MIN_VALUE$3 = 0;
const DEFAULT_MAX_VALUE$3 = 100;
const DEFAULT_STEP$3 = 1;
class CompoundSliderFilter {
    constructor(translate) {
        this.translate = translate;
        this._clearFilterTriggered = false;
        this._shouldTriggerQuery = true;
        this._elementRangeInputId = '';
        this._elementRangeOutputId = '';
        this.searchTerms = [];
        this._bindEventService = new BindingEventService();
    }
    /** Getter for the Filter Operator */
    get columnFilter() {
        return this.columnDef && this.columnDef.filter || {};
    }
    /** Getter to know what would be the default operator when none is specified */
    get defaultOperator() {
        return OperatorType.empty;
    }
    /** Getter for the Filter Generic Params */
    get filterParams() {
        return this.columnDef && this.columnDef.filter && this.columnDef.filter.params || {};
    }
    /** Getter for the `filter` properties */
    get filterProperties() {
        return this.columnDef && this.columnDef.filter || {};
    }
    /** Getter for the Grid Options pulled through the Grid Object */
    get gridOptions() {
        var _a, _b, _c;
        return (_c = (_b = (_a = this.grid) === null || _a === void 0 ? void 0 : _a.getOptions) === null || _b === void 0 ? void 0 : _b.call(_a)) !== null && _c !== void 0 ? _c : {};
    }
    /** Getter for the single Locale texts provided by the user in main file or else use default English locales via the Constants */
    get locales() {
        return this.gridOptions.locales || Constants.locales;
    }
    /** Getter for the Filter Operator */
    get operator() {
        return this._operator || this.columnFilter.operator || this.defaultOperator;
    }
    /** Setter for the Filter Operator */
    set operator(op) {
        this._operator = op;
    }
    /**
     * Initialize the Filter
     */
    init(args) {
        var _a;
        if (!args) {
            throw new Error('[Angular-SlickGrid] A filter must always have an "init()" with valid arguments.');
        }
        this.grid = args.grid;
        this.callback = args.callback;
        this.columnDef = args.columnDef;
        this.operator = args.operator || '';
        this.searchTerms = (_a = args === null || args === void 0 ? void 0 : args.searchTerms) !== null && _a !== void 0 ? _a : [];
        // define the input & slider number IDs
        this._elementRangeInputId = `rangeInput_${this.columnDef.field}`;
        this._elementRangeOutputId = `rangeOutput_${this.columnDef.field}`;
        // filter input can only have 1 search term, so we will use the 1st array index if it exist
        const searchTerm = (Array.isArray(this.searchTerms) && this.searchTerms.length >= 0) ? this.searchTerms[0] : '';
        // step 1, create the DOM Element of the filter which contain the compound Operator+Input
        // and initialize it if searchTerm is filled
        this.filterElm = this.createDomElement(searchTerm);
        // step 2, subscribe to the input change event and run the callback when that happens
        // also add/remove "filled" class for styling purposes
        this._bindEventService.bind(this.filterInputElm, 'change', this.onTriggerEvent.bind(this));
        this._bindEventService.bind(this.selectOperatorElm, 'change', this.onTriggerEvent.bind(this));
        // if user chose to display the slider number on the right side, then update it every time it changes
        // we need to use both "input" and "change" event to be all cross-browser
        if (!this.filterParams.hideSliderNumber) {
            this._bindEventService.bind(this.filterInputElm, ['input', 'change'], this.handleInputChange.bind(this));
        }
    }
    /**
     * Clear the filter value
     */
    clear(shouldTriggerQuery = true) {
        var _a, _b;
        if (this.filterElm && this.selectOperatorElm) {
            this._clearFilterTriggered = true;
            this._shouldTriggerQuery = shouldTriggerQuery;
            this.searchTerms = [];
            const clearedValue = (_b = (_a = this.filterParams) === null || _a === void 0 ? void 0 : _a.sliderStartValue) !== null && _b !== void 0 ? _b : DEFAULT_MIN_VALUE$3;
            this._currentValue = +clearedValue;
            this.selectOperatorElm.selectedIndex = 0;
            this.filterInputElm.value = clearedValue;
            if (this.filterNumberElm) {
                this.filterNumberElm.textContent = clearedValue;
            }
            this.onTriggerEvent(undefined);
            this.filterElm.classList.remove('filled');
        }
    }
    /**
     * destroy the filter
     */
    destroy() {
        var _a, _b, _c, _d;
        this._bindEventService.unbindAll();
        (_b = (_a = this.selectOperatorElm) === null || _a === void 0 ? void 0 : _a.remove) === null || _b === void 0 ? void 0 : _b.call(_a);
        emptyElement(this.filterElm);
        (_d = (_c = this.filterElm) === null || _c === void 0 ? void 0 : _c.remove) === null || _d === void 0 ? void 0 : _d.call(_c);
    }
    /**
     * Get selected value retrieved from the slider element
     * @params selected items
     */
    getValues() {
        return this._currentValue;
    }
    /** Set value(s) on the DOM element */
    setValues(values, operator) {
        const newValue = Array.isArray(values) ? values[0] : values;
        this._currentValue = +newValue;
        this.filterInputElm.value = `${newValue !== null && newValue !== void 0 ? newValue : ''}`;
        if (this.filterNumberElm) {
            this.filterNumberElm.textContent = `${newValue !== null && newValue !== void 0 ? newValue : ''}`;
        }
        // set the operator, in the DOM as well, when defined
        this.operator = operator || this.defaultOperator;
        if (operator && this.selectOperatorElm) {
            const operatorShorthand = mapOperatorToShorthandDesignation(this.operator);
            this.selectOperatorElm.value = operatorShorthand;
        }
    }
    //
    // protected functions
    // ------------------
    /** Get the available operator option values to populate the operator select dropdown list */
    getOperatorOptionValues() {
        var _a;
        if ((_a = this.columnFilter) === null || _a === void 0 ? void 0 : _a.compoundOperatorList) {
            return this.columnFilter.compoundOperatorList;
        }
        else {
            return [
                { operator: '', description: '' },
                { operator: '=', description: this.getOutputText('EQUAL_TO', 'TEXT_EQUAL_TO', 'Equal to') },
                { operator: '<', description: this.getOutputText('LESS_THAN', 'TEXT_LESS_THAN', 'Less than') },
                { operator: '<=', description: this.getOutputText('LESS_THAN_OR_EQUAL_TO', 'TEXT_LESS_THAN_OR_EQUAL_TO', 'Less than or equal to') },
                { operator: '>', description: this.getOutputText('GREATER_THAN', 'TEXT_GREATER_THAN', 'Greater than') },
                { operator: '>=', description: this.getOutputText('GREATER_THAN_OR_EQUAL_TO', 'TEXT_GREATER_THAN_OR_EQUAL_TO', 'Greater than or equal to') },
                { operator: '<>', description: this.getOutputText('NOT_EQUAL_TO', 'TEXT_NOT_EQUAL_TO', 'Not equal to') }
            ];
        }
    }
    /** Get Locale, Translated or a Default Text if first two aren't detected */
    getOutputText(translationKey, localeText, defaultText) {
        var _a, _b;
        if (((_a = this.gridOptions) === null || _a === void 0 ? void 0 : _a.enableTranslate) && ((_b = this.translate) === null || _b === void 0 ? void 0 : _b.instant)) {
            const translationPrefix = getTranslationPrefix(this.gridOptions);
            return this.translate.instant(`${translationPrefix}${translationKey}`);
        }
        return this.locales && this.locales[localeText] || defaultText;
    }
    /**
     * Create the DOM element
     */
    createDomElement(searchTerm) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        const columnId = (_b = (_a = this.columnDef) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '';
        const minValue = (_d = (_c = this.filterProperties) === null || _c === void 0 ? void 0 : _c.minValue) !== null && _d !== void 0 ? _d : DEFAULT_MIN_VALUE$3;
        const maxValue = (_f = (_e = this.filterProperties) === null || _e === void 0 ? void 0 : _e.maxValue) !== null && _f !== void 0 ? _f : DEFAULT_MAX_VALUE$3;
        const defaultValue = (_h = (_g = this.filterParams) === null || _g === void 0 ? void 0 : _g.sliderStartValue) !== null && _h !== void 0 ? _h : minValue;
        const step = (_k = (_j = this.filterProperties) === null || _j === void 0 ? void 0 : _j.valueStep) !== null && _k !== void 0 ? _k : DEFAULT_STEP$3;
        const startValue = +((_m = (_l = this.filterParams) === null || _l === void 0 ? void 0 : _l.sliderStartValue) !== null && _m !== void 0 ? _m : minValue);
        const headerElm = this.grid.getHeaderRowColumn(this.columnDef.id);
        emptyElement(headerElm);
        let searchTermInput = (searchTerm || '0');
        if (+searchTermInput < minValue) {
            searchTermInput = `${minValue}`;
        }
        if (+searchTermInput < startValue) {
            searchTermInput = `${startValue}`;
        }
        this._currentValue = +searchTermInput;
        /*
          Full DOM Element Template::
          <div class="form-group search-filter slider-container filter-${columnId}" data-columnid="${columnId}">
            <div class="input-group search-filter filter-${columnId}">
              <span class="input-group-addon input-group-prepend operator">
                <select class="form-control"><option value="">...</select>
              </span>
              <input type="range" class="form-control slider-filter-input range compound-slider ${this._elementRangeInputId}" value="0" min="0" max="100" step="1" name="${this._elementRangeInputId}"/>
              <div class="input-group-addon input-group-append slider-value">
                <span class="input-group-text rangeOutput_${columnId}">0</span>
              </div>
            </div>
          </div>
        */
        // create the DOM Select dropdown for the Operator
        this.selectOperatorElm = buildSelectOperator(this.getOperatorOptionValues());
        const spanPrependElm = document.createElement('span');
        spanPrependElm.className = 'input-group-addon input-group-prepend operator';
        spanPrependElm.appendChild(this.selectOperatorElm);
        // create the DOM element
        this.filterInputElm = document.createElement('input');
        this.filterInputElm.type = 'range';
        this.filterInputElm.className = `form-control slider-filter-input range compound-slider ${this._elementRangeInputId}`;
        this.filterInputElm.defaultValue = defaultValue;
        this.filterInputElm.value = searchTermInput;
        this.filterInputElm.min = `${minValue}`;
        this.filterInputElm.max = `${maxValue}`;
        this.filterInputElm.step = `${step}`;
        this.filterInputElm.name = this._elementRangeInputId;
        const divContainerFilterElm = document.createElement('div');
        divContainerFilterElm.className = `form-group search-filter slider-container filter-${columnId}`;
        // this.containerInputGroupElm = $(`<div class="input-group search-filter filter-${columnId}"></div>`);
        this.containerInputGroupElm = document.createElement('div');
        this.containerInputGroupElm.className = `input-group search-filter filter-${columnId}`;
        this.containerInputGroupElm.appendChild(spanPrependElm);
        this.containerInputGroupElm.appendChild(this.filterInputElm);
        divContainerFilterElm.appendChild(this.containerInputGroupElm);
        if (!this.filterParams.hideSliderNumber) {
            this.containerInputGroupElm.classList.add('input-group');
            this.filterInputElm.value = searchTermInput;
            const divGroupAppendElm = document.createElement('div');
            divGroupAppendElm.className = 'input-group-addon input-group-append slider-value';
            this.filterNumberElm = document.createElement('span');
            this.filterNumberElm.className = `input-group-text ${this._elementRangeOutputId}`;
            this.filterNumberElm.textContent = searchTermInput;
            divGroupAppendElm.appendChild(this.filterNumberElm);
            this.containerInputGroupElm.appendChild(divGroupAppendElm);
        }
        // this.filterNumberElm.html(searchTermInput);
        divContainerFilterElm.dataset.columnid = `${columnId}`;
        if (this.operator) {
            const operatorShorthand = mapOperatorToShorthandDesignation(this.operator);
            this.selectOperatorElm.value = operatorShorthand;
        }
        // if there's a search term, we will add the "filled" class for styling purposes
        if (searchTerm) {
            divContainerFilterElm.classList.add('filled');
        }
        // append the new DOM element to the header row
        headerElm.appendChild(divContainerFilterElm);
        return divContainerFilterElm;
    }
    handleInputChange(event) {
        const value = (event === null || event === void 0 ? void 0 : event.target).value;
        if (value !== undefined && value !== null) {
            const element = document.querySelector(`.${this._elementRangeOutputId || ''}`);
            if (element === null || element === void 0 ? void 0 : element.textContent) {
                element.textContent = value;
            }
        }
    }
    onTriggerEvent(e) {
        const value = this.filterInputElm.value;
        this._currentValue = +value;
        if (this._clearFilterTriggered) {
            this.filterElm.classList.remove('filled');
            this.callback(e, { columnDef: this.columnDef, clearFilterTriggered: this._clearFilterTriggered, shouldTriggerQuery: this._shouldTriggerQuery });
        }
        else {
            this.filterElm.classList.add('filled');
            const selectedOperator = this.selectOperatorElm.value;
            this.callback(e, { columnDef: this.columnDef, searchTerms: (value ? [value || '0'] : null), operator: selectedOperator || '', shouldTriggerQuery: this._shouldTriggerQuery });
        }
        // reset both flags for next use
        this._clearFilterTriggered = false;
        this._shouldTriggerQuery = true;
    }
}

class InputFilter {
    constructor() {
        this._clearFilterTriggered = false;
        this._debounceTypingDelay = 0;
        this._shouldTriggerQuery = true;
        this._inputType = 'text';
        this.searchTerms = [];
        this._bindEventService = new BindingEventService();
    }
    /** Getter for the Column Filter */
    get columnFilter() {
        return this.columnDef && this.columnDef.filter || {};
    }
    /** Getter to know what would be the default operator when none is specified */
    get defaultOperator() {
        return OperatorType.empty;
    }
    /** Getter of input type (text, number, password) */
    get inputType() {
        return this._inputType;
    }
    /** Setter of input type (text, number, password) */
    set inputType(type) {
        this._inputType = type;
    }
    /** Getter of the Operator to use when doing the filter comparing */
    get operator() {
        var _a, _b;
        return (_b = (_a = this.columnFilter) === null || _a === void 0 ? void 0 : _a.operator) !== null && _b !== void 0 ? _b : this.defaultOperator;
    }
    /** Setter for the filter operator */
    set operator(operator) {
        if (this.columnFilter) {
            this.columnFilter.operator = operator;
        }
    }
    /** Getter for the Grid Options pulled through the Grid Object */
    get gridOptions() {
        return (this.grid && this.grid.getOptions) ? this.grid.getOptions() : {};
    }
    /**
     * Initialize the Filter
     */
    init(args) {
        var _a, _b, _c, _d, _e;
        if (!args) {
            throw new Error('[Angular-SlickGrid] A filter must always have an "init()" with valid arguments.');
        }
        this.grid = args.grid;
        this.callback = args.callback;
        this.columnDef = args.columnDef;
        this.searchTerms = (args.hasOwnProperty('searchTerms') ? args.searchTerms : []) || [];
        // analyze if we have any keyboard debounce delay (do we wait for user to finish typing before querying)
        // it is used by default for a backend service but is optional when using local dataset
        const backendApi = (_a = this.gridOptions) === null || _a === void 0 ? void 0 : _a.backendServiceApi;
        this._debounceTypingDelay = (_e = (backendApi ? ((_b = backendApi === null || backendApi === void 0 ? void 0 : backendApi.filterTypingDebounce) !== null && _b !== void 0 ? _b : (_c = this.gridOptions) === null || _c === void 0 ? void 0 : _c.defaultBackendServiceFilterTypingDebounce) : (_d = this.gridOptions) === null || _d === void 0 ? void 0 : _d.filterTypingDebounce)) !== null && _e !== void 0 ? _e : 0;
        // filter input can only have 1 search term, so we will use the 1st array index if it exist
        const searchTerm = (Array.isArray(this.searchTerms) && this.searchTerms.length >= 0) ? this.searchTerms[0] : '';
        // step 1, create the DOM Element of the filter & initialize it if searchTerm is filled
        this._filterElm = this.createDomElement(searchTerm);
        // step 2, subscribe to the input event and run the callback when that happens
        // also add/remove "filled" class for styling purposes
        // we'll use all necessary events to cover the following (keyup, change, mousewheel & spinner)
        this._bindEventService.bind(this._filterElm, ['keyup', 'blur', 'change', 'wheel'], this.handleInputChange.bind(this));
    }
    /**
     * Clear the filter value
     */
    clear(shouldTriggerQuery = true) {
        if (this._filterElm) {
            this._clearFilterTriggered = true;
            this._shouldTriggerQuery = shouldTriggerQuery;
            this.searchTerms = [];
            this._filterElm.value = '';
            this._filterElm.dispatchEvent(new Event('change'));
        }
    }
    /**
     * destroy the filter
     */
    destroy() {
        var _a, _b;
        this._bindEventService.unbindAll();
        (_b = (_a = this._filterElm) === null || _a === void 0 ? void 0 : _a.remove) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
    getValue() {
        return this._filterElm.value;
    }
    /** Set value(s) on the DOM element */
    setValues(values, operator) {
        const searchValues = Array.isArray(values) ? values : [values];
        let searchValue = '';
        for (const value of searchValues) {
            searchValue = operator ? this.addOptionalOperatorIntoSearchString(value, operator) : value;
            this._filterElm.value = `${searchValue !== null && searchValue !== void 0 ? searchValue : ''}`;
        }
        // set the operator when defined
        this.operator = operator || this.defaultOperator;
    }
    //
    // protected functions
    // ------------------
    /**
     * When loading the search string from the outside into the input text field, we should also add the prefix/suffix of the operator.
     * We do this so that if it was loaded by a Grid Presets then we should also add the operator into the search string
     * Let's take these 3 examples:
     * 1. (operator: '>=', searchTerms:[55]) should display as ">=55"
     * 2. (operator: 'StartsWith', searchTerms:['John']) should display as "John*"
     * 3. (operator: 'EndsWith', searchTerms:['John']) should display as "*John"
     * @param operator - operator string
     */
    addOptionalOperatorIntoSearchString(inputValue, operator) {
        let searchTermPrefix = '';
        let searchTermSuffix = '';
        let outputValue = inputValue === undefined || inputValue === null ? '' : `${inputValue}`;
        if (operator && outputValue) {
            switch (operator) {
                case '<>':
                case '!=':
                case '=':
                case '==':
                case '>':
                case '>=':
                case '<':
                case '<=':
                    searchTermPrefix = operator;
                    break;
                case 'EndsWith':
                case '*z':
                    searchTermPrefix = '*';
                    break;
                case 'StartsWith':
                case 'a*':
                    searchTermSuffix = '*';
                    break;
            }
            outputValue = `${searchTermPrefix}${outputValue}${searchTermSuffix}`;
        }
        return outputValue;
    }
    /**
     * From the html template string, create a DOM element
     * @param {Object} searchTerm - filter search term
     * @returns {Object} DOM element filter
     */
    createDomElement(searchTerm) {
        var _a, _b, _c, _d, _e;
        const columnId = (_b = (_a = this.columnDef) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '';
        const headerElm = this.grid.getHeaderRowColumn(columnId);
        emptyElement(headerElm);
        // create the DOM element & add an ID and filter class
        let placeholder = (_d = (_c = this.gridOptions) === null || _c === void 0 ? void 0 : _c.defaultFilterPlaceholder) !== null && _d !== void 0 ? _d : '';
        if ((_e = this.columnFilter) === null || _e === void 0 ? void 0 : _e.placeholder) {
            placeholder = this.columnFilter.placeholder;
        }
        const inputElm = document.createElement('input');
        inputElm.type = this._inputType || 'text';
        inputElm.className = `form-control search-filter filter-${columnId}`;
        inputElm.autocomplete = 'off';
        inputElm.placeholder = placeholder;
        inputElm.setAttribute('role', 'presentation');
        inputElm.value = (searchTerm !== null && searchTerm !== void 0 ? searchTerm : '');
        inputElm.dataset.columnid = `${columnId}`;
        // if there's a search term, we will add the "filled" class for styling purposes
        if (searchTerm) {
            inputElm.classList.add('filled');
        }
        // append the new DOM element to the header row & an empty span
        headerElm.appendChild(inputElm);
        headerElm.appendChild(document.createElement('span'));
        return inputElm;
    }
    /**
     * Event handler to cover the following (keyup, change, mousewheel & spinner)
     * We will trigger the Filter Service callback from this handler
     */
    handleInputChange(event) {
        var _a, _b, _c, _d;
        if (this._clearFilterTriggered) {
            this.callback(event, { columnDef: this.columnDef, clearFilterTriggered: this._clearFilterTriggered, shouldTriggerQuery: this._shouldTriggerQuery });
            this._filterElm.classList.remove('filled');
        }
        else {
            const eventType = (_a = event === null || event === void 0 ? void 0 : event.type) !== null && _a !== void 0 ? _a : '';
            let value = (_c = (_b = event === null || event === void 0 ? void 0 : event.target) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : '';
            const enableWhiteSpaceTrim = this.gridOptions.enableFilterTrimWhiteSpace || this.columnFilter.enableTrimWhiteSpace;
            if (typeof value === 'string' && enableWhiteSpaceTrim) {
                value = value.trim();
            }
            value === '' ? this._filterElm.classList.remove('filled') : this._filterElm.classList.add('filled');
            const callbackArgs = { columnDef: this.columnDef, operator: this.operator, searchTerms: [value], shouldTriggerQuery: this._shouldTriggerQuery };
            const typingDelay = (eventType === 'keyup' && ((_d = event) === null || _d === void 0 ? void 0 : _d.key) !== 'Enter') ? this._debounceTypingDelay : 0;
            if (typingDelay > 0) {
                clearTimeout(this._timer);
                this._timer = setTimeout(() => this.callback(event, callbackArgs), typingDelay);
            }
            else {
                this.callback(event, callbackArgs);
            }
        }
        // reset both flags for next use
        this._clearFilterTriggered = false;
        this._shouldTriggerQuery = true;
    }
}

class InputMaskFilter extends InputFilter {
    /** Initialize the Filter */
    constructor() {
        super();
        this._inputMask = '';
        this.inputType = 'text';
    }
    /** Getter of the input mask, when provided */
    get inputMask() {
        return this._inputMask;
    }
    /**
     * Override the Filter init used by SlickGrid
     */
    init(args) {
        var _a, _b, _c, _d;
        if (!args) {
            throw new Error('[Angular-SlickGrid] A filter must always have an "init()" with valid arguments.');
        }
        this.grid = args.grid;
        this.callback = args.callback;
        this.columnDef = args.columnDef;
        this.searchTerms = (args.hasOwnProperty('searchTerms') ? args.searchTerms : []) || [];
        // get input mask from params (can be in columnDef or columnFilter params)
        if ((_b = (_a = this.columnDef) === null || _a === void 0 ? void 0 : _a.params) === null || _b === void 0 ? void 0 : _b.mask) {
            this._inputMask = this.columnDef.params.mask;
        }
        else if ((_d = (_c = this.columnFilter) === null || _c === void 0 ? void 0 : _c.params) === null || _d === void 0 ? void 0 : _d.mask) {
            this._inputMask = this.columnFilter.params.mask;
        }
        if (!this._inputMask) {
            throw new Error(`[Angular-Slickgrid] The Filters.inputMask requires the mask to be passed in the filter params or the column definition params
        for example:: this.columnDefinitions: [{ id: 'phone', field: 'phone', filter: { model: Filters.inputMask, params: { mask: '000-000-0000' }}}]`);
        }
        // filter input can only have 1 search term, so we will use the 1st array index if it exist
        const searchTerm = (Array.isArray(this.searchTerms) && this.searchTerms.length >= 0) ? this.searchTerms[0] : '';
        // step 1, create the DOM Element of the filter & initialize it if searchTerm is filled
        this._filterElm = this.createDomElement(searchTerm);
        // step 2, subscribe to the input event and run the callback when that happens
        // also add/remove "filled" class for styling purposes
        // we'll use all necessary events to cover the following (keyup, change, mousewheel & spinner)
        this._bindEventService.bind(this._filterElm, ['keyup', 'blur', 'change'], this.handleInputChange.bind(this));
    }
    /**
     * Event handler to cover the following (keyup, change, mousewheel & spinner)
     * We will trigger the Filter Service callback from this handler
     */
    handleInputChange(event) {
        var _a, _b, _c, _d;
        let value = '';
        if ((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value) {
            let targetValue = (_c = (_b = event === null || event === void 0 ? void 0 : event.target) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : '';
            const enableWhiteSpaceTrim = this.gridOptions.enableFilterTrimWhiteSpace || this.columnFilter.enableTrimWhiteSpace;
            if (typeof targetValue === 'string' && enableWhiteSpaceTrim) {
                targetValue = targetValue.trim();
            }
            // if it has a mask, we need to do a bit more work
            // and replace the filter string by the masked output without triggering an event
            const unmaskedValue = this.unmaskValue(targetValue);
            const maskedValue = this.maskValue(unmaskedValue);
            value = unmaskedValue;
            if (((_d = event) === null || _d === void 0 ? void 0 : _d.keyCode) >= 48) {
                this._filterElm.value = maskedValue; // replace filter string with masked string
                event.preventDefault();
            }
        }
        if (this._clearFilterTriggered) {
            this.callback(event, { columnDef: this.columnDef, clearFilterTriggered: this._clearFilterTriggered, shouldTriggerQuery: this._shouldTriggerQuery });
            this._filterElm.classList.remove('filled');
        }
        else {
            this._filterElm.classList.add('filled');
            this.callback(event, { columnDef: this.columnDef, operator: this.operator, searchTerms: [value], shouldTriggerQuery: this._shouldTriggerQuery });
        }
        // reset both flags for next use
        this._clearFilterTriggered = false;
        this._shouldTriggerQuery = true;
    }
    /** From a regular string, we will use the mask to output a new string */
    maskValue(inputValue) {
        let i = 0;
        let maskedValue = '';
        if (this._inputMask) {
            maskedValue = this._inputMask.replace(/[09A]/gi, (match) => {
                // only replace the char when the mask is a 0 or 9 for a digit OR the mask is "A" and the char is a non-digit meaning a string char
                if (((match === '0' || match === '9') && /\d+/g.test(inputValue[i])) // mask is 0 or 9 and value is a digit
                    || (match.toUpperCase() === 'A' && /[^\d]+/gi.test(inputValue[i])) // OR mask is an "A" and value is non-digit
                ) {
                    return inputValue[i++] || '';
                }
                return '';
            });
        }
        return maskedValue;
    }
    /** From a masked string, we will remove the mask and make a regular string again */
    unmaskValue(maskedValue) {
        // remove anything else but digits and chars from both the input mask and the input masked value for later comparison
        // e.g. (000) 000-0000 would return 0000000000
        const valueWithoutSymbols = maskedValue.replace(/[^0-9a-z]*/gi, '');
        const maskWithoutSymbols = this._inputMask.replace(/[^0-9a-z]*/gi, '');
        // then we can analyze if each char on each indexes equals what the mask requires, if not the char will be disregarded from the output
        // basically, if our mask is "0A0" and input value is "2ab", then only "2a" will be returned since the last char "b" is not part of the mask and is invalid
        let output = '';
        for (let i = 0; i < maskWithoutSymbols.length; i++) {
            if (valueWithoutSymbols[i]) {
                if (((maskWithoutSymbols[i] === '0' || maskWithoutSymbols[i] === '9') && /\d+/g.test(valueWithoutSymbols[i])) // mask is 0 or 9 and value is a digit
                    || (maskWithoutSymbols[i].toUpperCase() === 'A' && /[^\d]+/gi.test(valueWithoutSymbols[i])) // OR mask is an "A" and value is non-digit
                ) {
                    output += valueWithoutSymbols[i]; // valid and matches the Mask, so we can add it up to the string output
                }
            }
        }
        return output;
    }
}

class InputNumberFilter extends InputFilter {
    /** Initialize the Filter */
    constructor() {
        super();
        this.inputType = 'number';
    }
}

class InputPasswordFilter extends InputFilter {
    /** Initialize the Filter */
    constructor() {
        super();
        this.inputType = 'password';
    }
}

const DOMPurify$4 = DOMPurify_; // patch to fix rollup to work
class SelectFilter {
    /**
     * Initialize the Filter
     */
    constructor(translate, collectionService, isMultipleSelect = true) {
        this.translate = translate;
        this.collectionService = collectionService;
        this._isMultipleSelect = true;
        this._collectionLength = 0;
        this._shouldTriggerQuery = true;
        this.isFilled = false;
        this.enableTranslateLabel = false;
        this.subscriptions = [];
        this._isMultipleSelect = isMultipleSelect;
    }
    /** Getter for the Column Filter itself */
    get columnFilter() {
        return this.columnDef && this.columnDef.filter || {};
    }
    /** Getter for the Collection Options */
    get collectionOptions() {
        return this.columnDef && this.columnDef.filter && this.columnDef.filter.collectionOptions;
    }
    /** Getter for the Custom Structure if exist */
    get customStructure() {
        return this.columnDef && this.columnDef.filter && this.columnDef.filter.customStructure;
    }
    /** Getter for the Grid Options pulled through the Grid Object */
    get gridOptions() {
        return (this.grid && this.grid.getOptions) ? this.grid.getOptions() : {};
    }
    /** Getter to know what would be the default operator when none is specified */
    get defaultOperator() {
        return this.isMultipleSelect ? OperatorType.in : OperatorType.equal;
    }
    /** Getter to know if the current filter is a multiple-select (false means it's a single select) */
    get isMultipleSelect() {
        return this._isMultipleSelect;
    }
    /** Getter for the filter operator */
    get operator() {
        return this.columnFilter && this.columnFilter.operator || this.defaultOperator;
    }
    /** Setter for the filter operator */
    set operator(operator) {
        if (this.columnFilter) {
            this.columnFilter.operator = operator;
        }
    }
    /**
     * Initialize the filter template
     */
    init(args) {
        var _a, _b, _c;
        if (!args) {
            throw new Error('[Angular-SlickGrid] A filter must always have an "init()" with valid arguments.');
        }
        this.grid = args.grid;
        this.callback = args.callback;
        this.columnDef = args.columnDef;
        this.searchTerms = (args.hasOwnProperty('searchTerms') ? args.searchTerms : []) || [];
        if (!this.grid || !this.columnDef || !this.columnFilter || (!this.columnFilter.collection && !this.columnFilter.collectionAsync)) {
            throw new Error(`[Angular-SlickGrid] You need to pass a "collection" (or "collectionAsync") for the MultipleSelect/SingleSelect Filter to work correctly. Also each option should include a value/label pair (or value/labelKey when using Locale). For example:: { filter: model: Filters.multipleSelect, collection: [{ value: true, label: 'True' }, { value: false, label: 'False'}] }`);
        }
        this.enableTranslateLabel = this.columnFilter.enableTranslateLabel || false;
        this.labelName = this.customStructure && this.customStructure.label || 'label';
        this.labelPrefixName = this.customStructure && this.customStructure.labelPrefix || 'labelPrefix';
        this.labelSuffixName = this.customStructure && this.customStructure.labelSuffix || 'labelSuffix';
        this.optionLabel = this.customStructure && this.customStructure.optionLabel || 'value';
        this.valueName = this.customStructure && this.customStructure.value || 'value';
        if (this.enableTranslateLabel && !this.gridOptions.enableTranslate && (!this.translate || typeof this.translate.instant !== 'function')) {
            throw new Error(`[select-filter] The ngx-translate TranslateService is required for the Select Filter to work correctly when "enableTranslateLabel" is set.`);
        }
        // get locales provided by user in forRoot or else use default English locales via the Constants
        this._locales = this.gridOptions && this.gridOptions.locales || Constants.locales;
        // create the multiple select element
        this.initMultipleSelect();
        // add placeholder when found
        let placeholder = this.gridOptions && this.gridOptions.defaultFilterPlaceholder || '';
        if (this.columnFilter && this.columnFilter.placeholder) {
            placeholder = this.columnFilter.placeholder;
        }
        this.defaultOptions.placeholder = placeholder || '';
        // when we're using a multiple-select filter and we have an empty select option,
        // we probably want this value to be a valid filter option that will ONLY return value that are empty (not everything like its default behavior)
        // user can still override it by defining it
        if (this._isMultipleSelect && ((_a = this.columnDef) === null || _a === void 0 ? void 0 : _a.filter)) {
            this.columnDef.filter.emptySearchTermReturnAllValues = (_c = (_b = this.columnDef.filter) === null || _b === void 0 ? void 0 : _b.emptySearchTermReturnAllValues) !== null && _c !== void 0 ? _c : false;
        }
        // always render the Select (dropdown) DOM element, even if user passed a "collectionAsync",
        // if that is the case, the Select will simply be without any options but we still have to render it (else SlickGrid would throw an error)
        const newCollection = this.columnFilter.collection || [];
        this.renderDomElement(newCollection);
        // on every Filter which have a "collection" or a "collectionAsync"
        // we will add (or replace) a Subject to the "collectionAsync" property so that user has possibility to change the collection
        // if "collectionAsync" is already set by the user, it will resolve it first then after it will replace it with a Subject
        const collectionAsync = this.columnFilter && this.columnFilter.collectionAsync;
        if (collectionAsync) {
            return this.renderOptionsAsync(collectionAsync); // create Subject after resolve (createCollectionAsyncSubject)
        }
        else {
            return new Promise((resolve) => resolve(true));
        }
    }
    /**
     * Clear the filter values
     */
    clear(shouldTriggerQuery = true) {
        if (this.$filterElm && this.$filterElm.multipleSelect && this._collectionLength > 0) {
            // reload the filter element by it's id, to make sure it's still a valid element (because of some issue in the GraphQL example)
            this.$filterElm.multipleSelect('setSelects', []);
            this.$filterElm.removeClass('filled');
            this.$filterElm.siblings('div .search-filter').removeClass('filled');
            this.searchTerms = [];
            this._shouldTriggerQuery = shouldTriggerQuery;
            this.callback(undefined, { columnDef: this.columnDef, clearFilterTriggered: true, shouldTriggerQuery: this._shouldTriggerQuery });
            // reset both flags for next use
            this._shouldTriggerQuery = true;
        }
    }
    /**
     * destroy the filter
     */
    destroy() {
        // also dispose of all Subscriptions
        this.subscriptions = unsubscribeAllObservables(this.subscriptions);
        if (this.$filterElm && typeof this.$filterElm.multipleSelect === 'function') {
            this.$filterElm.multipleSelect('destroy');
            this.$filterElm.remove();
            const elementClassName = this.elementName.toString().replace('.', '\\.'); // make sure to escape any dot "." from CSS class to avoid console error
            $(`[name=${elementClassName}].ms-drop`).remove();
        }
        this.$filterElm = null;
    }
    /**
     * Get selected values retrieved from the multiple-selected element
     * @params selected items
     */
    getValues() {
        if (this.$filterElm && typeof this.$filterElm.multipleSelect === 'function') {
            return this.$filterElm.multipleSelect('getSelects');
        }
        return [];
    }
    /** Set value(s) on the DOM element */
    setValues(values, operator) {
        if (values && this.$filterElm && typeof this.$filterElm.multipleSelect === 'function') {
            values = Array.isArray(values) ? values : [values];
            this.$filterElm.multipleSelect('setSelects', values);
        }
        // set the operator when defined
        this.operator = operator || this.defaultOperator;
    }
    //
    // protected functions
    // ------------------
    /**
     * user might want to filter certain items of the collection
     * @param inputCollection
     * @return outputCollection filtered and/or sorted collection
     */
    filterCollection(inputCollection) {
        let outputCollection = inputCollection;
        // user might want to filter certain items of the collection
        if (this.columnDef && this.columnFilter && this.columnFilter.collectionFilterBy) {
            const filterBy = this.columnFilter.collectionFilterBy;
            const filterCollectionBy = this.columnFilter.collectionOptions && this.columnFilter.collectionOptions.filterResultAfterEachPass || null;
            outputCollection = this.collectionService.filterCollection(outputCollection, filterBy, filterCollectionBy);
        }
        return outputCollection;
    }
    /**
     * user might want to sort the collection in a certain way
     * @param inputCollection
     * @return outputCollection filtered and/or sorted collection
     */
    sortCollection(inputCollection) {
        let outputCollection = inputCollection;
        // user might want to sort the collection
        if (this.columnDef && this.columnFilter && this.columnFilter.collectionSortBy) {
            const sortBy = this.columnFilter.collectionSortBy;
            outputCollection = this.collectionService.sortCollection(this.columnDef, outputCollection, sortBy, this.enableTranslateLabel);
        }
        return outputCollection;
    }
    renderOptionsAsync(collectionAsync) {
        return __awaiter(this, void 0, void 0, function* () {
            let awaitedCollection = [];
            if (collectionAsync) {
                awaitedCollection = yield castToPromise(collectionAsync);
                this.renderDomElementFromCollectionAsync(awaitedCollection);
                // because we accept Promises & HttpClient Observable only execute once
                // we will re-create an RxJs Subject which will replace the "collectionAsync" which got executed once anyway
                // doing this provide the user a way to call a "collectionAsync.next()"
                this.createCollectionAsyncSubject();
            }
            return true;
        });
    }
    /** Create or recreate an Observable Subject and reassign it to the "collectionAsync" object so user can call a "collectionAsync.next()" on it */
    createCollectionAsyncSubject() {
        const newCollectionAsync = new Subject();
        this.columnFilter.collectionAsync = newCollectionAsync;
        this.subscriptions.push(newCollectionAsync.subscribe(collection => this.renderDomElementFromCollectionAsync(collection)));
    }
    /**
     * When user use a CollectionAsync we will use the returned collection to render the filter DOM element
     * and reinitialize filter collection with this new collection
     */
    renderDomElementFromCollectionAsync(collection) {
        if (this.collectionOptions && (this.collectionOptions.collectionInsideObjectProperty || this.collectionOptions.collectionInObjectProperty)) {
            const collectionInsideObjectProperty = this.collectionOptions.collectionInsideObjectProperty || this.collectionOptions.collectionInObjectProperty;
            collection = getDescendantProperty(collection, collectionInsideObjectProperty);
        }
        if (!Array.isArray(collection)) {
            throw new Error('Something went wrong while trying to pull the collection from the "collectionAsync" call in the Select Filter, the collection is not a valid array.');
        }
        // copy over the array received from the async call to the "collection" as the new collection to use
        // this has to be BEFORE the `collectionObserver().subscribe` to avoid going into an infinite loop
        this.columnFilter.collection = collection;
        // recreate Multiple Select after getting async collection
        this.renderDomElement(collection);
    }
    renderDomElement(inputCollection) {
        if (!Array.isArray(inputCollection) && this.collectionOptions && (this.collectionOptions.collectionInsideObjectProperty || this.collectionOptions.collectionInObjectProperty)) {
            const collectionInsideObjectProperty = this.collectionOptions.collectionInsideObjectProperty || this.collectionOptions.collectionInObjectProperty;
            inputCollection = getDescendantProperty(inputCollection, collectionInsideObjectProperty);
        }
        if (!Array.isArray(inputCollection)) {
            throw new Error('The "collection" passed to the Select Filter is not a valid array.');
        }
        // make a copy of the collection so that we don't impact SelectEditor, this could happen when calling "addBlankEntry" or "addCustomFirstEntry"
        let collection = [];
        if (inputCollection.length > 0) {
            collection = [...inputCollection];
        }
        // user can optionally add a blank entry at the beginning of the collection
        // make sure however that it wasn't added more than once
        if (this.collectionOptions && this.collectionOptions.addBlankEntry && Array.isArray(collection) && collection.length > 0 && collection[0][this.valueName] !== '') {
            collection.unshift(this.createBlankEntry());
        }
        // user can optionally add his own custom entry at the beginning of the collection
        if (this.collectionOptions && this.collectionOptions.addCustomFirstEntry && Array.isArray(collection) && collection.length > 0 && collection[0][this.valueName] !== this.collectionOptions.addCustomFirstEntry[this.valueName]) {
            collection.unshift(this.collectionOptions.addCustomFirstEntry);
        }
        // user can optionally add his own custom entry at the end of the collection
        if (this.collectionOptions && this.collectionOptions.addCustomLastEntry && Array.isArray(collection) && collection.length > 0) {
            const lastCollectionIndex = collection.length - 1;
            if (collection[lastCollectionIndex][this.valueName] !== this.collectionOptions.addCustomLastEntry[this.valueName]) {
                collection.push(this.collectionOptions.addCustomLastEntry);
            }
        }
        let newCollection = collection;
        // user might want to filter and/or sort certain items of the collection
        newCollection = this.filterCollection(newCollection);
        newCollection = this.sortCollection(newCollection);
        // step 1, create HTML DOM element
        const selectBuildResult = buildSelectEditorOrFilterDomElement('filter', newCollection, this.columnDef, this.grid, this.isMultipleSelect, this.translate, this.searchTerms || []);
        this.isFilled = selectBuildResult.hasFoundSearchTerm;
        // step 2, create the DOM Element of the filter & pre-load search terms
        // we will later also subscribe to the onClose event to filter the data whenever that event is triggered
        this.createDomElement(selectBuildResult.selectElement);
        this._collectionLength = newCollection.length;
    }
    /** Create a blank entry that can be added to the collection. It will also reuse the same customStructure if need be */
    createBlankEntry() {
        const blankEntry = {
            [this.labelName]: '',
            [this.valueName]: ''
        };
        if (this.labelPrefixName) {
            blankEntry[this.labelPrefixName] = '';
        }
        if (this.labelSuffixName) {
            blankEntry[this.labelSuffixName] = '';
        }
        return blankEntry;
    }
    /**
     * From the Select DOM Element created earlier, create a Multiple/Single Select Filter using the jQuery multiple-select.js lib
     * @param {Object} selectElement
     */
    createDomElement(selectElement) {
        const fieldId = this.columnDef && this.columnDef.id;
        // provide the name attribute to the DOM element which will be needed to auto-adjust drop position (dropup / dropdown)
        this.elementName = `filter-${fieldId}`;
        this.defaultOptions.name = this.elementName;
        const $headerElm = this.grid.getHeaderRowColumn(fieldId);
        $($headerElm).empty();
        // create the DOM element & add an ID and filter class
        this.$filterElm = $(selectElement);
        if (typeof this.$filterElm.multipleSelect !== 'function') {
            throw new Error(`multiple-select.js was not found, make sure to modify your "angular-cli.json" file and include "../node_modules/angular-slickgrid/lib/multiple-select/multiple-select.js" and it's css or SASS file`);
        }
        this.$filterElm.attr('name', this.elementName);
        this.$filterElm.data('columnId', fieldId);
        // if there's a search term, we will add the "filled" class for styling purposes
        if (this.isFilled) {
            this.$filterElm.addClass('filled');
        }
        // append the new DOM element to the header row
        if (this.$filterElm && typeof this.$filterElm.appendTo === 'function') {
            this.$filterElm.appendTo($headerElm);
        }
        // merge options & attach multiSelect
        const filterOptions = Object.assign(Object.assign({}, this.defaultOptions), this.columnFilter.filterOptions);
        this.filterElmOptions = Object.assign(Object.assign({}, this.defaultOptions), filterOptions);
        this.$filterElm = this.$filterElm.multipleSelect(this.filterElmOptions);
    }
    /** Initialize the Multiple Select element and its options to use */
    initMultipleSelect() {
        const isTranslateEnabled = this.gridOptions && this.gridOptions.enableTranslate;
        // default options used by this Filter, user can overwrite any of these by passing "otions"
        const options = {
            autoAdjustDropHeight: true,
            autoAdjustDropPosition: true,
            autoAdjustDropWidthByTextSize: true,
            container: 'body',
            filter: false,
            maxHeight: 275,
            single: true,
            textTemplate: ($elm) => {
                // are we rendering HTML code? by default it is sanitized and won't be rendered
                const isRenderHtmlEnabled = this.columnDef && this.columnDef.filter && this.columnDef.filter.enableRenderHtml || false;
                return isRenderHtmlEnabled ? $elm.text() : $elm.html();
            },
            onClose: () => {
                // we will subscribe to the onClose event for triggering our callback
                // also add/remove "filled" class for styling purposes
                this.onTriggerEvent(undefined);
            }
        };
        if (this.isMultipleSelect) {
            options.single = false;
            options.okButton = true;
            options.addTitle = true; // show tooltip of all selected items while hovering the filter
            const translationPrefix = getTranslationPrefix(this.gridOptions);
            options.countSelected = (isTranslateEnabled && this.translate && this.translate.instant) ? this.translate.instant(`${translationPrefix}X_OF_Y_SELECTED`) : this._locales && this._locales.TEXT_X_OF_Y_SELECTED;
            options.allSelected = (isTranslateEnabled && this.translate && this.translate.instant) ? this.translate.instant(`${translationPrefix}ALL_SELECTED`) : this._locales && this._locales.TEXT_ALL_SELECTED;
            options.okButtonText = (isTranslateEnabled && this.translate && this.translate.instant) ? this.translate.instant(`${translationPrefix}OK`) : this._locales && this._locales.TEXT_OK;
            options.selectAllText = (isTranslateEnabled && this.translate && this.translate.instant) ? this.translate.instant(`${translationPrefix}SELECT_ALL`) : this._locales && this._locales.TEXT_SELECT_ALL;
            options.selectAllDelimiter = ['', '']; // remove default square brackets of default text "[Select All]" => "Select All"
        }
        this.defaultOptions = options;
    }
    onTriggerEvent(e) {
        const selectedItems = this.getValues();
        if (Array.isArray(selectedItems) && selectedItems.length > 1 || (selectedItems.length === 1 && selectedItems[0] !== '')) {
            this.isFilled = true;
            this.$filterElm.addClass('filled').siblings('div .search-filter').addClass('filled');
        }
        else {
            this.isFilled = false;
            this.$filterElm.removeClass('filled');
            this.$filterElm.siblings('div .search-filter').removeClass('filled');
        }
        this.searchTerms = selectedItems;
        this.callback(undefined, { columnDef: this.columnDef, operator: this.operator, searchTerms: selectedItems, shouldTriggerQuery: this._shouldTriggerQuery });
        // reset flag for next use
        this._shouldTriggerQuery = true;
    }
}
SelectFilter.ctorParameters = () => [
    { type: TranslateService, decorators: [{ type: Optional }] },
    { type: CollectionService },
    null
];

class MultipleSelectFilter extends SelectFilter {
    /**
     * Initialize the Filter
     */
    constructor(translate, collectionService) {
        super(translate, collectionService, true);
        this.translate = translate;
        this.collectionService = collectionService;
    }
}

class NativeSelectFilter {
    constructor(translate) {
        this.translate = translate;
        this._clearFilterTriggered = false;
        this._shouldTriggerQuery = true;
        this._currentValues = [];
        this.searchTerms = [];
        this._bindEventService = new BindingEventService();
    }
    /** Getter for the Column Filter itself */
    get columnFilter() {
        var _a, _b;
        return (_b = (_a = this.columnDef) === null || _a === void 0 ? void 0 : _a.filter) !== null && _b !== void 0 ? _b : {};
    }
    /** Getter to know what would be the default operator when none is specified */
    get defaultOperator() {
        return OperatorType.equal;
    }
    /** Getter for the Grid Options pulled through the Grid Object */
    get gridOptions() {
        return (this.grid && this.grid.getOptions) ? this.grid.getOptions() : {};
    }
    /** Getter for the current Operator */
    get operator() {
        var _a, _b;
        return (_b = (_a = this.columnFilter) === null || _a === void 0 ? void 0 : _a.operator) !== null && _b !== void 0 ? _b : this.defaultOperator;
    }
    /** Setter for the filter operator */
    set operator(operator) {
        if (this.columnFilter) {
            this.columnFilter.operator = operator;
        }
    }
    /**
     * Initialize the Filter
     */
    init(args) {
        if (!args) {
            throw new Error('[Angular-SlickGrid] A filter must always have an "init()" with valid arguments.');
        }
        this.grid = args.grid;
        this.callback = args.callback;
        this.columnDef = args.columnDef;
        this.searchTerms = (args.hasOwnProperty('searchTerms') ? args.searchTerms : []) || [];
        if (!this.grid || !this.columnDef || !this.columnFilter || !this.columnFilter.collection) {
            throw new Error(`[Angular-SlickGrid] You need to pass a "collection" for the Native Select Filter to work correctly.`);
        }
        if (this.columnFilter.enableTranslateLabel && !this.gridOptions.enableTranslate && (!this.translate || typeof this.translate.instant !== 'function')) {
            throw new Error(`The ngx-translate TranslateService is required for the Native Select Filter to work correctly when "enableTranslateLabel" is set.`);
        }
        // filter input can only have 1 search term, so we will use the 1st array index if it exist
        let searchTerm = (Array.isArray(this.searchTerms) && this.searchTerms.length >= 0) ? this.searchTerms[0] : '';
        if (typeof searchTerm === 'boolean' || typeof searchTerm === 'number') {
            searchTerm = `${searchTerm !== null && searchTerm !== void 0 ? searchTerm : ''}`;
        }
        // step 1, create the DOM Element of the filter & initialize it if searchTerm is filled
        this.filterElm = this.createDomElement(searchTerm);
        // step 2, subscribe to the change event and run the callback when that happens
        // also add/remove "filled" class for styling purposes
        this._bindEventService.bind(this.filterElm, 'change', this.handleOnChange.bind(this));
    }
    /**
     * Clear the filter values
     */
    clear(shouldTriggerQuery = true) {
        if (this.filterElm) {
            this._clearFilterTriggered = true;
            this._shouldTriggerQuery = shouldTriggerQuery;
            this.searchTerms = [];
            this._currentValues = [];
            this.filterElm.value = '';
            this.filterElm.dispatchEvent(new Event('change'));
        }
    }
    /**
     * destroy the filter
     */
    destroy() {
        var _a, _b;
        this._bindEventService.unbindAll();
        (_b = (_a = this.filterElm) === null || _a === void 0 ? void 0 : _a.remove) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
    /**
     * Get selected values retrieved from the select element
     * @params selected items
     */
    getValues() {
        return this._currentValues;
    }
    /** Set value(s) on the DOM element */
    setValues(values, operator) {
        var _a;
        if (Array.isArray(values)) {
            this.filterElm.value = `${(_a = values[0]) !== null && _a !== void 0 ? _a : ''}`;
            this._currentValues = values;
        }
        else if (values) {
            this.filterElm.value = `${values !== null && values !== void 0 ? values : ''}`;
            this._currentValues = [values];
        }
        // set the operator when defined
        this.operator = operator || this.defaultOperator;
    }
    //
    // protected functions
    // ------------------
    /**
     * Create and return a select dropdown HTML element created from a collection
     * @param {Array<Object>} values - list of option values/labels
     * @param {Object} columnDef - column definition
     * @param {Object} translater - Translate Service
     * @returns {Object} selectElm - Select Dropdown HTML Element
     */
    buildFilterSelectFromCollection(collection) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const columnId = (_b = (_a = this.columnDef) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '';
        const selectElm = document.createElement('select');
        selectElm.className = `form-control search-filter filter-${columnId}`;
        const labelName = (_d = (_c = this.columnFilter.customStructure) === null || _c === void 0 ? void 0 : _c.label) !== null && _d !== void 0 ? _d : 'label';
        const valueName = (_f = (_e = this.columnFilter.customStructure) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : 'value';
        const isEnabledTranslate = (_h = (_g = this.columnFilter) === null || _g === void 0 ? void 0 : _g.enableTranslateLabel) !== null && _h !== void 0 ? _h : false;
        // collection could be an Array of Strings OR Objects
        if (collection.every(x => typeof x === 'string')) {
            for (const option of collection) {
                const selectOption = document.createElement('option');
                selectOption.value = option;
                selectOption.label = option;
                selectOption.textContent = option;
                selectElm.appendChild(selectOption);
            }
        }
        else {
            for (const option of collection) {
                if (!option || (option[labelName] === undefined && option.labelKey === undefined)) {
                    throw new Error(`A collection with value/label (or value/labelKey when using Locale) is required to populate the Native Select Filter list, for example:: { filter: model: Filters.select, collection: [ { value: '1', label: 'One' } ]')`);
                }
                const labelKey = option.labelKey || option[labelName];
                const textLabel = ((option.labelKey || isEnabledTranslate) && this.translate && this.translate.currentLang && this.translate.instant) ? this.translate.instant(labelKey || ' ') : labelKey;
                const selectOption = document.createElement('option');
                selectOption.value = option[valueName];
                selectOption.textContent = textLabel;
                selectElm.appendChild(selectOption);
            }
        }
        return selectElm;
    }
    /**
     * From the html template string, create a DOM element
     * @param filterTemplate
     */
    createDomElement(searchTerm) {
        var _a, _b, _c, _d;
        const columnId = (_b = (_a = this.columnDef) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '';
        const headerElm = this.grid.getHeaderRowColumn(columnId);
        emptyElement(headerElm);
        // create the DOM element & add an ID and filter class
        const searchTermInput = (searchTerm || '');
        const collection = (_d = (_c = this.columnFilter) === null || _c === void 0 ? void 0 : _c.collection) !== null && _d !== void 0 ? _d : [];
        if (!Array.isArray(collection)) {
            throw new Error('The "collection" passed to the Native Select Filter is not a valid array.');
        }
        const selectElm = this.buildFilterSelectFromCollection(collection);
        selectElm.value = searchTermInput;
        selectElm.dataset.columnid = `${columnId || ''}`;
        if (searchTermInput) {
            this._currentValues = [searchTermInput];
        }
        headerElm.appendChild(selectElm);
        return selectElm;
    }
    handleOnChange(e) {
        const value = e && e.target && e.target.value || '';
        this._currentValues = [value];
        if (this._clearFilterTriggered) {
            this.callback(e, { columnDef: this.columnDef, clearFilterTriggered: this._clearFilterTriggered, shouldTriggerQuery: this._shouldTriggerQuery });
            this.filterElm.classList.remove('filled');
        }
        else {
            value === '' ? this.filterElm.classList.remove('filled') : this.filterElm.classList.add('filled');
            this.callback(e, { columnDef: this.columnDef, operator: this.operator, searchTerms: [value], shouldTriggerQuery: this._shouldTriggerQuery });
        }
        // reset both flags for next use
        this._clearFilterTriggered = false;
        this._shouldTriggerQuery = true;
    }
}
NativeSelectFilter.ctorParameters = () => [
    { type: TranslateService, decorators: [{ type: Optional }] }
];

const flatpickr$1 = (flatpickr_ && flatpickr_['default'] || flatpickr_); // patch for rollup
const moment$1 = moment_['default'] || moment_; // patch to fix rollup "moment has no default export" issue, document here https://github.com/rollup/rollup/issues/670
class DateRangeFilter {
    constructor(translate) {
        this.translate = translate;
        this._clearFilterTriggered = false;
        this._shouldTriggerQuery = true;
        this.searchTerms = [];
        this._bindEventService = new BindingEventService();
    }
    /** Getter for the Grid Options pulled through the Grid Object */
    get gridOptions() {
        return (this.grid && this.grid.getOptions) ? this.grid.getOptions() : {};
    }
    /** Getter for the Column Filter */
    get columnFilter() {
        return this.columnDef && this.columnDef.filter || {};
    }
    /** Getter for the Current Dates selected */
    get currentDates() {
        return this._currentDates;
    }
    /** Getter to know what would be the default operator when none is specified */
    get defaultOperator() {
        return this.gridOptions.defaultFilterRangeOperator || OperatorType.rangeInclusive;
    }
    /** Getter for the Flatpickr Options */
    get flatpickrOptions() {
        return this._flatpickrOptions || {};
    }
    /** Getter of the Operator to use when doing the filter comparing */
    get operator() {
        var _a, _b;
        return (_b = (_a = this.columnFilter) === null || _a === void 0 ? void 0 : _a.operator) !== null && _b !== void 0 ? _b : this.defaultOperator;
    }
    /** Setter for the filter operator */
    set operator(operator) {
        if (this.columnFilter) {
            this.columnFilter.operator = operator;
        }
    }
    /**
     * Initialize the Filter
     */
    init(args) {
        if (!args) {
            throw new Error('[Angular-SlickGrid] A filter must always have an "init()" with valid arguments.');
        }
        this.grid = args.grid;
        this.callback = args.callback;
        this.columnDef = args.columnDef;
        this.searchTerms = (args.hasOwnProperty('searchTerms') ? args.searchTerms : []) || [];
        // step 1, create the DOM Element of the filter which contain the compound Operator+Input
        this._filterElm = this.createDomElement(this.searchTerms);
        // step 3, subscribe to the keyup event and run the callback when that happens
        // also add/remove "filled" class for styling purposes
        this._bindEventService.bind(this._filterDivInputElm, 'keyup', this.onTriggerEvent.bind(this));
    }
    /**
     * Clear the filter value
     */
    clear(shouldTriggerQuery = true) {
        if (this.flatInstance) {
            this._clearFilterTriggered = true;
            this._shouldTriggerQuery = shouldTriggerQuery;
            this.searchTerms = [];
            this.flatInstance.clear();
        }
    }
    /**
     * destroy the filter
     */
    destroy() {
        var _a, _b, _c;
        this._bindEventService.unbindAll();
        if ((_a = this.flatInstance) === null || _a === void 0 ? void 0 : _a.destroy) {
            this.flatInstance.destroy();
            if (this.flatInstance.element) {
                destroyObjectDomElementProps(this.flatInstance);
            }
        }
        (_c = (_b = this._filterElm) === null || _b === void 0 ? void 0 : _b.remove) === null || _c === void 0 ? void 0 : _c.call(_b);
    }
    hide() {
        if (this.flatInstance && typeof this.flatInstance.close === 'function') {
            this.flatInstance.close();
        }
    }
    show() {
        if (this.flatInstance && typeof this.flatInstance.open === 'function') {
            this.flatInstance.open();
        }
    }
    /**
     * Set value(s) on the DOM element
     * @params searchTerms
     */
    setValues(searchTerms, operator) {
        let pickerValues = [];
        // get the picker values, if it's a string with the "..", we'll do the split else we'll use the array of search terms
        if (typeof searchTerms === 'string' || (Array.isArray(searchTerms) && typeof searchTerms[0] === 'string') && searchTerms[0].indexOf('..') > 0) {
            pickerValues = (typeof searchTerms === 'string') ? [searchTerms] : searchTerms[0].split('..');
        }
        else if (Array.isArray(searchTerms)) {
            pickerValues = searchTerms;
        }
        if (this.flatInstance && searchTerms) {
            this._currentDates = pickerValues;
            this.flatInstance.setDate(pickerValues);
        }
        // set the operator when defined
        this.operator = operator || this.defaultOperator;
    }
    //
    // protected functions
    // ------------------
    buildDatePickerInput(searchTerms) {
        var _a, _b;
        const columnId = (_b = (_a = this.columnDef) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '';
        const inputFormat = mapFlatpickrDateFormatWithFieldType(this.columnFilter.type || this.columnDef.type || FieldType.dateIso);
        const outputFormat = mapFlatpickrDateFormatWithFieldType(this.columnDef.outputType || this.columnFilter.type || this.columnDef.type || FieldType.dateUtc);
        const userFilterOptions = (this.columnFilter && this.columnFilter.filterOptions || {});
        // get current locale, if user defined a custom locale just use or get it the Translate Service if it exist else just use English
        let currentLocale = (userFilterOptions && userFilterOptions.locale) || (this.translate && this.translate.currentLang) || this.gridOptions.locale || 'en';
        if (currentLocale.length > 2) {
            currentLocale = currentLocale.substring(0, 2);
        }
        let pickerValues = [];
        // get the picker values, if it's a string with the "..", we'll do the split else we'll use the array of search terms
        if (typeof searchTerms === 'string' || (Array.isArray(searchTerms) && typeof searchTerms[0] === 'string') && searchTerms[0].indexOf('..') > 0) {
            pickerValues = (typeof searchTerms === 'string') ? [searchTerms] : searchTerms[0].split('..');
        }
        else if (Array.isArray(searchTerms)) {
            pickerValues = searchTerms;
        }
        // if we are preloading searchTerms, we'll keep them for reference
        if (pickerValues) {
            this._currentDates = pickerValues;
            const outFormat = mapMomentDateFormatWithFieldType(this.columnFilter.type || this.columnDef.type || FieldType.dateIso);
            this._currentDateStrings = pickerValues.map(date => moment$1(date).format(outFormat));
        }
        const pickerOptions = {
            defaultDate: (pickerValues || ''),
            altInput: true,
            altFormat: outputFormat,
            dateFormat: inputFormat,
            mode: 'range',
            wrap: true,
            closeOnSelect: true,
            locale: currentLocale,
            onChange: (selectedDates) => {
                if (Array.isArray(selectedDates)) {
                    this._currentDates = selectedDates;
                    const outFormat = mapMomentDateFormatWithFieldType(this.columnDef.outputType || this.columnFilter.type || this.columnDef.type || FieldType.dateIso);
                    this._currentDateStrings = selectedDates.map(date => moment$1(date).format(outFormat));
                    this._currentValue = this._currentDateStrings.join('..');
                }
                // when using the time picker, we can simulate a keyup event to avoid multiple backend request
                // since backend request are only executed after user start typing, changing the time should be treated the same way
                const newEvent = pickerOptions.enableTime ? new CustomEvent('keyup') : undefined;
                this.onTriggerEvent(newEvent);
            },
            errorHandler: (error) => {
                if (error.toString().includes('invalid locale')) {
                    console.warn(`[Angular-Slickgrid] Flatpickr missing locale imports (${currentLocale}), will revert to English as the default locale.
          See Flatpickr Localization for more info, for example if we want to use French, then we can import it with:  import 'flatpickr/dist/l10n/fr';`);
                }
            }
        };
        // add the time picker when format is UTC (Z) or has the 'h' (meaning hours)
        if (outputFormat && (outputFormat === 'Z' || outputFormat.toLowerCase().includes('h'))) {
            pickerOptions.enableTime = true;
        }
        // merge options with optional user's custom options
        this._flatpickrOptions = Object.assign(Object.assign({}, pickerOptions), userFilterOptions);
        let placeholder = (this.gridOptions) ? (this.gridOptions.defaultFilterPlaceholder || '') : '';
        if (this.columnFilter && this.columnFilter.placeholder) {
            placeholder = this.columnFilter.placeholder;
        }
        const filterDivInputElm = document.createElement('div');
        filterDivInputElm.className = `flatpickr search-filter filter-${columnId}`;
        const inputElm = document.createElement('input');
        inputElm.type = 'text';
        inputElm.className = 'form-control';
        inputElm.dataset.input = '';
        inputElm.placeholder = placeholder;
        filterDivInputElm.appendChild(inputElm);
        this.flatInstance = flatpickr$1(filterDivInputElm, this._flatpickrOptions);
        return filterDivInputElm;
    }
    /**
     * Create the DOM element
     * @params searchTerms
     */
    createDomElement(searchTerms) {
        var _a, _b;
        const columnId = (_b = (_a = this.columnDef) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '';
        const headerElm = this.grid.getHeaderRowColumn(columnId);
        emptyElement(headerElm);
        // create the DOM Select dropdown for the Operator
        this._filterDivInputElm = this.buildDatePickerInput(searchTerms);
        /* the DOM element final structure will be
          <div class=flatpickr>
            <input type="text" class="form-control" data-input>
          </div>
        */
        // create the DOM element & add an ID and filter class
        this._filterDivInputElm.dataset.columnid = `${columnId}`;
        // if there's a search term, we will add the "filled" class for styling purposes
        if (Array.isArray(searchTerms) && searchTerms.length > 0 && searchTerms[0] !== '') {
            this._filterDivInputElm.classList.add('filled');
            this._currentDates = searchTerms;
            this._currentValue = searchTerms[0];
        }
        // append the new DOM element to the header row
        if (this._filterDivInputElm) {
            headerElm.appendChild(this._filterDivInputElm);
        }
        return this._filterDivInputElm;
    }
    onTriggerEvent(e) {
        if (this._clearFilterTriggered) {
            this.callback(e, { columnDef: this.columnDef, clearFilterTriggered: this._clearFilterTriggered, shouldTriggerQuery: this._shouldTriggerQuery });
            this._filterElm.classList.remove('filled');
        }
        else {
            (this._currentDateStrings) ? this._filterElm.classList.add('filled') : this._filterElm.classList.remove('filled');
            this.callback(e, { columnDef: this.columnDef, searchTerms: (this._currentDateStrings ? this._currentDateStrings : [this._currentValue]), operator: this.operator || '', shouldTriggerQuery: this._shouldTriggerQuery });
        }
        // reset both flags for next use
        this._clearFilterTriggered = false;
        this._shouldTriggerQuery = true;
    }
}
DateRangeFilter.ctorParameters = () => [
    { type: TranslateService, decorators: [{ type: Optional }] }
];

class SingleSelectFilter extends SelectFilter {
    /**
     * Initialize the Filter
     */
    constructor(translate, collectionService) {
        super(translate, collectionService, false);
        this.translate = translate;
        this.collectionService = collectionService;
    }
}

const DEFAULT_MIN_VALUE$2 = 0;
const DEFAULT_MAX_VALUE$2 = 100;
const DEFAULT_STEP$2 = 1;
class SliderFilter {
    constructor() {
        this._clearFilterTriggered = false;
        this._shouldTriggerQuery = true;
        this._elementRangeInputId = '';
        this._elementRangeOutputId = '';
        this.searchTerms = [];
        this._bindEventService = new BindingEventService();
    }
    /** Getter for the Column Filter */
    get columnFilter() {
        var _a, _b;
        return (_b = (_a = this.columnDef) === null || _a === void 0 ? void 0 : _a.filter) !== null && _b !== void 0 ? _b : {};
    }
    /** Getter to know what would be the default operator when none is specified */
    get defaultOperator() {
        return OperatorType.equal;
    }
    /** Getter for the Filter Generic Params */
    get filterParams() {
        var _a, _b, _c;
        return (_c = (_b = (_a = this.columnDef) === null || _a === void 0 ? void 0 : _a.filter) === null || _b === void 0 ? void 0 : _b.params) !== null && _c !== void 0 ? _c : {};
    }
    /** Getter for the `filter` properties */
    get filterProperties() {
        var _a, _b;
        return (_b = (_a = this.columnDef) === null || _a === void 0 ? void 0 : _a.filter) !== null && _b !== void 0 ? _b : {};
    }
    /** Getter for the current Operator */
    get operator() {
        var _a, _b;
        return (_b = (_a = this.columnFilter) === null || _a === void 0 ? void 0 : _a.operator) !== null && _b !== void 0 ? _b : this.defaultOperator;
    }
    /** Setter for the filter operator */
    set operator(operator) {
        if (this.columnFilter) {
            this.columnFilter.operator = operator;
        }
    }
    /**
     * Initialize the Filter
     */
    init(args) {
        if (!args) {
            throw new Error('[Angular-Slickgrid] A filter must always have an "init()" with valid arguments.');
        }
        this.grid = args.grid;
        this.callback = args.callback;
        this.columnDef = args.columnDef;
        this.searchTerms = (args.hasOwnProperty('searchTerms') ? args.searchTerms : []) || [];
        // define the input & slider number IDs
        this._elementRangeInputId = `rangeInput_${this.columnDef.field}`;
        this._elementRangeOutputId = `rangeOutput_${this.columnDef.field}`;
        // filter input can only have 1 search term, so we will use the 1st array index if it exist
        const searchTerm = (Array.isArray(this.searchTerms) && this.searchTerms.length >= 0) ? this.searchTerms[0] : '';
        // step 1, create the DOM Element of the filter & initialize it if searchTerm is filled
        this.filterElm = this.createDomElement(searchTerm);
        // step 2, subscribe to the change event and run the callback when that happens
        // also add/remove "filled" class for styling purposes
        this._bindEventService.bind(this.filterInputElm, 'change', this.handleOnChange.bind(this));
        // if user chose to display the slider number on the right side, then update it every time it changes
        // we need to use both "input" and "change" event to be all cross-browser
        if (!this.filterParams.hideSliderNumber) {
            this._bindEventService.bind(this.filterInputElm, ['input', 'change'], this.handleInputChange.bind(this));
        }
    }
    /**
     * Clear the filter value
     */
    clear(shouldTriggerQuery = true) {
        var _a, _b;
        if (this.filterElm) {
            this._clearFilterTriggered = true;
            this._shouldTriggerQuery = shouldTriggerQuery;
            this.searchTerms = [];
            const clearedValue = (_b = (_a = this.filterParams) === null || _a === void 0 ? void 0 : _a.sliderStartValue) !== null && _b !== void 0 ? _b : DEFAULT_MIN_VALUE$2;
            this._currentValue = +clearedValue;
            this.filterInputElm.value = clearedValue;
            if (this.filterNumberElm) {
                this.filterNumberElm.textContent = clearedValue;
            }
            this.filterInputElm.dispatchEvent(new Event('change'));
        }
    }
    /**
     * destroy the filter
     */
    destroy() {
        var _a, _b;
        this._bindEventService.unbindAll();
        emptyElement(this.filterElm);
        (_b = (_a = this.filterElm) === null || _a === void 0 ? void 0 : _a.remove) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
    /**
     * Get selected value retrieved from the slider element
     * @params selected items
     */
    getValues() {
        return this._currentValue;
    }
    /** Set value(s) on the DOM element */
    setValues(values, operator) {
        if (Array.isArray(values)) {
            this.filterInputElm.value = `${values[0]}`;
            if (this.filterNumberElm) {
                this.filterNumberElm.textContent = `${values[0]}`;
            }
            this._currentValue = +values[0];
        }
        else if (values) {
            this.filterInputElm.value = `${values !== null && values !== void 0 ? values : ''}`;
            this._currentValue = +values;
        }
        // set the operator when defined
        this.operator = operator || this.defaultOperator;
    }
    //
    // protected functions
    // ------------------
    /**
     * Create the Filter DOM element
     * @param searchTerm optional preset search terms
     */
    createDomElement(searchTerm) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        const columnId = (_b = (_a = this.columnDef) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '';
        const minValue = (_d = (_c = this.filterProperties) === null || _c === void 0 ? void 0 : _c.minValue) !== null && _d !== void 0 ? _d : DEFAULT_MIN_VALUE$2;
        const maxValue = (_f = (_e = this.filterProperties) === null || _e === void 0 ? void 0 : _e.maxValue) !== null && _f !== void 0 ? _f : DEFAULT_MAX_VALUE$2;
        const defaultValue = (_h = (_g = this.filterParams) === null || _g === void 0 ? void 0 : _g.sliderStartValue) !== null && _h !== void 0 ? _h : minValue;
        const step = (_k = (_j = this.filterProperties) === null || _j === void 0 ? void 0 : _j.valueStep) !== null && _k !== void 0 ? _k : DEFAULT_STEP$2;
        const startValue = +((_m = (_l = this.filterParams) === null || _l === void 0 ? void 0 : _l.sliderStartValue) !== null && _m !== void 0 ? _m : minValue);
        const headerElm = this.grid.getHeaderRowColumn(columnId);
        emptyElement(headerElm);
        // create the DOM element & add an ID and filter class
        let searchTermInput = (searchTerm || '0');
        if (+searchTermInput < minValue) {
            searchTermInput = `${minValue}`;
        }
        if (+searchTermInput < startValue) {
            searchTermInput = `${startValue}`;
        }
        this._currentValue = +searchTermInput;
        // create the DOM element
        this.filterInputElm = document.createElement('input');
        this.filterInputElm.type = 'range';
        this.filterInputElm.className = `form-control slider-filter-input range ${this._elementRangeInputId}`;
        this.filterInputElm.defaultValue = defaultValue;
        this.filterInputElm.value = searchTermInput;
        this.filterInputElm.min = `${minValue}`;
        this.filterInputElm.max = `${maxValue}`;
        this.filterInputElm.step = `${step}`;
        this.filterInputElm.name = this._elementRangeInputId;
        const divContainerFilterElm = document.createElement('div');
        divContainerFilterElm.className = `search-filter slider-container filter-${columnId}`;
        divContainerFilterElm.appendChild(this.filterInputElm);
        if (!this.filterParams.hideSliderNumber) {
            divContainerFilterElm.classList.add('input-group');
            this.filterInputElm.value = searchTermInput;
            const divGroupAppendElm = document.createElement('div');
            divGroupAppendElm.className = 'input-group-addon input-group-append slider-value';
            this.filterNumberElm = document.createElement('span');
            this.filterNumberElm.className = `input-group-text ${this._elementRangeOutputId}`;
            this.filterNumberElm.textContent = searchTermInput;
            divGroupAppendElm.appendChild(this.filterNumberElm);
            divContainerFilterElm.appendChild(divGroupAppendElm);
        }
        // this.filterNumberElm.html(searchTermInput);
        divContainerFilterElm.dataset.columnid = `${columnId}`;
        // if there's a search term, we will add the "filled" class for styling purposes
        if (searchTerm) {
            divContainerFilterElm.classList.add('filled');
        }
        // append the new DOM element to the header row
        headerElm.appendChild(divContainerFilterElm);
        return divContainerFilterElm;
    }
    handleInputChange(event) {
        const value = (event === null || event === void 0 ? void 0 : event.target).value;
        if (value !== undefined && value !== null) {
            const element = document.querySelector(`.${this._elementRangeOutputId || ''}`);
            if (element === null || element === void 0 ? void 0 : element.textContent) {
                element.textContent = value;
            }
        }
    }
    handleOnChange(e) {
        const value = e && e.target && e.target.value;
        this._currentValue = +value;
        if (this._clearFilterTriggered) {
            this.filterElm.classList.remove('filled');
            this.callback(e, { columnDef: this.columnDef, clearFilterTriggered: this._clearFilterTriggered, searchTerms: [], shouldTriggerQuery: this._shouldTriggerQuery });
        }
        else {
            this.filterElm.classList.add('filled');
            this.callback(e, { columnDef: this.columnDef, operator: this.operator, searchTerms: [value || '0'], shouldTriggerQuery: this._shouldTriggerQuery });
        }
        // reset both flags for next use
        this._clearFilterTriggered = false;
        this._shouldTriggerQuery = true;
    }
}

const DEFAULT_MIN_VALUE$1 = 0;
const DEFAULT_MAX_VALUE$1 = 100;
const DEFAULT_STEP$1 = 1;
/** A Slider Range Filter which uses jQuery UI, this is only meant to be used as a range filter (with 2 handles lowest & highest values) */
class SliderRangeFilter {
    constructor() {
        this._clearFilterTriggered = false;
        this._currentValues = [];
        this._shouldTriggerQuery = true;
        this.searchTerms = [];
    }
    /** Getter for the Filter Generic Params */
    get filterParams() {
        return this.columnDef && this.columnDef.filter && this.columnDef.filter.params || {};
    }
    /** Getter for the `filter` properties */
    get filterProperties() {
        return this.columnDef && this.columnDef.filter || {};
    }
    /** Getter for the Column Filter */
    get columnFilter() {
        return this.columnDef && this.columnDef.filter || {};
    }
    /** Getter for the Current Slider Values */
    get currentValues() {
        return this._currentValues;
    }
    /** Getter to know what would be the default operator when none is specified */
    get defaultOperator() {
        return this.gridOptions.defaultFilterRangeOperator || OperatorType.rangeInclusive;
    }
    /** Getter for the Grid Options pulled through the Grid Object */
    get gridOptions() {
        return (this.grid && this.grid.getOptions) ? this.grid.getOptions() : {};
    }
    /** Getter for the JQuery UI Slider Options */
    get sliderOptions() {
        return this._sliderOptions || {};
    }
    /** Getter of the Operator to use when doing the filter comparing */
    get operator() {
        return this.columnFilter && this.columnFilter.operator || this.defaultOperator;
    }
    /** Setter for the filter operator */
    set operator(operator) {
        if (this.columnFilter) {
            this.columnFilter.operator = operator;
        }
    }
    /**
     * Initialize the Filter
     */
    init(args) {
        if (!args) {
            throw new Error('[Angular-SlickGrid] A filter must always have an "init()" with valid arguments.');
        }
        this.grid = args.grid;
        this.callback = args.callback;
        this.columnDef = args.columnDef;
        this.searchTerms = (args.hasOwnProperty('searchTerms') ? args.searchTerms : []) || [];
        // step 1, create the DOM Element of the filter & initialize it if searchTerm is filled
        this.$filterElm = this.createDomElement(this.searchTerms);
    }
    /**
     * Clear the filter value
     */
    clear(shouldTriggerQuery = true) {
        if (this.$filterElm) {
            this._clearFilterTriggered = true;
            this._shouldTriggerQuery = shouldTriggerQuery;
            this.searchTerms = [];
            const lowestValue = this.filterParams.hasOwnProperty('sliderStartValue') ? this.filterParams.sliderStartValue : DEFAULT_MIN_VALUE$1;
            const highestValue = this.filterParams.hasOwnProperty('sliderEndValue') ? this.filterParams.sliderEndValue : DEFAULT_MAX_VALUE$1;
            this._currentValues = [lowestValue, highestValue];
            this.$filterElm.slider('values', [lowestValue, highestValue]);
            if (!this.filterParams.hideSliderNumbers) {
                this.renderSliderValues(lowestValue, highestValue);
            }
            this.callback(undefined, { columnDef: this.columnDef, clearFilterTriggered: true, shouldTriggerQuery });
            this.$filterContainerElm.removeClass('filled');
        }
    }
    /**
     * destroy the filter
     */
    destroy() {
        if (this.$filterElm) {
            this.$filterElm.off('change').remove();
            this.$filterContainerElm.remove();
        }
        this.$filterElm = null;
        this.$filterContainerElm = null;
    }
    /**
     * Render both slider values (low/high) on screen
     * @param lowestValue number
     * @param highestValue number
     */
    renderSliderValues(lowestValue, highestValue) {
        const columndId = this.columnDef && this.columnDef.id;
        const lowerElm = document.querySelector(`.lowest-range-${columndId}`);
        const highestElm = document.querySelector(`.highest-range-${columndId}`);
        if (lowerElm && lowerElm.innerHTML) {
            lowerElm.innerHTML = lowestValue.toString();
        }
        if (highestElm && highestElm.innerHTML) {
            highestElm.innerHTML = highestValue.toString();
        }
    }
    /**
     * Set value(s) on the DOM element
     * @params searchTerms
     */
    setValues(searchTerms, operator) {
        if (searchTerms) {
            let sliderValues = [];
            // get the slider values, if it's a string with the "..", we'll do the split else we'll use the array of search terms
            if (typeof searchTerms === 'string' || (Array.isArray(searchTerms) && typeof searchTerms[0] === 'string') && searchTerms[0].indexOf('..') > 0) {
                sliderValues = (typeof searchTerms === 'string') ? [searchTerms] : searchTerms[0].split('..');
            }
            else if (Array.isArray(searchTerms)) {
                sliderValues = searchTerms;
            }
            if (Array.isArray(sliderValues) && sliderValues.length === 2) {
                this.$filterElm.slider('values', sliderValues);
                if (!this.filterParams.hideSliderNumbers) {
                    this.renderSliderValues(sliderValues[0], sliderValues[1]);
                }
            }
        }
        // set the operator when defined
        this.operator = operator || this.defaultOperator;
    }
    //
    // protected functions
    // ------------------
    /**
     * From the html template string, create a DOM element
     * @param searchTerm optional preset search terms
     */
    createDomElement(searchTerms) {
        if (this.columnFilter && this.columnFilter.filterOptions && (this.columnFilter.filterOptions.change || this.columnFilter.filterOptions.slide)) {
            throw new Error(`[Angular-Slickgrid] You cannot override the "change" and/or the "slide" callback methods
        since they are used in SliderRange Filter itself, however any other methods can be used for example the "create", "start", "stop" methods.`);
        }
        const fieldId = this.columnDef && this.columnDef.id;
        const $headerElm = this.grid.getHeaderRowColumn(fieldId);
        const minValue = (this.filterProperties.hasOwnProperty('minValue') ? this.filterProperties.minValue : DEFAULT_MIN_VALUE$1);
        const maxValue = (this.filterProperties.hasOwnProperty('maxValue') ? this.filterProperties.maxValue : DEFAULT_MAX_VALUE$1);
        const step = (this.filterProperties.hasOwnProperty('valueStep') ? this.filterProperties.valueStep : DEFAULT_STEP$1);
        let defaultStartValue = DEFAULT_MIN_VALUE$1;
        let defaultEndValue = DEFAULT_MAX_VALUE$1;
        if (Array.isArray(searchTerms) && searchTerms.length > 1) {
            defaultStartValue = +searchTerms[0];
            defaultEndValue = +searchTerms[1];
        }
        else {
            defaultStartValue = +(this.filterParams.hasOwnProperty('sliderStartValue') ? this.filterParams.sliderStartValue : minValue);
            defaultEndValue = +(this.filterParams.hasOwnProperty('sliderEndValue') ? this.filterParams.sliderEndValue : maxValue);
        }
        $($headerElm).empty();
        // create the DOM element & add an ID and filter class
        const $lowestSliderValueElm = $(`
    <div class="input-group-addon input-group-prepend slider-range-value">
      <span class="input-group-text lowest-range-${fieldId}">${defaultStartValue}</span>
    </div>`);
        const $highestSliderValueElm = $(`
    <div class="input-group-addon input-group-append slider-range-value">
      <span class="input-group-text highest-range-${fieldId}">${defaultEndValue}</span>
    </div>`);
        this.$filterElm = $(`<div class="filter-input filter-${fieldId}"></div>`);
        this.$filterContainerElm = $(`<div class="input-group form-control search-filter slider-range-container slider-values filter-${fieldId}">`);
        if (this.filterParams.hideSliderNumbers) {
            this.$filterContainerElm.append(this.$filterElm);
        }
        else {
            this.$filterContainerElm.append($lowestSliderValueElm);
            this.$filterContainerElm.append(this.$filterElm);
            this.$filterContainerElm.append($highestSliderValueElm);
        }
        // if we are preloading searchTerms, we'll keep them for reference
        this._currentValues = [defaultStartValue, defaultEndValue];
        const definedOptions = {
            range: true,
            min: +minValue,
            max: +maxValue,
            step: +step,
            values: [defaultStartValue, defaultEndValue],
            change: (e, ui) => this.onValueChanged(e, ui),
            slide: (e, ui) => {
                const values = ui.values;
                if (!this.filterParams.hideSliderNumbers && Array.isArray(values)) {
                    this.renderSliderValues(values[0], values[1]);
                }
            }
        };
        // merge options with optional user's custom options
        this._sliderOptions = Object.assign(Object.assign({}, definedOptions), this.columnFilter.filterOptions);
        this.$filterElm.slider(this._sliderOptions);
        // if there's a search term, we will add the "filled" class for styling purposes
        if (Array.isArray(searchTerms) && searchTerms.length > 0 && searchTerms[0] !== '') {
            this.$filterContainerElm.addClass('filled');
        }
        // append the new DOM element to the header row
        if (this.$filterContainerElm && typeof this.$filterContainerElm.appendTo === 'function') {
            this.$filterContainerElm.appendTo($headerElm);
        }
        return this.$filterElm;
    }
    /** On a value change event triggered */
    onValueChanged(e, ui) {
        const values = ui && Array.isArray(ui.values) ? ui.values : [];
        const value = values.join('..');
        if (this._clearFilterTriggered) {
            this.callback(e, { columnDef: this.columnDef, clearFilterTriggered: this._clearFilterTriggered, shouldTriggerQuery: this._shouldTriggerQuery });
            this.$filterContainerElm.removeClass('filled');
        }
        else {
            value === '' ? this.$filterContainerElm.removeClass('filled') : this.$filterContainerElm.addClass('filled');
            this.callback(e, { columnDef: this.columnDef, operator: this.operator, searchTerms: values, shouldTriggerQuery: this._shouldTriggerQuery });
        }
        // reset both flags for next use
        this._clearFilterTriggered = false;
        this._shouldTriggerQuery = true;
    }
}

const Filters = {
    /** AutoComplete Filter (using jQuery UI autocomplete feature) */
    autoComplete: AutoCompleteFilter,
    /** Compound Date Filter (compound of Operator + Date picker) */
    compoundDate: CompoundDateFilter,
    /** Alias to compoundInputText to Compound Input Filter (compound of Operator + Input Text) */
    compoundInput: CompoundInputFilter,
    /** Compound Input Number Filter (compound of Operator + Input of type Number) */
    compoundInputNumber: CompoundInputNumberFilter,
    /** Compound Input Password Filter (compound of Operator + Input of type Password, also note that only the text shown in the UI will be masked, filter query is still plain text) */
    compoundInputPassword: CompoundInputPasswordFilter,
    /** Compound Input Text Filter (compound of Operator + Input Text) */
    compoundInputText: CompoundInputFilter,
    /** Compound Slider Filter (compound of Operator + Slider) */
    compoundSlider: CompoundSliderFilter,
    /** Range Date Filter (uses the Flactpickr Date picker with range option) */
    dateRange: DateRangeFilter,
    /** Alias to inputText, input type text filter (this is the default filter when no type is provided) */
    input: InputFilter,
    /**
     * Input Filter of type text that will be formatted with a mask output
     * e.g.: column: { filter: { model: Filters.inputMask }, params: { mask: '(000) 000-0000' }}
     */
    inputMask: InputMaskFilter,
    /** Input Filter of type Number */
    inputNumber: InputNumberFilter,
    /** Input Filter of type Password (note that only the text shown in the UI will be masked, filter query is still plain text) */
    inputPassword: InputPasswordFilter,
    /** Default Filter, input type text filter */
    inputText: InputFilter,
    /** Multiple Select filter, which uses 3rd party lib "multiple-select.js" */
    multipleSelect: MultipleSelectFilter,
    /** Select filter, which uses native DOM element select */
    select: NativeSelectFilter,
    /** Single Select filter, which uses 3rd party lib "multiple-select.js" */
    singleSelect: SingleSelectFilter,
    /** Slider Filter (only 1 value) */
    slider: SliderFilter,
    /** Slider Range Filter, uses jQuery UI Range Slider (2 values, lowest/highest search range) */
    sliderRange: SliderRangeFilter,
};

/** Global Grid Options Defaults */
const GlobalGridOptions = {
    alwaysShowVerticalScroll: true,
    autoEdit: false,
    asyncEditorLoading: false,
    autoFitColumnsOnFirstLoad: true,
    autoResize: {
        calculateAvailableSizeBy: 'window',
        bottomPadding: 20,
        minHeight: 180,
        minWidth: 300,
        sidePadding: 0
    },
    cellHighlightCssClass: 'slick-cell-modified',
    checkboxSelector: {
        cssClass: 'slick-cell-checkboxsel'
    },
    columnPicker: {
        fadeSpeed: 0,
        hideForceFitButton: false,
        hideSyncResizeButton: true,
        headerColumnValueExtractor: pickerHeaderColumnValueExtractor
    },
    cellMenu: {
        autoAdjustDrop: true,
        autoAlignSide: true,
        hideCloseButton: true,
        hideCommandSection: false,
        hideOptionSection: false,
    },
    contextMenu: {
        autoAdjustDrop: true,
        autoAlignSide: true,
        hideCloseButton: true,
        hideClearAllGrouping: false,
        hideCollapseAllGroups: false,
        hideCommandSection: false,
        hideCopyCellValueCommand: false,
        hideExpandAllGroups: false,
        hideExportCsvCommand: false,
        hideExportExcelCommand: false,
        hideExportTextDelimitedCommand: true,
        hideMenuOnScroll: true,
        hideOptionSection: false,
        iconCopyCellValueCommand: 'fa fa-clone',
        iconExportCsvCommand: 'fa fa-download',
        iconExportExcelCommand: 'fa fa-file-excel-o text-success',
        iconExportTextDelimitedCommand: 'fa fa-download',
        width: 200,
    },
    customFooterOptions: {
        dateFormat: 'yyyy-MM-dd, hh:mm aaaaa\'m\'',
        hideRowSelectionCount: false,
        hideTotalItemCount: false,
        hideLastUpdateTimestamp: true,
        footerHeight: 20,
        leftContainerClass: 'col-xs-12 col-sm-5',
        rightContainerClass: 'col-xs-6 col-sm-7',
        metricSeparator: '|',
        metricTexts: {
            items: 'items',
            itemsKey: 'ITEMS',
            itemsSelected: 'items selected',
            itemsSelectedKey: 'ITEMS_SELECTED',
            of: 'of',
            ofKey: 'OF',
        }
    },
    dataView: {
        syncGridSelection: true,
        syncGridSelectionWithBackendService: false, // but disable it when using backend services
    },
    datasetIdPropertyName: 'id',
    defaultColumnSortFieldId: 'id',
    defaultFilter: Filters.input,
    defaultBackendServiceFilterTypingDebounce: 500,
    enableFilterTrimWhiteSpace: false,
    defaultFilterPlaceholder: '🔎︎',
    defaultFilterRangeOperator: OperatorType.rangeInclusive,
    editable: false,
    enableAutoResize: true,
    enableAutoSizeColumns: true,
    enableCellNavigation: false,
    enableColumnPicker: true,
    enableColumnReorder: true,
    enableColumnResizeOnDoubleClick: true,
    enableContextMenu: true,
    enableExcelExport: true,
    enableExport: false,
    enableGridMenu: true,
    enableHeaderMenu: true,
    enableEmptyDataWarningMessage: true,
    emptyDataWarning: {
        className: 'slick-empty-data-warning',
        message: 'No data to display.',
        messageKey: 'EMPTY_DATA_WARNING_MESSAGE',
        hideFrozenLeftWarning: false,
        hideFrozenRightWarning: false,
        leftViewportMarginLeft: '40%',
        rightViewportMarginLeft: '40%',
        frozenLeftViewportMarginLeft: '0px',
        frozenRightViewportMarginLeft: '40%',
    },
    enableMouseHoverHighlightRow: true,
    enableSorting: true,
    enableTextSelectionOnCells: true,
    explicitInitialization: true,
    excelExportOptions: {
        addGroupIndentation: true,
        exportWithFormatter: false,
        filename: 'export',
        format: FileType.xlsx,
        groupingColumnHeaderTitle: 'Group By',
        groupCollapsedSymbol: '⮞',
        groupExpandedSymbol: '⮟',
        groupingAggregatorRowText: '',
        sanitizeDataExport: false,
    },
    exportOptions: {
        delimiter: DelimiterType.comma,
        exportWithFormatter: false,
        filename: 'export',
        format: FileType.csv,
        groupingColumnHeaderTitle: 'Group By',
        groupingAggregatorRowText: '',
        sanitizeDataExport: false,
        useUtf8WithBom: true
    },
    filterTypingDebounce: 0,
    forceFitColumns: false,
    frozenHeaderWidthCalcDifferential: 0,
    gridMenu: {
        commandLabels: {
            clearAllFiltersCommandKey: 'CLEAR_ALL_FILTERS',
            clearAllSortingCommandKey: 'CLEAR_ALL_SORTING',
            clearFrozenColumnsCommandKey: 'CLEAR_PINNING',
            exportCsvCommandKey: 'EXPORT_TO_CSV',
            exportExcelCommandKey: 'EXPORT_TO_EXCEL',
            exportTextDelimitedCommandKey: 'EXPORT_TO_TAB_DELIMITED',
            refreshDatasetCommandKey: 'REFRESH_DATASET',
            toggleFilterCommandKey: 'TOGGLE_FILTER_ROW',
            togglePreHeaderCommandKey: 'TOGGLE_PRE_HEADER_ROW',
        },
        hideClearAllFiltersCommand: false,
        hideClearAllSortingCommand: false,
        hideClearFrozenColumnsCommand: true,
        hideExportCsvCommand: false,
        hideExportExcelCommand: false,
        hideExportTextDelimitedCommand: true,
        hideForceFitButton: false,
        hideRefreshDatasetCommand: false,
        hideSyncResizeButton: true,
        hideToggleFilterCommand: false,
        hideTogglePreHeaderCommand: false,
        iconCssClass: 'fa fa-bars',
        iconClearAllFiltersCommand: 'fa fa-filter text-danger',
        iconClearAllSortingCommand: 'fa fa-unsorted text-danger',
        iconClearFrozenColumnsCommand: 'fa fa-times',
        iconExportCsvCommand: 'fa fa-download',
        iconExportExcelCommand: 'fa fa-file-excel-o text-success',
        iconExportTextDelimitedCommand: 'fa fa-download',
        iconRefreshDatasetCommand: 'fa fa-refresh',
        iconToggleFilterCommand: 'fa fa-random',
        iconTogglePreHeaderCommand: 'fa fa-random',
        menuWidth: 16,
        resizeOnShowHeaderRow: true,
        useClickToRepositionMenu: false,
        headerColumnValueExtractor: pickerHeaderColumnValueExtractor
    },
    headerMenu: {
        autoAlign: true,
        autoAlignOffset: 12,
        minWidth: 140,
        iconClearFilterCommand: 'fa fa-filter text-danger',
        iconClearSortCommand: 'fa fa-unsorted',
        iconFreezeColumns: 'fa fa-thumb-tack',
        iconSortAscCommand: 'fa fa-sort-amount-asc',
        iconSortDescCommand: 'fa fa-sort-amount-desc',
        iconColumnHideCommand: 'fa fa-times',
        iconColumnResizeByContentCommand: 'fa fa-arrows-h',
        hideColumnResizeByContentCommand: false,
        hideColumnHideCommand: false,
        hideClearFilterCommand: false,
        hideClearSortCommand: false,
        hideFreezeColumnsCommand: true,
        hideSortCommands: false
    },
    headerRowHeight: 35,
    multiColumnSort: true,
    numberedMultiColumnSort: true,
    tristateMultiColumnSort: false,
    sortColNumberInSeparateSpan: true,
    suppressActiveCellChangeOnEdit: true,
    pagination: {
        pageSizes: [10, 15, 20, 25, 30, 40, 50, 75, 100],
        pageSize: 25,
        totalItems: 0
    },
    // technically speaking the Row Detail requires the process & viewComponent but we'll ignore it just to set certain options
    // @ts-ignore
    rowDetailView: {
        cssClass: 'detail-view-toggle',
        panelRows: 1,
        keyPrefix: '__',
        useRowClick: false,
        useSimpleViewportCalc: true,
        saveDetailViewOnScroll: false,
    },
    rowHeight: 35,
    topPanelHeight: 35,
    translationNamespaceSeparator: ':',
    resizeByContentOnlyOnFirstLoad: true,
    resizeByContentOptions: {
        alwaysRecalculateColumnWidth: false,
        cellCharWidthInPx: 7.8,
        cellPaddingWidthInPx: 14,
        defaultRatioForStringType: 0.88,
        formatterPaddingWidthInPx: 0,
        maxItemToInspectCellContentWidth: 1000,
        maxItemToInspectSingleColumnWidthByContent: 5000,
        widthToRemoveFromExceededWidthReadjustment: 50,
    },
    treeDataOptions: {
        exportIndentMarginLeft: 5,
        exportIndentationLeadingChar: '͏͏͏͏͏͏͏͏͏·',
    }
};
/**
 * Value Extractor for both ColumnPicker & GridMenu Picker
 * when using Column Header Grouping, we'll prefix the column group title
 * else we'll simply return the column name title
 */
function pickerHeaderColumnValueExtractor(column) {
    const headerGroup = column && column.columnGroup || '';
    if (headerGroup) {
        return headerGroup + ' - ' + column.name;
    }
    return column && column.name || '';
}

class SlickgridConfig {
    constructor() {
        this.options = GlobalGridOptions;
    }
}
SlickgridConfig.ɵfac = function SlickgridConfig_Factory(t) { return new (t || SlickgridConfig)(); };
SlickgridConfig.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: SlickgridConfig, factory: SlickgridConfig.ɵfac });


class FilterFactory {
    constructor(config, translate, collectionService) {
        this.config = config;
        this.translate = translate;
        this.collectionService = collectionService;
        this._options = this.config.options;
    }
    // Uses the User model to create a new User
    createFilter(columnFilter) {
        let filter;
        if (columnFilter && columnFilter.model) {
            filter = typeof columnFilter.model === 'function' ? new columnFilter.model(this.translate, this.collectionService) : columnFilter.model;
        }
        // fallback to the default filter
        if (!filter && this._options.defaultFilter) {
            filter = new this._options.defaultFilter(this.translate, this.collectionService);
        }
        return filter;
    }
}
FilterFactory.ɵfac = function FilterFactory_Factory(t) { return new (t || FilterFactory)(ɵngcc0.ɵɵinject(SlickgridConfig), ɵngcc0.ɵɵinject(ɵngcc1.TranslateService, 8), ɵngcc0.ɵɵinject(CollectionService)); };
FilterFactory.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: FilterFactory, factory: FilterFactory.ɵfac });
FilterFactory.ctorParameters = () => [
    { type: SlickgridConfig },
    { type: TranslateService, decorators: [{ type: Optional }] },
    { type: CollectionService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FilterFactory, [{
        type: Injectable
    }], function () { return [{ type: SlickgridConfig }, { type: ɵngcc1.TranslateService, decorators: [{
                type: Optional
            }] }, { type: CollectionService }]; }, null); })();

class FilterService {
    constructor(filterFactory, sharedService) {
        this.filterFactory = filterFactory;
        this.sharedService = sharedService;
        this._isFilterFirstRender = true;
        this._isTreePresetExecuted = false;
        this._firstColumnIdRendered = '';
        this._filtersMetadata = [];
        this._columnFilters = {};
        this.httpCancelRequests$ = new Subject(); // this will be used to cancel any pending http request
        this.onFilterChanged = new Subject();
        this.onFilterCleared = new Subject();
        this._eventHandler = new Slick.EventHandler();
        this._onSearchChange = new Slick.Event();
    }
    /** Getter of the SlickGrid Event Handler */
    get eventHandler() {
        return this._eventHandler;
    }
    /** Getter to know if the filter was already rendered or if it was its first time render */
    get isFilterFirstRender() {
        return this._isFilterFirstRender;
    }
    /** Getter of the SlickGrid Event Handler */
    get onSearchChange() {
        return this._onSearchChange;
    }
    /** Getter for the Grid Options pulled through the Grid Object */
    get _gridOptions() {
        var _a, _b, _c;
        return (_c = (_b = (_a = this._grid) === null || _a === void 0 ? void 0 : _a.getOptions) === null || _b === void 0 ? void 0 : _b.call(_a)) !== null && _c !== void 0 ? _c : {};
    }
    /** Getter for the Column Definitions pulled through the Grid Object */
    get _columnDefinitions() {
        var _a, _b, _c;
        return (_c = (_b = (_a = this._grid) === null || _a === void 0 ? void 0 : _a.getColumns) === null || _b === void 0 ? void 0 : _b.call(_a)) !== null && _c !== void 0 ? _c : [];
    }
    /** Getter of SlickGrid DataView object */
    get _dataView() {
        var _a, _b, _c;
        return (_c = (_b = (_a = this._grid) === null || _a === void 0 ? void 0 : _a.getData) === null || _b === void 0 ? void 0 : _b.call(_a)) !== null && _c !== void 0 ? _c : {};
    }
    /**
     * Initialize the Service
     * @param grid
     */
    init(grid) {
        this._grid = grid;
        if (this._gridOptions && this._gridOptions.enableTreeData && this._gridOptions.treeDataOptions) {
            this._grid.setSortColumns([{ columnId: this._gridOptions.treeDataOptions.columnId, sortAsc: true }]);
        }
    }
    dispose() {
        // unsubscribe all SlickGrid events
        this._eventHandler.unsubscribeAll();
        if (isObservable(this.httpCancelRequests$)) {
            this.httpCancelRequests$.next(); // this cancels any pending http requests
            this.httpCancelRequests$.complete();
        }
        this.disposeColumnFilters();
        this._onSearchChange = null;
    }
    /**
     * Dispose of the filters, since it's a singleton, we don't want to affect other grids with same columns
     */
    disposeColumnFilters() {
        this.resetColumnFilters();
        // also destroy each Filter instances
        if (Array.isArray(this._filtersMetadata)) {
            this._filtersMetadata.forEach(filter => {
                if (filter === null || filter === void 0 ? void 0 : filter.destroy) {
                    filter.destroy();
                }
            });
        }
        this._filtersMetadata = [];
    }
    /**
     * When clearing or disposing of all filters, we need to loop through all columnFilters and delete them 1 by 1
     * only trying to make columnFilter an empty (without looping) would not trigger a dataset change
     */
    resetColumnFilters() {
        if (typeof this._columnFilters === 'object') {
            for (const columnId in this._columnFilters) {
                if (columnId && this._columnFilters[columnId]) {
                    delete this._columnFilters[columnId];
                }
            }
        }
    }
    /**
     * Bind a backend filter hook to the grid
     * @param grid SlickGrid Grid object
     */
    bindBackendOnFilter(grid) {
        this._filtersMetadata = [];
        // subscribe to SlickGrid onHeaderRowCellRendered event to create filter template
        this._eventHandler.subscribe(grid.onHeaderRowCellRendered, this.handleBackendOnSearchChange.bind(this));
        // subscribe to the SlickGrid event and call the backend execution
        if (this._onSearchChange) {
            this._eventHandler.subscribe(this._onSearchChange, this.onBackendFilterChange.bind(this));
        }
    }
    handleBackendOnSearchChange(_e, args) {
        // firstColumnIdRendered is null at first, so if it changes to being filled and equal, then we would know that it was already rendered
        // this is to avoid rendering the filter twice (only the Select Filter for now), rendering it again also clears the filter which has unwanted side effect
        if (args.column.id === this._firstColumnIdRendered) {
            this._isFilterFirstRender = false;
        }
        this.addFilterTemplateToHeaderRow(undefined, args, this._isFilterFirstRender);
        if (this._firstColumnIdRendered === '') {
            this._firstColumnIdRendered = args.column.id;
        }
    }
    /**
     * Bind a local filter hook to the grid
     * @param grid SlickGrid Grid object
     * @param dataView
     */
    bindLocalOnFilter(grid) {
        this._filtersMetadata = [];
        this._dataView.setFilterArgs({ columnFilters: this._columnFilters, grid: this._grid, dataView: this._dataView });
        this._dataView.setFilter(this.customLocalFilter.bind(this));
        // bind any search filter change (e.g. input filter input change event)
        if (this._onSearchChange) {
            this._eventHandler.subscribe(this._onSearchChange, this.handleLocalOnSearchChange.bind(this));
            // subscribe to SlickGrid onHeaderRowCellRendered event to create filter template
            this._eventHandler.subscribe(grid.onHeaderRowCellRendered, this.addFilterTemplateToHeaderRow.bind(this));
        }
    }
    handleLocalOnSearchChange(_e, args) {
        var _a;
        const isGridWithTreeData = this._gridOptions && this._gridOptions.enableTreeData || false;
        const isClearFilterEvent = (_a = args === null || args === void 0 ? void 0 : args.clearFilterTriggered) !== null && _a !== void 0 ? _a : false;
        // When using Tree Data, we need to do it in 2 steps
        // step 1. we need to prefilter (search) the data prior, the result will be an array of IDs which are the node(s) and their parent nodes when necessary.
        // step 2. calling the DataView.refresh() is what triggers the final filtering, with "customLocalFilter()" which will decide which rows should persist
        if (isGridWithTreeData) {
            this._tmpPreFilteredData = this.preFilterTreeData(this._dataView.getItems(), this._columnFilters);
        }
        const columnId = args.columnId;
        if (columnId !== null) {
            this._dataView.refresh();
        }
        // emit an onFilterChanged event when it's not called by a clear filter
        if (!isClearFilterEvent) {
            this.emitFilterChanged(EmitterType.local);
        }
    }
    clearFilterByColumnId(event, columnId) {
        var _a, _b;
        const isBackendApi = (_b = (_a = this._gridOptions) === null || _a === void 0 ? void 0 : _a.backendServiceApi) !== null && _b !== void 0 ? _b : false;
        const emitter = isBackendApi ? EmitterType.remote : EmitterType.local;
        // get current column filter before clearing, this allow us to know if the filter was empty prior to calling the clear filter
        const currentFilterColumnIds = Object.keys(this._columnFilters);
        let currentColFilter;
        if (Array.isArray(currentFilterColumnIds)) {
            currentColFilter = currentFilterColumnIds.find(name => name === `${columnId}`);
        }
        // find the filter object and call its clear method with true (the argument tells the method it was called by a clear filter)
        const colFilter = this._filtersMetadata.find((filter) => filter.columnDef.id === columnId);
        if (colFilter === null || colFilter === void 0 ? void 0 : colFilter.clear) {
            colFilter.clear(true);
        }
        // when using a backend service, we need to manually trigger a filter change but only if the filter was previously filled
        if (isBackendApi) {
            if (currentColFilter !== undefined) {
                this.onBackendFilterChange(event, { grid: this._grid, columnFilters: this._columnFilters });
            }
        }
        // emit an event when filter is cleared
        this.emitFilterChanged(emitter);
    }
    /** Clear the search filters (below the column titles) */
    clearFilters(triggerChange = true) {
        var _a, _b, _c, _d;
        this._filtersMetadata.forEach((filter) => {
            if (filter === null || filter === void 0 ? void 0 : filter.clear) {
                // clear element but don't trigger individual clear change,
                // we'll do 1 trigger for all filters at once afterward
                filter.clear(false);
            }
        });
        // also reset the columnFilters object and remove any filters from the object
        this.resetColumnFilters();
        // also remove any search terms directly on each column definitions
        if (Array.isArray(this._columnDefinitions)) {
            this._columnDefinitions.forEach((columnDef) => {
                var _a;
                if ((_a = columnDef.filter) === null || _a === void 0 ? void 0 : _a.searchTerms) {
                    delete columnDef.filter.searchTerms;
                }
            });
        }
        // we also need to refresh the dataView and optionally the grid (it's optional since we use DataView)
        if (this._dataView && this._grid) {
            this._dataView.refresh();
            this._grid.invalidate();
        }
        // when using backend service, we need to query only once so it's better to do it here
        const backendApi = (_a = this._gridOptions) === null || _a === void 0 ? void 0 : _a.backendServiceApi;
        if (backendApi && triggerChange) {
            const callbackArgs = { clearFilterTriggered: true, shouldTriggerQuery: triggerChange, grid: this._grid, columnFilters: this._columnFilters };
            const queryResponse = backendApi.service.processOnFilterChanged(undefined, callbackArgs);
            if (queryResponse instanceof Promise && queryResponse.then) {
                // @deprecated, processOnFilterChanged in the future should be returned as a query string NOT as a Promise
                console.warn(`[Angular-Slickgrid] please note that the "processOnFilterChanged" from your Backend Service, should now return a string instead of a Promise.
          Returning a Promise will be deprecated in the future.`);
                queryResponse.then((query) => {
                    var _a, _b, _c;
                    const totalItems = (_c = (_b = (_a = this._gridOptions) === null || _a === void 0 ? void 0 : _a.pagination) === null || _b === void 0 ? void 0 : _b.totalItems) !== null && _c !== void 0 ? _c : 0;
                    executeBackendCallback(backendApi, query, callbackArgs, new Date(), totalItems, this.emitFilterChanged.bind(this));
                });
            }
            else {
                const query = queryResponse;
                const totalItems = (_d = (_c = (_b = this._gridOptions) === null || _b === void 0 ? void 0 : _b.pagination) === null || _c === void 0 ? void 0 : _c.totalItems) !== null && _d !== void 0 ? _d : 0;
                executeBackendCallback(backendApi, query, callbackArgs, new Date(), totalItems, this.emitFilterChanged.bind(this));
            }
        }
        // emit an event when filters are all cleared
        if (triggerChange) {
            this.onFilterCleared.next(true);
        }
    }
    /** Local Grid Filter search */
    customLocalFilter(item, args) {
        var _a, _b, _c;
        const dataView = args && args.dataView;
        const grid = args && args.grid;
        const isGridWithTreeData = this._gridOptions && this._gridOptions.enableTreeData || false;
        const columnFilters = args && args.columnFilters || {};
        let treeDataOptions;
        // when the column is a Tree Data structure and the parent is collapsed, we won't go further and just continue with next row
        // so we always run this check even when there are no filter search, the reason is because the user might click on the expand/collapse
        if (isGridWithTreeData && this._gridOptions && this._gridOptions.treeDataOptions) {
            treeDataOptions = this._gridOptions.treeDataOptions;
            const collapsedPropName = (_a = treeDataOptions.collapsedPropName) !== null && _a !== void 0 ? _a : Constants.treeDataProperties.COLLAPSED_PROP;
            const parentPropName = (_b = treeDataOptions.parentPropName) !== null && _b !== void 0 ? _b : Constants.treeDataProperties.PARENT_PROP;
            const dataViewIdIdentifier = (_c = this._gridOptions.datasetIdPropertyName) !== null && _c !== void 0 ? _c : 'id';
            if (item[parentPropName] !== null) {
                let parent = this._dataView.getItemById(item[parentPropName]);
                while (parent) {
                    if (parent[collapsedPropName]) {
                        return false; // don't display any row that have their parent collapsed
                    }
                    parent = this._dataView.getItemById(parent[parentPropName]);
                }
            }
            // filter out any row items that aren't part of our pre-processed "preFilterTreeData()" result
            if (Array.isArray(this._tmpPreFilteredData)) {
                return this._tmpPreFilteredData.includes(item[dataViewIdIdentifier]); // return true when found, false otherwise
            }
        }
        else {
            if (typeof columnFilters === 'object') {
                for (const columnId of Object.keys(columnFilters)) {
                    const columnFilter = columnFilters[columnId];
                    const conditionOptions = this.preProcessFilterConditionOnDataContext(item, columnFilter, grid);
                    if (typeof conditionOptions === 'boolean') {
                        return conditionOptions;
                    }
                    let parsedSearchTerms = columnFilter && columnFilter.parsedSearchTerms; // parsed term could a single value or an array of values
                    // in the rare case that it's empty (it can happen when creating an external grid global search)
                    // then get the parsed terms, once it's filled it typically won't ask for it anymore
                    if (parsedSearchTerms === undefined) {
                        parsedSearchTerms = getParsedSearchTermsByFieldType(columnFilter.searchTerms, columnFilter.columnDef.type || FieldType.string); // parsed term could a single value or an array of values
                        if (parsedSearchTerms !== undefined) {
                            columnFilter.parsedSearchTerms = parsedSearchTerms;
                        }
                    }
                    // execute the filtering conditions check (all cell values vs search term(s))
                    if (!FilterConditions.executeFilterConditionTest(conditionOptions, parsedSearchTerms)) {
                        return false;
                    }
                }
            }
        }
        // if it reaches here, that means the row is valid and passed all filter
        return true;
    }
    /**
     * Loop through each form input search filter and parse their searchTerms,
     * for example a CompoundDate Filter will be parsed as a Moment object.
     * Also if we are dealing with a text filter input,
     * an operator can optionally be part of the filter itself and we need to extract it from there,
     * for example a filter of "John*" will be analyzed as { operator: StartsWith, searchTerms: ['John'] }
     * @param inputSearchTerms - filter search terms
     * @param columnFilter - column filter object (the object properties represent each column id and the value is the filter metadata)
     * @returns FilterConditionOption
     */
    parseFormInputFilterConditions(inputSearchTerms, columnFilter) {
        var _a, _b, _c;
        const searchValues = deepCopy(inputSearchTerms) || [];
        let fieldSearchValue = (Array.isArray(searchValues) && searchValues.length === 1) ? searchValues[0] : '';
        const columnDef = columnFilter.columnDef;
        const fieldType = (_c = (_b = (_a = columnDef.filter) === null || _a === void 0 ? void 0 : _a.type) !== null && _b !== void 0 ? _b : columnDef.type) !== null && _c !== void 0 ? _c : FieldType.string;
        let matches = null;
        if (fieldType !== FieldType.object) {
            fieldSearchValue = (fieldSearchValue === undefined || fieldSearchValue === null) ? '' : `${fieldSearchValue}`; // make sure it's a string
            matches = fieldSearchValue.match(/^([<>!=\*]{0,2})(.*[^<>!=\*])?([\*]?)$/); // group 1: Operator, 2: searchValue, 3: last char is '*' (meaning starts with, ex.: abc*)
        }
        let operator = (matches === null || matches === void 0 ? void 0 : matches[1]) || columnFilter.operator;
        const searchTerm = (matches === null || matches === void 0 ? void 0 : matches[2]) || '';
        const inputLastChar = (matches === null || matches === void 0 ? void 0 : matches[3]) || (operator === '*z' ? '*' : '');
        if (typeof fieldSearchValue === 'string') {
            fieldSearchValue = fieldSearchValue.replace(`'`, `''`); // escape any single quotes by doubling them
            if (operator === '*' || operator === '*z') {
                operator = OperatorType.endsWith;
            }
            else if (operator === 'a*' || inputLastChar === '*') {
                operator = OperatorType.startsWith;
            }
        }
        // if search value has a regex match we will only keep the value without the operator
        // in this case we need to overwrite the returned search values to truncate operator from the string search
        if (Array.isArray(matches) && matches.length >= 1 && (Array.isArray(searchValues) && searchValues.length === 1)) {
            searchValues[0] = searchTerm;
        }
        return {
            dataKey: columnDef.dataKey,
            fieldType,
            searchTerms: searchValues || [],
            operator: operator,
            searchInputLastChar: inputLastChar,
            filterSearchType: columnDef.filterSearchType,
            defaultFilterRangeOperator: this._gridOptions.defaultFilterRangeOperator,
        };
    }
    /**
     * PreProcess the filter(s) condition(s) on each item data context, the result might be a boolean or FilterConditionOption object.
     * It will be a boolean when the searchTerms are invalid or the column is not found (it so it will return True and the item won't be filtered out from the grid)
     * or else a FilterConditionOption object with the necessary info for the test condition needs to be processed in a further stage.
     * @param item - item data context
     * @param columnFilter - column filter object (the object properties represent each column id and the value is the filter metadata)
     * @param grid - SlickGrid object
     * @returns FilterConditionOption or boolean
     */
    preProcessFilterConditionOnDataContext(item, columnFilter, grid) {
        const columnDef = columnFilter.columnDef;
        const columnId = columnFilter.columnId;
        let columnIndex = grid.getColumnIndex(columnId);
        // it might be a hidden column, if so it won't be part of the getColumns (because it could be hidden via setColumns())
        // when that happens we can try to get the column definition from all defined columns
        if (!columnDef && this.sharedService && Array.isArray(this.sharedService.allColumns)) {
            columnIndex = this.sharedService.allColumns.findIndex(col => col.field === columnId);
        }
        // if we still don't have a column definition then we should return then row anyway (true)
        if (!columnDef) {
            return true;
        }
        // Row Detail View plugin, if the row is padding we just get the value we're filtering on from it's parent
        if (this._gridOptions.enableRowDetailView) {
            const metadataPrefix = this._gridOptions.rowDetailView && this._gridOptions.rowDetailView.keyPrefix || '__';
            if (item[`${metadataPrefix}isPadding`] && item[`${metadataPrefix}parent`]) {
                item = item[`${metadataPrefix}parent`];
            }
        }
        let queryFieldName = (columnDef.filter && columnDef.filter.queryField) || columnDef.queryFieldFilter || columnDef.queryField || columnDef.field || '';
        if (typeof columnDef.queryFieldNameGetterFn === 'function') {
            queryFieldName = columnDef.queryFieldNameGetterFn(item);
        }
        const fieldType = (columnDef.filter && columnDef.filter.type) || columnDef.type || FieldType.string;
        let cellValue = item[queryFieldName];
        // when item is a complex object (dot "." notation), we need to filter the value contained in the object tree
        if (queryFieldName && queryFieldName.indexOf('.') >= 0) {
            cellValue = getDescendantProperty(item, queryFieldName);
        }
        const operator = columnFilter.operator;
        const searchValues = columnFilter.searchTerms || [];
        // no need to query if search value is empty or if the search value is in fact equal to the operator
        if (!searchValues || (Array.isArray(searchValues) && (searchValues.length === 0 || searchValues.length === 1 && operator === searchValues[0]))) {
            return true;
        }
        // filter search terms should always be string type (even though we permit the end user to input numbers)
        // so make sure each term are strings, if user has some default search terms, we will cast them to string
        if (searchValues && Array.isArray(searchValues) && fieldType !== FieldType.object) {
            for (let k = 0, ln = searchValues.length; k < ln; k++) {
                // make sure all search terms are strings
                searchValues[k] = ((searchValues[k] === undefined || searchValues[k] === null) ? '' : searchValues[k]) + '';
            }
        }
        // when using localization (i18n), we should use the formatter output to search as the new cell value
        // we will also sanitize/remove HTML tags out of the text (which might be added by multiple-select)
        if (columnDef && columnDef.params && columnDef.params.useFormatterOuputToFilter) {
            const dataView = grid.getData();
            const idPropName = this._gridOptions.datasetIdPropertyName || 'id';
            const rowIndex = (dataView && typeof dataView.getIdxById === 'function') ? dataView.getIdxById(item[idPropName]) : 0;
            cellValue = (columnDef && typeof columnDef.formatter === 'function') ? columnDef.formatter(rowIndex || 0, columnIndex, cellValue, columnDef, item, this._grid) : '';
            cellValue = sanitizeHtmlToText(cellValue); // also remove any html tag
        }
        // make sure cell value is always a string
        if (typeof cellValue === 'number') {
            cellValue = cellValue.toString();
        }
        return {
            dataKey: columnDef.dataKey,
            fieldType,
            searchTerms: searchValues,
            cellValue,
            operator: operator,
            searchInputLastChar: columnFilter.searchInputLastChar,
            filterSearchType: columnDef.filterSearchType,
            defaultFilterRangeOperator: this._gridOptions.defaultFilterRangeOperator,
        };
    }
    /**
     * When using Tree Data, we need to prefilter (search) the data prior, the result will be an array of IDs which are the node(s) and their parent nodes when necessary.
     * This will then be passed to the DataView setFilter(customLocalFilter), which will itself loop through the list of IDs and display/hide the row if found that array of IDs
     * We do this in 2 steps so that we can still use the DataSet setFilter()
     */
    preFilterTreeData(inputItems, columnFilters) {
        var _a, _b, _c, _d, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        const treeDataOptions = (_a = this._gridOptions) === null || _a === void 0 ? void 0 : _a.treeDataOptions;
        const collapsedPropName = (_b = treeDataOptions === null || treeDataOptions === void 0 ? void 0 : treeDataOptions.collapsedPropName) !== null && _b !== void 0 ? _b : Constants.treeDataProperties.COLLAPSED_PROP;
        const parentPropName = (_c = treeDataOptions === null || treeDataOptions === void 0 ? void 0 : treeDataOptions.parentPropName) !== null && _c !== void 0 ? _c : Constants.treeDataProperties.PARENT_PROP;
        const dataViewIdIdentifier = (_f = (_d = this._gridOptions) === null || _d === void 0 ? void 0 : _d.datasetIdPropertyName) !== null && _f !== void 0 ? _f : 'id';
        const treeDataToggledItems = (_h = (_g = this._gridOptions.presets) === null || _g === void 0 ? void 0 : _g.treeData) === null || _h === void 0 ? void 0 : _h.toggledItems;
        const treeObj = {};
        const filteredChildrenAndParents = [];
        if (Array.isArray(inputItems)) {
            for (let i = 0; i < inputItems.length; i++) {
                treeObj[inputItems[i][dataViewIdIdentifier]] = inputItems[i];
                // as the filtered data is then used again as each subsequent letter
                // we need to delete the .__used property, otherwise the logic below
                // in the while loop (which checks for parents) doesn't work:
                delete treeObj[inputItems[i][dataViewIdIdentifier]].__used;
            }
            // Step 1. prepare search filter by getting their parsed value(s), for example if it's a date filter then parse it to a Moment object
            // loop through all column filters once and get parsed filter search value then save a reference in the columnFilter itself
            // it is much more effective to do it outside and prior to Step 2 so that we don't re-parse search filter for no reason while checking every row
            for (const columnId of Object.keys(columnFilters)) {
                const columnFilter = columnFilters[columnId];
                const searchValues = (columnFilter === null || columnFilter === void 0 ? void 0 : columnFilter.searchTerms) ? deepCopy(columnFilter.searchTerms) : [];
                const inputSearchConditions = this.parseFormInputFilterConditions(searchValues, columnFilter);
                const columnDef = columnFilter.columnDef;
                const fieldType = (_l = (_k = (_j = columnDef === null || columnDef === void 0 ? void 0 : columnDef.filter) === null || _j === void 0 ? void 0 : _j.type) !== null && _k !== void 0 ? _k : columnDef === null || columnDef === void 0 ? void 0 : columnDef.type) !== null && _l !== void 0 ? _l : FieldType.string;
                const parsedSearchTerms = getParsedSearchTermsByFieldType(inputSearchConditions.searchTerms, fieldType); // parsed term could a single value or an array of values
                if (parsedSearchTerms !== undefined) {
                    columnFilter.parsedSearchTerms = parsedSearchTerms;
                }
            }
            // Step 2. loop through every item data context to execute filter condition check
            for (let i = 0; i < inputItems.length; i++) {
                const item = inputItems[i];
                let matchFilter = true; // valid until proven otherwise
                // loop through all column filters and execute filter condition(s)
                for (const columnId of Object.keys(columnFilters)) {
                    const columnFilter = columnFilters[columnId];
                    const conditionOptionResult = this.preProcessFilterConditionOnDataContext(item, columnFilter, this._grid);
                    if (conditionOptionResult) {
                        const parsedSearchTerms = columnFilter === null || columnFilter === void 0 ? void 0 : columnFilter.parsedSearchTerms; // parsed term could a single value or an array of values
                        const conditionResult = (typeof conditionOptionResult === 'boolean') ? conditionOptionResult : FilterConditions.executeFilterConditionTest(conditionOptionResult, parsedSearchTerms);
                        if (conditionResult) {
                            // don't return true since we still need to check other keys in columnFilters
                            continue;
                        }
                    }
                    matchFilter = false;
                    continue;
                }
                // build an array from the matched filters, anything valid from filter condition
                // will be pushed to the filteredChildrenAndParents array
                if (matchFilter) {
                    const len = filteredChildrenAndParents.length;
                    // add child (id):
                    filteredChildrenAndParents.splice(len, 0, item[dataViewIdIdentifier]);
                    let parent = (_m = treeObj[item[parentPropName]]) !== null && _m !== void 0 ? _m : false;
                    // if there are any presets of collapsed parents, let's processed them
                    const shouldBeCollapsed = !((_o = this._gridOptions.treeDataOptions) === null || _o === void 0 ? void 0 : _o.initiallyCollapsed);
                    if (!this._isTreePresetExecuted && Array.isArray(treeDataToggledItems) && treeDataToggledItems.some(collapsedItem => collapsedItem.itemId === parent.id && collapsedItem.isCollapsed === shouldBeCollapsed)) {
                        parent[collapsedPropName] = shouldBeCollapsed;
                    }
                    while (parent) {
                        // only add parent (id) if not already added:
                        (_p = parent.__used) !== null && _p !== void 0 ? _p : filteredChildrenAndParents.splice(len, 0, parent[dataViewIdIdentifier]);
                        // mark each parent as used to not use them again later:
                        treeObj[parent[dataViewIdIdentifier]].__used = true;
                        // try to find parent of the current parent, if exists:
                        parent = (_q = treeObj[parent[parentPropName]]) !== null && _q !== void 0 ? _q : false;
                    }
                }
            }
        }
        this._isTreePresetExecuted = true;
        return filteredChildrenAndParents;
    }
    getColumnFilters() {
        return this._columnFilters;
    }
    getFiltersMetadata() {
        return this._filtersMetadata;
    }
    getCurrentLocalFilters() {
        var _a, _b;
        const currentFilters = [];
        if (this._columnFilters) {
            for (const colId of Object.keys(this._columnFilters)) {
                const columnFilter = this._columnFilters[colId];
                const filter = { columnId: colId || '' };
                const columnDef = this.sharedService.allColumns.find(col => col.id === filter.columnId);
                const emptySearchTermReturnAllValues = (_b = (_a = columnDef === null || columnDef === void 0 ? void 0 : columnDef.filter) === null || _a === void 0 ? void 0 : _a.emptySearchTermReturnAllValues) !== null && _b !== void 0 ? _b : true;
                if (columnFilter && columnFilter.searchTerms) {
                    filter.searchTerms = columnFilter.searchTerms;
                }
                if (columnFilter.operator) {
                    filter.operator = columnFilter.operator;
                }
                if (Array.isArray(filter.searchTerms) && filter.searchTerms.length > 0 && (!emptySearchTermReturnAllValues || filter.searchTerms[0] !== '')) {
                    currentFilters.push(filter);
                }
            }
        }
        return currentFilters;
    }
    /**
     * A simple function that will be called to emit a change when a filter changes.
     * Other services, like Pagination, can then subscribe to it.
     * @param caller
     */
    emitFilterChanged(caller) {
        if (caller === EmitterType.remote && this._gridOptions && this._gridOptions.backendServiceApi) {
            let currentFilters = [];
            const backendService = this._gridOptions.backendServiceApi.service;
            if (backendService && backendService.getCurrentFilters) {
                currentFilters = backendService.getCurrentFilters();
            }
            this.onFilterChanged.next(currentFilters);
        }
        else if (caller === EmitterType.local) {
            this.onFilterChanged.next(this.getCurrentLocalFilters());
        }
    }
    onBackendFilterChange(event, args) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!args || !args.grid) {
                throw new Error('Something went wrong when trying to bind the "onBackendFilterChange(event, args)" function, it seems that "args" is not populated correctly');
            }
            const backendApi = this._gridOptions.backendServiceApi;
            if (!backendApi || !backendApi.process || !backendApi.service) {
                throw new Error(`BackendServiceApi requires at least a "process" function and a "service" defined`);
            }
            // keep start time & end timestamps & return it after process execution
            const startTime = new Date();
            // run a preProcess callback if defined
            if (backendApi.preProcess) {
                backendApi.preProcess();
            }
            // query backend, except when it's called by a ClearFilters then we won't
            if (args === null || args === void 0 ? void 0 : args.shouldTriggerQuery) {
                const query = yield backendApi.service.processOnFilterChanged(event, args);
                const totalItems = this._gridOptions && this._gridOptions.pagination && this._gridOptions.pagination.totalItems || 0;
                executeBackendCallback(backendApi, query, args, startTime, totalItems, this.emitFilterChanged.bind(this));
            }
        });
    }
    /**
     * When user passes an array of preset filters, we need to pre-populate each column filter searchTerm(s)
     * The process is to loop through the preset filters array, find the associated column from columnDefinitions and fill in the filter object searchTerm(s)
     * This is basically the same as if we would manually add searchTerm(s) to a column filter object in the column definition, but we do it programmatically.
     * At the end of the day, when creating the Filter (DOM Element), it will use these searchTerm(s) so we can take advantage of that without recoding each Filter type (DOM element)
     */
    populateColumnFilterSearchTermPresets(filters) {
        var _a;
        if (Array.isArray(filters)) {
            this._columnDefinitions.forEach((columnDef) => {
                // clear any columnDef searchTerms before applying Presets
                if (columnDef.filter && columnDef.filter.searchTerms) {
                    delete columnDef.filter.searchTerms;
                }
                // from each presets, we will find the associated columnDef and apply the preset searchTerms & operator if there is
                const columnPreset = filters.find((presetFilter) => presetFilter.columnId === columnDef.id);
                if (columnPreset && columnPreset.searchTerms && Array.isArray(columnPreset.searchTerms)) {
                    columnDef.filter = columnDef.filter || {};
                    columnDef.filter.operator = columnPreset.operator || columnDef.filter.operator || '';
                    columnDef.filter.searchTerms = columnPreset.searchTerms;
                }
            });
            // when we have a Filter Presets on a Tree Data View grid, we need to call the pre-filtering of tree data
            if ((_a = this._gridOptions) === null || _a === void 0 ? void 0 : _a.enableTreeData) {
                this.refreshTreeDataFilters();
            }
        }
        return this._columnDefinitions;
    }
    /**
     * when we have a Filter Presets on a Tree Data View grid, we need to call the pre-filtering of tree data
     * we need to do this because Tree Data is the only type of grid that requires a pre-filter (preFilterTreeData) to be executed before the final filtering
     * @param {Array<Object>} [items] - optional flat array of parent/child items to use while redoing the full sort & refresh
     */
    refreshTreeDataFilters(items) {
        var _a, _b, _c, _d;
        const inputItems = (_c = items !== null && items !== void 0 ? items : (_b = (_a = this._dataView) === null || _a === void 0 ? void 0 : _a.getItems) === null || _b === void 0 ? void 0 : _b.call(_a)) !== null && _c !== void 0 ? _c : [];
        if (this._dataView && ((_d = this._gridOptions) === null || _d === void 0 ? void 0 : _d.enableTreeData) && inputItems.length > 0) {
            this._tmpPreFilteredData = this.preFilterTreeData(inputItems, this._columnFilters);
            this._dataView.refresh(); // and finally this refresh() is what triggers a DataView filtering check
        }
        else if (inputItems.length === 0 && Array.isArray(this.sharedService.hierarchicalDataset) && this.sharedService.hierarchicalDataset.length > 0) {
            // in some occasion, we might be dealing with a dataset that is hierarchical from the start (the source dataset is already a tree structure)
            // and we did not have time to convert it to a flat dataset yet (for SlickGrid to use),
            // we would end up calling the pre-filter too early because these pre-filter works only a flat dataset
            // for that use case (like Example 29), we need to delay for at least a cycle the pre-filtering (so we can simply recall the same method after a delay of 0 which equal to 1 CPU cycle)
            setTimeout(() => this.refreshTreeDataFilters());
        }
    }
    /**
     * Toggle the Filter Functionality
     * @param {boolean} isFilterDisabled - optionally force a disable/enable of the Sort Functionality? Defaults to True
     * @param {boolean} clearFiltersWhenDisabled - when disabling the Filter, do we also want to clear all the filters as well? Defaults to True
     */
    disableFilterFunctionality(isFilterDisabled = true, clearFiltersWhenDisabled = true) {
        const prevShowFilterFlag = this._gridOptions.enableFiltering;
        const newShowFilterFlag = !prevShowFilterFlag;
        if (newShowFilterFlag !== isFilterDisabled) {
            if (clearFiltersWhenDisabled && isFilterDisabled) {
                this.clearFilters();
            }
            this.disableAllFilteringCommands(isFilterDisabled);
            this._grid.setOptions({ enableFiltering: newShowFilterFlag }, false, true);
            this._grid.setHeaderRowVisibility(newShowFilterFlag);
            this._gridOptions.enableFiltering = !isFilterDisabled;
            this.sharedService.gridOptions = this._gridOptions;
            // when displaying header row, we'll call "setColumns" which in terms will recreate the header row filters
            this._grid.setColumns(this.sharedService.columnDefinitions);
        }
    }
    /**
     * Toggle the Filter Functionality (show/hide the header row filter bar as well)
     * @param {boolean} clearFiltersWhenDisabled - when disabling the filters, do we want to clear the filters before hiding the filters? Defaults to True
     */
    toggleFilterFunctionality(clearFiltersWhenDisabled = true) {
        const prevShowFilterFlag = this._gridOptions.enableFiltering;
        this.disableFilterFunctionality(prevShowFilterFlag, clearFiltersWhenDisabled);
    }
    /**
     * Toggle the Header Row filter bar (this does not disable the Filtering itself, you can use "toggleFilterFunctionality()" instead, however this will reset any column positions)
     */
    toggleHeaderFilterRow() {
        let showHeaderRow = this._gridOptions && this._gridOptions.showHeaderRow || false;
        showHeaderRow = !showHeaderRow; // inverse show header flag
        this._grid.setHeaderRowVisibility(showHeaderRow);
        // when displaying header row, we'll call "setColumns" which in terms will recreate the header row filters
        if (showHeaderRow === true) {
            this._grid.setColumns(this.sharedService.columnDefinitions);
        }
    }
    /**
     * Set the sort icons in the UI (ONLY the icons, it does not do any sorting)
     * The column sort icons are not necessarily inter-connected to the sorting functionality itself,
     * you can change the sorting icons separately by passing an array of columnId/sortAsc and that will change ONLY the icons
     * @param sortColumns
     */
    setSortColumnIcons(sortColumns) {
        if (this._grid && Array.isArray(sortColumns)) {
            this._grid.setSortColumns(sortColumns);
        }
    }
    /**
     * Update Filters dynamically just by providing an array of filter(s).
     * You can also choose emit (default) a Filter Changed event that will be picked by the Grid State Service.
     *
     * Also for backend service only, you can choose to trigger a backend query (default) or not if you wish to do it later,
     * this could be useful when using updateFilters & updateSorting and you wish to only send the backend query once.
     * @param filters array
     * @param triggerEvent defaults to True, do we want to emit a filter changed event?
     * @param triggerBackendQuery defaults to True, which will query the backend.
     * @param triggerOnSearchChangeEvent defaults to False, can be useful with Tree Data structure where the onSearchEvent has to run to execute a prefiltering step
     */
    updateFilters(filters, emitChangedEvent = true, triggerBackendQuery = true, triggerOnSearchChangeEvent = false) {
        if (!this._filtersMetadata || this._filtersMetadata.length === 0 || !this._gridOptions || !this._gridOptions.enableFiltering) {
            throw new Error('[Angular-Slickgrid] in order to use "updateFilters" method, you need to have Filterable Columns defined in your grid and "enableFiltering" set in your Grid Options');
        }
        if (Array.isArray(filters)) {
            // start by clearing all filters (without triggering an event) before applying any new filters
            this.clearFilters(false);
            // pre-fill (value + operator) and render all filters in the DOM
            // loop through each Filters provided (which has a columnId property)
            // then find their associated Filter instances that were originally created in the grid
            filters.forEach((newFilter) => {
                var _a;
                const uiFilter = this._filtersMetadata.find((filter) => newFilter.columnId === filter.columnDef.id);
                if (newFilter && uiFilter) {
                    const newOperator = newFilter.operator || uiFilter.defaultOperator;
                    this.updateColumnFilters(newFilter.searchTerms, uiFilter.columnDef, newOperator);
                    uiFilter.setValues(newFilter.searchTerms || [], newOperator);
                    if (triggerOnSearchChangeEvent || ((_a = this._gridOptions) === null || _a === void 0 ? void 0 : _a.enableTreeData)) {
                        this.callbackSearchEvent(undefined, { columnDef: uiFilter.columnDef, operator: newOperator, searchTerms: newFilter.searchTerms, shouldTriggerQuery: true, forceOnSearchChangeEvent: true });
                    }
                }
            });
            const backendApi = this._gridOptions && this._gridOptions.backendServiceApi;
            // refresh the DataView and trigger an event after all filters were updated and rendered
            this._dataView.refresh();
            if (backendApi) {
                const backendApiService = backendApi && backendApi.service;
                if (backendApiService && backendApiService.updateFilters) {
                    backendApiService.updateFilters(filters, true);
                    if (triggerBackendQuery) {
                        refreshBackendDataset(this._gridOptions);
                    }
                }
            }
            if (emitChangedEvent) {
                const emitterType = backendApi ? EmitterType.remote : EmitterType.local;
                this.emitFilterChanged(emitterType);
            }
        }
    }
    /**
     * **NOTE**: This should only ever be used when having a global external search and hidding the grid inline filters (with `enableFiltering: true` and `showHeaderRow: false`).
     * For inline filters, please use `updateFilters()` instead.
     *
     * Update a Single Filter dynamically just by providing (columnId, operator and searchTerms)
     * You can also choose emit (default) a Filter Changed event that will be picked by the Grid State Service.
     * Also for backend service only, you can choose to trigger a backend query (default) or not if you wish to do it later,
     * this could be useful when using updateFilters & updateSorting and you wish to only send the backend query once.
     * @param filters array
     * @param triggerEvent defaults to True, do we want to emit a filter changed event?
     * @param triggerBackendQuery defaults to True, which will query the backend.
     */
    updateSingleFilter(filter, emitChangedEvent = true, triggerBackendQuery = true) {
        var _a, _b, _c;
        const columnDef = this.sharedService.allColumns.find(col => col.id === filter.columnId);
        if (columnDef && filter.columnId) {
            this._columnFilters = {};
            const emptySearchTermReturnAllValues = (_b = (_a = columnDef.filter) === null || _a === void 0 ? void 0 : _a.emptySearchTermReturnAllValues) !== null && _b !== void 0 ? _b : true;
            if (Array.isArray(filter.searchTerms) && (filter.searchTerms.length > 1 || (filter.searchTerms.length === 1 && (!emptySearchTermReturnAllValues || filter.searchTerms[0] !== '')))) {
                // pass a columnFilter object as an object which it's property name must be a column field name (e.g.: 'duration': {...} )
                this._columnFilters[filter.columnId] = {
                    columnId: filter.columnId,
                    operator: filter.operator,
                    searchTerms: filter.searchTerms,
                    columnDef,
                    type: columnDef.type || FieldType.string,
                };
            }
            const backendApi = this._gridOptions && this._gridOptions.backendServiceApi;
            if (backendApi) {
                const backendApiService = backendApi && backendApi.service;
                if (backendApiService && backendApiService.updateFilters) {
                    backendApiService.updateFilters(this._columnFilters, true);
                    if (triggerBackendQuery) {
                        refreshBackendDataset(this._gridOptions);
                    }
                }
            }
            else {
                this._dataView.setFilterArgs({
                    columnFilters: this._columnFilters,
                    grid: this._grid
                });
                // when using Tree Data, we also need to refresh the filters because of the tree structure with recursion
                if ((_c = this._gridOptions) === null || _c === void 0 ? void 0 : _c.enableTreeData) {
                    this.refreshTreeDataFilters();
                }
                this._dataView.refresh();
            }
            if (emitChangedEvent) {
                const emitterType = backendApi ? EmitterType.remote : EmitterType.local;
                this.emitFilterChanged(emitterType);
            }
        }
    }
    // --
    // protected functions
    // -------------------
    /** Add all created filters (from their template) to the header row section area */
    addFilterTemplateToHeaderRow(_event, args, isFilterFirstRender = true) {
        const columnDef = args.column;
        const columnId = columnDef && columnDef.id || '';
        if (columnDef && columnId !== 'selector' && columnDef.filterable) {
            let searchTerms;
            let operator;
            const newFilter = this.filterFactory.createFilter(columnDef.filter);
            operator = (columnDef && columnDef.filter && columnDef.filter.operator) || (newFilter && newFilter.operator);
            if (this._columnFilters[columnDef.id]) {
                searchTerms = this._columnFilters[columnDef.id].searchTerms || undefined;
                operator = this._columnFilters[columnDef.id].operator || undefined;
            }
            else if (columnDef.filter) {
                // when hiding/showing (with Column Picker or Grid Menu), it will try to re-create yet again the filters (since SlickGrid does a re-render)
                // because of that we need to first get searchTerm(s) from the columnFilters (that is what the user last typed in a filter search input)
                searchTerms = columnDef.filter.searchTerms || undefined;
                this.updateColumnFilters(searchTerms, columnDef, operator);
            }
            const filterArguments = {
                grid: this._grid,
                operator,
                searchTerms,
                columnDef,
                callback: this.callbackSearchEvent.bind(this)
            };
            if (newFilter) {
                newFilter.init(filterArguments, isFilterFirstRender);
                const filterExistIndex = this._filtersMetadata.findIndex((filter) => newFilter.columnDef.id === filter.columnDef.id);
                // add to the filters arrays or replace it when found
                if (filterExistIndex === -1) {
                    this._filtersMetadata.push(newFilter);
                }
                else {
                    this._filtersMetadata[filterExistIndex] = newFilter;
                }
                // when hiding/showing (with Column Picker or Grid Menu), it will try to re-create yet again the filters (since SlickGrid does a re-render)
                // we need to also set again the values in the DOM elements if the values were set by a searchTerm(s)
                if (searchTerms && newFilter.setValues) {
                    newFilter.setValues(searchTerms, operator);
                }
            }
        }
    }
    /**
     * Callback method that is called and executed by the individual Filter (DOM element),
     * for example when user starts typing chars on a search input (which uses InputFilter), this Filter will execute the callback from an input change event.
     */
    callbackSearchEvent(event, args) {
        var _a, _b;
        if (args) {
            const searchTerm = ((event && event.target) ? event.target.value : undefined);
            const searchTerms = (args.searchTerms && Array.isArray(args.searchTerms)) ? args.searchTerms : (searchTerm ? [searchTerm] : undefined);
            const columnDef = args.columnDef || null;
            const columnId = columnDef && columnDef.id || '';
            const fieldType = columnDef && columnDef.filter && columnDef.filter.type || columnDef && columnDef.type || FieldType.string;
            const operator = args.operator || undefined;
            const hasSearchTerms = searchTerms && Array.isArray(searchTerms);
            const termsCount = hasSearchTerms && searchTerms && searchTerms.length;
            const oldColumnFilters = Object.assign({}, this._columnFilters);
            const emptySearchTermReturnAllValues = (_b = (_a = columnDef.filter) === null || _a === void 0 ? void 0 : _a.emptySearchTermReturnAllValues) !== null && _b !== void 0 ? _b : true;
            let parsedSearchTerms;
            if (columnDef && columnId) {
                if (!hasSearchTerms || termsCount === 0 || (termsCount === 1 && Array.isArray(searchTerms) && emptySearchTermReturnAllValues && searchTerms[0] === '')) {
                    // delete the property from the columnFilters when it becomes empty
                    // without doing this, it would leave an incorrect state of the previous column filters when filtering on another column
                    delete this._columnFilters[columnId];
                }
                else {
                    const colId = `${columnId}`;
                    const colFilter = {
                        columnId: colId,
                        columnDef,
                        parsedSearchTerms: [],
                        type: fieldType
                    };
                    const inputSearchConditions = this.parseFormInputFilterConditions(searchTerms, colFilter);
                    colFilter.operator = operator || inputSearchConditions.operator || mapOperatorByFieldType(fieldType);
                    parsedSearchTerms = getParsedSearchTermsByFieldType(inputSearchConditions.searchTerms, fieldType);
                    if (parsedSearchTerms !== undefined) {
                        colFilter.parsedSearchTerms = parsedSearchTerms;
                    }
                    // use searchTerms only coming from the input search result because original terms might include extra operator symbols within their string
                    // and the input search result would be correctly stripped them from input result and assigned to the appropriate operator
                    // for example we might have: { searchTerms: ['*doe'] } and that should be reassigned to: { operator: EndsWith, searchTerms: 'doe' }
                    colFilter.searchTerms = inputSearchConditions.searchTerms || [];
                    this._columnFilters[colId] = colFilter;
                }
            }
            // event might have been created as a CustomEvent (e.g. CompoundDateFilter), without being a valid Slick.EventData,
            // if so we will create a new Slick.EventData and merge it with that CustomEvent to avoid having SlickGrid errors
            const eventData = (event && typeof event.isPropagationStopped !== 'function') ? $.extend({}, new Slick.EventData(), event) : event;
            // trigger an event only if Filters changed or if ENTER key was pressed
            const eventKey = event && event.key;
            const eventKeyCode = event && event.keyCode;
            if (this._onSearchChange && (args.forceOnSearchChangeEvent || eventKey === 'Enter' || eventKeyCode === KeyCode.ENTER || !dequal(oldColumnFilters, this._columnFilters))) {
                this._onSearchChange.notify({
                    clearFilterTriggered: args.clearFilterTriggered,
                    shouldTriggerQuery: args.shouldTriggerQuery,
                    columnId,
                    columnDef,
                    columnFilters: this._columnFilters,
                    operator: operator || mapOperatorByFieldType(fieldType),
                    searchTerms,
                    parsedSearchTerms,
                    grid: this._grid
                }, eventData);
            }
        }
    }
    /**
     * Loop through all column definitions and do the following thing
     * 1. loop through each Header Menu commands and change the "hidden" commands to show/hide depending if it's enabled/disabled
     * Also note that we aren't deleting any properties, we just toggle their flags so that we can reloop through at later point in time.
     * (if we previously deleted these properties we wouldn't be able to change them back since these properties wouldn't exist anymore, hence why we just hide the commands)
     * @param {boolean} isDisabling - are we disabling the filter functionality? Defaults to true
     */
    disableAllFilteringCommands(isDisabling = true) {
        const columnDefinitions = this._grid.getColumns();
        // loop through column definition to hide/show header menu commands
        columnDefinitions.forEach((col) => {
            if (col && col.header && col.header.menu) {
                col.header.menu.items.forEach(menuItem => {
                    if (menuItem && typeof menuItem !== 'string') {
                        const menuCommand = menuItem.command;
                        if (menuCommand === 'clear-filter') {
                            menuItem.hidden = isDisabling;
                        }
                    }
                });
            }
        });
        // loop through column definition to hide/show grid menu commands
        if (this._gridOptions && this._gridOptions.gridMenu && this._gridOptions.gridMenu.customItems) {
            this._gridOptions.gridMenu.customItems.forEach((menuItem) => {
                if (menuItem && typeof menuItem !== 'string') {
                    const menuCommand = menuItem.command;
                    if (menuCommand === 'clear-filter' || menuCommand === 'toggle-filter') {
                        menuItem.hidden = isDisabling;
                    }
                }
            });
        }
        return columnDefinitions;
    }
    updateColumnFilters(searchTerms, columnDef, operator) {
        const fieldType = columnDef && columnDef.filter && columnDef.filter.type || columnDef && columnDef.type || FieldType.string;
        const parsedSearchTerms = getParsedSearchTermsByFieldType(searchTerms, fieldType); // parsed term could a single value or an array of values
        if (searchTerms && columnDef) {
            this._columnFilters[columnDef.id] = {
                columnId: columnDef.id,
                columnDef,
                searchTerms,
                operator,
                parsedSearchTerms,
                type: fieldType,
            };
        }
    }
}
FilterService.ɵfac = function FilterService_Factory(t) { return new (t || FilterService)(ɵngcc0.ɵɵinject(FilterFactory), ɵngcc0.ɵɵinject(SharedService)); };
FilterService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: FilterService, factory: FilterService.ɵfac });
FilterService.ctorParameters = () => [
    { type: FilterFactory },
    { type: SharedService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FilterService, [{
        type: Injectable
    }], function () { return [{ type: FilterFactory }, { type: SharedService }]; }, null); })();

class GridMenuExtension {
    constructor(excelExportService, exportService, extensionUtility, filterService, sharedService, sortService, translate) {
        this.excelExportService = excelExportService;
        this.exportService = exportService;
        this.extensionUtility = extensionUtility;
        this.filterService = filterService;
        this.sharedService = sharedService;
        this.sortService = sortService;
        this.translate = translate;
        this._areVisibleColumnDifferent = false;
        this._eventHandler = new Slick.EventHandler();
    }
    get eventHandler() {
        return this._eventHandler;
    }
    dispose() {
        var _a, _b, _c;
        // unsubscribe all SlickGrid events
        this._eventHandler.unsubscribeAll();
        if ((_a = this._addon) === null || _a === void 0 ? void 0 : _a.destroy) {
            this._addon.destroy();
        }
        if ((_c = (_b = this.sharedService.gridOptions) === null || _b === void 0 ? void 0 : _b.gridMenu) === null || _c === void 0 ? void 0 : _c.customItems) {
            this.sharedService.gridOptions.gridMenu = this._userOriginalGridMenu;
        }
        this.extensionUtility.nullifyFunctionNameStartingWithOn(this._gridMenuOptions);
        this._addon = null;
        this._gridMenuOptions = null;
    }
    /** Get the instance of the SlickGrid addon (control or plugin). */
    getAddonInstance() {
        return this._addon;
    }
    /** Create the Header Menu and expose all the available hooks that user can subscribe (onCommand, onBeforeMenuShow, ...) */
    register() {
        var _a, _b, _c, _d, _e;
        if (((_a = this.sharedService.gridOptions) === null || _a === void 0 ? void 0 : _a.enableTranslate) && (!this.translate || !this.translate.instant)) {
            throw new Error('[Angular-Slickgrid] requires "ngx-translate" to be installed and configured when the grid option "enableTranslate" is enabled.');
        }
        if ((_c = (_b = this.sharedService) === null || _b === void 0 ? void 0 : _b.gridOptions) === null || _c === void 0 ? void 0 : _c.gridMenu) {
            // keep original user grid menu, useful when switching locale to translate
            this._userOriginalGridMenu = Object.assign({}, this.sharedService.gridOptions.gridMenu);
            // get locales provided by user in forRoot or else use default English locales via the Constants
            this._locales = (_e = (_d = this.sharedService.gridOptions) === null || _d === void 0 ? void 0 : _d.locales) !== null && _e !== void 0 ? _e : Constants.locales;
            this._gridMenuOptions = Object.assign(Object.assign({}, this.getDefaultGridMenuOptions()), this.sharedService.gridOptions.gridMenu);
            this.sharedService.gridOptions.gridMenu = this._gridMenuOptions;
            // merge original user grid menu items with internal items
            // then sort all Grid Menu Custom Items (sorted by pointer, no need to use the return)
            const originalCustomItems = this._userOriginalGridMenu && Array.isArray(this._userOriginalGridMenu.customItems) ? this._userOriginalGridMenu.customItems : [];
            this._gridMenuOptions.customItems = [...originalCustomItems, ...this.addGridMenuCustomCommands(originalCustomItems)];
            this.extensionUtility.translateItems(this._gridMenuOptions.customItems, 'titleKey', 'title');
            this.extensionUtility.sortItems(this._gridMenuOptions.customItems, 'positionOrder');
            this._addon = new Slick.Controls.GridMenu(this.sharedService.allColumns, this.sharedService.grid, this.sharedService.gridOptions);
            // hook all events
            if (this._gridMenuOptions) {
                if (this._gridMenuOptions.onExtensionRegistered) {
                    this._gridMenuOptions.onExtensionRegistered(this._addon);
                }
                if (this._gridMenuOptions && typeof this._gridMenuOptions.onBeforeMenuShow === 'function') {
                    this._eventHandler.subscribe(this._addon.onBeforeMenuShow, (e, args) => {
                        if (this._gridMenuOptions && this._gridMenuOptions.onBeforeMenuShow) {
                            this._gridMenuOptions.onBeforeMenuShow(e, args);
                        }
                    });
                }
                if (this._gridMenuOptions && typeof this._gridMenuOptions.onAfterMenuShow === 'function') {
                    this._eventHandler.subscribe(this._addon.onAfterMenuShow, (e, args) => {
                        if (this._gridMenuOptions && this._gridMenuOptions.onAfterMenuShow) {
                            this._gridMenuOptions.onAfterMenuShow(e, args);
                        }
                    });
                }
                this._eventHandler.subscribe(this._addon.onColumnsChanged, (e, args) => {
                    this._areVisibleColumnDifferent = true;
                    if (this._gridMenuOptions && typeof this._gridMenuOptions.onColumnsChanged === 'function') {
                        this._gridMenuOptions.onColumnsChanged(e, args);
                    }
                    // keep reference to the updated visible columns list
                    if (args && Array.isArray(args.columns) && args.columns.length > this.sharedService.visibleColumns.length) {
                        this.sharedService.visibleColumns = args.columns;
                    }
                    // when using row selection, SlickGrid will only apply the "selected" CSS class on the visible columns only
                    // and if the row selection was done prior to the column being shown then that column that was previously hidden (at the time of the row selection)
                    // will not have the "selected" CSS class because it wasn't visible at the time.
                    // To bypass this problem we can simply recall the row selection with the same selection and that will trigger a re-apply of the CSS class
                    // on all columns including the column we just made visible
                    if (this.sharedService.gridOptions.enableRowSelection && args.showing) {
                        args.grid.setSelectedRows(args.grid.getSelectedRows());
                    }
                    // if we're using frozen columns, we need to readjust pinning when the new hidden column becomes visible again on the left pinning container
                    // we need to readjust frozenColumn index because SlickGrid freezes by index and has no knowledge of the columns themselves
                    const frozenColumnIndex = this.sharedService.gridOptions.frozenColumn !== undefined ? this.sharedService.gridOptions.frozenColumn : -1;
                    if (frozenColumnIndex >= 0) {
                        const { allColumns, columns: visibleColumns } = args;
                        this.extensionUtility.readjustFrozenColumnIndexWhenNeeded(frozenColumnIndex, allColumns, visibleColumns);
                    }
                });
                this._eventHandler.subscribe(this._addon.onCommand, (e, args) => {
                    this.executeGridMenuInternalCustomCommands(e, args);
                    if (this._gridMenuOptions && typeof this._gridMenuOptions.onCommand === 'function') {
                        this._gridMenuOptions.onCommand(e, args);
                    }
                });
                this._eventHandler.subscribe(this._addon.onMenuClose, (e, args) => {
                    if (this._gridMenuOptions && typeof this._gridMenuOptions.onMenuClose === 'function') {
                        this._gridMenuOptions.onMenuClose(e, args);
                    }
                    // we also want to resize the columns if the user decided to hide certain column(s)
                    if (this.sharedService.grid && typeof this.sharedService.grid.autosizeColumns === 'function') {
                        // make sure that the grid still exist (by looking if the Grid UID is found in the DOM tree)
                        const gridUid = this.sharedService.grid.getUID();
                        if (this._areVisibleColumnDifferent && gridUid && document.querySelector(`.${gridUid}`) !== null) {
                            const gridOptions = this.sharedService.grid.getOptions();
                            if (gridOptions.enableAutoSizeColumns) {
                                this.sharedService.grid.autosizeColumns();
                            }
                            this._areVisibleColumnDifferent = false;
                        }
                    }
                });
            }
            return this._addon;
        }
        return null;
    }
    /** Refresh the dataset through the Backend Service */
    refreshBackendDataset(gridOptions) {
        // user can pass new set of grid options which will override current ones
        if (gridOptions) {
            this.sharedService.gridOptions = Object.assign(Object.assign({}, this.sharedService.gridOptions), gridOptions);
        }
        refreshBackendDataset(this.sharedService.gridOptions);
    }
    showGridMenu(e) {
        this._addon.showGridMenu(e);
    }
    /** Translate the Grid Menu titles and column picker */
    translateGridMenu() {
        var _a, _b;
        // update the properties by pointers, that is the only way to get Grid Menu Control to see the new values
        // we also need to call the control init so that it takes the new Grid object with latest values
        if ((_b = (_a = this.sharedService) === null || _a === void 0 ? void 0 : _a.gridOptions) === null || _b === void 0 ? void 0 : _b.gridMenu) {
            this.sharedService.gridOptions.gridMenu.customItems = [];
            this.emptyGridMenuTitles();
            // merge original user grid menu items with internal items
            // then sort all Grid Menu Custom Items (sorted by pointer, no need to use the return)
            const originalCustomItems = this._userOriginalGridMenu && Array.isArray(this._userOriginalGridMenu.customItems) ? this._userOriginalGridMenu.customItems : [];
            this.sharedService.gridOptions.gridMenu.customItems = [...originalCustomItems, ...this.addGridMenuCustomCommands(originalCustomItems)];
            this.extensionUtility.translateItems(this.sharedService.gridOptions.gridMenu.customItems, 'titleKey', 'title');
            this.extensionUtility.sortItems(this.sharedService.gridOptions.gridMenu.customItems, 'positionOrder');
            this.sharedService.gridOptions.gridMenu.columnTitle = this.extensionUtility.getPickerTitleOutputString('columnTitle', 'gridMenu');
            this.sharedService.gridOptions.gridMenu.forceFitTitle = this.extensionUtility.getPickerTitleOutputString('forceFitTitle', 'gridMenu');
            this.sharedService.gridOptions.gridMenu.syncResizeTitle = this.extensionUtility.getPickerTitleOutputString('syncResizeTitle', 'gridMenu');
            // translate all columns (including non-visible)
            // eventually deprecate the "headerKey" and use only the "nameKey"
            this.extensionUtility.translateItems(this.sharedService.allColumns, 'headerKey', 'name');
            this.extensionUtility.translateItems(this.sharedService.allColumns, 'nameKey', 'name');
            // update the Titles of each sections (command, customTitle, ...)
            if (this._addon && this._addon.updateAllTitles) {
                this._addon.updateAllTitles(this.sharedService.gridOptions.gridMenu);
            }
        }
    }
    // --
    // private functions
    // ------------------
    /** Create Grid Menu with Custom Commands if user has enabled Filters and/or uses a Backend Service (OData, GraphQL) */
    addGridMenuCustomCommands(originalCustomItems) {
        var _a;
        const backendApi = this.sharedService.gridOptions.backendServiceApi || null;
        const gridMenuCustomItems = [];
        const gridOptions = this.sharedService.gridOptions;
        const translationPrefix = getTranslationPrefix(gridOptions);
        const commandLabels = (_a = this._gridMenuOptions) === null || _a === void 0 ? void 0 : _a.commandLabels;
        // show grid menu: Unfreeze Columns/Rows
        if (this.sharedService.gridOptions && this._gridMenuOptions && !this._gridMenuOptions.hideClearFrozenColumnsCommand) {
            const commandName = 'clear-pinning';
            if (!originalCustomItems.find(item => item !== 'divider' && item.hasOwnProperty('command') && item.command === commandName)) {
                gridMenuCustomItems.push({
                    iconCssClass: this._gridMenuOptions.iconClearFrozenColumnsCommand || 'fa fa-times',
                    title: this.extensionUtility.translateWhenEnabledAndServiceExist(`${translationPrefix}${commandLabels === null || commandLabels === void 0 ? void 0 : commandLabels.clearFrozenColumnsCommandKey}`, 'TEXT_CLEAR_PINNING', commandLabels === null || commandLabels === void 0 ? void 0 : commandLabels.clearFrozenColumnsCommand),
                    disabled: false,
                    command: commandName,
                    positionOrder: 52
                });
            }
        }
        if (this.sharedService.gridOptions && (this.sharedService.gridOptions.enableFiltering && !this.sharedService.hideHeaderRowAfterPageLoad)) {
            // show grid menu: Clear all Filters
            if (this.sharedService.gridOptions && this._gridMenuOptions && !this._gridMenuOptions.hideClearAllFiltersCommand) {
                const commandName = 'clear-filter';
                if (!originalCustomItems.find(item => item !== 'divider' && item.hasOwnProperty('command') && item.command === commandName)) {
                    gridMenuCustomItems.push({
                        iconCssClass: this._gridMenuOptions.iconClearAllFiltersCommand || 'fa fa-filter text-danger',
                        title: this.extensionUtility.translateWhenEnabledAndServiceExist(`${translationPrefix}${commandLabels === null || commandLabels === void 0 ? void 0 : commandLabels.clearAllFiltersCommandKey}`, 'TEXT_CLEAR_ALL_FILTERS', commandLabels === null || commandLabels === void 0 ? void 0 : commandLabels.clearAllFiltersCommand),
                        disabled: false,
                        command: commandName,
                        positionOrder: 50
                    });
                }
            }
            // show grid menu: toggle filter row
            if (this.sharedService.gridOptions && this._gridMenuOptions && !this._gridMenuOptions.hideToggleFilterCommand) {
                const commandName = 'toggle-filter';
                if (!originalCustomItems.find(item => item !== 'divider' && item.hasOwnProperty('command') && item.command === commandName)) {
                    gridMenuCustomItems.push({
                        iconCssClass: this._gridMenuOptions.iconToggleFilterCommand || 'fa fa-random',
                        title: this.extensionUtility.translateWhenEnabledAndServiceExist(`${translationPrefix}${commandLabels === null || commandLabels === void 0 ? void 0 : commandLabels.toggleFilterCommandKey}`, 'TEXT_TOGGLE_FILTER_ROW', commandLabels === null || commandLabels === void 0 ? void 0 : commandLabels.toggleFilterCommand),
                        disabled: false,
                        command: commandName,
                        positionOrder: 53
                    });
                }
            }
            // show grid menu: refresh dataset
            if (this.sharedService.gridOptions && this._gridMenuOptions && !this._gridMenuOptions.hideRefreshDatasetCommand && backendApi) {
                const commandName = 'refresh-dataset';
                if (!originalCustomItems.find(item => item !== 'divider' && item.hasOwnProperty('command') && item.command === commandName)) {
                    gridMenuCustomItems.push({
                        iconCssClass: this._gridMenuOptions.iconRefreshDatasetCommand || 'fa fa-refresh',
                        title: this.extensionUtility.translateWhenEnabledAndServiceExist(`${translationPrefix}${commandLabels === null || commandLabels === void 0 ? void 0 : commandLabels.refreshDatasetCommandKey}`, 'TEXT_REFRESH_DATASET', commandLabels === null || commandLabels === void 0 ? void 0 : commandLabels.refreshDatasetCommand),
                        disabled: false,
                        command: commandName,
                        positionOrder: 57
                    });
                }
            }
        }
        if (this.sharedService.gridOptions.showPreHeaderPanel) {
            // show grid menu: toggle pre-header row
            if (this.sharedService.gridOptions && this._gridMenuOptions && !this._gridMenuOptions.hideTogglePreHeaderCommand) {
                const commandName = 'toggle-preheader';
                if (!originalCustomItems.find(item => item !== 'divider' && item.hasOwnProperty('command') && item.command === commandName)) {
                    gridMenuCustomItems.push({
                        iconCssClass: this._gridMenuOptions.iconTogglePreHeaderCommand || 'fa fa-random',
                        title: this.extensionUtility.translateWhenEnabledAndServiceExist(`${translationPrefix}${commandLabels === null || commandLabels === void 0 ? void 0 : commandLabels.togglePreHeaderCommandKey}`, 'TEXT_TOGGLE_PRE_HEADER_ROW', commandLabels === null || commandLabels === void 0 ? void 0 : commandLabels.togglePreHeaderCommand),
                        disabled: false,
                        command: commandName,
                        positionOrder: 53
                    });
                }
            }
        }
        if (this.sharedService.gridOptions.enableSorting) {
            // show grid menu: Clear all Sorting
            if (this.sharedService.gridOptions && this._gridMenuOptions && !this._gridMenuOptions.hideClearAllSortingCommand) {
                const commandName = 'clear-sorting';
                if (!originalCustomItems.find(item => item !== 'divider' && item.hasOwnProperty('command') && item.command === commandName)) {
                    gridMenuCustomItems.push({
                        iconCssClass: this._gridMenuOptions.iconClearAllSortingCommand || 'fa fa-unsorted text-danger',
                        title: this.extensionUtility.translateWhenEnabledAndServiceExist(`${translationPrefix}${commandLabels === null || commandLabels === void 0 ? void 0 : commandLabels.clearAllSortingCommandKey}`, 'TEXT_CLEAR_ALL_SORTING', commandLabels === null || commandLabels === void 0 ? void 0 : commandLabels.clearAllSortingCommand),
                        disabled: false,
                        command: commandName,
                        positionOrder: 51
                    });
                }
            }
        }
        // show grid menu: Export to file
        if (this.sharedService.gridOptions && this.sharedService.gridOptions.enableExport && this._gridMenuOptions && !this._gridMenuOptions.hideExportCsvCommand) {
            const commandName = 'export-csv';
            if (!originalCustomItems.find(item => item !== 'divider' && item.hasOwnProperty('command') && item.command === commandName)) {
                gridMenuCustomItems.push({
                    iconCssClass: this._gridMenuOptions.iconExportCsvCommand || 'fa fa-download',
                    title: this.extensionUtility.translateWhenEnabledAndServiceExist(`${translationPrefix}${commandLabels === null || commandLabels === void 0 ? void 0 : commandLabels.exportCsvCommandKey}`, 'TEXT_EXPORT_TO_CSV', commandLabels === null || commandLabels === void 0 ? void 0 : commandLabels.exportCsvCommand),
                    disabled: false,
                    command: commandName,
                    positionOrder: 54
                });
            }
        }
        // show grid menu: Export to Excel
        if (this.sharedService.gridOptions && this.sharedService.gridOptions.enableExcelExport && this._gridMenuOptions && !this._gridMenuOptions.hideExportExcelCommand) {
            const commandName = 'export-excel';
            if (!originalCustomItems.find(item => item !== 'divider' && item.hasOwnProperty('command') && item.command === commandName)) {
                gridMenuCustomItems.push({
                    iconCssClass: this._gridMenuOptions.iconExportExcelCommand || 'fa fa-file-excel-o text-success',
                    title: this.extensionUtility.translateWhenEnabledAndServiceExist(`${translationPrefix}${commandLabels === null || commandLabels === void 0 ? void 0 : commandLabels.exportExcelCommandKey}`, 'TEXT_EXPORT_TO_EXCEL', commandLabels === null || commandLabels === void 0 ? void 0 : commandLabels.exportExcelCommand),
                    disabled: false,
                    command: commandName,
                    positionOrder: 55
                });
            }
        }
        // show grid menu: export to text file as tab delimited
        if (this.sharedService.gridOptions && this.sharedService.gridOptions.enableExport && this._gridMenuOptions && !this._gridMenuOptions.hideExportTextDelimitedCommand) {
            const commandName = 'export-text-delimited';
            if (!originalCustomItems.find(item => item !== 'divider' && item.hasOwnProperty('command') && item.command === commandName)) {
                gridMenuCustomItems.push({
                    iconCssClass: this._gridMenuOptions.iconExportTextDelimitedCommand || 'fa fa-download',
                    title: this.extensionUtility.translateWhenEnabledAndServiceExist(`${translationPrefix}${commandLabels === null || commandLabels === void 0 ? void 0 : commandLabels.exportTextDelimitedCommandKey}`, 'TEXT_EXPORT_TO_TAB_DELIMITED', commandLabels === null || commandLabels === void 0 ? void 0 : commandLabels.exportTextDelimitedCommand),
                    disabled: false,
                    command: commandName,
                    positionOrder: 56
                });
            }
        }
        // add the custom "Commands" title if there are any commands
        if (this.sharedService && this.sharedService.gridOptions && this._gridMenuOptions && (Array.isArray(gridMenuCustomItems) && gridMenuCustomItems.length > 0 || (Array.isArray(this._gridMenuOptions.customItems) && this._gridMenuOptions.customItems.length > 0))) {
            this._gridMenuOptions.customTitle = this._gridMenuOptions.customTitle || this.extensionUtility.getPickerTitleOutputString('customTitle', 'gridMenu');
        }
        return gridMenuCustomItems;
    }
    /**
     * Execute the Grid Menu Custom command callback that was triggered by the onCommand subscribe
     * These are the default internal custom commands
     * @param event
     * @param GridMenuItem args
     */
    executeGridMenuInternalCustomCommands(e, args) {
        if (args && args.command) {
            switch (args.command) {
                case 'clear-pinning':
                    const visibleColumns = [...this.sharedService.visibleColumns];
                    const newGridOptions = { frozenColumn: -1, frozenRow: -1, frozenBottom: false, enableMouseWheelScrollHandler: false };
                    this.sharedService.grid.setOptions(newGridOptions);
                    this.sharedService.gridOptions.frozenColumn = newGridOptions.frozenColumn;
                    this.sharedService.gridOptions.frozenRow = newGridOptions.frozenRow;
                    this.sharedService.gridOptions.frozenBottom = newGridOptions.frozenBottom;
                    this.sharedService.gridOptions.enableMouseWheelScrollHandler = newGridOptions.enableMouseWheelScrollHandler;
                    // SlickGrid seems to be somehow resetting the columns to their original positions,
                    // so let's re-fix them to the position we kept as reference
                    if (Array.isArray(visibleColumns)) {
                        this.sharedService.grid.setColumns(visibleColumns);
                    }
                    // we also need to autosize columns if the option is enabled
                    const gridOptions = this.sharedService.grid.getOptions();
                    if (gridOptions.enableAutoSizeColumns) {
                        this.sharedService.grid.autosizeColumns();
                    }
                    break;
                case 'clear-filter':
                    this.filterService.clearFilters();
                    this.sharedService.dataView.refresh();
                    break;
                case 'clear-sorting':
                    this.sortService.clearSorting();
                    this.sharedService.dataView.refresh();
                    break;
                case 'export-csv':
                    this.exportService.exportToFile({
                        delimiter: DelimiterType.comma,
                        format: FileType.csv,
                    });
                    break;
                case 'export-excel':
                    this.excelExportService.exportToExcel();
                    break;
                case 'export-text-delimited':
                    this.exportService.exportToFile({
                        delimiter: DelimiterType.tab,
                        format: FileType.txt,
                    });
                    break;
                case 'toggle-filter':
                    let showHeaderRow = this.sharedService && this.sharedService.gridOptions && this.sharedService.gridOptions.showHeaderRow || false;
                    showHeaderRow = !showHeaderRow; // inverse show header flag
                    this.sharedService.grid.setHeaderRowVisibility(showHeaderRow);
                    // when displaying header row, we'll call "setColumns" which in terms will recreate the header row filters
                    if (showHeaderRow === true) {
                        this.sharedService.grid.setColumns(this.sharedService.columnDefinitions);
                        this.sharedService.grid.scrollColumnIntoView(0); // quick fix to avoid filter being out of sync with horizontal scroll
                    }
                    break;
                case 'toggle-toppanel':
                    const showTopPanel = this.sharedService && this.sharedService.gridOptions && this.sharedService.gridOptions.showTopPanel || false;
                    this.sharedService.grid.setTopPanelVisibility(!showTopPanel);
                    break;
                case 'toggle-preheader':
                    const showPreHeaderPanel = this.sharedService && this.sharedService.gridOptions && this.sharedService.gridOptions.showPreHeaderPanel || false;
                    this.sharedService.grid.setPreHeaderPanelVisibility(!showPreHeaderPanel);
                    break;
                case 'refresh-dataset':
                    this.refreshBackendDataset();
                    break;
                default:
                    break;
            }
        }
    }
    emptyGridMenuTitles() {
        if (this.sharedService && this.sharedService.gridOptions && this._gridMenuOptions) {
            this._gridMenuOptions.customTitle = '';
            this._gridMenuOptions.columnTitle = '';
            this._gridMenuOptions.forceFitTitle = '';
            this._gridMenuOptions.syncResizeTitle = '';
        }
    }
    /** @return default Grid Menu options */
    getDefaultGridMenuOptions() {
        return {
            customTitle: undefined,
            columnTitle: this.extensionUtility.getPickerTitleOutputString('columnTitle', 'gridMenu'),
            forceFitTitle: this.extensionUtility.getPickerTitleOutputString('forceFitTitle', 'gridMenu'),
            syncResizeTitle: this.extensionUtility.getPickerTitleOutputString('syncResizeTitle', 'gridMenu'),
            iconCssClass: 'fa fa-bars',
            menuWidth: 18,
            customItems: [],
            hideClearAllFiltersCommand: false,
            hideRefreshDatasetCommand: false,
            hideToggleFilterCommand: false,
        };
    }
}
GridMenuExtension.ɵfac = function GridMenuExtension_Factory(t) { return new (t || GridMenuExtension)(ɵngcc0.ɵɵinject(ExcelExportService), ɵngcc0.ɵɵinject(ExportService), ɵngcc0.ɵɵinject(ExtensionUtility), ɵngcc0.ɵɵinject(FilterService), ɵngcc0.ɵɵinject(SharedService), ɵngcc0.ɵɵinject(SortService), ɵngcc0.ɵɵinject(ɵngcc1.TranslateService, 8)); };
GridMenuExtension.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: GridMenuExtension, factory: GridMenuExtension.ɵfac });
GridMenuExtension.ctorParameters = () => [
    { type: ExcelExportService },
    { type: ExportService },
    { type: ExtensionUtility },
    { type: FilterService },
    { type: SharedService },
    { type: SortService },
    { type: TranslateService, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GridMenuExtension, [{
        type: Injectable
    }], function () { return [{ type: ExcelExportService }, { type: ExportService }, { type: ExtensionUtility }, { type: FilterService }, { type: SharedService }, { type: SortService }, { type: ɵngcc1.TranslateService, decorators: [{
                type: Optional
            }] }]; }, null); })();

class GroupItemMetaProviderExtension {
    constructor(sharedService) {
        this.sharedService = sharedService;
    }
    dispose() {
        if (this._addon && this._addon.destroy) {
            this._addon.destroy();
        }
        this._addon = null;
    }
    /** Get the instance of the SlickGrid addon (control or plugin). */
    getAddonInstance() {
        return this._addon;
    }
    /** register the group item metadata provider to add expand/collapse group handlers */
    register() {
        if (this.sharedService && this.sharedService.grid) {
            this._addon = this.sharedService.groupItemMetadataProvider || {};
            this.sharedService.grid.registerPlugin(this._addon);
            return this._addon;
        }
        return null;
    }
}
GroupItemMetaProviderExtension.ɵfac = function GroupItemMetaProviderExtension_Factory(t) { return new (t || GroupItemMetaProviderExtension)(ɵngcc0.ɵɵinject(SharedService)); };
GroupItemMetaProviderExtension.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: GroupItemMetaProviderExtension, factory: GroupItemMetaProviderExtension.ɵfac });
GroupItemMetaProviderExtension.ctorParameters = () => [
    { type: SharedService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GroupItemMetaProviderExtension, [{
        type: Injectable
    }], function () { return [{ type: SharedService }]; }, null); })();

class HeaderButtonExtension {
    constructor(extensionUtility, sharedService) {
        this.extensionUtility = extensionUtility;
        this.sharedService = sharedService;
        this._eventHandler = new Slick.EventHandler();
    }
    get eventHandler() {
        return this._eventHandler;
    }
    dispose() {
        // unsubscribe all SlickGrid events
        this._eventHandler.unsubscribeAll();
        if (this._addon && this._addon.destroy) {
            this._addon.destroy();
        }
        this.extensionUtility.nullifyFunctionNameStartingWithOn(this._headerButtonOptions);
        this._addon = null;
        this._headerButtonOptions = null;
    }
    /** Get the instance of the SlickGrid addon (control or plugin). */
    getAddonInstance() {
        return this._addon;
    }
    // Header Button Plugin
    register() {
        if (this.sharedService && this.sharedService.grid && this.sharedService.gridOptions) {
            this._headerButtonOptions = this.sharedService.gridOptions.headerButton || {};
            this._addon = new Slick.Plugins.HeaderButtons(this._headerButtonOptions);
            this.sharedService.grid.registerPlugin(this._addon);
            // hook all events
            if (this._headerButtonOptions) {
                if (this._headerButtonOptions.onExtensionRegistered) {
                    this._headerButtonOptions.onExtensionRegistered(this._addon);
                }
                this._eventHandler.subscribe(this._addon.onCommand, (e, args) => {
                    if (this._headerButtonOptions && typeof this._headerButtonOptions.onCommand === 'function') {
                        this._headerButtonOptions.onCommand(e, args);
                    }
                });
            }
            return this._addon;
        }
        return null;
    }
}
HeaderButtonExtension.ɵfac = function HeaderButtonExtension_Factory(t) { return new (t || HeaderButtonExtension)(ɵngcc0.ɵɵinject(ExtensionUtility), ɵngcc0.ɵɵinject(SharedService)); };
HeaderButtonExtension.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: HeaderButtonExtension, factory: HeaderButtonExtension.ɵfac });
HeaderButtonExtension.ctorParameters = () => [
    { type: ExtensionUtility },
    { type: SharedService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HeaderButtonExtension, [{
        type: Injectable
    }], function () { return [{ type: ExtensionUtility }, { type: SharedService }]; }, null); })();

// global constants, height/width are in pixels
const DATAGRID_MIN_HEIGHT = 180;
const DATAGRID_MIN_WIDTH = 300;
const DATAGRID_BOTTOM_PADDING = 20;
const DATAGRID_FOOTER_HEIGHT = 20;
const DATAGRID_PAGINATION_HEIGHT = 35;
class ResizerService {
    constructor() {
        this._hasResizedByContentAtLeastOnce = false;
        this._totalColumnsWidthByContent = 0;
        this._resizePaused = false;
        this.onGridAfterResize = new Subject();
        this.onGridBeforeResize = new Subject();
        this._eventHandler = new Slick.EventHandler();
    }
    get eventHandler() {
        return this._eventHandler;
    }
    /** Getter for the SlickGrid DataView */
    get dataView() {
        var _a;
        return (_a = this._grid) === null || _a === void 0 ? void 0 : _a.getData();
    }
    /** Getter for the Grid Options pulled through the Grid Object */
    get _gridOptions() {
        return (this._grid && this._grid.getOptions) ? this._grid.getOptions() : {};
    }
    get _gridUid() {
        return (this._grid && this._grid.getUID) ? this._grid.getUID() : this._gridOptions && this._gridOptions.gridId;
    }
    get resizeByContentOptions() {
        var _a, _b;
        return (_b = (_a = this._gridOptions) === null || _a === void 0 ? void 0 : _a.resizeByContentOptions) !== null && _b !== void 0 ? _b : {};
    }
    init(grid, fixedDimensions) {
        var _a, _b;
        if (!grid || !this._gridOptions) {
            throw new Error(`
      Angular-Slickgrid resizer requires a valid Grid object and Grid Options defined.
      You can fix this by setting your gridOption to use "enableAutoResize" or create an instance of the ResizerService by calling bindAutoResizeDataGrid()`);
        }
        this._grid = grid;
        const containerNode = grid && grid.getContainerNode && grid.getContainerNode() || '';
        this._gridDomElm = $(containerNode);
        const autoResizeOptions = this._gridOptions && this._gridOptions.autoResize || {};
        this._gridContainerElm = (autoResizeOptions && autoResizeOptions.containerId) ? $(`#${autoResizeOptions.containerId}`) : $(`#${this._gridOptions.gridContainerId}`);
        if (fixedDimensions) {
            this._fixedHeight = fixedDimensions.height;
            this._fixedWidth = fixedDimensions.width;
        }
        (_b = (_a = this._eventHandler) === null || _a === void 0 ? void 0 : _a.subscribe) === null || _b === void 0 ? void 0 : _b.call(_a, this._grid.onColumnsResizeDblClick, (_e, args) => {
            this.handleSingleColumnResizeByContent(args.triggeredByColumn);
        });
    }
    /** Bind an auto resize trigger on the datagrid, if that is enable then it will resize itself to the available space
     * Options: we could also provide a % factor to resize on each height/width independently
     */
    bindAutoResizeDataGrid(newSizes) {
        // if we can't find the grid to resize, return without binding anything
        if (this._gridDomElm === undefined || this._gridDomElm.offset() === undefined) {
            return null;
        }
        // -- 1st resize the datagrid size at first load (we need this because the .on event is not triggered on first load)
        // -- also we add a slight delay (in ms) so that we resize after the grid render is done
        this.resizeGrid(10, newSizes);
        // -- 2nd bind a trigger on the Window DOM element, so that it happens also when resizing after first load
        // -- bind auto-resize to Window object only if it exist
        $(window).on(`resize.grid.${this._gridUid}`, this.handleResizeGrid.bind(this, newSizes));
    }
    handleResizeGrid(newSizes, event) {
        this.onGridBeforeResize.next(event);
        if (!this._resizePaused) {
            // for some yet unknown reason, calling the resize twice removes any stuttering/flickering
            // when changing the height and makes it much smoother experience
            this.resizeGrid(0, newSizes);
            this.resizeGrid(0, newSizes);
        }
    }
    /**
     * Calculate the datagrid new height/width from the available space, also consider that a % factor might be applied to calculation
     * object gridOptions
     */
    calculateGridNewDimensions(gridOptions) {
        var _a, _b;
        const autoResizeOptions = gridOptions && gridOptions.autoResize || {};
        if (!window || this._gridContainerElm === undefined || this._gridDomElm.offset() === undefined) {
            return null;
        }
        // calculate bottom padding
        // if using pagination, we need to add the pagination height to this bottom padding
        let bottomPadding = (autoResizeOptions && autoResizeOptions.bottomPadding !== undefined) ? autoResizeOptions.bottomPadding : DATAGRID_BOTTOM_PADDING;
        if (bottomPadding && gridOptions.enablePagination) {
            bottomPadding += DATAGRID_PAGINATION_HEIGHT;
        }
        // optionally show a custom footer with the data metrics (dataset length and last updated timestamp)
        if (bottomPadding && gridOptions.showCustomFooter) {
            bottomPadding += (_b = (_a = gridOptions === null || gridOptions === void 0 ? void 0 : gridOptions.customFooterOptions) === null || _a === void 0 ? void 0 : _a.footerHeight) !== null && _b !== void 0 ? _b : DATAGRID_FOOTER_HEIGHT;
        }
        let gridHeight = 0;
        let gridOffsetTop = 0;
        // which DOM element are we using to calculate the available size for the grid?
        if (autoResizeOptions.calculateAvailableSizeBy === 'container') {
            // uses the container's height to calculate grid height without any top offset
            gridHeight = this._gridContainerElm.height() || 0;
        }
        else {
            // uses the browser's window height with its top offset to calculate grid height
            gridHeight = window.innerHeight || 0;
            const coordOffsetTop = this._gridDomElm.offset();
            gridOffsetTop = (coordOffsetTop !== undefined) ? coordOffsetTop.top : 0;
        }
        const availableHeight = gridHeight - gridOffsetTop - bottomPadding;
        const availableWidth = this._gridContainerElm.width() || window.innerWidth || 0;
        const maxHeight = autoResizeOptions && autoResizeOptions.maxHeight || undefined;
        const minHeight = (autoResizeOptions && autoResizeOptions.minHeight !== undefined) ? autoResizeOptions.minHeight : DATAGRID_MIN_HEIGHT;
        const maxWidth = autoResizeOptions && autoResizeOptions.maxWidth || undefined;
        const minWidth = (autoResizeOptions && autoResizeOptions.minWidth !== undefined) ? autoResizeOptions.minWidth : DATAGRID_MIN_WIDTH;
        let newHeight = availableHeight;
        let newWidth = (autoResizeOptions && autoResizeOptions.sidePadding) ? availableWidth - autoResizeOptions.sidePadding : availableWidth;
        // optionally (when defined), make sure that grid height & width are within their thresholds
        if (newHeight < minHeight) {
            newHeight = minHeight;
        }
        if (maxHeight && newHeight > maxHeight) {
            newHeight = maxHeight;
        }
        if (newWidth < minWidth) {
            newWidth = minWidth;
        }
        if (maxWidth && newWidth > maxWidth) {
            newWidth = maxWidth;
        }
        // return the new dimensions unless a fixed height/width was defined
        return {
            height: this._fixedHeight || newHeight,
            width: this._fixedWidth || newWidth
        };
    }
    /** Dispose function when service is destroyed */
    dispose() {
        var _a;
        // unsubscribe all SlickGrid events
        (_a = this._eventHandler) === null || _a === void 0 ? void 0 : _a.unsubscribeAll();
        $(window).off(`resize.grid.${this._gridUid}`);
    }
    /**
     * Return the last resize dimensions used by the service
     * @return last dimensions
     */
    getLastResizeDimensions() {
        return this._lastDimensions;
    }
    handleSingleColumnResizeByContent(columnId) {
        var _a, _b, _c;
        const columnDefinitions = this._grid.getColumns();
        const columnDefIdx = columnDefinitions.findIndex(col => col.id === columnId);
        if (columnDefIdx >= 0) {
            // provide the initial column width by reference to the calculation and the result will also be returned by reference
            const columnDef = columnDefinitions[columnDefIdx];
            const columnWidths = { [columnId]: (_b = (_a = columnDef.originalWidth) !== null && _a !== void 0 ? _a : columnDef.minWidth) !== null && _b !== void 0 ? _b : 0 };
            columnDef.originalWidth = undefined; // reset original width since we want to recalculate it
            this.calculateCellWidthByReadingDataset(columnDef, columnWidths, this.resizeByContentOptions.maxItemToInspectSingleColumnWidthByContent, columnDefIdx);
            this.applyNewCalculatedColumnWidthByReference(columnDef, columnWidths[columnId]);
            // finally call the re-render for the UI to render the new column width
            this._grid.reRenderColumns((_c = columnDef === null || columnDef === void 0 ? void 0 : columnDef.rerenderOnResize) !== null && _c !== void 0 ? _c : false);
        }
    }
    /** Provide the possibility to pause the resizer for some time, until user decides to re-enabled it later if he wish to. */
    pauseResizer(isResizePaused) {
        this._resizePaused = isResizePaused;
    }
    /** Resize the datagrid to fit the browser height & width */
    resizeGrid(delay = 10, newSizes) {
        return new Promise((resolve) => {
            // because of the javascript async nature, we might want to delay the resize a little bit
            delay = delay || 0;
            if (delay > 0) {
                clearTimeout(this._timer);
                this._timer = setTimeout(() => resolve(this.resizeGridCallback(newSizes)), delay);
            }
            else {
                resolve(this.resizeGridCallback(newSizes));
            }
        });
    }
    resizeGridCallback(newSizes) {
        const lastDimensions = this.resizeGridWithDimensions(newSizes);
        this.onGridAfterResize.next(lastDimensions);
        return lastDimensions;
    }
    resizeGridWithDimensions(newSizes) {
        var _a, _b;
        // calculate the available sizes with minimum height defined as a constant
        const availableDimensions = this.calculateGridNewDimensions(this._gridOptions);
        const gridContainerElm = $(`#${this._gridOptions.gridContainerId}`) || {};
        if ((newSizes || availableDimensions) && this._gridDomElm.length > 0) {
            // get the new sizes, if new sizes are passed (not 0), we will use them else use available space
            // basically if user passes 1 of the dimension, let say he passes just the height,
            // we will use the height as a fixed height but the width will be resized by it's available space
            const newHeight = (newSizes && newSizes.height) ? newSizes.height : availableDimensions && availableDimensions.height;
            const newWidth = (newSizes && newSizes.width) ? newSizes.width : availableDimensions && availableDimensions.width;
            // apply these new height/width to the datagrid
            if (!this._gridOptions.autoHeight) {
                this._gridDomElm.height(newHeight);
                gridContainerElm.height(newHeight);
            }
            this._gridDomElm.width(newWidth);
            gridContainerElm.width(newWidth);
            // resize the slickgrid canvas on all browser except some IE versions
            // exclude all IE below IE11
            // IE11 wants to be a better standard (W3C) follower (finally) they even changed their appName output to also have 'Netscape'
            if (new RegExp('MSIE [6-8]').exec(navigator.userAgent) === null && this._grid && this._grid.resizeCanvas) {
                this._grid.resizeCanvas();
            }
            // also call the grid auto-size columns so that it takes available space when going bigger
            if (this._gridOptions && this._gridOptions.enableAutoSizeColumns && this._grid.autosizeColumns) {
                // make sure that the grid still exist (by looking if the Grid UID is found in the DOM tree) to avoid SlickGrid error "missing stylesheet"
                if (this._gridUid && $(`.${this._gridUid}`).length > 0) {
                    this._grid.autosizeColumns();
                }
            }
            else if (this._gridOptions.enableAutoResizeColumnsByCellContent && (!((_a = this._lastDimensions) === null || _a === void 0 ? void 0 : _a.width) || newWidth !== ((_b = this._lastDimensions) === null || _b === void 0 ? void 0 : _b.width))) {
                // we can call our resize by content here (when enabled)
                // since the core Slick.Resizer plugin only supports the "autosizeColumns"
                this.resizeColumnsByCellContent();
            }
            // keep last resized dimensions & resolve them to the Promise
            this._lastDimensions = {
                height: newHeight || 0,
                width: newWidth || 0
            };
            if ((this._gridOptions.enablePagination || this._gridOptions.backendServiceApi)) {
                this._lastDimensions.heightWithPagination = (newHeight || 0) + DATAGRID_PAGINATION_HEIGHT;
            }
        }
        return this._lastDimensions;
    }
    /**
     * Resize each column width by their cell text/value content (this could potentially go wider than the viewport and end up showing an horizontal scroll).
     * This operation requires to loop through each dataset item to inspect each cell content width and has a performance cost associated to this process.
     *
     * NOTE: please that for performance reasons we will only inspect the first 1000 rows,
     * however user could override it by using the grid option `resizeMaxItemToInspectCellContentWidth` to increase/decrease how many items to inspect.
     * @param {Boolean} recalculateColumnsTotalWidth - defaults to false, do we want to recalculate the necessary total columns width even if it was already calculated?
     */
    resizeColumnsByCellContent(recalculateColumnsTotalWidth = false) {
        var _a, _b, _c, _d, _f, _g;
        const columnDefinitions = this._grid.getColumns();
        const dataset = this.dataView.getItems();
        const columnWidths = {};
        let reRender = false;
        let readItemCount = 0;
        if ((!Array.isArray(dataset) || dataset.length === 0) || (this._hasResizedByContentAtLeastOnce && ((_a = this._gridOptions) === null || _a === void 0 ? void 0 : _a.resizeByContentOnlyOnFirstLoad) && !recalculateColumnsTotalWidth)) {
            return;
        }
        // calculate total width necessary by each cell content
        // we won't re-evaluate if we already had calculated the total
        if (this._totalColumnsWidthByContent === 0 || recalculateColumnsTotalWidth) {
            // loop through all columns to get their minWidth or width for later usage
            for (const columnDef of columnDefinitions) {
                columnWidths[columnDef.id] = (_c = (_b = columnDef.originalWidth) !== null && _b !== void 0 ? _b : columnDef.minWidth) !== null && _c !== void 0 ? _c : 0;
            }
            // calculate cell width by reading all data from dataset and also parse through any Formatter(s) when exist
            readItemCount = this.calculateCellWidthByReadingDataset(columnDefinitions, columnWidths, this.resizeByContentOptions.maxItemToInspectCellContentWidth);
            // finally loop through all column definitions one last time to apply new calculated `width` on each elligible column
            let totalColsWidth = 0;
            for (const column of columnDefinitions) {
                const resizeAlwaysRecalculateWidth = (_f = (_d = column.resizeAlwaysRecalculateWidth) !== null && _d !== void 0 ? _d : this.resizeByContentOptions.alwaysRecalculateColumnWidth) !== null && _f !== void 0 ? _f : false;
                if (column.originalWidth && !resizeAlwaysRecalculateWidth) {
                    column.width = column.originalWidth;
                }
                else if (columnWidths[column.id] !== undefined) {
                    if (column.rerenderOnResize) {
                        reRender = true;
                    }
                    // let's start with column width found in previous column & data analysis
                    this.applyNewCalculatedColumnWidthByReference(column, columnWidths[column.id]);
                }
                // add the new column width to the total width which we'll use later to compare against viewport width
                totalColsWidth += column.width || 0;
                this._totalColumnsWidthByContent = totalColsWidth;
            }
        }
        // send updated column definitions widths to SlickGrid
        this._grid.setColumns(columnDefinitions);
        this._hasResizedByContentAtLeastOnce = true;
        const calculateColumnWidths = {};
        for (const columnDef of columnDefinitions) {
            calculateColumnWidths[columnDef.id] = columnDef.width;
        }
        // get the grid container viewport width and if our viewport calculated total columns is greater than the viewport width
        // then we'll call reRenderColumns() when getting wider than viewport or else the default autosizeColumns() when we know we have plenty of space to shrink the columns
        const viewportWidth = (_g = this._gridContainerElm.width()) !== null && _g !== void 0 ? _g : 0;
        this._totalColumnsWidthByContent > viewportWidth ? this._grid.reRenderColumns(reRender) : this._grid.autosizeColumns();
    }
    // --
    // private functions
    // ------------------
    /**
     * Step 1 - The first step will read through the entire dataset (unless max item count is reached),
     * it will analyze each cell of the grid and calculate its max width via its content and column definition info (it will do so by calling step 2 method while looping through each cell).
     * @param columnOrColumns - single or array of column definition(s)
     * @param columnWidths - column width object that will be updated by reference pointers
     * @param columnIndexOverride - an optional column index, if provided it will override the column index position
     * @returns - count of items that was read
     */
    calculateCellWidthByReadingDataset(columnOrColumns, columnWidths, maxItemToInspect = 1000, columnIndexOverride) {
        const columnDefinitions = Array.isArray(columnOrColumns) ? columnOrColumns : [columnOrColumns];
        // const columnDefinitions = this._grid.getColumns();
        const dataset = this.dataView.getItems();
        let readItemCount = 0;
        for (const [rowIdx, item] of dataset.entries()) {
            if (rowIdx > maxItemToInspect) {
                break;
            }
            if (Array.isArray(columnDefinitions)) {
                if (typeof columnWidths === 'object') {
                    columnDefinitions.forEach((columnDef, colIdx) => {
                        const newColumnWidth = this.calculateCellWidthByContent(item, columnDef, rowIdx, columnIndexOverride !== null && columnIndexOverride !== void 0 ? columnIndexOverride : colIdx, columnWidths[columnDef.id]);
                        if (newColumnWidth !== undefined) {
                            columnWidths[columnDef.id] = newColumnWidth;
                        }
                    });
                }
            }
            readItemCount = rowIdx + 1;
        }
        return readItemCount;
    }
    /**
     * Step 2 - This step will parse any Formatter(s) if defined, it will then sanitize any HTML tags and calculate the max width from that cell content.
     * This function will be executed on every cell of the grid data.
     * @param {Object} item - item data context object
     * @param {Object} columnDef - column definition
     * @param {Number} rowIdx - row index
     * @param {Number} colIdx - column (cell) index
     * @param {Number} initialMininalColumnWidth - initial width, could be coming from `minWidth` or a default `width`
     * @returns - column width
     */
    calculateCellWidthByContent(item, columnDef, rowIdx, colIdx, initialMininalColumnWidth) {
        var _a, _b;
        const resizeCellCharWidthInPx = (_a = this.resizeByContentOptions.cellCharWidthInPx) !== null && _a !== void 0 ? _a : 7; // width in pixels of a string character, this can vary depending on which font family/size is used & cell padding
        if (!columnDef.originalWidth) {
            const charWidthPx = (_b = columnDef === null || columnDef === void 0 ? void 0 : columnDef.resizeCharWidthInPx) !== null && _b !== void 0 ? _b : resizeCellCharWidthInPx;
            const formattedData = parseFormatterWhenExist(columnDef === null || columnDef === void 0 ? void 0 : columnDef.formatter, rowIdx, colIdx, columnDef, item, this._grid);
            const formattedDataSanitized = sanitizeHtmlToText(formattedData);
            const formattedTextWidthInPx = Math.ceil(formattedDataSanitized.length * charWidthPx);
            const resizeMaxWidthThreshold = columnDef.resizeMaxWidthThreshold;
            if (columnDef && (initialMininalColumnWidth === undefined || formattedTextWidthInPx > initialMininalColumnWidth)) {
                initialMininalColumnWidth = (resizeMaxWidthThreshold !== undefined && formattedTextWidthInPx > resizeMaxWidthThreshold)
                    ? resizeMaxWidthThreshold
                    : (columnDef.maxWidth !== undefined && formattedTextWidthInPx > columnDef.maxWidth) ? columnDef.maxWidth : formattedTextWidthInPx;
            }
        }
        return initialMininalColumnWidth;
    }
    /**
     * Step 3 - Apply the new calculated width, it might or might not use this calculated width depending on a few conditions.
     * One of those condition will be to check that the new width doesn't go over a maxWidth and/or a maxWidthThreshold
     * @param {Object} column - column definition to apply the width
     * @param {Number} calculatedColumnWidth - new calculated column width to possibly apply
     */
    applyNewCalculatedColumnWidthByReference(column, calculatedColumnWidth) {
        var _a, _b, _c, _d, _f, _g, _h;
        // read a few optional resize by content grid options
        const resizeCellPaddingWidthInPx = (_a = this.resizeByContentOptions.cellPaddingWidthInPx) !== null && _a !== void 0 ? _a : 6;
        const resizeFormatterPaddingWidthInPx = (_b = this.resizeByContentOptions.formatterPaddingWidthInPx) !== null && _b !== void 0 ? _b : 6;
        const fieldType = (_f = (_d = (_c = column === null || column === void 0 ? void 0 : column.filter) === null || _c === void 0 ? void 0 : _c.type) !== null && _d !== void 0 ? _d : column === null || column === void 0 ? void 0 : column.type) !== null && _f !== void 0 ? _f : FieldType.string;
        // let's start with column width found in previous column & data analysis
        let newColWidth = calculatedColumnWidth;
        // apply optional ratio which is typically 1, except for string where we use a ratio of around ~0.9 since we have more various thinner characters like (i, l, t, ...)
        const stringWidthRatio = (_h = (_g = column === null || column === void 0 ? void 0 : column.resizeCalcWidthRatio) !== null && _g !== void 0 ? _g : this.resizeByContentOptions.defaultRatioForStringType) !== null && _h !== void 0 ? _h : 0.9;
        newColWidth *= fieldType === 'string' ? stringWidthRatio : 1;
        // apply extra cell padding, custom padding & editor formatter padding
        // --
        newColWidth += resizeCellPaddingWidthInPx;
        if (column.resizeExtraWidthPadding) {
            newColWidth += column.resizeExtraWidthPadding;
        }
        if (column.editor && this._gridOptions.editable) {
            newColWidth += resizeFormatterPaddingWidthInPx;
        }
        // make sure we're not over a column max width and/or optional custom max width threshold
        if (column.maxWidth !== undefined && newColWidth > column.maxWidth) {
            newColWidth = column.maxWidth;
        }
        if (column.resizeMaxWidthThreshold !== undefined && newColWidth > column.resizeMaxWidthThreshold) {
            newColWidth = column.resizeMaxWidthThreshold;
        }
        // make the value the closest bottom integer
        newColWidth = Math.ceil(newColWidth);
        // finally only apply the new width if user didn't yet provide one and/or if user really wants to specifically ask for a recalculate
        if (column.originalWidth === undefined || column.resizeAlwaysRecalculateWidth === true || this.resizeByContentOptions.alwaysRecalculateColumnWidth === true) {
            column.width = this.readjustNewColumnWidthWhenOverLimit(column, newColWidth);
        }
    }
    /**
     * Checks wether the new calculated column width is valid or not, if it's not then return a lower and acceptable width.
     * When using frozen (pinned) column, we cannot make our column wider than the grid viewport because it would become unusable/unscrollable
     * and so if we do reach that threshold then our calculated column width becomes officially invalid
     * @param {Object} column - column definition
     * @param {Number} newColumnWidth - calculated column width input
     * @returns boolean
     */
    readjustNewColumnWidthWhenOverLimit(column, newColumnWidth) {
        var _a, _b, _c, _d, _f, _g, _h, _j;
        const frozenColumnIdx = (_a = this._gridOptions.frozenColumn) !== null && _a !== void 0 ? _a : -1;
        const columns = (this._grid && this._grid.getColumns() || []);
        const columnIdx = (_b = columns.findIndex(col => col.id === column.id)) !== null && _b !== void 0 ? _b : 0;
        let adjustedWidth = newColumnWidth;
        if (frozenColumnIdx >= 0 && columnIdx <= frozenColumnIdx) {
            const allViewports = Array.from(this._grid.getViewports());
            if (allViewports) {
                const leftViewportWidth = (_d = (_c = allViewports.find(viewport => viewport.classList.contains('slick-viewport-left'))) === null || _c === void 0 ? void 0 : _c.clientWidth) !== null && _d !== void 0 ? _d : 0;
                const rightViewportWidth = (_g = (_f = allViewports.find(viewport => viewport.classList.contains('slick-viewport-right'))) === null || _f === void 0 ? void 0 : _f.clientWidth) !== null && _g !== void 0 ? _g : 0;
                const viewportFullWidth = leftViewportWidth + rightViewportWidth;
                const leftViewportWidthMinusCurrentCol = leftViewportWidth - ((_h = column.width) !== null && _h !== void 0 ? _h : 0);
                const isGreaterThanFullViewportWidth = (leftViewportWidthMinusCurrentCol + newColumnWidth) > viewportFullWidth;
                if (isGreaterThanFullViewportWidth) {
                    const resizeWidthToRemoveFromExceededWidthReadjustment = (_j = this.resizeByContentOptions.widthToRemoveFromExceededWidthReadjustment) !== null && _j !== void 0 ? _j : 50;
                    adjustedWidth = (leftViewportWidth - leftViewportWidthMinusCurrentCol + rightViewportWidth - resizeWidthToRemoveFromExceededWidthReadjustment);
                }
            }
        }
        return Math.ceil(adjustedWidth);
    }
}
ResizerService.ɵfac = function ResizerService_Factory(t) { return new (t || ResizerService)(); };
ResizerService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ResizerService, factory: ResizerService.ɵfac });
ResizerService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ResizerService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class HeaderMenuExtension {
    constructor(extensionUtility, filterService, resizerService, sharedService, sortService, translate) {
        this.extensionUtility = extensionUtility;
        this.filterService = filterService;
        this.resizerService = resizerService;
        this.sharedService = sharedService;
        this.sortService = sortService;
        this.translate = translate;
        this._eventHandler = new Slick.EventHandler();
    }
    get eventHandler() {
        return this._eventHandler;
    }
    dispose() {
        // unsubscribe all SlickGrid events
        this._eventHandler.unsubscribeAll();
        if (this._addon && this._addon.destroy) {
            this._addon.destroy();
        }
        this._addon = null;
    }
    /** Get the instance of the SlickGrid addon (control or plugin). */
    getAddonInstance() {
        return this._addon;
    }
    /**
     * Create the Header Menu and expose all the available hooks that user can subscribe (onCommand, onBeforeMenuShow, ...)
     * @param grid
     * @param dataView
     * @param columnDefinitions
     */
    register() {
        if (this.sharedService.gridOptions && this.sharedService.gridOptions.enableTranslate && (!this.translate || !this.translate.instant)) {
            throw new Error('[Angular-Slickgrid] requires "ngx-translate" to be installed and configured when the grid option "enableTranslate" is enabled.');
        }
        if (this.sharedService && this.sharedService.grid && this.sharedService.gridOptions) {
            // get locales provided by user in forRoot or else use default English locales via the Constants
            this._locales = this.sharedService.gridOptions && this.sharedService.gridOptions.locales || Constants.locales;
            this.sharedService.gridOptions.headerMenu = Object.assign(Object.assign({}, this.getDefaultHeaderMenuOptions()), this.sharedService.gridOptions.headerMenu);
            if (this.sharedService.gridOptions.enableHeaderMenu) {
                this.sharedService.gridOptions.headerMenu = this.addHeaderMenuCustomCommands(this.sharedService.gridOptions, this.sharedService.columnDefinitions);
            }
            this._addon = new Slick.Plugins.HeaderMenu(this.sharedService.gridOptions.headerMenu);
            this.sharedService.grid.registerPlugin(this._addon);
            // hook all events
            if (this.sharedService.grid && this.sharedService.gridOptions.headerMenu) {
                if (this.sharedService.gridOptions.headerMenu.onExtensionRegistered) {
                    this.sharedService.gridOptions.headerMenu.onExtensionRegistered(this._addon);
                }
                this._eventHandler.subscribe(this._addon.onCommand, (e, args) => {
                    this.executeHeaderMenuInternalCommands(e, args);
                    if (this.sharedService.gridOptions.headerMenu && typeof this.sharedService.gridOptions.headerMenu.onCommand === 'function') {
                        this.sharedService.gridOptions.headerMenu.onCommand(e, args);
                    }
                });
                if (this.sharedService.gridOptions.headerMenu && typeof this.sharedService.gridOptions.headerMenu.onBeforeMenuShow === 'function') {
                    this._eventHandler.subscribe(this._addon.onBeforeMenuShow, (e, args) => {
                        if (this.sharedService.gridOptions.headerMenu && this.sharedService.gridOptions.headerMenu.onBeforeMenuShow) {
                            this.sharedService.gridOptions.headerMenu.onBeforeMenuShow(e, args);
                        }
                    });
                }
                if (this.sharedService.gridOptions.headerMenu && typeof this.sharedService.gridOptions.headerMenu.onAfterMenuShow === 'function') {
                    this._eventHandler.subscribe(this._addon.onAfterMenuShow, (e, args) => {
                        if (this.sharedService.gridOptions.headerMenu && this.sharedService.gridOptions.headerMenu.onAfterMenuShow) {
                            this.sharedService.gridOptions.headerMenu.onAfterMenuShow(e, args);
                        }
                    });
                }
            }
            return this._addon;
        }
        return null;
    }
    /**
     * Create Header Menu with Custom Commands if user has enabled Header Menu
     * @param options
     * @param columnDefinitions
     * @return header menu
     */
    addHeaderMenuCustomCommands(options, columnDefinitions) {
        const headerMenuOptions = options.headerMenu || {};
        const gridOptions = this.sharedService.gridOptions;
        const translationPrefix = getTranslationPrefix(gridOptions);
        if (columnDefinitions && Array.isArray(columnDefinitions) && options.enableHeaderMenu) {
            columnDefinitions.forEach((columnDef) => {
                var _a, _b, _c;
                if (columnDef && !columnDef.excludeFromHeaderMenu) {
                    if (!columnDef.header || !columnDef.header.menu) {
                        columnDef.header = {
                            menu: {
                                items: []
                            }
                        };
                    }
                    const columnHeaderMenuItems = (_c = (_b = (_a = columnDef === null || columnDef === void 0 ? void 0 : columnDef.header) === null || _a === void 0 ? void 0 : _a.menu) === null || _b === void 0 ? void 0 : _b.items) !== null && _c !== void 0 ? _c : [];
                    // Freeze Column (pinning)
                    let hasFrozenOrResizeCommand = false;
                    if (headerMenuOptions && !headerMenuOptions.hideFreezeColumnsCommand) {
                        hasFrozenOrResizeCommand = true;
                        if (columnHeaderMenuItems.filter(item => item !== 'divider' && item.hasOwnProperty('command') && item.command === 'freeze-columns').length === 0) {
                            columnHeaderMenuItems.push({
                                iconCssClass: headerMenuOptions.iconFreezeColumns || 'fa fa-thumb-tack',
                                title: options.enableTranslate ? this.translate.instant(`${translationPrefix}FREEZE_COLUMNS`) : this._locales && this._locales.TEXT_FREEZE_COLUMNS,
                                command: 'freeze-columns',
                                positionOrder: 47
                            });
                        }
                    }
                    // Column Resize by Content (column autofit)
                    if (headerMenuOptions && !headerMenuOptions.hideColumnResizeByContentCommand && this.sharedService.gridOptions.enableColumnResizeOnDoubleClick) {
                        hasFrozenOrResizeCommand = true;
                        if (!columnHeaderMenuItems.some(item => item !== 'divider' && item.hasOwnProperty('command') && item.command === 'column-resize-by-content')) {
                            columnHeaderMenuItems.push({
                                iconCssClass: headerMenuOptions.iconColumnResizeByContentCommand || 'fa fa-arrows-h',
                                title: this.extensionUtility.translateWhenEnabledAndServiceExist(`${translationPrefix}COLUMN_RESIZE_BY_CONTENT`, 'TEXT_COLUMN_RESIZE_BY_CONTENT'),
                                command: 'column-resize-by-content',
                                positionOrder: 48
                            });
                        }
                    }
                    // add a divider (separator) between the top freeze columns commands and the rest of the commands
                    if (hasFrozenOrResizeCommand && !columnHeaderMenuItems.some(item => item !== 'divider' && item.positionOrder === 49)) {
                        columnHeaderMenuItems.push({ divider: true, command: '', positionOrder: 49 });
                    }
                    // Sorting Commands
                    if (options.enableSorting && columnDef.sortable && headerMenuOptions && !headerMenuOptions.hideSortCommands) {
                        if (columnHeaderMenuItems.filter(item => item !== 'divider' && item.hasOwnProperty('command') && item.command === 'sort-asc').length === 0) {
                            columnHeaderMenuItems.push({
                                iconCssClass: headerMenuOptions.iconSortAscCommand || 'fa fa-sort-asc',
                                title: options.enableTranslate ? this.translate.instant(`${translationPrefix}SORT_ASCENDING`) : this._locales && this._locales.TEXT_SORT_ASCENDING,
                                command: 'sort-asc',
                                positionOrder: 50
                            });
                        }
                        if (columnHeaderMenuItems.filter(item => item !== 'divider' && item.hasOwnProperty('command') && item.command === 'sort-desc').length === 0) {
                            columnHeaderMenuItems.push({
                                iconCssClass: headerMenuOptions.iconSortDescCommand || 'fa fa-sort-desc',
                                title: options.enableTranslate ? this.translate.instant(`${translationPrefix}SORT_DESCENDING`) : this._locales && this._locales.TEXT_SORT_DESCENDING,
                                command: 'sort-desc',
                                positionOrder: 51
                            });
                        }
                        // add a divider (separator) between the top sort commands and the other clear commands
                        if (columnHeaderMenuItems.filter(item => item !== 'divider' && item.hasOwnProperty('command') && item.positionOrder === 52).length === 0) {
                            columnHeaderMenuItems.push({ divider: true, command: '', positionOrder: 52 });
                        }
                        if (!headerMenuOptions.hideClearSortCommand && columnHeaderMenuItems.filter(item => item !== 'divider' && item.hasOwnProperty('command') && item.command === 'clear-sort').length === 0) {
                            columnHeaderMenuItems.push({
                                iconCssClass: headerMenuOptions.iconClearSortCommand || 'fa fa-unsorted',
                                title: options.enableTranslate ? this.translate.instant(`${translationPrefix}REMOVE_SORT`) : this._locales && this._locales.TEXT_REMOVE_SORT,
                                command: 'clear-sort',
                                positionOrder: 54
                            });
                        }
                    }
                    // Filtering Commands
                    if (options.enableFiltering && columnDef.filterable && headerMenuOptions && !headerMenuOptions.hideFilterCommands) {
                        if (!headerMenuOptions.hideClearFilterCommand && columnHeaderMenuItems.filter(item => item !== 'divider' && item.hasOwnProperty('command') && item.command === 'clear-filter').length === 0) {
                            columnHeaderMenuItems.push({
                                iconCssClass: headerMenuOptions.iconClearFilterCommand || 'fa fa-filter',
                                title: options.enableTranslate ? this.translate.instant(`${translationPrefix}REMOVE_FILTER`) : this._locales && this._locales.TEXT_REMOVE_FILTER,
                                command: 'clear-filter',
                                positionOrder: 53
                            });
                        }
                    }
                    // Hide Column Command
                    if (headerMenuOptions && !headerMenuOptions.hideColumnHideCommand && columnHeaderMenuItems.filter(item => item !== 'divider' && item.hasOwnProperty('command') && item.command === 'hide').length === 0) {
                        columnHeaderMenuItems.push({
                            iconCssClass: headerMenuOptions.iconColumnHideCommand || 'fa fa-times',
                            title: options.enableTranslate ? this.translate.instant(`${translationPrefix}HIDE_COLUMN`) : this._locales && this._locales.TEXT_HIDE_COLUMN,
                            command: 'hide',
                            positionOrder: 55
                        });
                    }
                    this.extensionUtility.translateItems(columnHeaderMenuItems, 'titleKey', 'title');
                    this.extensionUtility.sortItems(columnHeaderMenuItems, 'positionOrder');
                }
            });
        }
        return headerMenuOptions;
    }
    /** Hide a column from the grid */
    hideColumn(column) {
        var _a, _b;
        if ((_b = (_a = this.sharedService) === null || _a === void 0 ? void 0 : _a.grid) === null || _b === void 0 ? void 0 : _b.getColumnIndex) {
            const columnIndex = this.sharedService.grid.getColumnIndex(column.id);
            const currentVisibleColumns = this.sharedService.grid.getColumns();
            // if we're using frozen columns, we need to readjust pinning when the new hidden column is on the left pinning container
            // we need to do this because SlickGrid freezes by index and has no knowledge of the columns themselves
            const frozenColumnIndex = this.sharedService.gridOptions.frozenColumn !== undefined ? this.sharedService.gridOptions.frozenColumn : -1;
            if (frozenColumnIndex >= 0 && frozenColumnIndex >= columnIndex) {
                this.sharedService.gridOptions.frozenColumn = frozenColumnIndex - 1;
                this.sharedService.grid.setOptions({ frozenColumn: this.sharedService.gridOptions.frozenColumn });
            }
            // then proceed with hiding the column in SlickGrid & trigger an event when done
            const visibleColumns = arrayRemoveItemByIndex(currentVisibleColumns, columnIndex);
            this.sharedService.visibleColumns = visibleColumns;
            this.sharedService.grid.setColumns(visibleColumns);
            this.sharedService.onHeaderMenuHideColumns.next(visibleColumns);
        }
    }
    /**
     * Translate the Header Menu titles, we need to loop through all column definition to re-translate them
     */
    translateHeaderMenu() {
        if (this.sharedService.gridOptions && this.sharedService.gridOptions.headerMenu) {
            this.resetHeaderMenuTranslations(this.sharedService.visibleColumns);
        }
    }
    // --
    // private functions
    // ------------------
    /** @return default Header Menu options */
    getDefaultHeaderMenuOptions() {
        return {
            autoAlignOffset: 12,
            minWidth: 140,
            hideColumnHideCommand: false,
            hideSortCommands: false,
            title: ''
        };
    }
    /**
     * Reset all the internal Menu options which have text to translate
     * @param header menu object
     */
    resetHeaderMenuTranslations(columnDefinitions) {
        const gridOptions = this.sharedService.gridOptions;
        const translationPrefix = getTranslationPrefix(gridOptions);
        columnDefinitions.forEach((columnDef) => {
            if (columnDef && columnDef.header && columnDef.header && columnDef.header.menu && columnDef.header.menu.items) {
                if (!columnDef.excludeFromHeaderMenu) {
                    const columnHeaderMenuItems = columnDef.header.menu.items || [];
                    columnHeaderMenuItems.forEach(item => {
                        if (item !== 'divider' && item.hasOwnProperty('command')) {
                            switch (item.command) {
                                case 'column-resize-by-content':
                                    item.title = this.translate.instant(`${translationPrefix}COLUMN_RESIZE_BY_CONTENT`) || this._locales && this._locales.TEXT_COLUMN_RESIZE_BY_CONTENT;
                                    break;
                                case 'clear-filter':
                                    item.title = this.translate.instant(`${translationPrefix}REMOVE_FILTER`) || this._locales && this._locales.TEXT_REMOVE_FILTER;
                                    break;
                                case 'clear-sort':
                                    item.title = this.translate.instant(`${translationPrefix}REMOVE_SORT`) || this._locales && this._locales.TEXT_REMOVE_SORT;
                                    break;
                                case 'freeze-columns':
                                    item.title = this.translate.instant(`${translationPrefix}FREEZE_COLUMNS`) || this._locales && this._locales.TEXT_FREEZE_COLUMNS;
                                    break;
                                case 'sort-asc':
                                    item.title = this.translate.instant(`${translationPrefix}SORT_ASCENDING`) || this._locales && this._locales.TEXT_SORT_ASCENDING;
                                    break;
                                case 'sort-desc':
                                    item.title = this.translate.instant(`${translationPrefix}SORT_DESCENDING`) || this._locales && this._locales.TEXT_SORT_DESCENDING;
                                    break;
                                case 'hide':
                                    item.title = this.translate.instant(`${translationPrefix}HIDE_COLUMN`) || this._locales && this._locales.TEXT_HIDE_COLUMN;
                                    break;
                            }
                        }
                        // re-translate if there's a "titleKey"
                        if (this.sharedService.gridOptions && this.sharedService.gridOptions.enableTranslate) {
                            this.extensionUtility.translateItems(columnHeaderMenuItems, 'titleKey', 'title');
                        }
                    });
                }
            }
        });
    }
    /** Clear the Filter on the current column (if it's actually filtered) */
    clearColumnFilter(event, args) {
        if (args && args.column) {
            this.filterService.clearFilterByColumnId(event, args.column.id);
        }
    }
    /** Clear the Sort on the current column (if it's actually sorted) */
    clearColumnSort(event, args) {
        if (args && args.column && this.sharedService) {
            this.sortService.clearSortByColumnId(event, args.column.id);
        }
    }
    /** Execute the Header Menu Commands that was triggered by the onCommand subscribe */
    executeHeaderMenuInternalCommands(event, args) {
        if (args && args.command) {
            switch (args.command) {
                case 'hide':
                    this.hideColumn(args.column);
                    if (this.sharedService.gridOptions && this.sharedService.gridOptions.enableAutoSizeColumns) {
                        this.sharedService.grid.autosizeColumns();
                    }
                    break;
                case 'clear-filter':
                    this.clearColumnFilter(event, args);
                    break;
                case 'clear-sort':
                    this.clearColumnSort(event, args);
                    break;
                case 'column-resize-by-content':
                    this.resizerService.handleSingleColumnResizeByContent(`${args.column.id}`);
                    break;
                case 'freeze-columns':
                    const visibleColumns = [...this.sharedService.visibleColumns];
                    const columnPosition = visibleColumns.findIndex((col) => col.id === args.column.id);
                    const newGridOptions = { frozenColumn: columnPosition, enableMouseWheelScrollHandler: true };
                    // to circumvent a bug in SlickGrid core lib, let's keep the columns positions ref and re-apply them after calling setOptions
                    // the bug is highlighted in this issue comment:: https://github.com/6pac/SlickGrid/issues/592#issuecomment-822885069
                    const previousColumnDefinitions = this.sharedService.grid.getColumns();
                    this.sharedService.grid.setOptions(newGridOptions, false, true); // suppress the setColumns (3rd argument) since we'll do that ourselves
                    this.sharedService.gridOptions.frozenColumn = newGridOptions.frozenColumn;
                    this.sharedService.gridOptions.enableMouseWheelScrollHandler = newGridOptions.enableMouseWheelScrollHandler;
                    this.sharedService.frozenVisibleColumnId = args.column.id;
                    // to freeze columns, we need to take only the visible columns and we also need to use setColumns() when some of them are hidden
                    // to make sure that we only use the visible columns, not doing this will have the undesired effect of showing back some of the hidden columns
                    if (this.sharedService.hasColumnsReordered || (Array.isArray(this.sharedService.allColumns) && visibleColumns.length !== this.sharedService.allColumns.length)) {
                        this.sharedService.grid.setColumns(visibleColumns);
                    }
                    else {
                        // to circumvent a bug in SlickGrid core lib re-apply same column definitions that were backend up before calling setOptions()
                        this.sharedService.grid.setColumns(previousColumnDefinitions);
                    }
                    // we also need to autosize columns if the option is enabled
                    const gridOptions = this.sharedService.grid.getOptions();
                    if (gridOptions.enableAutoSizeColumns) {
                        this.sharedService.grid.autosizeColumns();
                    }
                    break;
                case 'sort-asc':
                case 'sort-desc':
                    const isSortingAsc = (args.command === 'sort-asc');
                    this.sortColumn(event, args, isSortingAsc);
                    break;
                default:
                    break;
            }
        }
    }
    /** Sort the current column */
    sortColumn(event, args, isSortingAsc = true) {
        if (args && args.column) {
            // get previously sorted columns
            const columnDef = args.column;
            // 1- get the sort columns without the current column, in the case of a single sort that would equal to an empty array
            const tmpSortedColumns = !this.sharedService.gridOptions.multiColumnSort ? [] : this.sortService.getCurrentColumnSorts(columnDef.id + '');
            let emitterType = EmitterType.local;
            // 2- add to the column array, the new sorted column by the header menu
            tmpSortedColumns.push({ columnId: `${columnDef.id}`, sortCol: columnDef, sortAsc: isSortingAsc });
            if (this.sharedService.gridOptions.backendServiceApi) {
                this.sortService.onBackendSortChanged(event, { multiColumnSort: true, sortCols: tmpSortedColumns, grid: this.sharedService.grid });
                emitterType = EmitterType.remote;
            }
            else if (this.sharedService.dataView) {
                this.sortService.onLocalSortChanged(this.sharedService.grid, tmpSortedColumns);
                emitterType = EmitterType.local;
            }
            else {
                // when using customDataView, we will simply send it as a onSort event with notify
                args.grid.onSort.notify(tmpSortedColumns);
            }
            // update the sharedService.grid sortColumns array which will at the same add the visual sort icon(s) on the UI
            const newSortColumns = tmpSortedColumns.map(col => {
                var _a, _b, _c;
                return {
                    columnId: (_b = (_a = col === null || col === void 0 ? void 0 : col.sortCol) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '',
                    sortAsc: (_c = col === null || col === void 0 ? void 0 : col.sortAsc) !== null && _c !== void 0 ? _c : true,
                };
            });
            // add sort icon in UI
            this.sharedService.grid.setSortColumns(newSortColumns);
            // if we have an emitter type set, we will emit a sort changed
            // for the Grid State Service to see the change.
            // We also need to pass current sorters changed to the emitSortChanged method
            if (emitterType) {
                const currentLocalSorters = [];
                newSortColumns.forEach((sortCol) => {
                    currentLocalSorters.push({
                        columnId: sortCol.columnId + '',
                        direction: sortCol.sortAsc ? 'ASC' : 'DESC'
                    });
                });
                this.sortService.emitSortChanged(emitterType, currentLocalSorters);
            }
        }
    }
}
HeaderMenuExtension.ɵfac = function HeaderMenuExtension_Factory(t) { return new (t || HeaderMenuExtension)(ɵngcc0.ɵɵinject(ExtensionUtility), ɵngcc0.ɵɵinject(FilterService), ɵngcc0.ɵɵinject(ResizerService), ɵngcc0.ɵɵinject(SharedService), ɵngcc0.ɵɵinject(SortService), ɵngcc0.ɵɵinject(ɵngcc1.TranslateService, 8)); };
HeaderMenuExtension.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: HeaderMenuExtension, factory: HeaderMenuExtension.ɵfac });
HeaderMenuExtension.ctorParameters = () => [
    { type: ExtensionUtility },
    { type: FilterService },
    { type: ResizerService },
    { type: SharedService },
    { type: SortService },
    { type: TranslateService, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HeaderMenuExtension, [{
        type: Injectable
    }], function () { return [{ type: ExtensionUtility }, { type: FilterService }, { type: ResizerService }, { type: SharedService }, { type: SortService }, { type: ɵngcc1.TranslateService, decorators: [{
                type: Optional
            }] }]; }, null); })();

const DOMPurify$3 = DOMPurify_; // patch to fix rollup to work
const ROW_DETAIL_CONTAINER_PREFIX = 'container_';
const PRELOAD_CONTAINER_PREFIX = 'container_loading';
class RowDetailViewExtension {
    constructor(angularUtilService, appRef, extensionUtility, filterService, sharedService) {
        this.angularUtilService = angularUtilService;
        this.appRef = appRef;
        this.extensionUtility = extensionUtility;
        this.filterService = filterService;
        this.sharedService = sharedService;
        this._views = [];
        this._subscriptions = [];
        this._eventHandler = new Slick.EventHandler();
    }
    get datasetIdPropName() {
        return this.gridOptions.datasetIdPropertyName || 'id';
    }
    get eventHandler() {
        return this._eventHandler;
    }
    get gridOptions() {
        return this.sharedService && this.sharedService.gridOptions || {};
    }
    get rowDetailViewOptions() {
        return this.gridOptions.rowDetailView;
    }
    /** Dispose of the RowDetailView Extension */
    dispose() {
        // unsubscribe all SlickGrid events
        this._eventHandler.unsubscribeAll();
        if (this._addon && this._addon.destroy) {
            this._addon.destroy();
        }
        this.extensionUtility.nullifyFunctionNameStartingWithOn(this._addonOptions);
        this._addonOptions = null;
        // also unsubscribe all RxJS subscriptions
        this._subscriptions = unsubscribeAllObservables(this._subscriptions);
        this.disposeAllViewComponents();
    }
    /** Dispose of all the opened Row Detail Panels Angular View Components */
    disposeAllViewComponents() {
        this._views.forEach((compRef) => this.disposeViewComponent(compRef));
        this._views = [];
    }
    /**
     * Create the plugin before the Grid creation, else it will behave oddly.
     * Mostly because the column definitions might change after the grid creation
     */
    create(columnDefinitions, gridOptions) {
        if (columnDefinitions && gridOptions) {
            if (!gridOptions.rowDetailView) {
                throw new Error('The Row Detail View requires options to be passed via the "rowDetailView" property of the Grid Options');
            }
            if (gridOptions && gridOptions.rowDetailView) {
                if (!this._addon) {
                    if (typeof gridOptions.rowDetailView.process === 'function') {
                        // we need to keep the user "process" method and replace it with our own execution method
                        // we do this because when we get the item detail, we need to call "onAsyncResponse.notify" for the plugin to work
                        this._userProcessFn = gridOptions.rowDetailView.process; // keep user's process method
                        gridOptions.rowDetailView.process = (item) => this.onProcessing(item); // replace process method & run our internal one
                    }
                    else {
                        throw new Error('You need to provide a "process" function for the Row Detail Extension to work properly');
                    }
                    // load the Preload & RowDetail Templates (could be straight HTML or Angular View/ViewModel)
                    // when those are Angular View/ViewModel, we need to create View Component & provide the html containers to the Plugin (preTemplate/postTemplate methods)
                    if (!gridOptions.rowDetailView.preTemplate) {
                        this._preloadComponent = gridOptions && gridOptions.rowDetailView && gridOptions.rowDetailView.preloadComponent;
                        gridOptions.rowDetailView.preTemplate = () => DOMPurify$3.sanitize(`<div class="${PRELOAD_CONTAINER_PREFIX}"></div>`);
                    }
                    if (!gridOptions.rowDetailView.postTemplate) {
                        this._viewComponent = gridOptions && gridOptions.rowDetailView && gridOptions.rowDetailView.viewComponent;
                        gridOptions.rowDetailView.postTemplate = (itemDetail) => DOMPurify$3.sanitize(`<div class="${ROW_DETAIL_CONTAINER_PREFIX}${itemDetail[this.datasetIdPropName]}"></div>`);
                    }
                    // finally register the Row Detail View Plugin
                    this._addonOptions = gridOptions.rowDetailView;
                    this._addon = new Slick.Plugins.RowDetailView(this._addonOptions);
                }
                const iconColumn = this._addon.getColumnDefinition();
                if (typeof iconColumn === 'object') {
                    iconColumn.excludeFromExport = true;
                    iconColumn.excludeFromColumnPicker = true;
                    iconColumn.excludeFromGridMenu = true;
                    iconColumn.excludeFromQuery = true;
                    iconColumn.excludeFromHeaderMenu = true;
                    // column index position in the grid
                    const columnPosition = gridOptions && gridOptions.rowDetailView && gridOptions.rowDetailView.columnIndexPosition || 0;
                    if (columnPosition > 0) {
                        columnDefinitions.splice(columnPosition, 0, iconColumn);
                    }
                    else {
                        columnDefinitions.unshift(iconColumn);
                    }
                }
            }
            return this._addon;
        }
        return null;
    }
    /** Get the instance of the SlickGrid addon (control or plugin). */
    getAddonInstance() {
        return this._addon;
    }
    register(rowSelectionPlugin) {
        if (this.sharedService && this.sharedService.grid && this.sharedService.gridOptions) {
            // the plugin has to be created BEFORE the grid (else it behaves oddly), but we can only watch grid events AFTER the grid is created
            this.sharedService.grid.registerPlugin(this._addon);
            // this also requires the Row Selection Model to be registered as well
            if (!rowSelectionPlugin || !this.sharedService.grid.getSelectionModel()) {
                rowSelectionPlugin = new Slick.RowSelectionModel(this.sharedService.gridOptions.rowSelectionOptions || { selectActiveRow: true });
                this.sharedService.grid.setSelectionModel(rowSelectionPlugin);
            }
            // hook all events
            if (this.sharedService.grid && this.rowDetailViewOptions) {
                if (this.rowDetailViewOptions.onExtensionRegistered) {
                    this.rowDetailViewOptions.onExtensionRegistered(this._addon);
                }
                this._eventHandler.subscribe(this._addon.onAsyncResponse, (e, args) => {
                    if (this.rowDetailViewOptions && typeof this.rowDetailViewOptions.onAsyncResponse === 'function') {
                        this.rowDetailViewOptions.onAsyncResponse(e, args);
                    }
                });
                this._eventHandler.subscribe(this._addon.onAsyncEndUpdate, (e, args) => {
                    // triggers after backend called "onAsyncResponse.notify()"
                    this.renderViewModel(args && args.item);
                    if (this.rowDetailViewOptions && typeof this.rowDetailViewOptions.onAsyncEndUpdate === 'function') {
                        this.rowDetailViewOptions.onAsyncEndUpdate(e, args);
                    }
                });
                this._eventHandler.subscribe(this._addon.onAfterRowDetailToggle, (e, args) => {
                    // display preload template & re-render all the other Detail Views after toggling
                    // the preload View will eventually go away once the data gets loaded after the "onAsyncEndUpdate" event
                    this.renderPreloadView();
                    this.renderAllViewComponents();
                    if (this.rowDetailViewOptions && typeof this.rowDetailViewOptions.onAfterRowDetailToggle === 'function') {
                        this.rowDetailViewOptions.onAfterRowDetailToggle(e, args);
                    }
                });
                this._eventHandler.subscribe(this._addon.onBeforeRowDetailToggle, (e, args) => {
                    // before toggling row detail, we need to create View Component if it doesn't exist
                    this.onBeforeRowDetailToggle(e, args);
                    if (this.rowDetailViewOptions && typeof this.rowDetailViewOptions.onBeforeRowDetailToggle === 'function') {
                        this.rowDetailViewOptions.onBeforeRowDetailToggle(e, args);
                    }
                });
                this._eventHandler.subscribe(this._addon.onRowBackToViewportRange, (e, args) => {
                    // when row is back to viewport range, we will re-render the View Component(s)
                    this.onRowBackToViewportRange(e, args);
                    if (this.rowDetailViewOptions && typeof this.rowDetailViewOptions.onRowBackToViewportRange === 'function') {
                        this.rowDetailViewOptions.onRowBackToViewportRange(e, args);
                    }
                });
                this._eventHandler.subscribe(this._addon.onRowOutOfViewportRange, (e, args) => {
                    if (this.rowDetailViewOptions && typeof this.rowDetailViewOptions.onRowOutOfViewportRange === 'function') {
                        this.rowDetailViewOptions.onRowOutOfViewportRange(e, args);
                    }
                });
                // --
                // hook some events needed by the Plugin itself
                // we need to redraw the open detail views if we change column position (column reorder)
                this._eventHandler.subscribe(this.sharedService.grid.onColumnsReordered, this.redrawAllViewComponents.bind(this));
                // on row selection changed, we also need to redraw
                if (this.gridOptions.enableRowSelection || this.gridOptions.enableCheckboxSelector) {
                    this._eventHandler.subscribe(this.sharedService.grid.onSelectedRowsChanged, this.redrawAllViewComponents.bind(this));
                }
                // on sort, all row detail are collapsed so we can dispose of all the Views as well
                this._eventHandler.subscribe(this.sharedService.grid.onSort, this.disposeAllViewComponents.bind(this));
                // on filter changed, we need to re-render all Views
                this._subscriptions.push(this.filterService.onFilterChanged.subscribe(this.redrawAllViewComponents.bind(this)));
            }
            return this._addon;
        }
        return null;
    }
    /** Redraw (re-render) all the expanded row detail View Components */
    redrawAllViewComponents() {
        this._views.forEach((compRef) => {
            this.redrawViewComponent(compRef);
        });
    }
    /** Render all the expanded row detail View Components */
    renderAllViewComponents() {
        this._views.forEach((view) => {
            if (view && view.dataContext) {
                this.renderViewModel(view.dataContext);
            }
        });
    }
    /** Redraw the necessary View Component */
    redrawViewComponent(createdView) {
        const containerElements = document.getElementsByClassName(`${ROW_DETAIL_CONTAINER_PREFIX}${createdView.id}`);
        if (containerElements && containerElements.length >= 0) {
            this.renderViewModel(createdView.dataContext);
        }
    }
    /** Render (or re-render) the View Component (Row Detail) */
    renderPreloadView() {
        const containerElements = document.getElementsByClassName(`${PRELOAD_CONTAINER_PREFIX}`);
        if (containerElements && containerElements.length >= 0) {
            this.angularUtilService.createAngularComponentAppendToDom(this._preloadComponent, containerElements[containerElements.length - 1], true);
        }
    }
    /** Render (or re-render) the View Component (Row Detail) */
    renderViewModel(item) {
        const containerElements = document.getElementsByClassName(`${ROW_DETAIL_CONTAINER_PREFIX}${item[this.datasetIdPropName]}`);
        if (containerElements && containerElements.length > 0) {
            const componentOutput = this.angularUtilService.createAngularComponentAppendToDom(this._viewComponent, containerElements[containerElements.length - 1], true);
            if (componentOutput && componentOutput.componentRef && componentOutput.componentRef.instance) {
                // pass a few properties to the Row Detail template component
                Object.assign(componentOutput.componentRef.instance, {
                    model: item,
                    addon: this._addon,
                    grid: this.sharedService.grid,
                    dataView: this.sharedService.dataView,
                    parent: this.rowDetailViewOptions && this.rowDetailViewOptions.parent,
                });
                const viewObj = this._views.find(obj => obj.id === item[this.datasetIdPropName]);
                if (viewObj) {
                    viewObj.componentRef = componentOutput.componentRef;
                }
                return viewObj;
            }
        }
        return undefined;
    }
    // --
    // private functions
    // ------------------
    disposeViewComponent(expandedView) {
        const compRef = expandedView && expandedView.componentRef;
        if (compRef) {
            this.appRef.detachView(compRef.hostView);
            compRef.destroy();
            return expandedView;
        }
        return null;
    }
    /**
     * notify the onAsyncResponse with the "args.item" (required property)
     * the plugin will then use item to populate the row detail panel with the "postTemplate"
     * @param item
     */
    notifyTemplate(item) {
        if (this._addon) {
            this._addon.onAsyncResponse.notify({ item }, undefined, this);
        }
    }
    /**
     * On Processing, we will notify the plugin with the new item detail once backend server call completes
     * @param item
     */
    onProcessing(item) {
        return __awaiter(this, void 0, void 0, function* () {
            if (item && typeof this._userProcessFn === 'function') {
                let awaitedItemDetail;
                const userProcessFn = this._userProcessFn(item);
                // wait for the "userProcessFn", once resolved we will save it into the "collection"
                const response = yield userProcessFn;
                if (response.hasOwnProperty(this.datasetIdPropName)) {
                    awaitedItemDetail = response; // from Promise
                }
                else if (response && response instanceof Observable || response instanceof Promise) {
                    awaitedItemDetail = yield castToPromise(response); // from Angular-http-client
                }
                if (!awaitedItemDetail || !awaitedItemDetail.hasOwnProperty(this.datasetIdPropName)) {
                    throw new Error(`[Angular-Slickgrid] could not process the Row Detail, you must make sure that your "process" callback
          (a Promise or an HttpClient call returning an Observable) returns an item object that has an "${this.datasetIdPropName}" property`);
                }
                // notify the plugin with the new item details
                this.notifyTemplate(awaitedItemDetail || {});
            }
        });
    }
    /**
     * Just before the row get expanded or collapsed we will do the following
     * First determine if the row is expanding or collapsing,
     * if it's expanding we will add it to our View Components reference array if we don't already have it
     * or if it's collapsing we will remove it from our View Components reference array
     */
    onBeforeRowDetailToggle(e, args) {
        // expanding
        if (args && args.item && args.item.__collapsed) {
            // expanding row detail
            const viewInfo = {
                id: args.item[this.datasetIdPropName],
                dataContext: args.item
            };
            const idPropName = this.gridOptions.datasetIdPropertyName || 'id';
            addToArrayWhenNotExists(this._views, viewInfo, idPropName);
        }
        else {
            // collapsing, so dispose of the View/Component
            const foundViewIndex = this._views.findIndex((view) => view.id === args.item[this.datasetIdPropName]);
            if (foundViewIndex >= 0 && this._views.hasOwnProperty(foundViewIndex)) {
                const compRef = this._views[foundViewIndex].componentRef;
                if (compRef) {
                    this.appRef.detachView(compRef.hostView);
                    compRef.destroy();
                }
                this._views.splice(foundViewIndex, 1);
            }
        }
    }
    /** When Row comes back to Viewport Range, we need to redraw the View */
    onRowBackToViewportRange(e, args) {
        if (args && args.item) {
            this._views.forEach((view) => {
                if (view.id === args.item[this.datasetIdPropName]) {
                    this.redrawViewComponent(view);
                }
            });
        }
    }
}
RowDetailViewExtension.ɵfac = function RowDetailViewExtension_Factory(t) { return new (t || RowDetailViewExtension)(ɵngcc0.ɵɵinject(AngularUtilService), ɵngcc0.ɵɵinject(ɵngcc0.ApplicationRef), ɵngcc0.ɵɵinject(ExtensionUtility), ɵngcc0.ɵɵinject(FilterService), ɵngcc0.ɵɵinject(SharedService)); };
RowDetailViewExtension.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: RowDetailViewExtension, factory: RowDetailViewExtension.ɵfac });
RowDetailViewExtension.ctorParameters = () => [
    { type: AngularUtilService },
    { type: ApplicationRef },
    { type: ExtensionUtility },
    { type: FilterService },
    { type: SharedService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RowDetailViewExtension, [{
        type: Injectable
    }], function () { return [{ type: AngularUtilService }, { type: ɵngcc0.ApplicationRef }, { type: ExtensionUtility }, { type: FilterService }, { type: SharedService }]; }, null); })();

class RowMoveManagerExtension {
    constructor(sharedService) {
        this.sharedService = sharedService;
        this._eventHandler = new Slick.EventHandler();
    }
    get eventHandler() {
        return this._eventHandler;
    }
    dispose() {
        // unsubscribe all SlickGrid events
        this._eventHandler.unsubscribeAll();
        if (this._addon && this._addon.destroy) {
            this._addon.destroy();
            this._addon = null;
        }
        if (this._rowSelectionPlugin && this._rowSelectionPlugin.destroy) {
            this._rowSelectionPlugin.destroy();
        }
    }
    /**
     * Create the plugin before the Grid creation to avoid having odd behaviors.
     * Mostly because the column definitions might change after the grid creation, so we want to make sure to add it before then
     */
    create(columnDefinitions, gridOptions) {
        if (Array.isArray(columnDefinitions) && gridOptions) {
            this._addon = this.loadAddonWhenNotExists(columnDefinitions, gridOptions);
            const newRowMoveColumn = this._addon.getColumnDefinition();
            const rowMoveColDef = Array.isArray(columnDefinitions) && columnDefinitions.find((col) => col && col.behavior === 'selectAndMove');
            const finalRowMoveColumn = rowMoveColDef ? rowMoveColDef : newRowMoveColumn;
            // set some exclusion properties since we don't want this column to be part of the export neither the list of column in the pickers
            if (typeof finalRowMoveColumn === 'object') {
                finalRowMoveColumn.excludeFromExport = true;
                finalRowMoveColumn.excludeFromColumnPicker = true;
                finalRowMoveColumn.excludeFromGridMenu = true;
                finalRowMoveColumn.excludeFromQuery = true;
                finalRowMoveColumn.excludeFromHeaderMenu = true;
            }
            // only add the new column if it doesn't already exist
            if (!rowMoveColDef) {
                // column index position in the grid
                const columnPosition = gridOptions && gridOptions.rowMoveManager && gridOptions.rowMoveManager.columnIndexPosition || 0;
                if (columnPosition > 0) {
                    columnDefinitions.splice(columnPosition, 0, finalRowMoveColumn);
                }
                else {
                    columnDefinitions.unshift(finalRowMoveColumn);
                }
            }
            return this._addon;
        }
        return null;
    }
    loadAddonWhenNotExists(columnDefinitions, gridOptions) {
        if (Array.isArray(columnDefinitions) && gridOptions) {
            if (!this._addon) {
                this._addon = new Slick.RowMoveManager(gridOptions && gridOptions.rowMoveManager || { cancelEditOnDrag: true });
            }
            return this._addon;
        }
        return null;
    }
    /** Get the instance of the SlickGrid addon (control or plugin). */
    getAddonInstance() {
        return this._addon;
    }
    register(rowSelectionPlugin) {
        if (this.sharedService && this.sharedService.grid && this.sharedService.gridOptions) {
            // this also requires the Row Selection Model to be registered as well
            if (!rowSelectionPlugin || !this.sharedService.grid.getSelectionModel()) {
                rowSelectionPlugin = new Slick.RowSelectionModel(this.sharedService.gridOptions.rowSelectionOptions || {});
                this.sharedService.grid.setSelectionModel(rowSelectionPlugin);
            }
            this._rowSelectionPlugin = rowSelectionPlugin;
            this.sharedService.grid.registerPlugin(this._addon);
            // hook all events
            if (this.sharedService.grid && this.sharedService.gridOptions.rowMoveManager) {
                if (this.sharedService.gridOptions.rowMoveManager.onExtensionRegistered) {
                    this.sharedService.gridOptions.rowMoveManager.onExtensionRegistered(this._addon);
                }
                this._eventHandler.subscribe(this._addon.onBeforeMoveRows, (e, args) => {
                    if (this.sharedService.gridOptions.rowMoveManager && typeof this.sharedService.gridOptions.rowMoveManager.onBeforeMoveRows === 'function') {
                        return this.sharedService.gridOptions.rowMoveManager.onBeforeMoveRows(e, args);
                    }
                });
                this._eventHandler.subscribe(this._addon.onMoveRows, (e, args) => {
                    if (this.sharedService.gridOptions.rowMoveManager && typeof this.sharedService.gridOptions.rowMoveManager.onMoveRows === 'function') {
                        this.sharedService.gridOptions.rowMoveManager.onMoveRows(e, args);
                    }
                });
            }
            return this._addon;
        }
        return null;
    }
}
RowMoveManagerExtension.ɵfac = function RowMoveManagerExtension_Factory(t) { return new (t || RowMoveManagerExtension)(ɵngcc0.ɵɵinject(SharedService)); };
RowMoveManagerExtension.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: RowMoveManagerExtension, factory: RowMoveManagerExtension.ɵfac });
RowMoveManagerExtension.ctorParameters = () => [
    { type: SharedService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RowMoveManagerExtension, [{
        type: Injectable
    }], function () { return [{ type: SharedService }]; }, null); })();

class RowSelectionExtension {
    constructor(sharedService) {
        this.sharedService = sharedService;
    }
    dispose() {
        if (this._addon && this._addon.destroy) {
            this._addon.destroy();
        }
        this._addon = null;
    }
    /** Get the instance of the SlickGrid addon (control or plugin). */
    getAddonInstance() {
        return this._addon;
    }
    register() {
        if (this.sharedService && this.sharedService.grid && this.sharedService.gridOptions) {
            this._addon = new Slick.RowSelectionModel(this.sharedService.gridOptions.rowSelectionOptions || {});
            this.sharedService.grid.setSelectionModel(this._addon);
            return this._addon;
        }
        return null;
    }
}
RowSelectionExtension.ɵfac = function RowSelectionExtension_Factory(t) { return new (t || RowSelectionExtension)(ɵngcc0.ɵɵinject(SharedService)); };
RowSelectionExtension.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: RowSelectionExtension, factory: RowSelectionExtension.ɵfac });
RowSelectionExtension.ctorParameters = () => [
    { type: SharedService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RowSelectionExtension, [{
        type: Injectable
    }], function () { return [{ type: SharedService }]; }, null); })();

// import common 3rd party SlickGrid plugins/libs
class ExtensionService {
    constructor(autoTooltipExtension, cellExternalCopyExtension, cellMenuExtension, checkboxSelectorExtension, columnPickerExtension, contextMenuExtension, draggableGroupingExtension, gridMenuExtension, groupItemMetaExtension, headerButtonExtension, headerMenuExtension, rowDetailViewExtension, rowMoveManagerExtension, rowSelectionExtension, sharedService, translate) {
        this.autoTooltipExtension = autoTooltipExtension;
        this.cellExternalCopyExtension = cellExternalCopyExtension;
        this.cellMenuExtension = cellMenuExtension;
        this.checkboxSelectorExtension = checkboxSelectorExtension;
        this.columnPickerExtension = columnPickerExtension;
        this.contextMenuExtension = contextMenuExtension;
        this.draggableGroupingExtension = draggableGroupingExtension;
        this.gridMenuExtension = gridMenuExtension;
        this.groupItemMetaExtension = groupItemMetaExtension;
        this.headerButtonExtension = headerButtonExtension;
        this.headerMenuExtension = headerMenuExtension;
        this.rowDetailViewExtension = rowDetailViewExtension;
        this.rowMoveManagerExtension = rowMoveManagerExtension;
        this.rowSelectionExtension = rowSelectionExtension;
        this.sharedService = sharedService;
        this.translate = translate;
        this._extensionCreatedList = {};
        this._extensionList = {};
    }
    get extensionList() {
        return this._extensionList;
    }
    /** Dispose of all the controls & plugins */
    dispose() {
        this.sharedService.grid = null;
        this.sharedService.visibleColumns = [];
        // dispose of each control/plugin & reset the list
        for (const extensionName of Object.keys(this._extensionList)) {
            if (this._extensionList.hasOwnProperty(extensionName)) {
                const extension = this._extensionList[extensionName];
                if (extension && extension.class && extension.class.dispose) {
                    extension.class.dispose();
                }
            }
        }
        for (const key of Object.keys(this._extensionList)) {
            delete this._extensionList[key];
        }
    }
    /** Get all columns (includes visible and non-visible) */
    getAllColumns() {
        return this.sharedService.allColumns || [];
    }
    /** Get only visible columns */
    getVisibleColumns() {
        return this.sharedService.visibleColumns || [];
    }
    /**
     * Get an Extension by it's name
     *  @param name
     */
    getExtensionByName(name) {
        if (this._extensionList && this._extensionList[name]) {
            return this._extensionList[name];
        }
        return undefined;
    }
    /**
     * Get the instance of the SlickGrid addon (control or plugin).
     * This is the raw addon coming directly from SlickGrid itself, not to confuse with Angular-Slickgrid extension
     *  @param name
     */
    getSlickgridAddonInstance(name) {
        const extension = this.getExtensionByName(name);
        if (extension && extension.class && (extension.instance || extension.addon)) {
            if (extension.class && extension.class.getAddonInstance) {
                return extension.class.getAddonInstance();
            }
            return extension.instance;
        }
        return null;
    }
    /** Auto-resize all the column in the grid to fit the grid width */
    autoResizeColumns() {
        this.sharedService.grid.autosizeColumns();
    }
    /** Bind/Create different Controls or Plugins after the Grid is created */
    bindDifferentExtensions() {
        if (this.sharedService && this.sharedService.gridOptions) {
            // make sure all columns are translated before creating ColumnPicker/GridMenu Controls
            // this is to avoid having hidden columns not being translated on first load
            if (this.sharedService.gridOptions.enableTranslate) {
                // eventually deprecate the "headerKey" and use only the "nameKey"
                this.translateItems(this.sharedService.allColumns, 'headerKey', 'name');
                this.translateItems(this.sharedService.allColumns, 'nameKey', 'name');
            }
            // Auto Tooltip Plugin
            if (this.sharedService.gridOptions.enableAutoTooltip) {
                if (this.autoTooltipExtension && this.autoTooltipExtension.register) {
                    const instance = this.autoTooltipExtension.register();
                    this._extensionList[ExtensionName.autoTooltip] = { name: ExtensionName.autoTooltip, class: this.autoTooltipExtension, addon: instance, instance };
                }
            }
            // Cell External Copy Manager Plugin (Excel Like)
            if (this.sharedService.gridOptions.enableExcelCopyBuffer) {
                if (this.cellExternalCopyExtension && this.cellExternalCopyExtension.register) {
                    const instance = this.cellExternalCopyExtension.register();
                    this._extensionList[ExtensionName.cellExternalCopyManager] = { name: ExtensionName.cellExternalCopyManager, class: this.cellExternalCopyExtension, addon: instance, instance };
                }
            }
            // (Action) Cell Menu Plugin
            if (this.sharedService.gridOptions.enableCellMenu) {
                if (this.cellMenuExtension && this.cellMenuExtension.register) {
                    const instance = this.cellMenuExtension.register();
                    this._extensionList[ExtensionName.cellMenu] = { name: ExtensionName.cellMenu, class: this.cellMenuExtension, addon: instance, instance };
                }
            }
            // Row Selection Plugin
            // this extension should be registered BEFORE the CheckboxSelector, RowDetail or RowMoveManager since it can be use by these 2 plugins
            if (!this.getExtensionByName(ExtensionName.rowSelection) && (this.sharedService.gridOptions.enableRowSelection || this.sharedService.gridOptions.enableCheckboxSelector || this.sharedService.gridOptions.enableRowDetailView || this.sharedService.gridOptions.enableRowMoveManager)) {
                if (this.rowSelectionExtension && this.rowSelectionExtension.register) {
                    const instance = this.rowSelectionExtension.register();
                    this._extensionList[ExtensionName.rowSelection] = { name: ExtensionName.rowSelection, class: this.rowSelectionExtension, addon: instance, instance };
                }
            }
            // Checkbox Selector Plugin
            if (this.sharedService.gridOptions.enableCheckboxSelector) {
                if (this.checkboxSelectorExtension && this.checkboxSelectorExtension.register) {
                    const rowSelectionExtension = this.getExtensionByName(ExtensionName.rowSelection);
                    this.checkboxSelectorExtension.register(rowSelectionExtension);
                    const createdExtension = this.getCreatedExtensionByName(ExtensionName.checkboxSelector); // get the instance from when it was really created earlier
                    const instance = createdExtension && createdExtension.instance;
                    this._extensionList[ExtensionName.checkboxSelector] = { name: ExtensionName.checkboxSelector, class: this.checkboxSelectorExtension, addon: instance, instance };
                }
            }
            // Column Picker Control
            if (this.sharedService.gridOptions.enableColumnPicker) {
                if (this.columnPickerExtension && this.columnPickerExtension.register) {
                    const instance = this.columnPickerExtension.register();
                    this._extensionList[ExtensionName.columnPicker] = { name: ExtensionName.columnPicker, class: this.columnPickerExtension, addon: instance, instance };
                }
            }
            // Context Menu Control
            if (this.sharedService.gridOptions.enableContextMenu) {
                if (this.contextMenuExtension && this.contextMenuExtension.register) {
                    const instance = this.contextMenuExtension.register();
                    this._extensionList[ExtensionName.contextMenu] = { name: ExtensionName.contextMenu, class: this.contextMenuExtension, addon: instance, instance };
                }
            }
            // Draggable Grouping Plugin
            if (this.sharedService.gridOptions.enableDraggableGrouping) {
                if (this.draggableGroupingExtension && this.draggableGroupingExtension.register) {
                    const instance = this.draggableGroupingExtension.register();
                    this._extensionList[ExtensionName.draggableGrouping] = { name: ExtensionName.draggableGrouping, class: this.draggableGroupingExtension, addon: instance, instance };
                }
            }
            // Grid Menu Control
            if (this.sharedService.gridOptions.enableGridMenu) {
                if (this.gridMenuExtension && this.gridMenuExtension.register) {
                    const instance = this.gridMenuExtension.register();
                    this._extensionList[ExtensionName.gridMenu] = { name: ExtensionName.gridMenu, class: this.gridMenuExtension, addon: instance, instance };
                }
            }
            // Grouping Plugin
            // register the group item metadata provider to add expand/collapse group handlers
            if (this.sharedService.gridOptions.enableDraggableGrouping || this.sharedService.gridOptions.enableGrouping) {
                if (this.groupItemMetaExtension && this.groupItemMetaExtension.register) {
                    const instance = this.groupItemMetaExtension.register();
                    this._extensionList[ExtensionName.groupItemMetaProvider] = { name: ExtensionName.groupItemMetaProvider, class: this.groupItemMetaExtension, addon: instance, instance };
                }
            }
            // Header Button Plugin
            if (this.sharedService.gridOptions.enableHeaderButton) {
                if (this.headerButtonExtension && this.headerButtonExtension.register) {
                    const instance = this.headerButtonExtension.register();
                    this._extensionList[ExtensionName.headerButton] = { name: ExtensionName.headerButton, class: this.headerButtonExtension, addon: instance, instance };
                }
            }
            // Header Menu Plugin
            if (this.sharedService.gridOptions.enableHeaderMenu) {
                if (this.headerMenuExtension && this.headerMenuExtension.register) {
                    const instance = this.headerMenuExtension.register();
                    this._extensionList[ExtensionName.headerMenu] = { name: ExtensionName.headerMenu, class: this.headerMenuExtension, addon: instance, instance };
                }
            }
            // Row Detail View Plugin
            if (this.sharedService.gridOptions.enableRowDetailView) {
                if (this.rowDetailViewExtension && this.rowDetailViewExtension.register) {
                    const rowSelectionExtension = this.getExtensionByName(ExtensionName.rowSelection);
                    this.rowDetailViewExtension.register(rowSelectionExtension);
                    const createdExtension = this.getCreatedExtensionByName(ExtensionName.rowDetailView); // get the plugin from when it was really created earlier
                    const instance = createdExtension && createdExtension.instance;
                    this._extensionList[ExtensionName.rowDetailView] = { name: ExtensionName.rowDetailView, class: this.rowDetailViewExtension, addon: instance, instance };
                }
            }
            // Row Move Manager Plugin
            if (this.sharedService.gridOptions.enableRowMoveManager && this.rowMoveManagerExtension && this.rowMoveManagerExtension.register) {
                const rowSelectionExtension = this.getExtensionByName(ExtensionName.rowSelection);
                this.rowMoveManagerExtension.register(rowSelectionExtension);
                const createdExtension = this.getCreatedExtensionByName(ExtensionName.rowMoveManager); // get the instance from when it was really created earlier
                const instance = createdExtension && createdExtension.instance;
                this._extensionList[ExtensionName.rowMoveManager] = { name: ExtensionName.rowMoveManager, class: this.rowMoveManagerExtension, addon: instance, instance };
            }
            // manually register other plugins
            if (this.sharedService.gridOptions.registerPlugins !== undefined) {
                const grid = this.sharedService.grid;
                const gridOptions = this.sharedService.gridOptions;
                if (Array.isArray(gridOptions.registerPlugins)) {
                    gridOptions.registerPlugins.forEach((plugin) => {
                        grid.registerPlugin(plugin);
                        const instance = grid.getPluginByName(plugin && plugin.name || '');
                        this._extensionList[ExtensionName.noname] = { name: ExtensionName.noname, class: null, addon: instance, instance };
                    });
                }
                else {
                    const plugin = gridOptions.registerPlugins;
                    grid.registerPlugin(plugin);
                    const instance = grid.getPluginByName(plugin && plugin.name || '');
                    this._extensionList[ExtensionName.noname] = { name: ExtensionName.noname, class: null, addon: instance, instance };
                }
            }
        }
    }
    /**
     * Bind/Create certain plugins before the Grid creation to avoid having odd behaviors.
     * Mostly because the column definitions might change after the grid creation, so we want to make sure to add it before then
     * @param columnDefinitions
     * @param gridOptions
     */
    createExtensionsBeforeGridCreation(columnDefinitions, gridOptions) {
        var _a, _b, _c, _d, _e, _f;
        const featureWithColumnIndexPositions = [];
        // the following 3 features might have `columnIndexPosition` that we need to respect their column order, we will execute them by their sort order further down
        // we push them into a array and we'll process them by their position (if provided, else use same order that they were inserted)
        if (gridOptions.enableCheckboxSelector) {
            if (!this.getCreatedExtensionByName(ExtensionName.checkboxSelector)) {
                featureWithColumnIndexPositions.push({ name: ExtensionName.checkboxSelector, extension: this.checkboxSelectorExtension, columnIndexPosition: (_b = (_a = gridOptions === null || gridOptions === void 0 ? void 0 : gridOptions.checkboxSelector) === null || _a === void 0 ? void 0 : _a.columnIndexPosition) !== null && _b !== void 0 ? _b : featureWithColumnIndexPositions.length });
            }
        }
        if (gridOptions.enableRowMoveManager) {
            if (!this.getCreatedExtensionByName(ExtensionName.rowMoveManager)) {
                featureWithColumnIndexPositions.push({ name: ExtensionName.rowMoveManager, extension: this.rowMoveManagerExtension, columnIndexPosition: (_d = (_c = gridOptions === null || gridOptions === void 0 ? void 0 : gridOptions.rowMoveManager) === null || _c === void 0 ? void 0 : _c.columnIndexPosition) !== null && _d !== void 0 ? _d : featureWithColumnIndexPositions.length });
            }
        }
        if (gridOptions.enableRowDetailView) {
            if (!this.getCreatedExtensionByName(ExtensionName.rowDetailView)) {
                featureWithColumnIndexPositions.push({ name: ExtensionName.rowDetailView, extension: this.rowDetailViewExtension, columnIndexPosition: (_f = (_e = gridOptions === null || gridOptions === void 0 ? void 0 : gridOptions.rowDetailView) === null || _e === void 0 ? void 0 : _e.columnIndexPosition) !== null && _f !== void 0 ? _f : featureWithColumnIndexPositions.length });
            }
        }
        // since some features could have a `columnIndexPosition`, we need to make sure these indexes are respected in the column definitions
        this.createExtensionByTheirColumnIndex(featureWithColumnIndexPositions, columnDefinitions, gridOptions);
        if (gridOptions.enableDraggableGrouping) {
            if (!this.getCreatedExtensionByName(ExtensionName.draggableGrouping)) {
                const draggableInstance = this.draggableGroupingExtension.create(gridOptions);
                if (draggableInstance) {
                    gridOptions.enableColumnReorder = draggableInstance.getSetupColumnReorder;
                    this._extensionCreatedList[ExtensionName.draggableGrouping] = { name: ExtensionName.draggableGrouping, addon: draggableInstance, instance: draggableInstance, class: this.draggableGroupingExtension };
                }
            }
        }
    }
    /** Hide a column from the grid */
    hideColumn(column) {
        if (this.sharedService && this.sharedService.grid && this.sharedService.grid.getColumns && this.sharedService.grid.setColumns) {
            const columnIndex = this.sharedService.grid.getColumnIndex(column.id);
            this.sharedService.visibleColumns = this.removeColumnByIndex(this.sharedService.grid.getColumns(), columnIndex);
            this.sharedService.grid.setColumns(this.sharedService.visibleColumns);
        }
    }
    /** Refresh the dataset through the Backend Service */
    refreshBackendDataset(gridOptions) {
        this.gridMenuExtension.refreshBackendDataset(gridOptions);
    }
    /**
     * Remove a column from the grid by it's index in the grid
     * @param columns input
     * @param index
     */
    removeColumnByIndex(columns, index) {
        if (Array.isArray(columns)) {
            return columns.filter((el, i) => index !== i);
        }
        return columns;
    }
    /** Translate the Cell Menu titles, we need to loop through all column definition to re-translate them */
    translateCellMenu() {
        if (this.cellMenuExtension && this.cellMenuExtension.translateCellMenu) {
            this.cellMenuExtension.translateCellMenu();
        }
    }
    /** Translate the Column Picker and it's last 2 checkboxes */
    translateColumnPicker() {
        if (this.columnPickerExtension && this.columnPickerExtension.translateColumnPicker) {
            this.columnPickerExtension.translateColumnPicker();
        }
    }
    /** Translate the Context Menu titles, we need to loop through all column definition to re-translate them */
    translateContextMenu() {
        if (this.contextMenuExtension && this.contextMenuExtension.translateContextMenu) {
            this.contextMenuExtension.translateContextMenu();
        }
    }
    /**
     * Translate the Header Menu titles, we need to loop through all column definition to re-translate them
     */
    translateGridMenu() {
        if (this.gridMenuExtension && this.gridMenuExtension.translateGridMenu) {
            this.gridMenuExtension.translateGridMenu();
        }
    }
    /**
     * Translate the Header Menu titles, we need to loop through all column definition to re-translate them
     */
    translateHeaderMenu() {
        if (this.headerMenuExtension && this.headerMenuExtension.translateHeaderMenu) {
            this.headerMenuExtension.translateHeaderMenu();
        }
    }
    /**
     * Translate manually the header titles.
     * We could optionally pass a locale (that will change currently loaded locale), else it will use current locale
     * @param locale to use
     * @param new column definitions (optional)
     */
    translateColumnHeaders(locale, newColumnDefinitions) {
        if (this.sharedService && this.sharedService.gridOptions && this.sharedService.gridOptions.enableTranslate && (!this.translate || !this.translate.instant)) {
            throw new Error('[Angular-Slickgrid] requires "ngx-translate" to be installed and configured when the grid option "enableTranslate" is enabled.');
        }
        if (locale) {
            this.translate.use(locale);
        }
        let columnDefinitions = newColumnDefinitions;
        if (!columnDefinitions) {
            columnDefinitions = this.sharedService.columnDefinitions;
        }
        // eventually deprecate the "headerKey" and use only the "nameKey"
        this.translateItems(columnDefinitions, 'headerKey', 'name');
        this.translateItems(this.sharedService.allColumns, 'headerKey', 'name');
        this.translateItems(columnDefinitions, 'nameKey', 'name');
        this.translateItems(this.sharedService.allColumns, 'nameKey', 'name');
        // re-render the column headers
        this.renderColumnHeaders(columnDefinitions, Array.isArray(newColumnDefinitions));
        this.gridMenuExtension.translateGridMenu();
    }
    /**
     * Render (or re-render) the column headers from column definitions.
     * calling setColumns() will trigger a grid re-render
     */
    renderColumnHeaders(newColumnDefinitions, forceColumnDefinitionsOverwrite = false) {
        let collection = newColumnDefinitions;
        if (!collection) {
            collection = this.sharedService.columnDefinitions;
        }
        if (Array.isArray(collection) && this.sharedService.grid && this.sharedService.grid.setColumns) {
            if (collection.length > this.sharedService.allColumns.length || forceColumnDefinitionsOverwrite) {
                this.sharedService.allColumns = collection;
            }
            this.sharedService.grid.setColumns(collection);
        }
        // recreate the Column Picker when enabled
        if (this.sharedService.gridOptions.enableColumnPicker) {
            this.recreateExternalAddon(this.columnPickerExtension, ExtensionName.columnPicker);
        }
        // recreate the Grid Menu when enabled
        if (this.sharedService.gridOptions.enableGridMenu) {
            this.recreateExternalAddon(this.gridMenuExtension, ExtensionName.gridMenu);
        }
        // recreate the Header Menu when enabled
        if (this.sharedService.gridOptions.enableHeaderMenu) {
            this.recreateExternalAddon(this.headerMenuExtension, ExtensionName.headerMenu);
        }
    }
    //
    // private functions
    // -------------------
    /**
     * Some extension (feature) have specific `columnIndexPosition` that the developer want to use, we need to make sure these indexes are respected in the column definitions in the order provided.
     * the following 3 features might have `columnIndexPosition` that we need to respect their column order, we will execute them by their sort order further down
     * we push them into a array and we'll process them by their position (if provided, else use same order that they were inserted)
     * @param featureWithIndexPositions
     * @param columnDefinitions
     * @param gridOptions
     */
    createExtensionByTheirColumnIndex(featureWithIndexPositions, columnDefinitions, gridOptions) {
        // 1- first step is to sort them by their index position
        featureWithIndexPositions.sort((feat1, feat2) => feat1.columnIndexPosition - feat2.columnIndexPosition);
        // 2- second step, we can now proceed to create each extension/addon and that will position them accordingly in the column definitions list
        featureWithIndexPositions.forEach(feature => {
            const instance = feature.extension.create(columnDefinitions, gridOptions);
            if (instance) {
                this._extensionCreatedList[feature.name] = { name: feature.name, addon: instance, instance, class: feature.extension };
            }
        });
    }
    /**
     * Get an Extension that was created by calling its "create" method (there are only 3 extensions which uses this method)
     *  @param name
     */
    getCreatedExtensionByName(name) {
        if (this._extensionCreatedList && this._extensionCreatedList.hasOwnProperty(name)) {
            return this._extensionCreatedList[name];
        }
        return undefined;
    }
    /**
     * Dispose of previous extension/addon instance, then re-register it and don't forget to overwrite previous instance ref
     * @param extensionName
     */
    recreateExternalAddon(externalExtension, extensionName) {
        externalExtension.dispose();
        const instance = externalExtension.register();
        const extension = this.getExtensionByName(extensionName);
        if (extension) {
            extension.addon = instance;
            extension.instance = instance;
        }
    }
    /** Translate an array of items from an input key and assign translated value to the output key */
    translateItems(items, inputKey, outputKey) {
        if (this.sharedService.gridOptions && this.sharedService.gridOptions.enableTranslate && (!this.translate || !this.translate.instant)) {
            throw new Error('[Angular-Slickgrid] requires "ngx-translate" to be installed and configured when the grid option "enableTranslate" is enabled.');
        }
        if (Array.isArray(items)) {
            for (const item of items) {
                if (item[inputKey]) {
                    item[outputKey] = this.translate && this.translate.currentLang && this.translate.instant(item[inputKey]);
                }
            }
        }
    }
}
ExtensionService.ɵfac = function ExtensionService_Factory(t) { return new (t || ExtensionService)(ɵngcc0.ɵɵinject(AutoTooltipExtension), ɵngcc0.ɵɵinject(CellExternalCopyManagerExtension), ɵngcc0.ɵɵinject(CellMenuExtension), ɵngcc0.ɵɵinject(CheckboxSelectorExtension), ɵngcc0.ɵɵinject(ColumnPickerExtension), ɵngcc0.ɵɵinject(ContextMenuExtension), ɵngcc0.ɵɵinject(DraggableGroupingExtension), ɵngcc0.ɵɵinject(GridMenuExtension), ɵngcc0.ɵɵinject(GroupItemMetaProviderExtension), ɵngcc0.ɵɵinject(HeaderButtonExtension), ɵngcc0.ɵɵinject(HeaderMenuExtension), ɵngcc0.ɵɵinject(RowDetailViewExtension), ɵngcc0.ɵɵinject(RowMoveManagerExtension), ɵngcc0.ɵɵinject(RowSelectionExtension), ɵngcc0.ɵɵinject(SharedService), ɵngcc0.ɵɵinject(ɵngcc1.TranslateService, 8)); };
ExtensionService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ExtensionService, factory: ExtensionService.ɵfac });
ExtensionService.ctorParameters = () => [
    { type: AutoTooltipExtension },
    { type: CellExternalCopyManagerExtension },
    { type: CellMenuExtension },
    { type: CheckboxSelectorExtension },
    { type: ColumnPickerExtension },
    { type: ContextMenuExtension },
    { type: DraggableGroupingExtension },
    { type: GridMenuExtension },
    { type: GroupItemMetaProviderExtension },
    { type: HeaderButtonExtension },
    { type: HeaderMenuExtension },
    { type: RowDetailViewExtension },
    { type: RowMoveManagerExtension },
    { type: RowSelectionExtension },
    { type: SharedService },
    { type: TranslateService, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ExtensionService, [{
        type: Injectable
    }], function () { return [{ type: AutoTooltipExtension }, { type: CellExternalCopyManagerExtension }, { type: CellMenuExtension }, { type: CheckboxSelectorExtension }, { type: ColumnPickerExtension }, { type: ContextMenuExtension }, { type: DraggableGroupingExtension }, { type: GridMenuExtension }, { type: GroupItemMetaProviderExtension }, { type: HeaderButtonExtension }, { type: HeaderMenuExtension }, { type: RowDetailViewExtension }, { type: RowMoveManagerExtension }, { type: RowSelectionExtension }, { type: SharedService }, { type: ɵngcc1.TranslateService, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * This GraphqlQueryBuilder class is a lib that already exist
 * but was causing issues with TypeScript, RequireJS and other bundler/packagers
 * and so I rewrote it in pure TypeScript.
 *
 * The previous lib can be viewed here at this Github
 * https://github.com/codemeasandwich/graphql-query-builder
 */
class GraphqlQueryBuilder {
    /* Constructor, query/mutator you wish to use, and an alias or filter arguments. */
    constructor(queryFnName, aliasOrFilter) {
        this.queryFnName = queryFnName;
        this.head = [];
        if (typeof aliasOrFilter === 'string') {
            this.alias = aliasOrFilter;
        }
        else if (typeof aliasOrFilter === 'object') {
            this.filter(aliasOrFilter);
        }
        else if (aliasOrFilter === undefined && arguments.length === 2) {
            throw new TypeError(`You have passed undefined as Second argument to "Query"`);
        }
        else if (aliasOrFilter !== undefined) {
            throw new TypeError(`Second argument to "Query" should be an alias name(String) or filter arguments(Object). What was passed is: ${aliasOrFilter}`);
        }
    }
    /**
     * The parameters to run the query against.
     * @param filters An object mapping attribute to values
     */
    filter(filters) {
        for (const prop of Object.keys(filters)) {
            if (typeof filters[prop] === 'function') {
                continue;
            }
            const val = this.getGraphQLValue(filters[prop]);
            if (val === '{}') {
                continue;
            }
            this.head.push(`${prop}:${val}`);
        }
        return this;
    }
    /**
     * Outlines the properties you wish to be returned from the query.
     * @param properties representing each attribute you want Returned
     */
    find(...searches) {
        if (!searches || !Array.isArray(searches) || searches.length === 0) {
            throw new TypeError(`find value can not be >>falsy<<`);
        }
        // if its a string.. it may have other values
        // else it sould be an Object or Array of maped values
        const searchKeys = (searches.length === 1 && Array.isArray(searches[0])) ? searches[0] : searches;
        this.body = this.parceFind(searchKeys);
        return this;
    }
    /**
     * set an alias for this result.
     * @param alias
     */
    setAlias(alias) {
        this.alias = alias;
    }
    /**
     * Return to the formatted query string
     * @return
     */
    toString() {
        if (this.body === undefined) {
            throw new ReferenceError(`return properties are not defined. use the 'find' function to defined them`);
        }
        return `${(this.alias) ? (this.alias + ':') : ''} ${this.queryFnName} ${(this.head.length > 0) ? '(' + this.head.join(',') + ')' : ''}  { ${this.body} }`;
    }
    // --
    // PRIVATE FUNCTIONS
    // -----------------
    parceFind(_levelA) {
        const propsA = _levelA.map((currentValue, index) => {
            const itemX = _levelA[index];
            if (itemX instanceof GraphqlQueryBuilder) {
                return itemX.toString();
            }
            else if (!Array.isArray(itemX) && typeof itemX === 'object') {
                const propsAA = Object.keys(itemX);
                if (1 !== propsAA.length) {
                    throw new RangeError(`Alias objects should only have one value. was passed: ${JSON.stringify(itemX)}`);
                }
                const propS = propsAA[0];
                const item = itemX[propS];
                if (Array.isArray(item)) {
                    return new GraphqlQueryBuilder(propS).find(item);
                }
                return `${propS} : ${item} `;
            }
            else if (typeof itemX === 'string') {
                return itemX;
            }
            else {
                throw new RangeError(`cannot handle Find value of ${itemX}`);
            }
        });
        return propsA.join(',');
    }
    getGraphQLValue(value) {
        if (typeof value === 'string') {
            value = JSON.stringify(value);
        }
        else if (Array.isArray(value)) {
            value = value.map(item => {
                return this.getGraphQLValue(item);
            }).join();
            value = `[${value}]`;
        }
        else if (value instanceof Date) {
            value = JSON.stringify(value);
        }
        else if (value !== null && typeof value === 'object') {
            value = this.objectToString(value);
        }
        return value;
    }
    objectToString(obj) {
        const sourceA = [];
        for (const prop of Object.keys(obj)) {
            if (typeof obj[prop] === 'function') {
                continue;
            }
            sourceA.push(`${prop}:${this.getGraphQLValue(obj[prop])}`);
        }
        return `{${sourceA.join()}}`;
    }
}

const DEFAULT_ITEMS_PER_PAGE$1 = 25;
const DEFAULT_PAGE_SIZE$1 = 20;
class GraphqlService {
    constructor() {
        this._currentFilters = [];
        this._currentSorters = [];
        this._datasetIdPropName = 'id';
        this.defaultPaginationOptions = {
            first: DEFAULT_ITEMS_PER_PAGE$1,
            offset: 0
        };
    }
    /** Getter for the Column Definitions */
    get columnDefinitions() {
        return this._columnDefinitions;
    }
    /** Getter for the Grid Options pulled through the Grid Object */
    get _gridOptions() {
        return (this._grid && this._grid.getOptions) ? this._grid.getOptions() : {};
    }
    /** Initialization of the service, which acts as a constructor */
    init(serviceOptions, pagination, grid, sharedService) {
        var _a, _b;
        this._grid = grid;
        this.options = serviceOptions || { datasetName: '', columnDefinitions: [] };
        this.pagination = pagination;
        this._datasetIdPropName = this._gridOptions.datasetIdPropertyName || 'id';
        if (grid === null || grid === void 0 ? void 0 : grid.getColumns) {
            this._columnDefinitions = (_b = (_a = sharedService === null || sharedService === void 0 ? void 0 : sharedService.allColumns) !== null && _a !== void 0 ? _a : serviceOptions === null || serviceOptions === void 0 ? void 0 : serviceOptions.columnDefinitions) !== null && _b !== void 0 ? _b : grid.getColumns();
        }
    }
    /**
     * Build the GraphQL query, since the service include/exclude cursor, the output query will be different.
     * @param serviceOptions GraphqlServiceOption
     */
    buildQuery() {
        if (!this.options || !this.options.datasetName || (!this._columnDefinitions && !Array.isArray(this.options.columnDefinitions))) {
            throw new Error('GraphQL Service requires the "datasetName" property to properly build the GraphQL query');
        }
        // get the column definitions and exclude some if they were tagged as excluded
        let columnDefinitions = this._columnDefinitions || this.options.columnDefinitions;
        columnDefinitions = columnDefinitions === null || columnDefinitions === void 0 ? void 0 : columnDefinitions.filter((column) => !column.excludeFromQuery);
        const queryQb = new GraphqlQueryBuilder('query');
        const datasetQb = new GraphqlQueryBuilder(this.options.datasetName);
        const nodesQb = new GraphqlQueryBuilder('nodes');
        // get all the columnds Ids for the filters to work
        const columnIds = [];
        if (columnDefinitions && Array.isArray(columnDefinitions)) {
            for (const column of columnDefinitions) {
                columnIds.push(column.field);
                // if extra "fields" are passed, also push them to columnIds
                if (column.fields) {
                    columnIds.push(...column.fields);
                }
            }
        }
        // Slickgrid also requires the "id" (or the dataset defined unique ide) field to be part of DataView
        // add it to the GraphQL query if it wasn't already part of the list
        if (columnIds.indexOf(this._datasetIdPropName) === -1) {
            columnIds.unshift(this._datasetIdPropName);
        }
        const columnsQuery = this.buildFilterQuery(columnIds);
        let graphqlNodeFields = [];
        if (this._gridOptions.enablePagination !== false) {
            if (this.options.isWithCursor) {
                // ...pageInfo { hasNextPage, endCursor }, edges { cursor, node { _columns_ } }, totalCount: 100
                const edgesQb = new GraphqlQueryBuilder('edges');
                const pageInfoQb = new GraphqlQueryBuilder('pageInfo');
                pageInfoQb.find('hasNextPage', 'hasPreviousPage', 'endCursor', 'startCursor');
                nodesQb.find(columnsQuery);
                edgesQb.find(['cursor']);
                graphqlNodeFields = ['totalCount', nodesQb, pageInfoQb, edgesQb];
            }
            else {
                // ...nodes { _columns_ }, totalCount: 100
                nodesQb.find(columnsQuery);
                graphqlNodeFields = ['totalCount', nodesQb];
            }
            // all properties to be returned by the query
            datasetQb.find(graphqlNodeFields);
        }
        else {
            // include all columns to be returned
            datasetQb.find(columnsQuery);
        }
        // add dataset filters, could be Pagination and SortingFilters and/or FieldFilters
        let datasetFilters = {};
        // only add pagination if it's enabled in the grid options
        if (this._gridOptions.enablePagination !== false) {
            datasetFilters = Object.assign(Object.assign({}, this.options.paginationOptions), { first: ((this.options.paginationOptions && this.options.paginationOptions.first) ? this.options.paginationOptions.first : ((this.pagination && this.pagination.pageSize) ? this.pagination.pageSize : null)) || this.defaultPaginationOptions.first });
            if (!this.options.isWithCursor) {
                datasetFilters.offset = ((this.options.paginationOptions && this.options.paginationOptions.hasOwnProperty('offset')) ? +this.options.paginationOptions['offset'] : 0);
            }
        }
        if (this.options.sortingOptions && Array.isArray(this.options.sortingOptions) && this.options.sortingOptions.length > 0) {
            // orderBy: [{ field:x, direction: 'ASC' }]
            datasetFilters.orderBy = this.options.sortingOptions;
        }
        if (this.options.filteringOptions && Array.isArray(this.options.filteringOptions) && this.options.filteringOptions.length > 0) {
            // filterBy: [{ field: date, operator: '>', value: '2000-10-10' }]
            datasetFilters.filterBy = this.options.filteringOptions;
        }
        if (this.options.addLocaleIntoQuery) {
            // first: 20, ... locale: "en-CA"
            datasetFilters.locale = this._gridOptions && this._gridOptions.i18n && this._gridOptions.i18n.currentLang || this._gridOptions.locale || 'en';
        }
        if (this.options.extraQueryArguments) {
            // first: 20, ... userId: 123
            for (const queryArgument of this.options.extraQueryArguments) {
                datasetFilters[queryArgument.field] = queryArgument.value;
            }
        }
        // with pagination:: query { users(first: 20, offset: 0, orderBy: [], filterBy: []) { totalCount: 100, nodes: { _columns_ }}}
        // without pagination:: query { users(orderBy: [], filterBy: []) { _columns_ }}
        datasetQb.filter(datasetFilters);
        queryQb.find(datasetQb);
        const enumSearchProperties = ['direction:', 'field:', 'operator:'];
        return this.trimDoubleQuotesOnEnumField(queryQb.toString(), enumSearchProperties, this.options.keepArgumentFieldDoubleQuotes || false);
    }
    /**
     * From an input array of strings, we want to build a GraphQL query string.
     * The process has to take the dot notation and parse it into a valid GraphQL query
     * Following this SO answer https://stackoverflow.com/a/47705476/1212166
     *
     * INPUT
     *  ['firstName', 'lastName', 'billing.address.street', 'billing.address.zip']
     * OUTPUT
     * firstName, lastName, billing{address{street, zip}}
     * @param inputArray
     */
    buildFilterQuery(inputArray) {
        const set = (o = {}, a) => {
            const k = a.shift();
            o[k] = a.length ? set(o[k], a) : null;
            return o;
        };
        const output = inputArray.reduce((o, a) => set(o, a.split('.')), {});
        return JSON.stringify(output)
            .replace(/\"|\:|null/g, '')
            .replace(/^\{/, '')
            .replace(/\}$/, '');
    }
    clearFilters() {
        this._currentFilters = [];
        this.updateOptions({ filteringOptions: [] });
    }
    clearSorters() {
        this._currentSorters = [];
        this.updateOptions({ sortingOptions: [] });
    }
    /**
     * Get an initialization of Pagination options
     * @return Pagination Options
     */
    getInitPaginationOptions() {
        const paginationFirst = this.pagination ? this.pagination.pageSize : DEFAULT_ITEMS_PER_PAGE$1;
        return (this.options && this.options.isWithCursor) ? { first: paginationFirst } : { first: paginationFirst, offset: 0 };
    }
    /** Get the GraphQL dataset name */
    getDatasetName() {
        return this.options.datasetName || '';
    }
    /** Get the Filters that are currently used by the grid */
    getCurrentFilters() {
        return this._currentFilters;
    }
    /** Get the Pagination that is currently used by the grid */
    getCurrentPagination() {
        return this._currentPagination;
    }
    /** Get the Sorters that are currently used by the grid */
    getCurrentSorters() {
        return this._currentSorters;
    }
    /*
     * Reset the pagination options
     */
    resetPaginationOptions() {
        let paginationOptions;
        if (this.options && this.options.isWithCursor) {
            // first, last, after, before
            paginationOptions = {
                after: '',
                before: undefined,
                last: undefined
            };
        }
        else {
            // first, last, offset
            paginationOptions = ((this.options && this.options.paginationOptions) || this.getInitPaginationOptions());
            paginationOptions.offset = 0;
        }
        // save current pagination as Page 1 and page size as "first" set size
        this._currentPagination = {
            pageNumber: 1,
            pageSize: paginationOptions.first || DEFAULT_PAGE_SIZE$1,
        };
        this.updateOptions({ paginationOptions });
    }
    updateOptions(serviceOptions) {
        this.options = Object.assign(Object.assign({}, this.options), serviceOptions);
    }
    /*
     * FILTERING
     */
    processOnFilterChanged(event, args) {
        const gridOptions = this._gridOptions;
        const backendApi = gridOptions.backendServiceApi;
        if (backendApi === undefined) {
            throw new Error('Something went wrong in the GraphqlService, "backendServiceApi" is not initialized');
        }
        // keep current filters & always save it as an array (columnFilters can be an object when it is dealt by SlickGrid Filter)
        this._currentFilters = this.castFilterToColumnFilters(args.columnFilters);
        if (!args || !args.grid) {
            throw new Error('Something went wrong when trying create the GraphQL Backend Service, it seems that "args" is not populated correctly');
        }
        // loop through all columns to inspect filters & set the query
        this.updateFilters(args.columnFilters, false);
        this.resetPaginationOptions();
        return this.buildQuery();
    }
    /*
     * PAGINATION
     * With cursor, the query can have 4 arguments (first, after, last, before), for example:
     *   users (first:20, after:"YXJyYXljb25uZWN0aW9uOjM=") {
     *     totalCount
     *     pageInfo {
     *       hasNextPage
     *       hasPreviousPage
     *       endCursor
     *       startCursor
     *     }
     *     edges {
     *       cursor
     *       node {
     *         name
     *         gender
     *       }
     *     }
     *   }
     * Without cursor, the query can have 3 arguments (first, last, offset), for example:
     *   users (first:20, offset: 10) {
     *     totalCount
     *     nodes {
     *       name
     *       gender
     *     }
     *   }
     */
    processOnPaginationChanged(_event, args) {
        const pageSize = +(args.pageSize || ((this.pagination) ? this.pagination.pageSize : DEFAULT_PAGE_SIZE$1));
        this.updatePagination(args.newPage, pageSize);
        // build the GraphQL query which we will use in the WebAPI callback
        return this.buildQuery();
    }
    /*
     * SORTING
     * we will use sorting as per a Facebook suggestion on a Github issue (with some small changes)
     * https://github.com/graphql/graphql-relay-js/issues/20#issuecomment-220494222
     *
     *  users (first: 20, offset: 10, orderBy: [{field: lastName, direction: ASC}, {field: firstName, direction: DESC}]) {
     *    totalCount
     *    nodes {
     *      name
     *      gender
     *    }
     *  }
     */
    // @deprecated note, we should remove "SortChangedArgs" and only use: ColumnSort | MultiColumnSort
    processOnSortChanged(_event, args) {
        const sortColumns = (args.multiColumnSort) ? args.sortCols : new Array({ sortCol: args.sortCol, sortAsc: args.sortAsc });
        // loop through all columns to inspect sorters & set the query
        this.updateSorters(sortColumns);
        // build the GraphQL query which we will use in the WebAPI callback
        return this.buildQuery();
    }
    /**
     * loop through all columns to inspect filters & update backend service filteringOptions
     * @param columnFilters
     */
    updateFilters(columnFilters, isUpdatedByPresetOrDynamically) {
        const searchByArray = [];
        let searchValue;
        // on filter preset load, we need to keep current filters
        if (isUpdatedByPresetOrDynamically) {
            this._currentFilters = this.castFilterToColumnFilters(columnFilters);
        }
        for (const columnId in columnFilters) {
            if (columnFilters.hasOwnProperty(columnId)) {
                const columnFilter = columnFilters[columnId];
                // if user defined some "presets", then we need to find the filters from the column definitions instead
                let columnDef;
                if (isUpdatedByPresetOrDynamically && Array.isArray(this._columnDefinitions)) {
                    columnDef = this._columnDefinitions.find((column) => column.id === columnFilter.columnId);
                }
                else {
                    columnDef = columnFilter.columnDef;
                }
                if (!columnDef) {
                    throw new Error('[GraphQL Service]: Something went wrong in trying to get the column definition of the specified filter (or preset filters). Did you make a typo on the filter columnId?');
                }
                const fieldName = (columnDef.filter && columnDef.filter.queryField) || columnDef.queryFieldFilter || columnDef.queryField || columnDef.field || columnDef.name || '';
                const fieldType = columnDef.type || FieldType.string;
                let searchTerms = columnFilter && columnFilter.searchTerms || [];
                let fieldSearchValue = (Array.isArray(searchTerms) && searchTerms.length === 1) ? searchTerms[0] : '';
                if (typeof fieldSearchValue === 'undefined') {
                    fieldSearchValue = '';
                }
                if (!fieldName) {
                    throw new Error(`GraphQL filter could not find the field name to query the search, your column definition must include a valid "field" or "name" (optionally you can also use the "queryfield").`);
                }
                fieldSearchValue = (fieldSearchValue === undefined || fieldSearchValue === null) ? '' : `${fieldSearchValue}`; // make sure it's a string
                const matches = fieldSearchValue.match(/^([<>!=\*]{0,2})(.*[^<>!=\*])([\*]?)$/); // group 1: Operator, 2: searchValue, 3: last char is '*' (meaning starts with, ex.: abc*)
                let operator = columnFilter.operator || ((matches) ? matches[1] : '');
                searchValue = (!!matches) ? matches[2] : '';
                const lastValueChar = (!!matches) ? matches[3] : (operator === '*z' ? '*' : '');
                // no need to query if search value is empty
                if (fieldName && searchValue === '' && searchTerms.length === 0) {
                    continue;
                }
                if (Array.isArray(searchTerms) && searchTerms.length === 1 && typeof searchTerms[0] === 'string' && searchTerms[0].indexOf('..') >= 0) {
                    if (!operator) {
                        operator = this._gridOptions.defaultFilterRangeOperator;
                    }
                    searchTerms = searchTerms[0].split('..', 2);
                    if (searchTerms[0] === '') {
                        operator = operator === OperatorType.rangeInclusive ? '<=' : operator === OperatorType.rangeExclusive ? '<' : operator;
                        searchTerms = searchTerms.slice(1);
                        searchValue = searchTerms[0];
                    }
                    else if (searchTerms[1] === '') {
                        operator = operator === OperatorType.rangeInclusive ? '>=' : operator === OperatorType.rangeExclusive ? '>' : operator;
                        searchTerms = searchTerms.slice(0, 1);
                        searchValue = searchTerms[0];
                    }
                }
                if (typeof searchValue === 'string') {
                    if (operator === '*' || operator === 'a*' || operator === '*z' || lastValueChar === '*') {
                        operator = ((operator === '*' || operator === '*z') ? 'EndsWith' : 'StartsWith');
                    }
                }
                // if we didn't find an Operator but we have a Column Operator inside the Filter (DOM Element), we should use its default Operator
                // multipleSelect is "IN", while singleSelect is "EQ", else don't map any operator
                if (!operator && columnDef.filter) {
                    operator = columnDef.filter.operator;
                }
                // No operator and 2 search terms should lead to default range operator.
                if (!operator && Array.isArray(searchTerms) && searchTerms.length === 2 && searchTerms[0] && searchTerms[1]) {
                    operator = this._gridOptions.defaultFilterRangeOperator;
                }
                // Range with 1 searchterm should lead to equals for a date field.
                if ((operator === OperatorType.rangeInclusive || OperatorType.rangeExclusive) && Array.isArray(searchTerms) && searchTerms.length === 1 && fieldType === FieldType.date) {
                    operator = OperatorType.equal;
                }
                // Normalize all search values
                searchValue = this.normalizeSearchValue(fieldType, searchValue);
                if (Array.isArray(searchTerms)) {
                    searchTerms.forEach((_part, index) => {
                        searchTerms[index] = this.normalizeSearchValue(fieldType, searchTerms[index]);
                    });
                }
                // when having more than 1 search term (we need to create a CSV string for GraphQL "IN" or "NOT IN" filter search)
                if (searchTerms && searchTerms.length > 1 && (operator === 'IN' || operator === 'NIN' || operator === 'NOTIN' || operator === 'NOT IN' || operator === 'NOT_IN')) {
                    searchValue = searchTerms.join(',');
                }
                else if (searchTerms && searchTerms.length === 2 && (operator === OperatorType.rangeExclusive || operator === OperatorType.rangeInclusive)) {
                    searchByArray.push({ field: fieldName, operator: (operator === OperatorType.rangeInclusive ? 'GE' : 'GT'), value: searchTerms[0] });
                    searchByArray.push({ field: fieldName, operator: (operator === OperatorType.rangeInclusive ? 'LE' : 'LT'), value: searchTerms[1] });
                    continue;
                }
                // if we still don't have an operator find the proper Operator to use by it's field type
                if (!operator) {
                    operator = mapOperatorByFieldType(fieldType);
                }
                // build the search array
                searchByArray.push({ field: fieldName, operator: mapOperatorType(operator), value: searchValue });
            }
        }
        // update the service options with filters for the buildQuery() to work later
        this.updateOptions({ filteringOptions: searchByArray });
    }
    /**
     * Update the pagination component with it's new page number and size
     * @param newPage
     * @param pageSize
     */
    updatePagination(newPage, pageSize) {
        this._currentPagination = {
            pageNumber: newPage,
            pageSize,
        };
        let paginationOptions;
        if (this.options && this.options.isWithCursor) {
            paginationOptions = {
                first: pageSize
            };
        }
        else {
            paginationOptions = {
                first: pageSize,
                offset: (newPage > 1) ? ((newPage - 1) * pageSize) : 0 // recalculate offset but make sure the result is always over 0
            };
        }
        // unless user specifically set "enablePagination" to False, we'll update pagination options in every other cases
        if (this._gridOptions && (this._gridOptions.enablePagination || !this._gridOptions.hasOwnProperty('enablePagination'))) {
            this.updateOptions({ paginationOptions });
        }
    }
    /**
     * loop through all columns to inspect sorters & update backend service sortingOptions
     * @param columnFilters
     */
    updateSorters(sortColumns, presetSorters) {
        let currentSorters = [];
        const graphqlSorters = [];
        if (!sortColumns && presetSorters) {
            // make the presets the current sorters, also make sure that all direction are in uppercase for GraphQL
            currentSorters = presetSorters;
            currentSorters.forEach((sorter) => sorter.direction = sorter.direction.toUpperCase());
            // display the correct sorting icons on the UI, for that it requires (columnId, sortAsc) properties
            const tmpSorterArray = currentSorters.map((sorter) => {
                var _a;
                const columnDef = (_a = this._columnDefinitions) === null || _a === void 0 ? void 0 : _a.find((column) => column.id === sorter.columnId);
                graphqlSorters.push({
                    field: columnDef ? ((columnDef.queryFieldSorter || columnDef.queryField || columnDef.field) + '') : (sorter.columnId + ''),
                    direction: sorter.direction
                });
                // return only the column(s) found in the Column Definitions ELSE null
                if (columnDef) {
                    return {
                        columnId: sorter.columnId,
                        sortAsc: sorter.direction.toUpperCase() === SortDirection.ASC
                    };
                }
                return null;
            });
            // set the sort icons, but also make sure to filter out null values (that happens when columnDef is not found)
            if (Array.isArray(tmpSorterArray)) {
                this._grid.setSortColumns(tmpSorterArray.filter((sorter) => sorter));
            }
        }
        else if (sortColumns && !presetSorters) {
            // build the orderBy array, it could be multisort, example
            // orderBy:[{field: lastName, direction: ASC}, {field: firstName, direction: DESC}]
            if (Array.isArray(sortColumns) && sortColumns.length > 0) {
                for (const column of sortColumns) {
                    if (column && column.sortCol) {
                        currentSorters.push({
                            columnId: column.sortCol.id + '',
                            direction: column.sortAsc ? SortDirection.ASC : SortDirection.DESC
                        });
                        const fieldName = (column.sortCol.queryFieldSorter || column.sortCol.queryField || column.sortCol.field || '') + '';
                        if (fieldName) {
                            graphqlSorters.push({
                                field: fieldName,
                                direction: column.sortAsc ? SortDirection.ASC : SortDirection.DESC
                            });
                        }
                    }
                }
            }
        }
        // keep current Sorters and update the service options with the new sorting
        this._currentSorters = currentSorters;
        this.updateOptions({ sortingOptions: graphqlSorters });
    }
    /**
     * A function which takes an input string and removes double quotes only
     * on certain fields are identified as GraphQL enums (except fields with dot notation)
     * For example let say we identified ("direction:", "sort") as word which are GraphQL enum fields
     * then the result will be:
     * FROM
     * query { users (orderBy:[{field:"firstName", direction:"ASC"} }]) }
     * TO
     * query { users (orderBy:[{field: firstName, direction: ASC}})}
     *
     * EXCEPTIONS (fields with dot notation "." which are inside a "field:")
     * these fields will keep double quotes while everything else will be stripped of double quotes
     * query { users (orderBy:[{field:"billing.street.name", direction: "ASC"} }
     * TO
     * query { users (orderBy:[{field:"billing.street.name", direction: ASC}}
     * @param inputStr input string
     * @param enumSearchWords array of enum words to filter
     * @returns outputStr output string
     */
    trimDoubleQuotesOnEnumField(inputStr, enumSearchWords, keepArgumentFieldDoubleQuotes) {
        const patternWordInQuotes = `\s?((field:\s*)?".*?")`;
        let patternRegex = enumSearchWords.join(patternWordInQuotes + '|');
        patternRegex += patternWordInQuotes; // the last one should also have the pattern but without the pipe "|"
        // example with (field: & direction:):  /field:s?(".*?")|direction:s?(".*?")/
        const reg = new RegExp(patternRegex, 'g');
        return inputStr.replace(reg, (group1, group2, group3) => {
            // remove double quotes except when the string starts with a "field:"
            let removeDoubleQuotes = true;
            if (group1.startsWith('field:') && keepArgumentFieldDoubleQuotes) {
                removeDoubleQuotes = false;
            }
            const rep = removeDoubleQuotes ? group1.replace(/"/g, '') : group1;
            return rep;
        });
    }
    //
    // private functions
    // -------------------
    /**
     * Cast provided filters (could be in multiple formats) into an array of CurrentFilter
     * @param columnFilters
     */
    castFilterToColumnFilters(columnFilters) {
        // keep current filters & always save it as an array (columnFilters can be an object when it is dealt by SlickGrid Filter)
        const filtersArray = (typeof columnFilters === 'object') ? Object.keys(columnFilters).map(key => columnFilters[key]) : columnFilters;
        if (!Array.isArray(filtersArray)) {
            return [];
        }
        return filtersArray.map((filter) => {
            const tmpFilter = { columnId: filter.columnId || '' };
            if (filter.operator) {
                tmpFilter.operator = filter.operator;
            }
            if (Array.isArray(filter.searchTerms)) {
                tmpFilter.searchTerms = filter.searchTerms;
            }
            return tmpFilter;
        });
    }
    /** Normalizes the search value according to field type. */
    normalizeSearchValue(fieldType, searchValue) {
        switch (fieldType) {
            case FieldType.date:
            case FieldType.string:
            case FieldType.text:
            case FieldType.readonly:
                if (typeof searchValue === 'string') {
                    // escape single quotes by doubling them
                    searchValue = searchValue.replace(/'/g, `''`);
                }
                break;
            case FieldType.integer:
            case FieldType.number:
            case FieldType.float:
                if (typeof searchValue === 'string') {
                    // Parse a valid decimal from the string.
                    // Replace double dots with single dots
                    searchValue = searchValue.replace(/\.\./g, '.');
                    // Remove a trailing dot
                    searchValue = searchValue.replace(/\.+$/g, '');
                    // Prefix a leading dot with 0
                    searchValue = searchValue.replace(/^\.+/g, '0.');
                    // Prefix leading dash dot with -0.
                    searchValue = searchValue.replace(/^\-+\.+/g, '-0.');
                    // Remove any non valid decimal characters from the search string
                    searchValue = searchValue.replace(/(?!^\-)[^\d\.]/g, '');
                    // if nothing left, search for 0
                    if (searchValue === '' || searchValue === '-') {
                        searchValue = '0';
                    }
                }
                break;
        }
        return searchValue;
    }
}
GraphqlService.ɵfac = function GraphqlService_Factory(t) { return new (t || GraphqlService)(); };
GraphqlService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: GraphqlService, factory: GraphqlService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GraphqlService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class OdataQueryBuilderService {
    constructor() {
        this._odataOptions = {
            filterQueue: [],
            orderBy: ''
        };
        this._defaultSortBy = '';
        this._columnFilters = {};
    }
    /*
      * Build the OData query string from all the options provided
      * @return string OData query
      */
    buildQuery() {
        if (!this._odataOptions) {
            throw new Error('Odata Service requires certain options like "top" for it to work');
        }
        this._odataOptions.filterQueue = [];
        const queryTmpArray = [];
        // When enableCount is set, add it to the OData query
        if (this._odataOptions && this._odataOptions.enableCount === true) {
            const countQuery = (this._odataOptions.version >= 4) ? '$count=true' : '$inlinecount=allpages';
            queryTmpArray.push(countQuery);
        }
        if (this._odataOptions.top) {
            queryTmpArray.push(`$top=${this._odataOptions.top}`);
        }
        if (this._odataOptions.skip) {
            queryTmpArray.push(`$skip=${this._odataOptions.skip}`);
        }
        if (this._odataOptions.orderBy) {
            let argument = '';
            if (Array.isArray(this._odataOptions.orderBy)) {
                argument = this._odataOptions.orderBy.join(','); // csv, that will form a query, for example: $orderby=RoleName asc, Id desc
            }
            else {
                argument = this._odataOptions.orderBy;
            }
            queryTmpArray.push(`$orderby=${argument}`);
        }
        if (this._odataOptions.filterBy || this._odataOptions.filter) {
            const filterBy = this._odataOptions.filter || this._odataOptions.filterBy;
            if (filterBy) {
                this._filterCount = 1;
                this._odataOptions.filterQueue = [];
                let filterStr = filterBy;
                if (Array.isArray(filterBy)) {
                    this._filterCount = filterBy.length;
                    filterStr = filterBy.join(` ${this._odataOptions.filterBySeparator || 'and'} `);
                }
                if (typeof filterStr === 'string') {
                    if (!(filterStr[0] === '(' && filterStr.slice(-1) === ')')) {
                        this.addToFilterQueueWhenNotExists(`(${filterStr})`);
                    }
                    else {
                        this.addToFilterQueueWhenNotExists(filterStr);
                    }
                }
            }
        }
        if (this._odataOptions.filterQueue.length > 0) {
            const query = this._odataOptions.filterQueue.join(` ${this._odataOptions.filterBySeparator || 'and'} `);
            this._odataOptions.filter = query; // overwrite with
            queryTmpArray.push(`$filter=${query}`);
        }
        // join all the odata functions by a '&'
        return queryTmpArray.join('&');
    }
    getFilterCount() {
        return this._filterCount;
    }
    get columnFilters() {
        return this._columnFilters;
    }
    get options() {
        return this._odataOptions;
    }
    set options(options) {
        this._odataOptions = options;
    }
    removeColumnFilter(fieldName) {
        if (this._columnFilters && this._columnFilters.hasOwnProperty(fieldName)) {
            delete this._columnFilters[fieldName];
        }
    }
    saveColumnFilter(fieldName, value, searchTerms) {
        this._columnFilters[fieldName] = {
            search: searchTerms,
            value
        };
    }
    /**
     * Change any OData options that will be used to build the query
     * @param object options
     */
    updateOptions(options) {
        for (const property of Object.keys(options)) {
            if (options.hasOwnProperty(property)) {
                this._odataOptions[property] = options[property]; // replace of the property
            }
            // we need to keep the defaultSortBy for references whenever the user removes his Sorting
            // then we would revert to the defaultSortBy and the only way is to keep a hard copy here
            if (property === 'orderBy' || property === 'sortBy') {
                let sortBy = options[property];
                // make sure first char of each orderBy field is capitalize
                if (this._odataOptions.caseType === CaseType.pascalCase) {
                    if (Array.isArray(sortBy)) {
                        sortBy.forEach((field, index, inputArray) => {
                            inputArray[index] = titleCase(field);
                        });
                    }
                    else {
                        sortBy = titleCase(options[property]);
                    }
                }
                this._odataOptions.orderBy = sortBy;
                this._defaultSortBy = sortBy;
            }
        }
    }
    //
    // private functions
    // -------------------
    addToFilterQueueWhenNotExists(filterStr) {
        if (this._odataOptions.filterQueue && this._odataOptions.filterQueue.indexOf(filterStr) === -1) {
            this._odataOptions.filterQueue.push(filterStr);
        }
    }
}

const DEFAULT_ITEMS_PER_PAGE = 25;
const DEFAULT_PAGE_SIZE = 20;
class GridOdataService {
    constructor() {
        this._currentFilters = [];
        this._currentSorters = [];
        this.defaultOptions = {
            top: DEFAULT_ITEMS_PER_PAGE,
            orderBy: '',
            caseType: CaseType.pascalCase
        };
        this._odataService = new OdataQueryBuilderService();
    }
    /** Getter for the Column Definitions */
    get columnDefinitions() {
        return this._columnDefinitions;
    }
    /** Getter for the Odata Service */
    get odataService() {
        return this._odataService;
    }
    /** Getter for the Grid Options pulled through the Grid Object */
    get _gridOptions() {
        return (this._grid && this._grid.getOptions) ? this._grid.getOptions() : {};
    }
    init(serviceOptions, pagination, grid, sharedService) {
        var _a, _b;
        this._grid = grid;
        const mergedOptions = Object.assign(Object.assign({}, this.defaultOptions), serviceOptions);
        // unless user specifically set "enablePagination" to False, we'll add "top" property for the pagination in every other cases
        if (this._gridOptions && !this._gridOptions.enablePagination) {
            // save current pagination as Page 1 and page size as "top"
            this._odataService.options = Object.assign(Object.assign({}, mergedOptions), { top: undefined });
            this._currentPagination = undefined;
        }
        else {
            const topOption = (pagination && pagination.pageSize) ? pagination.pageSize : this.defaultOptions.top;
            this._odataService.options = Object.assign(Object.assign({}, mergedOptions), { top: topOption });
            this._currentPagination = {
                pageNumber: 1,
                pageSize: this._odataService.options.top || this.defaultOptions.top || DEFAULT_PAGE_SIZE,
            };
        }
        this.options = this._odataService.options;
        this.pagination = pagination;
        if (grid === null || grid === void 0 ? void 0 : grid.getColumns) {
            const tmpColumnDefinitions = (_b = (_a = sharedService === null || sharedService === void 0 ? void 0 : sharedService.allColumns) !== null && _a !== void 0 ? _a : serviceOptions === null || serviceOptions === void 0 ? void 0 : serviceOptions.columnDefinitions) !== null && _b !== void 0 ? _b : grid.getColumns();
            this._columnDefinitions = tmpColumnDefinitions.filter((column) => !column.excludeFromQuery);
        }
    }
    buildQuery() {
        return this._odataService.buildQuery();
    }
    clearFilters() {
        this._currentFilters = [];
        this.updateFilters([]);
    }
    clearSorters() {
        this._currentSorters = [];
        this.updateSorters([]);
    }
    updateOptions(serviceOptions) {
        this.options = Object.assign(Object.assign({}, this.options), serviceOptions);
        this._odataService.options = this.options;
    }
    removeColumnFilter(fieldName) {
        this._odataService.removeColumnFilter(fieldName);
    }
    /** Get the Filters that are currently used by the grid */
    getCurrentFilters() {
        return this._currentFilters;
    }
    /** Get the Pagination that is currently used by the grid */
    getCurrentPagination() {
        return this._currentPagination;
    }
    /** Get the Sorters that are currently used by the grid */
    getCurrentSorters() {
        return this._currentSorters;
    }
    /**
     * Mapper for mathematical operators (ex.: <= is "le", > is "gt")
     * @param string operator
     * @returns string map
     */
    mapOdataOperator(operator) {
        let map = '';
        switch (operator) {
            case '<':
                map = 'lt';
                break;
            case '<=':
                map = 'le';
                break;
            case '>':
                map = 'gt';
                break;
            case '>=':
                map = 'ge';
                break;
            case '<>':
            case '!=':
                map = 'ne';
                break;
            case '=':
            case '==':
            default:
                map = 'eq';
                break;
        }
        return map;
    }
    /*
     * Reset the pagination options
     */
    resetPaginationOptions() {
        this._odataService.updateOptions({
            skip: 0
        });
    }
    saveColumnFilter(fieldName, value, terms) {
        this._odataService.saveColumnFilter(fieldName, value, terms);
    }
    /*
     * FILTERING
     */
    processOnFilterChanged(event, args) {
        const gridOptions = this._gridOptions;
        const backendApi = gridOptions.backendServiceApi;
        if (backendApi === undefined) {
            throw new Error('Something went wrong in the GridOdataService, "backendServiceApi" is not initialized');
        }
        // keep current filters & always save it as an array (columnFilters can be an object when it is dealt by SlickGrid Filter)
        this._currentFilters = this.castFilterToColumnFilters(args.columnFilters);
        if (!args || !args.grid) {
            throw new Error('Something went wrong when trying create the GridOdataService, it seems that "args" is not populated correctly');
        }
        // loop through all columns to inspect filters & set the query
        this.updateFilters(args.columnFilters);
        this.resetPaginationOptions();
        return this._odataService.buildQuery();
    }
    /*
     * PAGINATION
     */
    processOnPaginationChanged(_event, args) {
        const pageSize = +(args.pageSize || ((this.pagination) ? this.pagination.pageSize : DEFAULT_PAGE_SIZE));
        this.updatePagination(args.newPage, pageSize);
        // build the OData query which we will use in the WebAPI callback
        return this._odataService.buildQuery();
    }
    /*
     * SORTING
     */
    processOnSortChanged(_event, args) {
        const sortColumns = (args.multiColumnSort) ? args.sortCols : new Array({ sortCol: args.sortCol, sortAsc: args.sortAsc });
        // loop through all columns to inspect sorters & set the query
        this.updateSorters(sortColumns);
        // build the OData query which we will use in the WebAPI callback
        return this._odataService.buildQuery();
    }
    /**
     * loop through all columns to inspect filters & update backend service filters
     * @param columnFilters
     */
    updateFilters(columnFilters, isUpdatedByPresetOrDynamically) {
        let searchBy = '';
        const searchByArray = [];
        const odataVersion = this._odataService && this._odataService.options && this._odataService.options.version || 2;
        // on filter preset load, we need to keep current filters
        if (isUpdatedByPresetOrDynamically) {
            this._currentFilters = this.castFilterToColumnFilters(columnFilters);
        }
        // loop through all columns to inspect filters
        for (const columnId in columnFilters) {
            if (columnFilters.hasOwnProperty(columnId)) {
                const columnFilter = columnFilters[columnId];
                // if user defined some "presets", then we need to find the filters from the column definitions instead
                let columnDef;
                if (isUpdatedByPresetOrDynamically && Array.isArray(this._columnDefinitions)) {
                    columnDef = this._columnDefinitions.find((column) => {
                        return column.id === columnFilter.columnId;
                    });
                }
                else {
                    columnDef = columnFilter.columnDef;
                }
                if (!columnDef) {
                    throw new Error('[GridOData Service]: Something went wrong in trying to get the column definition of the specified filter (or preset filters). Did you make a typo on the filter columnId?');
                }
                let fieldName = (columnDef.filter && columnDef.filter.queryField) || columnDef.queryFieldFilter || columnDef.queryField || columnDef.field || columnDef.name || '';
                const fieldType = columnDef.type || FieldType.string;
                let searchTerms = (columnFilter && columnFilter.searchTerms ? [...columnFilter.searchTerms] : null) || [];
                let fieldSearchValue = (Array.isArray(searchTerms) && searchTerms.length === 1) ? searchTerms[0] : '';
                if (typeof fieldSearchValue === 'undefined') {
                    fieldSearchValue = '';
                }
                if (!fieldName) {
                    throw new Error(`GridOData filter could not find the field name to query the search, your column definition must include a valid "field" or "name" (optionally you can also use the "queryfield").`);
                }
                fieldSearchValue = (fieldSearchValue === undefined || fieldSearchValue === null) ? '' : `${fieldSearchValue}`; // make sure it's a string
                const matches = fieldSearchValue.match(/^([<>!=\*]{0,2})(.*[^<>!=\*])([\*]?)$/); // group 1: Operator, 2: searchValue, 3: last char is '*' (meaning starts with, ex.: abc*)
                let operator = columnFilter.operator || ((matches) ? matches[1] : '');
                let searchValue = (!!matches) ? matches[2] : '';
                const lastValueChar = (!!matches) ? matches[3] : (operator === '*z' || operator === OperatorType.endsWith) ? '*' : '';
                const bypassOdataQuery = columnFilter.bypassBackendQuery || false;
                // no need to query if search value is empty
                if (fieldName && searchValue === '' && searchTerms.length <= 1) {
                    this.removeColumnFilter(fieldName);
                    continue;
                }
                if (Array.isArray(searchTerms) && searchTerms.length === 1 && typeof searchTerms[0] === 'string' && searchTerms[0].indexOf('..') >= 0) {
                    if (!operator) {
                        operator = this._gridOptions.defaultFilterRangeOperator;
                    }
                    searchTerms = searchTerms[0].split('..', 2);
                    if (searchTerms[0] === '') {
                        operator = operator === OperatorType.rangeInclusive ? '<=' : operator === OperatorType.rangeExclusive ? '<' : operator;
                        searchTerms = searchTerms.slice(1);
                        searchValue = searchTerms[0];
                    }
                    else if (searchTerms[1] === '') {
                        operator = operator === OperatorType.rangeInclusive ? '>=' : operator === OperatorType.rangeExclusive ? '>' : operator;
                        searchTerms = searchTerms.slice(0, 1);
                        searchValue = searchTerms[0];
                    }
                }
                // if we didn't find an Operator but we have a Column Operator inside the Filter (DOM Element), we should use its default Operator
                // multipleSelect is "IN", while singleSelect is "EQ", else don't map any operator
                if (!operator && columnDef.filter) {
                    operator = columnDef.filter.operator;
                }
                // No operator and 2 search terms should lead to default range operator.
                if (!operator && Array.isArray(searchTerms) && searchTerms.length === 2 && searchTerms[0] && searchTerms[1]) {
                    operator = this._gridOptions.defaultFilterRangeOperator;
                }
                // Range with 1 searchterm should lead to equals for a date field.
                if ((operator === OperatorType.rangeInclusive || OperatorType.rangeExclusive) && Array.isArray(searchTerms) && searchTerms.length === 1 && fieldType === FieldType.date) {
                    operator = OperatorType.equal;
                }
                // if we still don't have an operator find the proper Operator to use by it's field type
                if (!operator) {
                    operator = mapOperatorByFieldType(fieldType);
                }
                // extra query arguments
                if (bypassOdataQuery) {
                    // push to our temp array and also trim white spaces
                    if (fieldName) {
                        this.saveColumnFilter(fieldName, fieldSearchValue, searchTerms);
                    }
                }
                else {
                    // Normalize all search values
                    searchValue = this.normalizeSearchValue(fieldType, searchValue, odataVersion);
                    if (Array.isArray(searchTerms)) {
                        searchTerms.forEach((part, index) => {
                            searchTerms[index] = this.normalizeSearchValue(fieldType, searchTerms[index], odataVersion);
                        });
                    }
                    searchBy = '';
                    // titleCase the fieldName so that it matches the WebApi names
                    if (this._odataService.options.caseType === CaseType.pascalCase) {
                        fieldName = titleCase(fieldName || '');
                    }
                    if (searchTerms && searchTerms.length > 1 && (operator === 'IN' || operator === 'NIN' || operator === 'NOTIN' || operator === 'NOT IN' || operator === 'NOT_IN')) {
                        // when having more than 1 search term (then check if we have a "IN" or "NOT IN" filter search)
                        const tmpSearchTerms = [];
                        if (operator === 'IN') {
                            // example:: (Stage eq "Expired" or Stage eq "Renewal")
                            for (let j = 0, lnj = searchTerms.length; j < lnj; j++) {
                                tmpSearchTerms.push(`${fieldName} eq ${searchTerms[j]}`);
                            }
                            searchBy = tmpSearchTerms.join(' or ');
                        }
                        else {
                            // example:: (Stage ne "Expired" and Stage ne "Renewal")
                            for (let k = 0, lnk = searchTerms.length; k < lnk; k++) {
                                tmpSearchTerms.push(`${fieldName} ne ${searchTerms[k]}`);
                            }
                            searchBy = tmpSearchTerms.join(' and ');
                        }
                        if (!(typeof searchBy === 'string' && searchBy[0] === '(' && searchBy.slice(-1) === ')')) {
                            searchBy = `(${searchBy})`;
                        }
                    }
                    else if (operator === '*' || operator === 'a*' || operator === '*z' || lastValueChar === '*' || operator === OperatorType.startsWith || operator === OperatorType.endsWith) {
                        // first/last character is a '*' will be a startsWith or endsWith
                        searchBy = (operator === '*' || operator === '*z' || operator === OperatorType.endsWith) ? `endswith(${fieldName}, ${searchValue})` : `startswith(${fieldName}, ${searchValue})`;
                    }
                    else if (operator === OperatorType.rangeExclusive || operator === OperatorType.rangeInclusive) {
                        // example:: (Name >= 'Bob' and Name <= 'Jane')
                        searchBy = this.filterBySearchTermRange(fieldName, operator, searchTerms);
                    }
                    else if ((operator === '' || operator === OperatorType.contains || operator === OperatorType.notContains) &&
                        (fieldType === FieldType.string || fieldType === FieldType.text || fieldType === FieldType.readonly)) {
                        searchBy = odataVersion >= 4 ? `contains(${fieldName}, ${searchValue})` : `substringof(${searchValue}, ${fieldName})`;
                        if (operator === OperatorType.notContains) {
                            searchBy = `not ${searchBy}`;
                        }
                    }
                    else {
                        // any other field type (or undefined type)
                        searchBy = `${fieldName} ${this.mapOdataOperator(operator)} ${searchValue}`;
                    }
                    // push to our temp array and also trim white spaces
                    if (searchBy !== '') {
                        searchByArray.push(searchBy.trim());
                        this.saveColumnFilter(fieldName || '', fieldSearchValue, searchValue);
                    }
                }
            }
        }
        // update the service options with filters for the buildQuery() to work later
        this._odataService.updateOptions({
            filter: (searchByArray.length > 0) ? searchByArray.join(' and ') : '',
            skip: undefined
        });
    }
    /**
     * Update the pagination component with it's new page number and size
     * @param newPage
     * @param pageSize
     */
    updatePagination(newPage, pageSize) {
        this._currentPagination = {
            pageNumber: newPage,
            pageSize,
        };
        // unless user specifically set "enablePagination" to False, we'll update pagination options in every other cases
        if (this._gridOptions && (this._gridOptions.enablePagination || !this._gridOptions.hasOwnProperty('enablePagination'))) {
            this._odataService.updateOptions({
                top: pageSize,
                skip: (newPage - 1) * pageSize
            });
        }
    }
    /**
     * loop through all columns to inspect sorters & update backend service orderBy
     * @param columnFilters
     */
    updateSorters(sortColumns, presetSorters) {
        let currentSorters = [];
        const odataSorters = [];
        if (!sortColumns && presetSorters) {
            // make the presets the current sorters, also make sure that all direction are in lowercase for OData
            currentSorters = presetSorters;
            currentSorters.forEach((sorter) => sorter.direction = sorter.direction.toLowerCase());
            // display the correct sorting icons on the UI, for that it requires (columnId, sortAsc) properties
            const tmpSorterArray = currentSorters.map((sorter) => {
                const columnDef = this._columnDefinitions.find((column) => column.id === sorter.columnId);
                odataSorters.push({
                    field: columnDef ? ((columnDef.queryFieldSorter || columnDef.queryField || columnDef.field) + '') : (sorter.columnId + ''),
                    direction: sorter.direction
                });
                // return only the column(s) found in the Column Definitions ELSE null
                if (columnDef) {
                    return {
                        columnId: sorter.columnId,
                        sortAsc: sorter.direction.toUpperCase() === SortDirection.ASC
                    };
                }
                return null;
            });
            // set the sort icons, but also make sure to filter out null values (that happens when columnDef is not found)
            if (Array.isArray(tmpSorterArray)) {
                this._grid.setSortColumns(tmpSorterArray);
            }
        }
        else if (sortColumns && !presetSorters) {
            // build the SortBy string, it could be multisort, example: customerNo asc, purchaserName desc
            if (sortColumns && sortColumns.length === 0) {
                // TODO fix this line
                // currentSorters = new Array(this.defaultOptions.orderBy); // when empty, use the default sort
            }
            else {
                if (sortColumns) {
                    for (const columnDef of sortColumns) {
                        if (columnDef.sortCol) {
                            let fieldName = (columnDef.sortCol.queryFieldSorter || columnDef.sortCol.queryField || columnDef.sortCol.field) + '';
                            let columnFieldName = (columnDef.sortCol.field || columnDef.sortCol.id) + '';
                            let queryField = (columnDef.sortCol.queryFieldSorter || columnDef.sortCol.queryField || columnDef.sortCol.field || '') + '';
                            if (this._odataService.options.caseType === CaseType.pascalCase) {
                                fieldName = titleCase(fieldName);
                                columnFieldName = titleCase(columnFieldName);
                                queryField = titleCase(queryField);
                            }
                            if (columnFieldName !== '') {
                                currentSorters.push({
                                    columnId: columnFieldName,
                                    direction: columnDef.sortAsc ? 'asc' : 'desc'
                                });
                            }
                            if (queryField !== '') {
                                odataSorters.push({
                                    field: queryField,
                                    direction: columnDef.sortAsc ? SortDirection.ASC : SortDirection.DESC
                                });
                            }
                        }
                    }
                }
            }
        }
        // transform the sortby array into a CSV string for OData
        currentSorters = currentSorters || [];
        const csvString = odataSorters.map((sorter) => {
            let str = '';
            if (sorter && sorter.field) {
                const sortField = (this._odataService.options.caseType === CaseType.pascalCase) ? titleCase(sorter.field) : sorter.field;
                str = `${sortField} ${sorter && sorter.direction && sorter.direction.toLowerCase() || ''}`;
            }
            return str;
        }).join(',');
        this._odataService.updateOptions({
            orderBy: csvString
        });
        // keep current Sorters and update the service options with the new sorting
        this._currentSorters = currentSorters;
        // build the OData query which we will use in the WebAPI callback
        return this._odataService.buildQuery();
    }
    //
    // private functions
    // -------------------
    /**
     * Cast provided filters (could be in multiple format) into an array of ColumnFilter
     * @param columnFilters
     */
    castFilterToColumnFilters(columnFilters) {
        // keep current filters & always save it as an array (columnFilters can be an object when it is dealt by SlickGrid Filter)
        const filtersArray = (typeof columnFilters === 'object') ? Object.keys(columnFilters).map(key => columnFilters[key]) : columnFilters;
        if (!Array.isArray(filtersArray)) {
            return [];
        }
        return filtersArray.map((filter) => {
            const tmpFilter = { columnId: filter.columnId || '' };
            if (filter.operator) {
                tmpFilter.operator = filter.operator;
            }
            if (Array.isArray(filter.searchTerms)) {
                tmpFilter.searchTerms = filter.searchTerms;
            }
            return tmpFilter;
        });
    }
    /**
     * Filter by a range of searchTerms (2 searchTerms OR 1 string separated by 2 dots "value1..value2")
     */
    filterBySearchTermRange(fieldName, operator, searchTerms) {
        let query = '';
        if (Array.isArray(searchTerms) && searchTerms.length === 2) {
            if (operator === OperatorType.rangeInclusive) {
                // example:: (Duration >= 5 and Duration <= 10)
                query = `(${fieldName} ge ${searchTerms[0]}`;
                if (searchTerms[1] !== '') {
                    query += ` and ${fieldName} le ${searchTerms[1]}`;
                }
                query += ')';
            }
            else if (operator === OperatorType.rangeExclusive) {
                // example:: (Duration > 5 and Duration < 10)
                query = `(${fieldName} gt ${searchTerms[0]}`;
                if (searchTerms[1] !== '') {
                    query += ` and ${fieldName} lt ${searchTerms[1]}`;
                }
                query += ')';
            }
        }
        return query;
    }
    /**
     * Normalizes the search value according to field type and oData version.
     */
    normalizeSearchValue(fieldType, searchValue, version) {
        switch (fieldType) {
            case FieldType.date:
                searchValue = parseUtcDate(searchValue, true);
                searchValue = version >= 4 ? searchValue : `DateTime'${searchValue}'`;
                break;
            case FieldType.string:
            case FieldType.text:
            case FieldType.readonly:
                if (typeof searchValue === 'string') {
                    // escape single quotes by doubling them
                    searchValue = searchValue.replace(/'/g, `''`);
                    // encode URI of the final search value
                    searchValue = encodeURIComponent(searchValue);
                    // strings need to be quoted.
                    searchValue = `'${searchValue}'`;
                }
                break;
            case FieldType.integer:
            case FieldType.number:
            case FieldType.float:
                if (typeof searchValue === 'string') {
                    // Parse a valid decimal from the string.
                    // Replace double dots with single dots
                    searchValue = searchValue.replace(/\.\./g, '.');
                    // Remove a trailing dot
                    searchValue = searchValue.replace(/\.+$/g, '');
                    // Prefix a leading dot with 0
                    searchValue = searchValue.replace(/^\.+/g, '0.');
                    // Prefix leading dash dot with -0.
                    searchValue = searchValue.replace(/^\-+\.+/g, '-0.');
                    // Remove any non valid decimal characters from the search string
                    searchValue = searchValue.replace(/(?!^\-)[^\d\.]/g, '');
                    // if nothing left, search for 0
                    if (searchValue === '' || searchValue === '-') {
                        searchValue = '0';
                    }
                }
                break;
        }
        return searchValue;
    }
}
GridOdataService.ɵfac = function GridOdataService_Factory(t) { return new (t || GridOdataService)(); };
GridOdataService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: GridOdataService, factory: GridOdataService.ɵfac });
GridOdataService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GridOdataService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class GridStateService {
    constructor(extensionService, filterService, resizerService, sharedService, sortService, treeDataService) {
        this.extensionService = extensionService;
        this.filterService = filterService;
        this.resizerService = resizerService;
        this.sharedService = sharedService;
        this.sortService = sortService;
        this.treeDataService = treeDataService;
        this._columns = [];
        this._currentColumns = [];
        this._subscriptions = [];
        this._selectedRowDataContextIds = []; // used with row selection
        this._selectedFilteredRowDataContextIds = []; // used with row selection
        this._wasRecheckedAfterPageChange = true; // used with row selection & pagination
        this.onGridStateChanged = new Subject();
        this._eventHandler = new Slick.EventHandler();
    }
    /** Getter for the Grid Options pulled through the Grid Object */
    get _gridOptions() {
        var _a, _b, _c;
        return (_c = (_b = (_a = this._grid) === null || _a === void 0 ? void 0 : _a.getOptions) === null || _b === void 0 ? void 0 : _b.call(_a)) !== null && _c !== void 0 ? _c : {};
    }
    get datasetIdPropName() {
        return this._gridOptions.datasetIdPropertyName || 'id';
    }
    /** Getter of the selected data context object IDs */
    get selectedRowDataContextIds() {
        return this._selectedRowDataContextIds;
    }
    /** Setter of the selected data context object IDs */
    set selectedRowDataContextIds(dataContextIds) {
        this._selectedRowDataContextIds = dataContextIds;
        // since this is coming from a preset, we also need to update the filtered IDs
        this._selectedFilteredRowDataContextIds = dataContextIds;
    }
    /**
     * Initialize the Grid State Service
     * @param grid
     */
    init(grid, dataView) {
        this._grid = grid;
        this._dataView = dataView;
        this.subscribeToAllGridChanges(grid);
    }
    /** Dispose of all the SlickGrid & Angular subscriptions */
    dispose() {
        // unsubscribe all SlickGrid events
        this._eventHandler.unsubscribeAll();
        // also unsubscribe all Angular Subscriptions
        this._subscriptions = unsubscribeAllObservables(this._subscriptions);
        this._currentColumns = [];
        this._columns = [];
    }
    /**
     * Get the current grid state (filters/sorters/pagination)
     * @return grid state
     */
    getCurrentGridState(args) {
        var _a;
        const { frozenColumn, frozenRow, frozenBottom } = this.sharedService.gridOptions;
        const gridState = {
            columns: this.getCurrentColumns(),
            filters: this.getCurrentFilters(),
            sorters: this.getCurrentSorters(),
            pinning: { frozenColumn, frozenRow, frozenBottom },
        };
        // optional Pagination
        const currentPagination = this.getCurrentPagination();
        if (currentPagination) {
            gridState.pagination = currentPagination;
        }
        // optional Row Selection
        if (this.hasRowSelectionEnabled()) {
            const currentRowSelection = this.getCurrentRowSelections(args === null || args === void 0 ? void 0 : args.requestRefreshRowFilteredRow);
            if (currentRowSelection) {
                gridState.rowSelection = currentRowSelection;
            }
        }
        // optional Tree Data toggle items
        if ((_a = this._gridOptions) === null || _a === void 0 ? void 0 : _a.enableTreeData) {
            const treeDataTreeToggleState = this.getCurrentTreeDataToggleState();
            if (treeDataTreeToggleState) {
                gridState.treeData = treeDataTreeToggleState;
            }
        }
        return gridState;
    }
    /**
     * Get the Columns (and their state: visibility/position) that are currently applied in the grid
     * @return current columns
     */
    getColumns() {
        return this._columns;
    }
    /**
     * From an array of Grid Column Definitions, get the associated Current Columns
     * @param gridColumns
     */
    getAssociatedCurrentColumns(gridColumns) {
        const currentColumns = [];
        if (gridColumns && Array.isArray(gridColumns)) {
            gridColumns.forEach((column) => {
                if (column === null || column === void 0 ? void 0 : column.id) {
                    currentColumns.push({
                        columnId: column.id,
                        cssClass: column.cssClass || '',
                        headerCssClass: column.headerCssClass || '',
                        width: column.width || 0
                    });
                }
            });
        }
        this._currentColumns = currentColumns;
        return currentColumns;
    }
    /**
     * Dynamically change the arrangement/distribution of the columns Positions/Visibilities and optionally Widths.
     * For a column to have its visibly as hidden, it has to be part of the original list but excluded from the list provided as argument to be considered a hidden field.
     * If you are passing columns Width, then you probably don't want to trigger the autosizeColumns (2nd argument to False).
     * We could also resize the columns by their content but be aware that you can only trigger 1 type of resize at a time (either the 2nd argument or the 3rd last argument but not both at same time)
     * The resize by content could be called by the 3rd argument OR simply by enabling `enableAutoResizeColumnsByCellContent` but again this will only get executed when the 2nd argument is set to false.
     * @param {Array<Column>} definedColumns - defined columns
     * @param {Boolean} triggerAutoSizeColumns - True by default, do we also want to call the "autosizeColumns()" method to make the columns fit in the grid?
     * @param {Boolean} triggerColumnsFullResizeByContent - False by default, do we also want to call full columns resize by their content?
     */
    changeColumnsArrangement(definedColumns, triggerAutoSizeColumns = true, triggerColumnsFullResizeByContent = false) {
        var _a, _b, _c, _d, _f, _g, _h, _j, _k;
        if (Array.isArray(definedColumns) && definedColumns.length > 0) {
            const newArrangedColumns = this.getAssociatedGridColumns(this._grid, definedColumns);
            if (newArrangedColumns && Array.isArray(newArrangedColumns) && newArrangedColumns.length > 0) {
                // make sure that the checkbox selector is still visible in the list when it is enabled
                if (Array.isArray(this.sharedService.allColumns)) {
                    const dynamicAddonColumnByIndexPositionList = [];
                    if (this._gridOptions.enableCheckboxSelector) {
                        const columnIndexPosition = (_c = (_b = (_a = this._gridOptions) === null || _a === void 0 ? void 0 : _a.checkboxSelector) === null || _b === void 0 ? void 0 : _b.columnIndexPosition) !== null && _c !== void 0 ? _c : 0;
                        dynamicAddonColumnByIndexPositionList.push({ columnId: '_checkbox_selector', columnIndexPosition });
                    }
                    if (this._gridOptions.enableRowDetailView) {
                        const columnIndexPosition = (_g = (_f = (_d = this._gridOptions) === null || _d === void 0 ? void 0 : _d.rowDetailView) === null || _f === void 0 ? void 0 : _f.columnIndexPosition) !== null && _g !== void 0 ? _g : 0;
                        dynamicAddonColumnByIndexPositionList.push({ columnId: '_detail_selector', columnIndexPosition });
                    }
                    if (this._gridOptions.enableRowMoveManager) {
                        const columnIndexPosition = (_k = (_j = (_h = this._gridOptions) === null || _h === void 0 ? void 0 : _h.rowMoveManager) === null || _j === void 0 ? void 0 : _j.columnIndexPosition) !== null && _k !== void 0 ? _k : 0;
                        dynamicAddonColumnByIndexPositionList.push({ columnId: '_move', columnIndexPosition });
                    }
                    // since some features could have a `columnIndexPosition`, we need to make sure these indexes are respected in the column definitions
                    this.addColumnDynamicWhenFeatureEnabled(dynamicAddonColumnByIndexPositionList, this.sharedService.allColumns, newArrangedColumns);
                }
                // keep copy the original optional `width` properties optionally provided by the user.
                // We will use this when doing a resize by cell content, if user provided a `width` it won't override it.
                newArrangedColumns.forEach(col => col.originalWidth = col.width || col.originalWidth);
                // finally set the new presets columns (including checkbox selector if need be)
                this._grid.setColumns(newArrangedColumns);
                this.sharedService.visibleColumns = newArrangedColumns;
                // resize the columns to fit the grid canvas
                if (triggerAutoSizeColumns) {
                    this._grid.autosizeColumns();
                }
                else if (triggerColumnsFullResizeByContent || (this._gridOptions.enableAutoResizeColumnsByCellContent && !this._gridOptions.autosizeColumnsByCellContentOnFirstLoad)) {
                    this.resizerService.resizeColumnsByCellContent(true);
                }
            }
        }
    }
    /**
     * From an array of Current Columns, get the associated Grid Column Definitions
     * @param grid
     * @param currentColumns
     */
    getAssociatedGridColumns(grid, currentColumns) {
        const columns = [];
        const gridColumns = this.sharedService.allColumns || grid.getColumns();
        if (currentColumns && Array.isArray(currentColumns)) {
            currentColumns.forEach((currentColumn, index) => {
                const gridColumn = gridColumns.find((c) => c.id === currentColumn.columnId);
                if (gridColumn === null || gridColumn === void 0 ? void 0 : gridColumn.id) {
                    columns.push(Object.assign(Object.assign({}, gridColumn), { cssClass: currentColumn.cssClass, headerCssClass: currentColumn.headerCssClass, width: currentColumn.width }));
                }
            });
        }
        this._columns = columns;
        return columns;
    }
    /**
     * Get the Columns (and their states: visibility/position/width) that are currently applied in the grid
     * @return current columns
     */
    getCurrentColumns() {
        let currentColumns = [];
        if (this._currentColumns && Array.isArray(this._currentColumns) && this._currentColumns.length > 0) {
            currentColumns = this._currentColumns;
        }
        else {
            currentColumns = this.getAssociatedCurrentColumns(this._grid.getColumns());
        }
        return currentColumns;
    }
    /**
     * Get the Filters (and their state, columnId, searchTerm(s)) that are currently applied in the grid
     * @return current filters
     */
    getCurrentFilters() {
        var _a, _b;
        if ((_a = this._gridOptions) === null || _a === void 0 ? void 0 : _a.backendServiceApi) {
            const backendService = this._gridOptions.backendServiceApi.service;
            if (backendService === null || backendService === void 0 ? void 0 : backendService.getCurrentFilters) {
                return backendService.getCurrentFilters();
            }
        }
        else if ((_b = this.filterService) === null || _b === void 0 ? void 0 : _b.getCurrentLocalFilters) {
            return this.filterService.getCurrentLocalFilters();
        }
        return null;
    }
    /**
     * Get current Pagination (and its state, pageNumber, pageSize) that are currently applied in the grid
     * @return current pagination state
     */
    getCurrentPagination() {
        var _a;
        if ((_a = this._gridOptions) === null || _a === void 0 ? void 0 : _a.enablePagination) {
            if (this._gridOptions.backendServiceApi) {
                const backendService = this._gridOptions.backendServiceApi.service;
                if (backendService === null || backendService === void 0 ? void 0 : backendService.getCurrentPagination) {
                    return backendService.getCurrentPagination();
                }
            }
            else {
                return this.sharedService.currentPagination;
            }
        }
        return undefined;
    }
    /**
     * Get the current Row Selections (and its state, gridRowIndexes, dataContextIds, filteredDataContextIds) that are currently applied in the grid
     * @return current row selection
     */
    getCurrentRowSelections(requestRefreshFilteredRow = true) {
        if (this._grid && this._gridOptions && this._dataView && this.hasRowSelectionEnabled()) {
            if (this._grid.getSelectedRows && this._dataView.mapRowsToIds) {
                let filteredDataContextIds = [];
                const gridRowIndexes = this._dataView.mapIdsToRows(this._selectedRowDataContextIds || []); // note that this will return only what is visible in current page
                const dataContextIds = this._selectedRowDataContextIds;
                // user might request to refresh the filtered selection dataset
                // typically always True, except when "reEvaluateRowSelectionAfterFilterChange" is called and we don't need to refresh the filtered dataset twice
                if (requestRefreshFilteredRow === true) {
                    filteredDataContextIds = this.refreshFilteredRowSelections();
                }
                filteredDataContextIds = this._selectedFilteredRowDataContextIds;
                return { gridRowIndexes, dataContextIds, filteredDataContextIds };
            }
        }
        return null;
    }
    /**
     * Get the current Sorters (and their state, columnId, direction) that are currently applied in the grid
     * @return current sorters
     */
    getCurrentSorters() {
        var _a, _b;
        if ((_a = this._gridOptions) === null || _a === void 0 ? void 0 : _a.backendServiceApi) {
            const backendService = this._gridOptions.backendServiceApi.service;
            if (backendService === null || backendService === void 0 ? void 0 : backendService.getCurrentSorters) {
                return backendService.getCurrentSorters();
            }
        }
        else if ((_b = this.sortService) === null || _b === void 0 ? void 0 : _b.getCurrentLocalSorters) {
            return this.sortService.getCurrentLocalSorters();
        }
        return null;
    }
    /**
     * Get the current list of Tree Data item(s) that got toggled in the grid
     * @returns {Array<TreeToggledItem>} treeDataToggledItems - items that were toggled (array of `parentId` and `isCollapsed` flag)
     */
    getCurrentTreeDataToggleState() {
        var _a;
        if (((_a = this._gridOptions) === null || _a === void 0 ? void 0 : _a.enableTreeData) && this.treeDataService) {
            return this.treeDataService.getCurrentToggleState();
        }
        return null;
    }
    /** Check whether the row selection needs to be preserved */
    needToPreserveRowSelection() {
        var _a;
        let preservedRowSelection = false;
        if (((_a = this._gridOptions) === null || _a === void 0 ? void 0 : _a.dataView) && this._gridOptions.dataView.hasOwnProperty('syncGridSelection')) {
            const syncGridSelection = this._gridOptions.dataView.syncGridSelection;
            if (typeof syncGridSelection === 'boolean') {
                preservedRowSelection = this._gridOptions.dataView.syncGridSelection;
            }
            else {
                preservedRowSelection = syncGridSelection.preserveHidden;
            }
            // if the result is True but the grid is using a Backend Service, we will do an extra flag check the reason is because it might have some unintended behaviors
            // with the BackendServiceApi because technically the data in the page changes the DataView on every page.
            if (preservedRowSelection && this._gridOptions.backendServiceApi && this._gridOptions.dataView.hasOwnProperty('syncGridSelectionWithBackendService')) {
                preservedRowSelection = (this._gridOptions.dataView.syncGridSelectionWithBackendService);
            }
        }
        return preservedRowSelection;
    }
    resetColumns(columnDefinitions) {
        const columns = columnDefinitions || this._columns;
        const currentColumns = this.getAssociatedCurrentColumns(columns);
        this.onGridStateChanged.next({ change: { newValues: currentColumns, type: GridStateType.columns }, gridState: this.getCurrentGridState() });
    }
    /**
     * Reset the grid to its original (all) columns, that is to display the entire set of columns with their original positions & visibilities
     * @param {Boolean} triggerAutoSizeColumns - True by default, do we also want to call the "autosizeColumns()" method to make the columns fit in the grid?
     */
    resetToOriginalColumns(triggerAutoSizeColumns = true) {
        this._grid.setColumns(this.sharedService.allColumns);
        this.sharedService.visibleColumns = this.sharedService.allColumns;
        // resize the columns to fit the grid canvas
        if (triggerAutoSizeColumns) {
            this._grid.autosizeColumns();
        }
    }
    /** if we use Row Selection or the Checkbox Selector, we need to reset any selection */
    resetRowSelectionWhenRequired() {
        var _a, _b;
        if (!this.needToPreserveRowSelection() && (this._gridOptions.enableRowSelection || this._gridOptions.enableCheckboxSelector)) {
            // this also requires the Row Selection Model to be registered as well
            const rowSelectionExtension = (_b = (_a = this.extensionService) === null || _a === void 0 ? void 0 : _a.getExtensionByName) === null || _b === void 0 ? void 0 : _b.call(_a, ExtensionName.rowSelection);
            if (rowSelectionExtension === null || rowSelectionExtension === void 0 ? void 0 : rowSelectionExtension.instance) {
                this._grid.setSelectedRows([]);
            }
        }
    }
    /**
     * Subscribe to all necessary SlickGrid or Service Events that deals with a Grid change,
     * when triggered, we will publish a Grid State Event with current Grid State
     */
    subscribeToAllGridChanges(grid) {
        // Subscribe to Event Emitter of Filter changed
        this._subscriptions.push(this.filterService.onFilterChanged.subscribe((currentFilters) => {
            this.resetRowSelectionWhenRequired();
            // trigger a Grid State filter change, however don't reevaluate the filtered row selections, we'll do that on the next Grid State change below
            this.onGridStateChanged.next({ change: { newValues: currentFilters, type: GridStateType.filter }, gridState: this.getCurrentGridState({ requestRefreshRowFilteredRow: !this.hasRowSelectionEnabled() }) });
            // when Row Selection is enabled, we also need to re-evaluate the row selection with the leftover filtered dataset
            if (this.hasRowSelectionEnabled()) {
                this.reEvaluateRowSelectionAfterFilterChange();
            }
        }));
        // Subscribe to Event Emitter of Filter cleared
        this._subscriptions.push(this.filterService.onFilterCleared.subscribe(() => {
            this.resetRowSelectionWhenRequired();
            this.onGridStateChanged.next({ change: { newValues: [], type: GridStateType.filter }, gridState: this.getCurrentGridState() });
        }));
        // Subscribe to Event Emitter of Sort changed
        this._subscriptions.push(this.sortService.onSortChanged.subscribe((currentSorters) => {
            this.resetRowSelectionWhenRequired();
            this.onGridStateChanged.next({ change: { newValues: currentSorters, type: GridStateType.sorter }, gridState: this.getCurrentGridState() });
        }));
        // Subscribe to Event Emitter of Sort cleared
        this._subscriptions.push(this.sortService.onSortCleared.subscribe(() => {
            this.resetRowSelectionWhenRequired();
            this.onGridStateChanged.next({ change: { newValues: [], type: GridStateType.sorter }, gridState: this.getCurrentGridState() });
        }));
        // Subscribe to ColumnPicker and/or GridMenu for show/hide Columns visibility changes
        this.bindExtensionAddonEventToGridStateChange(ExtensionName.columnPicker, 'onColumnsChanged');
        this.bindExtensionAddonEventToGridStateChange(ExtensionName.gridMenu, 'onColumnsChanged');
        // subscribe to Column Resize & Reordering
        this.bindSlickGridColumnChangeEventToGridStateChange('onColumnsReordered', grid);
        this.bindSlickGridColumnChangeEventToGridStateChange('onColumnsResized', grid);
        this.bindSlickGridOnSetOptionsEventToGridStateChange(grid);
        // subscribe to Row Selection changes (when enabled)
        if (this._gridOptions.enableRowSelection || this._gridOptions.enableCheckboxSelector) {
            this.bindSlickGridRowSelectionToGridStateChange();
        }
        // subscribe to HeaderMenu (hide column)
        this._subscriptions.push(this.sharedService.onHeaderMenuHideColumns.subscribe((visibleColumns) => {
            const currentColumns = this.getAssociatedCurrentColumns(visibleColumns);
            this.onGridStateChanged.next({ change: { newValues: currentColumns, type: GridStateType.columns }, gridState: this.getCurrentGridState() });
        }));
        // subscribe to Tree Data toggle items changes
        this._subscriptions.push(this.sharedService.onTreeItemToggled.subscribe((toggleChange) => {
            this.onGridStateChanged.next({ change: { newValues: toggleChange, type: GridStateType.treeData }, gridState: this.getCurrentGridState() });
        }));
        // subscribe to Tree Data full tree toggle changes
        this._subscriptions.push(this.sharedService.onTreeFullToggleEnd.subscribe((toggleChange) => {
            this.onGridStateChanged.next({ change: { newValues: toggleChange, type: GridStateType.treeData }, gridState: this.getCurrentGridState() });
        }));
    }
    // --
    // private methods
    // ------------------
    /**
       * Add certain column(s), when the feature is/are enabled, to an output column definitions array (by reference).
       * Basically some features (for example: Row Selection, Row Detail, Row Move) will be added as column(s) dynamically and internally by the lib,
       * we just ask the developer to enable the feature, via flags, and internally the lib will create the necessary column.
       * So specifically for these column(s) and feature(s), we need to re-add them internally when the user calls the `changeColumnsArrangement()` method.
       * @param {Array<Object>} dynamicAddonColumnByIndexPositionList - array of plugin columnId and columnIndexPosition that will be re-added (if it wasn't already found in the output array) dynamically
       * @param {Array<Column>} fullColumnDefinitions - full column definitions array that includes every columns (including Row Selection, Row Detail, Row Move when enabled)
       * @param {Array<Column>} newArrangedColumns - output array that will be use to show in the UI (it could have less columns than fullColumnDefinitions array since user might hide some columns)
       */
    addColumnDynamicWhenFeatureEnabled(dynamicAddonColumnByIndexPositionList, fullColumnDefinitions, newArrangedColumns) {
        // 1- first step is to sort them by their index position
        dynamicAddonColumnByIndexPositionList.sort((feat1, feat2) => feat1.columnIndexPosition - feat2.columnIndexPosition);
        // 2- second step, we can now proceed to create each extension/addon and that will position them accordingly in the column definitions list
        dynamicAddonColumnByIndexPositionList.forEach(feature => {
            const pluginColumnIdx = fullColumnDefinitions.findIndex(col => col.id === feature.columnId);
            const associatedGridCheckboxColumnIdx = newArrangedColumns.findIndex(col => col.id === feature.columnId);
            if (pluginColumnIdx >= 0 && associatedGridCheckboxColumnIdx === -1) {
                const pluginColumn = fullColumnDefinitions[pluginColumnIdx];
                pluginColumnIdx === 0 ? newArrangedColumns.unshift(pluginColumn) : newArrangedColumns.splice(pluginColumnIdx, 0, pluginColumn);
            }
        });
    }
    /**
     * Bind a SlickGrid Extension Event to a Grid State change event
     * @param extension name
     * @param grid
     */
    bindExtensionAddonEventToGridStateChange(extensionName, eventName) {
        var _a, _b, _c;
        const extension = (_b = (_a = this.extensionService) === null || _a === void 0 ? void 0 : _a.getExtensionByName) === null || _b === void 0 ? void 0 : _b.call(_a, extensionName);
        const slickEvent = (_c = extension === null || extension === void 0 ? void 0 : extension.instance) === null || _c === void 0 ? void 0 : _c[eventName];
        if (slickEvent && slickEvent.subscribe) {
            this._eventHandler.subscribe(slickEvent, (_e, args) => {
                const columns = args === null || args === void 0 ? void 0 : args.columns;
                const currentColumns = this.getAssociatedCurrentColumns(columns);
                this.onGridStateChanged.next({ change: { newValues: currentColumns, type: GridStateType.columns }, gridState: this.getCurrentGridState() });
            });
        }
    }
    /**
     * Bind a Grid Event (of Column changes) to a Grid State change event
     * @param event - event name
     * @param grid - SlickGrid object
     */
    bindSlickGridColumnChangeEventToGridStateChange(eventName, grid) {
        const slickGridEvent = grid && grid[eventName];
        if (slickGridEvent && slickGridEvent.subscribe) {
            this._eventHandler.subscribe(slickGridEvent, () => {
                const columns = grid.getColumns();
                const currentColumns = this.getAssociatedCurrentColumns(columns);
                this.onGridStateChanged.next({ change: { newValues: currentColumns, type: GridStateType.columns }, gridState: this.getCurrentGridState() });
            });
        }
    }
    /**
     * Bind a Grid Event (of grid option changes) to a Grid State change event, if we detect that any of the pinning (frozen) options changes then we'll trigger a Grid State change
     * @param grid - SlickGrid object
     */
    bindSlickGridOnSetOptionsEventToGridStateChange(grid) {
        this._eventHandler.subscribe(grid.onSetOptions, (_e, args) => {
            const { frozenBottom: frozenBottomBefore, frozenColumn: frozenColumnBefore, frozenRow: frozenRowBefore } = args.optionsBefore;
            const { frozenBottom: frozenBottomAfter, frozenColumn: frozenColumnAfter, frozenRow: frozenRowAfter } = args.optionsAfter;
            if ((frozenBottomBefore !== frozenBottomAfter) || (frozenColumnBefore !== frozenColumnAfter) || (frozenRowBefore !== frozenRowAfter)) {
                const newValues = { frozenBottom: frozenBottomAfter, frozenColumn: frozenColumnAfter, frozenRow: frozenRowAfter };
                const currentGridState = this.getCurrentGridState();
                this.onGridStateChanged.next({ change: { newValues, type: GridStateType.pinning }, gridState: currentGridState });
            }
        });
    }
    /**
     * Bind a Grid Event of Row Selection change to a Grid State change event
     * For the row selection, we can't just use the getSelectedRows() since this will only return the visible rows shown in the UI which is not enough.
     * The process is much more complex, what we have to do instead is the following
     * 1. when changing a row selection, we'll add the new selection if it's not yet in the global array of selected IDs
     * 2. when deleting a row selection, we'll remove the selection from our global array of selected IDs (unless it came from a page change)
     * 3. if we use Pagination and we change page, we'll keep track with a flag (this flag will be used to skip any deletion when we're changing page)
     * 4. after the Page or DataView is changed or updated, we'll do an extra (and delayed) check to make sure that what we have in our global array of selected IDs is displayed on screen
     */
    bindSlickGridRowSelectionToGridStateChange() {
        if (this._grid && this._gridOptions && this._dataView) {
            this._eventHandler.subscribe(this._dataView.onBeforePagingInfoChanged, () => {
                this._wasRecheckedAfterPageChange = false; // reset the page check flag, to skip deletions on page change (used in code below)
            });
            this._eventHandler.subscribe(this._dataView.onPagingInfoChanged, () => {
                // when user changes page, the selected row indexes might not show up
                // we can check to make sure it is but it has to be in a delay so it happens after the first "onSelectedRowsChanged" is triggered
                setTimeout(() => {
                    const shouldBeSelectedRowIndexes = this._dataView.mapIdsToRows(this._selectedRowDataContextIds || []);
                    const currentSelectedRowIndexes = this._grid.getSelectedRows();
                    if (!dequal(shouldBeSelectedRowIndexes, currentSelectedRowIndexes)) {
                        this._grid.setSelectedRows(shouldBeSelectedRowIndexes);
                    }
                });
            });
            this._eventHandler.subscribe(this._grid.onSelectedRowsChanged, (e, args) => {
                if (Array.isArray(args.rows) && Array.isArray(args.previousSelectedRows)) {
                    const newSelectedRows = args.rows;
                    const prevSelectedRows = args.previousSelectedRows;
                    const newSelectedAdditions = newSelectedRows.filter((i) => prevSelectedRows.indexOf(i) < 0);
                    const newSelectedDeletions = prevSelectedRows.filter((i) => newSelectedRows.indexOf(i) < 0);
                    // deletion might happen when user is changing page, if that is the case then skip the deletion since it's only a visual deletion (current page)
                    // if it's not a page change (when the flag is true), then proceed with the deletion in our global array of selected IDs
                    if (this._wasRecheckedAfterPageChange && newSelectedDeletions.length > 0) {
                        const toDeleteDataIds = this._dataView.mapRowsToIds(newSelectedDeletions) || [];
                        toDeleteDataIds.forEach((removeId) => {
                            this._selectedRowDataContextIds.splice(this._selectedRowDataContextIds.indexOf(removeId), 1);
                        });
                    }
                    // if we have newly added selected row(s), let's update our global array of selected IDs
                    if (newSelectedAdditions.length > 0) {
                        const toAddDataIds = this._dataView.mapRowsToIds(newSelectedAdditions) || [];
                        toAddDataIds.forEach((dataId) => {
                            if (this._selectedRowDataContextIds.indexOf(dataId) === -1) {
                                this._selectedRowDataContextIds.push(dataId);
                            }
                        });
                    }
                    // we set this flag which will be used on the 2nd time the "onSelectedRowsChanged" event is called
                    // when it's the first time, we skip deletion and this is what this flag is for
                    this._wasRecheckedAfterPageChange = true;
                    // form our full selected row IDs, let's make sure these indexes are selected in the grid, if not then let's call a reselect
                    // this could happen if the previous step was a page change
                    const shouldBeSelectedRowIndexes = this._dataView.mapIdsToRows(this._selectedRowDataContextIds || []);
                    const currentSelectedRowIndexes = this._grid.getSelectedRows();
                    if (!dequal(shouldBeSelectedRowIndexes, currentSelectedRowIndexes) && this._gridOptions.enablePagination) {
                        this._grid.setSelectedRows(shouldBeSelectedRowIndexes);
                    }
                    const filteredDataContextIds = this.refreshFilteredRowSelections();
                    const newValues = { gridRowIndexes: this._grid.getSelectedRows(), dataContextIds: this._selectedRowDataContextIds, filteredDataContextIds };
                    this.onGridStateChanged.next({ change: { newValues, type: GridStateType.rowSelection }, gridState: this.getCurrentGridState() });
                }
            });
        }
    }
    /** Check wether the grid has the Row Selection enabled */
    hasRowSelectionEnabled() {
        const selectionModel = this._grid.getSelectionModel();
        const isRowSelectionEnabled = this._gridOptions.enableRowSelection || this._gridOptions.enableCheckboxSelector;
        return (isRowSelectionEnabled && selectionModel);
    }
    reEvaluateRowSelectionAfterFilterChange() {
        const currentSelectedRowIndexes = this._grid.getSelectedRows();
        const previousSelectedFilteredRowDataContextIds = this._selectedFilteredRowDataContextIds.slice();
        const filteredDataContextIds = this.refreshFilteredRowSelections();
        // when selection changed, we'll send a Grid State event with the selection changes
        if (!dequal(this._selectedFilteredRowDataContextIds, previousSelectedFilteredRowDataContextIds)) {
            const newValues = { gridRowIndexes: currentSelectedRowIndexes, dataContextIds: this._selectedRowDataContextIds, filteredDataContextIds };
            this.onGridStateChanged.next({ change: { newValues, type: GridStateType.rowSelection }, gridState: this.getCurrentGridState({ requestRefreshRowFilteredRow: false }) });
        }
    }
    /** When a Filter is triggered or when user request it, we will refresh the filtered selection array and return it */
    refreshFilteredRowSelections() {
        let tmpFilteredArray = [];
        const filteredDataset = this._dataView.getFilteredItems() || [];
        if (Array.isArray(this._selectedRowDataContextIds)) {
            const selectedFilteredRowDataContextIds = [...this._selectedRowDataContextIds]; // take a fresh copy of all selections before filtering the row ids
            tmpFilteredArray = selectedFilteredRowDataContextIds.filter((selectedRowId) => {
                return filteredDataset.findIndex((item) => item[this.datasetIdPropName] === selectedRowId) > -1;
            });
            this._selectedFilteredRowDataContextIds = tmpFilteredArray;
        }
        return tmpFilteredArray;
    }
}
GridStateService.ɵfac = function GridStateService_Factory(t) { return new (t || GridStateService)(ɵngcc0.ɵɵinject(ExtensionService), ɵngcc0.ɵɵinject(FilterService), ɵngcc0.ɵɵinject(ResizerService), ɵngcc0.ɵɵinject(SharedService), ɵngcc0.ɵɵinject(SortService), ɵngcc0.ɵɵinject(TreeDataService)); };
GridStateService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: GridStateService, factory: GridStateService.ɵfac });
GridStateService.ctorParameters = () => [
    { type: ExtensionService },
    { type: FilterService },
    { type: ResizerService },
    { type: SharedService },
    { type: SortService },
    { type: TreeDataService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GridStateService, [{
        type: Injectable
    }], function () { return [{ type: ExtensionService }, { type: FilterService }, { type: ResizerService }, { type: SharedService }, { type: SortService }, { type: TreeDataService }]; }, null); })();

let highlightTimerEnd;
const GridServiceDeleteOptionDefaults = { triggerEvent: true };
const GridServiceInsertOptionDefaults = { highlightRow: true, position: 'top', resortGrid: false, selectRow: false, triggerEvent: true };
const GridServiceUpdateOptionDefaults = { highlightRow: true, selectRow: false, scrollRowIntoView: false, triggerEvent: true };
const HideColumnOptionDefaults = { autoResizeColumns: true, triggerEvent: true, hideFromColumnPicker: false, hideFromGridMenu: false };
class GridService {
    constructor(filterService, gridStateService, sharedService, sortService, treeDataService) {
        this.filterService = filterService;
        this.gridStateService = gridStateService;
        this.sharedService = sharedService;
        this.sortService = sortService;
        this.treeDataService = treeDataService;
        this.onItemAdded = new Subject();
        this.onItemDeleted = new Subject();
        this.onItemUpdated = new Subject();
        this.onItemUpserted = new Subject();
        this.onColumnsChanged = new Subject();
    }
    /** Getter for the Grid Options pulled through the Grid Object */
    get _gridOptions() {
        return (this._grid && this._grid.getOptions) ? this._grid.getOptions() : {};
    }
    dispose() {
        if (this._rowSelectionPlugin && this._rowSelectionPlugin.destroy) {
            this._rowSelectionPlugin.destroy();
        }
    }
    init(grid, dataView) {
        this._grid = grid;
        this._dataView = dataView;
    }
    /** Clear all Filters & Sorts */
    clearAllFiltersAndSorts() {
        // call both clear Filters & Sort but only trigger the last one to avoid sending multiple backend queries
        if (this.sortService && this.sortService.clearSorting) {
            this.sortService.clearSorting(false); // skip event trigger on this one
        }
        if (this.filterService && this.filterService.clearFilters) {
            this.filterService.clearFilters();
        }
    }
    /** Clear all the pinning (frozen) options */
    clearPinning() {
        const visibleColumns = [...this.sharedService.visibleColumns];
        this.sharedService.grid.setOptions({ frozenColumn: -1, frozenRow: -1, frozenBottom: false, enableMouseWheelScrollHandler: false });
        // SlickGrid seems to be somehow resetting the columns to their original positions,
        // so let's re-fix them to the position we kept as reference
        if (Array.isArray(visibleColumns)) {
            this.sharedService.grid.setColumns(visibleColumns);
        }
    }
    /**
     * Set pinning (frozen) grid options
     * @param  {Object} pinningOptions - which pinning/frozen options to modify
     * @param {Boolean} shouldAutosizeColumns - defaults to True, should we call an autosizeColumns after the pinning is done?
     * @param {Boolean} suppressRender - do we want to supress the grid re-rendering? (defaults to false)
     * @param {Boolean} suppressColumnSet - do we want to supress the columns set, via "setColumns()" method? (defaults to false)
     */
    setPinning(pinningOptions, shouldAutosizeColumns = true, suppressRender = false, suppressColumnSet = true) {
        this.sharedService.grid.setOptions(pinningOptions, suppressRender, suppressColumnSet);
        this.sharedService.gridOptions = Object.assign(Object.assign({}, this.sharedService.gridOptions), pinningOptions);
        if (shouldAutosizeColumns) {
            this.sharedService.grid.autosizeColumns();
        }
    }
    /**
     * Get all column set in the grid, that is all visible/hidden columns
     * and also include any extra columns used by some plugins (like Row Selection, Row Detail, ...)
     */
    getAllColumnDefinitions() {
        return this.sharedService.allColumns;
    }
    /** Get only visible column definitions and also include any extra columns by some plugins (like Row Selection, Row Detail, ...) */
    getVisibleColumnDefinitions() {
        return this.sharedService.visibleColumns;
    }
    /**
     * From a SlickGrid Event triggered get the Column Definition and Item Data Context
     *
     * For example the SlickGrid onClick will return cell arguments when subscribing to it.
     * From these cellArgs, we want to get the Column Definition and Item Data
     * @param cell event args
     * @return object with columnDef and dataContext
     */
    getColumnFromEventArguments(args) {
        if (!args || !args.grid || !args.grid.getColumns || !args.grid.getDataItem) {
            throw new Error('To get the column definition and data, we need to have these arguments passed as objects (row, cell, grid)');
        }
        return {
            row: args.row,
            cell: args.cell,
            columnDef: args.grid.getColumns()[args.cell],
            dataContext: args.grid.getDataItem(args.row),
            dataView: this._dataView,
            grid: this._grid
        };
    }
    /** Get data item by it's row index number */
    getDataItemByRowNumber(rowNumber) {
        if (!this._grid || typeof this._grid.getDataItem !== 'function') {
            throw new Error(`We could not find SlickGrid Grid object or it's "getDataItem" method`);
        }
        return this._grid.getDataItem(rowNumber);
    }
    /** Chain the item Metadata with our implementation of Metadata at given row index */
    getItemRowMetadataToHighlight(previousItemMetadata) {
        return (rowNumber) => {
            const item = this._dataView.getItem(rowNumber);
            let meta = { cssClasses: '' };
            if (typeof previousItemMetadata === 'function') {
                meta = previousItemMetadata(rowNumber);
            }
            if (!meta) {
                meta = { cssClasses: '' };
            }
            if (item && item._dirty) {
                meta.cssClasses = (meta && meta.cssClasses || '') + ' dirty';
            }
            if (item && item.rowClass && meta) {
                meta.cssClasses += ` ${item.rowClass}`;
                meta.cssClasses += ` row${rowNumber}`;
            }
            return meta;
        };
    }
    /**
       * @deprecated Hide a Column from the Grid (the column will just become hidden and will still show up in columnPicker/gridMenu)
       * @see hideColumnById
       * @param column
       */
    hideColumn(column) {
        if (this._grid && this._grid.getColumns && this._grid.setColumns && this._grid.getColumnIndex) {
            const columnIndex = this._grid.getColumnIndex(column.id);
            if (columnIndex >= 0) {
                this.hideColumnByIndex(columnIndex);
            }
        }
    }
    /**
     * @deprecated Hide a Column from the Grid by its column definition index (the column will just become hidden and will still show up in columnPicker/gridMenu)
     * @see hideColumnById Please use "hideColumnById(id)" or "hideColumnByIds([ids])" instead since it has a lot more options
     * @param columnIndex - column definition index
     * @param triggerEvent - do we want to trigger an event (onHeaderMenuColumnsChanged) when column becomes hidden? Defaults to true.
     */
    hideColumnByIndex(columnIndex, triggerEvent = true) {
        if (this._grid && this._grid.getColumns && this._grid.setColumns) {
            const currentColumns = this._grid.getColumns();
            const visibleColumns = arrayRemoveItemByIndex(currentColumns, columnIndex);
            this.sharedService.visibleColumns = visibleColumns;
            this._grid.setColumns(visibleColumns);
            if (triggerEvent) {
                this.onColumnsChanged.next(visibleColumns);
            }
        }
    }
    /**
     * Hide a Column from the Grid by its column definition id, the column will just become hidden and will still show up in columnPicker/gridMenu
     * @param {string | number} columnId - column definition id
     * @param {boolean} triggerEvent - do we want to trigger an event (onHeaderMenuColumnsChanged) when column becomes hidden? Defaults to true.
     * @return {number} columnIndex - column index position when found or -1
     */
    hideColumnById(columnId, options) {
        options = Object.assign(Object.assign({}, HideColumnOptionDefaults), options);
        if (this._grid && this._grid.getColumns && this._grid.setColumns) {
            const currentColumns = this._grid.getColumns();
            const colIndexFound = currentColumns.findIndex((col) => col.id === columnId);
            if (colIndexFound >= 0) {
                const visibleColumns = arrayRemoveItemByIndex(currentColumns, colIndexFound);
                this.sharedService.visibleColumns = visibleColumns;
                this._grid.setColumns(visibleColumns);
                const columnIndexFromAllColumns = this.sharedService.allColumns.findIndex(col => col.id === columnId);
                if (columnIndexFromAllColumns) {
                    if (options && options.hideFromColumnPicker) {
                        this.sharedService.allColumns[columnIndexFromAllColumns].excludeFromColumnPicker = true;
                    }
                    if (options && options.hideFromGridMenu) {
                        this.sharedService.allColumns[columnIndexFromAllColumns].excludeFromGridMenu = true;
                    }
                }
                // do we want to auto-resize the columns in the grid after hidding some? most often yes
                if (options && options.autoResizeColumns) {
                    this._grid.autosizeColumns();
                }
                // do we want to trigger an event after hidding
                if (options && options.triggerEvent) {
                    this.onColumnsChanged.next(visibleColumns);
                }
                return colIndexFound;
            }
        }
        return -1;
    }
    /**
     * Hide a Column from the Grid by its column definition id(s), the column will just become hidden and will still show up in columnPicker/gridMenu
     * @param {Array<string | number>} columnIds - column definition ids, can be a single string and an array of strings
     * @param {boolean} triggerEvent - do we want to trigger an event (onHeaderMenuColumnsChanged) when column becomes hidden? Defaults to true.
     */
    hideColumnByIds(columnIds, options) {
        options = Object.assign(Object.assign({}, HideColumnOptionDefaults), options);
        if (Array.isArray(columnIds)) {
            for (const columnId of columnIds) {
                // hide each column by its id but wait after the for loop to auto resize columns in the grid
                this.hideColumnById(columnId, Object.assign(Object.assign({}, options), { triggerEvent: false, autoResizeColumns: false }));
            }
            // do we want to auto-resize the columns in the grid after hidding some? most often yes
            if (options && options.autoResizeColumns) {
                this._grid.autosizeColumns();
            }
            // do we want to trigger an event after hidding
            if (options && options.triggerEvent) {
                this.onColumnsChanged.next(this.sharedService.visibleColumns);
            }
        }
    }
    /**
     * Highlight then fade a row for x seconds.
     * The implementation follows this SO answer: https://stackoverflow.com/a/19985148/1212166
     * @param rowNumber
     * @param fadeDelay
     */
    highlightRow(rowNumber, fadeDelay = 1500, fadeOutDelay = 300) {
        // create a SelectionModel if there's not one yet
        if (!this._grid.getSelectionModel() && Slick && Slick.RowSelectionModel) {
            this._rowSelectionPlugin = new Slick.RowSelectionModel(this._gridOptions.rowSelectionOptions || {});
            this._grid.setSelectionModel(this._rowSelectionPlugin);
        }
        if (Array.isArray(rowNumber)) {
            rowNumber.forEach(row => this.highlightRowByMetadata(row, fadeDelay, fadeOutDelay));
        }
        else {
            this.highlightRowByMetadata(rowNumber, fadeDelay, fadeOutDelay);
        }
    }
    highlightRowByMetadata(rowNumber, fadeDelay = 1500, fadeOutDelay = 300) {
        this._dataView.getItemMetadata = this.getItemRowMetadataToHighlight(this._dataView.getItemMetadata);
        const item = this._dataView.getItem(rowNumber);
        const idPropName = this._gridOptions.datasetIdPropertyName || 'id';
        if (item && item[idPropName] !== undefined) {
            item.rowClass = 'highlight';
            this._dataView.updateItem(item[idPropName], item);
            this.renderGrid();
            // fade out
            clearTimeout(highlightTimerEnd);
            highlightTimerEnd = setTimeout(() => {
                item.rowClass = 'highlight-end';
                this._dataView.updateItem(item[idPropName], item);
                this.renderGrid();
            }, fadeOutDelay);
            // delete the row's CSS highlight classes once the delay is passed
            setTimeout(() => {
                if (item && item[idPropName] !== undefined) {
                    delete item.rowClass;
                    if (this._dataView.getIdxById(item[idPropName]) !== undefined) {
                        this._dataView.updateItem(item[idPropName], item);
                        this.renderGrid();
                    }
                }
            }, fadeDelay + fadeOutDelay);
        }
    }
    /** Get the Data Item from a grid row index */
    getDataItemByRowIndex(index) {
        if (!this._grid || typeof this._grid.getDataItem !== 'function') {
            throw new Error('We could not find SlickGrid Grid object and/or "getDataItem" method');
        }
        return this._grid.getDataItem(index);
    }
    /** Get the Data Item from an array of grid row indexes */
    getDataItemByRowIndexes(indexes) {
        if (!this._grid || typeof this._grid.getDataItem !== 'function') {
            throw new Error('We could not find SlickGrid Grid object and/or "getDataItem" method');
        }
        const dataItems = [];
        if (Array.isArray(indexes)) {
            indexes.forEach((idx) => {
                dataItems.push(this._grid.getDataItem(idx));
            });
        }
        return dataItems;
    }
    /** Get the currently selected row indexes */
    getSelectedRows() {
        if (!this._grid || typeof this._grid.getSelectedRows !== 'function') {
            throw new Error('We could not find SlickGrid Grid object and/or "getSelectedRows" method');
        }
        return this._grid.getSelectedRows();
    }
    /** Get the currently selected rows item data */
    getSelectedRowsDataItem() {
        if (!this._grid || typeof this._grid.getSelectedRows !== 'function') {
            throw new Error('We could not find SlickGrid Grid object and/or "getSelectedRows" method');
        }
        const selectedRowIndexes = this._grid.getSelectedRows();
        return this.getDataItemByRowIndexes(selectedRowIndexes);
    }
    /** Select the selected row by a row index */
    setSelectedRow(rowIndex) {
        if (this._grid && this._grid.setSelectedRows) {
            this._grid.setSelectedRows([rowIndex]);
        }
    }
    /** Set selected rows with provided array of row indexes */
    setSelectedRows(rowIndexes) {
        if (this._grid && this._grid.setSelectedRows) {
            this._grid.setSelectedRows(rowIndexes);
        }
    }
    /** Re-Render the Grid */
    renderGrid() {
        if (this._grid && typeof this._grid.invalidate === 'function') {
            this._grid.invalidate();
            this._grid.render();
        }
    }
    /**
     * Reset the grid to it's original state (clear any filters, sorting & pagination if exists) .
     * The column definitions could be passed as argument to reset (this can be used after a Grid State reset)
     * The reset will clear the Filters & Sort, then will reset the Columns to their original state
     */
    resetGrid(columnDefinitions) {
        // reset columns to original states & refresh the grid
        if (this._grid && this._dataView) {
            const originalColumns = this.sharedService.allColumns || [];
            if (Array.isArray(originalColumns) && originalColumns.length > 0) {
                // set the grid columns to it's original column definitions
                this._grid.setColumns(originalColumns);
                if (this._gridOptions && this._gridOptions.enableAutoSizeColumns) {
                    this._grid.autosizeColumns();
                }
                this.gridStateService.resetColumns(columnDefinitions);
            }
        }
        // clear any Pinning/Frozen columns/rows
        this.clearPinning();
        if (this.filterService && this.filterService.clearFilters) {
            this.filterService.clearFilters();
        }
        if (this.sortService && this.sortService.clearSorting) {
            this.sortService.clearSorting();
        }
    }
    /** @deprecated please use "addItem" method instead */
    addItemToDatagrid(item, shouldHighlightRow = true, shouldResortGrid = false, shouldTriggerEvent = true, shouldSelectRow = true) {
        console.warn('[Angular-Slickgrid - GridService] please consider using the new "addItem" method since "addItemToDatagrid" will be deprecated in the future.');
        return this.addItem(item, { highlightRow: shouldHighlightRow, resortGrid: shouldResortGrid, triggerEvent: shouldTriggerEvent, selectRow: shouldSelectRow });
    }
    /** @deprecated please use "addItems" method instead */
    addItemsToDatagrid(items, shouldHighlightRow = true, shouldResortGrid = false, shouldTriggerEvent = true, shouldSelectRow = true) {
        console.warn('[Angular-Slickgrid - GridService] please consider using the new "addItems" method since "addItemsToDatagrid" will be deprecated in the future.');
        return this.addItems(items, { highlightRow: shouldHighlightRow, resortGrid: shouldResortGrid, triggerEvent: shouldTriggerEvent, selectRow: shouldSelectRow });
    }
    /**
     * Add an item (data item) to the datagrid, by default it will highlight (flashing) the inserted row but we can disable it too
     * @param item object which must contain a unique "id" property and any other suitable properties
     * @param options: provide the possibility to do certain actions after or during the upsert (highlightRow, resortGrid, selectRow, triggerEvent)
     * @return rowIndex: typically index 0 when adding to position "top" or a different number when adding to the "bottom"
     */
    addItem(item, options) {
        var _a, _b, _c, _d, _e;
        options = Object.assign(Object.assign({}, GridServiceInsertOptionDefaults), options);
        const insertPosition = (_a = options === null || options === void 0 ? void 0 : options.position) !== null && _a !== void 0 ? _a : 'top';
        if (!this._grid || !this._gridOptions || !this._dataView) {
            throw new Error('We could not find SlickGrid Grid, DataView objects');
        }
        const idPropName = this._gridOptions.datasetIdPropertyName || 'id';
        if (!item || !(idPropName in item)) {
            throw new Error(`Adding an item requires the item to include an "${idPropName}" property`);
        }
        // insert position top/bottom, defaults to top
        // when position is top we'll call insert at index 0, else call addItem which just push to the DataView array
        if (insertPosition === 'bottom' || ((_b = this._gridOptions) === null || _b === void 0 ? void 0 : _b.enableTreeData)) {
            this._dataView.addItem(item);
        }
        else {
            this._dataView.insertItem(0, item); // insert at index 0
        }
        // row number in the grid, by default it will be on first row (top is the default)
        let rowNumber = 0;
        const itemId = (_d = (_c = item) === null || _c === void 0 ? void 0 : _c[idPropName]) !== null && _d !== void 0 ? _d : '';
        if ((_e = this._gridOptions) === null || _e === void 0 ? void 0 : _e.enableTreeData) {
            // if we add/remove item(s) from the dataset, we need to also refresh our tree data filters
            this.invalidateHierarchicalDataset();
            rowNumber = this._dataView.getRowById(itemId);
            this._grid.scrollRowIntoView(rowNumber !== null && rowNumber !== void 0 ? rowNumber : 0, false);
        }
        else if (options.resortGrid) {
            // do we want the item to be sorted in the grid, when set to False it will insert on first row (defaults to false)
            this._dataView.reSort();
            // find the row number in the grid and if user wanted to see highlighted row
            // we need to do it here after resort and get each row number because it possibly changes after the sort
            rowNumber = this._dataView.getRowById(itemId);
        }
        else {
            // scroll to row index 0 when inserting on top else scroll to the bottom where it got inserted
            rowNumber = (insertPosition === 'bottom') ? this._dataView.getRowById(itemId) : 0;
            this._grid.scrollRowIntoView(rowNumber !== null && rowNumber !== void 0 ? rowNumber : 0);
        }
        // if highlight is enabled, we'll highlight the row we just added
        if (options.highlightRow && rowNumber !== undefined) {
            this.highlightRow(rowNumber);
        }
        // if row selection (checkbox selector) is enabled, we'll select the row in the grid
        if (rowNumber !== undefined && options.selectRow && this._gridOptions && (this._gridOptions.enableCheckboxSelector || this._gridOptions.enableRowSelection)) {
            this.setSelectedRow(rowNumber);
        }
        // do we want to trigger an event after adding the item
        if (options.triggerEvent) {
            this.onItemAdded.next(item);
        }
        return rowNumber;
    }
    /**
     * Add item array (data item) to the datagrid, by default it will highlight (flashing) the inserted row but we can disable it too
     * @param item object arrays, which must contain unique "id" property and any other suitable properties
     * @param options: provide the possibility to do certain actions after or during the upsert (highlightRow, resortGrid, selectRow, triggerEvent)
     */
    addItems(items, options) {
        var _a, _b, _c, _d, _e, _f;
        options = Object.assign(Object.assign({}, GridServiceInsertOptionDefaults), options);
        const idPropName = this._gridOptions.datasetIdPropertyName || 'id';
        const insertPosition = (_a = options === null || options === void 0 ? void 0 : options.position) !== null && _a !== void 0 ? _a : 'top';
        const rowNumbers = [];
        // loop through all items to add
        if (!Array.isArray(items)) {
            return [this.addItem(items, options) || 0]; // on a single item, just call addItem()
        }
        else {
            // begin bulk transaction
            this._dataView.beginUpdate(true);
            // insert position top/bottom, defaults to top
            // when position is top we'll call insert at index 0, else call addItem which just push to the DataView array
            if (insertPosition === 'bottom' || ((_b = this._gridOptions) === null || _b === void 0 ? void 0 : _b.enableTreeData)) {
                this._dataView.addItems(items);
            }
            else {
                this._dataView.insertItems(0, items); // insert at index 0 to the start of the dataset
            }
            // end the bulk transaction since we're all done
            this._dataView.endUpdate();
        }
        if ((_c = this._gridOptions) === null || _c === void 0 ? void 0 : _c.enableTreeData) {
            // if we add/remove item(s) from the dataset, we need to also refresh our tree data filters
            this.invalidateHierarchicalDataset();
            const firstItemId = (_e = (_d = items[0]) === null || _d === void 0 ? void 0 : _d[idPropName]) !== null && _e !== void 0 ? _e : '';
            const rowNumber = this._dataView.getRowById(firstItemId);
            this._grid.scrollRowIntoView(rowNumber !== null && rowNumber !== void 0 ? rowNumber : 0, false);
        }
        else if (options.resortGrid) {
            // do we want the item to be sorted in the grid, when set to False it will insert on first row (defaults to false)
            this._dataView.reSort();
        }
        // scroll to row index 0 when inserting on top else scroll to the bottom where it got inserted
        (insertPosition === 'bottom' && !((_f = this._gridOptions) === null || _f === void 0 ? void 0 : _f.enableTreeData)) ? this._grid.navigateBottom() : this._grid.navigateTop();
        // get row numbers of all new inserted items
        // we need to do it after resort and get each row number because it possibly changed after the sort
        items.forEach((item) => rowNumbers.push(this._dataView.getRowById(item[idPropName])));
        // if user wanted to see highlighted row
        if (options.highlightRow) {
            this.highlightRow(rowNumbers);
        }
        // select the row in the grid
        if (options.selectRow && this._gridOptions && (this._gridOptions.enableCheckboxSelector || this._gridOptions.enableRowSelection)) {
            this.setSelectedRows(rowNumbers);
        }
        // do we want to trigger an event after adding the item
        if (options.triggerEvent) {
            this.onItemAdded.next(items);
        }
        return rowNumbers;
    }
    /** @deprecated please use "deleteItem" method instead */
    deleteDataGridItem(item, shouldTriggerEvent = true) {
        console.warn('[Angular-Slickgrid - GridService] please consider using the new "deleteItem" method since "deleteDataGridItem" will be deprecated in the future.');
        this.deleteItem(item, { triggerEvent: shouldTriggerEvent });
    }
    /** @deprecated please use "deleteItems" method instead */
    deleteDataGridItems(items, shouldTriggerEvent = true) {
        console.warn('[Angular-Slickgrid - GridService] please consider using the new "deleteItems" method since "deleteDataGridItems" will be deprecated in the future.');
        this.deleteItems(items, { triggerEvent: shouldTriggerEvent });
    }
    /** @deprecated please use "deleteItemById" method instead */
    deleteDataGridItemById(itemId, shouldTriggerEvent = true) {
        console.warn('[Angular-Slickgrid - GridService] please consider using the new "deleteItemById" method since "deleteDataGridItemById" will be deprecated in the future.');
        this.deleteItemById(itemId, { triggerEvent: shouldTriggerEvent });
    }
    /** @deprecated please use "deleteItemByIds" method instead */
    deleteDataGridItemByIds(itemIds, shouldTriggerEvent = true) {
        console.warn('[Angular-Slickgrid - GridService] please consider using the new "deleteItemByIds" method since "deleteDataGridItemByIds" will be deprecated in the future.');
        this.deleteItemByIds(itemIds, { triggerEvent: shouldTriggerEvent });
    }
    /**
     * Delete an existing item from the datagrid (dataView)
     * @param item object which must contain a unique "id" property and any other suitable properties
     * @param options: provide the possibility to do certain actions after or during the upsert (triggerEvent)
     * @return item id deleted
     */
    deleteItem(item, options) {
        options = Object.assign(Object.assign({}, GridServiceDeleteOptionDefaults), options);
        const idPropName = this._gridOptions.datasetIdPropertyName || 'id';
        if (!item || !(idPropName in item)) {
            throw new Error(`Deleting an item requires the item to include an "${idPropName}" property`);
        }
        return this.deleteItemById(item[idPropName], options);
    }
    /**
     * Delete an array of existing items from the datagrid
     * @param item object which must contain a unique "id" property and any other suitable properties
     * @param options: provide the possibility to do certain actions after or during the upsert (triggerEvent)
     * @return item id deleted
     */
    deleteItems(items, options) {
        options = Object.assign(Object.assign({}, GridServiceDeleteOptionDefaults), options);
        const idPropName = this._gridOptions.datasetIdPropertyName || 'id';
        // when it's not an array, we can call directly the single item delete
        if (!Array.isArray(items)) {
            this.deleteItem(items, options);
            return [items[idPropName]];
        }
        // begin bulk transaction
        this._dataView.beginUpdate(true);
        const itemIds = [];
        items.forEach((item) => {
            if (item && item[idPropName] !== undefined) {
                itemIds.push(item[idPropName]);
            }
        });
        // delete the item from the dataView
        this._dataView.deleteItems(itemIds);
        // end the bulk transaction since we're all done
        this._dataView.endUpdate();
        // do we want to trigger an event after deleting the item
        if (options.triggerEvent) {
            this.onItemDeleted.next(items);
        }
        return itemIds;
    }
    /**
     * Delete an existing item from the datagrid (dataView) by it's id
     * @param itemId: item unique id
     * @param options: provide the possibility to do certain actions after or during the upsert (triggerEvent)
     * @return item id deleted
     */
    deleteItemById(itemId, options) {
        options = Object.assign(Object.assign({}, GridServiceDeleteOptionDefaults), options);
        if (itemId === null || itemId === undefined) {
            throw new Error(`Cannot delete a row without a valid "id"`);
        }
        // when user has row selection enabled, we should clear any selection to avoid confusion after a delete
        const isSyncGridSelectionEnabled = this.gridStateService && this.gridStateService.needToPreserveRowSelection() || false;
        if (!isSyncGridSelectionEnabled && this._grid && this._gridOptions && (this._gridOptions.enableCheckboxSelector || this._gridOptions.enableRowSelection)) {
            this.setSelectedRows([]);
        }
        // delete the item from the dataView
        this._dataView.deleteItem(itemId);
        // do we want to trigger an event after deleting the item
        if (options.triggerEvent) {
            this.onItemDeleted.next(itemId);
        }
        return itemId;
    }
    /**
     * Delete an array of existing items from the datagrid
     * @param itemIds array of item unique IDs
     * @param options: provide the possibility to do certain actions after or during the upsert (triggerEvent)
     */
    deleteItemByIds(itemIds, options) {
        options = Object.assign(Object.assign({}, GridServiceDeleteOptionDefaults), options);
        // when it's not an array, we can call directly the single item delete
        if (Array.isArray(itemIds)) {
            // begin bulk transaction
            this._dataView.beginUpdate(true);
            for (let i = 0; i < itemIds.length; i++) {
                if (itemIds[i] !== null) {
                    this.deleteItemById(itemIds[i], { triggerEvent: false });
                }
            }
            // end the bulk transaction since we're all done
            this._dataView.endUpdate();
            // do we want to trigger an event after deleting the item
            if (options.triggerEvent) {
                this.onItemDeleted.next(itemIds);
            }
            return itemIds;
        }
        return [];
    }
    /** @deprecated please use "updateItem" method instead */
    updateDataGridItem(item, shouldHighlightRow = true, shouldTriggerEvent = true, shouldSelectRow = true) {
        console.warn('[Angular-Slickgrid - GridService] please consider using the new "updateItem" method since "updateDataGridItem" will be deprecated in the future.');
        return this.updateItem(item, { highlightRow: shouldHighlightRow, triggerEvent: shouldTriggerEvent, selectRow: shouldSelectRow });
    }
    /** @deprecated please use "updateItems" method instead */
    updateDataGridItems(items, shouldHighlightRow = true, shouldTriggerEvent = true, shouldSelectRow = true) {
        console.warn('[Angular-Slickgrid - GridService] please consider using the new "updateItems" method since "updateDataGridItems" will be deprecated in the future.');
        return this.updateItems(items, { highlightRow: shouldHighlightRow, triggerEvent: shouldTriggerEvent, selectRow: shouldSelectRow });
    }
    /** @deprecated please use "updateItemById" method instead */
    updateDataGridItemById(itemId, item, shouldHighlightRow = true, shouldTriggerEvent = true, shouldSelectRow = true) {
        console.warn('[Angular-Slickgrid - GridService] please consider using the new "updateItemById" method since "updateDataGridItemById" will be deprecated in the future.');
        return this.updateItemById(itemId, item, { highlightRow: shouldHighlightRow, triggerEvent: shouldTriggerEvent, selectRow: shouldSelectRow });
    }
    /**
     * Update an existing item with new properties inside the datagrid
     * @param item object which must contain a unique "id" property and any other suitable properties
     * @param options: provide the possibility to do certain actions after or during the upsert (highlightRow, selectRow, triggerEvent)
     * @return grid row index
     */
    updateItem(item, options) {
        options = Object.assign(Object.assign({}, GridServiceUpdateOptionDefaults), options);
        const idPropName = this._gridOptions.datasetIdPropertyName || 'id';
        const itemId = (!item || !(idPropName in item)) ? undefined : item[idPropName];
        if (itemId === undefined) {
            throw new Error(`Calling Update of an item requires the item to include an "${idPropName}" property`);
        }
        return this.updateItemById(itemId, item, options);
    }
    /**
     * Update an array of existing items with new properties inside the datagrid
     * @param item object arrays, which must contain unique "id" property and any other suitable properties
     * @param options: provide the possibility to do certain actions after or during the update (highlightRow, selectRow, triggerEvent)
     * @return grid row indexes
     */
    updateItems(items, options) {
        var _a;
        options = Object.assign(Object.assign({}, GridServiceUpdateOptionDefaults), options);
        const idPropName = this._gridOptions.datasetIdPropertyName || 'id';
        // when it's not an array, we can call directly the single item update
        if (!Array.isArray(items)) {
            return [this.updateItem(items, options)];
        }
        // begin bulk transaction
        this._dataView.beginUpdate(true);
        // loop through each item, get their Ids
        // also call a grid render on the modified row for the item to be reflected in the UI
        const rowNumbers = [];
        const itemIds = [];
        items.forEach((item) => {
            const itemId = (!item || !(idPropName in item)) ? undefined : item[idPropName];
            itemIds.push(itemId); // keep item id reference
            if (this._dataView.getIdxById(itemId) !== undefined) {
                const rowNumber = this._dataView.getRowById(itemId);
                if (rowNumber !== undefined) {
                    rowNumbers.push(rowNumber);
                    this._grid.updateRow(rowNumber);
                }
            }
        });
        // Update the items in the dataView, note that the itemIds must be in the same order as the items
        this._dataView.updateItems(itemIds, items);
        // end the bulk transaction since we're all done
        this._dataView.endUpdate();
        if ((_a = this._gridOptions) === null || _a === void 0 ? void 0 : _a.enableTreeData) {
            // if we add/remove item(s) from the dataset, we need to also refresh our tree data filters
            this.invalidateHierarchicalDataset();
        }
        // only highlight at the end, all at once
        // we have to do this because doing highlight 1 by 1 would only re-select the last highlighted row which is wrong behavior
        if (options.highlightRow) {
            this.highlightRow(rowNumbers);
        }
        // select the row in the grid
        if (options.selectRow && this._gridOptions && (this._gridOptions.enableCheckboxSelector || this._gridOptions.enableRowSelection)) {
            this.setSelectedRows(rowNumbers);
        }
        // do we want to trigger an event after updating the item
        if (options.triggerEvent) {
            this.onItemUpdated.next(items);
        }
        return rowNumbers;
    }
    /**
     * Update an existing item in the datagrid by it's id and new properties
     * @param itemId: item unique id
     * @param item object which must contain a unique "id" property and any other suitable properties
     * @param options: provide the possibility to do certain actions after or during the upsert (highlightRow, selectRow, triggerEvent)
     * @return grid row number
     */
    updateItemById(itemId, item, options) {
        var _a;
        options = Object.assign(Object.assign({}, GridServiceUpdateOptionDefaults), options);
        if (itemId === undefined) {
            throw new Error(`Cannot update a row without a valid "id"`);
        }
        const rowNumber = this._dataView.getRowById(itemId);
        if (!item || rowNumber === undefined) {
            throw new Error(`The item to update in the grid was not found with id: ${itemId}`);
        }
        if (this._dataView.getIdxById(itemId) !== undefined) {
            // Update the item itself inside the dataView
            this._dataView.updateItem(itemId, item);
            this._grid.updateRow(rowNumber);
            if ((_a = this._gridOptions) === null || _a === void 0 ? void 0 : _a.enableTreeData) {
                // if we add/remove item(s) from the dataset, we need to also refresh our tree data filters
                this.invalidateHierarchicalDataset();
            }
            // do we want to scroll to the row so that it shows in the Viewport (UI)
            if (options.scrollRowIntoView) {
                this._grid.scrollRowIntoView(rowNumber);
            }
            // highlight the row we just updated, if defined
            if (options.highlightRow) {
                this.highlightRow(rowNumber);
            }
            // select the row in the grid
            if (options.selectRow && this._gridOptions && (this._gridOptions.enableCheckboxSelector || this._gridOptions.enableRowSelection)) {
                this.setSelectedRow(rowNumber);
            }
            // do we want to trigger an event after updating the item
            if (options.triggerEvent) {
                this.onItemUpdated.next(item);
            }
        }
        return rowNumber;
    }
    /**
     * Insert a row into the grid if it doesn't already exist or update if it does.
     * @param item object which must contain a unique "id" property and any other suitable properties
     * @param options: provide the possibility to do certain actions after or during the upsert (highlightRow, resortGrid, selectRow, triggerEvent)
     */
    upsertItem(item, options) {
        options = Object.assign(Object.assign({}, GridServiceInsertOptionDefaults), options);
        const idPropName = this._gridOptions.datasetIdPropertyName || 'id';
        const itemId = (!item || !(idPropName in item)) ? undefined : item[idPropName];
        if (itemId === undefined) {
            throw new Error(`Calling Upsert of an item requires the item to include an "${idPropName}" property`);
        }
        return this.upsertItemById(itemId, item, options);
    }
    /**
     * Update an array of existing items with new properties inside the datagrid
     * @param item object arrays, which must contain unique "id" property and any other suitable properties
     * @param options: provide the possibility to do certain actions after or during the upsert (highlightRow, resortGrid, selectRow, triggerEvent)
     * @return row numbers in the grid
     */
    upsertItems(items, options) {
        options = Object.assign(Object.assign({}, GridServiceInsertOptionDefaults), options);
        // when it's not an array, we can call directly the single item upsert
        if (!Array.isArray(items)) {
            return [this.upsertItem(items, options)];
        }
        // begin bulk transaction
        this._dataView.beginUpdate(true);
        const upsertedRows = [];
        items.forEach((item) => {
            upsertedRows.push(this.upsertItem(item, Object.assign(Object.assign({}, options), { highlightRow: false, resortGrid: false, selectRow: false, triggerEvent: false })));
        });
        // end the bulk transaction since we're all done
        this._dataView.endUpdate();
        const rowNumbers = upsertedRows.map((upsertRow) => upsertRow.added !== undefined ? upsertRow.added : upsertRow.updated);
        // only highlight at the end, all at once
        // we have to do this because doing highlight 1 by 1 would only re-select the last highlighted row which is wrong behavior
        if (options.highlightRow) {
            this.highlightRow(rowNumbers);
        }
        // select the row in the grid
        if (options.selectRow && this._gridOptions && (this._gridOptions.enableCheckboxSelector || this._gridOptions.enableRowSelection)) {
            this.setSelectedRows(rowNumbers);
        }
        // do we want to trigger an event after updating the item
        if (options.triggerEvent) {
            this.onItemUpserted.next(items);
            const addedItems = upsertedRows.filter((upsertRow) => upsertRow.added !== undefined);
            if (Array.isArray(addedItems) && addedItems.length > 0) {
                this.onItemAdded.next(addedItems);
            }
            const updatedItems = upsertedRows.filter((upsertRow) => upsertRow.updated !== undefined);
            if (Array.isArray(updatedItems) && updatedItems.length > 0) {
                this.onItemUpdated.next(updatedItems);
            }
        }
        return upsertedRows;
    }
    /**
     * Update an existing item in the datagrid by it's id and new properties
     * @param itemId: item unique id
     * @param item object which must contain a unique "id" property and any other suitable properties
     * @param options: provide the possibility to do certain actions after or during the upsert (highlightRow, resortGrid, selectRow, triggerEvent)
     * @return grid row number in the grid
     */
    upsertItemById(itemId, item, options) {
        let isItemAdded = false;
        options = Object.assign(Object.assign({}, GridServiceInsertOptionDefaults), options);
        if (itemId === undefined) {
            if (!this.hasRowSelectionEnabled()) {
                throw new Error(`Calling Upsert of an item requires the item to include a valid and unique "id" property`);
            }
        }
        let rowNumberAdded;
        let rowNumberUpdated;
        if (this._dataView.getRowById(itemId) === undefined) {
            rowNumberAdded = this.addItem(item, options);
            isItemAdded = true;
        }
        else {
            rowNumberUpdated = this.updateItem(item, { highlightRow: options.highlightRow, selectRow: options.selectRow, triggerEvent: options.triggerEvent });
            isItemAdded = false;
        }
        // do we want to trigger an event after updating the item
        if (options.triggerEvent) {
            this.onItemUpserted.next(item);
            isItemAdded ? this.onItemAdded.next(item) : this.onItemUpdated.next(item);
        }
        return { added: rowNumberAdded, updated: rowNumberUpdated };
    }
    /**
     * When dealing with hierarchical (tree) dataset, we can invalidate all the rows and force a full resort & re-render of the hierarchical tree dataset.
     * This method will automatically be called anytime user called `addItem()` or `addItems()`.
     * However please note that it won't be called when `updateItem`, if the data that gets updated does change the tree data column then you should call this method.
     * @param {Array<Object>} [items] - optional flat array of parent/child items to use while redoing the full sort & refresh
     */
    invalidateHierarchicalDataset(items) {
        var _a;
        // if we add/remove item(s) from the dataset, we need to also refresh our tree data filters
        if (((_a = this._gridOptions) === null || _a === void 0 ? void 0 : _a.enableTreeData) && this.treeDataService) {
            const inputItems = items !== null && items !== void 0 ? items : this._dataView.getItems();
            const sortedDatasetResult = this.treeDataService.convertFlatParentChildToTreeDatasetAndSort(inputItems || [], this.sharedService.allColumns, this._gridOptions);
            this.sharedService.hierarchicalDataset = sortedDatasetResult.hierarchical;
            this.filterService.refreshTreeDataFilters(items);
            this._dataView.setItems(sortedDatasetResult.flat);
        }
    }
    // --
    // private functions
    // -------------------
    /** Check wether the grid has the Row Selection enabled */
    hasRowSelectionEnabled() {
        const selectionModel = this._grid.getSelectionModel();
        const isRowSelectionEnabled = this._gridOptions.enableRowSelection || this._gridOptions.enableCheckboxSelector;
        return (isRowSelectionEnabled && selectionModel);
    }
}
GridService.ɵfac = function GridService_Factory(t) { return new (t || GridService)(ɵngcc0.ɵɵinject(FilterService), ɵngcc0.ɵɵinject(GridStateService), ɵngcc0.ɵɵinject(SharedService), ɵngcc0.ɵɵinject(SortService), ɵngcc0.ɵɵinject(TreeDataService)); };
GridService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: GridService, factory: GridService.ɵfac });
GridService.ctorParameters = () => [
    { type: FilterService },
    { type: GridStateService },
    { type: SharedService },
    { type: SortService },
    { type: TreeDataService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GridService, [{
        type: Injectable
    }], function () { return [{ type: FilterService }, { type: GridStateService }, { type: SharedService }, { type: SortService }, { type: TreeDataService }]; }, null); })();

class GridEventService {
    constructor() {
        this._eventHandler = new Slick.EventHandler();
    }
    get eventHandler() {
        return this._eventHandler;
    }
    dispose() {
        this._eventHandler.unsubscribeAll();
    }
    /* OnCellChange Event */
    bindOnCellChange(grid, dataView) {
        // subscribe to this Slickgrid event of onCellChange
        this._eventHandler.subscribe(grid.onCellChange, (e, args) => {
            this.handleOnCellChange.call(this, grid, dataView, e, args);
        });
    }
    /* OnClick Event */
    bindOnClick(grid, dataView) {
        this._eventHandler.subscribe(grid.onClick, (e, args) => {
            this.handleOnCellClick.call(this, grid, dataView, e, args);
        });
    }
    //
    // private functions
    // ------------------
    /* OnCellChange Event Handler */
    handleOnCellChange(grid, dataView, e, args) {
        if (!e || !args || !grid || args.cell === undefined || !grid.getColumns || !grid.getDataItem) {
            return;
        }
        const column = grid.getColumns()[args.cell];
        // if the column definition has a onCellChange property (a callback function), then run it
        if (typeof column.onCellChange === 'function') {
            // add to the output gridOptions & dataView since we'll need them inside the AJAX column.onCellChange
            const returnedArgs = {
                row: args.row,
                cell: args.cell,
                dataView,
                grid,
                columnDef: column,
                dataContext: grid.getDataItem(args.row)
            };
            // finally call up the Slick.column.onCellChanges.... function
            column.onCellChange(e, returnedArgs);
        }
    }
    /* OnCellClick Event Handler */
    handleOnCellClick(grid, dataView, e, args) {
        if (!e || !args || !grid || args.cell === undefined || !grid.getColumns || !grid.getDataItem) {
            return;
        }
        const column = grid && grid.getColumns && grid.getColumns()[args.cell];
        const gridOptions = grid && grid.getOptions && grid.getOptions() || {};
        // only when the grid option "autoCommitEdit" is enabled, we will make the cell active (in focus) when clicked
        // setting the cell as active as a side effect and if "autoCommitEdit" is set to false then the Editors won't save correctly
        if (gridOptions.enableCellNavigation && (!gridOptions.editable || (gridOptions.editable && gridOptions.autoCommitEdit))) {
            grid.setActiveCell(args.row, args.cell, false, false, true);
        }
        // if the column definition has a onCellClick property (a callback function), then run it
        if (typeof column.onCellClick === 'function') {
            // add to the output gridOptions & dataView since we'll need them inside the AJAX column.onClick
            const returnedArgs = {
                row: args.row,
                cell: args.cell,
                dataView,
                grid,
                columnDef: column,
                dataContext: grid.getDataItem(args.row)
            };
            // finally call up the Slick.column.onCellClick.... function
            column.onCellClick(e, returnedArgs);
        }
    }
}
GridEventService.ɵfac = function GridEventService_Factory(t) { return new (t || GridEventService)(); };
GridEventService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: GridEventService, factory: GridEventService.ɵfac });
GridEventService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GridEventService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class GroupingAndColspanService {
    constructor(extensionUtility, extensionService, resizerService, sharedService) {
        this.extensionUtility = extensionUtility;
        this.extensionService = extensionService;
        this.resizerService = resizerService;
        this.sharedService = sharedService;
        this.subscriptions = [];
        this._eventHandler = new Slick.EventHandler();
    }
    /** Getter of the SlickGrid Event Handler */
    get eventHandler() {
        return this._eventHandler;
    }
    /** Getter for the Grid Options pulled through the Grid Object */
    get _gridOptions() {
        return (this._grid && this._grid.getOptions) ? this._grid.getOptions() : {};
    }
    /** Getter for the Column Definitions pulled through the Grid Object */
    get _columnDefinitions() {
        return (this._grid && this._grid.getColumns) ? this._grid.getColumns() : [];
    }
    init(grid, dataView) {
        this._grid = grid;
        if (grid && this._gridOptions) {
            // When dealing with Pre-Header Grouping colspan, we need to re-create the pre-header in multiple occasions
            // for all these events, we have to trigger a re-create
            if (this._gridOptions.createPreHeaderPanel) {
                // on all following events, call the
                this._eventHandler.subscribe(grid.onSort, () => this.renderPreHeaderRowGroupingTitles());
                this._eventHandler.subscribe(grid.onRendered, () => this.renderPreHeaderRowGroupingTitles());
                this._eventHandler.subscribe(grid.onAutosizeColumns, () => this.renderPreHeaderRowGroupingTitles());
                this._eventHandler.subscribe(grid.onColumnsResized, () => this.renderPreHeaderRowGroupingTitles());
                this._eventHandler.subscribe(grid.onColumnsReordered, () => this.renderPreHeaderRowGroupingTitles());
                this._eventHandler.subscribe(dataView.onRowCountChanged, () => this.renderPreHeaderRowGroupingTitles());
                this.subscriptions.push(this.resizerService.onGridAfterResize.subscribe(() => this.renderPreHeaderRowGroupingTitles()), this.sharedService.onHeaderMenuHideColumns.subscribe(() => this.delayRenderPreHeaderRowGroupingTitles(0)));
                this._eventHandler.subscribe(grid.onSetOptions, (_e, args) => {
                    // when user changes frozen columns dynamically (e.g. from header menu), we need to re-render the pre-header of the grouping titles
                    if (args && args.optionsBefore && args.optionsAfter && args.optionsBefore.frozenColumn !== args.optionsAfter.frozenColumn) {
                        this.delayRenderPreHeaderRowGroupingTitles(0);
                    }
                });
                // for both picker (columnPicker/gridMenu) we also need to re-create after hiding/showing columns
                const columnPickerExtension = this.extensionService.getExtensionByName(ExtensionName.columnPicker);
                if (columnPickerExtension && columnPickerExtension.instance && columnPickerExtension.instance.onColumnsChanged) {
                    this._eventHandler.subscribe(columnPickerExtension.instance.onColumnsChanged, () => this.renderPreHeaderRowGroupingTitles());
                }
                const gridMenuExtension = this.extensionService.getExtensionByName(ExtensionName.gridMenu);
                if (gridMenuExtension && gridMenuExtension.instance && gridMenuExtension.instance.onColumnsChanged && gridMenuExtension.instance.onMenuClose) {
                    this._eventHandler.subscribe(gridMenuExtension.instance.onColumnsChanged, () => this.renderPreHeaderRowGroupingTitles());
                    this._eventHandler.subscribe(gridMenuExtension.instance.onMenuClose, () => this.renderPreHeaderRowGroupingTitles());
                }
                // also not sure why at this point, but it seems that I need to call the 1st create in a delayed execution
                // probably some kind of timing issues and delaying it until the grid is fully ready fixes this problem
                this.delayRenderPreHeaderRowGroupingTitles(50);
            }
        }
    }
    dispose() {
        // unsubscribe all SlickGrid events
        this._eventHandler.unsubscribeAll();
        // also unsubscribe all Angular Subscriptions
        this.subscriptions = unsubscribeAllObservables(this.subscriptions);
    }
    /** call "renderPreHeaderRowGroupingTitles()" with a setTimeout delay */
    delayRenderPreHeaderRowGroupingTitles(delay = 0) {
        setTimeout(() => this.renderPreHeaderRowGroupingTitles(), delay);
    }
    /** Create or Render the Pre-Header Row Grouping Titles */
    renderPreHeaderRowGroupingTitles() {
        var _a;
        if (this._gridOptions && this._gridOptions.frozenColumn !== undefined && this._gridOptions.frozenColumn >= 0) {
            // Add column groups to left panel
            let preHeaderPanelElm = this._grid.getPreHeaderPanelLeft();
            this.renderHeaderGroups(preHeaderPanelElm, 0, this._gridOptions.frozenColumn + 1);
            // Add column groups to right panel
            preHeaderPanelElm = this._grid.getPreHeaderPanelRight();
            this.renderHeaderGroups(preHeaderPanelElm, ((_a = this._gridOptions) === null || _a === void 0 ? void 0 : _a.frozenColumn) + 1, this._columnDefinitions.length);
        }
        else {
            // regular grid (not a frozen grid)
            const preHeaderPanelElm = this._grid.getPreHeaderPanel();
            this.renderHeaderGroups(preHeaderPanelElm, 0, this._columnDefinitions.length);
        }
    }
    renderHeaderGroups(preHeaderPanel, start, end) {
        var _a, _b, _c;
        emptyElement(preHeaderPanel);
        preHeaderPanel.className = 'slick-header-columns';
        preHeaderPanel.style.left = '-1000px';
        preHeaderPanel.style.width = `${this._grid.getHeadersWidth()}px`;
        if (preHeaderPanel.parentElement) {
            preHeaderPanel.parentElement.classList.add('slick-header');
        }
        const headerColumnWidthDiff = this._grid.getHeaderColumnWidthDiff();
        let colDef;
        let headerElm = null;
        let lastColumnGroup = '';
        let widthTotal = 0;
        const frozenHeaderWidthCalcDifferential = (_b = (_a = this._gridOptions) === null || _a === void 0 ? void 0 : _a.frozenHeaderWidthCalcDifferential) !== null && _b !== void 0 ? _b : 0;
        const isFrozenGrid = (((_c = this._gridOptions) === null || _c === void 0 ? void 0 : _c.frozenColumn) !== undefined && this._gridOptions.frozenColumn >= 0);
        for (let i = start; i < end; i++) {
            colDef = this._columnDefinitions[i];
            if (colDef) {
                if (lastColumnGroup === colDef.columnGroup && i > 0) {
                    widthTotal += colDef.width || 0;
                    if (headerElm === null || headerElm === void 0 ? void 0 : headerElm.style) {
                        headerElm.style.width = `${widthTotal - headerColumnWidthDiff - frozenHeaderWidthCalcDifferential}px`; // remove possible frozen border
                    }
                }
                else {
                    widthTotal = colDef.width || 0;
                    headerElm = document.createElement('div');
                    headerElm.className = `ui-state-default slick-header-column ${isFrozenGrid ? 'frozen' : ''}`;
                    headerElm.style.width = `${widthTotal - headerColumnWidthDiff}px`;
                    const spanColumnNameElm = document.createElement('span');
                    spanColumnNameElm.className = 'slick-column-name';
                    spanColumnNameElm.textContent = colDef.columnGroup || '';
                    headerElm.appendChild(spanColumnNameElm);
                    preHeaderPanel.appendChild(headerElm);
                }
                lastColumnGroup = colDef.columnGroup || '';
            }
        }
    }
    /** Translate Column Group texts and re-render them afterward. */
    translateGroupingAndColSpan() {
        const currentColumnDefinitions = this._grid.getColumns();
        this.extensionUtility.translateItems(currentColumnDefinitions, 'columnGroupKey', 'columnGroup');
        this._grid.setColumns(currentColumnDefinitions);
        this.renderPreHeaderRowGroupingTitles();
    }
}
GroupingAndColspanService.ɵfac = function GroupingAndColspanService_Factory(t) { return new (t || GroupingAndColspanService)(ɵngcc0.ɵɵinject(ExtensionUtility), ɵngcc0.ɵɵinject(ExtensionService), ɵngcc0.ɵɵinject(ResizerService), ɵngcc0.ɵɵinject(SharedService)); };
GroupingAndColspanService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: GroupingAndColspanService, factory: GroupingAndColspanService.ɵfac });
GroupingAndColspanService.ctorParameters = () => [
    { type: ExtensionUtility },
    { type: ExtensionService },
    { type: ResizerService },
    { type: SharedService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GroupingAndColspanService, [{
        type: Injectable
    }], function () { return [{ type: ExtensionUtility }, { type: ExtensionService }, { type: ResizerService }, { type: SharedService }]; }, null); })();

class PaginationService {
    /** Constructor */
    constructor(filterService, gridService, sharedService) {
        this.filterService = filterService;
        this.gridService = gridService;
        this.sharedService = sharedService;
        this._initialized = false;
        this._isLocalGrid = true;
        this._dataFrom = 1;
        this._dataTo = 1;
        this._itemsPerPage = 0;
        this._pageCount = 1;
        this._pageNumber = 1;
        this._totalItems = 0;
        this._availablePageSizes = [];
        this._eventHandler = new Slick.EventHandler();
        this._subscriptions = [];
        this.onPaginationChanged = new Subject();
        this.onPaginationVisibilityChanged = new Subject();
    }
    get paginationOptions() {
        return this._paginationOptions;
    }
    set paginationOptions(paginationOptions) {
        this._paginationOptions = paginationOptions;
    }
    get availablePageSizes() {
        return this._availablePageSizes || [];
    }
    get dataFrom() {
        return this._dataFrom;
    }
    get dataTo() {
        return this._dataTo;
    }
    get itemsPerPage() {
        return this._itemsPerPage;
    }
    get pageCount() {
        return this._pageCount;
    }
    get pageNumber() {
        return this._pageNumber;
    }
    set totalItems(totalItems) {
        this._totalItems = totalItems;
        if (this._initialized) {
            this.refreshPagination();
        }
    }
    get totalItems() {
        return this._totalItems;
    }
    init(grid, dataView, paginationOptions, backendServiceApi) {
        this._availablePageSizes = paginationOptions.pageSizes;
        this.dataView = dataView;
        this.grid = grid;
        this._backendServiceApi = backendServiceApi;
        this._paginationOptions = paginationOptions;
        this._isLocalGrid = !backendServiceApi;
        this._pageNumber = paginationOptions.pageNumber || 1;
        if (backendServiceApi && (!backendServiceApi.service || !backendServiceApi.process)) {
            throw new Error(`BackendServiceApi requires the following 2 properties "process" and "service" to be defined.`);
        }
        if (this._isLocalGrid && this.dataView) {
            this._eventHandler.subscribe(this.dataView.onPagingInfoChanged, (_e, pagingInfo) => {
                if (this._totalItems !== pagingInfo.totalRows) {
                    this.updateTotalItems(pagingInfo.totalRows);
                }
            });
            dataView.setRefreshHints({ isFilterUnchanged: true });
            dataView.setPagingOptions({ pageSize: this.paginationOptions.pageSize, pageNum: (this._pageNumber - 1) }); // dataView page starts at 0 instead of 1
        }
        // Subscribe to Filter Clear & Changed and go back to page 1 when that happen
        this._subscriptions.push(this.filterService.onFilterChanged.subscribe(() => this.resetPagination()));
        this._subscriptions.push(this.filterService.onFilterCleared.subscribe(() => this.resetPagination()));
        // Subscribe to any dataview row count changed so that when Adding/Deleting item(s) through the DataView
        // that would trigger a refresh of the pagination numbers
        if (this.dataView) {
            this._subscriptions.push(this.gridService.onItemAdded.subscribe((items) => this.processOnItemAddedOrRemoved(items, true)));
            this._subscriptions.push(this.gridService.onItemDeleted.subscribe((items) => this.processOnItemAddedOrRemoved(items, false)));
        }
        this.refreshPagination(false, false);
        this._initialized = true;
    }
    dispose() {
        this._initialized = false;
        // unsubscribe all SlickGrid events
        this._eventHandler.unsubscribeAll();
        // also unsubscribe all Angular Subscriptions
        this._subscriptions = unsubscribeAllObservables(this._subscriptions);
    }
    getCurrentPageNumber() {
        return this._pageNumber;
    }
    getCurrentPagination() {
        return {
            pageNumber: this._pageNumber,
            pageSize: this._itemsPerPage,
            pageSizes: this._availablePageSizes,
        };
    }
    getFullPagination() {
        return {
            pageCount: this._pageCount,
            pageNumber: this._pageNumber,
            pageSize: this._itemsPerPage,
            pageSizes: this._availablePageSizes,
            totalItems: this._totalItems,
            dataFrom: this._dataFrom,
            dataTo: this._dataTo,
        };
    }
    getCurrentItemPerPage() {
        return this._itemsPerPage;
    }
    changeItemPerPage(itemsPerPage, event) {
        this._pageNumber = 1;
        this._pageCount = Math.ceil(this._totalItems / itemsPerPage);
        this._itemsPerPage = itemsPerPage;
        return this.processOnPageChanged(this._pageNumber, event);
    }
    goToFirstPage(event) {
        this._pageNumber = 1;
        return this.processOnPageChanged(this._pageNumber, event);
    }
    goToLastPage(event) {
        this._pageNumber = this._pageCount || 1;
        return this.processOnPageChanged(this._pageNumber, event);
    }
    goToNextPage(event) {
        if (this._pageNumber < this._pageCount) {
            this._pageNumber++;
            return this.processOnPageChanged(this._pageNumber, event);
        }
        else {
            return new Promise(resolve => resolve(false));
        }
    }
    goToPageNumber(pageNumber, event) {
        const previousPageNumber = this._pageNumber;
        if (pageNumber < 1) {
            this._pageNumber = 1;
        }
        else if (pageNumber > this._pageCount) {
            this._pageNumber = this._pageCount;
        }
        else {
            this._pageNumber = pageNumber;
        }
        if (this._pageNumber !== previousPageNumber) {
            return this.processOnPageChanged(this._pageNumber, event);
        }
        else {
            return new Promise(resolve => resolve(false));
        }
    }
    goToPreviousPage(event) {
        if (this._pageNumber > 1) {
            this._pageNumber--;
            return this.processOnPageChanged(this._pageNumber, event);
        }
        else {
            return new Promise(resolve => resolve(false));
        }
    }
    refreshPagination(isPageNumberReset = false, triggerChangedEvent = true) {
        const previousPagination = Object.assign({}, this.getCurrentPagination());
        if (this._paginationOptions) {
            const pagination = this._paginationOptions;
            // set the number of items per page if not already set
            if (!this._itemsPerPage) {
                if (this._isLocalGrid) {
                    this._itemsPerPage = pagination.pageSize;
                }
                else {
                    this._itemsPerPage = +((this._backendServiceApi && this._backendServiceApi.options && this._backendServiceApi.options.paginationOptions && this._backendServiceApi.options.paginationOptions.first) ? this._backendServiceApi.options.paginationOptions.first : pagination.pageSize);
                }
            }
            // if totalItems changed, we should always go back to the first page and recalculation the From-To indexes
            if (isPageNumberReset || this._totalItems !== pagination.totalItems) {
                if (isPageNumberReset) {
                    this._pageNumber = 1;
                    this.paginationOptions.pageNumber = 1;
                }
                else if (!this._initialized && pagination.pageNumber && pagination.pageNumber > 1) {
                    this._pageNumber = pagination.pageNumber || 1;
                }
                // when page number is set to 1 then also reset the "offset" of backend service
                if (this._pageNumber === 1 && this._backendServiceApi) {
                    this._backendServiceApi.service.resetPaginationOptions();
                }
            }
            // calculate and refresh the multiple properties of the pagination UI
            this._availablePageSizes = pagination.pageSizes;
            if (!this._totalItems && pagination.totalItems) {
                this._totalItems = pagination.totalItems;
            }
            this.recalculateFromToIndexes();
        }
        this._pageCount = Math.ceil(this._totalItems / this._itemsPerPage);
        const currentPagination = this.getCurrentPagination();
        this.sharedService.currentPagination = currentPagination;
        if (triggerChangedEvent && !dequal(previousPagination, currentPagination)) {
            this.onPaginationChanged.next(currentPagination);
        }
    }
    processOnPageChanged(pageNumber, event) {
        return new Promise((resolve, reject) => {
            this.recalculateFromToIndexes();
            if (this._isLocalGrid && this.dataView) {
                this.dataView.setPagingOptions({ pageSize: this._itemsPerPage, pageNum: (pageNumber - 1) }); // dataView page starts at 0 instead of 1
                this.onPaginationChanged.next(this.getFullPagination());
            }
            else {
                const itemsPerPage = +this._itemsPerPage;
                // keep start time & end timestamps & return it after process execution
                const startTime = new Date();
                // run any pre-process, if defined, for example a spinner
                if (this._backendServiceApi && this._backendServiceApi.preProcess) {
                    this._backendServiceApi.preProcess();
                }
                const query = this._backendServiceApi && this._backendServiceApi.service.processOnPaginationChanged(event, { newPage: pageNumber, pageSize: itemsPerPage }) || '';
                // the processes can be Promises or an Observables (like HttpClient)
                const process = this._backendServiceApi && this._backendServiceApi.process(query);
                if (process instanceof Promise) {
                    process
                        .then((processResult) => {
                        resolve(executeBackendProcessesCallback(startTime, processResult, this._backendServiceApi, this._totalItems));
                    })
                        .catch((error) => {
                        onBackendError(error, this._backendServiceApi);
                        reject(process);
                    });
                }
                else if (isObservable(process)) {
                    this._subscriptions.push(process.subscribe((processResult) => {
                        resolve(executeBackendProcessesCallback(startTime, processResult, this._backendServiceApi, this._totalItems));
                    }, (error) => {
                        onBackendError(error, this._backendServiceApi);
                        reject(process);
                    }));
                }
                this.onPaginationChanged.next(this.getFullPagination());
            }
        });
    }
    recalculateFromToIndexes() {
        if (this._totalItems === 0) {
            this._dataFrom = 0;
            this._dataTo = 1;
            this._pageNumber = 0;
        }
        else {
            this._dataFrom = this._pageNumber > 1 ? ((this._pageNumber * this._itemsPerPage) - this._itemsPerPage + 1) : 1;
            this._dataTo = (this._totalItems < this._itemsPerPage) ? this._totalItems : ((this._pageNumber || 1) * this._itemsPerPage);
            if (this._dataTo > this._totalItems) {
                this._dataTo = this._totalItems;
            }
        }
        this._pageNumber = (this._totalItems > 0 && this._pageNumber === 0) ? 1 : this._pageNumber;
        // do a final check on the From/To and make sure they are not over or below min/max acceptable values
        if (this._dataTo > this._totalItems) {
            this._dataTo = this._totalItems;
        }
        else if (this._totalItems < this._itemsPerPage) {
            this._dataTo = this._totalItems;
        }
    }
    /** Reset the Pagination to first page and recalculate necessary numbers */
    resetPagination(triggerChangedEvent = true) {
        var _a, _b;
        if (this._isLocalGrid && this.dataView && ((_b = (_a = this.sharedService) === null || _a === void 0 ? void 0 : _a.gridOptions) === null || _b === void 0 ? void 0 : _b.enablePagination)) {
            // on a local grid we also need to reset the DataView paging to 1st page
            this.dataView.setPagingOptions({ pageSize: this._itemsPerPage, pageNum: 0 });
        }
        this.refreshPagination(true, triggerChangedEvent);
    }
    /**
     * Toggle the Pagination (show/hide), it will use the visible if defined else it will automatically inverse when called without argument
     *
     * IMPORTANT NOTE:
     * The Pagination must be created on initial page load, then only after can you toggle it.
     * Basically this method WILL NOT WORK to show the Pagination if it was never created from the start.
     */
    togglePaginationVisibility(visible) {
        if (this.grid && this.sharedService && this.sharedService.gridOptions) {
            const isVisible = visible !== undefined ? visible : !this.sharedService.gridOptions.enablePagination;
            // make sure to reset the Pagination and go back to first page to avoid any issues with Pagination being offset
            if (isVisible) {
                this.goToFirstPage();
            }
            // when using a local grid, we can reset the DataView pagination by changing its page size
            // page size of 0 would show all, hence cancel the pagination
            if (this._isLocalGrid) {
                const pageSize = visible ? this._itemsPerPage : 0;
                this.dataView.setPagingOptions({ pageSize, pageNum: 0 });
            }
            // finally toggle the "enablePagination" flag and make sure it happens AFTER the setPagingOptions is called (when using local grid)
            // to avoid conflict with GridState bindSlickGridRowSelectionToGridStateChange() method
            this.onPaginationVisibilityChanged.next({ visible: isVisible });
            this.sharedService.gridOptions.enablePagination = isVisible;
        }
    }
    // --
    // private functions
    // --------------------
    updateTotalItems(totalItems, triggerChangedEvent = false) {
        this._totalItems = totalItems;
        if (this._paginationOptions) {
            this._paginationOptions.totalItems = totalItems;
            this.refreshPagination(false, triggerChangedEvent);
        }
    }
    /**
     * When item is added or removed, we will refresh the numbers on the pagination however we won't trigger a backend change
     * This will have a side effect though, which is that the "To" count won't be matching the "items per page" count,
     * that is a necessary side effect to avoid triggering a backend query just to refresh the paging,
     * basically we assume that this offset is fine for the time being,
     * until user does an action which will refresh the data hence the pagination which will then become normal again
     */
    processOnItemAddedOrRemoved(items, isItemAdded = true) {
        if (items !== null) {
            const previousDataTo = this._dataTo;
            const itemCount = Array.isArray(items) ? items.length : 1;
            const itemCountWithDirection = isItemAdded ? +itemCount : -itemCount;
            // refresh the total count in the pagination and in the UI
            this._totalItems += itemCountWithDirection;
            this.recalculateFromToIndexes();
            // finally refresh the "To" count and we know it might be different than the "items per page" count
            // but this is necessary since we don't want an actual backend refresh
            this._dataTo = previousDataTo + itemCountWithDirection;
            this.onPaginationChanged.next(this.getFullPagination());
        }
    }
}
PaginationService.ɵfac = function PaginationService_Factory(t) { return new (t || PaginationService)(ɵngcc0.ɵɵinject(FilterService), ɵngcc0.ɵɵinject(GridService), ɵngcc0.ɵɵinject(SharedService)); };
PaginationService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: PaginationService, factory: PaginationService.ɵfac });
PaginationService.ctorParameters = () => [
    { type: FilterService },
    { type: GridService },
    { type: SharedService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PaginationService, [{
        type: Injectable
    }], function () { return [{ type: FilterService }, { type: GridService }, { type: SharedService }]; }, null); })();

class AvgAggregator {
    constructor(field) {
        this._nonNullCount = 0;
        this._sum = 0;
        this._field = field;
    }
    init() {
        this._nonNullCount = 0;
        this._sum = 0;
    }
    accumulate(item) {
        const val = (item && item.hasOwnProperty(this._field)) ? item[this._field] : null;
        if (val !== null && val !== undefined && val !== '' && !isNaN(val)) {
            this._nonNullCount++;
            this._sum += parseFloat(val);
        }
    }
    storeResult(groupTotals) {
        if (!groupTotals || groupTotals.avg === undefined) {
            groupTotals.avg = {};
        }
        if (this._nonNullCount !== 0) {
            groupTotals.avg[this._field] = this._sum / this._nonNullCount;
        }
    }
}

class MinAggregator {
    constructor(field) {
        this._min = null;
        this._field = field;
    }
    init() {
        this._min = null;
    }
    accumulate(item) {
        const val = (item && item.hasOwnProperty(this._field)) ? item[this._field] : null;
        if (val !== null && val !== undefined && val !== '' && !isNaN(val)) {
            if (this._min === null || this._min === undefined || val < this._min) {
                this._min = parseFloat(val);
            }
        }
    }
    storeResult(groupTotals) {
        if (!groupTotals || groupTotals.min === undefined) {
            groupTotals.min = {};
        }
        groupTotals.min[this._field] = this._min;
    }
}

class MaxAggregator {
    constructor(field) {
        this._max = null;
        this._field = field;
    }
    init() {
        this._max = null;
    }
    accumulate(item) {
        const val = (item && item.hasOwnProperty(this._field)) ? item[this._field] : null;
        if (val !== null && val !== undefined && val !== '' && !isNaN(val)) {
            if (this._max === null || this._max === undefined || val > this._max) {
                this._max = parseFloat(val);
            }
        }
    }
    storeResult(groupTotals) {
        if (!groupTotals || groupTotals.max === undefined) {
            groupTotals.max = {};
        }
        groupTotals.max[this._field] = this._max;
    }
}

class SumAggregator {
    constructor(field) {
        this._sum = 0;
        this._field = field;
    }
    init() {
        this._sum = 0;
    }
    accumulate(item) {
        const val = (item && item.hasOwnProperty(this._field)) ? item[this._field] : null;
        if (val !== null && val !== undefined && val !== '' && !isNaN(val)) {
            this._sum += parseFloat(val);
        }
    }
    storeResult(groupTotals) {
        if (!groupTotals || groupTotals.sum === undefined) {
            groupTotals.sum = {};
        }
        groupTotals.sum[this._field] = this._sum;
    }
}

/** Provides a list of different Aggregators for the Group Formatter */
const Aggregators = {
    Avg: AvgAggregator,
    Min: MinAggregator,
    Max: MaxAggregator,
    Sum: SumAggregator
};

function textValidator(inputValue, options) {
    const errorMsg = options.errorMessage;
    const isRequired = options.required;
    const minLength = options.minLength;
    const maxLength = options.maxLength;
    const operatorConditionalType = options.operatorConditionalType || 'inclusive';
    const mapValidation = {
        '{{minLength}}': minLength,
        '{{maxLength}}': maxLength
    };
    let isValid = true;
    let outputMsg = '';
    const inputValueLength = inputValue && inputValue.length || 0;
    if (options.validator) {
        return options.validator(inputValue, options.editorArgs);
    }
    // by default the editor is almost always valid (except when it's required but not provided)
    if (isRequired && inputValue === '') {
        isValid = false;
        outputMsg = errorMsg || Constants.VALIDATION_REQUIRED_FIELD;
    }
    else if (minLength !== undefined && maxLength !== undefined && ((operatorConditionalType === 'exclusive' && (inputValueLength <= minLength || inputValueLength >= maxLength)) || (operatorConditionalType === 'inclusive' && (inputValueLength < minLength || inputValueLength > maxLength)))) {
        // MIN & MAX Length provided
        // make sure text length is between minLength and maxLength
        isValid = false;
        outputMsg = errorMsg || Constants.VALIDATION_EDITOR_TEXT_LENGTH_BETWEEN.replace(/{{minLength}}|{{maxLength}}/gi, (matched) => mapValidation[matched]);
    }
    else if (minLength !== undefined && inputValueLength !== null && ((operatorConditionalType === 'exclusive' && inputValueLength <= minLength) || (operatorConditionalType === 'inclusive' && inputValueLength !== null && inputValueLength < minLength))) {
        // MIN Length ONLY
        // when text length is shorter than minLength
        isValid = false;
        const defaultErrorMsg = operatorConditionalType === 'inclusive' ? Constants.VALIDATION_EDITOR_TEXT_MIN_LENGTH_INCLUSIVE : Constants.VALIDATION_EDITOR_TEXT_MIN_LENGTH;
        outputMsg = errorMsg || defaultErrorMsg.replace(/{{minLength}}/gi, (matched) => mapValidation[matched]);
    }
    else if (maxLength !== undefined && inputValueLength !== null && ((operatorConditionalType === 'exclusive' && inputValueLength >= maxLength) || (operatorConditionalType === 'inclusive' && inputValueLength !== null && inputValueLength > maxLength))) {
        // MAX Length ONLY
        // when text length is longer than minLength
        isValid = false;
        const defaultErrorMsg = operatorConditionalType === 'inclusive' ? Constants.VALIDATION_EDITOR_TEXT_MAX_LENGTH_INCLUSIVE : Constants.VALIDATION_EDITOR_TEXT_MAX_LENGTH;
        outputMsg = errorMsg || defaultErrorMsg.replace(/{{maxLength}}/gi, (matched) => mapValidation[matched]);
    }
    return { valid: isValid, msg: outputMsg };
}

const DOMPurify$2 = DOMPurify_; // patch to fix rollup to work
// minimum length of chars to type before starting to start querying
const MIN_LENGTH = 3;
/*
 * An example of a 'detached' editor.
 * KeyDown events are also handled to provide handling for Tab, Shift-Tab, Esc and Ctrl-Enter.
 */
class AutoCompleteEditor {
    constructor(args) {
        this.args = args;
        this._defaultTextValue = '';
        this._elementCollection = null;
        if (!args) {
            throw new Error('[Angular-SlickGrid] Something is wrong with this grid, an Editor must always have valid arguments.');
        }
        this.grid = args.grid;
        this.init();
    }
    /** Getter for the Autocomplete Option */
    get autoCompleteOptions() {
        return this._autoCompleteOptions || {};
    }
    /** Get the Collection */
    get editorCollection() {
        return this.columnDef && this.columnDef.internalColumnEditor && this.columnDef.internalColumnEditor.collection || [];
    }
    /** Get the Final Collection used in the AutoCompleted Source (this may vary from the "collection" especially when providing a customStructure) */
    get elementCollection() {
        return this._elementCollection;
    }
    /** Get Column Definition object */
    get columnDef() {
        return this.args.column;
    }
    /** Get Column Editor object */
    get columnEditor() {
        return this.columnDef && this.columnDef.internalColumnEditor || {};
    }
    /** Getter for the Custom Structure if exist */
    get customStructure() {
        let customStructure = this.columnEditor && this.columnEditor.customStructure;
        const columnType = this.columnEditor && this.columnEditor.type || this.columnDef && this.columnDef.type;
        if (!customStructure && (columnType === FieldType.object && this.columnDef && this.columnDef.dataKey && this.columnDef.labelKey)) {
            customStructure = {
                label: this.columnDef.labelKey,
                value: this.columnDef.dataKey,
            };
        }
        return customStructure;
    }
    get hasAutoCommitEdit() {
        var _a;
        return (_a = this.gridOptions.autoCommitEdit) !== null && _a !== void 0 ? _a : false;
    }
    /** Get the Validator function, can be passed in Editor property or Column Definition */
    get validator() {
        return this.columnEditor.validator || this.columnDef.validator;
    }
    get editorOptions() {
        return this.columnEditor && this.columnEditor.editorOptions || {};
    }
    /** jQuery UI AutoComplete instance */
    get instance() {
        return this._$editorElm.autocomplete('instance');
    }
    /** Getter for the Grid Options pulled through the Grid Object */
    get gridOptions() {
        return (this.grid && this.grid.getOptions) ? this.grid.getOptions() : {};
    }
    /** Get the Editor DOM Element */
    get editorDomElement() {
        return this._$editorElm;
    }
    init() {
        this.labelName = this.customStructure && this.customStructure.label || 'label';
        this.valueName = this.customStructure && this.customStructure.value || 'value';
        this.labelPrefixName = this.customStructure && this.customStructure.labelPrefix || 'labelPrefix';
        this.labelSuffixName = this.customStructure && this.customStructure.labelSuffix || 'labelSuffix';
        // always render the DOM element, even if user passed a "collectionAsync",
        const newCollection = this.columnEditor.collection || [];
        this.renderDomElement(newCollection);
    }
    destroy() {
        if (this._$editorElm) {
            this._$editorElm.autocomplete('destroy');
            this._$editorElm.off('keydown.nav').remove();
        }
        this._$editorElm = null;
        this._elementCollection = null;
    }
    focus() {
        if (this._$editorElm) {
            this._$editorElm.focus().select();
        }
    }
    getValue() {
        return this._$editorElm.val();
    }
    setValue(value) {
        this._$editorElm.val(value);
    }
    applyValue(item, state) {
        let newValue = state;
        const fieldName = this.columnDef && this.columnDef.field;
        // if we have a collection defined, we will try to find the string within the collection and return it
        if (Array.isArray(this.editorCollection) && this.editorCollection.length > 0) {
            newValue = findOrDefault(this.editorCollection, (collectionItem) => {
                if (collectionItem && typeof state === 'object' && collectionItem.hasOwnProperty(this.labelName)) {
                    return (collectionItem.hasOwnProperty(this.labelName) && collectionItem[this.labelName].toString()) === (state.hasOwnProperty(this.labelName) && state[this.labelName].toString());
                }
                else if (collectionItem && typeof state === 'string' && collectionItem.hasOwnProperty(this.labelName)) {
                    return (collectionItem.hasOwnProperty(this.labelName) && collectionItem[this.labelName].toString()) === state;
                }
                return collectionItem && collectionItem.toString() === state;
            });
        }
        // is the field a complex object, "address.streetNumber"
        const isComplexObject = fieldName && fieldName.indexOf('.') > 0;
        // validate the value before applying it (if not valid we'll set an empty string)
        const validation = this.validate(newValue);
        newValue = (validation && validation.valid) ? newValue : '';
        // set the new value to the item datacontext
        if (isComplexObject) {
            setDeepValue(item, fieldName, newValue);
        }
        else {
            item[fieldName] = newValue;
        }
    }
    isValueChanged() {
        const elmValue = this._$editorElm.val();
        const lastKeyEvent = this._lastInputEvent && this._lastInputEvent.keyCode;
        if (this.columnEditor && this.columnEditor.alwaysSaveOnEnterKey && lastKeyEvent === KeyCode.ENTER) {
            return true;
        }
        return (!(elmValue === '' && (this._defaultTextValue === null || this._defaultTextValue === undefined))) && (elmValue !== this._defaultTextValue);
    }
    loadValue(item) {
        const fieldName = this.columnDef && this.columnDef.field;
        if (item && fieldName !== undefined) {
            // is the field a complex object, "address.streetNumber"
            const isComplexObject = fieldName && fieldName.indexOf('.') > 0;
            const data = (isComplexObject) ? getDescendantProperty(item, fieldName) : item[fieldName];
            this._currentValue = data;
            this._defaultTextValue = typeof data === 'string' ? data : (data && data.hasOwnProperty(this.labelName) && data[this.labelName] || '');
            this._$editorElm.val(this._defaultTextValue);
            this._$editorElm.select();
        }
    }
    save() {
        const validation = this.validate();
        const isValid = (validation && validation.valid) || false;
        if (this.hasAutoCommitEdit && isValid) {
            // do not use args.commitChanges() as this sets the focus to the next row.
            // also the select list will stay shown when clicking off the grid
            this.grid.getEditorLock().commitCurrentEdit();
        }
        else {
            this.args.commitChanges();
        }
    }
    serializeValue() {
        // if you want to add the autocomplete functionality but want the user to be able to input a new option
        if (this.editorOptions.forceUserInput) {
            const minLength = this.editorOptions && this.editorOptions.hasOwnProperty('minLength') ? this.editorOptions.minLength : MIN_LENGTH;
            this._currentValue = this._$editorElm.val().length > minLength ? this._$editorElm.val() : this._currentValue;
        }
        // if user provided a custom structure, we will serialize the value returned from the object with custom structure
        if (this.customStructure && this._currentValue && this._currentValue.hasOwnProperty(this.valueName) && (this.columnDef && this.columnDef.type !== FieldType.object && this.columnEditor && this.columnEditor.type !== FieldType.object)) {
            return this._currentValue[this.valueName];
        }
        else if (this._currentValue && this._currentValue.value !== undefined) {
            // when object has a "value" property and its column is set as an Object type, we'll return an object with optional custom structure
            if (this.columnDef && this.columnDef.type === FieldType.object || ((this.columnEditor && this.columnEditor.type) === FieldType.object)) {
                return {
                    [this.labelName]: this._currentValue.label,
                    [this.valueName]: this._currentValue.value
                };
            }
            return this._currentValue.value;
        }
        // if it falls here it might be that the user provided its own custom item with something else than the regular label/value pair
        // at this point it's only available when user provide a custom template for the autocomplete renderItem callback
        return this._currentValue;
    }
    validate(inputValue) {
        const val = (inputValue !== undefined) ? inputValue : this._$editorElm && this._$editorElm.val && this._$editorElm.val();
        return textValidator(val, {
            editorArgs: this.args,
            errorMessage: this.columnEditor.errorMessage,
            minLength: this.columnEditor.minLength,
            maxLength: this.columnEditor.maxLength,
            operatorConditionalType: this.columnEditor.operatorConditionalType,
            required: this.columnEditor.required,
            validator: this.validator,
        });
    }
    //
    // protected functions
    // ------------------
    // this function should be protected but for unit tests purposes we'll make it public until a better solution is found
    // a better solution would be to get the autocomplete DOM element to work with selection but I couldn't find how to do that in Jest
    handleSelect(event, ui) {
        if (ui && ui.item) {
            const item = ui && ui.item;
            this._currentValue = item;
            // when the user defines a "renderItem" (or "_renderItem") template, then we assume the user defines his own custom structure of label/value pair
            // otherwise we know that jQueryUI always require a label/value pair, we can pull them directly
            const hasCustomRenderItemCallback = this.columnEditor && this.columnEditor.callbacks && this.columnEditor.callbacks.hasOwnProperty('_renderItem') || (this.columnEditor && this.columnEditor.editorOptions && this.columnEditor.editorOptions.renderItem) || false;
            const itemLabel = typeof item === 'string' ? item : (hasCustomRenderItemCallback ? item[this.labelName] : item.label);
            this.setValue(itemLabel);
            this.save();
            // if user wants to hook to the "select", he can do via this "onSelect"
            // it purposely has a similar signature as the "select" callback + some extra arguments (row, cell, column, dataContext)
            if (this.editorOptions.onSelect) {
                const activeCell = this.grid && this.grid.getActiveCell() || {};
                this.editorOptions.onSelect(event, ui, activeCell.row, activeCell.cell, this.args.column, this.args.item);
            }
        }
        return false;
    }
    renderCustomItem(ul, item) {
        const templateString = this._autoCompleteOptions && this._autoCompleteOptions.renderItem && this._autoCompleteOptions.renderItem.templateCallback(item) || '';
        // sanitize any unauthorized html tags like script and others
        // for the remaining allowed tags we'll permit all attributes
        const sanitizedTemplateText = (DOMPurify$2.sanitize(templateString, {}) || '').toString();
        return $('<li></li>')
            .data('item.autocomplete', item)
            .append(sanitizedTemplateText)
            .appendTo(ul);
    }
    renderCollectionItem(ul, item) {
        const isRenderHtmlEnabled = this.columnEditor && this.columnEditor.enableRenderHtml || false;
        const prefixText = item.labelPrefix || '';
        const labelText = item.label || '';
        const suffixText = item.labelSuffix || '';
        const finalText = prefixText + labelText + suffixText;
        // sanitize any unauthorized html tags like script and others
        // for the remaining allowed tags we'll permit all attributes
        const sanitizedText = (DOMPurify$2.sanitize(finalText, {}) || '').toString();
        const $liDiv = $('<div></div>')[isRenderHtmlEnabled ? 'html' : 'text'](sanitizedText);
        return $('<li></li>')
            .data('item.autocomplete', item)
            .append($liDiv)
            .appendTo(ul);
    }
    renderDomElement(collection) {
        if (!Array.isArray(collection)) {
            throw new Error('The "collection" passed to the Autocomplete Editor is not a valid array.');
        }
        const columnId = this.columnDef && this.columnDef.id || '';
        const placeholder = this.columnEditor && this.columnEditor.placeholder || '';
        const title = this.columnEditor && this.columnEditor.title || '';
        this._$editorElm = $(`<input type="text" role="presentation" autocomplete="off" class="autocomplete editor-text editor-${columnId}" placeholder="${placeholder}" title="${title}" />`)
            .appendTo(this.args.container)
            .on('keydown.nav', (event) => {
            this._lastInputEvent = event;
            if (event.keyCode === KeyCode.LEFT || event.keyCode === KeyCode.RIGHT) {
                event.stopImmediatePropagation();
            }
        });
        // add a <span> in order to add spinner styling
        $(`<span></span>`).appendTo(this.args.container);
        // user might pass his own autocomplete options
        const autoCompleteOptions = this.columnEditor.editorOptions;
        // assign the collection to a temp variable before filtering/sorting the collection
        let finalCollection = collection;
        // user could also override the collection
        if (this.columnEditor && this.columnEditor.collectionOverride) {
            finalCollection = this.columnEditor.collectionOverride(finalCollection, { column: this.columnDef, dataContext: this.args.item, grid: this.grid });
        }
        // user might provide his own custom structure
        // jQuery UI autocomplete requires a label/value pair, so we must remap them when user provide different ones
        if (Array.isArray(finalCollection)) {
            finalCollection = finalCollection.map((item) => {
                return { label: item[this.labelName], value: item[this.valueName], labelPrefix: item[this.labelPrefixName] || '', labelSuffix: item[this.labelSuffixName] || '' };
            });
        }
        // keep the final source collection used in the AutoComplete as reference
        this._elementCollection = finalCollection;
        // when user passes it's own autocomplete options
        // we still need to provide our own "select" callback implementation
        if (autoCompleteOptions && autoCompleteOptions.source) {
            autoCompleteOptions.select = (event, ui) => this.handleSelect(event, ui);
            this._autoCompleteOptions = Object.assign({}, autoCompleteOptions);
            // when "renderItem" is defined, we need to add our custom style CSS class
            if (this._autoCompleteOptions.renderItem) {
                this._autoCompleteOptions.classes = {
                    'ui-autocomplete': `autocomplete-custom-${toKebabCase(this._autoCompleteOptions.renderItem.layout)}`
                };
            }
            // create the jQueryUI AutoComplete
            this._$editorElm.autocomplete(this._autoCompleteOptions);
            // when "renderItem" is defined, we need to call the user's custom renderItem template callback
            if (this._autoCompleteOptions.renderItem) {
                this._$editorElm.autocomplete('instance')._renderItem = this.renderCustomItem.bind(this);
            }
        }
        else {
            const definedOptions = {
                source: finalCollection,
                minLength: 0,
                select: (event, ui) => this.handleSelect(event, ui),
            };
            this._autoCompleteOptions = Object.assign(Object.assign({}, definedOptions), this.columnEditor.editorOptions);
            this._$editorElm.autocomplete(this._autoCompleteOptions);
            // we'll use our own renderer so that it works with label prefix/suffix and also with html rendering when enabled
            this._$editorElm.autocomplete('instance')._renderItem = this.renderCollectionItem.bind(this);
        }
        // in case the user wants to save even an empty value,
        // we need to subscribe to the onKeyDown event for that use case and clear the current value
        if (this.columnEditor.alwaysSaveOnEnterKey) {
            this._$editorElm.keydown((event) => {
                if (event.keyCode === KeyCode.ENTER) {
                    this._currentValue = null;
                }
            });
        }
        // we could optionally trigger a search when clicking on the AutoComplete
        if (this.editorOptions.openSearchListOnFocus) {
            this._$editorElm.click(() => this._$editorElm.autocomplete('search', this._$editorElm.val()));
        }
        // user might override any of the jQueryUI callback methods
        if (this.columnEditor.callbacks) {
            for (const callback of Object.keys(this.columnEditor.callbacks)) {
                if (typeof this.columnEditor.callbacks[callback] === 'function') {
                    this.instance[callback] = this.columnEditor.callbacks[callback];
                }
            }
        }
        this._$editorElm.on('focus', () => {
            this._$editorElm.select();
            // we could optionally trigger a search to open the AutoComplete search list
            if (this.editorOptions.openSearchListOnFocus) {
                this._$editorElm.autocomplete('search', this._$editorElm.val());
            }
        });
        setTimeout(() => this.focus(), 50);
    }
}

/*
 * An example of a 'detached' editor.
 * KeyDown events are also handled to provide handling for Tab, Shift-Tab, Esc and Ctrl-Enter.
 */
class CheckboxEditor {
    constructor(args) {
        this.args = args;
        if (!args) {
            throw new Error('[Angular-SlickGrid] Something is wrong with this grid, an Editor must always have valid arguments.');
        }
        this.grid = args.grid;
        this.gridOptions = (this.grid.getOptions() || {});
        this._bindEventService = new BindingEventService();
        this.init();
    }
    /** Get Column Definition object */
    get columnDef() {
        return this.args.column;
    }
    /** Get Column Editor object */
    get columnEditor() {
        return this.columnDef && this.columnDef.internalColumnEditor || {};
    }
    /** Getter for the Editor DOM Element */
    get editorDomElement() {
        return this._input;
    }
    get hasAutoCommitEdit() {
        var _a;
        return (_a = this.gridOptions.autoCommitEdit) !== null && _a !== void 0 ? _a : false;
    }
    /** Get the Validator function, can be passed in Editor property or Column Definition */
    get validator() {
        var _a, _b, _c;
        return (_b = (_a = this.columnEditor) === null || _a === void 0 ? void 0 : _a.validator) !== null && _b !== void 0 ? _b : (_c = this.columnDef) === null || _c === void 0 ? void 0 : _c.validator;
    }
    init() {
        var _a, _b, _c, _d, _e;
        const columnId = (_b = (_a = this.columnDef) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '';
        const title = (_d = (_c = this.columnEditor) === null || _c === void 0 ? void 0 : _c.title) !== null && _d !== void 0 ? _d : '';
        this._checkboxContainerElm = document.createElement('div');
        this._checkboxContainerElm.className = `checkbox-editor-container editor-${columnId}`;
        this._input = document.createElement('input');
        this._input.className = `editor-checkbox editor-${columnId}`;
        this._input.title = title;
        this._input.type = 'checkbox';
        this._input.value = 'true';
        const cellContainer = (_e = this.args) === null || _e === void 0 ? void 0 : _e.container;
        if (cellContainer && typeof cellContainer.appendChild === 'function') {
            cellContainer.appendChild(this._input);
        }
        // make the checkbox editor act like a regular checkbox that commit the value on click
        if (this.hasAutoCommitEdit) {
            this._bindEventService.bind(this._input, 'click', () => this.save());
        }
        this.focus();
    }
    destroy() {
        var _a, _b;
        this._bindEventService.unbindAll();
        (_b = (_a = this._input) === null || _a === void 0 ? void 0 : _a.remove) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
    focus() {
        if (this._input) {
            this._input.focus();
        }
    }
    /** pre-click, when enabled, will simply toggle the checkbox without requiring to double-click */
    preClick() {
        if (this._input) {
            this._input.checked = !this._input.checked;
        }
    }
    getValue() {
        var _a, _b;
        return (_b = (_a = this._input) === null || _a === void 0 ? void 0 : _a.checked) !== null && _b !== void 0 ? _b : false;
    }
    setValue(val) {
        const isChecked = val ? true : false;
        if (this._input) {
            this._input.checked = isChecked;
        }
    }
    applyValue(item, state) {
        var _a, _b, _c;
        const fieldName = this.columnDef && this.columnDef.field;
        if (fieldName !== undefined) {
            const isComplexObject = (fieldName === null || fieldName === void 0 ? void 0 : fieldName.indexOf('.')) > 0; // is the field a complex object, "address.streetNumber"
            // validate the value before applying it (if not valid we'll set an empty string)
            const validation = this.validate(state);
            const newValue = (validation && validation.valid) ? state : '';
            // set the new value to the item datacontext
            if (isComplexObject) { // when it's a complex object, user could override the object path (where the editable object is located)
                // else we use the path provided in the Field Column Definition
                const objectPath = (_c = (_b = (_a = this.columnEditor) === null || _a === void 0 ? void 0 : _a.complexObjectPath) !== null && _b !== void 0 ? _b : fieldName) !== null && _c !== void 0 ? _c : '';
                setDeepValue(item, objectPath, newValue);
            }
            else {
                item[fieldName] = newValue;
            }
        }
    }
    isValueChanged() {
        return (this.serializeValue() !== this._originalValue);
    }
    loadValue(item) {
        const fieldName = this.columnDef && this.columnDef.field;
        if (item && fieldName !== undefined && this._input) {
            // is the field a complex object, "address.streetNumber"
            const isComplexObject = (fieldName === null || fieldName === void 0 ? void 0 : fieldName.indexOf('.')) > 0;
            const value = (isComplexObject) ? getDescendantProperty(item, fieldName) : item[fieldName];
            this._originalValue = value;
            this._input.checked = !!this._originalValue;
        }
    }
    save() {
        const validation = this.validate();
        const isValid = (validation && validation.valid) || false;
        if (this.hasAutoCommitEdit && isValid) {
            // do not use args.commitChanges() as this sets the focus to the next row.
            // also the select list will stay shown when clicking off the grid
            this.grid.getEditorLock().commitCurrentEdit();
        }
        else {
            this.args.commitChanges();
        }
    }
    serializeValue() {
        var _a, _b;
        return (_b = (_a = this._input) === null || _a === void 0 ? void 0 : _a.checked) !== null && _b !== void 0 ? _b : false;
    }
    validate(inputValue) {
        var _a;
        const isRequired = this.columnEditor.required;
        const isChecked = (inputValue !== undefined) ? inputValue : (_a = this._input) === null || _a === void 0 ? void 0 : _a.checked;
        const errorMsg = this.columnEditor.errorMessage;
        if (this.validator) {
            return this.validator(isChecked, this.args);
        }
        // by default the editor is almost always valid (except when it's required but not provided)
        if (isRequired && !isChecked) {
            return {
                valid: false,
                msg: errorMsg || Constants.VALIDATION_REQUIRED_FIELD
            };
        }
        return {
            valid: true,
            msg: null
        };
    }
}

const flatpickr = (flatpickr_ && flatpickr_['default'] || flatpickr_); // patch for rollup
const moment = moment_['default'] || moment_; // patch to fix rollup "moment has no default export" issue, document here https://github.com/rollup/rollup/issues/670
/*
 * An example of a date picker editor using Flatpickr
 * https://chmln.github.io/flatpickr
 */
class DateEditor {
    constructor(args) {
        this.args = args;
        this._isValueTouched = false;
        this._lastTriggeredByClearDate = false;
        if (!args) {
            throw new Error('[Angular-SlickGrid] Something is wrong with this grid, an Editor must always have valid arguments.');
        }
        this.grid = args.grid;
        this.gridOptions = (this.grid.getOptions() || {});
        const options = this.gridOptions || this.args.column.params || {};
        if ((options === null || options === void 0 ? void 0 : options.i18n) instanceof TranslateService) {
            this._translate = options.i18n;
        }
        this._bindEventService = new BindingEventService();
        this.init();
    }
    /** Get Column Definition object */
    get columnDef() {
        return this.args.column;
    }
    /** Get Column Editor object */
    get columnEditor() {
        return this.columnDef && this.columnDef.internalColumnEditor || {};
    }
    /** Getter for the Editor DOM Element */
    get editorDomElement() {
        return this._inputElm;
    }
    /** Get Flatpickr options passed to the editor by the user */
    get editorOptions() {
        return this.columnEditor.editorOptions || {};
    }
    get hasAutoCommitEdit() {
        var _a;
        return (_a = this.gridOptions.autoCommitEdit) !== null && _a !== void 0 ? _a : false;
    }
    get pickerOptions() {
        return this._pickerMergedOptions;
    }
    /** Get the Validator function, can be passed in Editor property or Column Definition */
    get validator() {
        var _a, _b, _c;
        return (_b = (_a = this.columnEditor) === null || _a === void 0 ? void 0 : _a.validator) !== null && _b !== void 0 ? _b : (_c = this.columnDef) === null || _c === void 0 ? void 0 : _c.validator;
    }
    init() {
        var _a, _b, _c, _d, _e, _f, _g;
        if (this.args && this.columnDef) {
            const columnId = (_b = (_a = this.columnDef) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '';
            const placeholder = (_d = (_c = this.columnEditor) === null || _c === void 0 ? void 0 : _c.placeholder) !== null && _d !== void 0 ? _d : '';
            const title = this.columnEditor && this.columnEditor.title || '';
            this.defaultDate = (this.args.item) ? this.args.item[this.columnDef.field] : null;
            const inputFormat = mapFlatpickrDateFormatWithFieldType(this.columnEditor.type || this.columnDef.type || FieldType.dateUtc);
            const outputFormat = mapFlatpickrDateFormatWithFieldType(this.columnDef.outputType || this.columnEditor.type || this.columnDef.type || FieldType.dateUtc);
            let currentLocale = this._translate && this._translate.currentLang || this.gridOptions.locale || 'en';
            if (currentLocale && currentLocale.length > 2) {
                currentLocale = currentLocale.substring(0, 2);
            }
            const pickerOptions = {
                defaultDate: this.defaultDate,
                altInput: true,
                altFormat: outputFormat,
                dateFormat: inputFormat,
                closeOnSelect: true,
                wrap: true,
                locale: currentLocale,
                onChange: () => this.handleOnDateChange(),
                errorHandler: (error) => {
                    if (error.toString().includes('invalid locale')) {
                        console.warn(`[Angular-Slickgrid] Flatpickr missing locale imports (${currentLocale}), will revert to English as the default locale.
          See Flatpickr Localization for more info, for example if we want to use French, then we can import it with:  import 'flatpickr/dist/l10n/fr';`);
                    }
                    // for any other error do nothing
                    // Flatpickr is a little too sensitive and will throw an error when provided date is lower than minDate so just disregard the error completely
                }
            };
            // merge options with optional user's custom options
            this._pickerMergedOptions = Object.assign(Object.assign({}, pickerOptions), this.editorOptions);
            const inputCssClasses = `.editor-text.editor-${columnId}.form-control`;
            if (this._pickerMergedOptions.altInput) {
                this._pickerMergedOptions.altInputClass = 'flatpickr-alt-input form-control';
            }
            this._editorInputGroupElm = document.createElement('div');
            this._editorInputGroupElm.className = 'flatpickr input-group';
            const closeButtonGroupElm = document.createElement('span');
            closeButtonGroupElm.className = 'input-group-btn input-group-append';
            closeButtonGroupElm.dataset.clear = '';
            this._closeButtonElm = document.createElement('button');
            this._closeButtonElm.type = 'button';
            this._closeButtonElm.className = 'btn btn-default icon-clear';
            this._inputElm = document.createElement('input');
            this._inputElm.dataset.input = '';
            this._inputElm.dataset.defaultdate = this.defaultDate;
            this._inputElm.className = inputCssClasses.replace(/\./g, ' ');
            this._inputElm.placeholder = placeholder;
            this._inputElm.title = title;
            this._editorInputGroupElm.appendChild(this._inputElm);
            // show clear date button (unless user specifically doesn't want it)
            if (!((_f = (_e = this.columnEditor) === null || _e === void 0 ? void 0 : _e.params) === null || _f === void 0 ? void 0 : _f.hideClearButton)) {
                closeButtonGroupElm.appendChild(this._closeButtonElm);
                this._editorInputGroupElm.appendChild(closeButtonGroupElm);
                this._bindEventService.bind(this._closeButtonElm, 'click', () => this._lastTriggeredByClearDate = true);
            }
            this.args.container.appendChild(this._editorInputGroupElm);
            this.flatInstance = flatpickr(this._editorInputGroupElm, this._pickerMergedOptions);
            // when we're using an alternate input to display data, we'll consider this input as the one to do the focus later on
            // else just use the top one
            this._inputWithDataElm = ((_g = this._pickerMergedOptions) === null || _g === void 0 ? void 0 : _g.altInput) ? document.querySelector(`${inputCssClasses}.flatpickr-alt-input`) : this._inputElm;
            setTimeout(() => {
                this.show();
                this.focus();
            }, 50);
        }
    }
    destroy() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.hide();
        this._bindEventService.unbindAll();
        if ((_a = this.flatInstance) === null || _a === void 0 ? void 0 : _a.destroy) {
            this.flatInstance.destroy();
            if ((_b = this.flatInstance) === null || _b === void 0 ? void 0 : _b.element) {
                setTimeout(() => destroyObjectDomElementProps(this.flatInstance));
            }
        }
        emptyElement(this._editorInputGroupElm);
        emptyElement(this._inputWithDataElm);
        emptyElement(this._inputElm);
        (_d = (_c = this._editorInputGroupElm) === null || _c === void 0 ? void 0 : _c.remove) === null || _d === void 0 ? void 0 : _d.call(_c);
        (_f = (_e = this._inputWithDataElm) === null || _e === void 0 ? void 0 : _e.remove) === null || _f === void 0 ? void 0 : _f.call(_e);
        (_h = (_g = this._inputElm) === null || _g === void 0 ? void 0 : _g.remove) === null || _h === void 0 ? void 0 : _h.call(_g);
    }
    focus() {
        var _a, _b;
        if ((_a = this._inputElm) === null || _a === void 0 ? void 0 : _a.focus) {
            this._inputElm.focus();
        }
        if ((_b = this._inputWithDataElm) === null || _b === void 0 ? void 0 : _b.focus) {
            this._inputWithDataElm.focus();
            this._inputWithDataElm.select();
        }
    }
    hide() {
        if (this.flatInstance && typeof this.flatInstance.close === 'function') {
            this.flatInstance.close();
        }
    }
    show() {
        if (this.flatInstance && typeof this.flatInstance.open === 'function' && this.flatInstance._input) {
            this.flatInstance.open();
        }
    }
    getValue() {
        return this._inputElm.value;
    }
    setValue(val) {
        this.flatInstance.setDate(val);
    }
    applyValue(item, state) {
        var _a, _b, _c;
        const fieldName = this.columnDef && this.columnDef.field;
        if (fieldName !== undefined) {
            const outputTypeFormat = mapMomentDateFormatWithFieldType((this.columnDef && (this.columnDef.outputType || this.columnEditor.type || this.columnDef.type)) || FieldType.dateUtc);
            const saveTypeFormat = mapMomentDateFormatWithFieldType((this.columnDef && (this.columnDef.saveOutputType || this.columnDef.outputType || this.columnEditor.type || this.columnDef.type)) || FieldType.dateUtc);
            const isComplexObject = (fieldName === null || fieldName === void 0 ? void 0 : fieldName.indexOf('.')) > 0; // is the field a complex object, "address.streetNumber"
            // validate the value before applying it (if not valid we'll set an empty string)
            const validation = this.validate(state);
            const newValue = (state && validation && validation.valid) ? moment(state, outputTypeFormat).format(saveTypeFormat) : '';
            // set the new value to the item datacontext
            if (isComplexObject) {
                // when it's a complex object, user could override the object path (where the editable object is located)
                // else we use the path provided in the Field Column Definition
                const objectPath = (_c = (_b = (_a = this.columnEditor) === null || _a === void 0 ? void 0 : _a.complexObjectPath) !== null && _b !== void 0 ? _b : fieldName) !== null && _c !== void 0 ? _c : '';
                setDeepValue(item, objectPath, newValue);
            }
            else {
                item[fieldName] = newValue;
            }
        }
    }
    isValueChanged() {
        var _a;
        const elmValue = this._inputElm.value;
        const inputFormat = mapMomentDateFormatWithFieldType(this.columnEditor.type || ((_a = this.columnDef) === null || _a === void 0 ? void 0 : _a.type) || FieldType.dateIso);
        const outputTypeFormat = mapMomentDateFormatWithFieldType((this.columnDef && (this.columnDef.outputType || this.columnEditor.type || this.columnDef.type)) || FieldType.dateUtc);
        const elmDateStr = elmValue ? moment(elmValue, inputFormat, false).format(outputTypeFormat) : '';
        const orgDateStr = this._originalDate ? moment(this._originalDate, inputFormat, false).format(outputTypeFormat) : '';
        if (elmDateStr === 'Invalid date' || orgDateStr === 'Invalid date') {
            return false;
        }
        const isChanged = this._lastTriggeredByClearDate || (!(elmDateStr === '' && orgDateStr === '')) && (elmDateStr !== orgDateStr);
        return isChanged;
    }
    loadValue(item) {
        const fieldName = this.columnDef && this.columnDef.field;
        if (item && fieldName !== undefined) {
            // is the field a complex object, "address.streetNumber"
            const isComplexObject = (fieldName === null || fieldName === void 0 ? void 0 : fieldName.indexOf('.')) > 0;
            const value = (isComplexObject) ? getDescendantProperty(item, fieldName) : item[fieldName];
            this._originalDate = value;
            this.flatInstance.setDate(value);
        }
    }
    save() {
        const validation = this.validate();
        const isValid = (validation && validation.valid) || false;
        if (this.hasAutoCommitEdit && isValid) {
            // do not use args.commitChanges() as this sets the focus to the next row.
            // also the select list will stay shown when clicking off the grid
            this.grid.getEditorLock().commitCurrentEdit();
        }
        else {
            this.args.commitChanges();
        }
    }
    serializeValue() {
        var _a;
        const domValue = this._inputElm.value;
        if (!domValue) {
            return '';
        }
        const inputFormat = mapMomentDateFormatWithFieldType(this.columnEditor.type || ((_a = this.columnDef) === null || _a === void 0 ? void 0 : _a.type) || FieldType.dateIso);
        const outputTypeFormat = mapMomentDateFormatWithFieldType((this.columnDef && (this.columnDef.outputType || this.columnEditor.type || this.columnDef.type)) || FieldType.dateIso);
        const value = moment(domValue, inputFormat, false).format(outputTypeFormat);
        return value;
    }
    validate(inputValue) {
        var _a;
        const isRequired = this.columnEditor.required;
        const elmValue = (inputValue !== undefined) ? inputValue : (_a = this._inputElm) === null || _a === void 0 ? void 0 : _a.value;
        const errorMsg = this.columnEditor.errorMessage;
        if (this.validator) {
            return this.validator(elmValue, this.args);
        }
        // by default the editor is almost always valid (except when it's required but not provided)
        if (isRequired && elmValue === '') {
            return { valid: false, msg: errorMsg || Constants.VALIDATION_REQUIRED_FIELD };
        }
        return { valid: true, msg: null };
    }
    //
    // protected functions
    // ------------------
    handleOnDateChange() {
        this._isValueTouched = true;
        if (this.args) {
            this.save();
        }
        setTimeout(() => this._lastTriggeredByClearDate = false); // reset flag after a cycle
    }
}

function floatValidator(inputValue, options) {
    const floatNumber = !isNaN(inputValue) ? parseFloat(inputValue) : null;
    const decPlaces = options.decimal || 0;
    const isRequired = options.required;
    const minValue = options.minValue;
    const maxValue = options.maxValue;
    const operatorConditionalType = options.operatorConditionalType || 'inclusive';
    const errorMsg = options.errorMessage;
    const mapValidation = {
        '{{minValue}}': minValue,
        '{{maxValue}}': maxValue,
        '{{minDecimal}}': 0,
        '{{maxDecimal}}': decPlaces
    };
    let isValid = true;
    let outputMsg = '';
    if (typeof options.validator === 'function') {
        return options.validator(inputValue, options.editorArgs);
    }
    else if (isRequired && inputValue === '') {
        isValid = false;
        outputMsg = errorMsg || Constants.VALIDATION_REQUIRED_FIELD;
    }
    else if (inputValue !== '' && (isNaN(inputValue) || (decPlaces === 0 && !/^[-+]?(\d*(\.)?(\d)*)$/.test(inputValue)))) {
        // when decimal value is 0 (which is the default), we accept 0 or more decimal values
        isValid = false;
        outputMsg = errorMsg || Constants.VALIDATION_EDITOR_VALID_NUMBER;
    }
    else if (minValue !== undefined && maxValue !== undefined && floatNumber !== null && ((operatorConditionalType === 'exclusive' && (floatNumber <= minValue || floatNumber >= maxValue)) || (operatorConditionalType === 'inclusive' && (floatNumber < minValue || floatNumber > maxValue)))) {
        // MIN & MAX Values provided
        // when decimal value is bigger than 0, we only accept the decimal values as that value set
        // for example if we set decimalPlaces to 2, we will only accept numbers between 0 and 2 decimals
        isValid = false;
        outputMsg = errorMsg || Constants.VALIDATION_EDITOR_NUMBER_BETWEEN.replace(/{{minValue}}|{{maxValue}}/gi, (matched) => mapValidation[matched]);
    }
    else if (minValue !== undefined && floatNumber !== null && ((operatorConditionalType === 'exclusive' && floatNumber <= minValue) || (operatorConditionalType === 'inclusive' && floatNumber < minValue))) {
        // MIN VALUE ONLY
        // when decimal value is bigger than 0, we only accept the decimal values as that value set
        // for example if we set decimalPlaces to 2, we will only accept numbers between 0 and 2 decimals
        isValid = false;
        const defaultErrorMsg = operatorConditionalType === 'inclusive' ? Constants.VALIDATION_EDITOR_NUMBER_MIN_INCLUSIVE : Constants.VALIDATION_EDITOR_NUMBER_MIN;
        outputMsg = errorMsg || defaultErrorMsg.replace(/{{minValue}}/gi, (matched) => mapValidation[matched]);
    }
    else if (maxValue !== undefined && floatNumber !== null && ((operatorConditionalType === 'exclusive' && floatNumber >= maxValue) || (operatorConditionalType === 'inclusive' && floatNumber > maxValue))) {
        // MAX VALUE ONLY
        // when decimal value is bigger than 0, we only accept the decimal values as that value set
        // for example if we set decimalPlaces to 2, we will only accept numbers between 0 and 2 decimals
        isValid = false;
        const defaultErrorMsg = operatorConditionalType === 'inclusive' ? Constants.VALIDATION_EDITOR_NUMBER_MAX_INCLUSIVE : Constants.VALIDATION_EDITOR_NUMBER_MAX;
        outputMsg = errorMsg || defaultErrorMsg.replace(/{{maxValue}}/gi, (matched) => mapValidation[matched]);
    }
    else if ((decPlaces > 0 && !new RegExp(`^[-+]?(\\d*(\\.)?(\\d){0,${decPlaces}})$`).test(inputValue))) {
        // when decimal value is bigger than 0, we only accept the decimal values as that value set
        // for example if we set decimalPlaces to 2, we will only accept numbers between 0 and 2 decimals
        isValid = false;
        outputMsg = errorMsg || Constants.VALIDATION_EDITOR_DECIMAL_BETWEEN.replace(/{{minDecimal}}|{{maxDecimal}}/gi, (matched) => mapValidation[matched]);
    }
    return { valid: isValid, msg: outputMsg };
}

function integerValidator(inputValue, options) {
    let intNumber = !isNaN(inputValue) ? parseInt(inputValue, 10) : null;
    if (intNumber !== null && isNaN(intNumber)) {
        intNumber = null;
    }
    const errorMsg = options.errorMessage;
    const isRequired = options.required;
    const minValue = options.minValue;
    const maxValue = options.maxValue;
    const operatorConditionalType = options.operatorConditionalType || 'inclusive';
    const mapValidation = {
        '{{minValue}}': minValue,
        '{{maxValue}}': maxValue
    };
    let isValid = true;
    let outputMsg = '';
    if (options.validator) {
        return options.validator(inputValue, options.editorArgs);
    }
    else if (isRequired && inputValue === '') {
        isValid = false;
        outputMsg = errorMsg || Constants.VALIDATION_REQUIRED_FIELD;
    }
    else if (inputValue !== '' && ((isNaN(inputValue) || !/^[+-]?\d+$/.test(inputValue)))) {
        isValid = false;
        outputMsg = errorMsg || Constants.VALIDATION_EDITOR_VALID_INTEGER;
    }
    else if (minValue !== undefined && maxValue !== undefined && intNumber !== null && ((operatorConditionalType === 'exclusive' && (intNumber <= minValue || intNumber >= maxValue)) || (operatorConditionalType === 'inclusive' && (intNumber < minValue || intNumber > maxValue)))) {
        // MIN & MAX Values provided (between)
        // when decimal value is bigger than 0, we only accept the decimal values as that value set
        // for example if we set decimalPlaces to 2, we will only accept numbers between 0 and 2 decimals
        isValid = false;
        outputMsg = errorMsg || Constants.VALIDATION_EDITOR_INTEGER_BETWEEN.replace(/{{minValue}}|{{maxValue}}/gi, (matched) => mapValidation[matched]);
    }
    else if (minValue !== undefined && intNumber !== null && ((operatorConditionalType === 'exclusive' && intNumber <= minValue) || (operatorConditionalType === 'inclusive' && intNumber !== null && intNumber < minValue))) {
        // MIN VALUE ONLY
        // when decimal value has to be higher then provided minValue
        isValid = false;
        const defaultErrorMsg = operatorConditionalType === 'inclusive' ? Constants.VALIDATION_EDITOR_INTEGER_MIN_INCLUSIVE : Constants.VALIDATION_EDITOR_INTEGER_MIN;
        outputMsg = errorMsg || defaultErrorMsg.replace(/{{minValue}}/gi, (matched) => mapValidation[matched]);
    }
    else if (maxValue !== undefined && intNumber !== null && ((operatorConditionalType === 'exclusive' && intNumber >= maxValue) || (operatorConditionalType === 'inclusive' && intNumber !== null && intNumber > maxValue))) {
        // MAX VALUE ONLY
        // when decimal value has to be lower then provided maxValue
        isValid = false;
        const defaultErrorMsg = operatorConditionalType === 'inclusive' ? Constants.VALIDATION_EDITOR_INTEGER_MAX_INCLUSIVE : Constants.VALIDATION_EDITOR_INTEGER_MAX;
        outputMsg = errorMsg || defaultErrorMsg.replace(/{{maxValue}}/gi, (matched) => mapValidation[matched]);
    }
    return { valid: isValid, msg: outputMsg };
}

function sliderValidator(inputValue, options) {
    const isRequired = options.required;
    const minValue = options.minValue;
    const maxValue = options.maxValue;
    const errorMsg = options.errorMessage;
    const mapValidation = {
        '{{minValue}}': minValue,
        '{{maxValue}}': maxValue
    };
    if (options.validator) {
        return options.validator(inputValue, options.editorArgs);
    }
    else if (isRequired && inputValue === '') {
        return {
            valid: false,
            msg: errorMsg || Constants.VALIDATION_REQUIRED_FIELD
        };
    }
    else if (minValue !== undefined && maxValue !== undefined && inputValue !== null && (inputValue < minValue || inputValue > maxValue)) {
        // when decimal value is bigger than 0, we only accept the decimal values as that value set
        // for example if we set decimalPlaces to 2, we will only accept numbers between 0 and 2 decimals
        return {
            valid: false,
            msg: errorMsg || Constants.VALIDATION_EDITOR_NUMBER_BETWEEN.replace(/{{minValue}}|{{maxValue}}/gi, (matched) => {
                return mapValidation[matched];
            })
        };
    }
    return { valid: true, msg: null };
}

/*
 * An example of a 'detached' editor.
 * KeyDown events are also handled to provide handling for Tab, Shift-Tab, Esc and Ctrl-Enter.
 */
class DualInputEditor {
    constructor(args) {
        this.args = args;
        this._isValueSaveCalled = false;
        if (!args) {
            throw new Error('[Angular-Slickgrid] Something is wrong with this grid, an Editor must always have valid arguments.');
        }
        this.grid = args.grid;
        this.gridOptions = (this.grid.getOptions() || {});
        this._eventHandler = new Slick.EventHandler();
        this._bindEventService = new BindingEventService();
        this.init();
        this._eventHandler.subscribe(this.grid.onValidationError, () => this._isValueSaveCalled = true);
    }
    /** Get Column Definition object */
    get columnDef() {
        return this.args.column;
    }
    /** Get Column Editor object */
    get columnEditor() {
        return this.columnDef && this.columnDef.internalColumnEditor || {};
    }
    /** Get the Editor DOM Element */
    get editorDomElement() {
        return { leftInput: this._leftInput, rightInput: this._rightInput };
    }
    get editorParams() {
        return this.columnEditor.params || {};
    }
    get eventHandler() {
        return this._eventHandler;
    }
    get hasAutoCommitEdit() {
        var _a;
        return (_a = this.gridOptions.autoCommitEdit) !== null && _a !== void 0 ? _a : false;
    }
    get isValueSaveCalled() {
        return this._isValueSaveCalled;
    }
    /** Get the Shared Validator function, can be passed in Editor property or Column Definition */
    get validator() {
        var _a, _b, _c;
        return (_b = (_a = this.columnEditor) === null || _a === void 0 ? void 0 : _a.validator) !== null && _b !== void 0 ? _b : (_c = this.columnDef) === null || _c === void 0 ? void 0 : _c.validator;
    }
    init() {
        if (!this.editorParams || !this.editorParams.leftInput || !this.editorParams.leftInput.field || !this.editorParams.rightInput || !this.editorParams.rightInput.field) {
            throw new Error(`[Angular-Slickgrid] Please make sure that your Combo Input Editor has params defined with "leftInput" and "rightInput" (example: { editor: { model: Editors.comboInput, params: { leftInput: { field: 'firstName' }, { rightSide: { field: 'lastName' } }}}`);
        }
        this._leftFieldName = this.editorParams && this.editorParams.leftInput && this.editorParams.leftInput.field;
        this._rightFieldName = this.editorParams && this.editorParams.rightInput && this.editorParams.rightInput.field;
        this._leftInput = this.createInput('leftInput');
        this._rightInput = this.createInput('rightInput');
        const containerElm = this.args.container;
        if (containerElm && typeof containerElm.appendChild === 'function') {
            containerElm.appendChild(this._leftInput);
            containerElm.appendChild(this._rightInput);
        }
        this._leftInput.onkeydown = this.handleKeyDown.bind(this);
        this._rightInput.onkeydown = this.handleKeyDown.bind(this);
        // the lib does not get the focus out event for some reason, so register it here
        if (this.hasAutoCommitEdit) {
            this._bindEventService.bind(this._leftInput, 'focusout', ((event) => this.handleFocusOut(event, 'leftInput')));
            this._bindEventService.bind(this._rightInput, 'focusout', ((event) => this.handleFocusOut(event, 'rightInput')));
        }
        setTimeout(() => this._leftInput.select(), 50);
    }
    handleFocusOut(event, position) {
        // when clicking outside the editable cell OR when focusing out of it
        const targetClassNames = event.relatedTarget && event.relatedTarget.className || '';
        if (targetClassNames.indexOf('dual-editor') === -1 && this._lastEventType !== 'focusout-right') {
            if (position === 'rightInput' || (position === 'leftInput' && this._lastEventType !== 'focusout-left')) {
                this.save();
            }
        }
        const side = (position === 'leftInput') ? 'left' : 'right';
        this._lastEventType = `${event && event.type}-${side}`;
    }
    handleKeyDown(event) {
        this._lastInputKeyEvent = event;
        if (event.keyCode === KeyCode.LEFT || event.keyCode === KeyCode.RIGHT || event.keyCode === KeyCode.TAB) {
            event.stopImmediatePropagation();
        }
    }
    destroy() {
        var _a, _b, _c, _d;
        // unsubscribe all SlickGrid events
        this._eventHandler.unsubscribeAll();
        this._bindEventService.unbindAll();
        (_b = (_a = this._leftInput) === null || _a === void 0 ? void 0 : _a.remove) === null || _b === void 0 ? void 0 : _b.call(_a);
        (_d = (_c = this._rightInput) === null || _c === void 0 ? void 0 : _c.remove) === null || _d === void 0 ? void 0 : _d.call(_c);
    }
    createInput(position) {
        const editorSideParams = this.editorParams[position];
        const columnId = this.columnDef && this.columnDef.id;
        const idPropName = this.gridOptions.datasetIdPropertyName || 'id';
        const itemId = this.args && this.args.item && this.args.item[idPropName] || 0;
        let fieldType = editorSideParams.type || 'text';
        if (fieldType === 'float' || fieldType === 'integer') {
            fieldType = 'number';
        }
        const input = document.createElement('input');
        input.id = `item-${itemId}-${position}`;
        input.className = `dual-editor-text editor-${columnId} ${position.replace(/input/gi, '')}`;
        if (fieldType === 'readonly') {
            // when the custom type is defined as readonly, we'll make a readonly text input
            input.readOnly = true;
            fieldType = 'text';
        }
        input.type = fieldType || 'text';
        input.setAttribute('role', 'presentation');
        input.autocomplete = 'off';
        input.placeholder = editorSideParams.placeholder || '';
        input.title = editorSideParams.title || '';
        if (fieldType === 'number') {
            input.step = this.getInputDecimalSteps(position);
        }
        return input;
    }
    focus() {
        // do nothing since we have 2 inputs and we might focus on left/right depending on which is invalid and/or new
    }
    getValues() {
        const obj = {};
        const leftInputValue = this._leftInput.value;
        const rightInputValue = this._rightInput.value;
        const isLeftInputTypeNumber = (this.editorParams.leftInput && (this.editorParams.leftInput.type === 'float' || this.editorParams.leftInput.type === 'integer'));
        const isRightInputTypeNumber = (this.editorParams.rightInput && (this.editorParams.rightInput.type === 'float' || this.editorParams.rightInput.type === 'integer'));
        const resultLeftValue = (leftInputValue !== '' && isLeftInputTypeNumber) ? +this._leftInput.value : (leftInputValue || '');
        const resultRightValue = (rightInputValue !== '' && isRightInputTypeNumber) ? +this._rightInput.value : (rightInputValue || '');
        setDeepValue(obj, this._leftFieldName, resultLeftValue);
        setDeepValue(obj, this._rightFieldName, resultRightValue);
        return obj;
    }
    setValues(values) {
        if (Array.isArray(values) && values.length === 2) {
            this._leftInput.value = `${values[0]}`;
            this._rightInput.value = `${values[1]}`;
        }
    }
    applyValue(item, state) {
        this.applyValueByPosition(item, state, 'leftInput');
        this.applyValueByPosition(item, state, 'rightInput');
    }
    applyValueByPosition(item, state, position) {
        const fieldName = position === 'leftInput' ? this._leftFieldName : this._rightFieldName;
        if (fieldName !== undefined) {
            const isComplexObject = fieldName && fieldName.indexOf('.') > 0; // is the field a complex object, "address.streetNumber"
            let fieldNameToUse = fieldName;
            if (isComplexObject) {
                const complexFieldNames = fieldName.split(/\.(.*)/);
                fieldNameToUse = (complexFieldNames.length > 1 ? complexFieldNames[1] : complexFieldNames);
            }
            // validate the value before applying it (if not valid we'll set an empty string)
            const stateValue = isComplexObject ? getDescendantProperty(state, fieldNameToUse) : state[fieldName];
            const validation = this.validate({ position, inputValue: stateValue });
            // set the new value to the item datacontext
            if (isComplexObject) {
                const newValueFromComplex = getDescendantProperty(state, fieldNameToUse);
                const newValue = (validation && validation.valid) ? newValueFromComplex : '';
                setDeepValue(item, fieldName, newValue);
            }
            else if (fieldName) {
                item[fieldName] = (validation && validation.valid) ? state[fieldName] : '';
            }
        }
    }
    isValueChanged() {
        const leftElmValue = this._leftInput.value;
        const rightElmValue = this._rightInput.value;
        const leftEditorParams = this.editorParams && this.editorParams.leftInput;
        const rightEditorParams = this.editorParams && this.editorParams.rightInput;
        const lastKeyEvent = this._lastInputKeyEvent && this._lastInputKeyEvent.keyCode;
        if ((leftEditorParams && leftEditorParams.alwaysSaveOnEnterKey || rightEditorParams && rightEditorParams.alwaysSaveOnEnterKey) && lastKeyEvent === KeyCode.ENTER) {
            return true;
        }
        const leftResult = (!(leftElmValue === '' && (this.originalLeftValue === null || this.originalLeftValue === undefined))) && (leftElmValue !== this.originalLeftValue);
        const rightResult = (!(rightElmValue === '' && (this.originalRightValue === null || this.originalRightValue === undefined))) && (rightElmValue !== this.originalRightValue);
        return leftResult || rightResult;
    }
    loadValue(item) {
        this.loadValueByPosition(item, 'leftInput');
        this.loadValueByPosition(item, 'rightInput');
        this._leftInput.select();
    }
    loadValueByPosition(item, position) {
        // is the field a complex object, "address.streetNumber"
        const fieldName = (position === 'leftInput') ? this._leftFieldName : this._rightFieldName;
        const originalValuePosition = (position === 'leftInput') ? 'originalLeftValue' : 'originalRightValue';
        const inputVarPosition = (position === 'leftInput') ? '_leftInput' : '_rightInput';
        if (item && fieldName !== undefined) {
            const isComplexObject = fieldName && fieldName.indexOf('.') > 0;
            const itemValue = (isComplexObject) ? getDescendantProperty(item, fieldName) : (item.hasOwnProperty(fieldName) ? item[fieldName] : '');
            this[originalValuePosition] = itemValue;
            if (this.editorParams[position].type === 'float') {
                const decimalPlaces = this.getDecimalPlaces(position);
                if (decimalPlaces !== null && (this[originalValuePosition] || this[originalValuePosition] === 0) && (+this[originalValuePosition]).toFixed) {
                    this[originalValuePosition] = (+this[originalValuePosition]).toFixed(decimalPlaces);
                }
            }
            if (this[inputVarPosition]) {
                const originalValue = this[originalValuePosition];
                this[inputVarPosition].value = `${originalValue}`;
            }
        }
    }
    save() {
        const validation = this.validate();
        const isValid = (validation && validation.valid) || false;
        if (!this._isValueSaveCalled) {
            if (this.hasAutoCommitEdit && isValid) {
                this.grid.getEditorLock().commitCurrentEdit();
            }
            else {
                this.args.commitChanges();
            }
            this._isValueSaveCalled = true;
        }
    }
    serializeValue() {
        const obj = {};
        const leftValue = this.serializeValueByPosition('leftInput');
        const rightValue = this.serializeValueByPosition('rightInput');
        setDeepValue(obj, this._leftFieldName, leftValue);
        setDeepValue(obj, this._rightFieldName, rightValue);
        return obj;
    }
    serializeValueByPosition(position) {
        const elmValue = position === 'leftInput' ? this._leftInput.value : this._rightInput.value;
        if (elmValue === '' || isNaN(+elmValue)) {
            return elmValue;
        }
        let rtn = parseFloat(elmValue);
        const decPlaces = this.getDecimalPlaces(position);
        if (decPlaces !== null && (rtn || rtn === 0) && rtn.toFixed) {
            rtn = parseFloat(rtn.toFixed(decPlaces));
        }
        return rtn;
    }
    getDecimalPlaces(position) {
        const defaultDecimalPlaces = 0; // TODO move into a constant
        // returns the number of fixed decimal places or null
        const positionSide = position === 'leftInput' ? 'leftInput' : 'rightInput';
        const sideParams = this.editorParams[positionSide];
        const rtn = sideParams && sideParams.decimal;
        if (rtn === undefined) {
            return defaultDecimalPlaces;
        }
        return rtn;
    }
    getInputDecimalSteps(position) {
        const decimals = this.getDecimalPlaces(position);
        let zeroString = '';
        for (let i = 1; i < decimals; i++) {
            zeroString += '0';
        }
        if (decimals > 0) {
            return `0.${zeroString}1`;
        }
        return '1';
    }
    validate(inputValidation) {
        if (inputValidation) {
            const posValidation = this.validateByPosition(inputValidation.position, inputValidation.inputValue);
            if (!posValidation.valid) {
                inputValidation.position === 'leftInput' ? this._leftInput.select() : this._rightInput.select();
                return posValidation;
            }
        }
        else {
            const leftValidation = this.validateByPosition('leftInput');
            const rightValidation = this.validateByPosition('rightInput');
            if (!leftValidation.valid) {
                this._leftInput.select();
                return leftValidation;
            }
            if (!rightValidation.valid) {
                this._rightInput.select();
                return rightValidation;
            }
        }
        return { valid: true, msg: '' };
    }
    validateByPosition(position, inputValue) {
        const positionEditorParams = this.editorParams[position];
        let currentVal = '';
        if (inputValue) {
            currentVal = inputValue;
        }
        else {
            const input = position === 'leftInput' ? this._leftInput : this._rightInput;
            currentVal = input && input.value;
        }
        // there are 2 ways of passing a Validator, 1-independent validator on each side, 2-shared validator
        const commonValidator = this.validator;
        currentVal = typeof commonValidator === 'function' ? this.getValues() : currentVal;
        const baseValidatorOptions = {
            editorArgs: this.args,
            errorMessage: positionEditorParams.errorMessage,
            required: positionEditorParams.required,
            validator: typeof commonValidator === 'function' ? commonValidator : positionEditorParams.validator,
        };
        switch (positionEditorParams.type) {
            case 'float':
                return floatValidator(currentVal, Object.assign(Object.assign({}, baseValidatorOptions), { decimal: this.getDecimalPlaces(position), minValue: positionEditorParams.minValue, maxValue: positionEditorParams.maxValue, operatorConditionalType: positionEditorParams.operatorConditionalType }));
            case 'integer':
                return integerValidator(currentVal, Object.assign(Object.assign({}, baseValidatorOptions), { minValue: positionEditorParams.minValue, maxValue: positionEditorParams.maxValue, operatorConditionalType: positionEditorParams.operatorConditionalType }));
            case 'text':
            case 'password':
            default:
                return textValidator(currentVal, baseValidatorOptions);
        }
    }
}

/*
 * An example of a 'detached' editor.
 * KeyDown events are also handled to provide handling for Tab, Shift-Tab, Esc and Ctrl-Enter.
 */
class InputEditor {
    constructor(args, inputType) {
        this.args = args;
        this._inputType = 'text';
        if (!args) {
            throw new Error('[Angular-SlickGrid] Something is wrong with this grid, an Editor must always have valid arguments.');
        }
        this.grid = args.grid;
        this.gridOptions = args.grid && args.grid.getOptions();
        this._bindEventService = new BindingEventService();
        this.inputType = inputType || 'text';
        this.init();
    }
    /** Get Column Definition object */
    get columnDef() {
        return this.args.column;
    }
    /** Get Column Editor object */
    get columnEditor() {
        return this.columnDef && this.columnDef.internalColumnEditor || {};
    }
    /** Getter for the Editor DOM Element */
    get editorDomElement() {
        return this._input;
    }
    get hasAutoCommitEdit() {
        var _a;
        return (_a = this.gridOptions.autoCommitEdit) !== null && _a !== void 0 ? _a : false;
    }
    /** Getter of input type (text, number, password) */
    get inputType() {
        return this._inputType;
    }
    /** Setter of input type (text, number, password) */
    set inputType(type) {
        this._inputType = type;
    }
    /** Get the Validator function, can be passed in Editor property or Column Definition */
    get validator() {
        var _a, _b, _c;
        return (_b = (_a = this.columnEditor) === null || _a === void 0 ? void 0 : _a.validator) !== null && _b !== void 0 ? _b : (_c = this.columnDef) === null || _c === void 0 ? void 0 : _c.validator;
    }
    init() {
        var _a, _b, _c, _d, _e, _f;
        const columnId = (_b = (_a = this.columnDef) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '';
        const placeholder = (_d = (_c = this.columnEditor) === null || _c === void 0 ? void 0 : _c.placeholder) !== null && _d !== void 0 ? _d : '';
        const title = (_f = (_e = this.columnEditor) === null || _e === void 0 ? void 0 : _e.title) !== null && _f !== void 0 ? _f : '';
        this._input = document.createElement('input');
        this._input.className = `editor-text editor-${columnId}`;
        this._input.type = this._inputType || 'text';
        this._input.setAttribute('role', 'presentation');
        this._input.autocomplete = 'off';
        this._input.placeholder = placeholder;
        this._input.title = title;
        const cellContainer = this.args.container;
        if (cellContainer && typeof cellContainer.appendChild === 'function') {
            cellContainer.appendChild(this._input);
        }
        this._bindEventService.bind(this._input, 'focus', () => { var _a; return (_a = this._input) === null || _a === void 0 ? void 0 : _a.select(); });
        this._bindEventService.bind(this._input, 'keydown', ((event) => {
            this._lastInputKeyEvent = event;
            if (event.keyCode === KeyCode.LEFT || event.keyCode === KeyCode.RIGHT) {
                event.stopImmediatePropagation();
            }
        }));
        // the lib does not get the focus out event for some reason
        // so register it here
        if (this.hasAutoCommitEdit) {
            this._bindEventService.bind(this._input, 'focusout', () => {
                this.save();
            });
        }
    }
    destroy() {
        var _a, _b;
        this._bindEventService.unbindAll();
        (_b = (_a = this._input) === null || _a === void 0 ? void 0 : _a.remove) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
    focus() {
        if (this._input) {
            this._input.focus();
        }
    }
    getValue() {
        var _a;
        return ((_a = this._input) === null || _a === void 0 ? void 0 : _a.value) || '';
    }
    setValue(value) {
        if (this._input) {
            this._input.value = `${value}`;
        }
    }
    applyValue(item, state) {
        var _a, _b, _c;
        const fieldName = this.columnDef && this.columnDef.field;
        if (fieldName !== undefined) {
            const isComplexObject = (fieldName === null || fieldName === void 0 ? void 0 : fieldName.indexOf('.')) > 0; // is the field a complex object, "address.streetNumber"
            // validate the value before applying it (if not valid we'll set an empty string)
            const validation = this.validate(state);
            const newValue = (validation === null || validation === void 0 ? void 0 : validation.valid) ? state : '';
            // set the new value to the item datacontext
            if (isComplexObject) {
                // when it's a complex object, user could override the object path (where the editable object is located)
                // else we use the path provided in the Field Column Definition
                const objectPath = (_c = (_b = (_a = this.columnEditor) === null || _a === void 0 ? void 0 : _a.complexObjectPath) !== null && _b !== void 0 ? _b : fieldName) !== null && _c !== void 0 ? _c : '';
                setDeepValue(item, objectPath, newValue);
            }
            else if (fieldName) {
                item[fieldName] = newValue;
            }
        }
    }
    isValueChanged() {
        var _a;
        const elmValue = (_a = this._input) === null || _a === void 0 ? void 0 : _a.value;
        const lastKeyEvent = this._lastInputKeyEvent && this._lastInputKeyEvent.keyCode;
        if (this.columnEditor && this.columnEditor.alwaysSaveOnEnterKey && lastKeyEvent === KeyCode.ENTER) {
            return true;
        }
        return (!(elmValue === '' && (this._originalValue === null || this._originalValue === undefined))) && (elmValue !== this._originalValue);
    }
    loadValue(item) {
        const fieldName = this.columnDef && this.columnDef.field;
        if (item && fieldName !== undefined && this._input) {
            // is the field a complex object, "address.streetNumber"
            const isComplexObject = (fieldName === null || fieldName === void 0 ? void 0 : fieldName.indexOf('.')) > 0;
            const value = (isComplexObject) ? getDescendantProperty(item, fieldName) : (item.hasOwnProperty(fieldName) && item[fieldName] || '');
            this._originalValue = value;
            this._input.value = this._originalValue;
            this._input.select();
        }
    }
    save() {
        const validation = this.validate();
        const isValid = (validation && validation.valid) || false;
        if (this.hasAutoCommitEdit && isValid) {
            // do not use args.commitChanges() as this sets the focus to the next row.
            // also the select list will stay shown when clicking off the grid
            this.grid.getEditorLock().commitCurrentEdit();
        }
        else {
            this.args.commitChanges();
        }
    }
    serializeValue() {
        var _a, _b;
        return (_b = (_a = this._input) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '';
    }
    validate(inputValue) {
        const elmValue = (inputValue !== undefined) ? inputValue : this._input && this._input.value;
        return textValidator(elmValue, {
            editorArgs: this.args,
            errorMessage: this.columnEditor.errorMessage,
            minLength: this.columnEditor.minLength,
            maxLength: this.columnEditor.maxLength,
            operatorConditionalType: this.columnEditor.operatorConditionalType,
            required: this.columnEditor.required,
            validator: this.validator,
        });
    }
}

const DEFAULT_DECIMAL_PLACES = 0;
class FloatEditor extends InputEditor {
    constructor(args) {
        super(args, 'number');
        this.args = args;
    }
    /** Initialize the Editor */
    init() {
        var _a, _b, _c, _d, _e, _f;
        if (this.columnDef && this.columnEditor && this.args) {
            const columnId = (_b = (_a = this.columnDef) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '';
            const placeholder = (_d = (_c = this.columnEditor) === null || _c === void 0 ? void 0 : _c.placeholder) !== null && _d !== void 0 ? _d : '';
            const title = (_f = (_e = this.columnEditor) === null || _e === void 0 ? void 0 : _e.title) !== null && _f !== void 0 ? _f : '';
            const inputStep = (this.columnEditor.valueStep !== undefined) ? this.columnEditor.valueStep : this.getInputDecimalSteps();
            this._input = document.createElement('input');
            this._input.className = `editor-text editor-${columnId}`;
            this._input.type = 'number';
            this._input.setAttribute('role', 'presentation');
            this._input.autocomplete = 'off';
            this._input.placeholder = placeholder;
            this._input.title = title;
            this._input.step = `${inputStep}`;
            const cellContainer = this.args.container;
            if (cellContainer && typeof cellContainer.appendChild === 'function') {
                cellContainer.appendChild(this._input);
            }
            this._bindEventService.bind(this._input, 'focus', () => { var _a; return (_a = this._input) === null || _a === void 0 ? void 0 : _a.select(); });
            this._bindEventService.bind(this._input, 'keydown', ((event) => {
                this._lastInputKeyEvent = event;
                if (event.keyCode === KeyCode.LEFT || event.keyCode === KeyCode.RIGHT) {
                    event.stopImmediatePropagation();
                }
            }));
            // the lib does not get the focus out event for some reason
            // so register it here
            if (this.hasAutoCommitEdit) {
                this._bindEventService.bind(this._input, 'focusout', () => {
                    this.save();
                });
            }
        }
    }
    getDecimalPlaces() {
        var _a, _b, _c, _d, _e;
        // returns the number of fixed decimal places or null
        let rtn = (_e = (_b = (_a = this.columnEditor) === null || _a === void 0 ? void 0 : _a.decimal) !== null && _b !== void 0 ? _b : (_d = (_c = this.columnEditor) === null || _c === void 0 ? void 0 : _c.params) === null || _d === void 0 ? void 0 : _d.decimalPlaces) !== null && _e !== void 0 ? _e : undefined;
        if (rtn === undefined) {
            rtn = DEFAULT_DECIMAL_PLACES;
        }
        return (!rtn && rtn !== 0 ? null : rtn);
    }
    getInputDecimalSteps() {
        const decimals = this.getDecimalPlaces();
        let zeroString = '';
        for (let i = 1; i < decimals; i++) {
            zeroString += '0';
        }
        if (decimals > 0) {
            return `0.${zeroString}1`;
        }
        return '1';
    }
    loadValue(item) {
        const fieldName = this.columnDef && this.columnDef.field;
        if (fieldName !== undefined) {
            if (item && fieldName !== undefined && this._input) {
                // is the field a complex object, "address.streetNumber"
                const isComplexObject = (fieldName === null || fieldName === void 0 ? void 0 : fieldName.indexOf('.')) > 0;
                const value = (isComplexObject) ? getDescendantProperty(item, fieldName) : item[fieldName];
                this._originalValue = value;
                const decPlaces = this.getDecimalPlaces();
                if (decPlaces !== null && (this._originalValue || this._originalValue === 0) && (+this._originalValue).toFixed) {
                    this._originalValue = (+this._originalValue).toFixed(decPlaces);
                }
                this._input.value = `${this._originalValue}`;
                this._input.select();
            }
        }
    }
    serializeValue() {
        var _a;
        const elmValue = (_a = this._input) === null || _a === void 0 ? void 0 : _a.value;
        if (elmValue === undefined || elmValue === '' || isNaN(+elmValue)) {
            return elmValue;
        }
        let rtn = parseFloat(elmValue);
        const decPlaces = this.getDecimalPlaces();
        if (decPlaces !== null && (rtn || rtn === 0) && rtn.toFixed) {
            rtn = parseFloat(rtn.toFixed(decPlaces));
        }
        return rtn;
    }
    validate(inputValue) {
        var _a;
        const elmValue = (inputValue !== undefined) ? inputValue : (_a = this._input) === null || _a === void 0 ? void 0 : _a.value;
        return floatValidator(elmValue, {
            editorArgs: this.args,
            errorMessage: this.columnEditor.errorMessage,
            decimal: this.getDecimalPlaces(),
            minValue: this.columnEditor.minValue,
            maxValue: this.columnEditor.maxValue,
            operatorConditionalType: this.columnEditor.operatorConditionalType,
            required: this.columnEditor.required,
            validator: this.validator,
        });
    }
}

class InputPasswordEditor extends InputEditor {
    /** Initialize the Editor */
    constructor(args) {
        super(args, 'password');
        this.args = args;
    }
}

class IntegerEditor extends InputEditor {
    constructor(args) {
        super(args, 'number');
        this.args = args;
    }
    /** Initialize the Editor */
    init() {
        var _a, _b, _c, _d, _e, _f;
        if (this.columnDef && this.columnEditor && this.args) {
            const columnId = (_b = (_a = this.columnDef) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '';
            const placeholder = (_d = (_c = this.columnEditor) === null || _c === void 0 ? void 0 : _c.placeholder) !== null && _d !== void 0 ? _d : '';
            const title = (_f = (_e = this.columnEditor) === null || _e === void 0 ? void 0 : _e.title) !== null && _f !== void 0 ? _f : '';
            const inputStep = (this.columnEditor.valueStep !== undefined) ? this.columnEditor.valueStep : '1';
            this._input = document.createElement('input');
            this._input.className = `editor-text editor-${columnId}`;
            this._input.type = 'number';
            this._input.setAttribute('role', 'presentation');
            this._input.autocomplete = 'off';
            this._input.placeholder = placeholder;
            this._input.title = title;
            this._input.step = `${inputStep}`;
            const cellContainer = this.args.container;
            if (cellContainer && typeof cellContainer.appendChild === 'function') {
                cellContainer.appendChild(this._input);
            }
            this._bindEventService.bind(this._input, 'focus', () => { var _a; return (_a = this._input) === null || _a === void 0 ? void 0 : _a.select(); });
            this._bindEventService.bind(this._input, 'keydown', ((event) => {
                this._lastInputKeyEvent = event;
                if (event.keyCode === KeyCode.LEFT || event.keyCode === KeyCode.RIGHT) {
                    event.stopImmediatePropagation();
                }
            }));
            // the lib does not get the focus out event for some reason
            // so register it here
            if (this.hasAutoCommitEdit) {
                this._bindEventService.bind(this._input, 'focusout', () => {
                    this.save();
                });
            }
        }
    }
    loadValue(item) {
        const fieldName = this.columnDef && this.columnDef.field;
        if (fieldName !== undefined) {
            if (item && fieldName !== undefined && this._input) {
                // is the field a complex object, "address.streetNumber"
                const isComplexObject = (fieldName === null || fieldName === void 0 ? void 0 : fieldName.indexOf('.')) > 0;
                const value = (isComplexObject) ? getDescendantProperty(item, fieldName) : item[fieldName];
                this._originalValue = (isNaN(value) || value === null || value === undefined) ? value : `${value}`;
                this._input.value = `${this._originalValue}`;
                this._input.select();
            }
        }
    }
    serializeValue() {
        var _a;
        const elmValue = (_a = this._input) === null || _a === void 0 ? void 0 : _a.value;
        if (elmValue === undefined || elmValue === '' || isNaN(+elmValue)) {
            return elmValue;
        }
        const output = isNaN(+elmValue) ? elmValue : parseInt(elmValue, 10);
        return isNaN(+output) ? elmValue : output;
    }
    validate(inputValue) {
        const elmValue = (inputValue !== undefined) ? inputValue : this.getValue();
        return integerValidator(elmValue, {
            editorArgs: this.args,
            errorMessage: this.columnEditor.errorMessage,
            minValue: this.columnEditor.minValue,
            maxValue: this.columnEditor.maxValue,
            operatorConditionalType: this.columnEditor.operatorConditionalType,
            required: this.columnEditor.required,
            validator: this.validator,
        });
    }
}

/*
 * An example of a 'detached' editor.
 * The UI is added onto document BODY and .position(), .show() and .hide() are implemented.
 * KeyDown events are also handled to provide handling for Tab, Shift-Tab, Esc and Ctrl-Enter.
 */
class LongTextEditor {
    constructor(args) {
        this.args = args;
        if (!args) {
            throw new Error('[Angular-SlickGrid] Something is wrong with this grid, an Editor must always have valid arguments.');
        }
        this.grid = args.grid;
        this.gridOptions = args.grid.getOptions();
        const options = this.gridOptions || this.args.column.params || {};
        if (options && options.i18n instanceof TranslateService) {
            this._translate = options.i18n;
        }
        // get locales provided by user in forRoot or else use default English locales via the Constants
        this._locales = this.gridOptions && this.gridOptions.locales || Constants.locales;
        this._bindEventService = new BindingEventService();
        this.init();
    }
    /** Get Column Definition object */
    get columnDef() {
        return this.args.column;
    }
    /** Get Column Editor object */
    get columnEditor() {
        var _a, _b;
        return (_b = (_a = this.columnDef) === null || _a === void 0 ? void 0 : _a.internalColumnEditor) !== null && _b !== void 0 ? _b : {};
    }
    /** Getter for the Editor DOM Element */
    get editorDomElement() {
        return this._textareaElm;
    }
    get editorOptions() {
        var _a, _b;
        return (_b = (_a = this.columnEditor) === null || _a === void 0 ? void 0 : _a.editorOptions) !== null && _b !== void 0 ? _b : {};
    }
    get hasAutoCommitEdit() {
        var _a;
        return (_a = this.gridOptions.autoCommitEdit) !== null && _a !== void 0 ? _a : false;
    }
    /** Get the Validator function, can be passed in Editor property or Column Definition */
    get validator() {
        var _a, _b, _c;
        return (_b = (_a = this.columnEditor) === null || _a === void 0 ? void 0 : _a.validator) !== null && _b !== void 0 ? _b : (_c = this.columnDef) === null || _c === void 0 ? void 0 : _c.validator;
    }
    init() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;
        let cancelText = '';
        let saveText = '';
        if (((_a = this._translate) === null || _a === void 0 ? void 0 : _a.instant) && this.gridOptions.enableTranslate) {
            const translationPrefix = getTranslationPrefix(this.gridOptions);
            const cancelKey = (_c = (_b = this.editorOptions.buttonTexts) === null || _b === void 0 ? void 0 : _b.cancelKey) !== null && _c !== void 0 ? _c : `${translationPrefix}CANCEL`;
            const saveKey = (_e = (_d = this.editorOptions.buttonTexts) === null || _d === void 0 ? void 0 : _d.saveKey) !== null && _e !== void 0 ? _e : `${translationPrefix}SAVE`;
            cancelText = this._translate.instant(`${translationPrefix}${cancelKey}`);
            saveText = this._translate.instant(`${translationPrefix}${saveKey}`);
        }
        else {
            cancelText = (_j = (_g = (_f = this.editorOptions.buttonTexts) === null || _f === void 0 ? void 0 : _f.cancel) !== null && _g !== void 0 ? _g : (_h = this._locales) === null || _h === void 0 ? void 0 : _h.TEXT_CANCEL) !== null && _j !== void 0 ? _j : 'Cancel';
            saveText = (_o = (_l = (_k = this.editorOptions.buttonTexts) === null || _k === void 0 ? void 0 : _k.save) !== null && _l !== void 0 ? _l : (_m = this._locales) === null || _m === void 0 ? void 0 : _m.TEXT_SAVE) !== null && _o !== void 0 ? _o : 'Save';
        }
        const columnId = (_q = (_p = this.columnDef) === null || _p === void 0 ? void 0 : _p.id) !== null && _q !== void 0 ? _q : '';
        const placeholder = (_s = (_r = this.columnEditor) === null || _r === void 0 ? void 0 : _r.placeholder) !== null && _s !== void 0 ? _s : '';
        const title = (_u = (_t = this.columnEditor) === null || _t === void 0 ? void 0 : _t.title) !== null && _u !== void 0 ? _u : '';
        const maxLength = (_v = this.columnEditor) === null || _v === void 0 ? void 0 : _v.maxLength;
        const textAreaCols = (_x = (_w = this.editorOptions) === null || _w === void 0 ? void 0 : _w.cols) !== null && _x !== void 0 ? _x : 40;
        const textAreaRows = (_z = (_y = this.editorOptions) === null || _y === void 0 ? void 0 : _y.rows) !== null && _z !== void 0 ? _z : 4;
        const containerElm = document.body;
        this._wrapperElm = document.createElement('div');
        this._wrapperElm.className = `slick-large-editor-text editor-${columnId}`;
        this._wrapperElm.style.position = 'absolute';
        containerElm.appendChild(this._wrapperElm);
        this._textareaElm = document.createElement('textarea');
        this._textareaElm.cols = textAreaCols;
        this._textareaElm.rows = textAreaRows;
        this._textareaElm.placeholder = placeholder;
        this._textareaElm.title = title;
        this._wrapperElm.appendChild(this._textareaElm);
        const editorFooterElm = document.createElement('div');
        editorFooterElm.className = 'editor-footer';
        const countContainerElm = document.createElement('span');
        countContainerElm.className = 'counter';
        this._currentLengthElm = document.createElement('span');
        this._currentLengthElm.className = 'text-length';
        this._currentLengthElm.textContent = '0';
        countContainerElm.appendChild(this._currentLengthElm);
        if (maxLength !== undefined) {
            const maxLengthSeparatorElm = document.createElement('span');
            maxLengthSeparatorElm.className = 'separator';
            maxLengthSeparatorElm.textContent = '/';
            const maxLengthElm = document.createElement('span');
            maxLengthElm.className = 'max-length';
            maxLengthElm.textContent = `${maxLength}`;
            countContainerElm.appendChild(maxLengthSeparatorElm);
            countContainerElm.appendChild(maxLengthElm);
        }
        editorFooterElm.appendChild(countContainerElm);
        const cancelBtnElm = document.createElement('button');
        cancelBtnElm.className = 'btn btn-cancel btn-default btn-xs';
        cancelBtnElm.textContent = cancelText;
        const saveBtnElm = document.createElement('button');
        saveBtnElm.className = 'btn btn-save btn-primary btn-xs';
        saveBtnElm.textContent = saveText;
        editorFooterElm.appendChild(cancelBtnElm);
        editorFooterElm.appendChild(saveBtnElm);
        this._bindEventService.bind(cancelBtnElm, 'click', this.cancel.bind(this));
        this._bindEventService.bind(saveBtnElm, 'click', this.save.bind(this));
        this.position((_0 = this.args) === null || _0 === void 0 ? void 0 : _0.position);
        this._textareaElm.focus();
        this._textareaElm.select();
        this._wrapperElm.appendChild(editorFooterElm);
        this._bindEventService.bind(this._textareaElm, 'keydown', this.handleKeyDown.bind(this));
        this._bindEventService.bind(this._textareaElm, 'input', this.handleOnInputChange.bind(this));
        this._bindEventService.bind(this._textareaElm, 'paste', this.handleOnInputChange.bind(this));
    }
    cancel() {
        var _a;
        const value = this._defaultTextValue || '';
        this._textareaElm.value = value;
        this._currentLengthElm.textContent = `${value.length}`;
        if ((_a = this.args) === null || _a === void 0 ? void 0 : _a.cancelChanges) {
            this.args.cancelChanges();
        }
    }
    hide() {
        this._wrapperElm.style.display = 'none';
    }
    show() {
        this._wrapperElm.style.display = 'block';
    }
    destroy() {
        var _a, _b;
        this._bindEventService.unbindAll();
        (_b = (_a = this._wrapperElm) === null || _a === void 0 ? void 0 : _a.remove) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
    focus() {
        if (this._textareaElm) {
            this._textareaElm.focus();
            this._textareaElm.select();
        }
    }
    getValue() {
        return this._textareaElm.value;
    }
    setValue(val) {
        this._textareaElm.value = val;
        this._currentLengthElm.textContent = `${val.length}`;
    }
    applyValue(item, state) {
        var _a, _b, _c, _d;
        const fieldName = (_a = this.columnDef) === null || _a === void 0 ? void 0 : _a.field;
        if (fieldName !== undefined) {
            const isComplexObject = (fieldName === null || fieldName === void 0 ? void 0 : fieldName.indexOf('.')) > 0; // is the field a complex object, "address.streetNumber"
            // validate the value before applying it (if not valid we'll set an empty string)
            const validation = this.validate(state);
            const newValue = (validation && validation.valid) ? state : '';
            // set the new value to the item datacontext
            if (isComplexObject) {
                // when it's a complex object, user could override the object path (where the editable object is located)
                // else we use the path provided in the Field Column Definition
                const objectPath = (_d = (_c = (_b = this.columnEditor) === null || _b === void 0 ? void 0 : _b.complexObjectPath) !== null && _c !== void 0 ? _c : fieldName) !== null && _d !== void 0 ? _d : '';
                setDeepValue(item, objectPath, newValue);
            }
            else {
                item[fieldName] = newValue;
            }
        }
    }
    isValueChanged() {
        const elmValue = this._textareaElm.value;
        return (!(elmValue === '' && (this._defaultTextValue === null || this._defaultTextValue === undefined))) && (elmValue !== this._defaultTextValue);
    }
    loadValue(item) {
        var _a;
        const fieldName = (_a = this.columnDef) === null || _a === void 0 ? void 0 : _a.field;
        if (item && fieldName !== undefined) {
            // is the field a complex object, "address.streetNumber"
            const isComplexObject = (fieldName === null || fieldName === void 0 ? void 0 : fieldName.indexOf('.')) > 0;
            const value = (isComplexObject) ? getDescendantProperty(item, fieldName) : item[fieldName];
            this._defaultTextValue = value || '';
            this._textareaElm.value = this._defaultTextValue;
            this._currentLengthElm.textContent = this._defaultTextValue.length;
            this._textareaElm.defaultValue = this._defaultTextValue;
            this._textareaElm.select();
        }
    }
    /**
     * Reposition the LongText Editor to be right over the cell, so that it looks like we opened the editor on top of the cell when in reality we just reposition (absolute) over the cell.
     * By default we use an "auto" mode which will allow to position the LongText Editor to the best logical position in the window, also when we say position, we are talking about the relative position against the grid cell.
     * We can assume that in 80% of the time the default position is bottom right, the default is "auto" but we can also override this and use a specific position.
     * Most of the time positioning of the editor will be to the "right" of the cell is ok but if our column is completely on the right side then we'll want to change the position to "left" align.
     * Same goes for the top/bottom position, Most of the time positioning the editor to the "bottom" but we are clicking on a cell at the bottom of the grid then we might need to reposition to "top" instead.
     */
    position(parentPosition) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const containerOffset = getHtmlElementOffset(this.args.container);
        const containerHeight = this.args.container.offsetHeight;
        const containerWidth = this.args.container.offsetWidth;
        const calculatedEditorHeight = this._wrapperElm.getBoundingClientRect().height || this.args.position.height;
        const calculatedEditorWidth = this._wrapperElm.getBoundingClientRect().width || this.args.position.width;
        const calculatedBodyHeight = document.body.offsetHeight || window.innerHeight; // body height/width might be 0 if so use the window height/width
        const calculatedBodyWidth = document.body.offsetWidth || window.innerWidth;
        // first defined position will be bottom/right (which will position the editor completely over the cell)
        let newPositionTop = (_b = (_a = containerOffset === null || containerOffset === void 0 ? void 0 : containerOffset.top) !== null && _a !== void 0 ? _a : parentPosition.top) !== null && _b !== void 0 ? _b : 0;
        let newPositionLeft = (_d = (_c = containerOffset === null || containerOffset === void 0 ? void 0 : containerOffset.left) !== null && _c !== void 0 ? _c : parentPosition.left) !== null && _d !== void 0 ? _d : 0;
        // user could explicitely use a "left" position (when user knows his column is completely on the right)
        // or when using "auto" and we detect not enough available space then we'll position to the "left" of the cell
        const position = (_f = (_e = this.editorOptions) === null || _e === void 0 ? void 0 : _e.position) !== null && _f !== void 0 ? _f : 'auto';
        if (position === 'left' || (position === 'auto' && (newPositionLeft + calculatedEditorWidth) > calculatedBodyWidth)) {
            const marginRightAdjustment = (_h = (_g = this.editorOptions) === null || _g === void 0 ? void 0 : _g.marginRight) !== null && _h !== void 0 ? _h : 0;
            newPositionLeft -= (calculatedEditorWidth - containerWidth + marginRightAdjustment);
        }
        // do the same calculation/reposition with top/bottom (default is bottom of the cell or in other word starting from the cell going down)
        if (position === 'top' || (position === 'auto' && (newPositionTop + calculatedEditorHeight) > calculatedBodyHeight)) {
            newPositionTop -= (calculatedEditorHeight - containerHeight);
        }
        // reposition the editor over the cell (90% of the time this will end up using a position on the "right" of the cell)
        this._wrapperElm.style.top = `${newPositionTop}px`;
        this._wrapperElm.style.left = `${newPositionLeft}px`;
    }
    save() {
        var _a;
        const validation = this.validate();
        const isValid = (_a = validation === null || validation === void 0 ? void 0 : validation.valid) !== null && _a !== void 0 ? _a : false;
        if (this.hasAutoCommitEdit && isValid) {
            // do not use args.commitChanges() as this sets the focus to the next row.
            // also the select list will stay shown when clicking off the grid
            this.grid.getEditorLock().commitCurrentEdit();
        }
        else {
            this.args.commitChanges();
        }
    }
    serializeValue() {
        return this._textareaElm.value;
    }
    validate(inputValue) {
        var _a;
        const elmValue = (inputValue !== undefined) ? inputValue : (_a = this._textareaElm) === null || _a === void 0 ? void 0 : _a.value;
        return textValidator(elmValue, {
            editorArgs: this.args,
            errorMessage: this.columnEditor.errorMessage,
            minLength: this.columnEditor.minLength,
            maxLength: this.columnEditor.maxLength,
            operatorConditionalType: this.columnEditor.operatorConditionalType,
            required: this.columnEditor.required,
            validator: this.validator,
        });
    }
    // --
    // protected functions
    // ------------------
    handleKeyDown(event) {
        var _a;
        const keyCode = (_a = event.keyCode) !== null && _a !== void 0 ? _a : event.code;
        if (keyCode === KeyCode.ENTER && event.ctrlKey) {
            this.save();
        }
        else if (keyCode === KeyCode.ESCAPE) {
            event.preventDefault();
            this.cancel();
        }
        else if (keyCode === KeyCode.TAB && event.shiftKey) {
            event.preventDefault();
            if (this.args && this.grid) {
                this.grid.navigatePrev();
            }
        }
        else if (keyCode === KeyCode.TAB) {
            event.preventDefault();
            if (this.args && this.grid) {
                this.grid.navigateNext();
            }
        }
    }
    /** On every input change event, we'll update the current text length counter */
    handleOnInputChange(event) {
        var _a;
        const maxLength = (_a = this.columnEditor) === null || _a === void 0 ? void 0 : _a.maxLength;
        // when user defines a maxLength, we'll make sure that it doesn't go over this limit if so then truncate the text (disregard the extra text)
        let isTruncated = false;
        if (maxLength) {
            isTruncated = this.truncateText(this._textareaElm, maxLength);
        }
        // if the text get truncated then update text length as maxLength, else update text length with actual
        if (isTruncated) {
            this._currentLengthElm.textContent = `${maxLength}`;
        }
        else {
            const newText = event.type === 'paste' ? event.clipboardData.getData('text') : event.target.value;
            this._currentLengthElm.textContent = `${newText.length}`;
        }
    }
    /**
     * Truncate text if the value is longer than the acceptable max length
     * @param inputElm - textarea html element
     * @param maxLength - max acceptable length
     * @returns truncated - returns True if it truncated or False otherwise
     */
    truncateText(inputElm, maxLength) {
        const text = inputElm.value + '';
        if (text.length > maxLength) {
            inputElm.value = text.substring(0, maxLength);
            return true;
        }
        return false;
    }
}

/**
 * Slickgrid editor class for multiple/single select lists
 */
class SelectEditor {
    constructor(args, isMultipleSelect) {
        this.args = args;
        this.isMultipleSelect = isMultipleSelect;
        /** Do we translate the label? */
        this.enableTranslateLabel = false;
        /** Observable Subscriptions */
        this._subscriptions = [];
        // flag to signal that the editor is destroying itself, helps prevent
        // commit changes from being called twice and erroring
        this._isDisposing = false;
        if (!args) {
            throw new Error('[Angular-SlickGrid] Something is wrong with this grid, an Editor must always have valid arguments.');
        }
        this.grid = args.grid;
        this.gridOptions = (this.grid.getOptions() || {});
        const options = this.gridOptions || this.args.column.params || {};
        if (options && options.i18n instanceof TranslateService) {
            this._translate = options.i18n;
        }
        // get locales provided by user in main file or else use default English locales via the Constants
        this._locales = this.gridOptions.locales || Constants.locales;
        // provide the name attribute to the DOM element which will be needed to auto-adjust drop position (dropup / dropdown)
        const fieldId = this.columnDef && this.columnDef.id;
        this.elementName = `editor-${fieldId}`;
        const libOptions = {
            autoAdjustDropHeight: true,
            autoAdjustDropPosition: true,
            autoAdjustDropWidthByTextSize: true,
            container: 'body',
            filter: false,
            maxHeight: 275,
            name: this.elementName,
            single: true,
            textTemplate: ($elm) => {
                // render HTML code or not, by default it is sanitized and won't be rendered
                const isRenderHtmlEnabled = this.columnDef && this.columnDef.internalColumnEditor && this.columnDef.internalColumnEditor.enableRenderHtml || false;
                return isRenderHtmlEnabled ? $elm.text() : $elm.html();
            },
            onClose: () => this.save(),
        };
        if (isMultipleSelect) {
            libOptions.single = false;
            libOptions.addTitle = true;
            libOptions.okButton = true;
            libOptions.selectAllDelimiter = ['', ''];
            if (this._translate && this._translate.instant && this._translate.currentLang) {
                const translationPrefix = getTranslationPrefix(this.gridOptions);
                libOptions.countSelected = this._translate.instant(`${translationPrefix}X_OF_Y_SELECTED`);
                libOptions.allSelected = this._translate.instant(`${translationPrefix}ALL_SELECTED`);
                libOptions.selectAllText = this._translate.instant(`${translationPrefix}SELECT_ALL`);
                libOptions.okButtonText = this._translate.instant(`${translationPrefix}OK`);
            }
            else {
                libOptions.countSelected = this._locales && this._locales.TEXT_X_OF_Y_SELECTED;
                libOptions.allSelected = this._locales && this._locales.TEXT_ALL_SELECTED;
                libOptions.selectAllText = this._locales && this._locales.TEXT_SELECT_ALL;
                libOptions.okButtonText = this._locales && this._locales.TEXT_OK;
            }
        }
        // assign the multiple select lib options
        this.defaultOptions = libOptions;
        this.init();
    }
    /** Get the Collection */
    get collection() {
        return this.columnDef && this.columnDef.internalColumnEditor && this.columnDef.internalColumnEditor.collection || [];
    }
    /** Getter for the Collection Options */
    get collectionOptions() {
        return this.columnDef && this.columnDef.internalColumnEditor && this.columnDef.internalColumnEditor.collectionOptions;
    }
    /** Get Column Definition object */
    get columnDef() {
        return this.args.column;
    }
    /** Get Column Editor object */
    get columnEditor() {
        return this.columnDef && this.columnDef.internalColumnEditor;
    }
    /** Get the Editor DOM Element */
    get editorDomElement() {
        return this.$editorElm;
    }
    /** Getter for the Custom Structure if exist */
    get customStructure() {
        return this.columnDef && this.columnDef.internalColumnEditor && this.columnDef.internalColumnEditor.customStructure;
    }
    get hasAutoCommitEdit() {
        var _a;
        return (_a = this.gridOptions.autoCommitEdit) !== null && _a !== void 0 ? _a : false;
    }
    /**
     * The current selected values (multiple select) from the collection
     */
    get currentValues() {
        const elmValue = this.$editorElm.val();
        // collection of strings, just return the filtered string that are equals
        if (this.collection.every(x => typeof x === 'string')) {
            return this.collection.filter(c => elmValue.indexOf(c.toString()) !== -1);
        }
        // collection of label/value pair
        const separatorBetweenLabels = this.collectionOptions && this.collectionOptions.separatorBetweenTextLabels || '';
        const isIncludingPrefixSuffix = this.collectionOptions && this.collectionOptions.includePrefixSuffixToSelectedValues || false;
        return this.collection
            .filter(c => elmValue.indexOf(c.hasOwnProperty(this.valueName) && c[this.valueName] !== null && c[this.valueName].toString()) !== -1)
            .map(c => {
            const labelText = c[this.valueName];
            let prefixText = c[this.labelPrefixName] || '';
            let suffixText = c[this.labelSuffixName] || '';
            // when it's a complex object, then pull the object name only, e.g.: "user.firstName" => "user"
            const fieldName = this.columnDef && this.columnDef.field;
            // is the field a complex object, "address.streetNumber"
            const isComplexObject = fieldName && fieldName.indexOf('.') > 0;
            const serializeComplexValueFormat = this.columnEditor && this.columnEditor.serializeComplexValueFormat || 'object';
            if (isComplexObject && typeof c === 'object' && serializeComplexValueFormat === 'object') {
                return c;
            }
            // also translate prefix/suffix if enableTranslateLabel is true and text is a string
            prefixText = (this.enableTranslateLabel && this._translate && prefixText && typeof prefixText === 'string') ? this._translate.instant(prefixText || ' ') : prefixText;
            suffixText = (this.enableTranslateLabel && this._translate && suffixText && typeof suffixText === 'string') ? this._translate.instant(suffixText || ' ') : suffixText;
            if (isIncludingPrefixSuffix) {
                const tmpOptionArray = [prefixText, labelText, suffixText].filter((text) => text); // add to a temp array for joining purpose and filter out empty text
                return tmpOptionArray.join(separatorBetweenLabels);
            }
            return labelText;
        });
    }
    /**
     * The current selected values (single select) from the collection
     */
    get currentValue() {
        const elmValue = this.$editorElm.val();
        // collection of strings, just return the filtered string that are equals
        if (this.collection.every(x => typeof x === 'string')) {
            return findOrDefault(this.collection, (c) => c.toString() === elmValue);
        }
        // collection of label/value pair
        const separatorBetweenLabels = this.collectionOptions && this.collectionOptions.separatorBetweenTextLabels || '';
        const isIncludingPrefixSuffix = this.collectionOptions && this.collectionOptions.includePrefixSuffixToSelectedValues || false;
        const itemFound = findOrDefault(this.collection, (c) => c.hasOwnProperty(this.valueName) && c[this.valueName] !== null && c[this.valueName].toString() === elmValue);
        // is the field a complex object, "address.streetNumber"
        const fieldName = this.columnDef && this.columnDef.field;
        const isComplexObject = fieldName && fieldName.indexOf('.') > 0;
        const serializeComplexValueFormat = this.columnEditor && this.columnEditor.serializeComplexValueFormat || 'object';
        if (isComplexObject && typeof itemFound === 'object' && serializeComplexValueFormat === 'object') {
            return itemFound;
        }
        else if (itemFound && itemFound.hasOwnProperty(this.valueName)) {
            const labelText = itemFound[this.valueName];
            if (isIncludingPrefixSuffix) {
                let prefixText = itemFound[this.labelPrefixName] || '';
                let suffixText = itemFound[this.labelSuffixName] || '';
                // also translate prefix/suffix if enableTranslateLabel is true and text is a string
                prefixText = (this.enableTranslateLabel && this._translate && prefixText && typeof prefixText === 'string') ? this._translate.instant(prefixText || ' ') : prefixText;
                suffixText = (this.enableTranslateLabel && this._translate && suffixText && typeof suffixText === 'string') ? this._translate.instant(suffixText || ' ') : suffixText;
                // add to a temp array for joining purpose and filter out empty text
                const tmpOptionArray = [prefixText, labelText, suffixText].filter((text) => text);
                return tmpOptionArray.join(separatorBetweenLabels);
            }
            return labelText;
        }
        return '';
    }
    /** Get the Validator function, can be passed in Editor property or Column Definition */
    get validator() {
        return this.columnEditor.validator || this.columnDef.validator;
    }
    init() {
        if (!this.columnDef || !this.columnDef.internalColumnEditor || (!this.columnDef.internalColumnEditor.collection && !this.columnDef.internalColumnEditor.collectionAsync)) {
            throw new Error(`[Angular-SlickGrid] You need to pass a "collection" (or "collectionAsync") inside Column Definition Editor for the MultipleSelect/SingleSelect Editor to work correctly.
      Also each option should include a value/label pair (or value/labelKey when using Locale).
      For example: { editor: { collection: [{ value: true, label: 'True' },{ value: false, label: 'False'}] } }`);
        }
        this._collectionService = new CollectionService(this._translate);
        this.enableTranslateLabel = (this.columnDef.internalColumnEditor.enableTranslateLabel) ? this.columnDef.internalColumnEditor.enableTranslateLabel : false;
        this.labelName = this.customStructure && this.customStructure.label || 'label';
        this.labelPrefixName = this.customStructure && this.customStructure.labelPrefix || 'labelPrefix';
        this.labelSuffixName = this.customStructure && this.customStructure.labelSuffix || 'labelSuffix';
        this.optionLabel = this.customStructure && this.customStructure.optionLabel || 'value';
        this.valueName = this.customStructure && this.customStructure.value || 'value';
        if (this.enableTranslateLabel && (!this._translate || typeof this._translate.instant !== 'function')) {
            throw new Error('[Angular-Slickgrid] requires "ngx-translate" to be installed and configured when the grid option "enableTranslate" is enabled.');
        }
        // always render the Select (dropdown) DOM element, even if user passed a "collectionAsync",
        // if that is the case, the Select will simply be without any options but we still have to render it (else SlickGrid would throw an error)
        this.renderDomElement(this.collection);
    }
    getValue() {
        return (this.isMultipleSelect) ? this.currentValues : this.currentValue;
    }
    setValue(value) {
        if (this.isMultipleSelect && Array.isArray(value)) {
            this.loadMultipleValues(value);
        }
        else {
            this.loadSingleValue(value);
        }
    }
    hide() {
        if (this.$editorElm && typeof this.$editorElm.multipleSelect === 'function') {
            this.$editorElm.multipleSelect('close');
        }
    }
    show() {
        if (this.$editorElm && typeof this.$editorElm.multipleSelect === 'function') {
            this.$editorElm.multipleSelect('open');
        }
    }
    applyValue(item, state) {
        const fieldName = this.columnDef && this.columnDef.field;
        const fieldType = this.columnDef && this.columnDef.type;
        let newValue = state;
        // when the provided user defined the column field type as a possible number then try parsing the state value as that
        if (fieldType === FieldType.number || fieldType === FieldType.integer || fieldType === FieldType.boolean) {
            newValue = parseFloat(state);
        }
        // when set as a multiple selection, we can assume that the 3rd party lib multiple-select will return a CSV string
        // we need to re-split that into an array to be the same as the original column
        if (this.isMultipleSelect && typeof state === 'string' && state.indexOf(',') >= 0) {
            newValue = state.split(',');
        }
        // is the field a complex object, "user.address.streetNumber"
        const isComplexObject = fieldName && fieldName.indexOf('.') > 0;
        // validate the value before applying it (if not valid we'll set an empty string)
        const validation = this.validate(newValue);
        newValue = (validation && validation.valid) ? newValue : '';
        // set the new value to the item datacontext
        if (isComplexObject) {
            // when it's a complex object, user could override the object path (where the editable object is located)
            // else we use the path provided in the Field Column Definition
            const objectPath = this.columnEditor && this.columnEditor.complexObjectPath || fieldName;
            setDeepValue(item, objectPath, newValue);
        }
        else {
            item[fieldName] = newValue;
        }
    }
    destroy() {
        // when autoCommitEdit is enabled, we might end up leaving an editor without it being saved, if so do call a save before destroying
        // this mainly happens doing a blur or focusing on another cell in the grid (it won't come here if we click outside the grid, in the body)
        if (this.$editorElm && this.hasAutoCommitEdit && this.isValueChanged() && !this._isDisposing) {
            this._isDisposing = true; // change destroying flag to avoid infinite loop
            this.save(true);
        }
        this._isDisposing = true;
        if (this.$editorElm && typeof this.$editorElm.multipleSelect === 'function') {
            this.$editorElm.multipleSelect('destroy');
            this.$editorElm.remove();
            const elementClassName = this.elementName.toString().replace('.', '\\.'); // make sure to escape any dot "." from CSS class to avoid console error
            $(`[name=${elementClassName}].ms-drop`).remove();
            this.$editorElm.remove();
            this.$editorElm = null;
        }
    }
    loadValue(item) {
        const fieldName = this.columnDef && this.columnDef.field;
        if (item && fieldName !== undefined) {
            // is the field a complex object, "address.streetNumber"
            const isComplexObject = fieldName && fieldName.indexOf('.') > 0;
            // when it's a complex object, user could override the object path (where the editable object is located)
            // else we use the path provided in the Field Column Definition
            const objectPath = this.columnEditor && this.columnEditor.complexObjectPath || fieldName;
            const currentValue = (isComplexObject) ? getDescendantProperty(item, objectPath) : item[fieldName];
            const value = (isComplexObject && currentValue && currentValue.hasOwnProperty(this.valueName)) ? currentValue[this.valueName] : currentValue;
            if (this.isMultipleSelect && Array.isArray(value)) {
                this.loadMultipleValues(value);
            }
            else {
                this.loadSingleValue(value);
            }
            this.refresh();
        }
    }
    loadMultipleValues(currentValues) {
        // convert to string because that is how the DOM will return these values
        if (Array.isArray(currentValues)) {
            // keep the default values in memory for references
            this.originalValue = currentValues.map((i) => i);
            // compare all the array values but as string type since multiple-select always return string
            const currentStringValues = currentValues.map((i) => i.toString());
            this.$editorElm.find('option').each((i, $e) => {
                $e.selected = (currentStringValues.indexOf($e.value) !== -1);
            });
        }
    }
    loadSingleValue(currentValue) {
        // keep the default value in memory for references
        this.originalValue = typeof currentValue === 'number' ? `${currentValue}` : currentValue;
        this.$editorElm.val(currentValue);
        // make sure the prop exists first
        this.$editorElm.find('option').each((i, $e) => {
            // check equality after converting originalValue to string since the DOM value will always be of type string
            $e.selected = (`${currentValue}` === $e.value);
        });
    }
    save(forceCommitCurrentEdit = false) {
        var _a;
        const validation = this.validate();
        const isValid = (_a = validation === null || validation === void 0 ? void 0 : validation.valid) !== null && _a !== void 0 ? _a : false;
        if ((!this._isDisposing || forceCommitCurrentEdit) && this.hasAutoCommitEdit && isValid) {
            // do not use args.commitChanges() as this sets the focus to the next row.
            // also the select list will stay shown when clicking off the grid
            this.grid.getEditorLock().commitCurrentEdit();
        }
        else {
            this.args.commitChanges();
        }
    }
    serializeValue() {
        return (this.isMultipleSelect) ? this.currentValues : this.currentValue;
    }
    focus() {
        if (this.$editorElm && this.$editorElm.multipleSelect) {
            this.$editorElm.multipleSelect('focus');
        }
    }
    isValueChanged() {
        var _a;
        const valueSelection = (_a = this.$editorElm) === null || _a === void 0 ? void 0 : _a.multipleSelect('getSelects');
        if (this.isMultipleSelect) {
            const isEqual = dequal(valueSelection, this.originalValue);
            return !isEqual;
        }
        const value = Array.isArray(valueSelection) && valueSelection.length > 0 ? valueSelection[0] : undefined;
        return value !== undefined && value !== this.originalValue;
    }
    validate(inputValue) {
        const isRequired = this.columnEditor.required;
        const elmValue = (inputValue !== undefined) ? inputValue : this.$editorElm && this.$editorElm.val && this.$editorElm.val();
        const errorMsg = this.columnEditor.errorMessage;
        if (this.validator) {
            const value = (inputValue !== undefined) ? inputValue : (this.isMultipleSelect ? this.currentValues : this.currentValue);
            return this.validator(value, this.args);
        }
        // by default the editor is almost always valid (except when it's required but not provided)
        if (isRequired && (elmValue === '' || (Array.isArray(elmValue) && elmValue.length === 0))) {
            return {
                valid: false,
                msg: errorMsg || Constants.VALIDATION_REQUIRED_FIELD
            };
        }
        return {
            valid: true,
            msg: null
        };
    }
    //
    // protected functions
    // ------------------
    /**
     * user might want to filter certain items of the collection
     * @param inputCollection
     * @return outputCollection filtered and/or sorted collection
     */
    filterCollection(inputCollection) {
        let outputCollection = inputCollection;
        // user might want to filter certain items of the collection
        if (this.columnEditor && this.columnEditor.collectionFilterBy) {
            const filterBy = this.columnEditor.collectionFilterBy;
            const filterCollectionBy = this.columnEditor.collectionOptions && this.columnEditor.collectionOptions.filterResultAfterEachPass || null;
            outputCollection = this._collectionService.filterCollection(outputCollection, filterBy, filterCollectionBy);
        }
        return outputCollection;
    }
    /**
     * user might want to sort the collection in a certain way
     * @param inputCollection
     * @return outputCollection sorted collection
     */
    sortCollection(inputCollection) {
        let outputCollection = inputCollection;
        // user might want to sort the collection
        if (this.columnDef.internalColumnEditor && this.columnDef.internalColumnEditor.collectionSortBy) {
            const sortBy = this.columnDef.internalColumnEditor.collectionSortBy;
            outputCollection = this._collectionService.sortCollection(this.columnDef, outputCollection, sortBy, this.enableTranslateLabel);
        }
        return outputCollection;
    }
    renderDomElement(inputCollection) {
        if (!Array.isArray(inputCollection) && this.collectionOptions && (this.collectionOptions.collectionInsideObjectProperty || this.collectionOptions.collectionInObjectProperty)) {
            const collectionInsideObjectProperty = this.collectionOptions.collectionInsideObjectProperty || this.collectionOptions.collectionInObjectProperty;
            inputCollection = getDescendantProperty(inputCollection, collectionInsideObjectProperty);
        }
        if (!Array.isArray(inputCollection)) {
            throw new Error('The "collection" passed to the Select Editor is not a valid array.');
        }
        // make a copy of the collection so that we don't impact SelectFilter, this could happen when calling "addBlankEntry" or "addCustomFirstEntry"
        let collection = [];
        if (inputCollection.length > 0) {
            collection = [...inputCollection];
        }
        // user can optionally add a blank entry at the beginning of the collection
        // make sure however that it wasn't added more than once
        if (this.collectionOptions && this.collectionOptions.addBlankEntry && Array.isArray(collection) && collection.length > 0 && collection[0][this.valueName] !== '') {
            collection.unshift(this.createBlankEntry());
        }
        // user can optionally add his own custom entry at the beginning of the collection
        if (this.collectionOptions && this.collectionOptions.addCustomFirstEntry && Array.isArray(collection) && collection.length > 0 && collection[0][this.valueName] !== this.collectionOptions.addCustomFirstEntry[this.valueName]) {
            collection.unshift(this.collectionOptions && this.collectionOptions.addCustomFirstEntry);
        }
        // user can optionally add his own custom entry at the end of the collection
        if (this.collectionOptions && this.collectionOptions.addCustomLastEntry && Array.isArray(collection) && collection.length > 0) {
            const lastCollectionIndex = collection.length - 1;
            if (collection[lastCollectionIndex][this.valueName] !== this.collectionOptions.addCustomLastEntry[this.valueName]) {
                collection.push(this.collectionOptions && this.collectionOptions.addCustomLastEntry);
            }
        }
        let newCollection = collection || [];
        // user might want to filter and/or sort certain items of the collection
        newCollection = this.filterCollection(newCollection);
        newCollection = this.sortCollection(newCollection);
        // user could also override the collection
        if (this.columnEditor && this.columnEditor.collectionOverride) {
            newCollection = this.columnEditor.collectionOverride(newCollection, { column: this.columnDef, dataContext: this.args.item, grid: this.grid });
        }
        // step 1, create HTML string template
        const selectBuildResult = buildSelectEditorOrFilterDomElement('editor', newCollection, this.columnDef, this.grid, this.isMultipleSelect, this._translate);
        // step 2, create the DOM Element of the editor
        // we will later also subscribe to the onClose event to save the Editor whenever that event is triggered
        this.createDomElement(selectBuildResult.selectElement);
    }
    /** Create a blank entry that can be added to the collection. It will also reuse the same customStructure if need be */
    createBlankEntry() {
        const blankEntry = {
            [this.labelName]: '',
            [this.valueName]: ''
        };
        if (this.labelPrefixName) {
            blankEntry[this.labelPrefixName] = '';
        }
        if (this.labelSuffixName) {
            blankEntry[this.labelSuffixName] = '';
        }
        return blankEntry;
    }
    /**
     * From the Select DOM Element created earlier, create a Multiple/Single Select Editor using the jQuery multiple-select.js lib
     * @param {Object} selectElement
     */
    createDomElement(selectElement) {
        this.$editorElm = $(selectElement);
        if (this.$editorElm && typeof this.$editorElm.appendTo === 'function') {
            this.$editorElm.appendTo(this.args.container);
        }
        // add placeholder when found
        const placeholder = this.columnEditor && this.columnEditor.placeholder || '';
        this.defaultOptions.placeholder = placeholder || '';
        if (typeof this.$editorElm.multipleSelect === 'function') {
            const elementOptions = (this.columnDef.internalColumnEditor) ? this.columnDef.internalColumnEditor.elementOptions : {};
            const editorOptions = (this.columnDef && this.columnDef.internalColumnEditor) ? this.columnDef.internalColumnEditor.editorOptions : {};
            this.editorElmOptions = Object.assign(Object.assign(Object.assign({}, this.defaultOptions), elementOptions), editorOptions);
            this.$editorElm = this.$editorElm.multipleSelect(this.editorElmOptions);
            setTimeout(() => this.show());
        }
    }
    // refresh the jquery object because the selected checkboxes were already set
    // prior to this method being called
    refresh() {
        if (typeof this.$editorElm.multipleSelect === 'function') {
            this.$editorElm.multipleSelect('refresh');
        }
    }
}

class MultipleSelectEditor extends SelectEditor {
    /**
     * Initialize the Editor
     */
    constructor(args) {
        super(args, true);
        this.args = args;
    }
}

class SingleSelectEditor extends SelectEditor {
    /**
     * Initialize the Editor
     */
    constructor(args) {
        super(args, false);
        this.args = args;
    }
}

const DEFAULT_MIN_VALUE = 0;
const DEFAULT_MAX_VALUE = 100;
const DEFAULT_STEP = 1;
class SliderEditor {
    constructor(args) {
        this.args = args;
        this._defaultValue = 0;
        this._elementRangeInputId = '';
        this._elementRangeOutputId = '';
        this.sliderNumberElm = null;
        if (!args) {
            throw new Error('[Angular-SlickGrid] Something is wrong with this grid, an Editor must always have valid arguments.');
        }
        this.grid = args.grid;
        this.gridOptions = (this.grid.getOptions() || {});
        this._bindEventService = new BindingEventService();
        this.init();
    }
    /** Get Column Definition object */
    get columnDef() {
        return this.args.column;
    }
    /** Get Column Editor object */
    get columnEditor() {
        return this.columnDef && this.columnDef.internalColumnEditor || {};
    }
    /** Getter for the Editor DOM Element */
    get editorDomElement() {
        return this._editorElm;
    }
    /** Getter for the Editor Input DOM Element */
    get editorInputDomElement() {
        return this._inputElm;
    }
    get hasAutoCommitEdit() {
        var _a;
        return (_a = this.gridOptions.autoCommitEdit) !== null && _a !== void 0 ? _a : false;
    }
    /** Getter for the Editor Generic Params */
    get editorParams() {
        return this.columnEditor.params || {};
    }
    /** Get the Validator function, can be passed in Editor property or Column Definition */
    get validator() {
        var _a, _b, _c;
        return (_b = (_a = this.columnEditor) === null || _a === void 0 ? void 0 : _a.validator) !== null && _b !== void 0 ? _b : (_c = this.columnDef) === null || _c === void 0 ? void 0 : _c.validator;
    }
    init() {
        var _a, _b, _c;
        const container = this.args && this.args.container;
        if (container && this.columnDef) {
            // define the input & slider number IDs
            const itemId = (_c = (_b = (_a = this.args) === null || _a === void 0 ? void 0 : _a.item) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : '';
            this._elementRangeInputId = `rangeInput_${this.columnDef.id}_${itemId}`;
            this._elementRangeOutputId = `rangeOutput_${this.columnDef.id}_${itemId}`;
            // create HTML string template
            this._editorElm = this.buildDomElement();
            this._inputElm = this._editorElm.querySelector('input');
            this.sliderNumberElm = this._editorElm.querySelector(`span.input-group-text.${this._elementRangeOutputId}`);
            this.focus();
            // watch on change event
            container.appendChild(this._editorElm);
            this._bindEventService.bind(this._editorElm, ['change', 'mouseup', 'touchend'], () => this.save());
            // if user chose to display the slider number on the right side, then update it every time it changes
            // we need to use both "input" and "change" event to be all cross-browser
            if (!this.editorParams.hideSliderNumber) {
                this._bindEventService.bind(this._editorElm, ['input', 'change'], this.handleChangeSliderNumber.bind(this));
            }
        }
    }
    cancel() {
        if (this._inputElm) {
            this._inputElm.value = `${this.originalValue}`;
        }
        this.args.cancelChanges();
    }
    destroy() {
        var _a, _b;
        this._bindEventService.unbindAll();
        (_b = (_a = this._inputElm) === null || _a === void 0 ? void 0 : _a.remove) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
    focus() {
        if (this._inputElm) {
            this._inputElm.focus();
        }
    }
    getValue() {
        var _a, _b;
        return (_b = (_a = this._inputElm) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '';
    }
    setValue(value) {
        if (this._inputElm) {
            this._inputElm.value = `${value}`;
        }
        if (this.sliderNumberElm) {
            this.sliderNumberElm.textContent = `${value}`;
        }
    }
    applyValue(item, state) {
        var _a, _b, _c, _d, _e;
        const fieldName = (_b = (_a = this.columnDef) === null || _a === void 0 ? void 0 : _a.field) !== null && _b !== void 0 ? _b : '';
        if (fieldName !== undefined) {
            const isComplexObject = (fieldName === null || fieldName === void 0 ? void 0 : fieldName.indexOf('.')) > 0; // is the field a complex object, "address.streetNumber"
            const validation = this.validate(state);
            const newValue = (validation && validation.valid) ? state : '';
            // set the new value to the item datacontext
            if (isComplexObject) {
                // when it's a complex object, user could override the object path (where the editable object is located)
                // else we use the path provided in the Field Column Definition
                const objectPath = (_e = (_d = (_c = this.columnEditor) === null || _c === void 0 ? void 0 : _c.complexObjectPath) !== null && _d !== void 0 ? _d : fieldName) !== null && _e !== void 0 ? _e : '';
                setDeepValue(item, objectPath, newValue);
            }
            else if (item) {
                item[fieldName] = newValue;
            }
        }
    }
    isValueChanged() {
        var _a, _b;
        const elmValue = (_b = (_a = this._inputElm) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '';
        return (!(elmValue === '' && this.originalValue === undefined)) && (+elmValue !== this.originalValue);
    }
    loadValue(item) {
        var _a, _b;
        const fieldName = (_b = (_a = this.columnDef) === null || _a === void 0 ? void 0 : _a.field) !== null && _b !== void 0 ? _b : '';
        if (item && fieldName !== undefined) {
            // is the field a complex object, "address.streetNumber"
            const isComplexObject = (fieldName === null || fieldName === void 0 ? void 0 : fieldName.indexOf('.')) > 0;
            let value = (isComplexObject) ? getDescendantProperty(item, fieldName) : (item.hasOwnProperty(fieldName) ? item[fieldName] : this._defaultValue);
            if (value === '' || value === null || value === undefined) {
                value = this._defaultValue; // load default value when item doesn't have any value
            }
            this.originalValue = +value;
            if (this._inputElm) {
                this._inputElm.value = `${value}`;
            }
            if (this.sliderNumberElm) {
                this.sliderNumberElm.textContent = `${value}`;
            }
        }
    }
    save() {
        const validation = this.validate();
        const isValid = (validation && validation.valid) || false;
        if (this.hasAutoCommitEdit && isValid) {
            // do not use args.commitChanges() as this sets the focus to the next row.
            // also the select list will stay shown when clicking off the grid
            this.grid.getEditorLock().commitCurrentEdit();
        }
        else {
            this.args.commitChanges();
        }
    }
    serializeValue() {
        var _a, _b;
        const elmValue = (_b = (_a = this._inputElm) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '';
        return elmValue !== '' ? parseInt(elmValue, 10) : this.originalValue;
    }
    validate(inputValue) {
        var _a;
        const elmValue = (inputValue !== undefined) ? inputValue : (_a = this._inputElm) === null || _a === void 0 ? void 0 : _a.value;
        return sliderValidator(elmValue, {
            editorArgs: this.args,
            errorMessage: this.columnEditor.errorMessage,
            minValue: this.columnEditor.minValue,
            maxValue: this.columnEditor.maxValue,
            required: this.columnEditor.required,
            validator: this.validator,
        });
    }
    //
    // protected functions
    // ------------------
    /**
     * Create the HTML template as a string
     */
    buildDomElement() {
        var _a, _b;
        const columnId = (_b = (_a = this.columnDef) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '';
        const title = this.columnEditor && this.columnEditor.title || '';
        const minValue = this.columnEditor.hasOwnProperty('minValue') ? this.columnEditor.minValue : DEFAULT_MIN_VALUE;
        const maxValue = this.columnEditor.hasOwnProperty('maxValue') ? this.columnEditor.maxValue : DEFAULT_MAX_VALUE;
        const defaultValue = this.editorParams.hasOwnProperty('sliderStartValue') ? this.editorParams.sliderStartValue : minValue;
        const step = this.columnEditor.hasOwnProperty('valueStep') ? this.columnEditor.valueStep : DEFAULT_STEP;
        this._defaultValue = defaultValue;
        const inputElm = document.createElement('input');
        inputElm.name = this._elementRangeInputId;
        inputElm.title = title;
        inputElm.type = 'range';
        inputElm.defaultValue = defaultValue;
        inputElm.value = defaultValue;
        inputElm.min = `${minValue}`;
        inputElm.max = `${maxValue}`;
        inputElm.step = `${step}`;
        inputElm.className = `form-control slider-editor-input editor-${columnId} range ${this._elementRangeInputId}`;
        const divContainerElm = document.createElement('div');
        divContainerElm.className = 'slider-container slider-editor';
        divContainerElm.appendChild(inputElm);
        if (!this.editorParams.hideSliderNumber) {
            divContainerElm.classList.add('input-group');
            // <div class="input-group-addon input-group-append slider-value"><span class="input-group-text ${this._elementRangeOutputId}">${defaultValue}</span></div>
            const spanGroupElm = document.createElement('span');
            spanGroupElm.className = `input-group-text ${this._elementRangeOutputId}`;
            spanGroupElm.textContent = `${defaultValue}`;
            const divGroupAddonElm = document.createElement('div');
            divGroupAddonElm.className = 'input-group-addon input-group-append slider-value';
            divGroupAddonElm.appendChild(spanGroupElm);
            divContainerElm.appendChild(divGroupAddonElm);
        }
        return divContainerElm;
    }
    handleChangeSliderNumber(event) {
        var _a, _b;
        const value = (_b = (_a = event.target) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '';
        if (value !== '' && this.sliderNumberElm) {
            this.sliderNumberElm.textContent = value;
        }
    }
}

const Editors = {
    /** AutoComplete Editor (using jQuery UI autocomplete feature) */
    autoComplete: AutoCompleteEditor,
    /** Checkbox Editor (uses native checkbox DOM element) */
    checkbox: CheckboxEditor,
    /** Date Picker Editor (which uses 3rd party lib "flatpickr") */
    date: DateEditor,
    /** Dual Input Editor, default input type is text but it could be (integer/float/number/password/text) */
    dualInput: DualInputEditor,
    /** Float Number Editor using an input of type "number" */
    float: FloatEditor,
    /** Integer Number Editor using an input of type "number" */
    integer: IntegerEditor,
    /** Long Text Editor (uses a textarea) */
    longText: LongTextEditor,
    /** Multiple Select editor (which uses 3rd party lib "multiple-select.js") */
    multipleSelect: MultipleSelectEditor,
    /** Editor with an input of type Password (note that only the text shown in the UI will be masked, the editor value is still plain text) */
    password: InputPasswordEditor,
    /** Single Select editor (which uses 3rd party lib "multiple-select.js") */
    singleSelect: SingleSelectEditor,
    /** Slider Editor using an input of type "range" */
    slider: SliderEditor,
    /** Text Editor using an input of type "text" */
    text: InputEditor
};

const alignRightFormatter = (_row, _cell, value) => {
    let outputValue = value;
    if (value === null || value === undefined) {
        outputValue = '';
    }
    return `<div style="float: right">${outputValue}</div>`;
};

const arrayObjectToCsvFormatter = (row, cell, value, columnDef, dataContext) => {
    const columnParams = columnDef && columnDef.params || {};
    const propertyNames = columnParams.propertyNames;
    let parentObjectKeyName = columnParams.dataContextProperty;
    if (!parentObjectKeyName) {
        parentObjectKeyName = columnDef && columnDef.field && columnDef.field.split('.')[0]; // e.g. "users.roles" would be "users"
    }
    if (!propertyNames || !Array.isArray(propertyNames) || !parentObjectKeyName) {
        throw new Error(`Formatters.arrayObjectToCsv requires you to pass an array of "propertyNames" (declared in "params") that you want to pull the data from.
      For example, if we have an array of user objects that have the property of firstName & lastName then we need to pass in your column definition:: { params: { propertyNames: ['firtName'] }}.
      Optionally, you can also pass the "dataContextProperty" if you wish to run this on another completely different field of the dataContext object.`);
    }
    // the dataContext holds all the data, so we can find the values we want even when "value" argument might be null
    // e.g. if we want to use the propertyNames of ['firstName', 'lastName'] from the "users" array of objects
    if (dataContext[parentObjectKeyName] && Array.isArray(dataContext[parentObjectKeyName])) {
        // we will 1st get the object from the dataContext, then
        if (Array.isArray(dataContext[parentObjectKeyName]) && dataContext[parentObjectKeyName].length > 0) {
            const outputStrings = [];
            dataContext[parentObjectKeyName].forEach((data) => {
                const strings = [];
                // 2nd from that data loop through all propertyNames we want to use (e.g.: ['firstName', 'lastName'])
                propertyNames.forEach((prop) => {
                    strings.push(data[prop]);
                });
                // we will join these strings with spaces (e.g. 'John Doe' where 'John' was firstName and 'Doe' was lastName)
                outputStrings.push(strings.join(' '));
            });
            // finally join all the output strings by CSV (e.g.: 'John Doe, Jane Doe')
            const output = outputStrings.join(', ');
            return `<span title="${output}">${output}</span>`;
        }
    }
    return value;
};

const arrayToCsvFormatter = (row, cell, value) => {
    if (value && Array.isArray(value) && value.length > 0) {
        const values = value.join(', ');
        return `<span title="${values}">${values}</span>`;
    }
    return value;
};

const boldFormatter = (row, cell, value) => {
    return value ? `<b>${value}</b>` : '';
};

const centerFormatter = (_row, _cell, value) => {
    let outputValue = value;
    if (value === null || value === undefined) {
        outputValue = '';
    }
    return `<center>${outputValue}</center>`;
};

const checkboxFormatter = (row, cell, value) => value ? '&#x2611;' : '';

const checkmarkFormatter = (row, cell, value) => {
    let isChecked = false;
    const isValidNumber = isNumber(value);
    if (isValidNumber) {
        value = +value; // convert to number before doing next condition
    }
    if (value === true || (isValidNumber && +value > 0) || (typeof value === 'string' && value.length > 0 && value.toLowerCase() !== 'false' && value !== '0')) {
        isChecked = true;
    }
    return isChecked ? `<i class="fa fa-check checkmark-icon" aria-hidden="true"></i>` : '';
};

/**
 * A formatter to show the label property value of an editor collection
 */
const collectionEditorFormatter = (row, cell, value, columnDef, dataContext, grid) => {
    if (!value || !columnDef || !columnDef.internalColumnEditor || !columnDef.internalColumnEditor.collection
        || !columnDef.internalColumnEditor.collection.length) {
        return value;
    }
    const { internalColumnEditor, internalColumnEditor: { collection } } = columnDef;
    const labelName = (internalColumnEditor.customStructure) ? internalColumnEditor.customStructure.label : 'label';
    const valueName = (internalColumnEditor.customStructure) ? internalColumnEditor.customStructure.value : 'value';
    if (Array.isArray(value)) {
        if (collection.every(x => typeof x === 'string')) {
            return arrayToCsvFormatter(row, cell, value.map((v) => findOrDefault(collection, (c) => c === v)), columnDef, dataContext, grid);
        }
        else {
            return arrayToCsvFormatter(row, cell, value.map((v) => findOrDefault(collection, (c) => c[valueName] === v)[labelName]), columnDef, dataContext, grid);
        }
    }
    return findOrDefault(collection, (c) => c[valueName] === value)[labelName] || '';
};

/**
 * A formatter to show the label property value of a params collection
 */
const collectionFormatter = (row, cell, value, columnDef, dataContext, grid) => {
    if (!value || !columnDef || !columnDef.params || !columnDef.params.collection
        || !columnDef.params.collection.length) {
        return value;
    }
    const { params, params: { collection } } = columnDef;
    const labelName = (params.customStructure) ? params.customStructure.label : 'label';
    const valueName = (params.customStructure) ? params.customStructure.value : 'value';
    if (Array.isArray(value)) {
        return arrayToCsvFormatter(row, cell, value.map((v) => findOrDefault(collection, (c) => c[valueName] === v)[labelName]), columnDef, dataContext, grid);
    }
    return findOrDefault(collection, (c) => c[valueName] === value)[labelName] || '';
};

const complexObjectFormatter = (row, cell, cellValue, columnDef, dataContext) => {
    if (!columnDef) {
        return '';
    }
    const columnParams = columnDef.params || {};
    const complexFieldLabel = columnParams && columnParams.complexFieldLabel || columnDef.field;
    if (!complexFieldLabel) {
        throw new Error(`For the Formatters.complexObject to work properly, you need to tell it which property of the complex object to use.
      There are 3 ways to provide it:
      1- via the generic "params" with a "complexFieldLabel" property on your Column Definition, example: this.columnDefs = [{ id: 'user', field: 'user', params: { complexFieldLabel: 'user.firstName' } }]
      2- via the generic "params" with a "complexFieldLabel" and a "labelKey" property on your Column Definition, example: this.columnDefs = [{ id: 'user', field: 'user', labelKey: 'firstName' params: { complexFieldLabel: 'user' } }]
      3- via the field name that includes a dot notation, example: this.columnDefs = [{ id: 'user', field: 'user.firstName'}] `);
    }
    if (columnDef.labelKey && dataContext.hasOwnProperty(complexFieldLabel)) {
        return dataContext[complexFieldLabel] && dataContext[complexFieldLabel][columnDef.labelKey];
    }
    // when complexFieldLabel includes the dot ".", we will do the split and get the value from the complex object
    // however we also need to make sure that the complex objet exist, else we'll return the cell value (original value)
    if (typeof complexFieldLabel === 'string' && complexFieldLabel.indexOf('.') > 0) {
        let outputValue = complexFieldLabel.split('.').reduce((obj, i) => (obj && obj.hasOwnProperty(i) ? obj[i] : ''), dataContext);
        if (outputValue === undefined || outputValue === null || (typeof outputValue === 'object' && Object.entries(outputValue).length === 0)) {
            outputValue = ''; // return empty string when value ends up being an empty object
        }
        return outputValue;
    }
    return cellValue;
};

const decimalFormatter = (row, cell, value, columnDef, dataContext, grid) => {
    const params = columnDef.params || {};
    let minDecimal = getValueFromParamsOrFormatterOptions('minDecimal', columnDef, grid, 2);
    let maxDecimal = getValueFromParamsOrFormatterOptions('maxDecimal', columnDef, grid, 2);
    const decimalSeparator = getValueFromParamsOrFormatterOptions('decimalSeparator', columnDef, grid, '.');
    const thousandSeparator = getValueFromParamsOrFormatterOptions('thousandSeparator', columnDef, grid, '');
    const displayNegativeNumberWithParentheses = getValueFromParamsOrFormatterOptions('displayNegativeNumberWithParentheses', columnDef, grid, false);
    // @deprecated: decimalPlaces, minDecimalPlaces, maxDecimalPlaces
    // add these extra checks to support previous way of passing the decimal count
    if ((params.minDecimalPlaces !== null && params.minDecimalPlaces) || (params.decimalPlaces !== null && params.decimalPlaces)) {
        console.warn('[Angular-Slickgrid] please consider using "minDecimal" (instead of "minDecimalPlaces" or "decimalPlaces").');
        minDecimal = (params.minDecimalPlaces !== null && params.minDecimalPlaces) || (params.decimalPlaces !== null && params.decimalPlaces);
    }
    if (params.maxDecimalPlaces !== null && params.maxDecimalPlaces) {
        console.warn('[Angular-Slickgrid] please consider using "maxDecimal" (instead of "maxDecimalPlaces").');
        maxDecimal = (params.maxDecimalPlaces !== null && params.maxDecimalPlaces);
    }
    if (isNumber(value)) {
        return formatNumber(value, minDecimal, maxDecimal, displayNegativeNumberWithParentheses, '', '', decimalSeparator, thousandSeparator);
    }
    return value;
};

const deleteIconFormatter = () => `<i class="fa fa-trash pointer delete-icon" aria-hidden="true"></i>`;

const dollarFormatter = (row, cell, value, columnDef, dataContext, grid) => {
    const minDecimal = getValueFromParamsOrFormatterOptions('minDecimal', columnDef, grid, 2);
    const maxDecimal = getValueFromParamsOrFormatterOptions('maxDecimal', columnDef, grid, 4);
    const decimalSeparator = getValueFromParamsOrFormatterOptions('decimalSeparator', columnDef, grid, '.');
    const thousandSeparator = getValueFromParamsOrFormatterOptions('thousandSeparator', columnDef, grid, '');
    const displayNegativeNumberWithParentheses = getValueFromParamsOrFormatterOptions('displayNegativeNumberWithParentheses', columnDef, grid, false);
    if (isNumber(value)) {
        return formatNumber(value, minDecimal, maxDecimal, displayNegativeNumberWithParentheses, '$', '', decimalSeparator, thousandSeparator);
    }
    return value;
};

const dollarColoredFormatter = (row, cell, value, columnDef, dataContext, grid) => {
    const minDecimal = getValueFromParamsOrFormatterOptions('minDecimal', columnDef, grid, 2);
    const maxDecimal = getValueFromParamsOrFormatterOptions('maxDecimal', columnDef, grid, 4);
    const decimalSeparator = getValueFromParamsOrFormatterOptions('decimalSeparator', columnDef, grid, '.');
    const thousandSeparator = getValueFromParamsOrFormatterOptions('thousandSeparator', columnDef, grid, '');
    const displayNegativeNumberWithParentheses = getValueFromParamsOrFormatterOptions('displayNegativeNumberWithParentheses', columnDef, grid, false);
    if (isNumber(value)) {
        const colorStyle = (value >= 0) ? 'green' : 'red';
        const formattedNumber = formatNumber(value, minDecimal, maxDecimal, displayNegativeNumberWithParentheses, '$', '', decimalSeparator, thousandSeparator);
        return `<span style="color:${colorStyle}">${formattedNumber}</span>`;
    }
    return value;
};

const dollarColoredBoldFormatter = (row, cell, value, columnDef, dataContext, grid) => {
    const minDecimal = getValueFromParamsOrFormatterOptions('minDecimal', columnDef, grid, 2);
    const maxDecimal = getValueFromParamsOrFormatterOptions('maxDecimal', columnDef, grid, 4);
    const decimalSeparator = getValueFromParamsOrFormatterOptions('decimalSeparator', columnDef, grid, '.');
    const thousandSeparator = getValueFromParamsOrFormatterOptions('thousandSeparator', columnDef, grid, '');
    const displayNegativeNumberWithParentheses = getValueFromParamsOrFormatterOptions('displayNegativeNumberWithParentheses', columnDef, grid, false);
    if (isNumber(value)) {
        const colorStyle = (value >= 0) ? 'green' : 'red';
        const formattedNumber = formatNumber(value, minDecimal, maxDecimal, displayNegativeNumberWithParentheses, '$', '', decimalSeparator, thousandSeparator);
        return `<span style="color:${colorStyle}; font-weight:bold;">${formattedNumber}</span>`;
    }
    return value;
};

const editIconFormatter = (row, cell, value, columnDef, dataContext) => `<i class="fa fa-pencil pointer edit-icon" aria-hidden="true"></i>`;

const fakeHyperlinkFormatter = (_row, _cell, value) => {
    return value ? `<span class="fake-hyperlink">${value}</span>` : '';
};

const DOMPurify$1 = DOMPurify_; // patch to fix rollup to work
/**
 * Takes an hyperlink cell value and transforms it into a real hyperlink, given that the value starts with 1 of these (http|ftp|https).
 * The structure will be "<a href="hyperlink">hyperlink</a>"
 *
 * You can optionally change the hyperlink text displayed by using the generic params "hyperlinkText" in the column definition
 * For example: { id: 'link', field: 'link', params: { hyperlinkText: 'Company Website' } } will display "<a href="link">Company Website</a>"
 *
 * You can also optionally provide the hyperlink URL by using the generic params "hyperlinkUrl" in the column definition
 * For example: { id: 'link', field: 'link', params: {  hyperlinkText: 'Company Website', hyperlinkUrl: 'http://www.somewhere.com' } } will display "<a href="http://www.somewhere.com">Company Website</a>"
 */
const hyperlinkFormatter = (row, cell, value, columnDef, dataContext) => {
    const columnParams = columnDef && columnDef.params || {};
    let displayedText = columnParams.hyperlinkText ? columnParams.hyperlinkText : value;
    displayedText = DOMPurify$1.sanitize(displayedText || '');
    let outputLink = columnParams.hyperlinkUrl ? columnParams.hyperlinkUrl : value;
    outputLink = DOMPurify$1.sanitize(outputLink || '');
    const matchUrl = outputLink.match(/^(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&amp;:\/~\+#]*[\w\-\@?^=%&amp;\/~\+#])?/i);
    if (matchUrl && Array.isArray(matchUrl) && matchUrl.length > 0) {
        const finalUrl = matchUrl[0];
        return `<a href="${finalUrl}">${displayedText}</a>`;
    }
    return value;
};

const iconFormatter = (row, cell, value, columnDef, dataContext) => {
    const columnParams = columnDef && columnDef.params || {};
    const icon = columnParams.icon || columnParams.formatterIcon;
    if (!icon) {
        throw new Error(`You must provide the "icon" or "formatterIcon" via the generic "params" options (e.g.: { formatter: Formatters.icon, params: { formatterIcon: 'fa fa-search' }}`);
    }
    return `<i class="${icon}" aria-hidden="true"></i>`;
};

const infoIconFormatter = () => `<i class="fa fa-info-circle pointer info-icon" aria-hidden="true"></i>`;

const italicFormatter = (row, cell, value) => {
    return value ? `<i>${value}</i>` : '';
};

const lowercaseFormatter = (row, cell, value) => {
    // make sure the value is a string
    if (value !== undefined && typeof value !== 'string') {
        value = value + '';
    }
    return value ? value.toLowerCase() : '';
};

/**
 * Takes a value display it according to a mask provided
 * e.: 1234567890 with mask "(000) 000-0000" will display "(123) 456-7890"
 */
const maskFormatter = (row, cell, value, columnDef) => {
    const params = columnDef.params || {};
    const mask = params.mask;
    if (!mask) {
        throw new Error(`You must provide a "mask" via the generic "params" options (e.g.: { formatter: Formatters.mask, params: { mask: '000-000' }}`);
    }
    if (value) {
        let i = 0;
        const v = value.toString();
        return mask.replace(/[09A]/gi, () => v[i++] || '');
    }
    return value;
};

const multipleFormatter = (row, cell, value, columnDef, dataContext, grid) => {
    const params = columnDef.params || {};
    if (!params.formatters || !Array.isArray(params.formatters)) {
        throw new Error(`The multiple formatter requires the "formatters" to be provided as a column params.
    For example: this.columnDefinitions = [{ id: title, field: title, formatter: Formatters.multiple, params: { formatters: [Formatters.lowercase, Formatters.uppercase] }`);
    }
    const formatters = params.formatters;
    // loop through all Formatters, the value of 1st formatter will be used by 2nd formatter and so on.
    // they are piped and executed in sequences
    let currentValue = value;
    for (const formatter of formatters) {
        currentValue = formatter(row, cell, currentValue, columnDef, dataContext, grid);
    }
    return currentValue;
};

const percentFormatter = (row, cell, value, columnDef, dataContext, grid) => {
    const minDecimal = getValueFromParamsOrFormatterOptions('minDecimal', columnDef, grid);
    const maxDecimal = getValueFromParamsOrFormatterOptions('maxDecimal', columnDef, grid);
    const decimalSeparator = getValueFromParamsOrFormatterOptions('decimalSeparator', columnDef, grid, '.');
    const thousandSeparator = getValueFromParamsOrFormatterOptions('thousandSeparator', columnDef, grid, '');
    const displayNegativeNumberWithParentheses = getValueFromParamsOrFormatterOptions('displayNegativeNumberWithParentheses', columnDef, grid, false);
    if (isNumber(value)) {
        const percentValue = value * 100;
        return formatNumber(percentValue, minDecimal, maxDecimal, displayNegativeNumberWithParentheses, '', '%', decimalSeparator, thousandSeparator);
    }
    return value;
};

const percentCompleteBarFormatter = (row, cell, value) => {
    if (!isNumber(value)) {
        return '';
    }
    let color = '';
    let inputNumber = parseFloat(value);
    if (inputNumber > 100) {
        inputNumber = 100;
    }
    if (inputNumber < 30) {
        color = 'red';
    }
    else if (inputNumber < 70) {
        color = 'silver';
    }
    else {
        color = 'green';
    }
    return `<span class="percent-complete-bar" style="background:${color}; width:${inputNumber}%"></span>`;
};

const percentCompleteFormatter = (row, cell, value, columnDef, dataContext, grid) => {
    const minDecimal = getValueFromParamsOrFormatterOptions('minDecimal', columnDef, grid);
    const maxDecimal = getValueFromParamsOrFormatterOptions('maxDecimal', columnDef, grid);
    const decimalSeparator = getValueFromParamsOrFormatterOptions('decimalSeparator', columnDef, grid, '.');
    const thousandSeparator = getValueFromParamsOrFormatterOptions('thousandSeparator', columnDef, grid, '');
    const displayNegativeNumberWithParentheses = getValueFromParamsOrFormatterOptions('displayNegativeNumberWithParentheses', columnDef, grid, false);
    if (isNumber(value)) {
        const colorStyle = (value < 50) ? 'red' : 'green';
        const formattedNumber = formatNumber(value, minDecimal, maxDecimal, displayNegativeNumberWithParentheses, '', '%', decimalSeparator, thousandSeparator);
        const outputFormattedValue = value > 100 ? '100%' : formattedNumber;
        return `<span style='color:${colorStyle}'>${outputFormattedValue}</span>`;
    }
    return value;
};

const percentSymbolFormatter = (row, cell, value, columnDef, dataContext, grid) => {
    const minDecimal = getValueFromParamsOrFormatterOptions('minDecimal', columnDef, grid);
    const maxDecimal = getValueFromParamsOrFormatterOptions('maxDecimal', columnDef, grid);
    const decimalSeparator = getValueFromParamsOrFormatterOptions('decimalSeparator', columnDef, grid, '.');
    const thousandSeparator = getValueFromParamsOrFormatterOptions('thousandSeparator', columnDef, grid, '');
    const displayNegativeNumberWithParentheses = getValueFromParamsOrFormatterOptions('displayNegativeNumberWithParentheses', columnDef, grid, false);
    if (isNumber(value)) {
        return formatNumber(value, minDecimal, maxDecimal, displayNegativeNumberWithParentheses, '', '%', decimalSeparator, thousandSeparator);
    }
    return value;
};

const progressBarFormatter = (row, cell, value, columnDef, dataContext) => {
    if (!isNumber(value)) {
        return '';
    }
    let color = '';
    let inputNumber = parseFloat(value);
    if (inputNumber > 100) {
        inputNumber = 100;
    }
    if (inputNumber < 30) {
        color = 'danger';
    }
    else if (inputNumber < 70) {
        color = 'warning';
    }
    else {
        color = 'success';
    }
    const output = `<div class="progress">
    <div class="progress-bar progress-bar-${color} bg-${color}" role="progressbar" aria-valuenow="${inputNumber}" aria-valuemin="0" aria-valuemax="100" style="min-width: 2em; width: ${inputNumber}%;">
    ${inputNumber}%
    </div>
  </div>`;
    return output.replace(/\s{2,}/g, ' ').trim();
};

/** Takes a cell value and translates it with the "ngx-translate" service */
const translateFormatter = (row, cell, value, columnDef, dataContext, grid) => {
    const gridOptions = (grid && typeof grid.getOptions === 'function') ? grid.getOptions() : {};
    const translate = gridOptions.i18n || (columnDef && columnDef.params && columnDef.params.i18n);
    if (!translate || typeof translate.instant !== 'function') {
        throw new Error(`The translate formatter requires the "ngx-translate" Service to be provided as a Grid Options or Column Definition "i18n".
    For example: this.gridOptions = { enableTranslate: true, i18n: this.translate }`);
    }
    // make sure the value is a string (for example a boolean value would throw an error)
    if (value !== undefined && value !== null && typeof value !== 'string') {
        value = value + '';
    }
    return value ? translate.instant(value) : '';
};

/** Takes a boolean value, cast it to upperCase string and finally translates it with the "ngx-translate" service */
const translateBooleanFormatter = (row, cell, value, columnDef, dataContext, grid) => {
    const gridOptions = (grid && typeof grid.getOptions === 'function') ? grid.getOptions() : {};
    const translate = gridOptions.i18n || (columnDef && columnDef.params && columnDef.params.i18n);
    if (!translate || typeof translate.instant !== 'function') {
        throw new Error(`The translate formatter requires the "ngx-translate" Service to be provided as a Grid Options or Column Definition "i18n".
    For example: this.gridOptions = { enableTranslate: true, i18n: this.translate }`);
    }
    // make sure the value is a string (for example a boolean value would throw an error)
    if (value !== undefined && value !== null && typeof value !== 'string') {
        value = value + '';
    }
    return value ? translate.instant(value.toUpperCase()) : '';
};

/** Formatter that must be use with a Tree Data column */
const treeExportFormatter = (row, cell, value, columnDef, dataContext, grid) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    const gridOptions = grid.getOptions();
    const treeDataOptions = gridOptions === null || gridOptions === void 0 ? void 0 : gridOptions.treeDataOptions;
    const collapsedPropName = (_a = treeDataOptions === null || treeDataOptions === void 0 ? void 0 : treeDataOptions.collapsedPropName) !== null && _a !== void 0 ? _a : Constants.treeDataProperties.COLLAPSED_PROP;
    const hasChildrenPropName = (_b = treeDataOptions === null || treeDataOptions === void 0 ? void 0 : treeDataOptions.hasChildrenPropName) !== null && _b !== void 0 ? _b : Constants.treeDataProperties.HAS_CHILDREN_PROP;
    const treeLevelPropName = (_c = treeDataOptions === null || treeDataOptions === void 0 ? void 0 : treeDataOptions.levelPropName) !== null && _c !== void 0 ? _c : Constants.treeDataProperties.TREE_LEVEL_PROP;
    const indentMarginLeft = (_d = treeDataOptions === null || treeDataOptions === void 0 ? void 0 : treeDataOptions.exportIndentMarginLeft) !== null && _d !== void 0 ? _d : 5;
    const exportIndentationLeadingChar = (_e = treeDataOptions === null || treeDataOptions === void 0 ? void 0 : treeDataOptions.exportIndentationLeadingChar) !== null && _e !== void 0 ? _e : '.';
    const exportIndentationLeadingSpaceCount = (_f = treeDataOptions === null || treeDataOptions === void 0 ? void 0 : treeDataOptions.exportIndentationLeadingSpaceCount) !== null && _f !== void 0 ? _f : 3;
    const groupCollapsedSymbol = (_h = (_g = gridOptions === null || gridOptions === void 0 ? void 0 : gridOptions.excelExportOptions) === null || _g === void 0 ? void 0 : _g.groupCollapsedSymbol) !== null && _h !== void 0 ? _h : '⮞';
    const groupExpandedSymbol = (_k = (_j = gridOptions === null || gridOptions === void 0 ? void 0 : gridOptions.excelExportOptions) === null || _j === void 0 ? void 0 : _j.groupExpandedSymbol) !== null && _k !== void 0 ? _k : '⮟';
    let outputValue = value;
    if (typeof columnDef.queryFieldNameGetterFn === 'function') {
        const fieldName = columnDef.queryFieldNameGetterFn(dataContext);
        if ((fieldName === null || fieldName === void 0 ? void 0 : fieldName.indexOf('.')) >= 0) {
            outputValue = getDescendantProperty(dataContext, fieldName);
        }
        else {
            outputValue = dataContext.hasOwnProperty(fieldName) ? dataContext[fieldName] : value;
        }
    }
    if (outputValue === null || outputValue === undefined || dataContext === undefined) {
        return '';
    }
    if (!dataContext.hasOwnProperty(treeLevelPropName)) {
        throw new Error('[Slickgrid-Universal] You must provide valid "treeDataOptions" in your Grid Options, however it seems that we could not find any tree level info on the current item datacontext row.');
    }
    const treeLevel = (_l = dataContext === null || dataContext === void 0 ? void 0 : dataContext[treeLevelPropName]) !== null && _l !== void 0 ? _l : 0;
    let toggleSymbol = '';
    let indentation = 0;
    if (dataContext[hasChildrenPropName]) {
        toggleSymbol = (dataContext === null || dataContext === void 0 ? void 0 : dataContext[collapsedPropName]) ? groupCollapsedSymbol : groupExpandedSymbol; // parent with child will have a toggle icon
        indentation = treeLevel === 0 ? 0 : (indentMarginLeft * treeLevel);
    }
    else {
        indentation = (indentMarginLeft * (treeLevel === 0 ? 0 : treeLevel + 1));
    }
    const indentSpacer = addWhiteSpaces(indentation);
    if (treeDataOptions === null || treeDataOptions === void 0 ? void 0 : treeDataOptions.titleFormatter) {
        outputValue = parseFormatterWhenExist(treeDataOptions.titleFormatter, row, cell, columnDef, dataContext, grid);
    }
    const leadingChar = (treeLevel === 0 && toggleSymbol) ? '' : (treeLevel === 0 ? `${exportIndentationLeadingChar}${addWhiteSpaces(exportIndentationLeadingSpaceCount)}` : exportIndentationLeadingChar);
    outputValue = `${leadingChar}${indentSpacer}${toggleSymbol} ${outputValue}`;
    const sanitizedOutputValue = sanitizeHtmlToText(outputValue); // also remove any html tags that might exist
    return sanitizedOutputValue;
};

const DOMPurify = DOMPurify_; // patch to fix rollup to work
/** Formatter that must be use with a Tree Data column */
const treeFormatter = (row, cell, value, columnDef, dataContext, grid) => {
    var _a, _b, _c, _d, _e;
    const gridOptions = grid.getOptions();
    const treeDataOptions = gridOptions === null || gridOptions === void 0 ? void 0 : gridOptions.treeDataOptions;
    const indentMarginLeft = (_a = treeDataOptions === null || treeDataOptions === void 0 ? void 0 : treeDataOptions.indentMarginLeft) !== null && _a !== void 0 ? _a : 15;
    const collapsedPropName = (_b = treeDataOptions === null || treeDataOptions === void 0 ? void 0 : treeDataOptions.collapsedPropName) !== null && _b !== void 0 ? _b : Constants.treeDataProperties.COLLAPSED_PROP;
    const hasChildrenPropName = (_c = treeDataOptions === null || treeDataOptions === void 0 ? void 0 : treeDataOptions.hasChildrenPropName) !== null && _c !== void 0 ? _c : Constants.treeDataProperties.HAS_CHILDREN_PROP;
    const treeLevelPropName = (_d = treeDataOptions === null || treeDataOptions === void 0 ? void 0 : treeDataOptions.levelPropName) !== null && _d !== void 0 ? _d : Constants.treeDataProperties.TREE_LEVEL_PROP;
    let outputValue = value;
    if (typeof columnDef.queryFieldNameGetterFn === 'function') {
        const fieldName = columnDef.queryFieldNameGetterFn(dataContext);
        if ((fieldName === null || fieldName === void 0 ? void 0 : fieldName.indexOf('.')) >= 0) {
            outputValue = getDescendantProperty(dataContext, fieldName);
        }
        else {
            outputValue = dataContext.hasOwnProperty(fieldName) ? dataContext[fieldName] : value;
        }
    }
    if (outputValue === null || outputValue === undefined || dataContext === undefined) {
        return '';
    }
    if (!dataContext.hasOwnProperty(treeLevelPropName)) {
        throw new Error('[Slickgrid-Universal] You must provide valid "treeDataOptions" in your Grid Options, however it seems that we could not find any tree level info on the current item datacontext row.');
    }
    const treeLevel = (_e = dataContext === null || dataContext === void 0 ? void 0 : dataContext[treeLevelPropName]) !== null && _e !== void 0 ? _e : 0;
    const indentSpacer = `<span style="display:inline-block; width:${indentMarginLeft * treeLevel}px;"></span>`;
    const slickTreeLevelClass = `slick-tree-level-${treeLevel}`;
    let toggleClass = '';
    if (dataContext[hasChildrenPropName]) {
        toggleClass = (dataContext === null || dataContext === void 0 ? void 0 : dataContext[collapsedPropName]) ? 'collapsed' : 'expanded'; // parent with child will have a toggle icon
    }
    if (treeDataOptions === null || treeDataOptions === void 0 ? void 0 : treeDataOptions.titleFormatter) {
        outputValue = parseFormatterWhenExist(treeDataOptions.titleFormatter, row, cell, columnDef, dataContext, grid);
    }
    const sanitizedOutputValue = DOMPurify.sanitize(outputValue, { ADD_ATTR: ['target'] });
    const spanToggleClass = `slick-group-toggle ${toggleClass}`.trim();
    const outputHtml = `${indentSpacer}<span class="${spanToggleClass}"></span><span class="slick-tree-title" level="${treeLevel}">${sanitizedOutputValue}</span>`;
    return { addClasses: slickTreeLevelClass, text: outputHtml };
};

const uppercaseFormatter = (row, cell, value, columnDef, dataContext) => {
    // make sure the value is a string
    if (value !== undefined && typeof value !== 'string') {
        value = value + '';
    }
    return value ? value.toUpperCase() : '';
};

const yesNoFormatter = (row, cell, value, columnDef, dataContext) => value ? 'Yes' : 'No';

const bsDropdownFormatter = (row, cell, value, columnDef, dataContext) => {
    const columnParams = columnDef && columnDef.params || {};
    const label = columnParams.label || columnParams.formatterLabel;
    if (!label) {
        throw new Error(`You must provide the "label" or "formatterLabel" via the generic "params" options (e.g.: { formatter: Formatters.bsDropdown, params: { formatterLabel: 'Label' }}`);
    }
    return `<div id="myDrop-r${row}-c${cell}" class="dropdown pointer">
    <a class="dropdown-toggle">
      ${label}
      <span class="caret"></span>
    </a>
  </div>`;
};

/** Provides a list of different Formatters that will change the cell value displayed in the UI */
const Formatters = {
    /** Align cell value to the center (alias to Formatters.center)  */
    alignCenter: centerFormatter,
    /** Align cell value to the right */
    alignRight: alignRightFormatter,
    /**
     * Takes an array of complex objects converts it to a comma delimited string.
     * Requires to pass an array of "propertyNames" in the column definition the generic "params" property
     * For example, if we have an array of user objects that have the property of firstName & lastName then we need to pass in your column definition::
     * params: { propertyNames: ['firtName', 'lastName'] } => 'John Doe, Jane Doe'
     */
    arrayObjectToCsv: arrayObjectToCsvFormatter,
    /** Takes an array of string and converts it to a comma delimited string */
    arrayToCsv: arrayToCsvFormatter,
    /** show value in bold font weight */
    bold: boldFormatter,
    /** boostrap dropdown formatter */
    bsDropdown: bsDropdownFormatter,
    /** Center a text value horizontally */
    center: centerFormatter,
    /** When value is filled (true), it will display a checkbox Unicode icon */
    checkbox: checkboxFormatter,
    /**
     * When value is filled, or if the value is a number and is bigger than 0, it will display a Font-Awesome icon (fa-check).
     * The icon will NOT be displayed when the value is any of the following ("false", false, "0", 0, -0.5, null, undefined)
     * Anything else than the condition specified will display the icon, so a text with "00123" will display the icon but "0" will not.
     * Also note that a string ("null", "undefined") will display the icon but (null, undefined) will not, so the typeof is also important
     */
    checkmark: checkmarkFormatter,
    /**
     * Takes a complex data object and return the data under that property (for example: "user.firstName" will return the first name "John")
     * You can pass the complex structure in the "field" or the "params: { complexField: string }" properties.
     * For example::
     * this.columnDefs = [{ id: 'username', field: 'user.firstName', ... }]
     * OR this.columnDefs = [{ id: 'username', field: 'user', params: { complexField: 'user.firstName' }, ... }]
     */
    complex: complexObjectFormatter,
    complexObject: complexObjectFormatter,
    /**
     * Looks up values from the columnDefinition.params.collection property and displays the label in CSV or string format
     * @example
     * // the grid will display 'foo' and 'bar' and not 1 and 2 from your dataset
     * { params: { collection: [{ value: 1, label: 'foo'}, {value: 2, label: 'bar' }] }}
     * const dataset = [1, 2];
     */
    collection: collectionFormatter,
    /**
     * Roughly the same as the "collectionFormatter" except that it
     * looks up values from the columnDefinition.editor.collection (instead of params) property and displays the label in CSV or string format
     * @example
     * // the grid will display 'foo' and 'bar' and not 1 and 2 from your dataset
     * { editor: { collection: [{ value: 1, label: 'foo'}, {value: 2, label: 'bar' }] }}
     * const dataset = [1, 2];
     */
    collectionEditor: collectionEditorFormatter,
    /** Takes a Date object and displays it as an ISO Date format (YYYY-MM-DD) */
    dateIso: getAssociatedDateFormatter(FieldType.dateIso, '-'),
    /** Takes a Date object and displays it as an ISO Date+Time format (YYYY-MM-DD HH:mm:ss) */
    dateTimeIso: getAssociatedDateFormatter(FieldType.dateTimeIso, '-'),
    /** Takes a Date object and displays it as an ISO Date+Time (without seconds) format (YYYY-MM-DD HH:mm) */
    dateTimeShortIso: getAssociatedDateFormatter(FieldType.dateTimeShortIso, '-'),
    /** Takes a Date object and displays it as an ISO Date+Time+(am/pm) format (YYYY-MM-DD h:mm:ss a) */
    dateTimeIsoAmPm: getAssociatedDateFormatter(FieldType.dateTimeIsoAmPm, '-'),
    /** Takes a Date object and displays it as an Euro Date format (DD/MM/YYYY) */
    dateEuro: getAssociatedDateFormatter(FieldType.dateEuro, '/'),
    /** Takes a Date object and displays it as an Euro Date+Time format (DD/MM/YYYY HH:mm:ss) */
    dateTimeEuro: getAssociatedDateFormatter(FieldType.dateTimeEuro, '/'),
    /** Takes a Date object and displays it as an Euro Date+Time (without seconds) format (DD/MM/YYYY HH:mm) */
    dateTimeShortEuro: getAssociatedDateFormatter(FieldType.dateTimeShortEuro, '/'),
    /** Takes a Date object and displays it as an Euro Date+Time+(am/pm) format (DD/MM/YYYY hh:mm:ss a) */
    dateTimeEuroAmPm: getAssociatedDateFormatter(FieldType.dateTimeEuroAmPm, '/'),
    /** Takes a Date object and displays it as an US Date format (MM/DD/YYYY) */
    dateUs: getAssociatedDateFormatter(FieldType.dateUs, '/'),
    /** Takes a Date object and displays it as an US Date+Time format (MM/DD/YYYY HH:mm:ss) */
    dateTimeUs: getAssociatedDateFormatter(FieldType.dateTimeUs, '/'),
    /** Takes a Date object and displays it as an US Date+Time (without seconds) format (MM/DD/YYYY HH:mm:ss) */
    dateTimeShortUs: getAssociatedDateFormatter(FieldType.dateTimeShortUs, '/'),
    /** Takes a Date object and displays it as an US Date+Time+(am/pm) format (MM/DD/YYYY hh:mm:ss a) */
    dateTimeUsAmPm: getAssociatedDateFormatter(FieldType.dateTimeUsAmPm, '/'),
    /** Displays a Font-Awesome delete icon (fa-trash) */
    deleteIcon: deleteIconFormatter,
    /**
     * Display the value as x decimals formatted, defaults to 2 decimals.
     * You can pass "decimalPlaces" or "minDecimalPlaces" and/or "maxDecimalPlaces" to the "params" property.
     * For example:: `{ formatter: Formatters.decimal, params: { decimalPlaces: 3 }}`
     * The property "decimalPlaces" is an alias of "minDecimalPlaces"
     */
    decimal: decimalFormatter,
    /** Display the value as 2 decimals formatted with dollar sign '$' at the end of of the value */
    dollar: dollarFormatter,
    /** Display the value as 2 decimals formatted with dollar sign '$' at the end of of the value, change color of text to red/green on negative/positive value */
    dollarColored: dollarColoredFormatter,
    /** Display the value as 2 decimals formatted with dollar sign '$' at the end of of the value, change color of text to red/green on negative/positive value, show it in bold font weight as well */
    dollarColoredBold: dollarColoredBoldFormatter,
    /** Displays a Font-Awesome edit icon (fa-pencil) */
    editIcon: editIconFormatter,
    /** Takes any text value and display it as a fake a hyperlink (only styled as an hyperlink), this can be used in combo with "onCellClick" event */
    fakeHyperlink: fakeHyperlinkFormatter,
    /**
     * Takes an hyperlink cell value and transforms it into a real hyperlink, given that the value starts with 1 of these (http|ftp|https).
     * The structure will be "<a href="hyperlink">hyperlink</a>"
     *
     * You can optionally change the hyperlink text displayed by using the generic params "hyperlinkText" in the column definition
     * For example: { id: 'link', field: 'link', params: { hyperlinkText: 'Company Website' } } will display "<a href="link">Company Website</a>"
     *
     * You can also optionally provide the hyperlink URL by using the generic params "hyperlinkUrl" in the column definition
     * For example: { id: 'link', field: 'link', params: {  hyperlinkText: 'Company Website', hyperlinkUrl: 'http://www.somewhere.com' } } will display "<a href="http://www.somewhere.com">Company Website</a>"
     */
    hyperlink: hyperlinkFormatter,
    /** Display whichever icon you want (library agnostic, it could be Font-Awesome or any other) */
    icon: iconFormatter,
    /** Displays a Font-Awesome edit icon (fa-info-circle) */
    infoIcon: infoIconFormatter,
    /** show input text value as italic text */
    italic: italicFormatter,
    /** Takes a value and displays it all lowercase */
    lowercase: lowercaseFormatter,
    /**
     * Takes a value display it according to a mask provided
     * e.: 1234567890 with mask "(000) 000-0000" will display "(123) 456-7890"
     */
    mask: maskFormatter,
    /**
     * You can pipe multiple formatters (executed in sequence), use params to pass the list of formatters.
     * Requires to pass an array of "formatters" in the column definition the generic "params" property
     * For example::
     * { field: 'title', formatter: Formatters.multiple, params: { formatters: [ Formatters.lowercase, Formatters.uppercase ] }
     */
    multiple: multipleFormatter,
    /** Takes a cell value number (between 0.0-1.0) and displays a red (<50) or green (>=50) bar */
    percent: percentFormatter,
    /** Takes a cell value number (between 0.0-100) and displays a red (<50) or green (>=50) bar */
    percentComplete: percentCompleteFormatter,
    /** Takes a cell value number (between 0-100) and displays Bootstrap "percent-complete-bar" a red (<30), silver (>30 & <70) or green (>=70) bar */
    percentCompleteBar: percentCompleteBarFormatter,
    /** Takes a cell value number (between 0-100) and add the "%" after the number */
    percentSymbol: percentSymbolFormatter,
    /** Takes a cell value number (between 0-100) and displays Bootstrap "progress-bar" a red (<30), silver (>30 & <70) or green (>=70) bar */
    progressBar: progressBarFormatter,
    /** Takes a cell value and translates it (i18n). Requires an instance of the Translate Service:: `i18n: this.translate */
    translate: translateFormatter,
    /** Takes a boolean value, cast it to upperCase string and finally translates it (i18n). */
    translateBoolean: translateBooleanFormatter,
    /** Formatter that must be use with a Tree Data column */
    tree: treeFormatter,
    /** Formatter that must be use with a Tree Data column for Exporting the data */
    treeExport: treeExportFormatter,
    /** Takes a value and displays it all uppercase */
    uppercase: uppercaseFormatter,
    /** Takes a boolean value and display a string 'Yes' or 'No' */
    yesNo: yesNoFormatter
};

const avgTotalsPercentageFormatter = (totals, columnDef, grid) => {
    const field = columnDef.field || '';
    let val = totals.avg && totals.avg[field];
    const params = columnDef && columnDef.params;
    let prefix = params && params.groupFormatterPrefix || '';
    const suffix = params && params.groupFormatterSuffix || '';
    const minDecimal = getValueFromParamsOrFormatterOptions('minDecimal', columnDef, grid);
    const maxDecimal = getValueFromParamsOrFormatterOptions('maxDecimal', columnDef, grid);
    const decimalSeparator = getValueFromParamsOrFormatterOptions('decimalSeparator', columnDef, grid, '.');
    const thousandSeparator = getValueFromParamsOrFormatterOptions('thousandSeparator', columnDef, grid, '');
    const displayNegativeNumberWithParentheses = getValueFromParamsOrFormatterOptions('displayNegativeNumberWithParentheses', columnDef, grid, false);
    if (val !== null && val !== undefined && !isNaN(+val)) {
        if (val < 0) {
            val = Math.abs(val);
            if (!displayNegativeNumberWithParentheses) {
                prefix += '-';
            }
            else {
                if (isNaN(minDecimal) && isNaN(maxDecimal)) {
                    const outputVal = thousandSeparatorFormatted(Math.round(val), thousandSeparator);
                    return `${prefix}(${outputVal}%)${suffix}`;
                }
                return `${prefix}(${decimalFormatted(val, minDecimal, maxDecimal, decimalSeparator, thousandSeparator)}%)${suffix}`;
            }
        }
        if (isNaN(minDecimal) && isNaN(maxDecimal)) {
            const outputVal = thousandSeparatorFormatted(Math.round(val), thousandSeparator);
            return `${prefix}${outputVal}%${suffix}`;
        }
        return `${prefix}${decimalFormatted(val, minDecimal, maxDecimal, decimalSeparator, thousandSeparator)}%${suffix}`;
    }
    return '';
};

const avgTotalsDollarFormatter = (totals, columnDef, grid) => {
    const field = columnDef.field || '';
    const val = totals.avg && totals.avg[field];
    const params = columnDef && columnDef.params;
    const prefix = params && params.groupFormatterPrefix || '';
    const suffix = params && params.groupFormatterSuffix || '';
    const minDecimal = getValueFromParamsOrFormatterOptions('minDecimal', columnDef, grid, 2);
    const maxDecimal = getValueFromParamsOrFormatterOptions('maxDecimal', columnDef, grid, 4);
    const decimalSeparator = getValueFromParamsOrFormatterOptions('decimalSeparator', columnDef, grid, '.');
    const thousandSeparator = getValueFromParamsOrFormatterOptions('thousandSeparator', columnDef, grid, '');
    const displayNegativeNumberWithParentheses = getValueFromParamsOrFormatterOptions('displayNegativeNumberWithParentheses', columnDef, grid, false);
    if (val !== null && val !== undefined && !isNaN(+val)) {
        const formattedNumber = formatNumber(val, minDecimal, maxDecimal, displayNegativeNumberWithParentheses, '$', '', decimalSeparator, thousandSeparator);
        return `${prefix}${formattedNumber}${suffix}`;
    }
    return '';
};

const avgTotalsFormatter = (totals, columnDef, grid) => {
    const field = columnDef.field || '';
    let val = totals.avg && totals.avg[field];
    const params = columnDef && columnDef.params;
    let prefix = params && params.groupFormatterPrefix || '';
    const suffix = params && params.groupFormatterSuffix || '';
    const minDecimal = getValueFromParamsOrFormatterOptions('minDecimal', columnDef, grid);
    const maxDecimal = getValueFromParamsOrFormatterOptions('maxDecimal', columnDef, grid);
    const decimalSeparator = getValueFromParamsOrFormatterOptions('decimalSeparator', columnDef, grid, '.');
    const thousandSeparator = getValueFromParamsOrFormatterOptions('thousandSeparator', columnDef, grid, '');
    const displayNegativeNumberWithParentheses = getValueFromParamsOrFormatterOptions('displayNegativeNumberWithParentheses', columnDef, grid, false);
    if (val !== null && val !== undefined && !isNaN(+val)) {
        if (val < 0) {
            val = Math.abs(val);
            if (!displayNegativeNumberWithParentheses) {
                prefix += '-';
            }
            else {
                if (isNaN(minDecimal) && isNaN(maxDecimal)) {
                    const outputVal = thousandSeparatorFormatted(Math.round(val), thousandSeparator);
                    return `${prefix}(${outputVal})${suffix}`;
                }
                return `${prefix}(${decimalFormatted(val, minDecimal, maxDecimal, decimalSeparator, thousandSeparator)})${suffix}`;
            }
        }
        if (isNaN(minDecimal) && isNaN(maxDecimal)) {
            const outputVal = thousandSeparatorFormatted(Math.round(val), thousandSeparator);
            return `${prefix}${outputVal}${suffix}`;
        }
        return `${prefix}${decimalFormatted(val, minDecimal, maxDecimal, decimalSeparator, thousandSeparator)}${suffix}`;
    }
    return '';
};

const minTotalsFormatter = (totals, columnDef, grid) => {
    const field = columnDef.field || '';
    const val = totals.min && totals.min[field];
    const params = columnDef && columnDef.params;
    const prefix = params && params.groupFormatterPrefix || '';
    const suffix = params && params.groupFormatterSuffix || '';
    const minDecimal = getValueFromParamsOrFormatterOptions('minDecimal', columnDef, grid);
    const maxDecimal = getValueFromParamsOrFormatterOptions('maxDecimal', columnDef, grid);
    const decimalSeparator = getValueFromParamsOrFormatterOptions('decimalSeparator', columnDef, grid, '.');
    const thousandSeparator = getValueFromParamsOrFormatterOptions('thousandSeparator', columnDef, grid, '');
    const displayNegativeNumberWithParentheses = getValueFromParamsOrFormatterOptions('displayNegativeNumberWithParentheses', columnDef, grid, false);
    if (val !== null && val !== undefined && !isNaN(+val)) {
        const formattedNumber = formatNumber(val, minDecimal, maxDecimal, displayNegativeNumberWithParentheses, '', '', decimalSeparator, thousandSeparator);
        return `${prefix}${formattedNumber}${suffix}`;
    }
    return '';
};

const maxTotalsFormatter = (totals, columnDef, grid) => {
    const field = columnDef.field || '';
    const val = totals.max && totals.max[field];
    const params = columnDef && columnDef.params;
    const prefix = params && params.groupFormatterPrefix || '';
    const suffix = params && params.groupFormatterSuffix || '';
    const minDecimal = getValueFromParamsOrFormatterOptions('minDecimal', columnDef, grid);
    const maxDecimal = getValueFromParamsOrFormatterOptions('maxDecimal', columnDef, grid);
    const decimalSeparator = getValueFromParamsOrFormatterOptions('decimalSeparator', columnDef, grid, '.');
    const thousandSeparator = getValueFromParamsOrFormatterOptions('thousandSeparator', columnDef, grid, '');
    const displayNegativeNumberWithParentheses = getValueFromParamsOrFormatterOptions('displayNegativeNumberWithParentheses', columnDef, grid, false);
    if (val !== null && val !== undefined && !isNaN(+val)) {
        const formattedNumber = formatNumber(val, minDecimal, maxDecimal, displayNegativeNumberWithParentheses, '', '', decimalSeparator, thousandSeparator);
        return `${prefix}${formattedNumber}${suffix}`;
    }
    return '';
};

const sumTotalsColoredFormatter = (totals, columnDef, grid) => {
    const field = columnDef.field || '';
    const val = totals.sum && totals.sum[field];
    const params = columnDef && columnDef.params;
    const prefix = params && params.groupFormatterPrefix || '';
    const suffix = params && params.groupFormatterSuffix || '';
    const minDecimal = getValueFromParamsOrFormatterOptions('minDecimal', columnDef, grid);
    const maxDecimal = getValueFromParamsOrFormatterOptions('maxDecimal', columnDef, grid);
    const decimalSeparator = getValueFromParamsOrFormatterOptions('decimalSeparator', columnDef, grid, '.');
    const thousandSeparator = getValueFromParamsOrFormatterOptions('thousandSeparator', columnDef, grid, '');
    const displayNegativeNumberWithParentheses = getValueFromParamsOrFormatterOptions('displayNegativeNumberWithParentheses', columnDef, grid, false);
    if (val !== null && val !== undefined && !isNaN(+val)) {
        const colorStyle = (val >= 0) ? 'green' : 'red';
        const formattedNumber = formatNumber(val, minDecimal, maxDecimal, displayNegativeNumberWithParentheses, '', '', decimalSeparator, thousandSeparator);
        return `<span style="color:${colorStyle}">${prefix}${formattedNumber}${suffix}</span>`;
    }
    return '';
};

const sumTotalsDollarColoredBoldFormatter = (totals, columnDef, grid) => {
    const field = columnDef.field || '';
    const val = totals.sum && totals.sum[field];
    const params = columnDef && columnDef.params;
    const prefix = params && params.groupFormatterPrefix || '';
    const suffix = params && params.groupFormatterSuffix || '';
    const minDecimal = getValueFromParamsOrFormatterOptions('minDecimal', columnDef, grid, 2);
    const maxDecimal = getValueFromParamsOrFormatterOptions('maxDecimal', columnDef, grid, 4);
    const decimalSeparator = getValueFromParamsOrFormatterOptions('decimalSeparator', columnDef, grid, '.');
    const thousandSeparator = getValueFromParamsOrFormatterOptions('thousandSeparator', columnDef, grid, '');
    const displayNegativeNumberWithParentheses = getValueFromParamsOrFormatterOptions('displayNegativeNumberWithParentheses', columnDef, grid, false);
    if (val !== null && val !== undefined && !isNaN(+val)) {
        const colorStyle = (val >= 0) ? 'green' : 'red';
        const formattedNumber = formatNumber(val, minDecimal, maxDecimal, displayNegativeNumberWithParentheses, '$', '', decimalSeparator, thousandSeparator);
        return `<span style="color:${colorStyle}; font-weight: bold;">${prefix}${formattedNumber}${suffix}</span>`;
    }
    return '';
};

const sumTotalsDollarColoredFormatter = (totals, columnDef, grid) => {
    const field = columnDef.field || '';
    const val = totals.sum && totals.sum[field];
    const params = columnDef && columnDef.params;
    const prefix = params && params.groupFormatterPrefix || '';
    const suffix = params && params.groupFormatterSuffix || '';
    const minDecimal = getValueFromParamsOrFormatterOptions('minDecimal', columnDef, grid, 2);
    const maxDecimal = getValueFromParamsOrFormatterOptions('maxDecimal', columnDef, grid, 4);
    const decimalSeparator = getValueFromParamsOrFormatterOptions('decimalSeparator', columnDef, grid, '.');
    const thousandSeparator = getValueFromParamsOrFormatterOptions('thousandSeparator', columnDef, grid, '');
    const displayNegativeNumberWithParentheses = getValueFromParamsOrFormatterOptions('displayNegativeNumberWithParentheses', columnDef, grid, false);
    if (val !== null && val !== undefined && !isNaN(+val)) {
        const colorStyle = (val >= 0) ? 'green' : 'red';
        const formattedNumber = formatNumber(val, minDecimal, maxDecimal, displayNegativeNumberWithParentheses, '$', '', decimalSeparator, thousandSeparator);
        return `<span style="color:${colorStyle}">${prefix}${formattedNumber}${suffix}</span>`;
    }
    return '';
};

const sumTotalsDollarBoldFormatter = (totals, columnDef, grid) => {
    const field = columnDef.field || '';
    const val = totals.sum && totals.sum[field];
    const params = columnDef && columnDef.params;
    const prefix = params && params.groupFormatterPrefix || '';
    const suffix = params && params.groupFormatterSuffix || '';
    const minDecimal = getValueFromParamsOrFormatterOptions('minDecimal', columnDef, grid, 2);
    const maxDecimal = getValueFromParamsOrFormatterOptions('maxDecimal', columnDef, grid, 4);
    const decimalSeparator = getValueFromParamsOrFormatterOptions('decimalSeparator', columnDef, grid, '.');
    const thousandSeparator = getValueFromParamsOrFormatterOptions('thousandSeparator', columnDef, grid, '');
    const displayNegativeNumberWithParentheses = getValueFromParamsOrFormatterOptions('displayNegativeNumberWithParentheses', columnDef, grid, false);
    if (val !== null && val !== undefined && !isNaN(+val)) {
        const formattedNumber = formatNumber(val, minDecimal, maxDecimal, displayNegativeNumberWithParentheses, '$', '', decimalSeparator, thousandSeparator);
        return `<b>${prefix}${formattedNumber}${suffix}</b>`;
    }
    return '';
};

const sumTotalsDollarFormatter = (totals, columnDef, grid) => {
    const field = columnDef.field || '';
    const val = totals.sum && totals.sum[field];
    const params = columnDef && columnDef.params;
    const prefix = params && params.groupFormatterPrefix || '';
    const suffix = params && params.groupFormatterSuffix || '';
    const minDecimal = getValueFromParamsOrFormatterOptions('minDecimal', columnDef, grid, 2);
    const maxDecimal = getValueFromParamsOrFormatterOptions('maxDecimal', columnDef, grid, 4);
    const decimalSeparator = getValueFromParamsOrFormatterOptions('decimalSeparator', columnDef, grid, '.');
    const thousandSeparator = getValueFromParamsOrFormatterOptions('thousandSeparator', columnDef, grid, '');
    const displayNegativeNumberWithParentheses = getValueFromParamsOrFormatterOptions('displayNegativeNumberWithParentheses', columnDef, grid, false);
    if (val !== null && val !== undefined && !isNaN(+val)) {
        const formattedNumber = formatNumber(val, minDecimal, maxDecimal, displayNegativeNumberWithParentheses, '$', '', decimalSeparator, thousandSeparator);
        return `${prefix}${formattedNumber}${suffix}`;
    }
    return '';
};

const sumTotalsFormatter = (totals, columnDef, grid) => {
    const field = columnDef.field || '';
    const val = totals.sum && totals.sum[field];
    const params = columnDef && columnDef.params;
    const prefix = params && params.groupFormatterPrefix || '';
    const suffix = params && params.groupFormatterSuffix || '';
    const minDecimal = getValueFromParamsOrFormatterOptions('minDecimal', columnDef, grid);
    const maxDecimal = getValueFromParamsOrFormatterOptions('maxDecimal', columnDef, grid);
    const decimalSeparator = getValueFromParamsOrFormatterOptions('decimalSeparator', columnDef, grid, '.');
    const thousandSeparator = getValueFromParamsOrFormatterOptions('thousandSeparator', columnDef, grid, '');
    const displayNegativeNumberWithParentheses = getValueFromParamsOrFormatterOptions('displayNegativeNumberWithParentheses', columnDef, grid, false);
    if (val !== null && val !== undefined && !isNaN(+val)) {
        const formattedNumber = formatNumber(val, minDecimal, maxDecimal, displayNegativeNumberWithParentheses, '', '', decimalSeparator, thousandSeparator);
        return `${prefix}${formattedNumber}${suffix}`;
    }
    return '';
};

const sumTotalsBoldFormatter = (totals, columnDef, grid) => {
    const field = columnDef.field || '';
    const val = totals.sum && totals.sum[field];
    const params = columnDef && columnDef.params;
    const prefix = params && params.groupFormatterPrefix || '';
    const suffix = params && params.groupFormatterSuffix || '';
    const minDecimal = getValueFromParamsOrFormatterOptions('minDecimal', columnDef, grid);
    const maxDecimal = getValueFromParamsOrFormatterOptions('maxDecimal', columnDef, grid);
    const decimalSeparator = getValueFromParamsOrFormatterOptions('decimalSeparator', columnDef, grid, '.');
    const thousandSeparator = getValueFromParamsOrFormatterOptions('thousandSeparator', columnDef, grid, '');
    const displayNegativeNumberWithParentheses = getValueFromParamsOrFormatterOptions('displayNegativeNumberWithParentheses', columnDef, grid, false);
    if (val !== null && val !== undefined && !isNaN(+val)) {
        const formattedNumber = formatNumber(val, minDecimal, maxDecimal, displayNegativeNumberWithParentheses, '', '', decimalSeparator, thousandSeparator);
        return `<b>${prefix}${formattedNumber}${suffix}</b>`;
    }
    return '';
};

/** Provides a list of different Formatters that will change the cell value displayed in the UI */
const GroupTotalFormatters = {
    /**
     * Average all the column totals
     * Extra options available in "params":: "groupFormatterPrefix" and "groupFormatterSuffix", e.g.: params: { groupFormatterPrefix: '<i>Total</i>: ', groupFormatterSuffix: '$' }
     */
    avgTotals: avgTotalsFormatter,
    /**
     * Average all the column totals and display '$' at the end of the value
     * Extra options available in "params":: "groupFormatterPrefix" and "groupFormatterSuffix", e.g.: params: { groupFormatterPrefix: '<i>Total</i>: ', groupFormatterSuffix: '$' }
     */
    avgTotalsDollar: avgTotalsDollarFormatter,
    /**
     * Average all the column totals and display '%' at the end of the value
     * Extra options available in "params":: "groupFormatterPrefix" and "groupFormatterSuffix", e.g.: params: { groupFormatterPrefix: '<i>Total</i>: ', groupFormatterSuffix: '$' }
     */
    avgTotalsPercentage: avgTotalsPercentageFormatter,
    /**
     * Show max value of all the column totals
     * Extra options available in "params":: "groupFormatterPrefix" and "groupFormatterSuffix", e.g.: params: { groupFormatterPrefix: '<i>Total</i>: ', groupFormatterSuffix: '$' }
     */
    maxTotals: maxTotalsFormatter,
    /**
     * Show min value of all the column totals
     * Extra options available in "params":: "groupFormatterPrefix" and "groupFormatterSuffix", e.g.: params: { groupFormatterPrefix: '<i>Total</i>: ', groupFormatterSuffix: '$' }
     */
    minTotals: minTotalsFormatter,
    /**
     * Sums up all the column totals
     * Extra options available in "params":: "groupFormatterPrefix" and "groupFormatterSuffix", e.g.: params: { groupFormatterPrefix: '<i>Total</i>: ', groupFormatterSuffix: '$' }
     */
    sumTotals: sumTotalsFormatter,
    /**
     * Sums up all the column totals and display it in bold font weight
     * Extra options available in "params":: "groupFormatterPrefix" and "groupFormatterSuffix", e.g: params: { groupFormatterPrefix: '<i>Total</i>: ', groupFormatterSuffix: '$' }
     */
    sumTotalsBold: sumTotalsBoldFormatter,
    /**
     * Sums up all the column totals, change color of text to red/green on negative/positive value
     * Extra options available in "params":: "groupFormatterPrefix" and "groupFormatterSuffix", e.g: params: { groupFormatterPrefix: '<i>Total</i>: ', groupFormatterSuffix: '$' }
     */
    sumTotalsColored: sumTotalsColoredFormatter,
    /**
     * Sums up all the column totals and display dollar sign
     * Extra options available in "params":: "groupFormatterPrefix" and "groupFormatterSuffix", e.g: params: { groupFormatterPrefix: '<i>Total</i>: ', groupFormatterSuffix: '$' }
     */
    sumTotalsDollar: sumTotalsDollarFormatter,
    /**
     * Sums up all the column totals and display dollar sign and show it in bold font weight
     * Extra options available in "params":: "groupFormatterPrefix" and "groupFormatterSuffix", e.g: params: { groupFormatterPrefix: '<i>Total</i>: ', groupFormatterSuffix: '$' }
     */
    sumTotalsDollarBold: sumTotalsDollarBoldFormatter,
    /**
     * Sums up all the column totals, change color of text to red/green on negative/positive value
     * Extra options available in "params":: "groupFormatterPrefix" and "groupFormatterSuffix", e.g: params: { groupFormatterPrefix: '<i>Total</i>: ', groupFormatterSuffix: '$' }
     */
    sumTotalsDollarColored: sumTotalsDollarColoredFormatter,
    /**
     * Sums up all the column totals, change color of text to red/green on negative/positive value, show it in bold font weight as well
     * Extra options available in "params":: "groupFormatterPrefix" and "groupFormatterSuffix", e.g: params: { groupFormatterPrefix: '<i>Total</i>: ', groupFormatterSuffix: '$' }
     */
    sumTotalsDollarColoredBold: sumTotalsDollarColoredBoldFormatter,
};

class SlickPaginationComponent {
    /** Constructor */
    constructor(paginationService, translate) {
        this.paginationService = paginationService;
        this.translate = translate;
        this.subscriptions = [];
        this._enableTranslate = false;
        // text translations (handled by ngx-translate or by custom locale)
        this.textItemsPerPage = 'items per page';
        this.textItems = 'items';
        this.textOf = 'of';
        this.textPage = 'Page';
    }
    get availablePageSizes() {
        return this.paginationService.availablePageSizes;
    }
    get dataFrom() {
        return this.paginationService.dataFrom;
    }
    get dataTo() {
        return this.paginationService.dataTo;
    }
    /** is the left side pagination disabled? */
    get isLeftPaginationDisabled() {
        return this.pageNumber === 1 || this.totalItems === 0;
    }
    /** is the right side pagination disabled? */
    get isRightPaginationDisabled() {
        return this.pageNumber === this.pageCount || this.totalItems === 0;
    }
    get itemsPerPage() {
        return this.paginationService.itemsPerPage;
    }
    get pageCount() {
        return this.paginationService.pageCount;
    }
    get pageNumber() {
        return this.paginationService.pageNumber;
    }
    set pageNumber(page) {
        // the setter has to be declared but we won't use it, instead we will use the "changeToCurrentPage()" to only update the value after ENTER keydown event
    }
    get totalItems() {
        return this.paginationService.totalItems;
    }
    ngOnDestroy() {
        this.dispose();
    }
    ngOnInit() {
        this._gridOptions = this.gridOptions || {};
        this._enableTranslate = this._gridOptions && this._gridOptions.enableTranslate || false;
        this._locales = this._gridOptions && this._gridOptions.locales || Constants.locales;
        if (this._enableTranslate && !this.translate) {
            throw new Error('[Angular-Slickgrid] requires "ngx-translate" to be installed and configured when the grid option "enableTranslate" is enabled.');
        }
        this.translateAllUiTexts(this._locales);
        // translate all the text using ngx-translate or custom locales
        if (this._enableTranslate && this.translate && this.translate.onLangChange) {
            this.subscriptions.push(this.translate.onLangChange.subscribe(() => this.translateAllUiTexts(this._locales)));
        }
    }
    changeToFirstPage(event) {
        if (!this.isLeftPaginationDisabled) {
            this.paginationService.goToFirstPage(event);
        }
    }
    changeToLastPage(event) {
        if (!this.isRightPaginationDisabled) {
            this.paginationService.goToLastPage(event);
        }
    }
    changeToNextPage(event) {
        if (!this.isRightPaginationDisabled) {
            this.paginationService.goToNextPage(event);
        }
    }
    changeToPreviousPage(event) {
        if (!this.isLeftPaginationDisabled) {
            this.paginationService.goToPreviousPage(event);
        }
    }
    changeToCurrentPage(event) {
        let pageNumber = 1;
        if (event && event.currentTarget && event.currentTarget.value) {
            pageNumber = +(event.currentTarget.value);
        }
        this.paginationService.goToPageNumber(pageNumber, event);
    }
    changeItemPerPage(event) {
        let itemsPerPage = 1;
        if (event && event.currentTarget && event.currentTarget.value) {
            itemsPerPage = +(event.currentTarget.value);
        }
        this.paginationService.changeItemPerPage(itemsPerPage, event);
    }
    dispose() {
        // also unsubscribe all Angular Subscriptions
        this.subscriptions = unsubscribeAllObservables(this.subscriptions);
    }
    // --
    // private functions
    // --------------------
    /** Translate all the texts shown in the UI, use ngx-translate service when available or custom locales when service is null */
    translateAllUiTexts(locales) {
        if (this._enableTranslate && this.translate && this.translate.instant && this.translate.currentLang) {
            const translationPrefix = getTranslationPrefix(this._gridOptions);
            this.textItemsPerPage = this.translate.instant(`${translationPrefix}ITEMS_PER_PAGE`);
            this.textItems = this.translate.instant(`${translationPrefix}ITEMS`);
            this.textOf = this.translate.instant(`${translationPrefix}OF`);
            this.textPage = this.translate.instant(`${translationPrefix}PAGE`);
        }
        else if (locales) {
            this.textItemsPerPage = locales.TEXT_ITEMS_PER_PAGE || 'TEXT_ITEMS_PER_PAGE';
            this.textItems = locales.TEXT_ITEMS || 'TEXT_ITEMS';
            this.textOf = locales.TEXT_OF || 'TEXT_OF';
            this.textPage = locales.TEXT_PAGE || 'TEXT_PAGE';
        }
    }
}
SlickPaginationComponent.ɵfac = function SlickPaginationComponent_Factory(t) { return new (t || SlickPaginationComponent)(ɵngcc0.ɵɵdirectiveInject(PaginationService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.TranslateService, 8)); };
SlickPaginationComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SlickPaginationComponent, selectors: [["slick-pagination"]], inputs: { gridOptions: "gridOptions" }, decls: 34, vars: 14, consts: [[1, "slick-pagination"], [1, "slick-pagination-nav"], ["aria-label", "Page navigation"], [1, "pagination"], [1, "page-item", 3, "ngClass"], ["aria-label", "First", 1, "page-link", "icon-seek-first", "fa", "fa-angle-double-left", 3, "click"], ["aria-label", "Previous", 1, "page-link", "icon-seek-prev", "fa", "fa-angle-left", 3, "click"], [1, "slick-page-number"], ["type", "text", "data-test", "page-number-input", "size", "1", 1, "form-control", 3, "value", "readOnly", "change"], ["data-test", "page-count"], ["aria-label", "Next", 1, "page-link", "icon-seek-next", "text-center", "fa", "fa-lg", "fa-angle-right", 3, "click"], ["aria-label", "Last", 1, "page-link", "icon-seek-end", "fa", "fa-lg", "fa-angle-double-right", 3, "click"], [1, "slick-pagination-settings"], ["id", "items-per-page-label", 3, "change"], [3, "value", "selected", 4, "ngFor", "ngForOf"], [1, "slick-pagination-count"], [4, "ngIf"], [1, "page-info-total-items"], ["data-test", "total-items"], [3, "value", "selected"], [1, "page-info-from-to"], ["data-test", "item-from"], ["data-test", "item-to"]], template: function SlickPaginationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "nav", 2);
        ɵngcc0.ɵɵelementStart(3, "ul", 3);
        ɵngcc0.ɵɵelementStart(4, "li", 4);
        ɵngcc0.ɵɵelementStart(5, "a", 5);
        ɵngcc0.ɵɵlistener("click", function SlickPaginationComponent_Template_a_click_5_listener($event) { return ctx.changeToFirstPage($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "li", 4);
        ɵngcc0.ɵɵelementStart(7, "a", 6);
        ɵngcc0.ɵɵlistener("click", function SlickPaginationComponent_Template_a_click_7_listener($event) { return ctx.changeToPreviousPage($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 7);
        ɵngcc0.ɵɵelementStart(9, "span");
        ɵngcc0.ɵɵtext(10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "input", 8);
        ɵngcc0.ɵɵlistener("change", function SlickPaginationComponent_Template_input_change_11_listener($event) { return ctx.changeToCurrentPage($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "span");
        ɵngcc0.ɵɵtext(13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "span", 9);
        ɵngcc0.ɵɵtext(15);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "nav", 2);
        ɵngcc0.ɵɵelementStart(17, "ul", 3);
        ɵngcc0.ɵɵelementStart(18, "li", 4);
        ɵngcc0.ɵɵelementStart(19, "a", 10);
        ɵngcc0.ɵɵlistener("click", function SlickPaginationComponent_Template_a_click_19_listener($event) { return ctx.changeToNextPage($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "li", 4);
        ɵngcc0.ɵɵelementStart(21, "a", 11);
        ɵngcc0.ɵɵlistener("click", function SlickPaginationComponent_Template_a_click_21_listener($event) { return ctx.changeToLastPage($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(22, "span", 12);
        ɵngcc0.ɵɵelementStart(23, "select", 13);
        ɵngcc0.ɵɵlistener("change", function SlickPaginationComponent_Template_select_change_23_listener($event) { return ctx.changeItemPerPage($event); });
        ɵngcc0.ɵɵtemplate(24, SlickPaginationComponent_option_24_Template, 2, 3, "option", 14);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(25, "span");
        ɵngcc0.ɵɵtext(26);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(27, ", ");
        ɵngcc0.ɵɵelementStart(28, "span", 15);
        ɵngcc0.ɵɵtemplate(29, SlickPaginationComponent_span_29_Template, 8, 3, "span", 16);
        ɵngcc0.ɵɵelementStart(30, "span", 17);
        ɵngcc0.ɵɵelementStart(31, "span", 18);
        ɵngcc0.ɵɵtext(32);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(33);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngClass", ctx.isLeftPaginationDisabled ? "disabled" : "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ctx.isLeftPaginationDisabled ? "disabled" : "");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ctx.textPage);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("value", ctx.pageNumber)("readOnly", ctx.totalItems === 0);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.textOf);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.pageCount, "");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngClass", ctx.isRightPaginationDisabled ? "disabled" : "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ctx.isRightPaginationDisabled ? "disabled" : "");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.availablePageSizes);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.textItemsPerPage);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.totalItems);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.totalItems);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.textItems, " ");
    } }, directives: [ɵngcc2.NgClass, ɵngcc2.NgForOf, ɵngcc2.NgIf], encapsulation: 2 });
SlickPaginationComponent.ctorParameters = () => [
    { type: PaginationService },
    { type: TranslateService, decorators: [{ type: Optional }] }
];
SlickPaginationComponent.propDecorators = {
    gridOptions: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SlickPaginationComponent, [{
        type: Component,
        args: [{
                selector: 'slick-pagination',
                template: "<div class=\"slick-pagination\">\r\n  <div class=\"slick-pagination-nav\">\r\n    <nav aria-label=\"Page navigation\">\r\n      <ul class=\"pagination\">\r\n        <li class=\"page-item\" [ngClass]=\"isLeftPaginationDisabled ? 'disabled' : ''\">\r\n          <a class=\"page-link icon-seek-first fa fa-angle-double-left\" aria-label=\"First\"\r\n             (click)=\"changeToFirstPage($event)\">\r\n          </a>\r\n        </li>\r\n        <li class=\"page-item\" [ngClass]=\"isLeftPaginationDisabled ? 'disabled' : ''\">\r\n          <a class=\"page-link icon-seek-prev fa fa-angle-left\" aria-label=\"Previous\"\r\n             (click)=\"changeToPreviousPage($event)\">\r\n          </a>\r\n        </li>\r\n      </ul>\r\n    </nav>\r\n\r\n    <div class=\"slick-page-number\">\r\n      <span>{{textPage}}</span>\r\n      <input type=\"text\" class=\"form-control\" data-test=\"page-number-input\" [value]=\"pageNumber\" size=\"1\"\r\n             [readOnly]=\"totalItems === 0\" (change)=\"changeToCurrentPage($event)\">\r\n      <span>{{textOf}}</span><span data-test=\"page-count\"> {{pageCount}}</span>\r\n    </div>\r\n\r\n    <nav aria-label=\"Page navigation\">\r\n      <ul class=\"pagination\">\r\n        <li class=\"page-item\" [ngClass]=\"isRightPaginationDisabled ? 'disabled' : ''\">\r\n          <a class=\"page-link icon-seek-next text-center fa fa-lg fa-angle-right\" aria-label=\"Next\"\r\n             (click)=\"changeToNextPage($event)\">\r\n          </a>\r\n        </li>\r\n        <li class=\"page-item\" [ngClass]=\"isRightPaginationDisabled ? 'disabled' : ''\">\r\n          <a class=\"page-link icon-seek-end fa fa-lg fa-angle-double-right\" aria-label=\"Last\"\r\n             (click)=\"changeToLastPage($event)\">\r\n          </a>\r\n        </li>\r\n      </ul>\r\n    </nav>\r\n  </div>\r\n  <span class=\"slick-pagination-settings\">\r\n    <select id=\"items-per-page-label\" (change)=\"changeItemPerPage($event)\">\r\n      <option value=\"{{pageSize}}\" [selected]=\"pageSize === itemsPerPage\" *ngFor=\"let pageSize of availablePageSizes\">{{pageSize}}</option>\r\n    </select>\r\n    <span>{{textItemsPerPage}}</span>,\r\n    <span class=\"slick-pagination-count\">\r\n      <span *ngIf=\"totalItems\">\r\n        <span class=\"page-info-from-to\">\r\n          <span data-test=\"item-from\">{{dataFrom}}</span>-<span data-test=\"item-to\">{{dataTo}}</span>\r\n          {{textOf}}\r\n        </span>\r\n      </span>\r\n      <span class=\"page-info-total-items\">\r\n        <span data-test=\"total-items\">{{totalItems}}</span> {{textItems}}\r\n      </span>\r\n    </span>\r\n  </span>\r\n</div>\r\n"
            }]
    }], function () { return [{ type: PaginationService }, { type: ɵngcc1.TranslateService, decorators: [{
                type: Optional
            }] }]; }, { gridOptions: [{
            type: Input
        }] }); })();

/**
 * Automatically add a Custom Formatter on all column definitions that have an Editor.
 * Instead of manually adding a Custom Formatter on every column definitions that are editables, let's ask the system to do it in an easier automated way.
 * It will loop through all column definitions and add an Custom Editor Formatter when necessary,
 * also note that if there's already a Formatter on the column definition it will automatically use the Formatters.multiple and add the custom formatter into the `params: formatters: {}}`
 */
function autoAddEditorFormatterToColumnsWithEditor(columnDefinitions, customEditableFormatter) {
    if (Array.isArray(columnDefinitions)) {
        for (const columnDef of columnDefinitions) {
            if (columnDef.editor) {
                if (columnDef.formatter && columnDef.formatter !== Formatters.multiple && columnDef.formatter !== customEditableFormatter) {
                    const prevFormatter = columnDef.formatter;
                    columnDef.formatter = Formatters.multiple;
                    columnDef.params = Object.assign(Object.assign({}, columnDef.params), { formatters: [prevFormatter, customEditableFormatter] });
                }
                else if (columnDef.formatter && columnDef.formatter === Formatters.multiple && columnDef.params) {
                    // before adding the formatter, make sure it's not yet in the params.formatters list, we wouldn't want to add it multiple times
                    if (columnDef.params.formatters.findIndex((formatter) => formatter === customEditableFormatter) === -1) {
                        columnDef.params.formatters = [...columnDef.params.formatters, customEditableFormatter];
                    }
                }
                else {
                    columnDef.formatter = customEditableFormatter;
                }
            }
        }
    }
}

class SlickEmptyWarningComponent {
    constructor(translate) {
        this.translate = translate;
        this.isPreviouslyShown = false;
    }
    /** Getter for the Grid Options pulled through the Grid Object */
    get gridOptions() {
        return (this._grid && this._grid.getOptions) ? this._grid.getOptions() : {};
    }
    set grid(slickGrid) {
        this._grid = slickGrid;
    }
    dispose() {
        if (this._warningLeftElement && this._warningLeftElement.remove) {
            this._warningLeftElement.remove();
        }
        if (this._warningRightElement && this._warningRightElement.remove) {
            this._warningRightElement.remove();
        }
        this._warningLeftElement = undefined;
        this._warningRightElement = undefined;
    }
    /**
     * Display a warning of empty data when the filtered dataset is empty
     * NOTE: to make this code reusable, you could (should) move this code into a utility service
     * @param isShowing - are we showing the message?
     * @param options - any styling options you'd like to pass like the text color
     */
    showEmptyDataMessage(isShowing = true, options) {
        if (!this._grid || !this.gridOptions || this.isPreviouslyShown === isShowing) {
            return false;
        }
        // keep reference so that we won't re-render the warning if the status is the same
        this.isPreviouslyShown = isShowing;
        const gridUid = this._grid && this._grid.getUID();
        const defaultMessage = 'No data to display.';
        const mergedOptions = Object.assign(Object.assign({ message: defaultMessage }, this.gridOptions.emptyDataWarning), options);
        const emptyDataClassName = mergedOptions && mergedOptions.className || 'slick-empty-data-warning';
        this._warningLeftElement = document.querySelector(`.${gridUid} .${emptyDataClassName}`);
        const gridCanvasLeftElm = document.querySelector(`.${gridUid} .grid-canvas.grid-canvas-left`);
        const gridCanvasRightElm = document.querySelector(`.${gridUid} .grid-canvas.grid-canvas-right`);
        const leftElementMarginLeft = mergedOptions.leftViewportMarginLeft || 0;
        const rightElementMarginLeft = mergedOptions.rightViewportMarginLeft || 0;
        const leftElementFrozenMarginLeft = mergedOptions.frozenLeftViewportMarginLeft || 0;
        const rightElementFrozenMarginLeft = mergedOptions.frozenRightViewportMarginLeft || 0;
        const isFrozenGrid = (this.gridOptions.frozenColumn !== undefined && this.gridOptions.frozenColumn >= 0);
        const leftViewportMarginLeft = typeof leftElementMarginLeft === 'string' ? leftElementMarginLeft : `${leftElementMarginLeft}px`;
        const rightViewportMarginLeft = typeof rightElementMarginLeft === 'string' ? rightElementMarginLeft : `${rightElementMarginLeft}px`;
        // when dealing with a grid that has "autoHeight" option, we need to override 2 height that get miscalculated
        // that is because it is not aware that we are adding this slick empty element in this grid DOM
        if (this.gridOptions.autoHeight) {
            const leftPaneElm = document.querySelector('.slick-pane.slick-pane-top.slick-pane-left');
            // get default values
            if (leftPaneElm && gridCanvasLeftElm) {
                this.defHeightPane = parseInt(leftPaneElm.style.height || '', 10); // this field auto calc by row height
                // get row height of each feature when enabled (rowHeight will always be defined because that is cell height)
                this.defHeightRow = this.gridOptions.rowHeight;
                const filterRowHeight = (this.gridOptions.enableFiltering ? this.gridOptions.headerRowHeight : 0);
                const preHeaderRowHeight = (this.gridOptions.createPreHeaderPanel ? this.gridOptions.preHeaderPanelHeight : 0);
                if (isShowing) {
                    // use when height with rows more that 100px
                    // AutoHeight option collapse dataview to 100px when show message without data in huge grid
                    // (default autoHeight for message - 100px you can add as param if needed)
                    let leftPaneMinHeight = (this.defHeightPane !== undefined && this.defHeightPane < 100) ? this.defHeightPane : 100;
                    leftPaneMinHeight += filterRowHeight + preHeaderRowHeight; // add preHeader & filter height when enabled
                    leftPaneElm.style.minHeight = `${leftPaneMinHeight}px`;
                    gridCanvasLeftElm.style.minHeight = `${this.defHeightRow}px`;
                }
            }
        }
        // warning message could come from a translation key or by the warning options
        let warningMessage = mergedOptions.message;
        if (this.gridOptions.enableTranslate && this.translate && this.translate.instant && mergedOptions && mergedOptions.messageKey) {
            warningMessage = this.translate.instant(mergedOptions.messageKey);
        }
        if (!this._warningLeftElement && gridCanvasLeftElm && gridCanvasRightElm) {
            const sanitizedOptions = this.gridOptions && this.gridOptions.sanitizeHtmlOptions || {};
            // sanitize any unauthorized html tags like script and others
            // for the remaining allowed tags we'll permit all attributes
            const sanitizedText = (DOMPurify_.sanitize(warningMessage, sanitizedOptions) || '').toString();
            this._warningLeftElement = document.createElement('div');
            this._warningLeftElement.classList.add(emptyDataClassName);
            this._warningLeftElement.classList.add('left');
            this._warningLeftElement.innerHTML = sanitizedText;
            // clone the warning element and add the "right" class to it so we can distinguish
            this._warningRightElement = this._warningLeftElement.cloneNode(true);
            this._warningRightElement.classList.add('right');
            // append both warning elements to both left/right canvas
            gridCanvasRightElm.appendChild(this._warningRightElement);
            gridCanvasLeftElm.appendChild(this._warningLeftElement);
        }
        // if we did find the Slick-Empty-Warning element then we'll display/hide at the grid position with some margin offsets (we need to position under the headerRow and filterRow)
        // when using a frozen/pinned grid, we also have extra options to hide left/right message
        if (this._warningLeftElement) {
            // display/hide right/left messages
            let leftDisplay = isShowing ? 'block' : 'none';
            if (isFrozenGrid && isShowing) {
                leftDisplay = (mergedOptions.hideFrozenLeftWarning) ? 'none' : 'block';
            }
            this._warningLeftElement.style.display = leftDisplay;
            // use correct left margin (defaults to 40% on regular grid or 10px on frozen grid)
            const leftFrozenMarginLeft = typeof leftElementFrozenMarginLeft === 'string' ? leftElementFrozenMarginLeft : `${leftElementFrozenMarginLeft}px`;
            this._warningLeftElement.style.marginLeft = isFrozenGrid ? leftFrozenMarginLeft : leftViewportMarginLeft;
        }
        if (this._warningRightElement) {
            // use correct left margin (defaults to 40% on regular grid or 10px on frozen grid)
            let rightDisplay = isShowing ? 'block' : 'none';
            if (isFrozenGrid && isShowing) {
                rightDisplay = (mergedOptions.hideFrozenRightWarning) ? 'none' : 'block';
            }
            this._warningRightElement.style.display = rightDisplay;
            // use correct left margin (defaults to 40% on regular grid or 10px on frozen grid)
            const rightFrozenMarginLeft = typeof rightElementFrozenMarginLeft === 'string' ? rightElementFrozenMarginLeft : `${rightElementFrozenMarginLeft}px`;
            this._warningRightElement.style.marginLeft = isFrozenGrid ? rightFrozenMarginLeft : rightViewportMarginLeft;
        }
        return isShowing;
    }
}
SlickEmptyWarningComponent.ctorParameters = () => [
    { type: TranslateService, decorators: [{ type: Optional }] }
];

// import 3rd party vendor libs
const slickgridEventPrefix = 'sg';
class AngularSlickgridComponent {
    constructor(cd, elm, excelExportService, exportService, extensionService, extensionUtility, filterService, gridEventService, gridService, gridStateService, groupingAndColspanService, paginationService, resizer, sharedService, sortService, treeDataService, translate, forRootConfig) {
        this.cd = cd;
        this.elm = elm;
        this.excelExportService = excelExportService;
        this.exportService = exportService;
        this.extensionService = extensionService;
        this.extensionUtility = extensionUtility;
        this.filterService = filterService;
        this.gridEventService = gridEventService;
        this.gridService = gridService;
        this.gridStateService = gridStateService;
        this.groupingAndColspanService = groupingAndColspanService;
        this.paginationService = paginationService;
        this.resizer = resizer;
        this.sharedService = sharedService;
        this.sortService = sortService;
        this.treeDataService = treeDataService;
        this.translate = translate;
        this.forRootConfig = forRootConfig;
        this._currentDatasetLength = 0;
        this._eventHandler = new Slick.EventHandler();
        this._hideHeaderRowAfterPageLoad = false;
        this._isGridInitialized = false;
        this._isDatasetInitialized = false;
        this._isDatasetHierarchicalInitialized = false;
        this._isLeftFooterOriginallyEmpty = false;
        this._isLeftFooterDisplayingSelectionRowCount = false;
        this._isPaginationInitialized = false;
        this._isLocalGrid = true;
        this._selectedRowCount = 0;
        this.groupingDefinition = {};
        this.showCustomFooter = false;
        this.showPagination = false;
        this.totalItems = 0;
        this.subscriptions = [];
        this.onAngularGridCreated = new EventEmitter();
        this.onDataviewCreated = new EventEmitter();
        this.onGridCreated = new EventEmitter();
        this.onGridInitialized = new EventEmitter();
        this.onBeforeGridCreate = new EventEmitter();
        this.onBeforeGridDestroy = new EventEmitter();
        this.onAfterGridDestroyed = new EventEmitter();
        this.onGridStateChanged = new EventEmitter();
        this.onGridBeforeExportToFile = this.exportService.onGridBeforeExportToFile;
        this.onGridAfterExportToFile = this.exportService.onGridAfterExportToFile;
        this.onGridBeforeExportToExcel = this.excelExportService.onGridBeforeExportToExcel;
        this.onGridAfterExportToExcel = this.excelExportService.onGridAfterExportToExcel;
        this.gridId = '';
        this.slickEmptyWarning = new SlickEmptyWarningComponent(this.translate);
    }
    get paginationOptions() {
        return this._paginationOptions;
    }
    set paginationOptions(options) {
        if (options && this._paginationOptions) {
            this._paginationOptions = Object.assign(Object.assign({}, this._paginationOptions), options);
        }
        else {
            this._paginationOptions = options;
        }
        this.gridOptions.pagination = this._paginationOptions;
        this.paginationService.updateTotalItems(options && options.totalItems || 0, true);
    }
    set gridHeight(height) {
        this._fixedHeight = height;
    }
    set gridWidth(width) {
        this._fixedWidth = width;
    }
    set columnDefinitions(columnDefinitions) {
        this._columnDefinitions = columnDefinitions;
        if (this._isGridInitialized) {
            this.updateColumnDefinitionsList(columnDefinitions);
        }
        if (columnDefinitions.length > 0) {
            this.copyColumnWidthsReference(columnDefinitions);
        }
    }
    get columnDefinitions() {
        return this._columnDefinitions;
    }
    get dataset() {
        return this.dataView.getItems();
    }
    set dataset(newDataset) {
        var _a;
        const prevDatasetLn = this._currentDatasetLength;
        let data = newDataset;
        // when Tree Data is enabled and we don't yet have the hierarchical dataset filled, we can force a convert & sort of the array
        if (this.grid && ((_a = this.gridOptions) === null || _a === void 0 ? void 0 : _a.enableTreeData) && Array.isArray(newDataset) && (newDataset.length > 0 || newDataset.length !== prevDatasetLn)) {
            this._isDatasetHierarchicalInitialized = false;
            data = this.sortTreeDataset(newDataset);
        }
        this._dataset = data;
        this.refreshGridData(data || []);
        this._currentDatasetLength = (newDataset || []).length;
    }
    get datasetHierarchical() {
        return this.sharedService.hierarchicalDataset;
    }
    set datasetHierarchical(newHierarchicalDataset) {
        var _a, _b;
        const prevFlatDatasetLn = this._currentDatasetLength;
        this.sharedService.hierarchicalDataset = newHierarchicalDataset;
        if (newHierarchicalDataset && this.columnDefinitions && ((_a = this.filterService) === null || _a === void 0 ? void 0 : _a.clearFilters)) {
            this.filterService.clearFilters();
        }
        // when a hierarchical dataset is set afterward, we can reset the flat dataset and call a tree data sort that will overwrite the flat dataset
        if (newHierarchicalDataset && this.grid && ((_b = this.sortService) === null || _b === void 0 ? void 0 : _b.processTreeDataInitialSort)) {
            this.dataView.setItems([], this.gridOptions.datasetIdPropertyName);
            this.sortService.processTreeDataInitialSort();
            this.sortTreeDataset([]);
            // we also need to reset/refresh the Tree Data filters because if we inserted new item(s) then it might not show up without doing this refresh
            // however we need 1 cpu cycle before having the DataView refreshed, so we need to wrap this check in a setTimeout
            setTimeout(() => {
                const flatDatasetLn = this.dataView.getItemCount();
                if (flatDatasetLn !== prevFlatDatasetLn && flatDatasetLn > 0) {
                    this.filterService.refreshTreeDataFilters();
                }
            });
        }
        this._isDatasetHierarchicalInitialized = true;
    }
    get elementRef() {
        return this.elm;
    }
    ngAfterViewInit() {
        this.initialization();
        this._isGridInitialized = true;
        // user must provide a "gridHeight" or use "autoResize: true" in the grid options
        if (!this._fixedHeight && !this.gridOptions.enableAutoResize) {
            throw new Error(`[Angular-Slickgrid] requires a "grid-height" or the "enableAutoResize" grid option to be enabled.
        Without that the grid will seem empty while in fact it just does not have any height define.`);
        }
        // recheck the empty warning message after grid is shown so that it works in every use case
        if (this.gridOptions && this.gridOptions.enableEmptyDataWarningMessage && Array.isArray(this.dataset)) {
            const finalTotalCount = this.dataset.length;
            this.displayEmptyDataWarning(finalTotalCount < 1);
        }
    }
    ngOnInit() {
        this.onBeforeGridCreate.emit(true);
        if (this.gridOptions && !this.gridOptions.enableAutoResize && (this._fixedHeight || this._fixedWidth)) {
            this.gridHeightString = `${this._fixedHeight}px`;
            this.gridWidthString = `${this._fixedWidth}px`;
        }
    }
    ngOnDestroy() {
        this.onBeforeGridDestroy.emit(this.grid);
        this.destroy();
        this.onAfterGridDestroyed.emit(true);
    }
    destroy(shouldEmptyDomElementContainer = false) {
        var _a, _b, _c;
        this.extensionService.dispose();
        this.filterService.dispose();
        this.gridEventService.dispose();
        this.gridStateService.dispose();
        this.gridService.dispose();
        this.groupingAndColspanService.dispose();
        this.paginationService.dispose();
        this.resizer.dispose();
        this.sortService.dispose();
        this.treeDataService.dispose();
        // dispose the Components
        this.slickEmptyWarning.dispose();
        if ((_a = this._eventHandler) === null || _a === void 0 ? void 0 : _a.unsubscribeAll) {
            this._eventHandler.unsubscribeAll();
        }
        if (this.dataView) {
            if ((_b = this.dataView) === null || _b === void 0 ? void 0 : _b.setItems) {
                this.dataView.setItems([]);
            }
            if (this.dataView.destroy) {
                this.dataView.destroy();
            }
        }
        if ((_c = this.grid) === null || _c === void 0 ? void 0 : _c.destroy) {
            this.grid.destroy(shouldEmptyDomElementContainer);
        }
        if (this.backendServiceApi) {
            for (const prop of Object.keys(this.backendServiceApi)) {
                delete this.backendServiceApi[prop];
            }
            this.backendServiceApi = undefined;
        }
        for (const prop of Object.keys(this.columnDefinitions)) {
            this.columnDefinitions[prop] = null;
        }
        for (const prop of Object.keys(this.sharedService)) {
            this.sharedService[prop] = null;
        }
        // we could optionally also empty the content of the grid container DOM element
        if (shouldEmptyDomElementContainer) {
            this.emptyGridContainerElm();
        }
        // also unsubscribe all RxJS subscriptions
        this.subscriptions = unsubscribeAllObservables(this.subscriptions);
        this._dataset = null;
        this.datasetHierarchical = undefined;
        this._columnDefinitions = [];
        this._angularGridInstances = undefined;
        this.grid = null;
        this.dataView = null;
    }
    emptyGridContainerElm() {
        var _a, _b;
        const gridContainerId = (_b = (_a = this.gridOptions) === null || _a === void 0 ? void 0 : _a.gridContainerId) !== null && _b !== void 0 ? _b : 'grid1';
        const gridContainerElm = document.querySelector(gridContainerId);
        emptyElement(gridContainerElm);
    }
    /** Dispatch of Custom Event, which by default will bubble & is cancelable */
    dispatchCustomEvent(eventName, data, isBubbling = true, isCancelable = true) {
        const eventInit = { bubbles: isBubbling, cancelable: isCancelable };
        if (data) {
            eventInit.detail = data;
        }
        return this.elm.nativeElement.dispatchEvent(new CustomEvent(eventName, eventInit));
    }
    /**
     * Define our internal Post Process callback, it will execute internally after we get back result from the Process backend call
     * For now, this is GraphQL Service ONLY feature and it will basically refresh the Dataset & Pagination without having the user to create his own PostProcess every time
     */
    createBackendApiInternalPostProcessCallback(gridOptions) {
        const backendApi = gridOptions && gridOptions.backendServiceApi;
        if (backendApi && backendApi.service) {
            // internalPostProcess only works (for now) with a GraphQL Service, so make sure it is of that type
            if (backendApi.service instanceof GraphqlService || typeof backendApi.service.getDatasetName === 'function') {
                backendApi.internalPostProcess = (processResult) => {
                    const datasetName = (backendApi && backendApi.service && typeof backendApi.service.getDatasetName === 'function') ? backendApi.service.getDatasetName() : '';
                    if (processResult && processResult.data && processResult.data[datasetName]) {
                        const data = processResult.data[datasetName].hasOwnProperty('nodes') ? processResult.data[datasetName].nodes : processResult.data[datasetName];
                        const totalCount = processResult.data[datasetName].hasOwnProperty('totalCount') ? processResult.data[datasetName].totalCount : processResult.data[datasetName].length;
                        this.refreshGridData(data, totalCount || 0);
                    }
                };
            }
        }
    }
    /**
     * On a Pagination changed, we will trigger a Grid State changed with the new pagination info
     * Also if we use Row Selection or the Checkbox Selector, we need to reset any selection
     */
    paginationChanged(pagination) {
        const isSyncGridSelectionEnabled = this.gridStateService && this.gridStateService.needToPreserveRowSelection() || false;
        if (!isSyncGridSelectionEnabled && (this.gridOptions.enableRowSelection || this.gridOptions.enableCheckboxSelector)) {
            this.gridService.setSelectedRows([]);
        }
        const { pageNumber, pageSize } = pagination;
        if (this.sharedService) {
            if (pageSize) {
                this.sharedService.currentPagination = { pageNumber: pageNumber, pageSize: pageSize };
            }
        }
        this.gridStateService.onGridStateChanged.next({
            change: { newValues: { pageNumber: pageNumber, pageSize: pageSize }, type: GridStateType.pagination },
            gridState: this.gridStateService.getCurrentGridState()
        });
    }
    /**
     * When dataset changes, we need to refresh the entire grid UI & possibly resize it as well
     * @param dataset
     */
    refreshGridData(dataset, totalCount) {
        var _a;
        if (this.gridOptions && this.gridOptions.enableEmptyDataWarningMessage && Array.isArray(dataset)) {
            const finalTotalCount = totalCount || dataset.length;
            this.displayEmptyDataWarning(finalTotalCount < 1);
        }
        if (Array.isArray(dataset) && this.grid && ((_a = this.dataView) === null || _a === void 0 ? void 0 : _a.setItems)) {
            this.dataView.setItems(dataset, this.gridOptions.datasetIdPropertyName);
            if (!this.gridOptions.backendServiceApi && !this.gridOptions.enableTreeData) {
                this.dataView.reSort();
            }
            if (dataset.length > 0) {
                if (!this._isDatasetInitialized) {
                    this.loadFilterPresetsWhenDatasetInitialized();
                    if (this.gridOptions.enableCheckboxSelector) {
                        this.loadRowSelectionPresetWhenExists();
                    }
                }
                this._isDatasetInitialized = true;
            }
            if (dataset) {
                this.grid.invalidate();
            }
            // display the Pagination component only after calling this refresh data first, we call it here so that if we preset pagination page number it will be shown correctly
            this.showPagination = (this.gridOptions && (this.gridOptions.enablePagination || (this.gridOptions.backendServiceApi && this.gridOptions.enablePagination === undefined))) ? true : false;
            if (this.gridOptions && this.gridOptions.backendServiceApi && this.gridOptions.pagination) {
                const paginationOptions = this.setPaginationOptionsWhenPresetDefined(this.gridOptions, this._paginationOptions);
                // when we have a totalCount use it, else we'll take it from the pagination object
                // only update the total items if it's different to avoid refreshing the UI
                const totalRecords = totalCount !== undefined ? totalCount : (this.gridOptions && this.gridOptions.pagination && this.gridOptions.pagination.totalItems);
                if (totalRecords !== this.totalItems) {
                    this.totalItems = totalRecords;
                }
                // initialize the Pagination Service with new pagination options (which might have presets)
                if (!this._isPaginationInitialized) {
                    this.initializePaginationService(paginationOptions);
                }
                else {
                    // update the pagination service with the new total
                    this.paginationService.totalItems = this.totalItems;
                }
            }
            // resize the grid inside a slight timeout, in case other DOM element changed prior to the resize (like a filter/pagination changed)
            if (this.grid && this.gridOptions.enableAutoResize) {
                const delay = this.gridOptions.autoResize && this.gridOptions.autoResize.delay;
                this.resizer.resizeGrid(delay || 10);
            }
        }
    }
    /**
     * Check if there's any Pagination Presets defined in the Grid Options,
     * if there are then load them in the paginationOptions object
     */
    setPaginationOptionsWhenPresetDefined(gridOptions, paginationOptions) {
        if (gridOptions.presets && gridOptions.presets.pagination && gridOptions.pagination) {
            paginationOptions.pageSize = gridOptions.presets.pagination.pageSize;
            paginationOptions.pageNumber = gridOptions.presets.pagination.pageNumber;
        }
        return paginationOptions;
    }
    /**
     * Dynamically change or update the column definitions list.
     * We will re-render the grid so that the new header and data shows up correctly.
     * If using i18n, we also need to trigger a re-translate of the column headers
     */
    updateColumnDefinitionsList(newColumnDefinitions) {
        var _a, _b, _c;
        // map/swap the internal library Editor to the SlickGrid Editor factory
        newColumnDefinitions = this.swapInternalEditorToSlickGridFactoryEditor(newColumnDefinitions);
        if (this.gridOptions.enableTranslate) {
            this.extensionService.translateColumnHeaders(false, newColumnDefinitions);
        }
        else {
            this.extensionService.renderColumnHeaders(newColumnDefinitions, true);
        }
        if ((_a = this.gridOptions) === null || _a === void 0 ? void 0 : _a.enableAutoSizeColumns) {
            this.grid.autosizeColumns();
        }
        else if (((_b = this.gridOptions) === null || _b === void 0 ? void 0 : _b.enableAutoResizeColumnsByCellContent) && ((_c = this.resizer) === null || _c === void 0 ? void 0 : _c.resizeColumnsByCellContent)) {
            this.resizer.resizeColumnsByCellContent();
        }
    }
    /**
     * Show the filter row displayed on first row, we can optionally pass false to hide it.
     * @param showing
     */
    showHeaderRow(showing = true) {
        this.grid.setHeaderRowVisibility(showing, false);
        if (showing === true && this._isGridInitialized) {
            this.grid.setColumns(this.columnDefinitions);
        }
        return showing;
    }
    //
    // private functions
    // ------------------
    /**
     * Loop through all column definitions and copy the original optional `width` properties optionally provided by the user.
     * We will use this when doing a resize by cell content, if user provided a `width` it won't override it.
     */
    copyColumnWidthsReference(columnDefinitions) {
        columnDefinitions.forEach(col => col.originalWidth = col.width);
    }
    displayEmptyDataWarning(showWarning = true) {
        this.slickEmptyWarning.grid = this.grid;
        this.slickEmptyWarning && this.slickEmptyWarning.showEmptyDataMessage(showWarning);
    }
    bindDifferentHooks(grid, gridOptions, dataView) {
        // on locale change, we have to manually translate the Headers, GridMenu
        if (this.translate && this.translate.onLangChange) {
            // translate some of them on first load, then on each language change
            if (gridOptions.enableTranslate) {
                this.translateColumnHeaderTitleKeys();
                this.translateColumnGroupKeys();
                this.translateCustomFooterTexts();
            }
            this.subscriptions.push(this.translate.onLangChange.subscribe(() => {
                if (gridOptions.enableTranslate) {
                    this.extensionService.translateCellMenu();
                    this.extensionService.translateColumnHeaders();
                    this.extensionService.translateColumnPicker();
                    this.extensionService.translateContextMenu();
                    this.extensionService.translateGridMenu();
                    this.extensionService.translateHeaderMenu();
                    this.translateCustomFooterTexts();
                    this.translateColumnHeaderTitleKeys();
                    this.translateColumnGroupKeys();
                    if (gridOptions.createPreHeaderPanel && !gridOptions.enableDraggableGrouping) {
                        this.groupingAndColspanService.translateGroupingAndColSpan();
                    }
                }
            }));
        }
        if (!this.customDataView) {
            // bind external sorting (backend) when available or default onSort (dataView)
            if (gridOptions.enableSorting) {
                // bind external sorting (backend) unless specified to use the local one
                if (gridOptions.backendServiceApi && !gridOptions.backendServiceApi.useLocalSorting) {
                    this.sortService.bindBackendOnSort(grid);
                }
                else {
                    this.sortService.bindLocalOnSort(grid);
                }
            }
            // bind external filter (backend) when available or default onFilter (dataView)
            if (gridOptions.enableFiltering) {
                this.filterService.init(grid);
                // bind external filter (backend) unless specified to use the local one
                if (gridOptions.backendServiceApi && !gridOptions.backendServiceApi.useLocalFiltering) {
                    this.filterService.bindBackendOnFilter(grid);
                }
                else {
                    this.filterService.bindLocalOnFilter(grid);
                }
            }
            // load any presets if any (after dataset is initialized)
            this.loadColumnPresetsWhenDatasetInitialized();
            this.loadFilterPresetsWhenDatasetInitialized();
        }
        // if user set an onInit Backend, we'll run it right away (and if so, we also need to run preProcess, internalPostProcess & postProcess)
        if (gridOptions.backendServiceApi) {
            const backendApi = gridOptions.backendServiceApi;
            if (backendApi && backendApi.service && backendApi.service.init) {
                backendApi.service.init(backendApi.options, gridOptions.pagination, this.grid, this.sharedService);
            }
        }
        // expose all Slick Grid Events through dispatch
        for (const prop in grid) {
            if (grid.hasOwnProperty(prop) && prop.startsWith('on')) {
                this._eventHandler.subscribe(grid[prop], (event, args) => {
                    return this.dispatchCustomEvent(`${slickgridEventPrefix}${titleCase(prop)}`, { eventData: event, args });
                });
            }
        }
        // expose all Slick DataView Events through dispatch
        for (const prop in dataView) {
            if (dataView.hasOwnProperty(prop) && prop.startsWith('on')) {
                this._eventHandler.subscribe(dataView[prop], (event, args) => {
                    return this.dispatchCustomEvent(`${slickgridEventPrefix}${titleCase(prop)}`, { eventData: event, args });
                });
            }
        }
        // expose GridState Service changes event through dispatch
        this.subscriptions.push(this.gridStateService.onGridStateChanged.subscribe((gridStateChange) => {
            this.onGridStateChanged.emit(gridStateChange);
        }));
        // on cell click, mainly used with the columnDef.action callback
        this.gridEventService.bindOnCellChange(grid, dataView);
        this.gridEventService.bindOnClick(grid, dataView);
        if (dataView && grid) {
            // When data changes in the DataView, we need to refresh the metrics and/or display a warning if the dataset is empty
            this._eventHandler.subscribe(dataView.onRowCountChanged, (_e, args) => {
                grid.invalidate();
                this.handleOnItemCountChanged(args.current || 0, this.dataView.getItemCount());
            });
            this._eventHandler.subscribe(dataView.onSetItemsCalled, (_e, args) => {
                var _a;
                grid.invalidate();
                this.handleOnItemCountChanged(this.dataView.getLength(), args.itemCount);
                // when user has resize by content enabled, we'll force a full width calculation since we change our entire dataset
                if (args.itemCount > 0 && (this.gridOptions.autosizeColumnsByCellContentOnFirstLoad || this.gridOptions.enableAutoResizeColumnsByCellContent)) {
                    this.resizer.resizeColumnsByCellContent(!((_a = this.gridOptions) === null || _a === void 0 ? void 0 : _a.resizeByContentOnlyOnFirstLoad));
                }
            });
            this._eventHandler.subscribe(dataView.onRowsChanged, (_e, args) => {
                // filtering data with local dataset will not always show correctly unless we call this updateRow/render
                // also don't use "invalidateRows" since it destroys the entire row and as bad user experience when updating a row
                // see commit: https://github.com/ghiscoding/Angular-Slickgrid/commit/bb62c0aa2314a5d61188ff005ccb564577f08805
                if (gridOptions && gridOptions.enableFiltering && !gridOptions.enableRowDetailView) {
                    if (args && args.rows && Array.isArray(args.rows)) {
                        args.rows.forEach((row) => grid.updateRow(row));
                        grid.render();
                    }
                }
            });
            // when column are reordered, we need to update the visibleColumn array
            this._eventHandler.subscribe(grid.onColumnsReordered, (e, args) => {
                this.sharedService.hasColumnsReordered = true;
                this.sharedService.visibleColumns = args.impactedColumns;
            });
        }
        // does the user have a colspan callback?
        if (gridOptions && gridOptions.colspanCallback && dataView && dataView.getItem && dataView.getItemMetadata) {
            dataView.getItemMetadata = (rowNumber) => {
                let callbackResult = null;
                if (gridOptions.colspanCallback && gridOptions.colspanCallback) {
                    callbackResult = gridOptions.colspanCallback(dataView.getItem(rowNumber));
                }
                return callbackResult;
            };
        }
    }
    bindBackendCallbackFunctions(gridOptions) {
        const backendApi = gridOptions.backendServiceApi;
        const backendApiService = backendApi && backendApi.service;
        const serviceOptions = backendApiService && backendApiService.options || {};
        const isExecuteCommandOnInit = (!serviceOptions) ? false : ((serviceOptions && serviceOptions.hasOwnProperty('executeProcessCommandOnInit')) ? serviceOptions['executeProcessCommandOnInit'] : true);
        if (backendApiService) {
            // update backend filters (if need be) BEFORE the query runs (via the onInit command a few lines below)
            // if user entered some any "presets", we need to reflect them all in the grid
            if (gridOptions && gridOptions.presets) {
                // Filters "presets"
                if (backendApiService.updateFilters && Array.isArray(gridOptions.presets.filters) && gridOptions.presets.filters.length > 0) {
                    backendApiService.updateFilters(gridOptions.presets.filters, true);
                }
                // Sorters "presets"
                if (backendApiService.updateSorters && Array.isArray(gridOptions.presets.sorters) && gridOptions.presets.sorters.length > 0) {
                    // when using multi-column sort, we can have multiple but on single sort then only grab the first sort provided
                    const sortColumns = this.gridOptions.multiColumnSort ? gridOptions.presets.sorters : gridOptions.presets.sorters.slice(0, 1);
                    backendApiService.updateSorters(undefined, sortColumns);
                }
                // Pagination "presets"
                if (backendApiService.updatePagination && gridOptions.presets.pagination) {
                    const { pageNumber, pageSize } = gridOptions.presets.pagination;
                    backendApiService.updatePagination(pageNumber, pageSize);
                }
            }
            else {
                const columnFilters = this.filterService.getColumnFilters();
                if (columnFilters && backendApiService.updateFilters) {
                    backendApiService.updateFilters(columnFilters, false);
                }
            }
            // execute onInit command when necessary
            if (backendApi && backendApiService && (backendApi.onInit || isExecuteCommandOnInit)) {
                const query = (typeof backendApiService.buildQuery === 'function') ? backendApiService.buildQuery() : '';
                const process = (isExecuteCommandOnInit) ? (backendApi.process && backendApi.process(query) || null) : (backendApi.onInit && backendApi.onInit(query) || null);
                // wrap this inside a setTimeout to avoid timing issue since the gridOptions needs to be ready before running this onInit
                setTimeout(() => {
                    // keep start time & end timestamps then return these metrics after the process execution
                    const startTime = new Date();
                    // run any pre-process, if defined, for example a spinner
                    if (backendApi.preProcess) {
                        backendApi.preProcess();
                    }
                    // the processes can be Promises or Observables (like Angular HttpClient)
                    const totalItems = this.gridOptions && this.gridOptions.pagination && this.gridOptions.pagination.totalItems;
                    if (process instanceof Promise && process.then) {
                        process.then((processResult) => executeBackendProcessesCallback(startTime, processResult, backendApi, totalItems))
                            .catch((error) => onBackendError(error, backendApi));
                    }
                    else if (isObservable(process)) {
                        this.subscriptions.push(process.subscribe((processResult) => executeBackendProcessesCallback(startTime, processResult, backendApi, totalItems), (error) => onBackendError(error, backendApi)));
                    }
                });
            }
        }
    }
    bindResizeHook(grid, options) {
        if ((options.autoFitColumnsOnFirstLoad && options.autosizeColumnsByCellContentOnFirstLoad) || (options.enableAutoSizeColumns && options.enableAutoResizeColumnsByCellContent)) {
            throw new Error(`[Angular-Slickgrid] You cannot enable both autosize/fit viewport & resize by content, you must choose which resize technique to use. You can enable these 2 options ("autoFitColumnsOnFirstLoad" and "enableAutoSizeColumns") OR these other 2 options ("autosizeColumnsByCellContentOnFirstLoad" and "enableAutoResizeColumnsByCellContent").`);
        }
        // expand/autofit columns on first page load
        if (grid && options.autoFitColumnsOnFirstLoad && options.enableAutoSizeColumns) {
            grid.autosizeColumns();
        }
        // auto-resize grid on browser resize
        if (this._fixedHeight || this._fixedWidth) {
            this.resizer.init(grid, { height: this._fixedHeight, width: this._fixedWidth });
        }
        else {
            this.resizer.init(grid);
        }
        if (options.enableAutoResize) {
            this.resizer.bindAutoResizeDataGrid();
            if (grid && options.autoFitColumnsOnFirstLoad && options.enableAutoSizeColumns) {
                grid.autosizeColumns();
            }
        }
    }
    executeAfterDataviewCreated(grid, gridOptions, dataView) {
        // if user entered some Sort "presets", we need to reflect them all in the DOM
        if (gridOptions.enableSorting) {
            if (gridOptions.presets && Array.isArray(gridOptions.presets.sorters)) {
                // when using multi-column sort, we can have multiple but on single sort then only grab the first sort provided
                const sortColumns = this.gridOptions.multiColumnSort ? gridOptions.presets.sorters : gridOptions.presets.sorters.slice(0, 1);
                this.sortService.loadGridSorters(sortColumns);
            }
        }
    }
    /** When data changes in the DataView, we'll refresh the metrics and/or display a warning if the dataset is empty */
    handleOnItemCountChanged(currentPageRowItemCount, totalItemCount) {
        this._currentDatasetLength = totalItemCount;
        this.metrics = {
            startTime: new Date(),
            endTime: new Date(),
            itemCount: currentPageRowItemCount,
            totalItemCount
        };
        // when using local (in-memory) dataset, we'll display a warning message when filtered data is empty
        if (this._isLocalGrid && this.gridOptions && this.gridOptions.enableEmptyDataWarningMessage) {
            this.displayEmptyDataWarning(currentPageRowItemCount === 0);
        }
    }
    initializePaginationService(paginationOptions) {
        if (this.gridOptions) {
            this.paginationData = {
                gridOptions: this.gridOptions,
            };
            this.paginationService.totalItems = this.totalItems;
            this.paginationService.init(this.grid, this.dataView, paginationOptions, this.backendServiceApi);
            this.subscriptions.push(this.paginationService.onPaginationChanged.subscribe((changes) => this.paginationChanged(changes)), this.paginationService.onPaginationVisibilityChanged.subscribe((visibility) => {
                this.showPagination = visibility && visibility.visible || false;
                if (this.gridOptions && this.gridOptions.backendServiceApi) {
                    refreshBackendDataset();
                }
            }));
            this._isPaginationInitialized = true;
        }
        this.cd.detectChanges();
    }
    initialization() {
        var _a, _b, _c, _d, _f, _g;
        // when detecting a frozen grid, we'll automatically enable the mousewheel scroll handler so that we can scroll from both left/right frozen containers
        if (this.gridOptions && ((this.gridOptions.frozenRow !== undefined && this.gridOptions.frozenRow >= 0) || this.gridOptions.frozenColumn !== undefined && this.gridOptions.frozenColumn >= 0) && this.gridOptions.enableMouseWheelScrollHandler === undefined) {
            this.gridOptions.enableMouseWheelScrollHandler = true;
        }
        // make sure the dataset is initialized (if not it will throw an error that it cannot getLength of null)
        this._dataset = this._dataset || [];
        this.gridOptions = this.mergeGridOptions(this.gridOptions);
        this._paginationOptions = this.gridOptions.pagination;
        this.locales = (_b = (_a = this.gridOptions) === null || _a === void 0 ? void 0 : _a.locales) !== null && _b !== void 0 ? _b : Constants.locales;
        this.backendServiceApi = (_c = this.gridOptions) === null || _c === void 0 ? void 0 : _c.backendServiceApi;
        this.createBackendApiInternalPostProcessCallback(this.gridOptions);
        this._isLocalGrid = !this.backendServiceApi; // considered a local grid if it doesn't have a backend service set
        this._isLeftFooterOriginallyEmpty = !((_d = this.gridOptions.customFooterOptions) === null || _d === void 0 ? void 0 : _d.leftFooterText);
        if (!this.customDataView) {
            const dataviewInlineFilters = this.gridOptions.dataView && this.gridOptions.dataView.inlineFilters || false;
            let dataViewOptions = { inlineFilters: dataviewInlineFilters };
            if (this.gridOptions.draggableGrouping || this.gridOptions.enableGrouping) {
                this.groupItemMetadataProvider = new Slick.Data.GroupItemMetadataProvider();
                this.sharedService.groupItemMetadataProvider = this.groupItemMetadataProvider;
                dataViewOptions = Object.assign(Object.assign({}, dataViewOptions), { groupItemMetadataProvider: this.groupItemMetadataProvider });
            }
            this.dataView = new Slick.Data.DataView(dataViewOptions);
        }
        // for convenience to the user, we provide the property "editor" as an Angular-Slickgrid editor complex object
        // however "editor" is used internally by SlickGrid for it's own Editor Factory
        // so in our lib we will swap "editor" and copy it into a new property called "internalColumnEditor"
        // then take back "editor.model" and make it the new "editor" so that SlickGrid Editor Factory still works
        this._columnDefinitions = this.swapInternalEditorToSlickGridFactoryEditor(this._columnDefinitions);
        // if the user wants to automatically add a Custom Editor Formatter, we need to call the auto add function again
        if (this.gridOptions.autoAddCustomEditorFormatter) {
            autoAddEditorFormatterToColumnsWithEditor(this._columnDefinitions, this.gridOptions.autoAddCustomEditorFormatter);
        }
        // save reference for all columns before they optionally become hidden/visible
        this.sharedService.allColumns = this._columnDefinitions;
        this.sharedService.visibleColumns = this._columnDefinitions;
        this.extensionService.createExtensionsBeforeGridCreation(this._columnDefinitions, this.gridOptions);
        // if user entered some Pinning/Frozen "presets", we need to apply them in the grid options
        if ((_f = this.gridOptions.presets) === null || _f === void 0 ? void 0 : _f.pinning) {
            this.gridOptions = Object.assign(Object.assign({}, this.gridOptions), this.gridOptions.presets.pinning);
        }
        // build SlickGrid Grid, also user might optionally pass a custom dataview (e.g. remote model)
        this.grid = new Slick.Grid(`#${this.gridId}`, this.customDataView || this.dataView, this._columnDefinitions, this.gridOptions);
        this.sharedService.dataView = this.dataView;
        this.sharedService.grid = this.grid;
        this.extensionService.bindDifferentExtensions();
        this.bindDifferentHooks(this.grid, this.gridOptions, this.dataView);
        // emit the Grid & DataView object to make them available in parent component
        this.onGridCreated.emit(this.grid);
        // when it's a frozen grid, we need to keep the frozen column id for reference if we ever show/hide column from ColumnPicker/GridMenu afterward
        const frozenColumnIndex = this.gridOptions.frozenColumn !== undefined ? this.gridOptions.frozenColumn : -1;
        if (frozenColumnIndex >= 0 && frozenColumnIndex <= this._columnDefinitions.length) {
            this.sharedService.frozenVisibleColumnId = this._columnDefinitions[frozenColumnIndex].id || '';
        }
        // initialize the SlickGrid grid
        this.grid.init();
        // initialized the resizer service only after SlickGrid is initialized
        // if we don't we end up binding our resize to a grid element that doesn't yet exist in the DOM and the resizer service will fail silently (because it has a try/catch that unbinds the resize without throwing back)
        this.resizer.init(this.grid);
        // when using Tree Data View
        if (this.gridOptions.enableTreeData) {
            this.treeDataService.init(this.grid);
        }
        if (!this.customDataView && (this.dataView && this.dataView.beginUpdate && this.dataView.setItems && this.dataView.endUpdate)) {
            const initialDataset = ((_g = this.gridOptions) === null || _g === void 0 ? void 0 : _g.enableTreeData) ? this.sortTreeDataset(this._dataset) : this._dataset;
            this.onDataviewCreated.emit(this.dataView);
            this.dataView.beginUpdate();
            this.dataView.setItems(initialDataset || [], this.gridOptions.datasetIdPropertyName);
            this.dataView.endUpdate();
            // if you don't want the items that are not visible (due to being filtered out or being on a different page)
            // to stay selected, pass 'false' to the second arg
            const selectionModel = this.grid && this.grid.getSelectionModel();
            if (selectionModel && this.gridOptions && this.gridOptions.dataView && this.gridOptions.dataView.hasOwnProperty('syncGridSelection')) {
                // if we are using a Backend Service, we will do an extra flag check, the reason is because it might have some unintended behaviors
                // with the BackendServiceApi because technically the data in the page changes the DataView on every page change.
                let preservedRowSelectionWithBackend = false;
                if (this.gridOptions.backendServiceApi && this.gridOptions.dataView.hasOwnProperty('syncGridSelectionWithBackendService')) {
                    preservedRowSelectionWithBackend = this.gridOptions.dataView.syncGridSelectionWithBackendService;
                }
                const syncGridSelection = this.gridOptions.dataView.syncGridSelection;
                if (typeof syncGridSelection === 'boolean') {
                    let preservedRowSelection = syncGridSelection;
                    if (!this._isLocalGrid) {
                        // when using BackendServiceApi, we'll be using the "syncGridSelectionWithBackendService" flag BUT "syncGridSelection" must also be set to True
                        preservedRowSelection = syncGridSelection && preservedRowSelectionWithBackend;
                    }
                    this.dataView.syncGridSelection(this.grid, preservedRowSelection);
                }
                else if (typeof syncGridSelection === 'object') {
                    this.dataView.syncGridSelection(this.grid, syncGridSelection.preserveHidden, syncGridSelection.preserveHiddenOnSelectionChange);
                }
            }
            const datasetLn = this.dataView.getLength() || this._dataset && this._dataset.length || 0;
            if (datasetLn > 0) {
                if (!this._isDatasetInitialized && (this.gridOptions.enableCheckboxSelector || this.gridOptions.enableRowSelection)) {
                    this.loadRowSelectionPresetWhenExists();
                }
                this.loadFilterPresetsWhenDatasetInitialized();
                this._isDatasetInitialized = true;
            }
        }
        // user might want to hide the header row on page load but still have `enableFiltering: true`
        // if that is the case, we need to hide the headerRow ONLY AFTER all filters got created & dataView exist
        if (this._hideHeaderRowAfterPageLoad) {
            this.showHeaderRow(false);
            this.sharedService.hideHeaderRowAfterPageLoad = this._hideHeaderRowAfterPageLoad;
        }
        // after the DataView is created & updated execute some processes
        this.executeAfterDataviewCreated(this.grid, this.gridOptions, this.dataView);
        // bind resize ONLY after the dataView is ready
        this.bindResizeHook(this.grid, this.gridOptions);
        // bind & initialize grouping and header grouping colspan service
        if (this.gridOptions.createPreHeaderPanel && !this.gridOptions.enableDraggableGrouping) {
            this.groupingAndColspanService.init(this.grid, this.dataView);
        }
        // bind & initialize the grid service
        this.gridService.init(this.grid, this.dataView);
        // when user enables translation, we need to translate Headers on first pass & subsequently in the bindDifferentHooks
        if (this.gridOptions.enableTranslate) {
            this.extensionService.translateColumnHeaders();
        }
        // if Export is enabled, initialize the service with the necessary grid and other objects
        if (this.gridOptions.enableExport) {
            this.exportService.init(this.grid, this.dataView);
        }
        // if Excel Export is enabled, initialize the service with the necessary grid and other objects
        if (this.gridOptions.enableExcelExport && this.sharedService) {
            this.excelExportService.init(this.grid, this.dataView);
        }
        // once all hooks are in placed and the grid is initialized, we can emit an event
        this.onGridInitialized.emit(this.grid);
        // bind the Backend Service API callback functions only after the grid is initialized
        // because the preProcess() and onInit() might get triggered
        if (this.gridOptions && this.gridOptions.backendServiceApi) {
            this.bindBackendCallbackFunctions(this.gridOptions);
        }
        this.gridStateService.init(this.grid, this.dataView);
        // local grid, check if we need to show the Pagination
        // if so then also check if there's any presets and finally initialize the PaginationService
        // a local grid with Pagination presets will potentially have a different total of items, we'll need to get it from the DataView and update our total
        if (this.gridOptions && this.gridOptions.enablePagination && this._isLocalGrid) {
            this.showPagination = true;
            this.loadLocalGridPagination();
        }
        this._angularGridInstances = {
            // Slick Grid & DataView objects
            dataView: this.dataView,
            slickGrid: this.grid,
            extensions: this.extensionService && this.extensionService.extensionList,
            // public methods
            destroy: this.destroy.bind(this),
            // return all available Services (non-singleton)
            backendService: this.gridOptions && this.gridOptions.backendServiceApi && this.gridOptions.backendServiceApi.service,
            excelExportService: this.excelExportService,
            exportService: this.exportService,
            extensionService: this.extensionService,
            filterService: this.filterService,
            gridEventService: this.gridEventService,
            gridStateService: this.gridStateService,
            gridService: this.gridService,
            groupingService: this.groupingAndColspanService,
            paginationService: this.paginationService,
            resizerService: this.resizer,
            sortService: this.sortService,
            treeDataService: this.treeDataService,
            /** @deprecated please use "extensionService" instead */
            pluginService: this.extensionService,
        };
        // all instances (SlickGrid, DataView & all Services)
        this.onAngularGridCreated.emit(this._angularGridInstances);
        // user could show a custom footer with the data metrics (dataset length and last updated timestamp)
        this.optionallyShowCustomFooterWithMetrics();
    }
    /** Load the Editor Collection asynchronously and replace the "collection" property when Observable resolves */
    loadEditorCollectionAsync(column) {
        const collectionAsync = column && column.editor && column.editor.collectionAsync;
        if (collectionAsync instanceof Observable) {
            this.subscriptions.push(collectionAsync.subscribe((resolvedCollection) => this.updateEditorCollection(column, resolvedCollection)));
        }
    }
    /** Load any possible Columns Grid Presets */
    loadColumnPresetsWhenDatasetInitialized() {
        // if user entered some Columns "presets", we need to reflect them all in the grid
        if (this.gridOptions.presets && Array.isArray(this.gridOptions.presets.columns) && this.gridOptions.presets.columns.length > 0) {
            const gridColumns = this.gridStateService.getAssociatedGridColumns(this.grid, this.gridOptions.presets.columns);
            if (gridColumns && Array.isArray(gridColumns) && gridColumns.length > 0) {
                // make sure that the checkbox selector is also visible if it is enabled
                if (this.gridOptions.enableCheckboxSelector) {
                    const checkboxColumn = (Array.isArray(this._columnDefinitions) && this._columnDefinitions.length > 0) ? this._columnDefinitions[0] : null;
                    if (checkboxColumn && checkboxColumn.id === '_checkbox_selector' && gridColumns[0].id !== '_checkbox_selector') {
                        gridColumns.unshift(checkboxColumn);
                    }
                }
                // keep copy the original optional `width` properties optionally provided by the user.
                // We will use this when doing a resize by cell content, if user provided a `width` it won't override it.
                gridColumns.forEach(col => col.originalWidth = col.width);
                // finally set the new presets columns (including checkbox selector if need be)
                this.grid.setColumns(gridColumns);
                this.sharedService.visibleColumns = gridColumns;
            }
        }
    }
    /** Load any possible Filters Grid Presets */
    loadFilterPresetsWhenDatasetInitialized() {
        var _a, _b, _c;
        if (this.gridOptions && !this.customDataView) {
            // if user entered some Filter "presets", we need to reflect them all in the DOM
            // also note that a presets of Tree Data Toggling will also call this method because Tree Data toggling does work with data filtering
            // (collapsing a parent will basically use Filter for hidding (aka collapsing) away the child underneat it)
            if (this.gridOptions.presets && (Array.isArray(this.gridOptions.presets.filters) || Array.isArray((_b = (_a = this.gridOptions.presets) === null || _a === void 0 ? void 0 : _a.treeData) === null || _b === void 0 ? void 0 : _b.toggledItems))) {
                this.filterService.populateColumnFilterSearchTermPresets(((_c = this.gridOptions.presets) === null || _c === void 0 ? void 0 : _c.filters) || []);
            }
        }
    }
    /**
     * local grid, check if we need to show the Pagination
     * if so then also check if there's any presets and finally initialize the PaginationService
     * a local grid with Pagination presets will potentially have a different total of items, we'll need to get it from the DataView and update our total
     */
    loadLocalGridPagination() {
        if (this.gridOptions) {
            this.totalItems = Array.isArray(this.dataset) ? this.dataset.length : 0;
            if (this._paginationOptions && this.dataView && this.dataView.getPagingInfo) {
                const slickPagingInfo = this.dataView.getPagingInfo() || {};
                if (slickPagingInfo.hasOwnProperty('totalRows') && this._paginationOptions.totalItems !== slickPagingInfo.totalRows) {
                    this.totalItems = slickPagingInfo.totalRows;
                }
            }
            if (this._paginationOptions) {
                this._paginationOptions.totalItems = this.totalItems;
                const paginationOptions = this.setPaginationOptionsWhenPresetDefined(this.gridOptions, this._paginationOptions);
                this.initializePaginationService(paginationOptions);
            }
        }
    }
    /** Load any Row Selections into the DataView that were presets by the user */
    loadRowSelectionPresetWhenExists() {
        // if user entered some Row Selections "presets"
        const presets = this.gridOptions && this.gridOptions.presets;
        const selectionModel = this.grid && this.grid.getSelectionModel();
        const enableRowSelection = this.gridOptions && (this.gridOptions.enableCheckboxSelector || this.gridOptions.enableRowSelection);
        if (enableRowSelection && selectionModel && presets && presets.rowSelection && (Array.isArray(presets.rowSelection.gridRowIndexes) || Array.isArray(presets.rowSelection.dataContextIds))) {
            let dataContextIds = presets.rowSelection.dataContextIds;
            let gridRowIndexes = presets.rowSelection.gridRowIndexes;
            // maps the IDs to the Grid Rows and vice versa, the "dataContextIds" has precedence over the other
            if (Array.isArray(dataContextIds) && dataContextIds.length > 0) {
                gridRowIndexes = this.dataView.mapIdsToRows(dataContextIds) || [];
            }
            else if (Array.isArray(gridRowIndexes) && gridRowIndexes.length > 0) {
                dataContextIds = this.dataView.mapRowsToIds(gridRowIndexes) || [];
            }
            this.gridStateService.selectedRowDataContextIds = dataContextIds;
            // change the selected rows except UNLESS it's a Local Grid with Pagination
            // local Pagination uses the DataView and that also trigger a change/refresh
            // and we don't want to trigger 2 Grid State changes just 1
            if ((this._isLocalGrid && !this.gridOptions.enablePagination) || !this._isLocalGrid) {
                setTimeout(() => this.grid.setSelectedRows(gridRowIndexes));
            }
        }
    }
    mergeGridOptions(gridOptions) {
        gridOptions.gridId = this.gridId;
        gridOptions.gridContainerId = `slickGridContainer-${this.gridId}`;
        // if we have a backendServiceApi and the enablePagination is undefined, we'll assume that we do want to see it, else get that defined value
        // @deprecated TODO remove this check in the future, user should explicitely enable the Pagination since this feature is now optional (you can now call OData/GraphQL without Pagination which is a new feature)
        gridOptions.enablePagination = ((gridOptions.backendServiceApi && gridOptions.enablePagination === undefined) ? true : gridOptions.enablePagination) || false;
        // use jquery extend to deep merge & copy to avoid immutable properties being changed in GlobalGridOptions after a route change
        const options = $.extend(true, {}, GlobalGridOptions, this.forRootConfig, gridOptions);
        // using jQuery extend to do a deep clone has an unwanted side on objects and pageSizes but ES6 spread has other worst side effects
        // so we will just overwrite the pageSizes when needed, this is the only one causing issues so far.
        // jQuery wrote this on their docs:: On a deep extend, Object and Array are extended, but object wrappers on primitive types such as String, Boolean, and Number are not.
        if (options && options.pagination && (gridOptions.enablePagination || gridOptions.backendServiceApi) && gridOptions.pagination && Array.isArray(gridOptions.pagination.pageSizes)) {
            options.pagination.pageSizes = gridOptions.pagination.pageSizes;
        }
        // also make sure to show the header row if user have enabled filtering
        this._hideHeaderRowAfterPageLoad = (options.showHeaderRow === false);
        if (options.enableFiltering && !options.showHeaderRow) {
            options.showHeaderRow = options.enableFiltering;
        }
        // when we use Pagination on Local Grid, it doesn't seem to work without enableFiltering
        // so we'll enable the filtering but we'll keep the header row hidden
        if (!options.enableFiltering && options.enablePagination && this._isLocalGrid) {
            options.enableFiltering = true;
            options.showHeaderRow = false;
            this._hideHeaderRowAfterPageLoad = true;
            this.sharedService.hideHeaderRowAfterPageLoad = true;
        }
        return options;
    }
    /**
     * We could optionally display a custom footer below the grid to show some metrics (last update, item count with/without filters)
     * It's an opt-in, user has to enable "showCustomFooter" and it cannot be used when there's already a Pagination since they display the same kind of info
     */
    optionallyShowCustomFooterWithMetrics() {
        if (this.gridOptions) {
            const customFooterOptions = this.gridOptions.customFooterOptions;
            this.registerOnSelectedRowsChangedWhenEnabled(customFooterOptions);
            if (this.gridOptions.enableTranslate) {
                this.translateCustomFooterTexts();
            }
            else if (customFooterOptions) {
                customFooterOptions.metricTexts = customFooterOptions.metricTexts || {};
                customFooterOptions.metricTexts.lastUpdate = customFooterOptions.metricTexts.lastUpdate || this.locales && this.locales.TEXT_LAST_UPDATE || 'TEXT_LAST_UPDATE';
                customFooterOptions.metricTexts.items = customFooterOptions.metricTexts.items || this.locales && this.locales.TEXT_ITEMS || 'TEXT_ITEMS';
                customFooterOptions.metricTexts.itemsSelected = customFooterOptions.metricTexts.itemsSelected || this.locales && this.locales.TEXT_ITEMS_SELECTED || 'TEXT_ITEMS_SELECTED';
                customFooterOptions.metricTexts.of = customFooterOptions.metricTexts.of || this.locales && this.locales.TEXT_OF || 'TEXT_OF';
            }
            this.registerOnSelectedRowsChangedWhenEnabled(this.gridOptions.customFooterOptions);
            // we will display the custom footer only when there's no Pagination
            if (!this.gridOptions.enablePagination && !this._isPaginationInitialized) {
                this.showCustomFooter = (this.gridOptions.hasOwnProperty('showCustomFooter') ? this.gridOptions.showCustomFooter : false);
                this.customFooterOptions = this.gridOptions.customFooterOptions || {};
            }
            this.cd.detectChanges();
        }
    }
    /**
     * When user has row selections enabled and does not have any custom text shown on the left side footer,
     * we will show the row selection count on the bottom left side of the footer (by subscribing to the SlickGrid `onSelectedRowsChanged` event).
     * @param customFooterOptions
     */
    registerOnSelectedRowsChangedWhenEnabled(customFooterOptions) {
        var _a, _b, _c, _d;
        const isRowSelectionEnabled = this.gridOptions.enableCheckboxSelector || this.gridOptions.enableRowSelection;
        if (isRowSelectionEnabled && customFooterOptions && (!customFooterOptions.hideRowSelectionCount && this._isLeftFooterOriginallyEmpty)) {
            this._isLeftFooterDisplayingSelectionRowCount = true;
            const selectedCountText = (_d = (_b = (_a = customFooterOptions.metricTexts) === null || _a === void 0 ? void 0 : _a.itemsSelected) !== null && _b !== void 0 ? _b : (_c = this.locales) === null || _c === void 0 ? void 0 : _c.TEXT_ITEMS_SELECTED) !== null && _d !== void 0 ? _d : 'TEXT_ITEMS_SELECTED';
            customFooterOptions.leftFooterText = `0 ${selectedCountText}`;
            this._eventHandler.subscribe(this.grid.onSelectedRowsChanged, (_e, args) => {
                var _a, _b, _c, _d;
                this._selectedRowCount = args.rows.length;
                const selectedCountText2 = (_d = (_b = (_a = customFooterOptions.metricTexts) === null || _a === void 0 ? void 0 : _a.itemsSelected) !== null && _b !== void 0 ? _b : (_c = this.locales) === null || _c === void 0 ? void 0 : _c.TEXT_ITEMS_SELECTED) !== null && _d !== void 0 ? _d : 'TEXT_ITEMS_SELECTED';
                customFooterOptions.leftFooterText = `${this._selectedRowCount} ${selectedCountText2}`;
            });
        }
    }
    /**
     * Takes a flat dataset with parent/child relationship, sort it (via its tree structure) and return the sorted flat array
     * @returns {Array<Object>} sort flat parent/child dataset
     */
    sortTreeDataset(flatDatasetInput) {
        var _a, _b;
        const prevDatasetLn = this._currentDatasetLength;
        let sortedDatasetResult;
        let flatDatasetOutput = [];
        // if the hierarchical dataset was already initialized then no need to re-convert it, we can use it directly from the shared service ref
        if (this._isDatasetHierarchicalInitialized && this.datasetHierarchical) {
            sortedDatasetResult = this.treeDataService.sortHierarchicalDataset(this.datasetHierarchical);
            flatDatasetOutput = sortedDatasetResult.flat;
        }
        else if (Array.isArray(flatDatasetInput) && flatDatasetInput.length > 0) {
            if ((_b = (_a = this.gridOptions) === null || _a === void 0 ? void 0 : _a.treeDataOptions) === null || _b === void 0 ? void 0 : _b.initialSort) {
                // else we need to first convert the flat dataset to a hierarchical dataset and then sort
                sortedDatasetResult = this.treeDataService.convertFlatParentChildToTreeDatasetAndSort(flatDatasetInput, this._columnDefinitions, this.gridOptions);
                this.sharedService.hierarchicalDataset = sortedDatasetResult.hierarchical;
                flatDatasetOutput = sortedDatasetResult.flat;
            }
            else {
                // else we assume that the user provided an array that is already sorted (user's responsability)
                // and so we can simply convert the array to a tree structure and we're done, no need to sort
                this.sharedService.hierarchicalDataset = this.treeDataService.convertFlatParentChildToTreeDataset(flatDatasetInput, this.gridOptions);
                flatDatasetOutput = flatDatasetInput || [];
            }
        }
        // if we add/remove item(s) from the dataset, we need to also refresh our tree data filters
        if (flatDatasetInput.length > 0 && flatDatasetInput.length !== prevDatasetLn) {
            this.filterService.refreshTreeDataFilters(flatDatasetOutput);
        }
        return flatDatasetOutput;
    }
    /**
     * For convenience to the user, we provide the property "editor" as an Angular-Slickgrid editor complex object
     * however "editor" is used internally by SlickGrid for it's own Editor Factory
     * so in our lib we will swap "editor" and copy it into a new property called "internalColumnEditor"
     * then take back "editor.model" and make it the new "editor" so that SlickGrid Editor Factory still works
     */
    swapInternalEditorToSlickGridFactoryEditor(columnDefinitions) {
        if (columnDefinitions.some(col => `${col.id}`.includes('.'))) {
            console.error('[Angular-Slickgrid] Make sure that none of your Column Definition "id" property includes a dot in its name because that will cause some problems with the Editors. For example if your column definition "field" property is "user.firstName" then use "firstName" as the column "id".');
        }
        return columnDefinitions.map((column) => {
            // on every Editor that have a "collectionAsync", resolve the data and assign it to the "collection" property
            if (column && column.editor && column.editor.collectionAsync) {
                this.loadEditorCollectionAsync(column);
            }
            return Object.assign(Object.assign({}, column), { editor: column.editor && column.editor.model, internalColumnEditor: Object.assign({}, column.editor) });
        });
    }
    /** Translate all Custom Footer Texts (footer with metrics) */
    translateCustomFooterTexts() {
        if (this.translate && this.translate.instant && this.translate.currentLang) {
            const customFooterOptions = this.gridOptions && this.gridOptions.customFooterOptions || {};
            customFooterOptions.metricTexts = customFooterOptions.metricTexts || {};
            for (const propName of Object.keys(customFooterOptions.metricTexts)) {
                if (propName.lastIndexOf('Key') > 0) {
                    const propNameWithoutKey = propName.substring(0, propName.lastIndexOf('Key'));
                    customFooterOptions.metricTexts[propNameWithoutKey] = this.translate.instant(customFooterOptions.metricTexts[propName] || ' ');
                }
            }
            // when we're display row selection count on left footer, we also need to translate that text with its count
            if (this._isLeftFooterDisplayingSelectionRowCount) {
                customFooterOptions.leftFooterText = `${this._selectedRowCount} ${customFooterOptions.metricTexts.itemsSelected}`;
            }
        }
    }
    translateColumnHeaderTitleKeys() {
        // translate all columns (including hidden columns)
        // eventually deprecate the "headerKey" and use only the "nameKey"
        this.extensionUtility.translateItems(this.sharedService.allColumns, 'headerKey', 'name');
        this.extensionUtility.translateItems(this.sharedService.allColumns, 'nameKey', 'name');
    }
    translateColumnGroupKeys() {
        // translate all column groups (including hidden columns)
        this.extensionUtility.translateItems(this.sharedService.allColumns, 'columnGroupKey', 'columnGroup');
    }
    /**
     * Update the Editor "collection" property from an async call resolved
     * Since this is called after the async call resolves, the pointer will not be the same as the "column" argument passed.
     * Once we found the new pointer, we will reassign the "editor" and "collection" to the "internalColumnEditor" so it has newest collection
     */
    updateEditorCollection(column, newCollection) {
        column.editor.collection = newCollection;
        // find the new column reference pointer
        const columns = this.grid.getColumns();
        if (Array.isArray(columns)) {
            const columnRef = columns.find((col) => col.id === column.id);
            columnRef.internalColumnEditor = column.editor;
        }
    }
}
AngularSlickgridComponent.ɵfac = function AngularSlickgridComponent_Factory(t) { return new (t || AngularSlickgridComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ExcelExportService), ɵngcc0.ɵɵdirectiveInject(ExportService), ɵngcc0.ɵɵdirectiveInject(ExtensionService), ɵngcc0.ɵɵdirectiveInject(ExtensionUtility), ɵngcc0.ɵɵdirectiveInject(FilterService), ɵngcc0.ɵɵdirectiveInject(GridEventService), ɵngcc0.ɵɵdirectiveInject(GridService), ɵngcc0.ɵɵdirectiveInject(GridStateService), ɵngcc0.ɵɵdirectiveInject(GroupingAndColspanService), ɵngcc0.ɵɵdirectiveInject(PaginationService), ɵngcc0.ɵɵdirectiveInject(ResizerService), ɵngcc0.ɵɵdirectiveInject(SharedService), ɵngcc0.ɵɵdirectiveInject(SortService), ɵngcc0.ɵɵdirectiveInject(TreeDataService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.TranslateService, 8), ɵngcc0.ɵɵdirectiveInject('config')); };
AngularSlickgridComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AngularSlickgridComponent, selectors: [["angular-slickgrid"]], inputs: { gridId: "gridId", paginationOptions: "paginationOptions", gridHeight: "gridHeight", gridWidth: "gridWidth", columnDefinitions: "columnDefinitions", dataset: "dataset", datasetHierarchical: "datasetHierarchical", gridOptions: "gridOptions", customDataView: "customDataView" }, outputs: { onAngularGridCreated: "onAngularGridCreated", onDataviewCreated: "onDataviewCreated", onGridCreated: "onGridCreated", onGridInitialized: "onGridInitialized", onBeforeGridCreate: "onBeforeGridCreate", onBeforeGridDestroy: "onBeforeGridDestroy", onAfterGridDestroyed: "onAfterGridDestroyed", onGridStateChanged: "onGridStateChanged", onGridBeforeExportToFile: "onGridBeforeExportToFile", onGridAfterExportToFile: "onGridAfterExportToFile", onGridBeforeExportToExcel: "onGridBeforeExportToExcel", onGridAfterExportToExcel: "onGridAfterExportToExcel" }, features: [ɵngcc0.ɵɵProvidersFeature([
            // make everything transient (non-singleton)
            AngularUtilService,
            AutoTooltipExtension,
            CellExternalCopyManagerExtension,
            CellMenuExtension,
            CheckboxSelectorExtension,
            ColumnPickerExtension,
            ContextMenuExtension,
            DraggableGroupingExtension,
            ExcelExportService,
            ExtensionService,
            ExportService,
            ExtensionUtility,
            FilterFactory,
            FilterService,
            GraphqlService,
            GridEventService,
            GridMenuExtension,
            GridService,
            GridStateService,
            GroupingAndColspanService,
            GroupItemMetaProviderExtension,
            HeaderButtonExtension,
            HeaderMenuExtension,
            PaginationService,
            ResizerService,
            RowDetailViewExtension,
            RowMoveManagerExtension,
            RowSelectionExtension,
            SharedService,
            SortService,
            SlickgridConfig,
            TreeDataService,
        ])], decls: 4, vars: 8, consts: [[1, "gridPane", 3, "id"], [1, "slickgrid-container", 2, "width", "100%"], [3, "id", "gridOptions", 4, "ngIf"], ["class", "slick-custom-footer", "style", "width: 100%;", 3, "height", 4, "ngIf"], [3, "id", "gridOptions"], [1, "slick-custom-footer", 2, "width", "100%"], [1, "left-footer", 3, "ngClass"], ["class", "right-footer metrics", 3, "ngClass", 4, "ngIf"], [1, "right-footer", "metrics", 3, "ngClass"], [4, "ngIf"], [1, "separator"]], template: function AngularSlickgridComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, AngularSlickgridComponent_slick_pagination_2_Template, 1, 2, "slick-pagination", 2);
        ɵngcc0.ɵɵtemplate(3, AngularSlickgridComponent_div_3_Template, 4, 5, "div", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("width", ctx.gridWidthString);
        ɵngcc0.ɵɵpropertyInterpolate1("id", "slickGridContainer-", ctx.gridId, "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("height", ctx.gridHeightString);
        ɵngcc0.ɵɵattribute("id", ctx.gridId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showPagination);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showCustomFooter && ctx.customFooterOptions);
    } }, directives: [ɵngcc2.NgIf, SlickPaginationComponent, ɵngcc2.NgClass], pipes: [ɵngcc2.DatePipe], encapsulation: 2 });
AngularSlickgridComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: ExcelExportService },
    { type: ExportService },
    { type: ExtensionService },
    { type: ExtensionUtility },
    { type: FilterService },
    { type: GridEventService },
    { type: GridService },
    { type: GridStateService },
    { type: GroupingAndColspanService },
    { type: PaginationService },
    { type: ResizerService },
    { type: SharedService },
    { type: SortService },
    { type: TreeDataService },
    { type: TranslateService, decorators: [{ type: Optional }] },
    { type: undefined, decorators: [{ type: Inject, args: ['config',] }] }
];
AngularSlickgridComponent.propDecorators = {
    onAngularGridCreated: [{ type: Output }],
    onDataviewCreated: [{ type: Output }],
    onGridCreated: [{ type: Output }],
    onGridInitialized: [{ type: Output }],
    onBeforeGridCreate: [{ type: Output }],
    onBeforeGridDestroy: [{ type: Output }],
    onAfterGridDestroyed: [{ type: Output }],
    onGridStateChanged: [{ type: Output }],
    onGridBeforeExportToFile: [{ type: Output }],
    onGridAfterExportToFile: [{ type: Output }],
    onGridBeforeExportToExcel: [{ type: Output }],
    onGridAfterExportToExcel: [{ type: Output }],
    customDataView: [{ type: Input }],
    gridId: [{ type: Input }],
    gridOptions: [{ type: Input }],
    paginationOptions: [{ type: Input }],
    gridHeight: [{ type: Input }],
    gridWidth: [{ type: Input }],
    columnDefinitions: [{ type: Input }],
    dataset: [{ type: Input }],
    datasetHierarchical: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AngularSlickgridComponent, [{
        type: Component,
        args: [{
                selector: 'angular-slickgrid',
                template: "<div id=\"slickGridContainer-{{gridId}}\" class=\"gridPane\" [style.width]=\"gridWidthString\">\r\n  <div attr.id='{{gridId}}' class=\"slickgrid-container\" style=\"width: 100%\" [style.height]=\"gridHeightString\">\r\n  </div>\r\n\r\n  <!-- Pagination section under the grid -->\r\n  <slick-pagination id=\"slickPagingContainer-{{gridId}}\" *ngIf=\"showPagination\" [gridOptions]=\"gridOptions\">\r\n  </slick-pagination>\r\n\r\n  <!-- Custom Footer section under the grid -->\r\n  <div *ngIf=\"showCustomFooter && customFooterOptions\" class=\"slick-custom-footer\" style=\"width: 100%;\"\r\n       [style.height]=\"customFooterOptions?.footerHeight || 20\">\r\n    <div class=\"left-footer\" [ngClass]=\"customFooterOptions.leftContainerClass\">{{customFooterOptions.leftFooterText}}</div>\r\n\r\n    <div class=\"right-footer metrics\" [ngClass]=\"customFooterOptions.rightContainerClass\"\r\n         *ngIf=\"metrics && !customFooterOptions.hideMetrics\">\r\n      <span *ngIf=\"!customFooterOptions.hideLastUpdateTimestamp\">\r\n        <span>{{customFooterOptions.metricTexts?.lastUpdate}}</span>\r\n        {{metrics.endTime | date: customFooterOptions.dateFormat}}\r\n        <span class=\"separator\">{{customFooterOptions.metricSeparator}}</span>\r\n      </span>\r\n\r\n      {{metrics.itemCount}}\r\n      <span *ngIf=\"!customFooterOptions.hideTotalItemCount\">{{customFooterOptions.metricTexts?.of}}\r\n        {{metrics.totalItemCount}}\r\n      </span>\r\n      {{customFooterOptions.metricTexts?.items}}\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n",
                providers: [
                    // make everything transient (non-singleton)
                    AngularUtilService,
                    AutoTooltipExtension,
                    CellExternalCopyManagerExtension,
                    CellMenuExtension,
                    CheckboxSelectorExtension,
                    ColumnPickerExtension,
                    ContextMenuExtension,
                    DraggableGroupingExtension,
                    ExcelExportService,
                    ExtensionService,
                    ExportService,
                    ExtensionUtility,
                    FilterFactory,
                    FilterService,
                    GraphqlService,
                    GridEventService,
                    GridMenuExtension,
                    GridService,
                    GridStateService,
                    GroupingAndColspanService,
                    GroupItemMetaProviderExtension,
                    HeaderButtonExtension,
                    HeaderMenuExtension,
                    PaginationService,
                    ResizerService,
                    RowDetailViewExtension,
                    RowMoveManagerExtension,
                    RowSelectionExtension,
                    SharedService,
                    SortService,
                    SlickgridConfig,
                    TreeDataService,
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ExcelExportService }, { type: ExportService }, { type: ExtensionService }, { type: ExtensionUtility }, { type: FilterService }, { type: GridEventService }, { type: GridService }, { type: GridStateService }, { type: GroupingAndColspanService }, { type: PaginationService }, { type: ResizerService }, { type: SharedService }, { type: SortService }, { type: TreeDataService }, { type: ɵngcc1.TranslateService, decorators: [{
                type: Optional
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: ['config']
            }] }]; }, { onAngularGridCreated: [{
            type: Output
        }], onDataviewCreated: [{
            type: Output
        }], onGridCreated: [{
            type: Output
        }], onGridInitialized: [{
            type: Output
        }], onBeforeGridCreate: [{
            type: Output
        }], onBeforeGridDestroy: [{
            type: Output
        }], onAfterGridDestroyed: [{
            type: Output
        }], onGridStateChanged: [{
            type: Output
        }], onGridBeforeExportToFile: [{
            type: Output
        }], onGridAfterExportToFile: [{
            type: Output
        }], onGridBeforeExportToExcel: [{
            type: Output
        }], onGridAfterExportToExcel: [{
            type: Output
        }], gridId: [{
            type: Input
        }], paginationOptions: [{
            type: Input
        }], gridHeight: [{
            type: Input
        }], gridWidth: [{
            type: Input
        }], columnDefinitions: [{
            type: Input
        }], dataset: [{
            type: Input
        }], datasetHierarchical: [{
            type: Input
        }], gridOptions: [{
            type: Input
        }], customDataView: [{
            type: Input
        }] }); })();

class AngularSlickgridModule {
    static forRoot(config = {}) {
        return {
            ngModule: AngularSlickgridModule,
            providers: [
                { provide: 'config', useValue: config },
                AngularUtilService,
                BsDropDownService,
                CollectionService,
                FilterFactory,
                GraphqlService,
                GridOdataService,
            ]
        };
    }
}
AngularSlickgridModule.ɵfac = function AngularSlickgridModule_Factory(t) { return new (t || AngularSlickgridModule)(); };
AngularSlickgridModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: AngularSlickgridModule });
AngularSlickgridModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            TranslateModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AngularSlickgridModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    TranslateModule
                ],
                declarations: [
                    AngularSlickgridComponent,
                    SlickPaginationComponent
                ],
                exports: [
                    AngularSlickgridComponent,
                    SlickPaginationComponent
                ],
                entryComponents: [AngularSlickgridComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AngularSlickgridModule, { declarations: function () { return [AngularSlickgridComponent, SlickPaginationComponent]; }, imports: function () { return [CommonModule,
        TranslateModule]; }, exports: function () { return [AngularSlickgridComponent, SlickPaginationComponent]; } }); })();

// Public classes.

/**
 * Generated bundle index. Do not edit.
 */

export { Aggregators, AngularSlickgridComponent, AngularSlickgridModule, AngularUtilService, AutoCompleteEditor, AutoCompleteFilter, AutoTooltipExtension, BindingEventService, BsDropDownService, CaseType, CellExternalCopyManagerExtension, CellMenuExtension, CheckboxEditor, CheckboxSelectorExtension, CollectionService, ColumnPickerExtension, CompoundDateFilter, CompoundInputFilter, CompoundInputNumberFilter, CompoundInputPasswordFilter, CompoundSliderFilter, ContextMenuExtension, DateEditor, DateRangeFilter, DelimiterType, DraggableGroupingExtension, DualInputEditor, Editors, EmitterType, ExcelExportService, ExportService, ExtensionName, ExtensionService, ExtensionUtility, FieldType, FileType, FilterConditions, FilterFactory, FilterMultiplePassType, FilterService, Filters, FloatEditor, Formatters, GraphqlService, GridEventService, GridMenuExtension, GridOdataService, GridService, GridStateService, GridStateType, GroupItemMetaProviderExtension, GroupTotalFormatters, GroupingAndColspanService, HeaderButtonExtension, HeaderMenuExtension, InputEditor, InputFilter, InputMaskFilter, InputNumberFilter, InputPasswordFilter, IntegerEditor, KeyCode, LongTextEditor, MultipleSelectEditor, MultipleSelectFilter, NativeSelectFilter, OdataQueryBuilderService, OperatorType, PaginationService, ResizerService, RowDetailViewExtension, RowMoveManagerExtension, RowSelectionExtension, SelectEditor, SelectFilter, SharedService, SingleSelectEditor, SingleSelectFilter, SlickPaginationComponent, SlickgridConfig, SliderEditor, SliderFilter, SliderRangeFilter, SortDirection, SortDirectionNumber, SortService, Sorters, ToggleStateChangeType, TreeDataService, addToArrayWhenNotExists, addTreeLevelByMutation, addWhiteSpaces, alignRightFormatter, arrayObjectToCsvFormatter, arrayRemoveItemByIndex, arrayToCsvFormatter, boldFormatter, buildSelectEditorOrFilterDomElement, castToPromise, centerFormatter, checkboxFormatter, checkmarkFormatter, collectionEditorFormatter, collectionFormatter, compareObjects, complexObjectFormatter, decimalFormatted, decimalFormatter, deepCopy, deleteIconFormatter, destroyObjectDomElementProps, dollarColoredBoldFormatter, dollarColoredFormatter, dollarFormatter, editIconFormatter, emptyElement, executeBackendCallback, executeBackendProcessesCallback, executeBooleanFilterCondition, executeCollectionSearchFilterCondition, executeFilterConditionTest, executeNumberFilterCondition, executeObjectFilterCondition, executeStringFilterCondition, exportWithFormatterWhenDefined, findItemInHierarchicalStructure, findItemInTreeStructure, findOrDefault, flattenToParentChildArray, formatNumber, getAssociatedDateFormatter, getDescendantProperty, getFilterParsedBoolean, getFilterParsedNumbers, getFilterParsedObjectResult, getFilterParsedText, getHtmlElementOffset, getParsedSearchTermsByFieldType, getTranslationPrefix, getValueFromParamsOrFormatterOptions, getVarTypeOfByColumnFieldType, htmlDecode, htmlEncode, htmlEncodedStringWithPadding, htmlEntityDecode, htmlEntityEncode, hyperlinkFormatter, iconFormatter, infoIconFormatter, isCollectionOperator, isNumber, italicFormatter, lowercaseFormatter, mapFlatpickrDateFormatWithFieldType, mapMomentDateFormatWithFieldType, mapOperatorByFieldType, mapOperatorToShorthandDesignation, mapOperatorType, maskFormatter, multipleFormatter, objectWithoutKey, onBackendError, parseBoolean, parseFormatterWhenExist, parseUtcDate, percentCompleteBarFormatter, percentCompleteFormatter, percentFormatter, percentSymbolFormatter, progressBarFormatter, refreshBackendDataset, sanitizeHtmlToText, setDeepValue, testFilterCondition, thousandSeparatorFormatted, titleCase, toCamelCase, toKebabCase, toSnakeCase, translateBooleanFormatter, translateFormatter, treeExportFormatter, treeFormatter, unflattenParentChildArrayToTree, uniqueArray, uniqueObjectArray, unsubscribeAllObservables, uppercaseFormatter, yesNoFormatter, AvgAggregator as ɵa, MinAggregator as ɵb, MaxAggregator as ɵc, SumAggregator as ɵd, InputPasswordEditor as ɵe, bsDropdownFormatter as ɵf, fakeHyperlinkFormatter as ɵg, avgTotalsFormatter as ɵh, avgTotalsDollarFormatter as ɵi, avgTotalsPercentageFormatter as ɵj, maxTotalsFormatter as ɵk, minTotalsFormatter as ɵl, sumTotalsFormatter as ɵm, sumTotalsBoldFormatter as ɵn, sumTotalsColoredFormatter as ɵo, sumTotalsDollarFormatter as ɵp, sumTotalsDollarBoldFormatter as ɵq, sumTotalsDollarColoredFormatter as ɵr, sumTotalsDollarColoredBoldFormatter as ɵs, getAssociatedDateSorter as ɵt, numericSorter as ɵu, objectStringSorter as ɵv, stringSorter as ɵw };

